webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(161);
	
	__webpack_require__(308);
	__webpack_require__(309);
	
	__webpack_require__(232);
	
	__webpack_require__(4);
	var deferredBootstrapper = __webpack_require__(369);
	
	__webpack_require__(154);
	__webpack_require__(157);
	__webpack_require__(158);
	__webpack_require__(159);
	__webpack_require__(156);
	__webpack_require__(155);
	// require("angular-facebook");
	__webpack_require__(374);
	__webpack_require__(372);
	__webpack_require__(375);
	__webpack_require__(380);
	__webpack_require__(370);
	__webpack_require__(160);
	__webpack_require__(160);
	__webpack_require__(379);
	
	__webpack_require__(373);//loading spinner
	__webpack_require__(367);//the original is crappy
	
	__webpack_require__(376);
	__webpack_require__(383);
	__webpack_require__(378);
	
	__webpack_require__(371);
	__webpack_require__(382);
	__webpack_require__(381);
	
	var $ = __webpack_require__(13);
	var main = __webpack_require__(361);
	
	var config = __webpack_require__(3);
	var jsonConfigDev = __webpack_require__(233);
	var jsonConfigStaging = __webpack_require__(235);
	var jsonConfigProduction = __webpack_require__(234);
	
	
	if (false) {
		config.Config.load(jsonConfigDev);
	} else if (true) {
		config.Config.load(jsonConfigStaging);
	} else if (__PRODUCTION__) {
		config.Config.load(jsonConfigProduction);
	} else {
		throw "NO CONFIG LOADED";
	}
	
	
	
	$(function() {
		$("head").append("<meta name='viewport' content='width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'>");
		$("body").attr("translate-cloak", "");
		$("body").append("\
			<div class='ot-site-content'>\
				<spinner name='mainSpinner' show='false'>\
				<div class='ot-spinner-overlay'></div>\
				<div class='spinner'>\
					<div class='double-bounce1'></div>\
					<div class='double-bounce2'></div>\
				</div>\
				</spinner>\
				<ot-header></ot-header>\
				<div ng-view></div>\
			</div>\
		");
		new main.Main().init(deferredBootstrapper);
		//window.onbeforeunload = function () {
		//    return "Do you really want to close?";
		//};
	});
	
	
	//Moved facebook init here to use the right facebook app
	
	window.fbAsyncInit = function() {
		FB.init({
			appId      : config.Config.facebookAppId,
			xfbml      : true,
			status     : true,
			cookie     : true,
			version    : 'v2.5'
		});
	};
	
	(function(d, s, id){
		 var js, fjs = d.getElementsByTagName(s)[0];
		 if (d.getElementById(id)) {return;}
		 js = d.createElement(s); js.id = id;
		 js.src = "//connect.facebook.net/en_US/sdk.js";
		 fjs.parentNode.insertBefore(js, fjs);
	 }(document, 'script', 'facebook-jssdk'));


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.10.6
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            m._isValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated;
	
	            if (m._strict) {
	                m._isValid = m._isValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (typeof from._isAMomentObject !== 'undefined') {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (typeof from._i !== 'undefined') {
	            to._i = from._i;
	        }
	        if (typeof from._f !== 'undefined') {
	            to._f = from._f;
	        }
	        if (typeof from._l !== 'undefined') {
	            to._l = from._l;
	        }
	        if (typeof from._strict !== 'undefined') {
	            to._strict = from._strict;
	        }
	        if (typeof from._tzm !== 'undefined') {
	            to._tzm = from._tzm;
	        }
	        if (typeof from._isUTC !== 'undefined') {
	            to._isUTC = from._isUTC;
	        }
	        if (typeof from._offset !== 'undefined') {
	            to._offset = from._offset;
	        }
	        if (typeof from._pf !== 'undefined') {
	            to._pf = getParsingFlags(from);
	        }
	        if (typeof from._locale !== 'undefined') {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (typeof val !== 'undefined') {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            return Math.ceil(number);
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function Locale() {
	    }
	
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && typeof module !== 'undefined' &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                __webpack_require__(177)("./" + name);
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (typeof values === 'undefined') {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, values) {
	        if (values !== null) {
	            values.abbr = name;
	            locales[name] = locales[name] || new Locale();
	            locales[name].set(values);
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get (mom, unit) {
	        return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
	    }
	
	    function get_set__set (mom, unit, value) {
	        return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	
	    // MOMENTS
	
	    function getSet (units, value) {
	        var unit;
	        if (typeof units === 'object') {
	            for (unit in units) {
	                this.set(unit, units[unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (typeof this[units] === 'function') {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '';
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	    var regexes = {};
	
	    function isFunction (sth) {
	        // https://github.com/moment/moment/issues/2325
	        return typeof sth === 'function' &&
	            Object.prototype.toString.call(sth) === '[object Function]';
	    }
	
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  matchWord);
	    addRegexToken('MMMM', matchWord);
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m) {
	        return this._months[m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m) {
	        return this._monthsShort[m.month()];
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        // TODO: Move this out of here!
	        if (typeof value === 'string') {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (typeof value !== 'number') {
	                return mom;
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (firstTime) {
	                warn(msg + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	
	    var from_string__isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/],
	        ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d{2}/],
	        ['YYYY-DDD', /\d{4}-\d{3}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/],
	        ['HH:mm', /(T| )\d\d:\d\d/],
	        ['HH', /(T| )\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = from_string__isoRegex.exec(string);
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(string)) {
	                    config._f = isoDates[i][0];
	                    break;
	                }
	            }
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(string)) {
	                    // match[6] should be 'T' or space
	                    config._f += (match[6] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (string.match(matchOffset)) {
	                config._f += 'Z';
	            }
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'moment construction falls back to js Date. This is ' +
	        'discouraged and will be removed in upcoming major ' +
	        'release. Please refer to ' +
	        'https://github.com/moment/moment/issues/1407 for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor doesn't accept years < 1970
	        if (y < 1970) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	        if (y < 1970) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', false);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // firstDayOfWeek       0 = sun, 6 = sat
	    //                      the day of the week that starts the week
	    //                      (usually sunday or monday)
	    // firstDayOfWeekOfYear 0 = sun, 6 = sat
	    //                      the first week is the week that contains the first
	    //                      of this day of the week
	    //                      (eg. ISO weeks use thursday (4))
	    function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
	        var end = firstDayOfWeekOfYear - firstDayOfWeek,
	            daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
	            adjustedMoment;
	
	
	        if (daysToDayOfWeek > end) {
	            daysToDayOfWeek -= 7;
	        }
	
	        if (daysToDayOfWeek < end - 7) {
	            daysToDayOfWeek += 7;
	        }
	
	        adjustedMoment = local__createLocal(mom).add(daysToDayOfWeek, 'd');
	        return {
	            week: Math.ceil(adjustedMoment.dayOfYear() / 7),
	            year: adjustedMoment.year()
	        };
	    }
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
	        var week1Jan = 6 + firstDayOfWeek - firstDayOfWeekOfYear, janX = createUTCDate(year, 0, 1 + week1Jan), d = janX.getUTCDay(), dayOfYear;
	        if (d < firstDayOfWeek) {
	            d += 7;
	        }
	
	        weekday = weekday != null ? 1 * weekday : firstDayOfWeek;
	
	        dayOfYear = 1 + week1Jan + 7 * (week - 1) - d + weekday;
	
	        return {
	            year: dayOfYear > 0 ? year : year - 1,
	            dayOfYear: dayOfYear > 0 ?  dayOfYear : daysInYear(year - 1) + dayOfYear
	        };
	    }
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        var now = new Date();
	        if (config._useUTC) {
	            return [now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()];
	        }
	        return [now.getFullYear(), now.getMonth(), now.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < dow) {
	                    ++week;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, doy, dow);
	
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (getParsingFlags(config).bigHour === true &&
	                config._a[HOUR] <= 12 &&
	                config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = [i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond];
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else {
	            configFromInput(config);
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date();
	        } else if (isDate(input)) {
	            config._d = new Date(+input);
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	         'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
	         function () {
	             var other = local__createLocal.apply(null, arguments);
	             return other < this ? this : other;
	         }
	     );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            return other > this ? this : other;
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 36e5; // 1000 * 60 * 60
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchOffset);
	    addRegexToken('ZZ', matchOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(string) {
	        var matches = ((string || '').match(matchOffset) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? +input : +local__createLocal(input)) - (+res);
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(+res._d + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(input);
	            }
	            if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            this.utcOffset(offsetFromString(this._i));
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (typeof this._isDSTShifted !== 'undefined') {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return !this._isUTC;
	    }
	
	    function isUtcOffset () {
	        return this._isUTC;
	    }
	
	    function isUtc () {
	        return this._isUTC && this._offset === 0;
	    }
	
	    var aspNetRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    var create__isoRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;
	
	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])        * sign,
	                h  : toInt(match[HOUR])        * sign,
	                m  : toInt(match[MINUTE])      * sign,
	                s  : toInt(match[SECOND])      * sign,
	                ms : toInt(match[MILLISECOND]) * sign
	            };
	        } else if (!!(match = create__isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                d : parseIso(match[4], sign),
	                h : parseIso(match[5], sign),
	                m : parseIso(match[6], sign),
	                s : parseIso(match[7], sign),
	                w : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = duration._days,
	            months = duration._months;
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(+mom._d + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            diff = this.diff(sod, 'days', true),
	            format = diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	        return this.format(formats && formats[format] || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var inputMs;
	        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this > +input;
	        } else {
	            inputMs = isMoment(input) ? +input : +local__createLocal(input);
	            return inputMs < +this.clone().startOf(units);
	        }
	    }
	
	    function isBefore (input, units) {
	        var inputMs;
	        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this < +input;
	        } else {
	            inputMs = isMoment(input) ? +input : +local__createLocal(input);
	            return +this.clone().endOf(units) < inputMs;
	        }
	    }
	
	    function isBetween (from, to, units) {
	        return this.isAfter(from, units) && this.isBefore(to, units);
	    }
	
	    function isSame (input, units) {
	        var inputMs;
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this === +input;
	        } else {
	            inputMs = +local__createLocal(input);
	            return +(this.clone().startOf(units)) <= inputMs && inputMs <= +(this.clone().endOf(units));
	        }
	    }
	
	    function diff (input, units, asFloat) {
	        var that = cloneWithOffset(input, this),
	            zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4,
	            delta, output;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        return -(wholeMonthDiff + adjust);
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if ('function' === typeof Date.prototype.toISOString) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function format (inputString) {
	        var output = formatMoment(this, inputString || utils_hooks__hooks.defaultFormat);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	        return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	        return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf () {
	        return +this._d - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(+this / 1000);
	    }
	
	    function toDate () {
	        return this._offset ? new Date(+this) : this._d;
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // HELPERS
	
	    function weeksInYear(year, dow, doy) {
	        return weekOfYear(local__createLocal([year, 11, 31 + dow - doy]), dow, doy).week;
	    }
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        var year = weekOfYear(this, this.localeData()._week.dow, this.localeData()._week.doy).year;
	        return input == null ? year : this.add((input - year), 'y');
	    }
	
	    function getSetISOWeekYear (input) {
	        var year = weekOfYear(this, 1, 4).year;
	        return input == null ? year : this.add((input - year), 'y');
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    addFormatToken('Q', 0, 0, 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   matchWord);
	    addRegexToken('ddd',  matchWord);
	    addRegexToken('dddd', matchWord);
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config) {
	        var weekday = config._locale.weekdaysParse(input);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m) {
	        return this._weekdays[m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return this._weekdaysShort[m.day()];
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return this._weekdaysMin[m.day()];
	    }
	
	    function localeWeekdaysParse (weekdayName) {
	        var i, mom, regex;
	
	        this._weekdaysParse = this._weekdaysParse || [];
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            if (!this._weekdaysParse[i]) {
	                mom = local__createLocal([2000, 1]).day(i);
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, function () {
	        return this.hours() % 12 || 12;
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add          = add_subtract__add;
	    momentPrototype__proto.calendar     = moment_calendar__calendar;
	    momentPrototype__proto.clone        = clone;
	    momentPrototype__proto.diff         = diff;
	    momentPrototype__proto.endOf        = endOf;
	    momentPrototype__proto.format       = format;
	    momentPrototype__proto.from         = from;
	    momentPrototype__proto.fromNow      = fromNow;
	    momentPrototype__proto.to           = to;
	    momentPrototype__proto.toNow        = toNow;
	    momentPrototype__proto.get          = getSet;
	    momentPrototype__proto.invalidAt    = invalidAt;
	    momentPrototype__proto.isAfter      = isAfter;
	    momentPrototype__proto.isBefore     = isBefore;
	    momentPrototype__proto.isBetween    = isBetween;
	    momentPrototype__proto.isSame       = isSame;
	    momentPrototype__proto.isValid      = moment_valid__isValid;
	    momentPrototype__proto.lang         = lang;
	    momentPrototype__proto.locale       = locale;
	    momentPrototype__proto.localeData   = localeData;
	    momentPrototype__proto.max          = prototypeMax;
	    momentPrototype__proto.min          = prototypeMin;
	    momentPrototype__proto.parsingFlags = parsingFlags;
	    momentPrototype__proto.set          = getSet;
	    momentPrototype__proto.startOf      = startOf;
	    momentPrototype__proto.subtract     = add_subtract__subtract;
	    momentPrototype__proto.toArray      = toArray;
	    momentPrototype__proto.toObject     = toObject;
	    momentPrototype__proto.toDate       = toDate;
	    momentPrototype__proto.toISOString  = moment_format__toISOString;
	    momentPrototype__proto.toJSON       = moment_format__toISOString;
	    momentPrototype__proto.toString     = toString;
	    momentPrototype__proto.unix         = unix;
	    momentPrototype__proto.valueOf      = to_type__valueOf;
	
	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key];
	        return typeof output === 'function' ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (typeof output === 'function') ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
	    }
	
	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (typeof prop === 'function') {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto._calendar       = defaultCalendar;
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto._longDateFormat = defaultLongDateFormat;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto._invalidDate    = defaultInvalidDate;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto._ordinal        = defaultOrdinal;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto._ordinalParse   = defaultOrdinalParse;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto._relativeTime   = defaultRelativeTime;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;
	
	    // Month
	    prototype__proto.months       =        localeMonths;
	    prototype__proto._months      = defaultLocaleMonths;
	    prototype__proto.monthsShort  =        localeMonthsShort;
	    prototype__proto._monthsShort = defaultLocaleMonthsShort;
	    prototype__proto.monthsParse  =        localeMonthsParse;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto._week = defaultLocaleWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto._weekdays      = defaultLocaleWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function list (format, index, field, count, setter) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, setter);
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < count; i++) {
	            out[i] = lists__get(format, i, field, setter);
	        }
	        return out;
	    }
	
	    function lists__listMonths (format, index) {
	        return list(format, index, 'months', 12, 'month');
	    }
	
	    function lists__listMonthsShort (format, index) {
	        return list(format, index, 'monthsShort', 12, 'month');
	    }
	
	    function lists__listWeekdays (format, index) {
	        return list(format, index, 'weekdays', 7, 'day');
	    }
	
	    function lists__listWeekdaysShort (format, index) {
	        return list(format, index, 'weekdaysShort', 7, 'day');
	    }
	
	    function lists__listWeekdaysMin (format, index) {
	        return list(format, index, 'weekdaysMin', 7, 'day');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes === 1          && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   === 1          && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    === 1          && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  === 1          && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   === 1          && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    utils_hooks__hooks.version = '2.10.6';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	
	    var _moment = utils_hooks__hooks;
	
	    return _moment;
	
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(153)(module)))

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* This file is generated automatically! DO NOT EDIT MANUALLY */
	module.exports = {
	components: {
	accessRouteErr: __webpack_require__(236),
	apiTest: __webpack_require__(237),
	controlPanel: __webpack_require__(238),
	event: __webpack_require__(239),
	guests: __webpack_require__(240),
	hostPromotion: __webpack_require__(241),
	landing: __webpack_require__(242),
	manage: __webpack_require__(243),
	notFound: __webpack_require__(244),
	nourished: __webpack_require__(245),
	profile: __webpack_require__(246)},
	commonDirectives: {
	avatar: __webpack_require__(247),
	banner: __webpack_require__(248),
	field: __webpack_require__(249),
	imageUploader: __webpack_require__(250),
	inputCombo: __webpack_require__(251),
	inputSelect: __webpack_require__(252),
	loader: __webpack_require__(253),
	logo: __webpack_require__(254),
	separator: __webpack_require__(255),
	socialShare: __webpack_require__(256),
	stepper: __webpack_require__(257)},
	contentDirectives: {
	attendants: __webpack_require__(258),
	dishList: __webpack_require__(259),
	event: __webpack_require__(260),
	eventActionMenu: __webpack_require__(261),
	eventList: __webpack_require__(262),
	eventRow: __webpack_require__(263),
	eventTable: __webpack_require__(264),
	host: __webpack_require__(265),
	info: __webpack_require__(266),
	inviteGuests: __webpack_require__(267),
	manageHeader: __webpack_require__(268),
	manageMenu: __webpack_require__(269),
	modalActionBar: __webpack_require__(270),
	notification: __webpack_require__(271),
	priceBadge: __webpack_require__(272),
	rsvp: __webpack_require__(273),
	search: __webpack_require__(274),
	searchDescription: __webpack_require__(275),
	searchFilter: __webpack_require__(276),
	typeList: __webpack_require__(277),
	typePicker: __webpack_require__(278)},
	navigationDirectives: {
	burger: __webpack_require__(279),
	emailLogin: __webpack_require__(280),
	emailSignup: __webpack_require__(281),
	facebookLogin: __webpack_require__(282),
	footer: __webpack_require__(283),
	header: __webpack_require__(284),
	hire: __webpack_require__(285),
	indicator: __webpack_require__(286),
	indicatorList: __webpack_require__(287),
	link: __webpack_require__(288),
	linkList: __webpack_require__(289),
	userRecap: __webpack_require__(290)},
	modals: {
	burger: __webpack_require__(291),
	changePassword: __webpack_require__(292),
	confirm: __webpack_require__(293),
	forgot: __webpack_require__(294),
	hostMessage: __webpack_require__(295),
	login: __webpack_require__(296),
	manageGuests: __webpack_require__(297),
	rsvp: __webpack_require__(298),
	rsvpGuests: __webpack_require__(299),
	rsvpPayment: __webpack_require__(300),
	success: __webpack_require__(301),
	welcome: __webpack_require__(302)}};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    var Config = (function () {
	        function Config() {
	        }
	        Config.load = function (jsonConfig) {
	            Config.facebookAppId = jsonConfig.facebookAppId;
	            Config.stripePublishableKey = jsonConfig.stripePublishableKey;
	            Config.amazonUrl = jsonConfig.amazonUrl;
	            Config.publicEndpoint = jsonConfig.publicEndpoint;
	            Config.googleKey = jsonConfig.googleKey;
	            Config.productionMode = jsonConfig.production;
	            Config.isOnward = !!jsonConfig.isOnward;
	            Config.apiEndpoint = jsonConfig.apiEndpoint;
	            Config.controlPanelEndpoint = Config.apiEndpoint + "../../../cp";
	            Config.tokenEndpoint = Config.apiEndpoint + "/../../oauth/token";
	            Config.tokenSocialEndpoint = Config.apiEndpoint + "/../../tokens/social";
	            Config.usersEndpoint = Config.apiEndpoint + "/../../users";
	            Config.resetPasswordEndpoint = Config.apiEndpoint + "/../../users/password";
	            Config.profileEndpoint = Config.apiEndpoint + "/profile";
	            Config.updatePasswordEndpoint = Config.apiEndpoint + "/profile/password";
	            Config.eventsEndpoint = Config.apiEndpoint + "/events";
	            Config.reservationsEndpoint = Config.apiEndpoint + "/reservations";
	            Config.dashboardEventsEndpoint = Config.apiEndpoint + "/dashboard/events";
	            Config.hostRequestEndpoint = Config.apiEndpoint + "/profile/host_request";
	            Config.newUploadEndpoint = Config.apiEndpoint + "/uploads/new";
	            Config.areasEndpoint = Config.apiEndpoint + "/areas";
	            Config.timezoneEndpoint = Config.apiEndpoint + Config.utilities + "/timezones";
	            Config.cardsEndpoint = Config.apiEndpoint + Config.cards;
	            Config.couponEndpoint = Config.apiEndpoint + Config.coupon;
	        };
	        Config.wp_home = "/#/landing";
	        Config.wp_becameanhost = "/#/landing";
	        Config.wp_termsandconditions = " http://gamechangers.bbyo.org/terms-and-conditions";
	        Config.wp_onetable = "http://onetable.org";
	        Config.wp_locations = "http://gamechangers.bbyo.org/debate-nights";
	        Config.linkHash = "#";
	        Config.home = "/landing";
	        Config.error = "/error/";
	        Config.manage = "/manage";
	        Config.events = "/events";
	        Config.profile = "/profile";
	        Config.hostPromotion = "/host/promote";
	        Config.upcoming = "upcoming";
	        Config.hosted = "hosted";
	        Config.saved = "saved";
	        Config.past = "past";
	        Config.reservations = "reservations";
	        Config.payments = "payments";
	        Config.suggested = "suggested";
	        Config.sponsors = "sponsors";
	        Config.tokenError = "reset_password_token";
	        Config.minCharError = "password";
	        Config.localStorageToken = "access_token";
	        Config.localStorageTokenType = "token_type";
	        Config.localStorageRefreshToken = "refresh_token";
	        Config.utilities = "/utilities";
	        Config.cards = "/cards";
	        Config.coupon = "/coupons/code";
	        return Config;
	    })();
	    exports.Config = Config;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 4 */,
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var ConfirmController = (function () {
	        function ConfirmController(parent, config) {
	            this.parent = parent;
	            this.config = config;
	        }
	        ConfirmController.openPrivateDinnerModal = function (modal, confirmCallback) {
	            var _this = this;
	            return modal.open({
	                controller: function () { return new ConfirmController(_this, {
	                    title: "EVENT.PRIVATE_DINNER_TITLE",
	                    title2: "EVENT.PRIVATE_DINNER_MESSAGE",
	                    logo: false,
	                    class: "ot-small",
	                    actions: [
	                        {
	                            label: "EVENT.MODAL_CLOSE",
	                            primary: true,
	                            callback: confirmCallback
	                        }
	                    ]
	                }); },
	                controllerAs: "vm",
	                replace: true,
	                size: "sm",
	                template: TPL.modals.confirm,
	                windowClass: 'center-modal'
	            });
	        };
	        ConfirmController.openPasswordChangeDoneModal = function (modal) {
	            var _this = this;
	            return modal.open({
	                controller: function () { return new ConfirmController(_this, {
	                    title: "CHANGE_PASSWORD.CHANGE_DONE",
	                    logo: true,
	                    class: "ot-small",
	                    actions: null
	                }); },
	                controllerAs: "vm",
	                replace: true,
	                size: "sm",
	                template: TPL.modals.confirm
	            });
	        };
	        ConfirmController.openForgotPasswordDoneModal = function (modal) {
	            var _this = this;
	            return modal.open({
	                controller: function () { return new ConfirmController(_this, {
	                    title: "FORGOT.MAIL_SENT",
	                    logo: true,
	                    class: "ot-small",
	                    actions: null
	                }); },
	                controllerAs: "vm",
	                replace: true,
	                size: "sm",
	                template: TPL.modals.confirm
	            });
	        };
	        ConfirmController.openConfirmDeleteEventModal = function (modal, confirmCallback, cancelCallback) {
	            var _this = this;
	            return modal.open({
	                controller: function () { return new ConfirmController(_this, {
	                    title: "EVENT.CONFIRM_DELETE_TITLE",
	                    title2: "EVENT.CONFIRM_DELETE_TITLE2",
	                    logo: false,
	                    actions: [
	                        {
	                            label: "EVENT.CONFIRM_DELETE_SUBMIT",
	                            primary: true,
	                            callback: confirmCallback
	                        },
	                        {
	                            label: "EVENT.CONFIRM_DELETE_CANCEL",
	                            primary: false,
	                            callback: cancelCallback
	                        },
	                    ]
	                }); },
	                controllerAs: "vm",
	                replace: true,
	                size: "sm",
	                template: TPL.modals.confirm
	            });
	        };
	        ConfirmController.openConfirmDeleteReservationModal = function (modal, confirmCallback, cancelCallback) {
	            var _this = this;
	            return modal.open({
	                controller: function () { return new ConfirmController(_this, {
	                    title: "EVENT.CONFIRM_DELETE_RESERVATION_TITLE",
	                    title2: "EVENT.CONFIRM_DELETE_RESERVATION_TITLE2",
	                    logo: false,
	                    actions: [
	                        {
	                            label: "EVENT.CONFIRM_DELETE_SUBMIT",
	                            primary: true,
	                            callback: confirmCallback
	                        },
	                        {
	                            label: "EVENT.CONFIRM_DELETE_CANCEL",
	                            primary: false,
	                            callback: cancelCallback
	                        },
	                    ]
	                }); },
	                controllerAs: "vm",
	                replace: true,
	                size: "sm",
	                template: TPL.modals.confirm
	            });
	        };
	        ConfirmController.openRequestHostModal = function (modal, confirmCallback, cancelCallback) {
	            var _this = this;
	            return modal.open({
	                controller: function () { return new ConfirmController(_this, {
	                    title: "PROFILE.CONFIRM_HOST_TITLE",
	                    title2: "PROFILE.CONFIRM_HOST_TITLE2",
	                    logo: false,
	                    actions: [
	                        {
	                            label: "PROFILE.CONFIRM_HOST_SUBMIT",
	                            primary: true,
	                            callback: confirmCallback
	                        },
	                        {
	                            label: "PROFILE.CONFIRM_HOST_CANCEL",
	                            primary: false,
	                            callback: cancelCallback
	                        },
	                    ]
	                }); },
	                controllerAs: "vm",
	                replace: true,
	                size: "sm",
	                template: TPL.modals.confirm
	            });
	        };
	        ConfirmController.openImageTooLargeModal = function (modal) {
	            var _this = this;
	            return modal.open({
	                controller: function () { return new ConfirmController(_this, {
	                    title: "EVENT.IMAGE_TOO_LARGE_TITLE",
	                    title2: "EVENT.IMAGE_TOO_LARGE_SUBTITLE",
	                    logo: true,
	                    actions: null
	                }); },
	                controllerAs: "vm",
	                replace: true,
	                size: "sm",
	                template: TPL.modals.confirm
	            });
	        };
	        ConfirmController.openSaveDataModal = function (modal, saveDataCallback, dropDataCallback, backCallback) {
	            var _this = this;
	            return modal.open({
	                controller: function () { return new ConfirmController(_this, {
	                    title: "CREATE.MODAL_TITLE",
	                    title2: "CREATE.MODAL_SUBTITLE",
	                    title3: "CREATE.MODAL_SUGGESTION",
	                    logo: false,
	                    actions: [
	                        {
	                            label: "CREATE.MODAL_ACTION_KEEP",
	                            primary: true,
	                            callback: saveDataCallback
	                        },
	                        {
	                            label: "CREATE.MODAL_ACTION_DISCARD",
	                            primary: true,
	                            callback: dropDataCallback
	                        },
	                        {
	                            label: "CREATE.MODAL_ACTION_BACK",
	                            primary: false,
	                            callback: backCallback
	                        },
	                    ]
	                }); },
	                controllerAs: "vm",
	                replace: true,
	                size: "sm",
	                template: TPL.modals.confirm
	            });
	        };
	        ConfirmController.openReservationDonePublicModal = function (modal, shareCallback, browseCallback, backCallback) {
	            return ConfirmController.openReservationDoneModal(modal, "EVENT.SUCCESS_CONTENT_PUBLIC", shareCallback, browseCallback, backCallback);
	        };
	        ConfirmController.openReservationDoneManualModal = function (modal, shareCallback, browseCallback, backCallback) {
	            return ConfirmController.openReservationDoneModal(modal, "EVENT.SUCCESS_CONTENT_PENDING", shareCallback, browseCallback, backCallback);
	        };
	        ConfirmController.openReservationDoneModal = function (modal, content, shareCallback, browseCallback, backCallback) {
	            var _this = this;
	            return modal.open({
	                controller: function () { return new ConfirmController(_this, {
	                    title: "EVENT.SUCCESS_TITLE",
	                    title2: content,
	                    logo: false,
	                    actions: [
	                        {
	                            label: "EVENT.SUCCESS_BROWSE",
	                            primary: true,
	                            callback: browseCallback
	                        },
	                        {
	                            label: "EVENT.SUCCESS_BACK",
	                            primary: false,
	                            callback: backCallback
	                        },
	                    ]
	                }); },
	                controllerAs: "vm",
	                replace: true,
	                size: "sm",
	                template: TPL.modals.confirm
	            });
	        };
	        return ConfirmController;
	    })();
	    exports.ConfirmController = ConfirmController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 6 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, config_1) {
	    (function (UserType) {
	        UserType[UserType["NONE"] = 0] = "NONE";
	        UserType[UserType["GUEST"] = 1] = "GUEST";
	        UserType[UserType["HOST"] = 2] = "HOST";
	    })(exports.UserType || (exports.UserType = {}));
	    var UserType = exports.UserType;
	    var User = (function () {
	        function User() {
	            this.type = UserType.NONE;
	        }
	        User.createUser = function (tokenResponse, profileResponse) {
	            var result = new User();
	            result.token = User.buildToken(tokenResponse);
	            result.refreshProfile(profileResponse);
	            return result;
	        };
	        User.prototype.refreshProfile = function (profileResponse) {
	            this.user_id = profileResponse.data.id;
	            this.firstName = profileResponse.data.first_name;
	            this.lastName = profileResponse.data.last_name;
	            this.email = profileResponse.data.email;
	            this.avatar = User.getUserAvatar(profileResponse);
	            this.city = profileResponse.data.city;
	            this.city_state = profileResponse.data.city_state;
	            this.state = profileResponse.data.state;
	            if (profileResponse.data.dob) {
	                var date = new Date(profileResponse.data.dob);
	                var _userOffset = date.getTimezoneOffset() * 60 * 1000;
	                var _utcTime = new Date(date.getTime() + _userOffset);
	                if (_utcTime != null) {
	                    this.birthDate = _utcTime;
	                }
	                else {
	                    this.birthDate = date;
	                }
	            }
	            this.address = profileResponse.data.address;
	            this.phone = profileResponse.data.phone;
	            this.bio = profileResponse.data.bio;
	            this.location = profileResponse.data.location;
	            this.type = User.getUserType(profileResponse);
	            this.hostRequested = User.isHostRequested(profileResponse);
	        };
	        User.getUserAvatar = function (profileResponse) {
	            if (!profileResponse.data.avatar) {
	                return null;
	            }
	            return profileResponse.data.avatar.m;
	        };
	        User.getUserType = function (profileResponse) {
	            switch (profileResponse.data.state) {
	                case "guest":
	                case "awaiting_for_host":
	                    return UserType.GUEST;
	                case "host":
	                    return UserType.HOST;
	                default:
	                    return UserType.NONE;
	            }
	        };
	        User.isHostRequested = function (profileResponse) {
	            return profileResponse.data.state == "awaiting_for_host";
	        };
	        User.buildToken = function (tokenResponse) {
	            return tokenResponse.token_type + " " + tokenResponse.access_token;
	        };
	        User.createFakeUser = function (type) {
	            switch (type) {
	                case UserType.NONE:
	                    return new User();
	                case UserType.GUEST:
	                    var result = new User();
	                    result.type = UserType.GUEST;
	                    return result;
	                case UserType.HOST:
	                    var result = new User();
	                    result.type = UserType.HOST;
	                    return result;
	            }
	        };
	        return User;
	    })();
	    exports.User = User;
	    var Covers = (function () {
	        function Covers() {
	        }
	        Covers.getCoversInstance = function (publicEndpoint) {
	            return Covers.covers(publicEndpoint);
	        };
	        Covers.urlFromUri = function (uri) {
	            for (var i = 0; i < Covers.covers.length; i++) {
	                var cover = Covers.covers[i];
	                if (cover.uri == uri) {
	                    return cover.url;
	                }
	            }
	        };
	        Covers.isCover = function (url) {
	            return url && url.indexOf("cover://") == 0;
	        };
	        Covers.covers = function (publicEndpoint) {
	            return [
	                {
	                    imgClass: "ot-cover-0",
	                    uri: "content://cover_0",
	                    url: config_1.Config.publicEndpoint + "assets/cover_0.jpg",
	                    isActive: false
	                },
	                {
	                    imgClass: "ot-cover-1",
	                    uri: "content://cover_1",
	                    url: config_1.Config.publicEndpoint + "assets/cover_1.jpg",
	                    isActive: false
	                },
	                {
	                    imgClass: "ot-cover-2",
	                    uri: "content://cover_2",
	                    url: config_1.Config.publicEndpoint + "assets/cover_2.jpg",
	                    isActive: false
	                },
	                {
	                    imgClass: "ot-cover-3",
	                    uri: "content://cover_3",
	                    url: config_1.Config.publicEndpoint + "assets/cover_3.jpg",
	                    isActive: false
	                }
	            ];
	        };
	        return Covers;
	    })();
	    exports.Covers = Covers;
	    (function (EventType) {
	        EventType[EventType["PUBLIC"] = 0] = "PUBLIC";
	        EventType[EventType["PRIVATE"] = 1] = "PRIVATE";
	        EventType[EventType["MANUAL"] = 2] = "MANUAL";
	        EventType[EventType["ALL"] = 3] = "ALL";
	    })(exports.EventType || (exports.EventType = {}));
	    var EventType = exports.EventType;
	    ;
	    (function (MealType) {
	        MealType[MealType["HOME_COOKED"] = 0] = "HOME_COOKED";
	        MealType[MealType["ORDERED_IN"] = 1] = "ORDERED_IN";
	        MealType[MealType["BUFFET"] = 2] = "BUFFET";
	    })(exports.MealType || (exports.MealType = {}));
	    var MealType = exports.MealType;
	    ;
	    (function (AlcoholType) {
	        AlcoholType[AlcoholType["HOST_PROVIDES"] = 0] = "HOST_PROVIDES";
	        AlcoholType[AlcoholType["BYOB"] = 1] = "BYOB";
	        AlcoholType[AlcoholType["ALCOHOL_FREE"] = 2] = "ALCOHOL_FREE";
	        AlcoholType[AlcoholType["ALL"] = 3] = "ALL";
	    })(exports.AlcoholType || (exports.AlcoholType = {}));
	    var AlcoholType = exports.AlcoholType;
	    ;
	    (function (DietType) {
	        DietType[DietType["VEGETARIAN"] = 0] = "VEGETARIAN";
	        DietType[DietType["VEGAN"] = 1] = "VEGAN";
	        DietType[DietType["GLUTEN_FREE"] = 2] = "GLUTEN_FREE";
	        DietType[DietType["KOSHER"] = 3] = "KOSHER";
	        DietType[DietType["ALL"] = 4] = "ALL";
	    })(exports.DietType || (exports.DietType = {}));
	    var DietType = exports.DietType;
	    ;
	    (function (CostType) {
	        CostType[CostType["FREE"] = 0] = "FREE";
	        CostType[CostType["PAID"] = 1] = "PAID";
	        CostType[CostType["ALL"] = 2] = "ALL";
	    })(exports.CostType || (exports.CostType = {}));
	    var CostType = exports.CostType;
	    ;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, config_1) {
	    var LoginController = (function () {
	        function LoginController(parent, $rootScope, which, afterLoginCallback) {
	            var _this = this;
	            this.signUp = false;
	            this.parent = parent;
	            this.logIn = which == "login";
	            this.currentModal = this.parent.currentModal;
	            this.afterLoginCallback = afterLoginCallback;
	            var dismissAfterLoginCallback = $rootScope.$on("session.login", function () {
	                _this.currentModal.dismiss();
	                if (_this.afterLoginCallback != null) {
	                    _this.afterLoginCallback();
	                    _this.afterLoginCallback = null;
	                }
	                dismissAfterLoginCallback();
	            });
	        }
	        LoginController.prototype.getTermsLink = function () {
	            return config_1.Config.wp_termsandconditions;
	        };
	        LoginController.prototype.getLocationLink = function () {
	            return config_1.Config.wp_locations;
	        };
	        LoginController.openLoginModal = function (modal, parent, rootScope, afterLoginCallback) {
	            return modal.open({
	                controller: function () { return new LoginController(parent, rootScope, "login", afterLoginCallback); },
	                controllerAs: "vm",
	                replace: true,
	                size: "md",
	                template: TPL.modals.login
	            });
	        };
	        LoginController.openSignupModal = function (modal, parent, rootScope) {
	            return modal.open({
	                controller: function () { return new LoginController(parent, rootScope, "signup"); },
	                controllerAs: "vm",
	                replace: true,
	                size: "md",
	                template: TPL.modals.login
	            });
	        };
	        LoginController.prototype.isOnward = function () {
	            if (config_1.Config.isOnward) {
	                return true;
	            }
	        };
	        return LoginController;
	    })();
	    exports.LoginController = LoginController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_freshdirect.jpg";

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_instacart.jpg";

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_plated.jpg";

/***/ },
/* 13 */,
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_x.png";

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_navbar.jpg";

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logoless.gif";

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bower_components/ngWYSIWYG/dist/images/icons.png";

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bower_components/ngWYSIWYG/dist/images/resize.gif";

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * lodash <https://lodash.com/>
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.16.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://github.com/es-shims.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for function metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256,
	      FLIP_FLAG = 512;
	
	  /** Used to compose bitmasks for comparison styles. */
	  var UNORDERED_COMPARE_FLAG = 1,
	      PARTIAL_COMPARE_FLAG = 2;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 500,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', ARY_FLAG],
	    ['bind', BIND_FLAG],
	    ['bindKey', BIND_KEY_FLAG],
	    ['curry', CURRY_FLAG],
	    ['curryRight', CURRY_RIGHT_FLAG],
	    ['flip', FLIP_FLAG],
	    ['partial', PARTIAL_FLAG],
	    ['partialRight', PARTIAL_RIGHT_FLAG],
	    ['rearg', REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	      rsComboSymbolsRange = '\\u20d0-\\u20f0',
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	    rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	    rsUpper + '+' + rsOptUpperContr,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array ? array.length : 0;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array ? array.length : 0;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array ? array.length : 0;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array ? array.length : 0;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objectToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        iteratorSymbol = Symbol ? Symbol.iterator : undefined,
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array of at least `200` elements
	     * and any iteratees accept only one argument. The heuristic for whether a
	     * section qualifies for shortcut fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE ||
	          (arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function assignInDefaults(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths of elements to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          isNil = object == null,
	          length = paths.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = isNil ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {boolean} [isFull] Specify a clone including symbols.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var props = isArr ? undefined : (isFull ? getAllKeys : keys)(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      return objectToString.call(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      if (!isKey(path, object)) {
	        path = castPath(path);
	        object = parent(object, path);
	        path = last(path);
	      }
	      var func = object == null ? object : object[toKey(path)];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && objectToString.call(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && objectToString.call(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {boolean} [bitmask] The bitmask of comparison flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - Unordered comparison
	     *     2 - Partial comparison
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, bitmask, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = getTag(object);
	        objTag = objTag == argsTag ? objectTag : objTag;
	      }
	      if (!othIsArr) {
	        othTag = getTag(other);
	        othTag = othTag == argsTag ? objectTag : othTag;
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	          : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	      }
	      if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObject(value) && objectToString.call(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, props) {
	      object = Object(object);
	      return basePickBy(object, props, function(value, key) {
	        return key in object;
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick from.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, props, predicate) {
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (predicate(value, key)) {
	          baseAssignValue(result, key, value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          }
	          else if (!isKey(index, array)) {
	            var path = castPath(index),
	                object = parent(array, path);
	
	            if (object != null) {
	              delete object[toKey(last(path))];
	            }
	          }
	          else {
	            delete array[toKey(index)];
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	      object = parent(object, path);
	
	      var key = toKey(last(path));
	      return !(object != null && hasOwnProperty.call(object, key)) || delete object[key];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var index = -1,
	          length = arrays.length;
	
	      while (++index < length) {
	        var result = result
	          ? arrayPush(
	              baseDifference(result, arrays[index], iteratee, comparator),
	              baseDifference(arrays[index], result, iteratee, comparator)
	            )
	          : arrays[index];
	      }
	      return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value) {
	      return isArray(value) ? value : stringToPath(value);
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbol properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 &&
	              isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	          isFlip = bitmask & FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	      if (!(bitmask & CURRY_BOUND_FLAG)) {
	        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     *   512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] == null
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, customizer, bitmask, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= UNORDERED_COMPARE_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbol properties of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	    /**
	     * Creates an array of the own and inherited enumerable symbol properties
	     * of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = objectToString.call(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : undefined;
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object ? object.length : 0;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	        ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      string = toString(string);
	
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to process.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array ? array.length : 0;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs ? pairs.length : 0,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array ? array.length : 0;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (comparator === last(mapped)) {
	        comparator = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array ? nativeJoin.call(array, separator) : '';
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array ? array.length : 0,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array ? nativeReverse.call(array) : array;
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array ? array.length : 0;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length)
	        ? baseUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      return (array && array.length)
	        ? baseUniq(array, undefined, comparator)
	        : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return partial(wrapper, value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, false, true);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      return baseClone(value, false, true, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, true, true);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      return baseClone(value, true, true, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && objectToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return value != null && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are **not** supported.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      return (objectToString.call(value) == errorTag) ||
	        (typeof value.message == 'string' && typeof value.name == 'string');
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed array and other constructors.
	      var tag = isObject(value) ? objectToString.call(value) : '';
	      return tag == funcTag || tag == genTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && objectToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || objectToString.call(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return (typeof Ctor == 'function' &&
	        Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && objectToString.call(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && objectToString.call(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (iteratorSymbol && value[iteratorSymbol]) {
	        return iteratorToArray(value[iteratorSymbol]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, assignInDefaults);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, mergeDefaults);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable string keyed properties of `object` that are
	     * not omitted.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      props = arrayMap(props, toKey);
	      return basePick(object, baseDifference(getAllKeysIn(object), props));
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, props) {
	      return object == null ? {} : basePick(object, arrayMap(props, toKey));
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      return object == null ? {} : basePickBy(object, getAllKeysIn(object), getIteratee(predicate));
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        object = undefined;
	        length = 1;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object ? baseValues(object, keys(object)) : [];
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = baseClamp(toInteger(position), 0, string.length);
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, assignInDefaults);
	
	      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs ? pairs.length : 0,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (iteratorSymbol) {
	      lodash.prototype[iteratorSymbol] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(153)(module)))

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(8), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, angular, data, config_1) {
	    (function (SessionStatus) {
	        SessionStatus[SessionStatus["NOT_LOGGED"] = 0] = "NOT_LOGGED";
	        SessionStatus[SessionStatus["LOGGING"] = 1] = "LOGGING";
	        SessionStatus[SessionStatus["LOGGED"] = 2] = "LOGGED";
	        SessionStatus[SessionStatus["LOG_FAILED"] = 3] = "LOG_FAILED";
	    })(exports.SessionStatus || (exports.SessionStatus = {}));
	    var SessionStatus = exports.SessionStatus;
	    (function (DataStatus) {
	        DataStatus[DataStatus["NOT_LOADED"] = 0] = "NOT_LOADED";
	        DataStatus[DataStatus["LOADING"] = 1] = "LOADING";
	        DataStatus[DataStatus["LOADED"] = 2] = "LOADED";
	        DataStatus[DataStatus["LOAD_FAILED"] = 3] = "LOAD_FAILED";
	        DataStatus[DataStatus["DELETED"] = 4] = "DELETED";
	    })(exports.DataStatus || (exports.DataStatus = {}));
	    var DataStatus = exports.DataStatus;
	    (function (EventListType) {
	        EventListType[EventListType["PUBLIC"] = 0] = "PUBLIC";
	        EventListType[EventListType["PRIVATE"] = 1] = "PRIVATE";
	        EventListType[EventListType["UPCOMING"] = 2] = "UPCOMING";
	        EventListType[EventListType["SUGGESTED"] = 3] = "SUGGESTED";
	        EventListType[EventListType["HOSTED"] = 4] = "HOSTED";
	        EventListType[EventListType["SAVED"] = 5] = "SAVED";
	        EventListType[EventListType["PAST"] = 6] = "PAST";
	    })(exports.EventListType || (exports.EventListType = {}));
	    var EventListType = exports.EventListType;
	    ;
	    (function (LoginType) {
	        LoginType[LoginType["PASSWORD"] = 0] = "PASSWORD";
	        LoginType[LoginType["REFRESH_TOKEN"] = 1] = "REFRESH_TOKEN";
	        LoginType[LoginType["FACEBOOK"] = 2] = "FACEBOOK";
	        LoginType[LoginType["LOCAL_STORAGE"] = 3] = "LOCAL_STORAGE";
	    })(exports.LoginType || (exports.LoginType = {}));
	    var LoginType = exports.LoginType;
	    ;
	    var DataModel = (function () {
	        function DataModel($http, $timeout, $q, $log, spinnerService) {
	            this.eventStatus = DataStatus.NOT_LOADED;
	            this.reservationListStatus = DataStatus.NOT_LOADED;
	            this.myReservationsStatus = DataStatus.NOT_LOADED;
	            this.sponsorListStatus = DataStatus.NOT_LOADED;
	            this.publicEventList = [];
	            this.publicEventListStatus = DataStatus.NOT_LOADED;
	            this.privateEventList = [];
	            this.privateEventListStatus = DataStatus.NOT_LOADED;
	            this.upcomingEventList = [];
	            this.upcomingEventListStatus = DataStatus.NOT_LOADED;
	            this.suggestedEventList = [];
	            this.suggestedEventListStatus = DataStatus.NOT_LOADED;
	            this.hostedEventList = [];
	            this.hostedEventListStatus = DataStatus.NOT_LOADED;
	            this.pastEventList = [];
	            this.pastEventListStatus = DataStatus.NOT_LOADED;
	            this.savedEventList = [];
	            this.savedEventListStatus = DataStatus.NOT_LOADED;
	            this.http = $http;
	            this.timeout = $timeout;
	            this.log = $log;
	            this.q = $q;
	            this.spinnerService = spinnerService;
	        }
	        DataModel.prototype.setStatus = function (type, status) {
	            switch (type) {
	                case EventListType.PUBLIC:
	                    this.publicEventListStatus = status;
	                    return;
	                case EventListType.PRIVATE:
	                    this.privateEventListStatus = status;
	                    return;
	                case EventListType.UPCOMING:
	                    this.upcomingEventListStatus = status;
	                    return;
	                case EventListType.HOSTED:
	                    this.hostedEventListStatus = status;
	                    return;
	                case EventListType.SAVED:
	                    this.savedEventListStatus = status;
	                    return;
	                case EventListType.PAST:
	                    this.pastEventListStatus = status;
	                    return;
	                case EventListType.SUGGESTED:
	                    this.suggestedEventListStatus = status;
	                    return;
	                default:
	                    throw "Request status change for an unknown type";
	            }
	        };
	        DataModel.prototype.getStatus = function (type) {
	            switch (type) {
	                case EventListType.PUBLIC:
	                    return this.publicEventListStatus;
	                case EventListType.PRIVATE:
	                    return this.privateEventListStatus;
	                case EventListType.UPCOMING:
	                    return this.upcomingEventListStatus;
	                case EventListType.HOSTED:
	                    return this.hostedEventListStatus;
	                case EventListType.SAVED:
	                    return this.savedEventListStatus;
	                case EventListType.PAST:
	                    return this.pastEventListStatus;
	                case EventListType.SUGGESTED:
	                    return this.suggestedEventListStatus;
	                default:
	                    throw "Request status for an unknown type";
	            }
	        };
	        DataModel.prototype.setData = function (type, data, merge, user) {
	            var _this = this;
	            if (merge === void 0) { merge = false; }
	            switch (type) {
	                case EventListType.PUBLIC:
	                    if (merge) {
	                        angular.forEach(data, function (item) {
	                            _this.publicEventList.push(item);
	                        });
	                    }
	                    else {
	                        this.publicEventList = data;
	                    }
	                    return;
	                case EventListType.PRIVATE:
	                    this.log.debug(merge);
	                    if (merge) {
	                        angular.forEach(data, function (item) {
	                            _this.privateEventList.push(item);
	                        });
	                        this.log.debug("merge");
	                        this.log.debug(this.privateEventList);
	                    }
	                    else {
	                        this.privateEventList = data;
	                        this.myReservations;
	                        if (this.myReservations && typeof this.myReservations != "undefined") {
	                            angular.forEach(this.privateEventList, function (value) {
	                                angular.forEach(_this.myReservations, function (value1) {
	                                    if (value1.event_id == value.id) {
	                                        value1.event_id;
	                                        value.my_reservation = value1;
	                                    }
	                                });
	                                if (value.created_by_profile && value.created_by_profile.id == user.user_id) {
	                                    value.hosted_by_me = true;
	                                }
	                            });
	                        }
	                        this.privateEventList;
	                        this.log.debug("not merge");
	                        this.log.debug(this.privateEventList);
	                    }
	                    return;
	                case EventListType.UPCOMING:
	                    if (merge) {
	                        angular.forEach(data, function (item) {
	                            _this.upcomingEventList.push(item);
	                        });
	                    }
	                    else {
	                        this.upcomingEventList = data;
	                    }
	                    return;
	                case EventListType.HOSTED:
	                    if (merge) {
	                        angular.forEach(data, function (item) {
	                            _this.hostedEventList.push(item);
	                        });
	                    }
	                    else {
	                        this.hostedEventList = data;
	                    }
	                    return;
	                case EventListType.SAVED:
	                    if (merge) {
	                        angular.forEach(data, function (item) {
	                            _this.savedEventList.push(item);
	                        });
	                    }
	                    else {
	                        this.savedEventList = data;
	                    }
	                    return;
	                case EventListType.PAST:
	                    if (merge) {
	                        angular.forEach(data, function (item) {
	                            _this.pastEventList.push(item);
	                        });
	                    }
	                    else {
	                        this.pastEventList = data;
	                    }
	                    return;
	                case EventListType.SUGGESTED:
	                    if (merge) {
	                        angular.forEach(data, function (item) {
	                            _this.suggestedEventList.push(item);
	                        });
	                    }
	                    else {
	                        this.suggestedEventList = data;
	                    }
	                    return;
	                default:
	                    throw "Request data change for an unknown type";
	            }
	        };
	        DataModel.prototype.setMetadata = function (type, metadata) {
	            switch (type) {
	                case EventListType.PUBLIC:
	                    this.publicEventListMetadata = metadata;
	                    return;
	                case EventListType.PRIVATE:
	                    this.privateEventListMetadata = metadata;
	                    return;
	                case EventListType.UPCOMING:
	                    this.upcomingEventListMetadata = metadata;
	                    return;
	                case EventListType.HOSTED:
	                    this.hostedEventListMetadata = metadata;
	                    return;
	                case EventListType.SAVED:
	                    this.savedEventListMetadata = metadata;
	                    return;
	                case EventListType.PAST:
	                    this.pastEventListMetadata = metadata;
	                    return;
	                case EventListType.SUGGESTED:
	                    this.suggestedEventListMetadata = metadata;
	                    return;
	                default:
	                    throw "Request metadata change for an unknown type";
	            }
	        };
	        DataModel.prototype.getMetadata = function (type) {
	            switch (type) {
	                case EventListType.PUBLIC:
	                    return this.publicEventListMetadata;
	                case EventListType.PRIVATE:
	                    return this.privateEventListMetadata;
	                case EventListType.UPCOMING:
	                    return this.upcomingEventListMetadata;
	                case EventListType.HOSTED:
	                    return this.hostedEventListMetadata;
	                case EventListType.SAVED:
	                    return this.savedEventListMetadata;
	                case EventListType.PAST:
	                    return this.pastEventListMetadata;
	                case EventListType.SUGGESTED:
	                    return this.suggestedEventListMetadata;
	                default:
	                    throw "Request metadata for an unknown type";
	            }
	        };
	        DataModel.prototype.shortenUrl = function (longUrl) {
	            var request = {
	                method: "POST",
	                url: "https://www.googleapis.com/urlshortener/v1/url?key=" + config_1.Config.googleKey,
	                data: {
	                    longUrl: longUrl
	                }
	            };
	            return this.http(request);
	        };
	        DataModel.prototype.loadEvents = function (request, type, user) {
	            var _this = this;
	            request.method = "GET";
	            this.setStatus(type, DataStatus.LOADING);
	            this.setData(type, null, false, null);
	            this.setMetadata(type, null);
	            this.log.debug("loadEvents");
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	                _this.setData(type, response.data.data, false, user);
	                response.data.metadata["request"] = request;
	                _this.setMetadata(type, response.data.metadata);
	                _this.setStatus(type, DataStatus.LOADED);
	            }, function (error) {
	                _this.setData(type, null, false, null);
	                _this.setMetadata(type, null);
	                _this.setStatus(type, DataStatus.LOAD_FAILED);
	                throw error;
	            });
	        };
	        DataModel.prototype.loadMore = function (type, user) {
	            var _this = this;
	            var metadata = this.getMetadata(type);
	            if (metadata && metadata.next_page && !metadata["loadedMore"]) {
	                if (!metadata["request"].params) {
	                    metadata["request"].params = {};
	                }
	                metadata["request"].params.page = metadata.next_page;
	                metadata["loadedMore"] = true;
	                this.log.debug("loadMore");
	                return this.http(metadata["request"]).then(function (response) {
	                    _this.log.debug(response);
	                    _this.setData(type, response.data.data, true, user);
	                    response.data.metadata["request"] = metadata["request"];
	                    _this.setMetadata(type, response.data.metadata);
	                    return true;
	                }, function (error) {
	                    _this.setData(type, null, false, null);
	                    _this.setMetadata(type, null);
	                    _this.setStatus(type, DataStatus.LOAD_FAILED);
	                    throw error;
	                });
	            }
	            else {
	                return this.q.when(false);
	            }
	        };
	        DataModel.prototype.loadEvent = function (request, eventId) {
	            var _this = this;
	            request.method = "GET";
	            request.url = config_1.Config.eventsEndpoint + "/" + eventId;
	            this.eventStatus = DataStatus.LOADING;
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	                _this.event = _this.parseEvent(response.data.data);
	                _this.eventStatus = DataStatus.LOADED;
	                return _this.event;
	            }, function (error) {
	                _this.event = null;
	                _this.eventStatus = DataStatus.LOAD_FAILED;
	                throw error;
	            });
	        };
	        DataModel.prototype.deleteEvent = function (request, eventId) {
	            var _this = this;
	            request.method = "DELETE";
	            request.url = config_1.Config.eventsEndpoint + "/" + eventId;
	            this.eventStatus = DataStatus.LOADING;
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	            }, function (error) {
	                throw error;
	            });
	        };
	        DataModel.prototype.loadReservations = function (request, eventId) {
	            var _this = this;
	            request.method = "GET";
	            request.url = config_1.Config.eventsEndpoint + "/" + eventId + "/" + config_1.Config.reservations;
	            this.reservationListStatus = DataStatus.LOADING;
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	                _this.reservationListStatus = DataStatus.LOADED;
	                return _this.reservationList = response.data.data;
	            }, function (error) {
	                _this.reservationList = null;
	                _this.reservationListStatus = DataStatus.LOAD_FAILED;
	                throw error;
	            });
	        };
	        DataModel.prototype.loadMyReservations = function (request) {
	            var _this = this;
	            request.method = "GET";
	            request.url = config_1.Config.profileEndpoint + "/" + config_1.Config.reservations;
	            this.reservationListStatus = DataStatus.LOADING;
	            this.http(request).then(function (response) {
	                _this.log.debug(response);
	                _this.myReservations = response.data.data;
	                _this.myReservationsStatus = DataStatus.LOADED;
	            }, function (error) {
	                _this.reservationList = null;
	                _this.reservationListStatus = DataStatus.LOAD_FAILED;
	                throw error;
	            });
	        };
	        DataModel.prototype.loadTimezones = function (request) {
	            var _this = this;
	            request.method = "GET";
	            request.url = config_1.Config.timezoneEndpoint;
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	                return response.data.data;
	            }, function (error) {
	                throw error;
	            });
	        };
	        DataModel.prototype.loadCardsList = function (request) {
	            var _this = this;
	            request.method = "GET";
	            request.url = config_1.Config.cardsEndpoint;
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	                return response.data.data;
	            }, function (error) {
	                throw error;
	            });
	        };
	        DataModel.prototype.loadCard = function (request, cardId) {
	            var _this = this;
	            request.method = "GET";
	            request.url = config_1.Config.cardsEndpoint + "/" + cardId;
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	                return response.data.data;
	            }, function (error) {
	                throw error;
	            });
	        };
	        DataModel.prototype.getCouponData = function (request, couponNumber) {
	            var _this = this;
	            request.method = "GET";
	            request.url = config_1.Config.couponEndpoint + "/" + couponNumber;
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	                return response.data.data;
	            }, function (error) {
	                throw error;
	            });
	        };
	        DataModel.prototype.loadSponsors = function (request, areaCode) {
	            var _this = this;
	            request.method = "GET";
	            request.url = config_1.Config.areasEndpoint + "/" + areaCode + "/" + config_1.Config.sponsors;
	            this.sponsorListStatus = DataStatus.LOADING;
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	                _this.sponsorList = response.data.data;
	                _this.sponsorListStatus = DataStatus.LOADED;
	                return true;
	            }).catch(function (error) {
	                _this.sponsorList = null;
	                _this.sponsorListStatus = DataStatus.LOAD_FAILED;
	                throw error;
	            });
	        };
	        DataModel.prototype.deleteReservation = function (request, eventId) {
	            var _this = this;
	            request.method = "DELETE";
	            request.url = config_1.Config.eventsEndpoint + "/" + eventId + "/" + config_1.Config.reservations;
	            this.eventStatus = DataStatus.LOADING;
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	            }, function (error) {
	                throw error;
	            });
	        };
	        DataModel.prototype.acceptReservation = function (request, reservationId, message) {
	            var _this = this;
	            request.method = "POST";
	            request.url = config_1.Config.reservationsEndpoint + "/" + reservationId + "/accept";
	            request.data = {
	                data: {
	                    message: message
	                }
	            };
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	            }, function (error) {
	                throw error;
	            });
	        };
	        DataModel.prototype.rejectReservation = function (request, reservationId, message) {
	            var _this = this;
	            request.method = "POST";
	            request.url = config_1.Config.reservationsEndpoint + "/" + reservationId + "/reject";
	            request.data = {
	                data: {
	                    message: message
	                }
	            };
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	            }, function (error) {
	                throw error;
	            });
	        };
	        DataModel.prototype.parseEvent = function (rawEvent) {
	            try {
	                rawEvent.notes = JSON.parse(rawEvent.notes);
	            }
	            catch (e) {
	                rawEvent.notes = {
	                    version: "1",
	                    first: [],
	                    second: [],
	                    third: []
	                };
	            }
	            return rawEvent;
	        };
	        DataModel.prototype.loadPublicEvents = function (request) {
	            this.loadEvents(request, EventListType.PUBLIC, null);
	        };
	        DataModel.prototype.loadMorePublicEvents = function () {
	            return this.loadMore(EventListType.PUBLIC);
	        };
	        DataModel.prototype.loadPrivateEvents = function (request, user) {
	            this.loadEvents(request, EventListType.PRIVATE, user);
	        };
	        DataModel.prototype.loadMorePrivateEvents = function (user) {
	            return this.loadMore(EventListType.PRIVATE, user);
	        };
	        DataModel.prototype.loadUpcomingEvents = function (request) {
	            this.loadEvents(request, EventListType.UPCOMING, null);
	        };
	        DataModel.prototype.loadMoreUpcomingEvents = function () {
	            return this.loadMore(EventListType.UPCOMING);
	        };
	        DataModel.prototype.loadHostedEvents = function (request) {
	            this.loadEvents(request, EventListType.HOSTED, null);
	        };
	        DataModel.prototype.loadMoreHostedEvents = function () {
	            return this.loadMore(EventListType.HOSTED);
	        };
	        DataModel.prototype.loadSavedEvents = function (request) {
	            this.loadEvents(request, EventListType.SAVED, null);
	        };
	        DataModel.prototype.loadMoreSavedEvents = function () {
	            return this.loadMore(EventListType.SAVED);
	        };
	        DataModel.prototype.loadPastEvents = function (request) {
	            this.loadEvents(request, EventListType.PAST, null);
	        };
	        DataModel.prototype.loadMorePastEvents = function () {
	            return this.loadMore(EventListType.PAST);
	        };
	        DataModel.prototype.loadSuggestedEvents = function (request) {
	            this.loadEvents(request, EventListType.SUGGESTED, null);
	        };
	        DataModel.prototype.isLoadingEvents = function (type) {
	            return this.getStatus(type) == DataStatus.LOADING;
	        };
	        DataModel.prototype.hasLoadedEvents = function (type) {
	            return this.getStatus(type) == DataStatus.LOADED;
	        };
	        DataModel.prototype.isLoadingPrivateEvents = function () {
	            return this.isLoadingEvents(EventListType.PRIVATE);
	        };
	        DataModel.prototype.hasLoadedPrivateEvents = function () {
	            return this.hasLoadedEvents(EventListType.PRIVATE);
	        };
	        DataModel.prototype.isLoadingPublicEvents = function () {
	            return this.isLoadingEvents(EventListType.PUBLIC);
	        };
	        DataModel.prototype.hasLoadedPublicEvents = function () {
	            return this.hasLoadedEvents(EventListType.PUBLIC);
	        };
	        DataModel.prototype.isLoadingUpcomingEvents = function () {
	            return this.isLoadingEvents(EventListType.UPCOMING);
	        };
	        DataModel.prototype.hasLoadedUpcomingEvents = function () {
	            return this.hasLoadedEvents(EventListType.UPCOMING);
	        };
	        DataModel.prototype.isLoadingHostedEvents = function () {
	            return this.isLoadingEvents(EventListType.HOSTED);
	        };
	        DataModel.prototype.hasLoadedHostedEvents = function () {
	            return this.hasLoadedEvents(EventListType.HOSTED);
	        };
	        DataModel.prototype.isLoadingSavedEvents = function () {
	            return this.isLoadingEvents(EventListType.SAVED);
	        };
	        DataModel.prototype.hasLoadedSavedEvents = function () {
	            return this.hasLoadedEvents(EventListType.SAVED);
	        };
	        DataModel.prototype.isLoadingSuggestedEvents = function () {
	            return this.isLoadingEvents(EventListType.SUGGESTED);
	        };
	        DataModel.prototype.hasLoadedSuggestedEvents = function () {
	            return this.hasLoadedEvents(EventListType.SUGGESTED);
	        };
	        return DataModel;
	    })();
	    exports.DataModel = DataModel;
	    var SessionService = (function () {
	        function SessionService($http, $timeout, $rootScope, $route, $cookies, Upload, $moment, prelogin, preconfig, $log, $q, spinnerService) {
	            window["SESSION"] = this;
	            this.cookies = $cookies;
	            this.http = $http;
	            this.timeout = $timeout;
	            this.route = $route;
	            this.rootScope = $rootScope;
	            this.upload = Upload;
	            this.moment = $moment;
	            this.log = $log;
	            this.q = $q;
	            this.data = new DataModel($http, $timeout, $q, $log, spinnerService);
	            this.availableCities = SessionService.parseAvailableCities(preconfig);
	            this.user = data.User.createFakeUser(data.UserType.NONE);
	            this.status = SessionStatus.NOT_LOGGED;
	            this.spinnerService = spinnerService;
	            if (!prelogin) {
	                this.user = data.User.createFakeUser(data.UserType.NONE);
	                this.status = SessionStatus.NOT_LOGGED;
	            }
	            else {
	                this.user = prelogin.user;
	                this.status = prelogin.status;
	            }
	        }
	        SessionService.toDate = function (dateString, clearTimeZone) {
	            if (clearTimeZone === void 0) { clearTimeZone = false; }
	            if (clearTimeZone) {
	                var doo = new Date(dateString);
	                return new Date(doo.getTime() + doo.getTimezoneOffset() * 60000);
	            }
	            else {
	                return new Date(dateString);
	            }
	        };
	        SessionService.toPrice = function (priceString) {
	            return parseFloat(priceString) || undefined;
	        };
	        SessionService.toISOString = function (date) {
	            return date ? date.toISOString() : undefined;
	        };
	        SessionService.toString = function (localDate) {
	            return localDate ? localDate.toString() : undefined;
	        };
	        SessionService.after24Hours = function (d) {
	            return new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1);
	        };
	        SessionService.isToday = function (d) {
	            var now = new Date();
	            return d.getFullYear() == now.getFullYear() &&
	                d.getMonth() == now.getMonth() &&
	                d.getDate() == now.getDate();
	        };
	        SessionService.isTomorrow = function (d) {
	            return SessionService.isToday(SessionService.after24Hours(d));
	        };
	        SessionService.prototype.prelogin = function () {
	            var _this = this;
	            return this.loginWithLocalStorage()
	                .catch(function (err) {
	                return _this.timeout(false);
	            });
	        };
	        SessionService.prototype.preconfig = function () {
	            return this.loadCityList();
	        };
	        SessionService.parseAvailableCities = function (preconfig) {
	            if (!preconfig) {
	                return [];
	            }
	            var result = [];
	            var ny;
	            var other;
	            var allcity = { "id": 0, "code": "", "url": "", "label": "All States", "timezone": "", "neighborhoods": null, "nourishment": false, "photo": { "id": 0, "original": null, "s": null, "m": null, "l": null } };
	            result.push(allcity);
	            angular.forEach(preconfig, function (value) {
	                if (value.code == "OTHER" || value.code == "OT") {
	                    other = value;
	                }
	                else {
	                    result.push(value);
	                }
	            });
	            if (config_1.Config.isOnward) {
	                result.sort();
	            }
	            if (other) {
	                result.push(other);
	            }
	            return result;
	        };
	        SessionService.prototype.obtainToken = function (auth0, auth1, loginType) {
	            var _this = this;
	            var url;
	            var message;
	            switch (loginType) {
	                case LoginType.LOCAL_STORAGE:
	                    var localStorageTokenType = localStorage.getItem(config_1.Config.localStorageTokenType);
	                    var localStorageAccessToken = localStorage.getItem(config_1.Config.localStorageToken);
	                    var localStorageRefreshToken = localStorage.getItem(config_1.Config.localStorageRefreshToken);
	                    if (!localStorageTokenType || !localStorageAccessToken || !localStorageRefreshToken) {
	                        return this.q.reject("Cannot obtain token from localStorage");
	                    }
	                    return this.q.when({
	                        token_type: localStorageTokenType,
	                        access_token: localStorageAccessToken,
	                        refresh_token: localStorageRefreshToken
	                    });
	                case LoginType.FACEBOOK:
	                    url = config_1.Config.tokenSocialEndpoint;
	                    message = {
	                        "grant_type": "social",
	                        "social_provider": "facebook",
	                        "social_uid": auth0,
	                        "social_token": auth1
	                    };
	                    break;
	                case LoginType.REFRESH_TOKEN:
	                    url = config_1.Config.tokenEndpoint;
	                    message = {
	                        grant_type: "refresh_token",
	                        refresh_token: auth0
	                    };
	                    break;
	                default:
	                    url = config_1.Config.tokenEndpoint;
	                    message = {
	                        "grant_type": "password",
	                        "username": auth0,
	                        "password": auth1
	                    };
	            }
	            this.log.debug(message);
	            return this.http({
	                method: "POST",
	                url: url,
	                data: message
	            }).then(function (tokenResponse) {
	                var tokenData = tokenResponse.data;
	                _this.log.debug(tokenData);
	                return tokenData;
	            });
	        };
	        SessionService.prototype.buildBaseRequest = function (tokenData) {
	            var token = !!tokenData ?
	                data.User.buildToken(tokenData) :
	                this.user.token;
	            return {
	                headers: { Authorization: token }
	            };
	        };
	        SessionService.prototype.loadProfile = function (tokenData) {
	            var _this = this;
	            var request = this.buildBaseRequest(tokenData);
	            request.method = "GET";
	            request.url = config_1.Config.profileEndpoint;
	            return this.http(request).then(function (profileResponse) {
	                _this.log.debug(profileResponse);
	                return [tokenData, profileResponse];
	            });
	        };
	        SessionService.prototype.loginWithFb = function (userId, token) {
	            return this.login(userId, token, LoginType.FACEBOOK);
	        };
	        SessionService.prototype.loginWithRefreshToken = function (refreshToken) {
	            return this.login(refreshToken, null, LoginType.REFRESH_TOKEN);
	        };
	        SessionService.prototype.loginWithPassword = function (username, password) {
	            return this.login(username, password, LoginType.PASSWORD);
	        };
	        SessionService.prototype.loginWithLocalStorage = function () {
	            return this.login(null, null, LoginType.LOCAL_STORAGE);
	        };
	        SessionService.prototype.login = function (auth0, auth1, loginType) {
	            var _this = this;
	            this.log.debug("login has been called");
	            if (loginType != LoginType.REFRESH_TOKEN) {
	                this.status = SessionStatus.LOGGING;
	            }
	            return this.obtainToken(auth0, auth1, loginType)
	                .then(function (tokenData) { return _this.loadProfile(tokenData); })
	                .then(function (result) {
	                var tokenData = result[0];
	                var profileData = result[1].data;
	                _this.user = data.User.createUser(tokenData, profileData);
	                if (loginType != LoginType.LOCAL_STORAGE) {
	                    try {
	                        localStorage.setItem(config_1.Config.localStorageTokenType, tokenData.token_type);
	                        localStorage.setItem(config_1.Config.localStorageRefreshToken, tokenData.refresh_token);
	                        localStorage.setItem(config_1.Config.localStorageToken, tokenData.access_token);
	                    }
	                    catch (error) {
	                        _this.log.debug("Local Storege Error");
	                    }
	                }
	                if (!(_this.status == SessionStatus.LOGGED)) {
	                    _this.status = SessionStatus.LOGGED;
	                    _this.rootScope.$broadcast("session.login");
	                }
	                return {
	                    user: _this.user,
	                    status: _this.status
	                };
	            })
	                .catch(function (err) {
	                _this.log.debug("Caught");
	                _this.log.debug("login error: " + err);
	                _this.status = SessionStatus.LOG_FAILED;
	                _this.user = null;
	                throw err;
	            });
	        };
	        SessionService.prototype.logout = function () {
	            this.log.debug("logout has been called");
	            localStorage.removeItem(config_1.Config.localStorageRefreshToken);
	            localStorage.removeItem(config_1.Config.localStorageToken);
	            localStorage.removeItem(config_1.Config.localStorageTokenType);
	            this.status = SessionStatus.NOT_LOGGED;
	            this.user = data.User.createFakeUser(data.UserType.NONE);
	            this.data = new DataModel(this.http, this.timeout, this.q, this.log, this.spinnerService);
	            FB.getLoginStatus(function (response) {
	                if (response.status === 'connected') {
	                    FB.logout(function (response) {
	                    });
	                }
	            });
	            this.rootScope.$broadcast("session.logout");
	        };
	        SessionService.prototype.loadHostedEvents = function () {
	            var request = this.buildBaseRequest();
	            request.method = "GET";
	            request.url = config_1.Config.dashboardEventsEndpoint + '?only=hosted';
	            this.data.loadHostedEvents(request);
	        };
	        SessionService.prototype.loadMoreHostedEvents = function () {
	            return this.data.loadMoreHostedEvents();
	        };
	        SessionService.prototype.loadUpcomingEvents = function () {
	            var request = this.buildBaseRequest();
	            request.method = "GET";
	            request.url = config_1.Config.dashboardEventsEndpoint + '?only=reserved';
	            this.data.loadUpcomingEvents(request);
	        };
	        SessionService.prototype.loadMoreUpcomingEvents = function () {
	            return this.data.loadMoreUpcomingEvents();
	        };
	        SessionService.prototype.loadSavedEvents = function () {
	            var request = this.buildBaseRequest();
	            request.method = "GET";
	            request.url = config_1.Config.dashboardEventsEndpoint + '?only=draft';
	            this.data.loadSavedEvents(request);
	        };
	        SessionService.prototype.loadMoreSavedEvents = function () {
	            return this.data.loadMoreSavedEvents();
	        };
	        SessionService.prototype.loadPastEvents = function () {
	            var request = this.buildBaseRequest();
	            request.method = "GET";
	            request.url = config_1.Config.dashboardEventsEndpoint + '?only=past';
	            this.data.loadPastEvents(request);
	        };
	        SessionService.prototype.loadMorePastEvents = function () {
	            return this.data.loadMorePastEvents();
	        };
	        SessionService.prototype.loadNourishment = function (eventId) {
	            var _this = this;
	            var request = this.buildBaseRequest();
	            request.method = "GET";
	            request.url = config_1.Config.eventsEndpoint + '/' + eventId + '/nourishments';
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	                return response;
	            });
	        };
	        SessionService.prototype.sponsorFilter = function (sponsors) {
	            var amount;
	            var result = [];
	            angular.forEach(sponsors, function (sponsor) {
	                amount = sponsor.currentValue;
	                var parts = { "sponsor_id": sponsor.id, "amount": Math.round(sponsor.currentValue * 100) };
	                if (amount) {
	                    result.push(parts);
	                }
	            });
	            return result;
	        };
	        SessionService.prototype.saveNourishment = function (eventId, supposedGuests, sponsors) {
	            var _this = this;
	            var request = this.buildBaseRequest();
	            var sponsorsData = this.sponsorFilter(sponsors);
	            request.method = "PUT";
	            request.url = config_1.Config.eventsEndpoint + '/' + eventId;
	            request.data = {
	                data: {
	                    expected_guests: supposedGuests,
	                    sponsorships: sponsorsData
	                }
	            };
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	                return response;
	            });
	        };
	        SessionService.prototype.saveExpectedGuest = function (eventId, supposedGuests) {
	            var _this = this;
	            var request = this.buildBaseRequest();
	            request.method = "PUT";
	            request.url = config_1.Config.eventsEndpoint + '/' + eventId;
	            request.data = {
	                data: {
	                    expected_guests: supposedGuests
	                }
	            };
	            return this.http(request).then(function (response) {
	                _this.log.debug(response);
	                return response;
	            });
	        };
	        SessionService.prototype.getLandingPage = function () {
	            return config_1.Config.home;
	        };
	        SessionService.prototype.isLogging = function () {
	            return this.status == SessionStatus.LOGGING;
	        };
	        SessionService.prototype.isNotLogging = function () {
	            return this.status == SessionStatus.NOT_LOGGED || this.status == SessionStatus.LOG_FAILED;
	        };
	        SessionService.prototype.isOnward = function () {
	            if (config_1.Config.isOnward) {
	                return true;
	            }
	        };
	        SessionService.prototype.isLogged = function () {
	            return this.status == SessionStatus.LOGGED;
	        };
	        SessionService.prototype.getType = function () {
	            return this.user.type;
	        };
	        SessionService.prototype.isGuest = function () {
	            return this.user.type == data.UserType.GUEST;
	        };
	        SessionService.prototype.isHost = function () {
	            return this.user.type == data.UserType.HOST;
	        };
	        SessionService.prototype.isHostRequested = function () {
	            return this.user.hostRequested;
	        };
	        SessionService.prototype.getStatus = function () {
	            return this.status;
	        };
	        SessionService.prototype.getUserId = function () {
	            return this.user.user_id;
	        };
	        SessionService.prototype.getFirstName = function () {
	            return this.user.firstName;
	        };
	        SessionService.prototype.getLastName = function () {
	            return this.user.lastName;
	        };
	        SessionService.prototype.getFullName = function () {
	            return this.user.firstName + " " + this.user.lastName;
	        };
	        SessionService.prototype.getBirthDate = function () {
	            return this.user.birthDate;
	        };
	        SessionService.prototype.getAvatar = function () {
	            return this.user.avatar;
	        };
	        SessionService.prototype.getAddress = function () {
	            return this.user.address;
	        };
	        SessionService.prototype.getAddressSecondary = function () {
	            return this.user.address_secondary;
	        };
	        SessionService.prototype.getLocation = function () {
	            return this.user.location;
	        };
	        SessionService.prototype.getCity = function () {
	            return this.user.city;
	        };
	        SessionService.prototype.getCityState = function () {
	            return this.user.city_state;
	        };
	        SessionService.prototype.getPhone = function () {
	            return this.user.phone;
	        };
	        SessionService.prototype.getBio = function () {
	            return this.user.bio;
	        };
	        SessionService.prototype.getEmail = function () {
	            return this.user.email;
	        };
	        SessionService.prototype.getData = function () {
	            return this.data;
	        };
	        SessionService.prototype.getLocalNow = function () {
	            return new Date();
	        };
	        SessionService.prototype.loadPublicEvents = function (rawFilter) {
	            this.data.loadPublicEvents(this.buildLoadEventsRequest(rawFilter));
	        };
	        SessionService.prototype.loadMorePublicEvents = function () {
	            return this.data.loadMorePublicEvents();
	        };
	        SessionService.prototype.loadPrivateEvents = function (user, rawFilter) {
	            this.data.loadPrivateEvents(this.buildLoadEventsRequest(rawFilter), this.user);
	        };
	        SessionService.prototype.loadMorePrivateEvents = function () {
	            return this.data.loadMorePrivateEvents(this.user);
	        };
	        SessionService.prototype.deleteEvent = function (eventId) {
	            return this.data.deleteEvent(this.buildBaseRequest(), eventId);
	        };
	        SessionService.prototype.deleteReservation = function (eventId) {
	            return this.data.deleteReservation(this.buildBaseRequest(), eventId);
	        };
	        SessionService.prototype.acceptReservation = function (reservationId, message) {
	            return this.data.acceptReservation(this.buildBaseRequest(), reservationId, message);
	        };
	        SessionService.prototype.rejectReservation = function (reservationId, message) {
	            return this.data.rejectReservation(this.buildBaseRequest(), reservationId, message);
	        };
	        SessionService.prototype.getAvailableCities = function () {
	            return this.availableCities;
	        };
	        SessionService.prototype.getCardList = function () {
	            if (this.isLogged()) {
	                return this.data.loadCardsList(this.buildBaseRequest());
	            }
	        };
	        SessionService.prototype.getCardSelected = function (cardId) {
	            if (this.isLogged()) {
	                return this.data.loadCard(this.buildBaseRequest(), cardId);
	            }
	        };
	        SessionService.prototype.couponValidation = function (couponNumber) {
	            if (this.isLogged()) {
	                return this.data.getCouponData(this.buildBaseRequest(), couponNumber);
	            }
	        };
	        SessionService.prototype.formatDate = function (date) {
	            var dateFormatted;
	            if (date) {
	                dateFormatted = date;
	                var year = dateFormatted.getFullYear();
	                var month = dateFormatted.getMonth() + 1;
	                if (month.toString().length == 1) {
	                    month = "0" + month;
	                }
	                var day = dateFormatted.getDate();
	                if (day.toString().length == 1) {
	                    day = "0" + day;
	                }
	                dateFormatted = year + "-" + month + "-" + day;
	            }
	            return dateFormatted;
	        };
	        SessionService.prototype.formatTime = function (time) {
	            var timeFormatted;
	            if (time) {
	                timeFormatted = time;
	                var hours = timeFormatted.getHours();
	                var minutes = timeFormatted.getMinutes();
	                if (hours.toString().length == 1) {
	                    hours = "0" + hours;
	                }
	                if (minutes.toString().length == 1) {
	                    minutes = "0" + minutes;
	                }
	                timeFormatted = hours + ":" + minutes;
	            }
	            return timeFormatted;
	        };
	        SessionService.prototype.buildLoadEventsRequest = function (rawFilter) {
	            var request = this.buildBaseRequest();
	            request.url = config_1.Config.eventsEndpoint;
	            if (rawFilter) {
	                var queryString;
	                if (rawFilter.queryString && rawFilter.queryString.length > 0) {
	                    var tmp = rawFilter.queryString.trim();
	                    if (tmp.length > 0) {
	                        queryString = tmp;
	                    }
	                }
	                var cost;
	                var rawCostType = rawFilter.costType;
	                switch (rawCostType) {
	                    case data.CostType.FREE:
	                        cost = 'free';
	                        break;
	                    case data.CostType.PAID:
	                        cost = 'paid';
	                        break;
	                }
	                var eventType;
	                var rawEventType = rawFilter.eventType;
	                switch (rawEventType) {
	                    case data.EventType.PUBLIC:
	                        eventType = 'public';
	                        break;
	                    case data.EventType.PRIVATE:
	                        eventType = 'private';
	                        break;
	                    case data.EventType.MANUAL:
	                        eventType = 'manual_approval';
	                        break;
	                }
	                var alcoholTypes;
	                if (rawFilter.alcoholTypes && rawFilter.alcoholTypes.length > 0) {
	                    alcoholTypes = "";
	                    if (rawFilter.alcoholTypes.indexOf(data.AlcoholType.HOST_PROVIDES) >= 0) {
	                        alcoholTypes += 'host_provides,';
	                    }
	                    if (rawFilter.alcoholTypes.indexOf(data.AlcoholType.BYOB) >= 0) {
	                        alcoholTypes += 'byob,';
	                    }
	                    if (rawFilter.alcoholTypes.indexOf(data.AlcoholType.ALCOHOL_FREE) >= 0) {
	                        alcoholTypes += 'alcohol_free,';
	                    }
	                    alcoholTypes = alcoholTypes.substring(0, alcoholTypes.length - 1);
	                }
	                var dietTypes;
	                if (rawFilter.dietTypes && rawFilter.dietTypes.length > 0) {
	                    dietTypes = "";
	                    if (rawFilter.dietTypes.indexOf(data.DietType.VEGETARIAN) >= 0) {
	                        dietTypes += 'vegetarian,';
	                    }
	                    if (rawFilter.dietTypes.indexOf(data.DietType.VEGAN) >= 0) {
	                        dietTypes += 'vegan,';
	                    }
	                    if (rawFilter.dietTypes.indexOf(data.DietType.GLUTEN_FREE) >= 0) {
	                        dietTypes += 'gluten_free,';
	                    }
	                    if (rawFilter.dietTypes.indexOf(data.DietType.KOSHER) >= 0) {
	                        dietTypes += 'kosher,';
	                    }
	                    dietTypes = dietTypes.substring(0, dietTypes.length - 1);
	                }
	                var city;
	                if (rawFilter.city && rawFilter.city.length > 0) {
	                    city = rawFilter.city;
	                }
	                var dateMin;
	                if (rawFilter.minDate) {
	                    dateMin = rawFilter.minDate;
	                    var year = dateMin.getFullYear();
	                    var month = dateMin.getMonth() + 1;
	                    if (month.toString().length == 1) {
	                        month = "0" + month;
	                    }
	                    var day = dateMin.getDate();
	                    if (day.toString().length == 1) {
	                        day = "0" + day;
	                    }
	                    dateMin = year + "-" + month + "-" + day;
	                }
	                var dateMax;
	                if (rawFilter.maxDate) {
	                    dateMax = rawFilter.maxDate;
	                    var year = dateMax.getFullYear();
	                    var month = dateMax.getMonth() + 1;
	                    if (month.toString().length == 1) {
	                        month = "0" + month;
	                    }
	                    var day = dateMax.getDate();
	                    if (day.toString().length == 1) {
	                        day = "0" + day;
	                    }
	                    dateMax = year + "-" + month + "-" + day;
	                }
	                request.params = {
	                    q: queryString,
	                    event_type: eventType,
	                    date_from: dateMin,
	                    date_to: dateMax,
	                    cost: cost,
	                    area_code: city,
	                    alcohol_policy: alcoholTypes,
	                    dietary_restrictions: dietTypes
	                };
	            }
	            return request;
	        };
	        SessionService.prototype.loadSuggestedEvents = function () {
	            var request = this.buildBaseRequest();
	            request.url = config_1.Config.eventsEndpoint + "/" + this.data.event.uuid + "/" + config_1.Config.suggested;
	            this.data.loadSuggestedEvents(request);
	        };
	        SessionService.prototype.loadEvent = function (eventId) {
	            if (typeof eventId === 'undefined') {
	                eventId = this.data.event.uuid;
	            }
	            return this.data.loadEvent(this.buildBaseRequest(), eventId);
	        };
	        SessionService.prototype.reserve = function (reservationDraft) {
	            var _this = this;
	            var request = this.buildBaseRequest();
	            request.method = "POST";
	            request.url = config_1.Config.eventsEndpoint + "/" + this.data.event.uuid + "/" + config_1.Config.reservations;
	            var data = {
	                data: {
	                    additional_guests: reservationDraft
	                }
	            };
	            request.data = data;
	            return this.http(request).then(function () {
	                _this.loadMyReservations();
	            });
	        };
	        SessionService.prototype.pay = function (data, qty, reservationDraft, couponId) {
	            var request = this.buildBaseRequest();
	            request.method = "POST";
	            request.url = config_1.Config.eventsEndpoint + "/" + this.data.event.uuid + "/" + config_1.Config.reservations;
	            data.qty = qty;
	            if (couponId == "") {
	                request.data = {
	                    data: {
	                        additional_guests: reservationDraft,
	                        payment: data
	                    }
	                };
	            }
	            else {
	                request.data = {
	                    data: {
	                        additional_guests: reservationDraft,
	                        payment: data,
	                        coupon_id: couponId
	                    }
	                };
	            }
	            return this.http(request);
	        };
	        SessionService.prototype.registerNewCard = function (data) {
	            var request = this.buildBaseRequest();
	            request.method = "POST";
	            request.url = config_1.Config.cardsEndpoint;
	            request.data = {
	                data: {
	                    stripe_token: data.stripe_token,
	                    favourite: data.favourite
	                }
	            };
	            return this.http(request);
	        };
	        SessionService.prototype.changeCard = function (data, param) {
	            var request = this.buildBaseRequest();
	            if (param === "delete") {
	                request.method = "DELETE";
	                request.url = config_1.Config.cardsEndpoint + "/" + data.id;
	            }
	            else {
	                request.method = "PATCH";
	                request.url = config_1.Config.cardsEndpoint + "/" + data.id;
	                request.data = {
	                    data: {
	                        favourite: data.favourite
	                    }
	                };
	            }
	            return this.http(request);
	        };
	        SessionService.prototype.loadReservations = function (eventId) {
	            return this.data.loadReservations(this.buildBaseRequest(), eventId);
	        };
	        SessionService.prototype.loadMyReservations = function () {
	            if (this.isLogged()) {
	                this.data.loadMyReservations(this.buildBaseRequest());
	            }
	        };
	        SessionService.prototype.loadTimezones = function () {
	            if (this.isLogged()) {
	                return this.data.loadTimezones(this.buildBaseRequest());
	            }
	        };
	        SessionService.prototype.loadSponsors = function (areaCode) {
	            if (this.isLogged()) {
	                return this.data.loadSponsors(this.buildBaseRequest(), areaCode);
	            }
	        };
	        SessionService.prototype.createEvent = function (eventDraft) {
	            var request = this.buildBaseRequest();
	            request.method = "POST";
	            request.url = config_1.Config.eventsEndpoint;
	            var when = this.computeEventDateAndDuration(eventDraft.begin, eventDraft.begin, eventDraft.end);
	            this.log.debug(when);
	            var newEventType;
	            if (eventDraft.eventType == data.EventType.PUBLIC) {
	                newEventType = "public";
	            }
	            else if (eventDraft.eventType == data.EventType.PRIVATE) {
	                newEventType = "private";
	            }
	            else if (eventDraft.eventType == data.EventType.MANUAL) {
	                newEventType = "manual_approval";
	            }
	            var timezoneOther;
	            if (eventDraft.timezone !== undefined) {
	                timezoneOther = eventDraft.timezone.label;
	            }
	            else {
	                timezoneOther = null;
	            }
	            var newData = {
	                data: {
	                    full_address: eventDraft.full_address,
	                    secondary_address: eventDraft.secondary_address,
	                    title: eventDraft.name,
	                    description: eventDraft.description,
	                    pets_allowed: true,
	                    event_date: when.newDate,
	                    event_time: when.newTime,
	                    duration: when.duration,
	                    alcohol_policy: eventDraft.alcoholType,
	                    meal_type: eventDraft.mealType,
	                    dietary_restrictions: eventDraft.dietTypes,
	                    notes: JSON.stringify(eventDraft.notes),
	                    event_type: newEventType,
	                    number_of_guests_min: eventDraft.minGuestCount,
	                    number_of_guests_max: eventDraft.maxseats,
	                    price_per_person: SessionService.toPrice(eventDraft.price) * 100,
	                    cover: eventDraft.coverUpdate,
	                    area_code: eventDraft.area.city && eventDraft.area.city.code,
	                    area_other: eventDraft.area_other,
	                    neighborhood: eventDraft.area.neighborhood && eventDraft.area.neighborhood.code,
	                    timezone: eventDraft.area.city.timezone,
	                    timezone_other: timezoneOther,
	                    parent_auth: eventDraft.parentAuth
	                }
	            };
	            request.data = newData;
	            return this.http(request);
	        };
	        SessionService.prototype.updateEvent = function (eventDraft, eventId) {
	            var request = this.buildBaseRequest();
	            request.method = "PUT";
	            request.url = config_1.Config.eventsEndpoint + "/" + eventId;
	            var when = this.computeEventDateAndDuration(eventDraft.begin, eventDraft.begin, eventDraft.end);
	            this.log.debug(when);
	            var newEventType;
	            if (eventDraft.eventType == data.EventType.PUBLIC) {
	                newEventType = "public";
	            }
	            else if (eventDraft.eventType == data.EventType.PRIVATE) {
	                newEventType = "private";
	            }
	            else if (eventDraft.eventType == data.EventType.MANUAL) {
	                newEventType = "manual_approval";
	            }
	            var newData = {
	                data: {
	                    full_address: eventDraft.full_address,
	                    secondary_address: eventDraft.secondary_address,
	                    title: eventDraft.name,
	                    description: eventDraft.description,
	                    pets_allowed: true,
	                    event_date: when.newDate,
	                    event_time: when.newTime,
	                    event_type: newEventType,
	                    duration: when.duration,
	                    alcohol_policy: eventDraft.alcoholType,
	                    meal_type: eventDraft.mealType,
	                    dietary_restrictions: eventDraft.dietTypes,
	                    notes: JSON.stringify(eventDraft.notes),
	                    type_of_event: "dinner",
	                    number_of_guests_min: eventDraft.minGuestCount,
	                    number_of_guests_max: eventDraft.maxseats,
	                    visible: true,
	                    private: true,
	                    price_per_person: SessionService.toPrice(eventDraft.price) * 100,
	                    cover: eventDraft.coverUpdate,
	                    area_code: eventDraft.area.city && eventDraft.area.city.code,
	                    area_other: eventDraft.area_other,
	                    neighborhood: eventDraft.area.neighborhood && eventDraft.area.neighborhood.code,
	                    timezone: eventDraft.area.city.timezone,
	                    timezone_other: eventDraft.timezone.label
	                }
	            };
	            request.data = newData;
	            return this.http(request);
	        };
	        SessionService.prototype.publishEvent = function (eventId) {
	            var request = this.buildBaseRequest();
	            request.method = "POST";
	            request.url = config_1.Config.eventsEndpoint + "/" + eventId + "/submit";
	            return this.http(request);
	        };
	        SessionService.prototype.computeEventDateAndDuration = function (date, begin, end) {
	            begin.setFullYear(date.getFullYear());
	            begin.setDate(date.getDate());
	            begin.setMonth(date.getMonth());
	            end.setFullYear(date.getFullYear());
	            end.setDate(date.getDate());
	            end.setMonth(date.getMonth());
	            if (end.getTime() < begin.getTime()) {
	                end.setDate(end.getDate() + 1);
	            }
	            var resultDate = begin;
	            var resultDuration = end.getTime() - begin.getTime();
	            var resultDuration = Math.floor(resultDuration / 1000);
	            return {
	                date: SessionService.toISOString(resultDate),
	                newDate: this.formatDate(resultDate),
	                newTime: this.formatTime(resultDate),
	                duration: resultDuration
	            };
	        };
	        SessionService.prototype.updateProfile = function (profileDraft) {
	            var _this = this;
	            var request = this.buildBaseRequest();
	            request.method = "PUT";
	            request.url = config_1.Config.profileEndpoint;
	            var dob = profileDraft.birthDate;
	            var dateString;
	            if (dob) {
	                dateString = this.moment(dob).format('YYYY-MM-DD');
	            }
	            var data = {
	                data: {
	                    first_name: profileDraft.firstName,
	                    last_name: profileDraft.lastName,
	                    city: profileDraft.city,
	                    city_state: profileDraft.city_state,
	                    dob: dateString,
	                    email: profileDraft.email,
	                    avatar: profileDraft.avatar,
	                    address: profileDraft.address,
	                    phone: profileDraft.phone,
	                    bio: profileDraft.bio
	                }
	            };
	            request.data = data;
	            return this.http(request).then(function () { return _this.refreshProfile(); });
	        };
	        SessionService.prototype.refreshProfile = function () {
	            var _this = this;
	            return this.loadProfile().then(function (tokenAndProfile) {
	                var profile = tokenAndProfile[1].data;
	                _this.user.refreshProfile(profile);
	                return true;
	            });
	        };
	        SessionService.prototype.signup = function (newDataDraft) {
	            this.log.debug("signup has been called");
	            var request = {
	                method: "POST",
	                url: config_1.Config.usersEndpoint,
	                data: {
	                    first_name: newDataDraft.firstName,
	                    last_name: newDataDraft.lastName,
	                    email: newDataDraft.newEmail,
	                    phone: newDataDraft.cellPhone,
	                    high_school: newDataDraft.highSchoolSelected,
	                    gender: newDataDraft.genderSelected,
	                    zip_code: newDataDraft.zipCode,
	                    bbyo_member: newDataDraft.bbyoMemberSelected,
	                    parent_first_name: newDataDraft.parentFirstName,
	                    parent_last_name: newDataDraft.parentLastName,
	                    parent_email: newDataDraft.parentNewEmail,
	                    parent_phone: newDataDraft.parentCellPhone,
	                    password: newDataDraft.newPassword,
	                    password_confirmation: newDataDraft.newPassword
	                }
	            };
	            return this.http(request);
	        };
	        SessionService.prototype.getS3Credentials = function () {
	            var request = this.buildBaseRequest();
	            request.method = "GET";
	            request.url = config_1.Config.newUploadEndpoint + "?success_action_redirect=%23";
	            return this.http(request);
	        };
	        SessionService.prototype.uploadFile = function (file, progressListener) {
	            //this.upload.base64DataUrl(file).then((a)=> {
	            //});
	            var _this = this;
	            return this.getS3Credentials().then(function (response) {
	                var s3Credentials = response.data;
	                return _this.uploadToS3(s3Credentials, file, progressListener).then(function (response) {
	                    _this.log.debug(response.data);
	                    var m = response.data.match(/<Location>(.+?)<\/Location>/);
	                    if (m && m[1]) {
	                        _this.log.debug(m[1]);
	                        return m[1];
	                    }
	                    else {
	                        throw "S3 Upload error";
	                    }
	                });
	            });
	        };
	        SessionService.prototype.uploadToS3 = function (s3Credentials, file, progressListener) {
	            //TODO resolve url in a better way
	            var _this = this;
	            return this.upload.upload({
	                url: "https://" + s3Credentials.s3.bucket + ".s3.amazonaws.com/",
	                method: 'POST',
	                data: {
	                    key: s3Credentials.s3.key,
	                    AWSAccessKeyId: s3Credentials.s3.aws_access_key_id,
	                    acl: s3Credentials.s3.acl,
	                    policy: s3Credentials.s3.policy,
	                    signature: s3Credentials.s3.signature,
	                    success_action_status: s3Credentials.s3.success_action_status,
	                    file: file
	                }
	            }).then(null, function (error) {
	                _this.log.debug('Error status: ' + error.status);
	            }, function (evt) {
	                var progressPercentage = (evt.loaded / evt.total);
	                if (progressListener) {
	                    progressListener(evt);
	                }
	            });
	        };
	        SessionService.prototype.resetPassword = function (email) {
	            var request = this.buildBaseRequest();
	            request.method = "POST";
	            request.url = config_1.Config.resetPasswordEndpoint;
	            request.data = {
	                email: email
	            };
	            return this.http(request);
	        };
	        SessionService.prototype.changePasswordByToken = function (rawData) {
	            var request = this.buildBaseRequest();
	            request.method = "PUT";
	            request.url = config_1.Config.resetPasswordEndpoint;
	            request.data = {
	                password: rawData.password,
	                password_confirmation: rawData.password,
	                reset_password_token: rawData.resetPasswordToken
	            };
	            return this.http(request);
	        };
	        SessionService.prototype.changePassword = function (rawData) {
	            var request = this.buildBaseRequest();
	            request.method = "PUT";
	            request.url = config_1.Config.updatePasswordEndpoint;
	            request.data = {
	                data: {
	                    password: rawData.password,
	                    password_confirmation: rawData.password_confirmation,
	                }
	            };
	            return this.http(request);
	        };
	        SessionService.prototype.shortenUrl = function (url) {
	            return this.data.shortenUrl(url);
	        };
	        SessionService.prototype.sendInvitations = function (messageType, emails, text) {
	            var request = this.buildBaseRequest();
	            request.method = "POST";
	            request.url = config_1.Config.eventsEndpoint + '/' + this.data.event.uuid + '/invitations';
	            request.data = {
	                data: {
	                    emails: emails,
	                    text: text,
	                    message_type: messageType
	                }
	            };
	            return this.http(request);
	        };
	        SessionService.prototype.sendMessageToHost = function (emails, text) {
	            var request = this.buildBaseRequest();
	            request.method = "POST";
	            request.url = config_1.Config.eventsEndpoint + '/' + this.data.event.uuid + '/hostmessage';
	            request.data = {
	                data: {
	                    emails: emails,
	                    text: text,
	                }
	            };
	            return this.http(request);
	        };
	        SessionService.prototype.requestHost = function () {
	            var request = this.buildBaseRequest();
	            request.method = "POST";
	            request.url = config_1.Config.hostRequestEndpoint;
	            return this.http(request);
	        };
	        SessionService.prototype.autoPromoteToHost = function () {
	            var _this = this;
	            var request = this.buildBaseRequest();
	            request.method = "POST";
	            request.url = config_1.Config.hostRequestEndpoint;
	            request.data = {
	                force: 1
	            };
	            return this.http(request)
	                .then(function (response) {
	                return _this.loginWithLocalStorage();
	            });
	        };
	        SessionService.prototype.loadCityList = function () {
	            var request = this.buildBaseRequest();
	            request.method = "GET";
	            request.url = config_1.Config.areasEndpoint;
	            return this.http(request).then(function (response) { return response.data.data; });
	        };
	        SessionService.$inject = ["$http", "$timeout", "$rootScope", "$route", "$cookies", "Upload", "moment", "prelogin", "preconfig", "$log", "$q", "spinnerService"];
	        return SessionService;
	    })();
	    exports.SessionService = SessionService;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : afrikaans (af)
	//! author : Werner Mollentze : https://github.com/wernerm
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	}));

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Moroccan Arabic (ar-ma)
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_ma = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ma;
	
	}));

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic Saudi Arabia (ar-sa)
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var ar_sa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_sa;
	
	}));

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  : Tunisian Arabic (ar-tn)
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_tn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ar_tn;
	
	}));

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! Locale: Arabic (ar)
	//! Author: Abdel Said: https://github.com/abdelsaid
	//! Changes in months, weekdays: Ahmed Elkhatib
	//! Native plural forms: forabi https://github.com/forabi
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'كانون الثاني يناير',
	        'شباط فبراير',
	        'آذار مارس',
	        'نيسان أبريل',
	        'أيار مايو',
	        'حزيران يونيو',
	        'تموز يوليو',
	        'آب أغسطس',
	        'أيلول سبتمبر',
	        'تشرين الأول أكتوبر',
	        'تشرين الثاني نوفمبر',
	        'كانون الأول ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	}));

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : azerbaijani (az)
	//! author : topchiyev : https://github.com/topchiyev
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	}));

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : belarusian (be)
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_'),
	            'accusative': 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_')
	        },
	        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            'accusative': 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_')
	        },
	        nounCase = (/\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/).test(format) ?
	            'accusative' :
	            'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var be = moment.defineLocale('be', {
	        months : monthsCaseReplace,
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        ordinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	}));

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : bulgarian (bg)
	//! author : Krasen Borisov : https://github.com/kraz
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	}));

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (bn)
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রুবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্রু_শনি'.split('_'),
	        weekdaysMin : 'রব_সম_মঙ্গ_বু_ব্রিহ_শু_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কএক সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকেল|রাত/,
	        isPM: function (input) {
	            return /^(দুপুর|বিকেল|রাত)$/.test(input);
	        },
	        //Bengali is a vast language its spoken
	        //in different forms in various parts of the world.
	        //I have just generalized with most common one used
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকেল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	}));

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : tibetan (bo)
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        isPM: function (input) {
	            return /^(ཉིན་གུང|དགོང་དག|མཚན་མོ)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	}));

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : breton (br)
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        ordinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	}));

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : bosnian (bs)
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	}));

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : catalan (ca)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'LT:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	}));

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : czech (cs)
	//! author : petrbela : https://github.com/petrbela
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	}));

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : chuvash (cv)
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        ordinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	}));

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh (cy)
	//! author : Robert Allen
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	}));

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : danish (da)
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[I dag kl.] LT',
	            nextDay : '[I morgen kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[I går kl.] LT',
	            lastWeek : '[sidste] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	}));

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : austrian german (de-at)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de_at = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[Morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[Gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de_at;
	
	}));

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : german (de)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[Morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[Gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	}));

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : modern greek (el)
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (typeof output === 'function') {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        ordinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	}));

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : australian english (en-au)
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_au = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_au;
	
	}));

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : canadian english (en-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ca = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM, YYYY',
	            LLL : 'D MMMM, YYYY h:mm A',
	            LLLL : 'dddd, D MMMM, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return en_ca;
	
	}));

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : great britain english (en-gb)
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_gb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_gb;
	
	}));

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : esperanto (eo)
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	        weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-an de] MMMM, YYYY',
	            LLL : 'D[-an de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'je %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        ordinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	}));

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : spanish (es)
	//! author : Julio Napurí : https://github.com/julionc
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'Ene._Feb._Mar._Abr._May._Jun._Jul._Ago._Sep._Oct._Nov._Dic.'.split('_'),
	        monthsShort = 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_');
	
	    var es = moment.defineLocale('es', {
	        months : 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        weekdays : 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
	        weekdaysShort : 'Dom._Lun._Mar._Mié._Jue._Vie._Sáb.'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Mi_Ju_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	}));

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : estonian (et)
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	}));

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : euskara (eu)
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	}));

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian (fa)
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چندین ثانیه',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        ordinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	}));

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : finnish (fi)
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	}));

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : faroese (fo)
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	}));

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : canadian french (fr-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ca = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        }
	    });
	
	    return fr_ca;
	
	}));

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : french (fr)
	//! author : John Fischer : https://github.com/jfroffice
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	}));

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : frisian (fy)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	}));

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : galician (gl)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
	        monthsShort : 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
	        weekdays : 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
	        weekdaysShort : 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str === 'uns segundos') {
	                    return 'nuns segundos';
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gl;
	
	}));

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew (he)
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        }
	    });
	
	    return he;
	
	}));

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hindi (hi)
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	}));

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hrvatski (hr)
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_'),
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	}));

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hungarian (hu)
	//! author : Adam Brunner : https://github.com/adambrunner
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hu;
	
	}));

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian (hy-am)
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_'),
	            'accusative': 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_')
	        },
	        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function monthsShortCaseReplace(m, format) {
	        var monthsShort = 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_');
	        return monthsShort[m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_');
	        return weekdays[m.day()];
	    }
	
	    var hy_am = moment.defineLocale('hy-am', {
	        months : monthsCaseReplace,
	        monthsShort : monthsShortCaseReplace,
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hy_am;
	
	}));

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Indonesia (id)
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	}));

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : icelandic (is)
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	}));

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : italian (it)
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	        weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	        weekdaysMin : 'D_L_Ma_Me_G_V_S'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	}));

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : japanese (ja)
	//! author : LI Long : https://github.com/baryon
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'Ah時m分',
	            LTS : 'Ah時m分s秒',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah時m分',
	            LLLL : 'YYYY年M月D日Ah時m分 dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : '[来週]dddd LT',
	            lastDay : '[昨日] LT',
	            lastWeek : '[前週]dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	}));

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Boso Jowo (jv)
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	}));

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian (ka)
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            'accusative': 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        nounCase = (/D[oD] *MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            'accusative': 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_')
	        },
	        nounCase = (/(წინა|შემდეგ)/).test(format) ?
	            'accusative' :
	            'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var ka = moment.defineLocale('ka', {
	        months : monthsCaseReplace,
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	}));

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : khmer (km)
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនៈ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	}));

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : korean (ko)
	//!
	//! authors
	//!
	//! - Kyungwook, Park : https://github.com/kyungw00k
	//! - Jeeeyul Lee <jeeeyul@gmail.com>
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h시 m분',
	            LTS : 'A h시 m분 s초',
	            L : 'YYYY.MM.DD',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h시 m분',
	            LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇초',
	            ss : '%d초',
	            m : '일분',
	            mm : '%d분',
	            h : '한시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한달',
	            MM : '%d달',
	            y : '일년',
	            yy : '%d년'
	        },
	        ordinalParse : /\d{1,2}일/,
	        ordinal : '%d일',
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	}));

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish (lb)
	//! author : mweimerskirch : https://github.com/mweimerskirch, David Raison : https://github.com/kwisatz
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	}));

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian (lt)
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    },
	    weekDays = 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_');
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	                'nominative': 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	                'accusative': 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_')
	            },
	            nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	                'accusative' :
	                'nominative';
	        return months[nounCase][m.month()];
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    function relativeWeekDay(moment, format) {
	        var nominative = format.indexOf('dddd HH:mm') === -1,
	            weekDay = weekDays[moment.day()];
	        return nominative ? weekDay : weekDay.substring(0, weekDay.length - 2) + 'į';
	    }
	
	    var lt = moment.defineLocale('lt', {
	        months : monthsCaseReplace,
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : relativeWeekDay,
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	}));

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : latvian (lv)
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	}));

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin (me)
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
	        monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
	        weekdays: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota'],
	        weekdaysShort: ['ned.', 'pon.', 'uto.', 'sri.', 'čet.', 'pet.', 'sub.'],
	        weekdaysMin: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	}));

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : macedonian (mk)
	//! author : Borislav Mickov : https://github.com/B0k0
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : 'dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Во изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Во изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	}));

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : malayalam (ml)
	//! author : Floyd Pink : https://github.com/floydpink
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        isPM : function (input) {
	            return /^(ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	}));

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi (mr)
	//! author : Harshad Kale : https://github.com/kalehv
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s नंतर',
	            past : '%s पूर्वी',
	            s : 'सेकंद',
	            m: 'एक मिनिट',
	            mm: '%d मिनिटे',
	            h : 'एक तास',
	            hh : '%d तास',
	            d : 'एक दिवस',
	            dd : '%d दिवस',
	            M : 'एक महिना',
	            MM : '%d महिने',
	            y : 'एक वर्ष',
	            yy : '%d वर्षे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	}));

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms_my = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms_my;
	
	}));

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	}));

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese (my)
	//! author : Squar team, mysquar.com
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	}));

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : norwegian bokmål (nb)
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tirs_ons_tors_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'H.mm',
	            LTS : 'H.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H.mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] H.mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'for %s siden',
	            s : 'noen sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	}));

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : nepali/nepalese
	//! author : suvash : https://github.com/suvash
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आइ._सो._मङ्_बु._बि._शु._श.'.split('_'),
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राती|बिहान|दिउँसो|बेलुका|साँझ|राती/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 3 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'बेलुका' || meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राती';
	            } else if (hour < 10) {
	                return 'बिहान';
	            } else if (hour < 15) {
	                return 'दिउँसो';
	            } else if (hour < 18) {
	                return 'बेलुका';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राती';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोली] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडी',
	            s : 'केही समय',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	}));

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : dutch (nl)
	//! author : Joris Röling : https://github.com/jjupiter
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	}));

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : norwegian nynorsk (nn)
	//! author : https://github.com/mechuwind
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'for %s sidan',
	            s : 'nokre sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	}));

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : polish (pl)
	//! author : Rafal Hirsz : https://github.com/evoL
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
	        weekdaysMin : 'N_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	}));

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : brazilian portuguese (pt-br)
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt_br = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : '%s atrás',
	            s : 'poucos segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return pt_br;
	
	}));

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : portuguese (pt)
	//! author : Jefferson : https://github.com/jalex79
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	}));

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : romanian (ro)
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	}));

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : russian (ru)
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	            'accusative': 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_')
	        },
	        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function monthsShortCaseReplace(m, format) {
	        var monthsShort = {
	            'nominative': 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	            'accusative': 'янв_фев_мар_апр_мая_июня_июля_авг_сен_окт_ноя_дек'.split('_')
	        },
	        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return monthsShort[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            'accusative': 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_')
	        },
	        nounCase = (/\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/).test(format) ?
	            'accusative' :
	            'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	
	    var ru = moment.defineLocale('ru', {
	        months : monthsCaseReplace,
	        monthsShort : monthsShortCaseReplace,
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[й|я]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i],
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function () {
	                return this.day() === 2 ? '[Во] dddd [в] LT' : '[В] dddd [в] LT';
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ru;
	
	}));

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese (si)
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        ordinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	}));

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : slovak (sk)
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	}));

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : slovenian (sl)
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	}));

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian (sq)
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author: Menelion Elensúle: https://github.com/Oire (tests)
	//! author : Oerd Cukalla : https://github.com/oerd (fixes)
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	}));

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian-cyrillic (sr-cyrl)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr_cyrl = moment.defineLocale('sr-cyrl', {
	        months: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар'],
	        monthsShort: ['јан.', 'феб.', 'мар.', 'апр.', 'мај', 'јун', 'јул', 'авг.', 'сеп.', 'окт.', 'нов.', 'дец.'],
	        weekdays: ['недеља', 'понедељак', 'уторак', 'среда', 'четвртак', 'петак', 'субота'],
	        weekdaysShort: ['нед.', 'пон.', 'уто.', 'сре.', 'чет.', 'пет.', 'суб.'],
	        weekdaysMin: ['не', 'по', 'ут', 'ср', 'че', 'пе', 'су'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr_cyrl;
	
	}));

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian-latin (sr)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
	        monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
	        weekdays: ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota'],
	        weekdaysShort: ['ned.', 'pon.', 'uto.', 'sre.', 'čet.', 'pet.', 'sub.'],
	        weekdaysMin: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	}));

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : swedish (sv)
	//! author : Jens Alm : https://github.com/ulmus
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	}));

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : tamil (ta)
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        ordinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	}));

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : thai (th)
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'มกรา_กุมภา_มีนา_เมษา_พฤษภา_มิถุนา_กรกฎา_สิงหา_กันยา_ตุลา_พฤศจิกา_ธันวา'.split('_'),
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        longDateFormat : {
	            LT : 'H นาฬิกา m นาที',
	            LTS : 'H นาฬิกา m นาที s วินาที',
	            L : 'YYYY/MM/DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H นาฬิกา m นาที',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H นาฬิกา m นาที'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	}));

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog/Filipino (tl-ph)
	//! author : Dan Hagman
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tl_ph = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ngayon sa] LT',
	            nextDay: '[Bukas sa] LT',
	            nextWeek: 'dddd [sa] LT',
	            lastDay: '[Kahapon sa] LT',
	            lastWeek: 'dddd [huling linggo] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tl_ph;
	
	}));

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : turkish (tr)
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[haftaya] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen hafta] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	}));

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : talossan (tzl)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v with the help of Iustì Canun
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'LT.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY LT',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY LT'
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', ' ' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', ' ' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', ' ' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', ' ' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', ' ' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1].trim());
	    }
	
	    return tzl;
	
	}));

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt in Latin (tzm-latn)
	//! author : Abdel Said : https://github.com/abdelsaid
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm_latn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm_latn;
	
	}));

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt (tzm)
	//! author : Abdel Said : https://github.com/abdelsaid
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	}));

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : ukrainian (uk)
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'хвилина_хвилини_хвилин',
	            'hh': 'година_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function monthsCaseReplace(m, format) {
	        var months = {
	            'nominative': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_'),
	            'accusative': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_')
	        },
	        nounCase = (/D[oD]? *MMMM?/).test(format) ?
	            'accusative' :
	            'nominative';
	        return months[nounCase][m.month()];
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        },
	        nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : monthsCaseReplace,
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	}));

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : uzbek (uz)
	//! author : Sardor Muminov : https://github.com/muminoff
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	}));

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : vietnamese (vi)
	//! author : Bang Nguyen : https://github.com/bangnk
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	}));

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : chinese (zh-cn)
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_cn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah点mm分',
	            LTS : 'Ah点m分s秒',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah点mm分',
	            LLLL : 'YYYY年MMMD日ddddAh点mm分',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah点mm分',
	            llll : 'YYYY年MMMD日ddddAh点mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : function () {
	                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	            },
	            nextDay : function () {
	                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	            },
	            lastDay : function () {
	                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	            },
	            nextWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() - startOfWeek.unix() >= 7 * 24 * 3600 ? '[下]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            lastWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            sameElse : 'LL'
	        },
	        ordinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zh_cn;
	
	}));

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : traditional chinese (zh-tw)
	//! author : Ben : https://github.com/ben-lin
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_tw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '一分鐘',
	            mm : '%d分鐘',
	            h : '一小時',
	            hh : '%d小時',
	            d : '一天',
	            dd : '%d天',
	            M : '一個月',
	            MM : '%d個月',
	            y : '一年',
	            yy : '%d年'
	        }
	    });
	
	    return zh_tw;
	
	}));

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "glyphicons-halflings-regular.eot";

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/bannerless.jpg";

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cover_0.jpg";

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cover_1.jpg";

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cover_2.jpg";

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cover_3.jpg";

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/emblem_bbyo.png";

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/icon_appetizers.png";

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/icon_dessert.png";

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/icon_main.png";

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_alcohol_free.png";

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_beer_and_wine.png";

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_birite.jpg";

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_byob.png";

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_doordash.jpg";

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_drizzly.jpg";

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_etsy.jpg";

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_gluten_free.png";

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_goodeggs.jpg";

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_growbehold.jpg";

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_kosher.png";

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_local-mission-market.jpg";

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_our-harvest.jpg";

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_pescatarian.png";

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_rainbow-grocery.jpg";

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_seamless.jpg";

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_sherry_leheman.jpg";

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_soomsoom.jpg";

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_table-swoon.jpg";

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_the-market.jpg";

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_thrive-market.jpg";

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_vegan.png";

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_vegetarian.png";

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_whole-foods-market.jpg";

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/loading.gif";

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_footer.png";

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_navbar.svg";

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_onward.png";

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_onward_verical.png";

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_vertical.png";

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/search.svg";

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/share_fb.png";

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/share_tw.png";

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bower_components/ngWYSIWYG/dist/images/header-bg.gif";

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(2), __webpack_require__(3), __webpack_require__(5), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, angular, TPL, config_1, confirm_1, login_1) {
	    var Link = (function () {
	        function Link() {
	        }
	        Link.prototype.isActive = function (currentLocation) {
	            if (!this.linkSection || !currentLocation) {
	                return false;
	            }
	            if (typeof this.linkSection === 'string') {
	                return currentLocation.indexOf(this.linkSection) >= 0;
	            }
	            var active = false;
	            angular.forEach(this.linkSection, function (value) {
	                if (currentLocation.indexOf(value) >= 0) {
	                    active = true;
	                }
	            });
	            return active;
	        };
	        Link.createDummyLink = function () {
	            var result = new Link();
	            result.id = Link.idGen++;
	            result.label = "Link " + result.id.toString();
	            result.callback = function () { alert("clicked"); };
	            return result;
	        };
	        Link.buildLink = function (label, linkUrl, target, callback, linkClass, linkSection, subLinkList) {
	            var result = new Link();
	            result.id = Link.idGen++;
	            result.label = label;
	            result.callback = callback;
	            result.linkClass = linkClass;
	            result.linkSection = linkSection;
	            result.linkUrl = linkUrl;
	            result.target = target;
	            return result;
	        };
	        Link.idGen = 0;
	        return Link;
	    })();
	    exports.Link = Link;
	    var LinkList = (function (_super) {
	        __extends(LinkList, _super);
	        function LinkList() {
	            _super.call(this);
	        }
	        LinkList.buildLinkList = function () {
	            var result = new LinkList();
	            for (var i = 0; i < 5; i++) {
	                result.push(Link.createDummyLink());
	            }
	            return result;
	        };
	        LinkList.buildFooterLinkList = function (session, location, anchorScroll, modal) {
	            var result = new LinkList();
	            result.push(Link.buildLink("LANDING.POWERED", "", config_1.Config.wp_onetable, function () {
	                location.url(config_1.Config.wp_onetable);
	            }, "ot-link"));
	            return result;
	        };
	        LinkList.buildHeaderLinkList = function (session, location, anchorScroll, modal, window, rootScope) {
	            var result = new LinkList();
	            result.push(Link.buildLink("LANDING.FIND_EVENT", "", config_1.Config.home, function () {
	                location.url(config_1.Config.home);
	            }, "ot-link"));
	            result.push(Link.buildLink("LANDING.CREATE_DINNER", "", config_1.Config.home + "/" + config_1.Config.events, function () {
	                location.url(config_1.Config.events);
	            }, "ot-link"));
	            result.push(Link.buildLink("LANDING.ABOUT", config_1.Config.wp_locations, "_blank", function () {
	            }, "ot-link"));
	            return result;
	        };
	        LinkList.buildEventAnchorList = function (location, anchorScroll) {
	            var result = new LinkList();
	            var goTo = function (hash) {
	                var old = location.hash();
	                location.hash(hash);
	                anchorScroll();
	                location.hash(old);
	            };
	            var linkDetails = Link.buildLink("EVENT.DETAILS_ANCHOR", "", "", function () {
	                goTo(linkDetails.linkSection);
	            }, "ot-subheader-link", "details");
	            var linkDishes = Link.buildLink("EVENT.DISHES_ANCHOR", "", "", function () {
	                goTo(linkDishes.linkSection);
	            }, "ot-subheader-link ot-dishes-link", "menu");
	            var linkHost = Link.buildLink("EVENT.HOST_ANCHOR", "", "", function () {
	                goTo(linkHost.linkSection);
	            }, "ot-subheader-link", "host");
	            result.push(linkDetails);
	            result.push(linkDishes);
	            result.push(linkHost);
	            return result;
	        };
	        LinkList.becomeHostProcedure = function (session, modal, rootScope) {
	            if (session.isNotLogging()) {
	                var parent = {};
	                parent.currentModal = login_1.LoginController.openLoginModal(modal, parent, rootScope, function () {
	                    LinkList.becomeHostProcedure(session, modal, rootScope);
	                });
	            }
	            else {
	                var rUSModal = confirm_1.ConfirmController.openRequestHostModal(modal, function () {
	                }, function () {
	                    rUSModal.dismiss();
	                });
	            }
	        };
	        return LinkList;
	    })(Array);
	    exports.LinkList = LinkList;
	    var LinkListDirective = (function () {
	        function LinkListDirective(session, $location, $anchorScroll, $modal, $window, $rootScope) {
	            this.scope = {
	                params: "=params"
	            };
	            this.template = TPL.navigationDirectives.linkList;
	            this.link = function (scope, el, attrs) {
	                var linkList;
	                var type = scope.params ? scope.params.type : "";
	                switch (type) {
	                    case "header":
	                        linkList = LinkList.buildHeaderLinkList(session, $location, $anchorScroll, $modal, $window, $rootScope);
	                        break;
	                    case "eventAnchors":
	                        linkList = LinkList.buildEventAnchorList($location, $anchorScroll);
	                        break;
	                    default:
	                        linkList = LinkList.buildFooterLinkList(session, $location, $anchorScroll, $modal);
	                }
	                scope.vm = {
	                    linkList: linkList,
	                    session: session
	                };
	            };
	        }
	        LinkListDirective.factory = function () {
	            var tmp = function (a, b, c, d, e, f) { return new LinkListDirective(a, b, c, d, e, f); };
	            tmp.$inject = ["session", "$location", "$anchorScroll", "$uibModal", "$window", "$rootScope"];
	            return tmp;
	        };
	        return LinkListDirective;
	    })();
	    exports.LinkListDirective = LinkListDirective;
	    var LinkDirective = (function () {
	        function LinkDirective(location) {
	            this.template = TPL.navigationDirectives.link;
	            this.scope = {
	                item: "=item"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.computeLinkCss = function () {
	                    var s = scope.item.isActive(location.path()) ? "ot-active-link " : "";
	                    return s.concat(scope.item.linkClass);
	                };
	            };
	        }
	        LinkDirective.factory = function () {
	            var tmp = function (a) { return new LinkDirective(a); };
	            tmp.$inject = ["$location"];
	            return tmp;
	        };
	        return LinkDirective;
	    })();
	    exports.LinkDirective = LinkDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, config_1, confirm_1) {
	    var ChangePasswordController = (function () {
	        function ChangePasswordController(parent, session, modal, location) {
	            this.parent = parent;
	            this.currentModal = parent.currentModal;
	            this.modal = modal;
	            this.location = location;
	            this.errorchangepwd = "";
	            this.session = session;
	            this.resetPasswordToken = this.parent.resetPasswordToken;
	        }
	        ChangePasswordController.prototype.submit = function (form) {
	            var _this = this;
	            if (form.$valid) {
	                if (this.resetPasswordToken) {
	                    this.session.changePasswordByToken({ password: this.password, resetPasswordToken: this.resetPasswordToken }).then(function () {
	                        if (_this.currentModal) {
	                            _this.currentModal.dismiss();
	                        }
	                        _this.location.search('changePassword', null);
	                        _this.location.replace();
	                        confirm_1.ConfirmController.openPasswordChangeDoneModal(_this.modal);
	                    }).catch(function (data) {
	                        if (data.data.errors[config_1.Config.tokenError]) {
	                            _this.errorchangepwd = "FORGOT.TOKEN_ERROR";
	                        }
	                        if (data.data.errors[config_1.Config.minCharError]) {
	                            if (data.data.errors[config_1.Config.minCharError] == "is too short (minimum is 8 characters)") {
	                                _this.errorchangepwd = "FORGOT.MIN_CHAR_PASSWORD";
	                            }
	                        }
	                    });
	                }
	                else {
	                    this.session.changePassword({ password: this.password, password_confirmation: this.password }).then(function () {
	                        if (_this.currentModal) {
	                            _this.currentModal.dismiss();
	                        }
	                        _this.location.search('changePassword', null);
	                        _this.location.replace();
	                        confirm_1.ConfirmController.openPasswordChangeDoneModal(_this.modal);
	                    }).catch(function (data) {
	                        if (data.data.errors[config_1.Config.tokenError]) {
	                            _this.errorchangepwd = "FORGOT.TOKEN_ERROR";
	                        }
	                        if (data.data.errors[config_1.Config.minCharError]) {
	                            if (data.data.errors[config_1.Config.minCharError] == "is too short (minimum is 8 characters)") {
	                                _this.errorchangepwd = "FORGOT.MIN_CHAR_PASSWORD";
	                            }
	                        }
	                    });
	                }
	            }
	        };
	        ChangePasswordController.prototype.resetError = function () {
	            this.errorchangepwd = false;
	        };
	        ChangePasswordController.openChangePasswordModal = function (modal, parent, session, location) {
	            return ChangePasswordController.openChangePasswordModalInternal(modal, parent, session, location, true);
	        };
	        ChangePasswordController.openUndismissableChangePasswordModal = function (modal, parent, session, location) {
	            return ChangePasswordController.openChangePasswordModalInternal(modal, parent, session, location, false);
	        };
	        ChangePasswordController.openChangePasswordModalInternal = function (modal, parent, session, location, undismissable) {
	            var backdrop = undismissable ? 'true' : 'static';
	            return modal.open({
	                controller: function () { return new ChangePasswordController(parent, session, modal, location); },
	                controllerAs: "vm",
	                replace: true,
	                size: "sm",
	                backdrop: backdrop,
	                template: TPL.modals.changePassword
	            });
	        };
	        return ChangePasswordController;
	    })();
	    exports.ChangePasswordController = ChangePasswordController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var ManageGuestsController = (function () {
	        function ManageGuestsController(session, modalInstance, log, route) {
	            this.session = session;
	            this.modalInstance = modalInstance;
	            this.log = log;
	            this.route = route;
	            this.scope = {
	                params: "=params"
	            };
	            this.eventId = ManageGuestsController.eventId;
	            this.session.loadEvent(this.eventId);
	            this.session.loadReservations(this.eventId);
	        }
	        ManageGuestsController.prototype.approveReservation = function (reservationId) {
	            var _this = this;
	            this.log.debug("TODO APPROVE: " + reservationId);
	            this.session.loadReservations(this.eventId);
	            this.session.acceptReservation(reservationId).then(function (response) {
	                _this.log.debug("acceptReservation");
	                _this.log.debug(response);
	            }).then(function () {
	                _this.session.loadReservations(_this.eventId);
	                _this.session.loadEvent(_this.eventId);
	                _this.route.reload();
	            }).catch(function (error) {
	                _this.maxguestsError = _this.session.getData().reservationListStatus;
	                _this.numberGuestsMax = _this.session.getData().event.number_of_guests_max;
	            });
	            ;
	        };
	        ManageGuestsController.prototype.denyReservation = function (reservationId) {
	            var _this = this;
	            this.log.debug("TODO DENY: " + reservationId);
	            this.session.rejectReservation(reservationId).then(function (response) {
	                _this.log.debug("denyReservation");
	                _this.log.debug(response);
	            }).then(function () {
	                _this.session.loadReservations(_this.eventId);
	            });
	        };
	        ManageGuestsController.prototype.getReservationList = function () {
	            var list = this.session.getData().reservationList;
	            if (list != null) {
	                var returnList = [];
	                angular.forEach(list, function (reservation) {
	                    if (reservation.state != 'rejected') {
	                        returnList.push(reservation);
	                    }
	                });
	                return returnList;
	            }
	            else {
	                return [];
	            }
	        };
	        ManageGuestsController.prototype.getReservationListPending = function () {
	            var list = this.session.getData().reservationList;
	            if (list != null) {
	                var returnListCount = 0;
	                angular.forEach(list, function (reservation) {
	                    if (reservation.state == 'pending') {
	                        returnListCount++;
	                    }
	                });
	                return returnListCount;
	            }
	            else {
	                return 0;
	            }
	        };
	        ManageGuestsController.prototype.getGuestsPending = function () {
	            if (this.session.getData().event && typeof this.session.getData().event != "undefined") {
	                var pending_guests = this.session.getData().event.reservations_stats.guests_pending;
	                return pending_guests;
	            }
	        };
	        ManageGuestsController.prototype.getReservationListAccepted = function () {
	            var list = this.session.getData().reservationList;
	            if (list != null) {
	                var returnListCount = 0;
	                angular.forEach(list, function (reservation) {
	                    if (reservation.state == 'accepted') {
	                        returnListCount++;
	                    }
	                });
	                return returnListCount;
	            }
	            else {
	                return 0;
	            }
	        };
	        ManageGuestsController.prototype.getGuestsAccepted = function () {
	            if (this.session.getData().event && typeof this.session.getData().event != "undefined") {
	                var accepted_guests = this.session.getData().event.reservations_stats.guests_accepted;
	                return accepted_guests;
	            }
	        };
	        ManageGuestsController.prototype.isEventHosted = function () {
	            if (this.session.getData().event !== undefined && this.session.getData().event.created_by_profile.id === this.session.user.user_id) {
	                return true;
	            }
	        };
	        ManageGuestsController.open = function (modal, eventId) {
	            ManageGuestsController.eventId = eventId;
	            return modal.open({
	                controller: ManageGuestsController,
	                controllerAs: "vm",
	                replace: true,
	                size: "md",
	                template: TPL.modals.manageGuests
	            });
	        };
	        ManageGuestsController.$inject = ["session", "$uibModalInstance", "$log", "$route"];
	        return ManageGuestsController;
	    })();
	    exports.ManageGuestsController = ManageGuestsController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 153 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(181);

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./Landing_Banner.jpg": 201,
		"./arabic.png": 202,
		"./bannerless.jpg": 107,
		"./bay_area@2x.jpg": 203,
		"./chicago@2x.jpg": 204,
		"./cover_0.jpg": 108,
		"./cover_0_old.jpg": 205,
		"./cover_1.jpg": 109,
		"./cover_1_old.jpg": 206,
		"./cover_2.jpg": 110,
		"./cover_2_old.jpg": 207,
		"./cover_3.jpg": 111,
		"./cover_3_old.jpg": 208,
		"./cover_4_old.jpg": 209,
		"./cover_5_old.jpg": 210,
		"./cover_6_old.jpg": 211,
		"./credit-card.jpg": 212,
		"./emblem_bbyo.png": 112,
		"./emblem_navbar.png": 213,
		"./emblem_navbar.svg": 214,
		"./emblem_onetable.png": 215,
		"./favicon.ico": 216,
		"./icon_appetizers.png": 113,
		"./icon_dessert.png": 114,
		"./icon_main.png": 115,
		"./img_alcohol_free.png": 116,
		"./img_beer_and_wine.png": 117,
		"./img_birite.jpg": 118,
		"./img_byob.png": 119,
		"./img_doordash.jpg": 120,
		"./img_drizzly.jpg": 121,
		"./img_etsy.jpg": 122,
		"./img_freshdirect.jpg": 10,
		"./img_gluten_free.png": 123,
		"./img_goodeggs.jpg": 124,
		"./img_growbehold.jpg": 125,
		"./img_instacart.jpg": 11,
		"./img_kosher.png": 126,
		"./img_local-mission-market.jpg": 127,
		"./img_our-harvest.jpg": 128,
		"./img_pescatarian.png": 129,
		"./img_plated.jpg": 12,
		"./img_rainbow-grocery.jpg": 130,
		"./img_seamless.jpg": 131,
		"./img_sherry-lehmann.jpg": 217,
		"./img_sherry_leheman.jpg": 132,
		"./img_soomsoom.jpg": 133,
		"./img_table-swoon.jpg": 134,
		"./img_the-market.jpg": 135,
		"./img_thrive-market.jpg": 136,
		"./img_thrive_market.jpg": 218,
		"./img_vegan.png": 137,
		"./img_vegetarian.png": 138,
		"./img_whole-foods-market.jpg": 139,
		"./img_x.png": 14,
		"./loading.gif": 140,
		"./logo.png": 219,
		"./logo_footer.png": 141,
		"./logo_footer.svg": 220,
		"./logo_footer_old.jpg": 221,
		"./logo_footer_old.png": 222,
		"./logo_footer_old1.jpg": 223,
		"./logo_footer_old1.png": 224,
		"./logo_navbar.jpg": 15,
		"./logo_navbar.svg": 142,
		"./logo_navbar_old.jpg": 225,
		"./logo_navbar_old1.jpg": 226,
		"./logo_onward.png": 143,
		"./logo_onward_verical.png": 144,
		"./logo_vertical.png": 145,
		"./logo_vertical.svg": 227,
		"./logo_vertical_old1.png": 228,
		"./logoless.gif": 16,
		"./new_york@2x.jpg": 229,
		"./others@2x.jpg": 230,
		"./search.svg": 146,
		"./share_fb.png": 147,
		"./share_tw.png": 148
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 161;


/***/ },
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * angular-deferred-bootstrap - v0.1.9 - 2015-12-17
	 * https://github.com/philippd/angular-deferred-bootstrap
	 * Copyright (c) 2015 Philipp Denzler
	 * License: MIT
	 */
	(function (window, document) {
	'use strict';
	
	var isObject = angular.isObject,
	  isFunction = angular.isFunction,
	  isArray = angular.isArray,
	  isString = angular.isString,
	  forEach = angular.forEach,
	  loadingClass = 'deferred-bootstrap-loading',
	  errorClass = 'deferred-bootstrap-error',
	  bodyElement,
	  $q;
	
	function addLoadingClass () {
	  bodyElement.addClass(loadingClass);
	}
	
	function removeBodyClasses () {
	  bodyElement.removeClass(loadingClass);
	  bodyElement.removeClass(errorClass);
	}
	
	function addErrorClass () {
	  removeBodyClasses();
	  bodyElement.addClass(errorClass);
	}
	
	function isPromise (value) {
	  return isObject(value) && isFunction(value.then);
	}
	
	function checkConfig (config) {
	  if (!isObject(config)) {
	    throw new Error('Bootstrap configuration must be an object.');
	  }
	  if (!isString(config.module)) {
	    throw new Error('\'config.module\' must be a string.');
	  }
	  if (config.resolve && config.moduleResolves) {
	    throw new Error('Bootstrap configuration can contain either \'resolve\' or \'moduleResolves\' but not both');
	  }
	  if (config.resolve) {
	    if (!isObject(config.resolve)) {
	      throw new Error('\'config.resolve\' must be an object.');
	    }
	  }
	  if (config.bootstrapConfig) {
	    if (!isObject(config.bootstrapConfig)) {
	      throw new Error('\'config.bootstrapConfig\' must be an object.');
	    }
	  }
	  if (config.moduleResolves) {
	    if (!isArray(config.moduleResolves)) {
	      throw new Error('\'config.moduleResolves\' must be an array.');
	    }
	  }
	
	  forEach(config.moduleResolves, function (moduleResolve) {
	    if (!moduleResolve.module) {
	      throw new Error('A \'moduleResolve\' configuration item must contain a \'module\' name.');
	    }
	
	    if (!isObject(moduleResolve.resolve)) {
	      throw new Error('\'moduleResolve.resolve\' must be an object.');
	    }
	  });
	
	  if (angular.isDefined(config.onError) && !isFunction(config.onError)) {
	    throw new Error('\'config.onError\' must be a function.');
	  }
	}
	function provideRootElement (modules, element) {
	  element = angular.element(element);
	  modules.unshift(['$provide', function($provide) {
	    $provide.value('$rootElement', element);
	  }]);
	}
	
	function createInjector (injectorModules, element) {
	  var modules = ['ng'];
	  if (isString(injectorModules)) {
	    modules.push(injectorModules);
	  } else if (isArray(injectorModules)) {
	    modules = modules.concat(injectorModules);
	  }
	  provideRootElement(modules, element);
	  return angular.injector(modules, element);
	}
	
	function doBootstrap (element, module, bootstrapConfig) {
	  var deferred = $q.defer();
	
	  angular.element(document).ready(function () {
	    angular.bootstrap(element, [module], bootstrapConfig);
	    removeBodyClasses();
	
	    deferred.resolve(true);
	  });
	
	  return deferred.promise;
	}
	
	function bootstrap (configParam) {
	  var config = configParam || {},
	    element = config.element,
	    module = config.module,
	    injectorModules = config.injectorModules || [],
	    injector,
	    promises = [],
	    constants = [],
	    bootstrapConfig = config.bootstrapConfig;
	
	  bodyElement = angular.element(document.body);
	
	  addLoadingClass();
	  checkConfig(config);
	  injector = createInjector(injectorModules, element);
	  $q = injector.get('$q');
	
	  function callResolveFn (resolveFunction, constantName, moduleName) {
	    var result;
	
	    constants.push({
	      name: constantName,
	      moduleName: moduleName || module
	    });
	
	    if (!isFunction(resolveFunction) && !isArray(resolveFunction)) {
	      throw new Error('Resolve for \'' + constantName + '\' is not a valid dependency injection format.');
	    }
	
	    result = injector.instantiate(resolveFunction);
	
	    if (isPromise(result)) {
	      promises.push(result);
	    } else {
	      throw new Error('Resolve function for \'' + constantName + '\' must return a promise.');
	    }
	  }
	
	  function handleResults (results) {
	    forEach(results, function (value, index) {
	      var result = value && value.data ? value.data : value,
	        moduleName = constants[index].moduleName,
	        constantName = constants[index].name;
	
	      angular.module(moduleName).constant(constantName, result);
	    });
	
	    return doBootstrap(element, module, bootstrapConfig);
	  }
	
	  function handleError (error) {
	    addErrorClass();
	    if (isFunction(config.onError)) {
	      config.onError(error);
	    }
	  }
	
	  if (config.moduleResolves) {
	    forEach(config.moduleResolves, function (moduleResolve, index) {
	      forEach(moduleResolve.resolve, function (resolveFunction, constantName) {
	        callResolveFn(resolveFunction, constantName, config.moduleResolves[index].module);
	      });
	    });
	  } else {
	    forEach(config.resolve, function (resolveFunction, constantName) {
	      callResolveFn(resolveFunction, constantName);
	    });
	  }
	
	  return $q.all(promises).then(handleResults, handleError);
	}
	
	var deferredBootstrapper = {
	  bootstrap: bootstrap
	};
	
	if(true) {
	  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (deferredBootstrapper), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if(typeof module === 'object' && module.exports) {
	  module.exports = deferredBootstrapper;
	} else {
	  window.deferredBootstrapper = deferredBootstrapper;
	}
	
	})(window, document);

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* angular-moment.js / v0.10.3 / (c) 2013, 2014, 2015 Uri Shaked / MIT Licence */
	
	'format amd';
	/* global define */
	
	(function () {
		'use strict';
	
		function angularMoment(angular, moment) {
	
			/**
			 * @ngdoc overview
			 * @name angularMoment
			 *
			 * @description
			 * angularMoment module provides moment.js functionality for angular.js apps.
			 */
			return angular.module('angularMoment', [])
	
			/**
			 * @ngdoc object
			 * @name angularMoment.config:angularMomentConfig
			 *
			 * @description
			 * Common configuration of the angularMoment module
			 */
				.constant('angularMomentConfig', {
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#preprocess
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {string} The default preprocessor to apply
					 *
					 * @description
					 * Defines a default preprocessor to apply (e.g. 'unix', 'etc', ...). The default value is null,
					 * i.e. no preprocessor will be applied.
					 */
					preprocess: null, // e.g. 'unix', 'utc', ...
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#timezone
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {string} The default timezone
					 *
					 * @description
					 * The default timezone (e.g. 'Europe/London'). Empty string by default (does not apply
					 * any timezone shift).
					 */
					timezone: '',
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#format
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {string} The pre-conversion format of the date
					 *
					 * @description
					 * Specify the format of the input date. Essentially it's a
					 * default and saves you from specifying a format in every
					 * element. Overridden by element attr. Null by default.
					 */
					format: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#statefulFilters
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {boolean} Whether angular-moment filters should be stateless (or not)
					 *
					 * @description
					 * Specifies whether the filters included with angular-moment are stateful.
					 * Stateful filters will automatically re-evaluate whenever you change the timezone
					 * or language settings, but may negatively impact performance. true by default.
					 */
					statefulFilters: true
				})
	
			/**
			 * @ngdoc object
			 * @name angularMoment.object:moment
			 *
			 * @description
			 * moment global (as provided by the moment.js library)
			 */
				.constant('moment', moment)
	
			/**
			 * @ngdoc object
			 * @name angularMoment.config:amTimeAgoConfig
			 * @module angularMoment
			 *
			 * @description
			 * configuration specific to the amTimeAgo directive
			 */
				.constant('amTimeAgoConfig', {
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#withoutSuffix
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {boolean} Whether to include a suffix in am-time-ago directive
					 *
					 * @description
					 * Defaults to false.
					 */
					withoutSuffix: false,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#serverTime
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {number} Server time in milliseconds since the epoch
					 *
					 * @description
					 * If set, time ago will be calculated relative to the given value.
					 * If null, local time will be used. Defaults to null.
					 */
					serverTime: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#titleFormat
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {string} The format of the date to be displayed in the title of the element. If null,
					 *        the directive set the title of the element.
					 *
					 * @description
					 * The format of the date used for the title of the element. null by default.
					 */
					titleFormat: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#fullDateThreshold
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {number} The minimum number of days for showing a full date instead of relative time
					 *
					 * @description
					 * The threshold for displaying a full date. The default is null, which means the date will always
					 * be relative, and full date will never be displayed.
					 */
					fullDateThreshold: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#fullDateFormat
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {string} The format to use when displaying a full date.
					 *
					 * @description
					 * Specify the format of the date when displayed as full date. null by default.
					 */
					fullDateFormat: null
				})
	
			/**
			 * @ngdoc directive
			 * @name angularMoment.directive:amTimeAgo
			 * @module angularMoment
			 *
			 * @restrict A
			 */
				.directive('amTimeAgo', ['$window', 'moment', 'amMoment', 'amTimeAgoConfig', 'angularMomentConfig', function ($window, moment, amMoment, amTimeAgoConfig, angularMomentConfig) {
	
					return function (scope, element, attr) {
						var activeTimeout = null;
						var currentValue;
						var currentFormat = angularMomentConfig.format;
						var withoutSuffix = amTimeAgoConfig.withoutSuffix;
						var titleFormat = amTimeAgoConfig.titleFormat;
						var fullDateThreshold = amTimeAgoConfig.fullDateThreshold;
						var fullDateFormat = amTimeAgoConfig.fullDateFormat;
						var localDate = new Date().getTime();
						var preprocess = angularMomentConfig.preprocess;
						var modelName = attr.amTimeAgo;
						var currentFrom;
						var isTimeElement = ('TIME' === element[0].nodeName.toUpperCase());
	
						function getNow() {
							var now;
							if (currentFrom) {
								now = currentFrom;
							} else if (amTimeAgoConfig.serverTime) {
								var localNow = new Date().getTime();
								var nowMillis = localNow - localDate + amTimeAgoConfig.serverTime;
								now = moment(nowMillis);
							}
							else {
								now = moment();
							}
							return now;
						}
	
						function cancelTimer() {
							if (activeTimeout) {
								$window.clearTimeout(activeTimeout);
								activeTimeout = null;
							}
						}
	
						function updateTime(momentInstance) {
							var daysAgo = getNow().diff(momentInstance, 'day');
							var showFullDate = fullDateThreshold && daysAgo >= fullDateThreshold;
	
							if (showFullDate) {
								element.text(momentInstance.format(fullDateFormat));
							} else {
								element.text(momentInstance.from(getNow(), withoutSuffix));
							}
	
							if (titleFormat && !element.attr('title')) {
								element.attr('title', momentInstance.local().format(titleFormat));
							}
	
							if (!showFullDate) {
								var howOld = Math.abs(getNow().diff(momentInstance, 'minute'));
								var secondsUntilUpdate = 3600;
								if (howOld < 1) {
									secondsUntilUpdate = 1;
								} else if (howOld < 60) {
									secondsUntilUpdate = 30;
								} else if (howOld < 180) {
									secondsUntilUpdate = 300;
								}
	
								activeTimeout = $window.setTimeout(function () {
									updateTime(momentInstance);
								}, secondsUntilUpdate * 1000);
							}
						}
	
						function updateDateTimeAttr(value) {
							if (isTimeElement) {
								element.attr('datetime', value);
							}
						}
	
						function updateMoment() {
							cancelTimer();
							if (currentValue) {
								var momentValue = amMoment.preprocessDate(currentValue, preprocess, currentFormat);
								updateTime(momentValue);
								updateDateTimeAttr(momentValue.toISOString());
							}
						}
	
						scope.$watch(modelName, function (value) {
							if ((typeof value === 'undefined') || (value === null) || (value === '')) {
								cancelTimer();
								if (currentValue) {
									element.text('');
									updateDateTimeAttr('');
									currentValue = null;
								}
								return;
							}
	
							currentValue = value;
							updateMoment();
						});
	
						if (angular.isDefined(attr.amFrom)) {
							scope.$watch(attr.amFrom, function (value) {
								if ((typeof value === 'undefined') || (value === null) || (value === '')) {
									currentFrom = null;
								} else {
									currentFrom = moment(value);
								}
								updateMoment();
							});
						}
	
						if (angular.isDefined(attr.amWithoutSuffix)) {
							scope.$watch(attr.amWithoutSuffix, function (value) {
								if (typeof value === 'boolean') {
									withoutSuffix = value;
									updateMoment();
								} else {
									withoutSuffix = amTimeAgoConfig.withoutSuffix;
								}
							});
						}
	
						attr.$observe('amFormat', function (format) {
							if (typeof format !== 'undefined') {
								currentFormat = format;
								updateMoment();
							}
						});
	
						attr.$observe('amPreprocess', function (newValue) {
							preprocess = newValue;
							updateMoment();
						});
	
						attr.$observe('amFullDateThreshold', function (newValue) {
							fullDateThreshold = newValue;
							updateMoment();
						});
	
						attr.$observe('amFullDateFormat', function (newValue) {
							fullDateFormat = newValue;
							updateMoment();
						});
	
						scope.$on('$destroy', function () {
							cancelTimer();
						});
	
						scope.$on('amMoment:localeChanged', function () {
							updateMoment();
						});
					};
				}])
	
			/**
			 * @ngdoc service
			 * @name angularMoment.service.amMoment
			 * @module angularMoment
			 */
				.service('amMoment', ['moment', '$rootScope', '$log', 'angularMomentConfig', function (moment, $rootScope, $log, angularMomentConfig) {
					/**
					 * @ngdoc property
					 * @name angularMoment:amMoment#preprocessors
					 * @module angularMoment
					 *
					 * @description
					 * Defines the preprocessors for the preprocessDate method. By default, the following preprocessors
					 * are defined: utc, unix.
					 */
					this.preprocessors = {
						utc: moment.utc,
						unix: moment.unix
					};
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#changeLocale
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Changes the locale for moment.js and updates all the am-time-ago directive instances
					 * with the new locale. Also broadcasts an `amMoment:localeChanged` event on $rootScope.
					 *
					 * @param {string} locale Locale code (e.g. en, es, ru, pt-br, etc.)
					 * @param {object} customization object of locale strings to override
					 */
					this.changeLocale = function (locale, customization) {
						var result = moment.locale(locale, customization);
						if (angular.isDefined(locale)) {
							$rootScope.$broadcast('amMoment:localeChanged');
	
						}
						return result;
					};
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#changeTimezone
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Changes the default timezone for amCalendar, amDateFormat and amTimeAgo. Also broadcasts an
					 * `amMoment:timezoneChanged` event on $rootScope.
					 *
					 * @param {string} timezone Timezone name (e.g. UTC)
					 */
					this.changeTimezone = function (timezone) {
						angularMomentConfig.timezone = timezone;
						$rootScope.$broadcast('amMoment:timezoneChanged');
					};
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#preprocessDate
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Preprocess a given value and convert it into a Moment instance appropriate for use in the
					 * am-time-ago directive and the filters.
					 *
					 * @param {*} value The value to be preprocessed
					 * @param {string} preprocess The name of the preprocessor the apply (e.g. utc, unix)
					 * @param {string=} format Specifies how to parse the value (see {@link http://momentjs.com/docs/#/parsing/string-format/})
					 * @return {Moment} A value that can be parsed by the moment library
					 */
					this.preprocessDate = function (value, preprocess, format) {
						if (angular.isUndefined(preprocess)) {
							preprocess = angularMomentConfig.preprocess;
						}
						if (this.preprocessors[preprocess]) {
							return this.preprocessors[preprocess](value, format);
						}
						if (preprocess) {
							$log.warn('angular-moment: Ignoring unsupported value for preprocess: ' + preprocess);
						}
						if (!isNaN(parseFloat(value)) && isFinite(value)) {
							// Milliseconds since the epoch
							return moment(parseInt(value, 10));
						}
						// else just returns the value as-is.
						return moment(value, format);
					};
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#applyTimezone
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Apply a timezone onto a given moment object. It can be a named timezone (e.g. 'America/Phoenix') or an offset from UTC (e.g. '+0300')
					 * moment-timezone.js is needed when a named timezone is used, otherwise, it'll not apply any timezone shift.
					 *
					 * @param {Moment} aMoment a moment() instance to apply the timezone shift to
					 * @param {string=} timezone The timezone to apply. If none given, will apply the timezone
					 *        configured in angularMomentConfig.timezone. It can be a named timezone (e.g. 'America/Phoenix') or an offset from UTC (e.g. '+0300')
					 *
					 * @returns {Moment} The given moment with the timezone shift applied
					 */
					this.applyTimezone = function (aMoment, timezone) {
						timezone = timezone || angularMomentConfig.timezone;
						if (!timezone) {
							return aMoment;
						}
	
						if (timezone.match(/^Z|[+-]\d\d:?\d\d$/i)) {
							aMoment = aMoment.utcOffset(timezone);
						} else if (aMoment.tz) {
							aMoment = aMoment.tz(timezone);
						} else {
							$log.warn('angular-moment: named timezone specified but moment.tz() is undefined. Did you forget to include moment-timezone.js?');
						}
	
						return aMoment;
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amCalendar
			 * @module angularMoment
			 */
				.filter('amCalendar', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amCalendarFilter(value, preprocess, timezone) {
						if (typeof value === 'undefined' || value === null) {
							return '';
						}
	
						value = amMoment.preprocessDate(value, preprocess);
						var date = moment(value);
						if (!date.isValid()) {
							return '';
						}
	
						return amMoment.applyTimezone(date, timezone).calendar();
					}
	
					// Since AngularJS 1.3, filters have to explicitly define being stateful
					// (this is no longer the default).
					amCalendarFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amCalendarFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDifference
			 * @module angularMoment
			 */
				.filter('amDifference', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amDifferenceFilter(value, otherValue, unit, usePrecision, preprocessValue, preprocessOtherValue) {
						if (typeof value === 'undefined' || value === null) {
							return '';
						}
	
						value = amMoment.preprocessDate(value, preprocessValue);
						var date = moment(value);
						if (!date.isValid()) {
							return '';
						}
	
						var date2;
						if (typeof otherValue === 'undefined' || otherValue === null) {
							date2 = moment();
						} else {
							otherValue = amMoment.preprocessDate(otherValue, preprocessOtherValue);
							date2 = moment(otherValue);
							if (!date2.isValid()) {
								return '';
							}
						}
	
						return amMoment.applyTimezone(date).diff(amMoment.applyTimezone(date2), unit, usePrecision);
					}
	
					amDifferenceFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDifferenceFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDateFormat
			 * @module angularMoment
			 * @function
			 */
				.filter('amDateFormat', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amDateFormatFilter(value, format, preprocess, timezone, inputFormat) {
						var currentFormat = inputFormat || angularMomentConfig.format;
						if (typeof value === 'undefined' || value === null) {
							return '';
						}
	
						value = amMoment.preprocessDate(value, preprocess, currentFormat);
						var date = moment(value);
						if (!date.isValid()) {
							return '';
						}
	
						return amMoment.applyTimezone(date, timezone).format(format);
					}
	
					amDateFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDateFormatFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDurationFormat
			 * @module angularMoment
			 * @function
			 */
				.filter('amDurationFormat', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amDurationFormatFilter(value, format, suffix) {
						if (typeof value === 'undefined' || value === null) {
							return '';
						}
	
						return moment.duration(value, format).humanize(suffix);
					}
	
					amDurationFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDurationFormatFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amTimeAgo
			 * @module angularMoment
			 * @function
			 */
				.filter('amTimeAgo', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amTimeAgoFilter(value, preprocess, suffix, from) {
						var date, dateFrom;
	
						if (typeof value === 'undefined' || value === null) {
							return '';
						}
	
						value = amMoment.preprocessDate(value, preprocess);
						date = moment(value);
						if (!date.isValid()) {
							return '';
						}
	
						dateFrom = moment(from);
						if (typeof from !== 'undefined' && dateFrom.isValid()) {
							return amMoment.applyTimezone(date).from(dateFrom, suffix);
						}
	
						return amMoment.applyTimezone(date).fromNow(suffix);
					}
	
					amTimeAgoFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amTimeAgoFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amSubtract
			 * @module angularMoment
			 * @function
			 */
				.filter('amSubtract', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amSubtractFilter(value, amount, type) {
	
						if (typeof value === 'undefined' || value === null) {
							return '';
						}
	
						return moment(value).subtract(parseInt(amount, 10), type);
					}
	
					amSubtractFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amSubtractFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amAdd
			 * @module angularMoment
			 * @function
			 */
				.filter('amAdd', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amAddFilter(value, amount, type) {
	
						if (typeof value === 'undefined' || value === null) {
							return '';
						}
	
						return moment(value).add(parseInt(amount, 10), type);
					}
	
					amAddFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amAddFilter;
				}]);
		}
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(377)], __WEBPACK_AMD_DEFINE_FACTORY__ = (angularMoment), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module && module.exports) {
			angularMoment(angular, require('moment'));
			module.exports = 'angularMoment';
		} else {
			angularMoment(angular, (typeof global !== 'undefined' ? global : window).moment);
		}
	})();


/***/ },
/* 167 */,
/* 168 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.5.8
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	var bind;
	var extend;
	var forEach;
	var isDefined;
	var lowercase;
	var noop;
	var htmlParser;
	var htmlSanitizeWriter;
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The whitelist for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
	 *   `$compileProvider`}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    if (svgEnabled) {
	      extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	  // Private stuff
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	
	  bind = angular.bind;
	  extend = angular.extend;
	  forEach = angular.forEach;
	  isDefined = angular.isDefined;
	  lowercase = angular.lowercase;
	  noop = angular.noop;
	
	  htmlParser = htmlParserImpl;
	  htmlSanitizeWriter = htmlSanitizeWriterImpl;
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	    // Match everything outside of normal chars and " (quote character)
	    NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;
	
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = toMap("area,br,col,hr,img,wbr");
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = toMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	      optionalEndTagInlineElements = toMap("rp,rt"),
	      optionalEndTagElements = extend({},
	                                              optionalEndTagInlineElements,
	                                              optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = extend({}, optionalEndTagBlockElements, toMap("address,article," +
	          "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
	          "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul"));
	
	  // Inline Elements - HTML5
	  var inlineElements = extend({}, optionalEndTagInlineElements, toMap("a,abbr,acronym,b," +
	          "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
	          "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = toMap("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph," +
	          "hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline," +
	          "radialGradient,rect,stop,svg,switch,text,title,tspan");
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = toMap("script,style");
	
	  var validElements = extend({},
	                                     voidElements,
	                                     blockElements,
	                                     inlineElements,
	                                     optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = toMap("background,cite,href,longdesc,src,xlink:href");
	
	  var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	      'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = extend({},
	                                  uriAttrs,
	                                  svgAttrs,
	                                  htmlAttrs);
	
	  function toMap(str, lowercaseKeys) {
	    var obj = {}, items = str.split(','), i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  var inertBodyElement;
	  (function(window) {
	    var doc;
	    if (window.document && window.document.implementation) {
	      doc = window.document.implementation.createHTMLDocument("inert");
	    } else {
	      throw $sanitizeMinErr('noinert', "Can't create an inert html document");
	    }
	    var docElement = doc.documentElement || doc.getDocumentElement();
	    var bodyElements = docElement.getElementsByTagName('body');
	
	    // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
	    if (bodyElements.length === 1) {
	      inertBodyElement = bodyElements[0];
	    } else {
	      var html = doc.createElement('html');
	      inertBodyElement = doc.createElement('body');
	      html.appendChild(inertBodyElement);
	      doc.appendChild(html);
	    }
	  })(window);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParserImpl(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	    inertBodyElement.innerHTML = html;
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', "Failed to sanitize html because the input is unstable");
	      }
	      mXSSAttempts--;
	
	      // strip custom-namespaced attributes on IE<=11
	      if (window.document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	      html = inertBodyElement.innerHTML; //trigger mXSS
	      inertBodyElement.innerHTML = html;
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1: // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3: // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	      if (node.nodeType == 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = node.nextSibling;
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = node.parentNode;
	            if (node === inertBodyElement) break;
	            nextNode = node.nextSibling;
	          if (node.nodeType == 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while (node = inertBodyElement.firstChild) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.
	      replace(/&/g, '&amp;').
	      replace(SURROGATE_PAIR_REGEXP, function(value) {
	        var hi = value.charCodeAt(0);
	        var low = value.charCodeAt(1);
	        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	      }).
	      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	        return '&#' + value.charCodeAt(0) + ';';
	      }).
	      replace(/</g, '&lt;').
	      replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriterImpl(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = bind(buf, buf.push);
	    return {
	      start: function(tag, attrs) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          forEach(attrs, function(value, key) {
	            var lkey = lowercase(key);
	            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	            if (validAttrs[lkey] === true &&
	              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function(tag) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function(chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(chars));
	        }
	      }
	    };
	  }
	
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    if (node.nodeType === window.Node.ELEMENT_NODE) {
	      var attrs = node.attributes;
	      for (var i = 0, l = attrs.length; i < l; i++) {
	        var attrNode = attrs[i];
	        var attrName = attrNode.name.toLowerCase();
	        if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	          node.removeAttributeNode(attrNode);
	          i--;
	          l--;
	        }
	      }
	    }
	
	    var nextNode = node.firstChild;
	    if (nextNode) {
	      stripCustomNsAttrs(nextNode);
	    }
	
	    nextNode = node.nextSibling;
	    if (nextNode) {
	      stripCustomNsAttrs(nextNode);
	    }
	  }
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n'+
	             'http://angularjs.org/,\n'+
	             'mailto:us@somewhere.org,\n'+
	             'another@somewhere.org,\n'+
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isDefined = angular.isDefined;
	  var isFunction = angular.isFunction;
	  var isObject = angular.isObject;
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var attributesFn =
	      isFunction(attributes) ? attributes :
	      isObject(attributes) ? function getAttributesObject() {return attributes;} :
	      function getEmptyAttributesObject() {return {};};
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key, linkAttributes = attributesFn(url);
	      html.push('<a ');
	
	      for (key in linkAttributes) {
	        html.push(key + '="' + linkAttributes[key] + '" ');
	      }
	
	      if (isDefined(target) && !('target' in linkAttributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ },
/* 169 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 *  * angular-socialshare v0.0.2
	 *   * ♡ CopyHeart 2014 by Dayanand Prabhu http://djds4rce.github.io
	 *    * Copying is an act of love. Please copy.
	 *     */
	
	angular.module('djds4rce.angular-socialshare', [])
		.factory('$FB', ['$window', function($window) {
			return {
				init: function(fbId) {
					if (fbId) {
						this.fbId = fbId;
						$window.fbAsyncInit = function() {
							FB.init({
								appId: fbId,
								channelUrl: 'app/channel.html',
								status: true,
								xfbml: true
							});
						};
						(function(d) {
							var js,
								id = 'facebook-jssdk',
								ref = d.getElementsByTagName('script')[0];
							if (d.getElementById(id)) {
								return;
							}
	
							js = d.createElement('script');
							js.id = id;
							js.async = true;
							js.src = "//connect.facebook.net/en_US/all.js";
	
							ref.parentNode.insertBefore(js, ref);
	
						}(document));
					} else {
						throw ("FB App Id Cannot be blank");
					}
				}
			};
	
		}]).directive('facebook', ['$http', function($http) {
			return {
				scope: {
					callback: '=',
					shares: '='
				},
				transclude: true,
				template: '<div class="facebookButton">' +
					'<div class="pluginButton">' +
					'<div class="pluginButtonContainer">' +
					'<div class="pluginButtonImage">' +
					'<button type="button">' +
					'<i class="pluginButtonIcon img sp_plugin-button-2x sx_plugin-button-2x_favblue"></i>' +
					'</button>' +
					'</div>' +
					'<span class="pluginButtonLabel">Share</span>' +
					'</div>' +
					'</div>' +
					'</div>' +
					'<div class="facebookCount">' +
					'<div class="pluginCountButton pluginCountNum">' +
					'<span ng-transclude></span>' +
					'</div>' +
					'<div class="pluginCountButtonNub"><s></s><i></i></div>' +
					'</div>',
				link: function(scope, element, attr) {
					attr.$observe('url', function() {
						if (attr.shares && attr.url) {
							$http.get('https://api.facebook.com/method/links.getStats?urls=' + attr.url + '&format=json').success(function(res) {
								var count = res[0] ? res[0].total_count.toString() : 0;
								var decimal = '';
								if (count.length > 6) {
									if (count.slice(-6, -5) != "0") {
										decimal = '.' + count.slice(-6, -5);
									}
									count = count.slice(0, -6);
									count = count + decimal + 'M';
								} else if (count.length > 3) {
									if (count.slice(-3, -2) != "0") {
										decimal = '.' + count.slice(-3, -2);
									}
									count = count.slice(0, -3);
									count = count + decimal + 'k';
								}
								scope.shares = count;
							}).error(function() {
								scope.shares = 0;
							});
						}
						element.unbind();
						element.bind('click', function(e) {
							FB.ui({
								method: 'share',
								href: attr.url
							}, function(response){
								if (scope.callback !== undefined && typeof scope.callback === "function") {
									scope.callback(response);
								}
							});
							e.preventDefault();
						});
					});
				}
			};
		}]).directive('facebookFeedShare', ['$http', function($http) {
			return {
				scope: {
					callback: '=',
					shares: '='
				},
				transclude: true,
				template: '<div class="facebookButton">' +
					'<div class="pluginButton">' +
					'<div class="pluginButtonContainer">' +
					'<div class="pluginButtonImage">' +
					'<button type="button">' +
					'<i class="pluginButtonIcon img sp_plugin-button-2x sx_plugin-button-2x_favblue"></i>' +
					'</button>' +
					'</div>' +
					'<span class="pluginButtonLabel">Share</span>' +
					'</div>' +
					'</div>' +
					'</div>' +
					'<div class="facebookCount">' +
					'<div class="pluginCountButton pluginCountNum">' +
					'<span ng-transclude></span>' +
					'</div>' +
					'<div class="pluginCountButtonNub"><s></s><i></i></div>' +
					'</div>',
				link: function(scope, element, attr) {
					attr.$observe('url', function() {
						if (attr.shares && attr.url) {
							$http.get('https://api.facebook.com/method/links.getStats?urls=' + attr.url + '&format=json').success(function(res) {
								var count = res[0] ? res[0].total_count.toString() : 0;
								var decimal = '';
								if (count.length > 6) {
									if (count.slice(-6, -5) != "0") {
										decimal = '.' + count.slice(-6, -5);
									}
									count = count.slice(0, -6);
									count = count + decimal + 'M';
								} else if (count.length > 3) {
									if (count.slice(-3, -2) != "0") {
										decimal = '.' + count.slice(-3, -2);
									}
									count = count.slice(0, -3);
									count = count + decimal + 'k';
								}
								scope.shares = count;
							}).error(function() {
								scope.shares = 0;
							});
						}
						element.unbind();
						element.bind('click', function(e) {
							FB.ui({
								method: 'feed',
								link: attr.url,
								picture: attr.picture,
								name: attr.name,
								caption: attr.caption,
								description: attr.description
							}, function(response){
								if (scope.callback !== undefined && typeof scope.callback === "function") {
									scope.callback(response);
								}
							});
							e.preventDefault();
						});
					});
				}
			};
		}]).directive('twitter', ['$timeout', function($timeout) {
			return {
				link: function(scope, element, attr) {
					var renderTwitterButton = debounce(function() {
						if (attr.url) {
							$timeout(function() {
								element[0].innerHTML = '';
								twttr.widgets.createShareButton(
									attr.url,
									element[0],
									function() {}, {
										count: attr.count,
										text: attr.text,
										via: attr.via,
										size: attr.size
									}
								);
							});
						}
					}, 75);
					attr.$observe('url', renderTwitterButton);
					attr.$observe('text', renderTwitterButton);
				}
			};
		}]).directive('linkedin', ['$timeout', '$http', '$window', function($timeout, $http, $window) {
			return {
				scope: {
					shares: '='
				},
				transclude: true,
				template: '<div class="linkedinButton">' +
					'<div class="pluginButton">' +
					'<div class="pluginButtonContainer">' +
					'<div class="pluginButtonImage">in' +
					'</div>' +
					'<span class="pluginButtonLabel"><span>Share</span></span>' +
					'</div>' +
					'</div>' +
					'</div>' +
					'<div class="linkedinCount">' +
					'<div class="pluginCountButton">' +
					'<div class="pluginCountButtonRight">' +
					'<div class="pluginCountButtonLeft">' +
					'<span ng-transclude></span>' +
					'</div>' +
					'</div>' +
					'</div>' +
					'</div>',
				link: function(scope, element, attr) {
					var renderLinkedinButton = debounce(function() {
						if (attr.shares && attr.url) {
							$http.jsonp('https://www.linkedin.com/countserv/count/share?url=' + attr.url + '&callback=JSON_CALLBACK&format=jsonp').success(function(res) {
								scope.shares = res.count.toLocaleString();
							}).error(function() {
								scope.shares = 0;
							});
						}
						$timeout(function() {
							element.unbind();
							element.bind('click', function() {
								var url = encodeURIComponent(attr.url).replace(/'/g, "%27").replace(/"/g, "%22")
								$window.open("//www.linkedin.com/shareArticle?mini=true&url=" + url + "&title=" + attr.title + "&summary=" + attr.summary);
							});
						});
					}, 100);
					attr.$observe('url', renderLinkedinButton);
					attr.$observe('title', renderLinkedinButton);
					attr.$observe('summary', renderLinkedinButton);
				}
			};
		}]).directive('gplus', [function() {
			return {
				link: function(scope, element, attr) {
					var googleShare = debounce(function() {
						if (typeof gapi == "undefined") {
							(function() {
								var po = document.createElement('script');
								po.type = 'text/javascript';
								po.async = true;
								po.src = 'https://apis.google.com/js/platform.js';
								po.onload = renderGoogleButton;
								var s = document.getElementsByTagName('script')[0];
								s.parentNode.insertBefore(po, s);
							})();
						} else {
							renderGoogleButton();
						}
					}, 100);
					//voodo magic
					var renderGoogleButton = (function(ele, attr) {
						return function() {
							var googleButton = document.createElement('div');
							var id = attr.id || randomString(5);
							attr.id = id;
							googleButton.setAttribute('id', id);
							element.innerHTML = '';
							element.append(googleButton);
							if (attr.class && attr.class.indexOf('g-plusone') != -1) {
								window.gapi.plusone.render(id, attr);
							} else {
								window.gapi.plus.render(id, attr);
							}
						}
					}(element, attr));
					attr.$observe('href', googleShare);
				}
			};
		}]).directive('tumblrText', [function() {
			return {
				link: function(scope, element, attr) {
					var tumblr_button = document.createElement("a");
					var renderTumblrText = debounce(function() {
						tumblr_button.setAttribute("href", "https://www.tumblr.com/share/link?url=" + encodeURIComponent(attr.url) + "&name=" + encodeURIComponent(attr.name) + "&description=" + encodeURIComponent(attr.description));
						tumblr_button.setAttribute("title", attr.title || "Share on Tumblr");
						tumblr_button.setAttribute("style", attr.styling || "display:inline-block; text-indent:-9999px; overflow:hidden; width:81px; height:20px; background:url('https://platform.tumblr.com/v1/share_1.png') top left no-repeat transparent;");
						element[0].innerHTML = '';
						element.append(tumblr_button);
					}, 100);
					attr.$observe('url', renderTumblrText);
					attr.$observe('name', renderTumblrText);
					attr.$observe('description', renderTumblrText);
				}
	
			}
		}]).directive('tumblrQoute', [function() {
			return {
				link: function(scope, element, attr) {
					var tumblr_button = document.createElement("a");
					var renderTumblrQoute = debounce(function() {
						tumblr_button.setAttribute("href", "https://www.tumblr.com/share/quote?quote=" + encodeURIComponent(attr.qoute) + "&source=" + encodeURIComponent(attr.source));
						tumblr_button.setAttribute("title", attr.title || "Share on Tumblr");
						tumblr_button.setAttribute("style", attr.styling || "display:inline-block; text-indent:-9999px; overflow:hidden; width:81px; height:20px; background:url('https://platform.tumblr.com/v1/share_1.png') top left no-repeat transparent;");
						element[0].innerHTML = '';
						element.append(tumblr_button);
					}, 100);
					attr.$observe('qoute', renderTumblrQoute);
					attr.$observe('source', renderTumblrQoute);
				}
			}
		}]).directive('tumblrImage', [function() {
			return {
				link: function(scope, element, attr) {
					var tumblr_button = document.createElement("a");
					var renderTumblrImage = debounce(function() {
						tumblr_button.setAttribute("href", "https://www.tumblr.com/share/photo?source=" + encodeURIComponent(attr.source) + "&caption=" + encodeURIComponent(attr.caption) + "&clickthru=" + encodeURIComponent(attr.clickthru));
						tumblr_button.setAttribute("title", attr.title || "Share on Tumblr");
						tumblr_button.setAttribute("style", attr.styling || "display:inline-block; text-indent:-9999px; overflow:hidden; width:81px; height:20px; background:url('https://platform.tumblr.com/v1/share_1.png') top left no-repeat transparent;");
						element[0].innerHTML = '';
						element.append(tumblr_button);
					}, 100);
					attr.$observe('source', renderTumblrImage);
					attr.$observe('caption', renderTumblrImage);
					attr.$observe('clickthru', renderTumblrImage);
				}
			}
		}]).directive('tumblrVideo', [function() {
			return {
				link: function(scope, element, attr) {
					var tumblr_button = document.createElement("a");
					var renderTumblrVideo = debounce(function() {
						tumblr_button.setAttribute("href", "https://www.tumblr.com/share/video?embed=" + encodeURIComponent(attr.embedcode) + "&caption=" + encodeURIComponent(attr.caption));
						tumblr_button.setAttribute("title", attr.title || "Share on Tumblr");
						tumblr_button.setAttribute("style", attr.styling || "display:inline-block; text-indent:-9999px; overflow:hidden; width:81px; height:20px; background:url('https://platform.tumblr.com/v1/share_1.png') top left no-repeat transparent;");
						element[0].innerHTML = '';
						element.append(tumblr_button);
					}, 100);
					attr.$observe('embedcode', renderTumblrVideo);
					attr.$observe('caption', renderTumblrVideo);
				}
			}
		}]).directive('pintrest', ['$window', '$timeout', function($window, $timeout) {
			return {
				template: '<a href="{{href}}" data-pin-do="{{pinDo}}" data-pin-config="{{pinConfig}}"><img src="//assets.pinterest.com/images/pidgets/pinit_fg_en_rect_gray_20.png" /></a>',
				link: function(scope, element, attr) {
					var pintrestButtonRenderer = debounce(function() {
						var pin_button = document.createElement("a");
						pin_button.setAttribute("href", '//www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(attr.href) + '&media=' + encodeURIComponent(attr.img) + '&description=' + encodeURIComponent(attr.description));
						pin_button.setAttribute("pinDo", attr.pinDo || "buttonPin");
						pin_button.setAttribute("pinConfig", attr.pinConfig || "beside");
						element[0].innerHTML = '';
						element.append(pin_button);
						$timeout(function() {
							$window.parsePins(element);
						});
					}, 100);
	
					attr.$observe('href', pintrestButtonRenderer);
					attr.$observe('img', pintrestButtonRenderer);
					attr.$observe('description', pintrestButtonRenderer);
				}
			}
		}]);
	//Simple Debounce Implementation
	//http://davidwalsh.name/javascript-debounce-function
	function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this,
				args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};
	//http://stackoverflow.com/questions/1349404/generate-a-string-of-5-random-characters-in-javascript
	/**
	 * RANDOM STRING GENERATOR
	 *
	 * Info:      http://stackoverflow.com/a/27872144/383904
	 * Use:       randomString(length [,"A"] [,"N"] );
	 * Default:   return a random alpha-numeric string
	 * Arguments: If you use the optional "A", "N" flags:
	 *            "A" (Alpha flag)   return random a-Z string
	 *            "N" (Numeric flag) return random 0-9 string
	 */
	function randomString(len, an) {
		an = an && an.toLowerCase();
		var str = "",
			i = 0,
			min = an == "a" ? 10 : 0,
			max = an == "n" ? 10 : 62;
		for (; i++ < len;) {
			var r = Math.random() * (max - min) + min << 0;
			str += String.fromCharCode(r += r > 9 ? r < 36 ? 55 : 61 : 48);
		}
		return str;
	}


/***/ },
/* 170 */
/***/ function(module, exports) {

	"undefined"!=typeof module&&"undefined"!=typeof exports&&module.exports===exports&&(module.exports="angularSpinners"),function(e,n,r){n.module("angularSpinners",[]).factory("spinnerService",function(){var e={};return{_register:function(n){if(!n.hasOwnProperty("name"))throw new Error("Spinner must specify a name when registering with the spinner service.");e[n.name]=n},_unregister:function(n){e.hasOwnProperty(n)&&delete e[n]},_unregisterGroup:function(n){for(var r in e)e[r].group===n&&delete e[r]},_unregisterAll:function(){for(var n in e)delete e[n]},show:function(n){var r=e[n];if(!r)throw new Error("No spinner named '"+n+"' is registered.");r.show()},hide:function(n){var r=e[n];if(!r)throw new Error("No spinner named '"+n+"' is registered.");r.hide()},showGroup:function(n){var r=!1;for(var o in e){var i=e[o];i.group===n&&(i.show(),r=!0)}if(!r)throw new Error("No spinners found with group '"+n+"'.")},hideGroup:function(n){var r=!1;for(var o in e){var i=e[o];i.group===n&&(i.hide(),r=!0)}if(!r)throw new Error("No spinners found with group '"+n+"'.")},showAll:function(){for(var n in e)e[n].show()},hideAll:function(){for(var n in e)e[n].hide()}}}),n.module("angularSpinners").directive("spinner",function(){return{restrict:"EA",replace:!0,transclude:!0,scope:{name:"@?",group:"@?",show:"=?",imgSrc:"@?",register:"@?",onLoaded:"&?",onShow:"&?",onHide:"&?"},template:['<div ng-show="show">','  <img ng-if="imgSrc" ng-src="{{imgSrc}}" />',"  <ng-transclude></ng-transclude>","</div>"].join(""),controller:["$scope","spinnerService",function(e,n){e.register=e.hasOwnProperty("register")&&"false"===e.register.toLowerCase()?!1:!0;var r={name:e.name,group:e.group,show:function(){e.show=!0},hide:function(){e.show=!1},toggle:function(){e.show=!e.show}};e.register===!0&&n._register(r),(e.onShow||e.onHide)&&e.$watch("show",function(o){o&&e.onShow?e.onShow({spinnerService:n,spinnerApi:r}):!o&&e.onHide&&e.onHide({spinnerService:n,spinnerApi:r})}),e.onLoaded&&e.onLoaded({spinnerService:n,spinnerApi:r})}]}})}(window,window.angular);

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var require;var require;/* WEBPACK VAR INJECTION */(function(global) {(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.angularStripe = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	(function (global){
	'use strict'
	
	var angular = (typeof window !== "undefined" ? window['angular'] : typeof global !== "undefined" ? global['angular'] : null)
	
	module.exports = angular.module('assert-q-constructor', [])
	  .factory('assertQConstructor', main)
	  .name
	
	main.$inject = ['$q']
	function main ($q) {
	  return function assertQConstructor (message) {
	    if (typeof $q !== 'function') {
	      throw new Error(message || '$q is not a function')
	    }
	  }
	}
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],2:[function(_dereq_,module,exports){
	'use strict';
	
	function isObjOrFn(x) {
		return (typeof x === 'object' || typeof x === 'function') && x !== null;
	}
	
	module.exports.get = function (obj, path) {
		if (!isObjOrFn(obj) || typeof path !== 'string') {
			return obj;
		}
	
		var pathArr = path.split('.');
		pathArr.some(function (path, index) {
			obj = obj[path];
	
			if (obj === undefined) {
				return true;
			}
		});
	
		return obj;
	};
	
	module.exports.set = function (obj, path, value) {
		if (!isObjOrFn(obj) || typeof path !== 'string') {
			return;
		}
	
		var pathArr = path.split('.');
		pathArr.forEach(function (path, index) {
			if (!isObjOrFn(obj[path])) {
				obj[path] = {};
			}
	
			if (index === pathArr.length - 1) {
				obj[path] = value;
			}
	
			obj = obj[path];
		});
	};
	
	},{}],3:[function(_dereq_,module,exports){
	'use strict'
	
	var extend = _dereq_('xtend/mutable')
	var dot = _dereq_('dot-prop')
	
	var asyncMethods = [
	  'card.createToken',
	  'bankAccount.createToken',
	  'bitcoinReceiver.createReceiver',
	  'bitcoinReceiver.pollReceiver',
	  'bitcoinReceiver.getReceiver',
	]
	
	var helperMethods = [
	  'setPublishableKey',
	  'card.validateCardNumber',
	  'card.validateExpiry',
	  'card.validateCVC',
	  'card.cardType',
	  'bankAccount.validateRoutingNumber',
	  'bankAccount.validateAccountNumber',
	  'bitcoinReceiver.cancelReceiverPoll'
	]
	
	module.exports = function promisifyStripe (Stripe, Promise) {
	  if (typeof Stripe !== 'function') throw new Error('Stripe.js must be provided')
	  if (typeof Promise !== 'function') throw new Error('Promise constructor must be provided')
	  var stripe = {}
	  asyncMethods.forEach(function (method) {
	    var names = method.split('.')
	    var receiverName = names[0]
	    var methodName = names[1]
	    dot.set(stripe, method, promisify(Promise, methodName, Stripe[receiverName], stripeResponseHandler))
	  })
	  helperMethods.forEach(function (method) {
	    dot.set(stripe, method, dot.get(Stripe, method))
	  })
	  return stripe
	}
	
	function promisify (Promise, method, receiver, resolver) {
	  return function promisified () {
	    var args = Array.prototype.slice.call(arguments)
	    return new Promise(function (resolve, reject) {
	      receiver[method].apply(receiver, args.concat(function promisifiedResolve () {
	        resolver.apply({resolve: resolve, reject: reject}, arguments)
	      }))      
	    })
	  }
	}
	
	function stripeResponseHandler (status, response) {
	  if (response.error) {
	    this.reject(extend(new Error(), response.error))
	  }
	  else {
	    this.resolve(response)
	  }
	}
	
	},{"dot-prop":2,"xtend/mutable":4}],4:[function(_dereq_,module,exports){
	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend(target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}
	
	},{}],5:[function(_dereq_,module,exports){
	'use strict'
	
	var service = _dereq_('./service')
	
	module.exports = stripeProvider
	
	stripeProvider.$inject = ['Stripe']
	function stripeProvider (Stripe) {
	  if (!Stripe) throw new Error('Stripe must be available as window.Stripe')
	  this.setPublishableKey = Stripe.setPublishableKey
	  this.$get = service
	}
	
	},{"./service":6}],6:[function(_dereq_,module,exports){
	'use strict'
	
	var stripeAsPromised = _dereq_('stripe-as-promised')
	
	module.exports = factory
	
	factory.$inject = ['Stripe', '$q']
	function factory (Stripe, $q) {
	  return stripeAsPromised(Stripe, $q)
	}
	
	},{"stripe-as-promised":3}],7:[function(_dereq_,module,exports){
	(function (global){
	'use strict'
	
	var angular = (typeof window !== "undefined" ? window['angular'] : typeof global !== "undefined" ? global['angular'] : null)
	var provider = _dereq_('./provider')
	var Stripe = window.Stripe
	
	module.exports = angular.module('angular-stripe', [
	  _dereq_('angular-assert-q-constructor')
	])
	.constant('Stripe', Stripe)
	.provider('stripe', provider)
	.run(verifyQ)
	.name
	
	verifyQ.$inject = ['assertQConstructor']
	function verifyQ (assertQConstructor) {
	  assertQConstructor('angular-stripe: For Angular <= 1.2 support, first load https://github.com/bendrucker/angular-q-constructor')
	}
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"./provider":5,"angular-assert-q-constructor":1}]},{},[7])(7)
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 172 */,
/* 173 */,
/* 174 */
/***/ function(module, exports) {

	/**
	 * angular-ui-notification - Angular.js service providing simple notifications using Bootstrap 3 styles with css transitions for animating
	 * @author Alex_Crack
	 * @version v0.1.0
	 * @link https://github.com/alexcrack/angular-ui-notification
	 * @license MIT
	 */
	angular.module('ui-notification',[]);
	
	angular.module('ui-notification').provider('Notification', function() {
	
	    this.options = {
	        delay: 5000,
	        startTop: 10,
	        startRight: 10,
	        verticalSpacing: 10,
	        horizontalSpacing: 10,
	        positionX: 'right',
	        positionY: 'top',
	        replaceMessage: false,
	        templateUrl: 'angular-ui-notification.html'
	    };
	
	    this.setOptions = function(options) {
	        if (!angular.isObject(options)) throw new Error("Options should be an object!");
	        this.options = angular.extend({}, this.options, options);
	    };
	
	    this.$get = ["$timeout", "$http", "$compile", "$templateCache", "$rootScope", "$injector", "$sce", "$q", "$window", function($timeout, $http, $compile, $templateCache, $rootScope, $injector, $sce, $q, $window) {
	        var options = this.options;
	
	        var startTop = options.startTop;
	        var startRight = options.startRight;
	        var verticalSpacing = options.verticalSpacing;
	        var horizontalSpacing = options.horizontalSpacing;
	        var delay = options.delay;
	
	        var messageElements = [];
	        var isResizeBound = false;
	
	        var notify = function(args, t){
	            var deferred = $q.defer();
	
	            if (typeof args !== 'object') {
	                args = {message:args};
	            }
	
	            args.scope = args.scope ? args.scope : $rootScope;
	            args.template = args.templateUrl ? args.templateUrl : options.templateUrl;
	            args.delay = !angular.isUndefined(args.delay) ? args.delay : delay;
	            args.type = t || options.type ||  '';
	            args.positionY = args.positionY ? args.positionY : options.positionY;
	            args.positionX = args.positionX ? args.positionX : options.positionX;
	            args.replaceMessage = args.replaceMessage ? args.replaceMessage : options.replaceMessage;
	
	            $http.get(args.template,{cache: $templateCache}).success(function(template) {
	
	                var scope = args.scope.$new();
	                scope.message = $sce.trustAsHtml(args.message);
	                scope.title = $sce.trustAsHtml(args.title);
	                scope.t = args.type.substr(0,1);
	                scope.delay = args.delay;
	
	                var reposite = function() {
	                    var j = 0;
	                    var k = 0;
	                    var lastTop = startTop;
	                    var lastRight = startRight;
	                    var lastPosition = [];
	                    for(var i = messageElements.length - 1; i >= 0; i --) {
	                        var element  = messageElements[i];
	                        if (args.replaceMessage && i < messageElements.length - 1) {
	                            element.addClass('killed');
	                            continue;
	                        }
	                        var elHeight = parseInt(element[0].offsetHeight);
	                        var elWidth  = parseInt(element[0].offsetWidth);
	                        var position = lastPosition[element._positionY+element._positionX];
	
	                        if ((top + elHeight) > window.innerHeight) {
	                            position = startTop;
	                            k ++;
	                            j = 0;
	                        }
	
	                        var top = (lastTop = position ? (j === 0 ? position : position + verticalSpacing) : startTop);
	                        var right = lastRight + (k * (horizontalSpacing + elWidth));
	
	                        element.css(element._positionY, top + 'px');
	                        if (element._positionX == 'center') {
	                            element.css('left', parseInt(window.innerWidth / 2 - elWidth / 2) + 'px');
	                        } else {
	                            element.css(element._positionX, right + 'px');
	                        }
	
	                        lastPosition[element._positionY+element._positionX] = top + elHeight;
	
	                        j ++;
	                    }
	                };
	
	                var templateElement = $compile(template)(scope);
	                templateElement._positionY = args.positionY;
	                templateElement._positionX = args.positionX;
	                templateElement.addClass(args.type);
	                templateElement.bind('webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd click', function(e){
	                    e = e.originalEvent || e;
	                    if (e.type === 'click' || (e.propertyName === 'opacity' && e.elapsedTime >= 1)){
	                        templateElement.remove();
	                        messageElements.splice(messageElements.indexOf(templateElement), 1);
	                        reposite();
	                    }
	                });
	                if (angular.isNumber(args.delay)) {
	                    $timeout(function() {
	                        templateElement.addClass('killed');
	                    }, args.delay);
	                }
	
	                angular.element(document.getElementsByTagName('body')).append(templateElement);
	                var offset = -(parseInt(templateElement[0].offsetHeight) + 50);
	                templateElement.css(templateElement._positionY, offset + "px");
	                messageElements.push(templateElement);
	
	                scope._templateElement = templateElement;
	
	                scope.kill = function(isHard) {
	                    if (isHard) {
	                        messageElements.splice(messageElements.indexOf(scope._templateElement), 1);
	                        scope._templateElement.remove();
	                        $timeout(reposite);
	                    } else {
	                        scope._templateElement.addClass('killed');
	                    }
	                };
	
	                $timeout(reposite);
	
	                if (!isResizeBound) {
	                    angular.element($window).bind('resize', function(e) {
	                        $timeout(reposite);
	                    });
	                    isResizeBound = true;
	                }
	
	                deferred.resolve(scope);
	
	            }).error(function(data){
	                throw new Error('Template ('+args.template+') could not be loaded. ' + data);
	            });
	
	            return deferred.promise;
	        };
	
	        notify.primary = function(args) {
	            return this(args, 'primary');
	        };
	        notify.error = function(args) {
	            return this(args, 'error');
	        };
	        notify.success = function(args) {
	            return this(args, 'success');
	        };
	        notify.info = function(args) {
	            return this(args, 'info');
	        };
	        notify.warning = function(args) {
	            return this(args, 'warning');
	        };
	
	        notify.clearAll = function() {
	            angular.forEach(messageElements, function(element) {
	                element.addClass('killed');
	            });
	        };
	
	        return notify;
	    }];
	});
	
	angular.module("ui-notification").run(["$templateCache", function($templateCache) {$templateCache.put("angular-ui-notification.html","<div class=\"ui-notification\"><h3 ng-show=\"title\" ng-bind-html=\"title\"></h3><div class=\"message\" ng-bind-html=\"message\"></div></div>");}]);

/***/ },
/* 175 */
/***/ function(module, exports) {

	// author:   Samuel Mueller 
	// version: 1.0.7 
	// license:  MIT 
	// homepage: http://github.com/samu/angular-table 
	(function() {
	  var ColumnConfiguration, PageSequence, PaginatedSetup, ScopeConfigWrapper, Setup, StandardSetup, Table, TableConfiguration, configurationVariableNames, paginationTemplate,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };
	
	  angular.module("angular-table", []);
	
	  ColumnConfiguration = (function() {
	    function ColumnConfiguration(bodyMarkup, headerMarkup) {
	      this.attribute = bodyMarkup.attribute;
	      this.title = bodyMarkup.title;
	      this.sortable = bodyMarkup.sortable;
	      this.width = bodyMarkup.width;
	      this.initialSorting = bodyMarkup.initialSorting;
	      if (headerMarkup) {
	        this.customContent = headerMarkup.customContent;
	        this.attributes = headerMarkup.attributes;
	      }
	    }
	
	    ColumnConfiguration.prototype.createElement = function() {
	      var th;
	      return th = angular.element(document.createElement("th"));
	    };
	
	    ColumnConfiguration.prototype.renderTitle = function(element) {
	      return element.html(this.customContent || this.title);
	    };
	
	    ColumnConfiguration.prototype.renderAttributes = function(element) {
	      var attribute, _i, _len, _ref, _results;
	      if (this.customContent) {
	        _ref = this.attributes;
	        _results = [];
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          attribute = _ref[_i];
	          _results.push(element.attr(attribute.name, attribute.value));
	        }
	        return _results;
	      }
	    };
	
	    ColumnConfiguration.prototype.renderSorting = function(element) {
	      var icon;
	      if (this.sortable) {
	        element.attr("ng-click", "predicate = '" + this.attribute + "'; descending = !descending;");
	        icon = angular.element("<i style='margin-left: 10px;'></i>");
	        icon.attr("ng-class", "getSortIcon('" + this.attribute + "', predicate, descending)");
	        return element.append(icon);
	      }
	    };
	
	    ColumnConfiguration.prototype.renderWidth = function(element) {
	      return element.attr("width", this.width);
	    };
	
	    ColumnConfiguration.prototype.renderHtml = function() {
	      var th;
	      th = this.createElement();
	      this.renderTitle(th);
	      this.renderAttributes(th);
	      this.renderSorting(th);
	      this.renderWidth(th);
	      return th;
	    };
	
	    return ColumnConfiguration;
	
	  })();
	
	  configurationVariableNames = (function() {
	    function configurationVariableNames(configObjectName) {
	      this.configObjectName = configObjectName;
	      this.itemsPerPage = "" + this.configObjectName + ".itemsPerPage";
	      this.sortContext = "" + this.configObjectName + ".sortContext";
	      this.fillLastPage = "" + this.configObjectName + ".fillLastPage";
	      this.maxPages = "" + this.configObjectName + ".maxPages";
	      this.currentPage = "" + this.configObjectName + ".currentPage";
	      this.orderBy = "" + this.configObjectName + ".orderBy";
	      this.paginatorLabels = "" + this.configObjectName + ".paginatorLabels";
	    }
	
	    return configurationVariableNames;
	
	  })();
	
	  ScopeConfigWrapper = (function() {
	    function ScopeConfigWrapper(scope, configurationVariableNames, listName) {
	      this.scope = scope;
	      this.configurationVariableNames = configurationVariableNames;
	      this.listName = listName;
	    }
	
	    ScopeConfigWrapper.prototype.getList = function() {
	      return this.scope.$eval(this.listName);
	    };
	
	    ScopeConfigWrapper.prototype.getItemsPerPage = function() {
	      return this.scope.$eval(this.configurationVariableNames.itemsPerPage) || 10;
	    };
	
	    ScopeConfigWrapper.prototype.getCurrentPage = function() {
	      return this.scope.$eval(this.configurationVariableNames.currentPage) || 0;
	    };
	
	    ScopeConfigWrapper.prototype.getMaxPages = function() {
	      return this.scope.$eval(this.configurationVariableNames.maxPages) || void 0;
	    };
	
	    ScopeConfigWrapper.prototype.getSortContext = function() {
	      return this.scope.$eval(this.configurationVariableNames.sortContext) || 'global';
	    };
	
	    ScopeConfigWrapper.prototype.setCurrentPage = function(currentPage) {
	      return this.scope.$eval("" + this.configurationVariableNames.currentPage + "=" + currentPage);
	    };
	
	    ScopeConfigWrapper.prototype.getOrderBy = function() {
	      return this.scope.$eval(this.configurationVariableNames.orderBy) || 'orderBy';
	    };
	
	    ScopeConfigWrapper.prototype.getPaginatorLabels = function() {
	      var paginatorLabelsDefault;
	      paginatorLabelsDefault = {
	        stepBack: '‹',
	        stepAhead: '›',
	        jumpBack: '«',
	        jumpAhead: '»',
	        first: 'First',
	        last: 'Last'
	      };
	      return this.scope.$eval(this.configurationVariableNames.paginatorLabels) || paginatorLabelsDefault;
	    };
	
	    return ScopeConfigWrapper;
	
	  })();
	
	  TableConfiguration = (function() {
	    function TableConfiguration(tableElement, attributes) {
	      this.tableElement = tableElement;
	      this.attributes = attributes;
	      this.id = this.attributes.id;
	      this.config = this.attributes.atConfig;
	      this.paginated = this.attributes.atPaginated != null;
	      this.list = this.attributes.atList;
	      this.createColumnConfigurations();
	    }
	
	    TableConfiguration.prototype.capitaliseFirstLetter = function(string) {
	      if (string) {
	        return string.charAt(0).toUpperCase() + string.slice(1);
	      } else {
	        return "";
	      }
	    };
	
	    TableConfiguration.prototype.extractWidth = function(classes) {
	      var width;
	      width = /([0-9]+px)/i.exec(classes);
	      if (width) {
	        return width[0];
	      } else {
	        return "";
	      }
	    };
	
	    TableConfiguration.prototype.isSortable = function(classes) {
	      var sortable;
	      sortable = /(sortable)/i.exec(classes);
	      if (sortable) {
	        return true;
	      } else {
	        return false;
	      }
	    };
	
	    TableConfiguration.prototype.getInitialSorting = function(td) {
	      var initialSorting;
	      initialSorting = td.attr("at-initial-sorting");
	      if (initialSorting) {
	        if (initialSorting === "asc" || initialSorting === "desc") {
	          return initialSorting;
	        }
	        throw "Invalid value for initial-sorting: " + initialSorting + ". Allowed values are 'asc' or 'desc'.";
	      }
	      return void 0;
	    };
	
	    TableConfiguration.prototype.collectHeaderMarkup = function(table) {
	      var customHeaderMarkups, th, tr, _i, _len, _ref;
	      customHeaderMarkups = {};
	      tr = table.find("tr");
	      _ref = tr.find("th");
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        th = _ref[_i];
	        th = angular.element(th);
	        customHeaderMarkups[th.attr("at-attribute")] = {
	          customContent: th.html(),
	          attributes: th[0].attributes
	        };
	      }
	      return customHeaderMarkups;
	    };
	
	    TableConfiguration.prototype.collectBodyMarkup = function(table) {
	      var attribute, bodyDefinition, initialSorting, sortable, td, title, width, _i, _len, _ref;
	      bodyDefinition = [];
	      _ref = table.find("td");
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        td = _ref[_i];
	        td = angular.element(td);
	        attribute = td.attr("at-attribute");
	        title = td.attr("at-title") || this.capitaliseFirstLetter(td.attr("at-attribute"));
	        sortable = td.attr("at-sortable") !== void 0 || this.isSortable(td.attr("class"));
	        width = this.extractWidth(td.attr("class"));
	        initialSorting = this.getInitialSorting(td);
	        bodyDefinition.push({
	          attribute: attribute,
	          title: title,
	          sortable: sortable,
	          width: width,
	          initialSorting: initialSorting
	        });
	      }
	      return bodyDefinition;
	    };
	
	    TableConfiguration.prototype.createColumnConfigurations = function() {
	      var bodyMarkup, headerMarkup, i, _i, _len;
	      headerMarkup = this.collectHeaderMarkup(this.tableElement);
	      bodyMarkup = this.collectBodyMarkup(this.tableElement);
	      this.columnConfigurations = [];
	      for (_i = 0, _len = bodyMarkup.length; _i < _len; _i++) {
	        i = bodyMarkup[_i];
	        this.columnConfigurations.push(new ColumnConfiguration(i, headerMarkup[i.attribute]));
	      }
	    };
	
	    return TableConfiguration;
	
	  })();
	
	  Setup = (function() {
	    function Setup() {}
	
	    Setup.prototype.setupTr = function(element, repeatString) {
	      var tbody, tr;
	      tbody = element.find("tbody");
	      tr = tbody.find("tr");
	      tr.attr("ng-repeat", repeatString);
	      return tbody;
	    };
	
	    return Setup;
	
	  })();
	
	  StandardSetup = (function(_super) {
	    __extends(StandardSetup, _super);
	
	    function StandardSetup(configurationVariableNames, list) {
	      this.list = list;
	      this.repeatString = "item in " + this.list + " | orderBy:predicate:descending";
	    }
	
	    StandardSetup.prototype.compile = function(element, attributes, transclude) {
	      return this.setupTr(element, this.repeatString);
	    };
	
	    StandardSetup.prototype.link = function() {};
	
	    return StandardSetup;
	
	  })(Setup);
	
	  PaginatedSetup = (function(_super) {
	    __extends(PaginatedSetup, _super);
	
	    function PaginatedSetup(configurationVariableNames) {
	      this.configurationVariableNames = configurationVariableNames;
	      this.repeatString = "item in sortedAndPaginatedList";
	    }
	
	    PaginatedSetup.prototype.compile = function(element) {
	      var fillerTr, tbody, td, tdString, tds, _i, _len;
	      tbody = this.setupTr(element, this.repeatString);
	      tds = element.find("td");
	      tdString = "";
	      for (_i = 0, _len = tds.length; _i < _len; _i++) {
	        td = tds[_i];
	        tdString += "<td><span>&nbsp;</span></td>";
	      }
	      fillerTr = angular.element(document.createElement("tr"));
	      fillerTr.attr("ng-show", this.configurationVariableNames.fillLastPage);
	      fillerTr.html(tdString);
	      fillerTr.attr("ng-repeat", "item in fillerArray");
	      tbody.append(fillerTr);
	    };
	
	    PaginatedSetup.prototype.link = function($scope, $element, $attributes, $filter) {
	      var cvn, getFillerArray, getSortedAndPaginatedList, update, w;
	      cvn = this.configurationVariableNames;
	      w = new ScopeConfigWrapper($scope, cvn, $attributes.atList);
	      getSortedAndPaginatedList = function(list, currentPage, itemsPerPage, orderBy, sortContext, predicate, descending, $filter) {
	        var fromPage, val;
	        if (list) {
	          val = list;
	          fromPage = itemsPerPage * currentPage - list.length;
	          if (sortContext === "global") {
	            val = $filter(orderBy)(val, predicate, descending);
	            val = $filter("limitTo")(val, fromPage);
	            val = $filter("limitTo")(val, itemsPerPage);
	          } else {
	            val = $filter("limitTo")(val, fromPage);
	            val = $filter("limitTo")(val, itemsPerPage);
	            val = $filter(orderBy)(val, predicate, descending);
	          }
	          return val;
	        } else {
	          return [];
	        }
	      };
	      getFillerArray = function(list, currentPage, numberOfPages, itemsPerPage) {
	        var fillerLength, itemCountOnLastPage, x, _i, _j, _ref, _ref1, _ref2, _results, _results1;
	        itemsPerPage = parseInt(itemsPerPage);
	        if (list.length <= 0) {
	          _results = [];
	          for (x = _i = 0, _ref = itemsPerPage - 1; 0 <= _ref ? _i <= _ref : _i >= _ref; x = 0 <= _ref ? ++_i : --_i) {
	            _results.push(x);
	          }
	          return _results;
	        } else if (currentPage === numberOfPages - 1) {
	          itemCountOnLastPage = list.length % itemsPerPage;
	          if (itemCountOnLastPage !== 0) {
	            fillerLength = itemsPerPage - itemCountOnLastPage - 1;
	            _results1 = [];
	            for (x = _j = _ref1 = list.length, _ref2 = list.length + fillerLength; _ref1 <= _ref2 ? _j <= _ref2 : _j >= _ref2; x = _ref1 <= _ref2 ? ++_j : --_j) {
	              _results1.push(x);
	            }
	            return _results1;
	          } else {
	            return [];
	          }
	        }
	      };
	      update = function() {
	        var nop;
	        $scope.sortedAndPaginatedList = getSortedAndPaginatedList(w.getList(), w.getCurrentPage(), w.getItemsPerPage(), w.getOrderBy(), w.getSortContext(), $scope.predicate, $scope.descending, $filter);
	        nop = Math.ceil(w.getList().length / w.getItemsPerPage());
	        return $scope.fillerArray = getFillerArray(w.getList(), w.getCurrentPage(), nop, w.getItemsPerPage());
	      };
	      $scope.$watch(cvn.currentPage, function() {
	        return update();
	      });
	      $scope.$watch(cvn.itemsPerPage, function() {
	        return update();
	      });
	      $scope.$watch(cvn.sortContext, function() {
	        return update();
	      });
	      $scope.$watchCollection($attributes.atList, function() {
	        return update();
	      });
	      $scope.$watch("" + $attributes.atList + ".length", function() {
	        $scope.numberOfPages = Math.ceil(w.getList().length / w.getItemsPerPage());
	        return update();
	      });
	      $scope.$watch("predicate", function() {
	        return update();
	      });
	      return $scope.$watch("descending", function() {
	        return update();
	      });
	    };
	
	    return PaginatedSetup;
	
	  })(Setup);
	
	  Table = (function() {
	    function Table(element, tableConfiguration, configurationVariableNames) {
	      this.element = element;
	      this.tableConfiguration = tableConfiguration;
	      this.configurationVariableNames = configurationVariableNames;
	    }
	
	    Table.prototype.constructHeader = function() {
	      var i, tr, _i, _len, _ref;
	      tr = angular.element(document.createElement("tr"));
	      _ref = this.tableConfiguration.columnConfigurations;
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        i = _ref[_i];
	        tr.append(i.renderHtml());
	      }
	      return tr;
	    };
	
	    Table.prototype.setupHeader = function() {
	      var header, thead, tr;
	      thead = this.element.find("thead");
	      if (thead) {
	        header = this.constructHeader();
	        tr = angular.element(thead).find("tr");
	        tr.remove();
	        return thead.append(header);
	      }
	    };
	
	    Table.prototype.getSetup = function() {
	      if (this.tableConfiguration.paginated) {
	        return new PaginatedSetup(this.configurationVariableNames);
	      } else {
	        return new StandardSetup(this.configurationVariableNames, this.tableConfiguration.list);
	      }
	    };
	
	    Table.prototype.compile = function() {
	      this.setupHeader();
	      this.setup = this.getSetup();
	      return this.setup.compile(this.element);
	    };
	
	    Table.prototype.setupInitialSorting = function($scope) {
	      var bd, _i, _len, _ref, _results;
	      _ref = this.tableConfiguration.columnConfigurations;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        bd = _ref[_i];
	        if (bd.initialSorting) {
	          if (!bd.attribute) {
	            throw "initial-sorting specified without attribute.";
	          }
	          $scope.predicate = bd.attribute;
	          _results.push($scope.descending = bd.initialSorting === "desc");
	        } else {
	          _results.push(void 0);
	        }
	      }
	      return _results;
	    };
	
	    Table.prototype.post = function($scope, $element, $attributes, $filter) {
	      this.setupInitialSorting($scope);
	      if (!$scope.getSortIcon) {
	        $scope.getSortIcon = function(predicate, currentPredicate, descending) {
	          if (predicate !== $scope.predicate) {
	            return "glyphicon glyphicon-minus";
	          }
	          if (descending) {
	            return "glyphicon glyphicon-chevron-down";
	          } else {
	            return "glyphicon glyphicon-chevron-up";
	          }
	        };
	      }
	      return this.setup.link($scope, $element, $attributes, $filter);
	    };
	
	    return Table;
	
	  })();
	
	  PageSequence = (function() {
	    function PageSequence(lowerBound, upperBound, start, length) {
	      this.lowerBound = lowerBound != null ? lowerBound : 0;
	      this.upperBound = upperBound != null ? upperBound : 1;
	      if (start == null) {
	        start = 0;
	      }
	      this.length = length != null ? length : 1;
	      if (this.length > (this.upperBound - this.lowerBound)) {
	        throw "sequence is too long";
	      }
	      this.data = this.generate(start);
	    }
	
	    PageSequence.prototype.generate = function(start) {
	      var x, _i, _ref, _results;
	      if (start > (this.upperBound - this.length)) {
	        start = this.upperBound - this.length;
	      } else if (start < this.lowerBound) {
	        start = this.lowerBound;
	      }
	      _results = [];
	      for (x = _i = start, _ref = parseInt(start) + parseInt(this.length) - 1; start <= _ref ? _i <= _ref : _i >= _ref; x = start <= _ref ? ++_i : --_i) {
	        _results.push(x);
	      }
	      return _results;
	    };
	
	    PageSequence.prototype.resetParameters = function(lowerBound, upperBound, length) {
	      this.lowerBound = lowerBound;
	      this.upperBound = upperBound;
	      this.length = length;
	      if (this.length > (this.upperBound - this.lowerBound)) {
	        throw "sequence is too long";
	      }
	      return this.data = this.generate(this.data[0]);
	    };
	
	    PageSequence.prototype.relocate = function(distance) {
	      var newStart;
	      newStart = this.data[0] + distance;
	      return this.data = this.generate(newStart, newStart + this.length);
	    };
	
	    PageSequence.prototype.realignGreedy = function(page) {
	      var newStart;
	      if (page < this.data[0]) {
	        newStart = page;
	        return this.data = this.generate(newStart);
	      } else if (page > this.data[this.length - 1]) {
	        newStart = page - (this.length - 1);
	        return this.data = this.generate(newStart);
	      }
	    };
	
	    PageSequence.prototype.realignGenerous = function(page) {};
	
	    return PageSequence;
	
	  })();
	
	  paginationTemplate = "<div style='margin: 0px;'> <ul class='pagination'> <li ng-class='{disabled: getCurrentPage() <= 0}'> <a href='' ng-click='stepPage(-numberOfPages)'>{{getPaginatorLabels().first}}</a> </li> <li ng-show='showSectioning()' ng-class='{disabled: getCurrentPage() <= 0}'> <a href='' ng-click='jumpBack()'>{{getPaginatorLabels().jumpBack}}</a> </li> <li ng-class='{disabled: getCurrentPage() <= 0}'> <a href='' ng-click='stepPage(-1)'>{{getPaginatorLabels().stepBack}}</a> </li> <li ng-class='{active: getCurrentPage() == page}' ng-repeat='page in pageSequence.data'> <a href='' ng-click='goToPage(page)' ng-bind='page + 1'></a> </li> <li ng-class='{disabled: getCurrentPage() >= numberOfPages - 1}'> <a href='' ng-click='stepPage(1)'>{{getPaginatorLabels().stepAhead}}</a> </li> <li ng-show='showSectioning()' ng-class='{disabled: getCurrentPage() >= numberOfPages - 1}'> <a href='' ng-click='jumpAhead()'>{{getPaginatorLabels().jumpAhead}}</a> </li> <li ng-class='{disabled: getCurrentPage() >= numberOfPages - 1}'> <a href='' ng-click='stepPage(numberOfPages)'>{{getPaginatorLabels().last}}</a> </li> </ul> </div>";
	
	  angular.module("angular-table").directive("atTable", [
	    "$filter", function($filter) {
	      return {
	        restrict: "AC",
	        scope: true,
	        compile: function(element, attributes, transclude) {
	          var cvn, table, tc;
	          tc = new TableConfiguration(element, attributes);
	          cvn = new configurationVariableNames(attributes.atConfig);
	          table = new Table(element, tc, cvn);
	          table.compile();
	          return {
	            post: function($scope, $element, $attributes) {
	              return table.post($scope, $element, $attributes, $filter);
	            }
	          };
	        }
	      };
	    }
	  ]);
	
	  angular.module("angular-table").directive("atPagination", [
	    function() {
	      return {
	        restrict: "E",
	        scope: true,
	        replace: true,
	        template: paginationTemplate,
	        link: function($scope, $element, $attributes) {
	          var cvn, getNumberOfPages, keepInBounds, setNumberOfPages, update, w;
	          cvn = new configurationVariableNames($attributes.atConfig);
	          w = new ScopeConfigWrapper($scope, cvn, $attributes.atList);
	          keepInBounds = function(val, min, max) {
	            val = Math.max(min, val);
	            return Math.min(max, val);
	          };
	          getNumberOfPages = function() {
	            return $scope.numberOfPages;
	          };
	          setNumberOfPages = function(numberOfPages) {
	            return $scope.numberOfPages = numberOfPages;
	          };
	          update = function(reset) {
	            var newNumberOfPages, pagesToDisplay;
	            if (w.getList()) {
	              if (w.getList().length > 0) {
	                newNumberOfPages = Math.ceil(w.getList().length / w.getItemsPerPage());
	                setNumberOfPages(newNumberOfPages);
	                if ($scope.showSectioning()) {
	                  pagesToDisplay = w.getMaxPages();
	                } else {
	                  pagesToDisplay = newNumberOfPages;
	                }
	                $scope.pageSequence.resetParameters(0, newNumberOfPages, pagesToDisplay);
	                w.setCurrentPage(keepInBounds(w.getCurrentPage(), 0, getNumberOfPages() - 1));
	                return $scope.pageSequence.realignGreedy(w.getCurrentPage());
	              } else {
	                setNumberOfPages(1);
	                $scope.pageSequence.resetParameters(0, 1, 1);
	                w.setCurrentPage(0);
	                return $scope.pageSequence.realignGreedy(0);
	              }
	            }
	          };
	          $scope.showSectioning = function() {
	            return w.getMaxPages() && getNumberOfPages() > w.getMaxPages();
	          };
	          $scope.getCurrentPage = function() {
	            return w.getCurrentPage();
	          };
	          $scope.getPaginatorLabels = function() {
	            return w.getPaginatorLabels();
	          };
	          $scope.stepPage = function(step) {
	            step = parseInt(step);
	            w.setCurrentPage(keepInBounds(w.getCurrentPage() + step, 0, getNumberOfPages() - 1));
	            return $scope.pageSequence.realignGreedy(w.getCurrentPage());
	          };
	          $scope.goToPage = function(page) {
	            return w.setCurrentPage(page);
	          };
	          $scope.jumpBack = function() {
	            return $scope.stepPage(-w.getMaxPages());
	          };
	          $scope.jumpAhead = function() {
	            return $scope.stepPage(w.getMaxPages());
	          };
	          $scope.pageSequence = new PageSequence();
	          $scope.$watch(cvn.itemsPerPage, function() {
	            return update();
	          });
	          $scope.$watch(cvn.maxPages, function() {
	            return update();
	          });
	          $scope.$watch($attributes.atList, function() {
	            return update();
	          });
	          $scope.$watch("" + $attributes.atList + ".length", function() {
	            return update();
	          });
	          return update();
	        }
	      };
	    }
	  ]);
	
	  angular.module("angular-table").directive("atImplicit", [
	    function() {
	      return {
	        restrict: "AC",
	        compile: function(element, attributes, transclude) {
	          var attribute;
	          attribute = element.attr("at-attribute");
	          if (!attribute) {
	            throw "at-implicit specified without at-attribute: " + (element.html());
	          }
	          return element.append("<span ng-bind='item." + attribute + "'></span>");
	        }
	      };
	    }
	  ]);
	
	}).call(this);


/***/ },
/* 176 */,
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 21,
		"./af.js": 21,
		"./ar": 25,
		"./ar-ma": 22,
		"./ar-ma.js": 22,
		"./ar-sa": 23,
		"./ar-sa.js": 23,
		"./ar-tn": 24,
		"./ar-tn.js": 24,
		"./ar.js": 25,
		"./az": 26,
		"./az.js": 26,
		"./be": 27,
		"./be.js": 27,
		"./bg": 28,
		"./bg.js": 28,
		"./bn": 29,
		"./bn.js": 29,
		"./bo": 30,
		"./bo.js": 30,
		"./br": 31,
		"./br.js": 31,
		"./bs": 32,
		"./bs.js": 32,
		"./ca": 33,
		"./ca.js": 33,
		"./cs": 34,
		"./cs.js": 34,
		"./cv": 35,
		"./cv.js": 35,
		"./cy": 36,
		"./cy.js": 36,
		"./da": 37,
		"./da.js": 37,
		"./de": 39,
		"./de-at": 38,
		"./de-at.js": 38,
		"./de.js": 39,
		"./el": 40,
		"./el.js": 40,
		"./en-au": 41,
		"./en-au.js": 41,
		"./en-ca": 42,
		"./en-ca.js": 42,
		"./en-gb": 43,
		"./en-gb.js": 43,
		"./eo": 44,
		"./eo.js": 44,
		"./es": 45,
		"./es.js": 45,
		"./et": 46,
		"./et.js": 46,
		"./eu": 47,
		"./eu.js": 47,
		"./fa": 48,
		"./fa.js": 48,
		"./fi": 49,
		"./fi.js": 49,
		"./fo": 50,
		"./fo.js": 50,
		"./fr": 52,
		"./fr-ca": 51,
		"./fr-ca.js": 51,
		"./fr.js": 52,
		"./fy": 53,
		"./fy.js": 53,
		"./gl": 54,
		"./gl.js": 54,
		"./he": 55,
		"./he.js": 55,
		"./hi": 56,
		"./hi.js": 56,
		"./hr": 57,
		"./hr.js": 57,
		"./hu": 58,
		"./hu.js": 58,
		"./hy-am": 59,
		"./hy-am.js": 59,
		"./id": 60,
		"./id.js": 60,
		"./is": 61,
		"./is.js": 61,
		"./it": 62,
		"./it.js": 62,
		"./ja": 63,
		"./ja.js": 63,
		"./jv": 64,
		"./jv.js": 64,
		"./ka": 65,
		"./ka.js": 65,
		"./km": 66,
		"./km.js": 66,
		"./ko": 67,
		"./ko.js": 67,
		"./lb": 68,
		"./lb.js": 68,
		"./lt": 69,
		"./lt.js": 69,
		"./lv": 70,
		"./lv.js": 70,
		"./me": 71,
		"./me.js": 71,
		"./mk": 72,
		"./mk.js": 72,
		"./ml": 73,
		"./ml.js": 73,
		"./mr": 74,
		"./mr.js": 74,
		"./ms": 76,
		"./ms-my": 75,
		"./ms-my.js": 75,
		"./ms.js": 76,
		"./my": 77,
		"./my.js": 77,
		"./nb": 78,
		"./nb.js": 78,
		"./ne": 79,
		"./ne.js": 79,
		"./nl": 80,
		"./nl.js": 80,
		"./nn": 81,
		"./nn.js": 81,
		"./pl": 82,
		"./pl.js": 82,
		"./pt": 84,
		"./pt-br": 83,
		"./pt-br.js": 83,
		"./pt.js": 84,
		"./ro": 85,
		"./ro.js": 85,
		"./ru": 86,
		"./ru.js": 86,
		"./si": 87,
		"./si.js": 87,
		"./sk": 88,
		"./sk.js": 88,
		"./sl": 89,
		"./sl.js": 89,
		"./sq": 90,
		"./sq.js": 90,
		"./sr": 92,
		"./sr-cyrl": 91,
		"./sr-cyrl.js": 91,
		"./sr.js": 92,
		"./sv": 93,
		"./sv.js": 93,
		"./ta": 94,
		"./ta.js": 94,
		"./th": 95,
		"./th.js": 95,
		"./tl-ph": 96,
		"./tl-ph.js": 96,
		"./tr": 97,
		"./tr.js": 97,
		"./tzl": 98,
		"./tzl.js": 98,
		"./tzm": 100,
		"./tzm-latn": 99,
		"./tzm-latn.js": 99,
		"./tzm.js": 100,
		"./uk": 101,
		"./uk.js": 101,
		"./uz": 102,
		"./uz.js": 102,
		"./vi": 103,
		"./vi.js": 103,
		"./zh-cn": 104,
		"./zh-cn.js": 104,
		"./zh-tw": 105,
		"./zh-tw.js": 105
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 177;


/***/ },
/* 178 */
/***/ function(module, exports) {

	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 10.0.4
	 */
	
	if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
	  window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
	    return function (header, value) {
	      if (header === '__setXHR_') {
	        var val = value(this);
	        // fix for angular < 1.2.0
	        if (val instanceof Function) {
	          val(this);
	        }
	      } else {
	        orig.apply(this, arguments);
	      }
	    };
	  })(window.XMLHttpRequest.prototype.setRequestHeader);
	}
	
	var ngFileUpload = angular.module('ngFileUpload', []);
	
	ngFileUpload.version = '10.0.4';
	
	ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  var upload = this;
	
	  this.isResumeSupported = function () {
	    return window.Blob && (Blob instanceof Function) && new Blob().slice;
	  };
	
	  var resumeSupported = this.isResumeSupported();
	
	  function sendHttp(config) {
	    config.method = config.method || 'POST';
	    config.headers = config.headers || {};
	
	    var deferred = config._deferred = config._deferred || $q.defer();
	    var promise = deferred.promise;
	
	    function notifyProgress(e) {
	      if (deferred.notify) {
	        deferred.notify(e);
	      }
	      if (promise.progressFunc) {
	        $timeout(function () {
	          promise.progressFunc(e);
	        });
	      }
	    }
	
	    function getNotifyEvent(n) {
	      if (config._start != null && resumeSupported) {
	        return {
	          loaded: n.loaded + config._start, total: config._file.size, type: n.type, config: config,
	          lengthComputable: true, target: n.target
	        };
	      } else {
	        return n;
	      }
	    }
	
	    if (!config.disableProgress) {
	      config.headers.__setXHR_ = function () {
	        return function (xhr) {
	          if (!xhr || !(xhr instanceof XMLHttpRequest)) return;
	          config.__XHR = xhr;
	          if (config.xhrFn) config.xhrFn(xhr);
	          xhr.upload.addEventListener('progress', function (e) {
	            e.config = config;
	            notifyProgress(getNotifyEvent(e));
	          }, false);
	          //fix for firefox not firing upload progress end, also IE8-9
	          xhr.upload.addEventListener('load', function (e) {
	            if (e.lengthComputable) {
	              e.config = config;
	              notifyProgress(getNotifyEvent(e));
	            }
	          }, false);
	        };
	      };
	    }
	
	    function uploadWithAngular() {
	      $http(config).then(function (r) {
	        if (resumeSupported && config._chunkSize && !config._finished) {
	          notifyProgress({loaded: config._end, total: config._file.size, config: config, type: 'progress'});
	          upload.upload(config);
	        } else {
	          if (config._finished) delete config._finished;
	          deferred.resolve(r);
	        }
	      }, function (e) {
	        deferred.reject(e);
	      }, function (n) {
	        deferred.notify(n);
	      });
	    }
	
	    if (!resumeSupported) {
	      uploadWithAngular();
	    } else if (config._chunkSize && config._end && !config._finished) {
	      config._start = config._end;
	      config._end += config._chunkSize;
	      uploadWithAngular();
	    } else if (config.resumeSizeUrl) {
	      $http.get(config.resumeSizeUrl).then(function (resp) {
	        if (config.resumeSizeResponseReader) {
	          config._start = config.resumeSizeResponseReader(resp.data);
	        } else {
	          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
	        }
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else if (config.resumeSize) {
	      config.resumeSize().then(function (size) {
	        config._start = size;
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else {
	      uploadWithAngular();
	    }
	
	
	    promise.success = function (fn) {
	      promise.then(function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.error = function (fn) {
	      promise.then(null, function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.progress = function (fn) {
	      promise.progressFunc = fn;
	      promise.then(null, null, function (n) {
	        fn(n);
	      });
	      return promise;
	    };
	    promise.abort = promise.pause = function () {
	      if (config.__XHR) {
	        $timeout(function () {
	          config.__XHR.abort();
	        });
	      }
	      return promise;
	    };
	    promise.xhr = function (fn) {
	      config.xhrFn = (function (origXhrFn) {
	        return function () {
	          if (origXhrFn) origXhrFn.apply(promise, arguments);
	          fn.apply(promise, arguments);
	        };
	      })(config.xhrFn);
	      return promise;
	    };
	
	    return promise;
	  }
	
	  this.rename = function (file, name) {
	    file.ngfName = name;
	    return file;
	  };
	
	  this.jsonBlob = function (val) {
	    if (val != null && !angular.isString(val)) {
	      val = JSON.stringify(val);
	    }
	    var blob = new Blob([val], {type: 'application/json'});
	    blob._ngfBlob = true;
	    return blob;
	  };
	
	  this.json = function (val) {
	    return angular.toJson(val);
	  };
	
	  this.upload = function (config) {
	    function isFile(file) {
	      return file != null && (file instanceof Blob || (file.flashId && file.name && file.size));
	    }
	
	    function toResumeFile(file, formData) {
	      if (file._ngfBlob) return file;
	      config._file = config._file || file;
	      if (config._start != null && resumeSupported) {
	        if (config._end && config._end >= file.size) {
	          config._finished = true;
	          config._end = file.size;
	        }
	        var slice = file.slice(config._start, config._end || file.size);
	        slice.name = file.name;
	        slice.ngfName = file.ngfName;
	        if (config._chunkSize) {
	          formData.append('_chunkSize', config._end - config._start);
	          formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
	          formData.append('_totalSize', config._file.size);
	        }
	        return slice;
	      }
	      return file;
	    }
	
	    function addFieldToFormData(formData, val, key) {
	      if (val !== undefined) {
	        if (angular.isDate(val)) {
	          val = val.toISOString();
	        }
	        if (angular.isString(val)) {
	          formData.append(key, val);
	        } else if (isFile(val)) {
	          var file = toResumeFile(val, formData);
	          var split = key.split(',');
	          if (split[1]) {
	            file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
	            key = split[0];
	          }
	          config._fileKey = config._fileKey || key;
	          formData.append(key, file, file.ngfName || file.name);
	        } else {
	          if (angular.isObject(val)) {
	            if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;
	
	            val.$$ngfCircularDetection = true;
	            try {
	              for (var k in val) {
	                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
	                  var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
	                  if (val.length && parseInt(k) > -1) {
	                    objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
	                  }
	                  addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
	                }
	              }
	            } finally {
	              delete val.$$ngfCircularDetection;
	            }
	          } else {
	            formData.append(key, val);
	          }
	        }
	      }
	    }
	
	    function digestConfig() {
	      config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	      config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	      config.headers = config.headers || {};
	      config.headers['Content-Type'] = undefined;
	      config.transformRequest = config.transformRequest ?
	        (angular.isArray(config.transformRequest) ?
	          config.transformRequest : [config.transformRequest]) : [];
	      config.transformRequest.push(function (data) {
	        var formData = new FormData(), key;
	        data = data || config.fields || {};
	        if (config.file) {
	          data.file = config.file;
	        }
	        for (key in data) {
	          if (data.hasOwnProperty(key)) {
	            var val = data[key];
	            if (config.formDataAppender) {
	              config.formDataAppender(formData, key, val);
	            } else {
	              addFieldToFormData(formData, val, key);
	            }
	          }
	        }
	
	        return formData;
	      });
	    }
	
	    if (!config._isDigested) {
	      config._isDigested = true;
	      digestConfig();
	    }
	
	    return sendHttp(config);
	  };
	
	  this.http = function (config) {
	    config.transformRequest = config.transformRequest || function (data) {
	        if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof Blob) {
	          return data;
	        }
	        return $http.defaults.transformRequest[0].apply(this, arguments);
	      };
	    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	    return sendHttp(config);
	  };
	
	  this.translateScalars = function (str) {
	    if (angular.isString(str)) {
	      if (str.search(/kb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1000);
	      } else if (str.search(/mb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1000000);
	      } else if (str.search(/gb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1000000000);
	      } else if (str.search(/b/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/s/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/m/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 60);
	      } else if (str.search(/h/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 3600);
	      }
	    }
	    return str;
	  };
	
	  this.setDefaults = function (defaults) {
	    this.defaults = defaults || {};
	  };
	
	  this.defaults = {};
	  this.version = ngFileUpload.version;
	}
	
	]);
	
	ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
	  var upload = UploadExif;
	  upload.getAttrWithDefaults = function (attr, name) {
	    if (attr[name] != null) return attr[name];
	    var def = upload.defaults[name];
	    return (def == null ? def : (angular.isString(def) ? def : JSON.stringify(def)));
	  };
	
	  upload.attrGetter = function (name, attr, scope, params) {
	    var attrVal = this.getAttrWithDefaults(attr, name);
	    if (scope) {
	      try {
	        if (params) {
	          return $parse(attrVal)(scope, params);
	        } else {
	          return $parse(attrVal)(scope);
	        }
	      } catch (e) {
	        // hangle string value without single qoute
	        if (name.search(/min|max|pattern/i)) {
	          return attrVal;
	        } else {
	          throw e;
	        }
	      }
	    } else {
	      return attrVal;
	    }
	  };
	
	  upload.shouldUpdateOn = function (type, attr, scope) {
	    var modelOptions = upload.attrGetter('ngModelOptions', attr, scope);
	    if (modelOptions && modelOptions.updateOn) {
	      return modelOptions.updateOn.split(' ').indexOf(type) > -1;
	    }
	    return true;
	  };
	
	  upload.emptyPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.resolve.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.happyPromise = function (promise, data) {
	    var d = $q.defer();
	    promise.then(function (result) {
	      d.resolve(result);
	    }, function (error) {
	      $timeout(function () {
	        throw error;
	      });
	      d.resolve(data);
	    });
	    return d.promise;
	  };
	
	  function applyExifRotations(files, attr, scope) {
	    var promises = [upload.emptyPromise()];
	    angular.forEach(files, function (f, i) {
	      if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, {$file: f})) {
	        promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
	          files.splice(i, 1, fixedFile);
	        }));
	      }
	    });
	    return $q.all(promises);
	  }
	
	  function resize(files, attr, scope) {
	    var param = upload.attrGetter('ngfResize', attr, scope);
	    if (!param || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
	    var promises = [upload.emptyPromise()];
	    angular.forEach(files, function (f, i) {
	      if (f.type.indexOf('image') === 0) {
	        if (param.pattern && !upload.validatePattern(f, param.pattern)) return;
	        var promise = upload.resize(f, param.width, param.height, param.quality, param.type);
	        promises.push(promise);
	        promise.then(function (resizedFile) {
	          files.splice(i, 1, resizedFile);
	        }, function (e) {
	          f.$error = 'resize';
	          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
	        });
	      }
	    });
	    return $q.all(promises);
	  }
	
	  function handleKeep(files, prevFiles, attr, scope) {
	    var dupFiles = [];
	    var keep = upload.attrGetter('ngfKeep', attr, scope);
	    if (keep) {
	      var hasNew = false;
	
	      if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
	        var len = prevFiles.length;
	        if (files) {
	          for (var i = 0; i < files.length; i++) {
	            for (var j = 0; j < len; j++) {
	              if (files[i].name === prevFiles[j].name) {
	                dupFiles.push(files[i]);
	                break;
	              }
	            }
	            if (j === len) {
	              prevFiles.push(files[i]);
	              hasNew = true;
	            }
	          }
	        }
	        files = prevFiles;
	      } else {
	        files = prevFiles.concat(files || []);
	      }
	    }
	    return {files: files, dupFiles: dupFiles, keep: keep};
	  }
	
	  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
	    function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
	      var file = files && files.length ? files[0] : null;
	
	      if (ngModel) {
	        upload.applyModelValidation(ngModel, files);
	        ngModel.$ngfModelChange = true;
	        ngModel.$setViewValue(isSingleModel ? file : files);
	      }
	
	      if (fileChange) {
	        $parse(fileChange)(scope, {
	          $files: files,
	          $file: file,
	          $newFiles: newFiles,
	          $duplicateFiles: dupFiles,
	          $invalidFiles: invalidFiles,
	          $event: evt
	        });
	      }
	
	      var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
	      if (invalidModel) {
	        $timeout(function () {
	          $parse(invalidModel).assign(scope, invalidFiles);
	        });
	      }
	      $timeout(function () {
	        // scope apply changes
	      });
	    }
	
	    var newFiles = files;
	    var prevFiles = ngModel && ngModel.$modelValue && (angular.isArray(ngModel.$modelValue) ?
	        ngModel.$modelValue : [ngModel.$modelValue]);
	    prevFiles = (prevFiles || attr.$$ngfPrevFiles || []).slice(0);
	    var keepResult = handleKeep(files, prevFiles, attr, scope);
	    files = keepResult.files;
	    var dupFiles = keepResult.dupFiles;
	    var isSingleModel = !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr) && !keepResult.keep;
	
	    attr.$$ngfPrevFiles = files;
	
	    if (keepResult.keep && (!newFiles || !newFiles.length)) return;
	
	    upload.validate(newFiles, ngModel, attr, scope).then(function () {
	      if (noDelay) {
	        update(files, [], newFiles, dupFiles, isSingleModel);
	      } else {
	        var options = upload.attrGetter('ngModelOptions', attr, scope);
	        if (!options || !options.allowInvalid) {
	          var valids = [], invalids = [];
	          angular.forEach(files, function (file) {
	            if (file.$error) {
	              invalids.push(file);
	            } else {
	              valids.push(file);
	            }
	          });
	          files = valids;
	        }
	        var fixOrientation = upload.emptyPromise(files);
	        if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
	          fixOrientation = applyExifRotations(files, attr, scope);
	        }
	        fixOrientation.then(function () {
	          resize(files, attr, scope).then(function () {
	            $timeout(function () {
	              update(files, invalids, newFiles, dupFiles, isSingleModel);
	            }, options && options.debounce ? options.debounce.change || options.debounce : 0);
	          }, function (e) {
	            throw 'Could not resize files ' + e;
	          });
	        });
	      }
	    });
	
	    // cleaning object url memories
	    var l = prevFiles.length;
	    while (l--) {
	      var prevFile = prevFiles[l];
	      if (window.URL && prevFile.blobUrl) {
	        URL.revokeObjectURL(prevFile.blobUrl);
	        delete prevFile.blobUrl;
	      }
	    }
	  };
	
	  return upload;
	}]);
	
	ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
	  var generatedElems = [];
	
	  function isDelayedClickSupported(ua) {
	    // fix for android native browser < 4.4 and safari windows
	    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
	    if (m && m.length > 2) {
	      var v = Upload.defaults.androidFixMinorVersion || 4;
	      return parseInt(m[1]) < 4 || (parseInt(m[1]) === v && parseInt(m[2]) < v);
	    }
	
	    // safari on windows
	    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
	  }
	
	  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
	    /** @namespace attr.ngfSelect */
	    /** @namespace attr.ngfChange */
	    /** @namespace attr.ngModel */
	    /** @namespace attr.ngModelOptions */
	    /** @namespace attr.ngfMultiple */
	    /** @namespace attr.ngfCapture */
	    /** @namespace attr.ngfValidate */
	    /** @namespace attr.ngfKeep */
	    var attrGetter = function (name, scope) {
	      return upload.attrGetter(name, attr, scope);
	    };
	
	    function isInputTypeFile() {
	      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
	    }
	
	    function fileChangeAttr() {
	      return attrGetter('ngfChange') || attrGetter('ngfSelect');
	    }
	
	    function changeFn(evt) {
	      if (upload.shouldUpdateOn('change', attr, scope)) {
	        var fileList = evt.__files_ || (evt.target && evt.target.files), files = [];
	        for (var i = 0; i < fileList.length; i++) {
	          files.push(fileList[i]);
	        }
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(),
	          files.length ? files : null, evt);
	      }
	    }
	
	    upload.registerModelChangeValidator(ngModel, attr, scope);
	
	    var unwatches = [];
	    unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
	      fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
	    }));
	    unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
	      fileElem.attr('capture', attrGetter('ngfCapture', scope));
	    }));
	    attr.$observe('accept', function () {
	      fileElem.attr('accept', attrGetter('accept'));
	    });
	    unwatches.push(function () {
	      if (attr.$$observers) delete attr.$$observers.accept;
	    });
	    function bindAttrToFileInput(fileElem) {
	      if (elem !== fileElem) {
	        for (var i = 0; i < elem[0].attributes.length; i++) {
	          var attribute = elem[0].attributes[i];
	          if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
	            if (attribute.value == null || attribute.value === '') {
	              if (attribute.name === 'required') attribute.value = 'required';
	              if (attribute.name === 'multiple') attribute.value = 'multiple';
	            }
	            fileElem.attr(attribute.name, attribute.name === 'id' ? 'ngf-' + attribute.value : attribute.value);
	          }
	        }
	      }
	    }
	
	    function createFileInput() {
	      if (isInputTypeFile()) {
	        return elem;
	      }
	
	      var fileElem = angular.element('<input type="file">');
	      bindAttrToFileInput(fileElem);
	
	      fileElem.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
	        .css('width', '0px').css('height', '0px').css('border', 'none')
	        .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
	      generatedElems.push({el: elem, ref: fileElem});
	      document.body.appendChild(fileElem[0]);
	
	      return fileElem;
	    }
	
	    var initialTouchStartY = 0;
	
	    function clickHandler(evt) {
	      if (elem.attr('disabled') || attrGetter('ngfSelectDisabled', scope)) return false;
	
	      var r = handleTouch(evt);
	      if (r != null) return r;
	
	      resetModel(evt);
	
	      // fix for md when the element is removed from the DOM and added back #460
	      try {
	        if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
	          generatedElems.push({el: elem, ref: fileElem});
	          document.body.appendChild(fileElem[0]);
	          fileElem.bind('change', changeFn);
	        }
	      } catch(e){/*ignore*/}
	
	      if (isDelayedClickSupported(navigator.userAgent)) {
	        setTimeout(function () {
	          fileElem[0].click();
	        }, 0);
	      } else {
	        fileElem[0].click();
	      }
	
	      return false;
	    }
	
	    function handleTouch(evt) {
	      var touches = evt.changedTouches || (evt.originalEvent && evt.originalEvent.changedTouches);
	      if (evt.type === 'touchstart') {
	        initialTouchStartY = touches ? touches[0].clientY : 0;
	        return true; // don't block event default
	      } else {
	        evt.stopPropagation();
	        evt.preventDefault();
	
	        // prevent scroll from triggering event
	        if (evt.type === 'touchend') {
	          var currentLocation = touches ? touches[0].clientY : 0;
	          if (Math.abs(currentLocation - initialTouchStartY) > 20) return false;
	        }
	      }
	    }
	
	    var fileElem = elem;
	
	    function resetModel(evt) {
	      if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
	        fileElem.val(null);
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
	      }
	    }
	
	    if (!isInputTypeFile()) {
	      fileElem = createFileInput();
	    }
	    fileElem.bind('change', changeFn);
	
	    if (!isInputTypeFile()) {
	      elem.bind('click touchstart touchend', clickHandler);
	    } else {
	      elem.bind('click', resetModel);
	    }
	
	    function ie10SameFileSelectFix(evt) {
	      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
	        if (!fileElem[0].parentNode) {
	          fileElem = null;
	          return;
	        }
	        evt.preventDefault();
	        evt.stopPropagation();
	        fileElem.unbind('click');
	        var clone = fileElem.clone();
	        fileElem.replaceWith(clone);
	        fileElem = clone;
	        fileElem.attr('__ngf_ie10_Fix_', 'true');
	        fileElem.bind('change', changeFn);
	        fileElem.bind('click', ie10SameFileSelectFix);
	        fileElem[0].click();
	        return false;
	      } else {
	        fileElem.removeAttr('__ngf_ie10_Fix_');
	      }
	    }
	
	    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
	      fileElem.bind('click', ie10SameFileSelectFix);
	    }
	
	    if (ngModel) ngModel.$formatters.push(function (val) {
	      if (val == null || val.length === 0) {
	        if (fileElem.val()) {
	          fileElem.val(null);
	        }
	      }
	      return val;
	    });
	
	    scope.$on('$destroy', function () {
	      if (!isInputTypeFile()) fileElem.remove();
	      angular.forEach(unwatches, function (unwatch) {
	        unwatch();
	      });
	    });
	
	    $timeout(function () {
	      for (var i = 0; i < generatedElems.length; i++) {
	        var g = generatedElems[i];
	        if (!document.body.contains(g.el[0])) {
	          generatedElems.splice(i, 1);
	          g.ref.remove();
	        }
	      }
	    });
	
	    if (window.FileAPI && window.FileAPI.ngfFixIE) {
	      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
	    }
	  }
	
	  return {
	    restrict: 'AEC',
	    require: '?ngModel',
	    link: function (scope, elem, attr, ngModel) {
	      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
	    }
	  };
	}]);
	
	(function () {
	
	  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
	    var upload = UploadBase;
	    upload.base64DataUrl = function (file) {
	      if (angular.isArray(file)) {
	        var d = $q.defer(), count = 0;
	        angular.forEach(file, function (f) {
	          upload.dataUrl(f, true)['finally'](function () {
	            count++;
	            if (count === file.length) {
	              var urls = [];
	              angular.forEach(file, function (ff) {
	                urls.push(ff.$ngfDataUrl);
	              });
	              d.resolve(urls, file);
	            }
	          });
	        });
	        return d.promise;
	      } else {
	        return upload.dataUrl(file, true);
	      }
	    };
	    upload.dataUrl = function (file, disallowObjectUrl) {
	      if (!file) return upload.emptyPromise(file, file);
	      if ((disallowObjectUrl && file.$ngfDataUrl != null) || (!disallowObjectUrl && file.$ngfBlobUrl != null)) {
	        return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
	      }
	      var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
	      if (p) return p;
	
	      var deferred = $q.defer();
	      $timeout(function () {
	        if (window.FileReader && file &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
	          //prefer URL.createObjectURL for handling refrences to files of all sizes
	          //since it doesn´t build a large string in memory
	          var URL = window.URL || window.webkitURL;
	          if (URL && URL.createObjectURL && !disallowObjectUrl) {
	            var url;
	            try {
	              url = URL.createObjectURL(file);
	            } catch (e) {
	              $timeout(function () {
	                file.$ngfBlobUrl = '';
	                deferred.reject();
	              });
	              return;
	            }
	            $timeout(function () {
	              file.$ngfBlobUrl = url;
	              if (url) deferred.resolve(url, file);
	            });
	          } else {
	            var fileReader = new FileReader();
	            fileReader.onload = function (e) {
	              $timeout(function () {
	                file.$ngfDataUrl = e.target.result;
	                deferred.resolve(e.target.result, file);
	              });
	            };
	            fileReader.onerror = function () {
	              $timeout(function () {
	                file.$ngfDataUrl = '';
	                deferred.reject();
	              });
	            };
	            fileReader.readAsDataURL(file);
	          }
	        } else {
	          $timeout(function () {
	            file[disallowObjectUrl ? 'dataUrl' : 'blobUrl'] = '';
	            deferred.reject();
	          });
	        }
	      });
	
	      if (disallowObjectUrl) {
	        p = file.$$ngfDataUrlPromise = deferred.promise;
	      } else {
	        p = file.$$ngfBlobUrlPromise = deferred.promise;
	      }
	      p['finally'](function () {
	        delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
	      });
	      return p;
	    };
	    return upload;
	  }]);
	
	  function getTagType(el) {
	    if (el.tagName.toLowerCase() === 'img') return 'image';
	    if (el.tagName.toLowerCase() === 'audio') return 'audio';
	    if (el.tagName.toLowerCase() === 'video') return 'video';
	    return /./;
	  }
	
	  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
	    function constructDataUrl(file) {
	      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
	      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
	        $timeout(function () {
	          var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
	          if (isBackground) {
	            elem.css('background-image', 'url(\'' + (src || '') + '\')');
	          } else {
	            elem.attr('src', src);
	          }
	          if (src) {
	            elem.removeClass('ng-hide');
	          } else {
	            elem.addClass('ng-hide');
	          }
	        });
	      });
	    }
	
	    $timeout(function () {
	      var unwatch = scope.$watch(attr[directiveName], function (file) {
	        var size = resizeParams;
	        if (directiveName === 'ngfThumbnail') {
	          if (!size) {
	            size = {width: elem[0].clientWidth, height: elem[0].clientHeight};
	          }
	          if (size.width === 0 && window.getComputedStyle) {
	            var style = getComputedStyle(elem[0]);
	            size = {
	              width: parseInt(style.width.slice(0, -2)),
	              height: parseInt(style.height.slice(0, -2))
	            };
	          }
	        }
	
	        if (angular.isString(file)) {
	          elem.removeClass('ng-hide');
	          if (isBackground) {
	            return elem.css('background-image', 'url(\'' + file + '\')');
	          } else {
	            return elem.attr('src', file);
	          }
	        }
	        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 &&
	          (!isBackground || file.type.indexOf('image') === 0)) {
	          if (size && Upload.isResizeSupported()) {
	            Upload.resize(file, size.width, size.height, size.quality).then(
	              function (f) {
	                constructDataUrl(f);
	              }, function (e) {
	                throw e;
	              }
	            );
	          } else {
	            constructDataUrl(file);
	          }
	        } else {
	          elem.addClass('ng-hide');
	        }
	      });
	
	      scope.$on('$destroy', function () {
	        unwatch();
	      });
	    });
	  }
	
	
	  /** @namespace attr.ngfSrc */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc',
	          Upload.attrGetter('ngfResize', attr, scope), false);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfBackground */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground',
	          Upload.attrGetter('ngfResize', attr, scope), true);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfThumbnail */
	  /** @namespace attr.ngfAsBackground */
	  /** @namespace attr.ngfSize */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        var size = Upload.attrGetter('ngfSize', attr, scope);
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size,
	          Upload.attrGetter('ngfAsBackground', attr, scope));
	      }
	    };
	  }]);
	
	  ngFileUpload.config(['$compileProvider', function ($compileProvider) {
	    if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|local|file|data|blob):/);
	    if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|local|file|data|blob):/);
	  }]);
	
	  ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
	    return function (file, disallowObjectUrl, trustedUrl) {
	      if (angular.isString(file)) {
	        return $sce.trustAsResourceUrl(file);
	      }
	      var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
	      if (file && !src) {
	        if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
	          file.$ngfDataUrlFilterInProgress = true;
	          UploadDataUrl.dataUrl(file, disallowObjectUrl);
	        }
	        return '';
	      }
	      if (file) delete file.$ngfDataUrlFilterInProgress;
	      return (file && src ? (trustedUrl ? $sce.trustAsResourceUrl(src) : src) : file) || '';
	    };
	  }]);
	
	})();
	
	ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
	  var upload = UploadDataUrl;
	
	  function globStringToRegex(str) {
	    var regexp = '', excludes = [];
	    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
	      regexp = str.substring(1, str.length - 1);
	    } else {
	      var split = str.split(',');
	      if (split.length > 1) {
	        for (var i = 0; i < split.length; i++) {
	          var r = globStringToRegex(split[i]);
	          if (r.regexp) {
	            regexp += '(' + r.regexp + ')';
	            if (i < split.length - 1) {
	              regexp += '|';
	            }
	          } else {
	            excludes = excludes.concat(r.excludes);
	          }
	        }
	      } else {
	        if (str.indexOf('!') === 0) {
	          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
	        } else {
	          if (str.indexOf('.') === 0) {
	            str = '*' + str;
	          }
	          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
	          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
	        }
	      }
	    }
	    return {regexp: regexp, excludes: excludes};
	  }
	
	  upload.validatePattern = function (file, val) {
	    if (!val) {
	      return true;
	    }
	    var pattern = globStringToRegex(val), valid = true;
	    if (pattern.regexp && pattern.regexp.length) {
	      var regexp = new RegExp(pattern.regexp, 'i');
	      valid = (file.type != null && regexp.test(file.type)) ||
	        (file.name != null && regexp.test(file.name));
	    }
	    var len = pattern.excludes.length;
	    while (len--) {
	      var exclude = new RegExp(pattern.excludes[len], 'i');
	      valid = valid && (file.type == null || exclude.test(file.type)) &&
	        (file.name == null || exclude.test(file.name));
	    }
	    return valid;
	  };
	
	  upload.registerModelChangeValidator = function (ngModel, attr, scope) {
	    if (ngModel) {
	      ngModel.$formatters.push(function (files) {
	        if (!ngModel.$ngfModelChange) {
	          upload.validate(files, ngModel, attr, scope, function () {
	            upload.applyModelValidation(ngModel, files);
	          });
	        } else {
	          ngModel.$ngfModelChange = false;
	        }
	      });
	    }
	  };
	
	  function markModelAsDirty(ngModel, files) {
	    if (files != null && !ngModel.$dirty) {
	      if (ngModel.$setDirty) {
	        ngModel.$setDirty();
	      } else {
	        ngModel.$dirty = true;
	      }
	    }
	  }
	
	  upload.applyModelValidation = function (ngModel, files) {
	    markModelAsDirty(ngModel, files);
	    angular.forEach(ngModel.$ngfValidations, function (validation) {
	      ngModel.$setValidity(validation.name, validation.valid);
	    });
	  };
	
	  upload.validate = function (files, ngModel, attr, scope) {
	    ngModel = ngModel || {};
	    ngModel.$ngfValidations = ngModel.$ngfValidations || [];
	
	    angular.forEach(ngModel.$ngfValidations, function (v) {
	      v.valid = true;
	    });
	
	    var attrGetter = function (name, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (files == null || files.length === 0) {
	      return upload.emptyPromise(ngModel);
	    }
	
	    files = files.length === undefined ? [files] : files.slice(0);
	
	    function validateSync(name, validatorVal, fn) {
	      if (files) {
	        var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	        var i = files.length, valid = null;
	        while (i--) {
	          var file = files[i];
	          if (file) {
	            var val = attrGetter(dName, {'$file': file});
	            if (val == null) {
	              val = validatorVal(attrGetter('ngfValidate') || {});
	              valid = valid == null ? true : valid;
	            }
	            if (val != null) {
	              if (!fn(file, val)) {
	                file.$error = name;
	                file.$errorParam = val;
	                files.splice(i, 1);
	                valid = false;
	              }
	            }
	          }
	        }
	        if (valid !== null) {
	          ngModel.$ngfValidations.push({name: name, valid: valid});
	        }
	      }
	    }
	
	    validateSync('pattern', function (cons) {
	      return cons.pattern;
	    }, upload.validatePattern);
	    validateSync('minSize', function (cons) {
	      return cons.size && cons.size.min;
	    }, function (file, val) {
	      return file.size >= upload.translateScalars(val);
	    });
	    validateSync('maxSize', function (cons) {
	      return cons.size && cons.size.max;
	    }, function (file, val) {
	      return file.size <= upload.translateScalars(val);
	    });
	    var totalSize = 0;
	    validateSync('maxTotalSize', function (cons) {
	      return cons.maxTotalSize && cons.maxTotalSize;
	    }, function (file, val) {
	      totalSize += file.size;
	      if (totalSize > upload.translateScalars(val)) {
	        files.splice(0, files.length);
	        return false;
	      }
	      return true;
	    });
	
	    validateSync('validateFn', function () {
	      return null;
	    }, function (file, r) {
	      return r === true || r === null || r === '';
	    });
	
	    if (!files.length) {
	      return upload.emptyPromise(ngModel, ngModel.$ngfValidations);
	    }
	
	    function validateAsync(name, validatorVal, type, asyncFn, fn) {
	      var promises = [upload.emptyPromise()];
	      if (files) {
	        var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	        files = files.length === undefined ? [files] : files;
	        angular.forEach(files, function (file) {
	          var defer = $q.defer();
	          promises.push(defer.promise);
	          if (type && (file.type == null || file.type.search(type) !== 0)) {
	            defer.resolve();
	            return;
	          }
	          var val = attrGetter(dName, {'$file': file}) || validatorVal(attrGetter('ngfValidate', {'$file': file}) || {});
	          if (val) {
	            asyncFn(file, val).then(function (d) {
	              if (!fn(d, val)) {
	                file.$error = name;
	                file.$errorParam = val;
	                defer.reject();
	              } else {
	                defer.resolve();
	              }
	            }, function () {
	              if (attrGetter('ngfValidateForce', {'$file': file})) {
	                file.$error = name;
	                file.$errorParam = val;
	                defer.reject();
	              } else {
	                defer.resolve();
	              }
	            });
	          } else {
	            defer.resolve();
	          }
	        });
	        return $q.all(promises).then(function () {
	          ngModel.$ngfValidations.push({name: name, valid: true});
	        }, function () {
	          ngModel.$ngfValidations.push({name: name, valid: false});
	        });
	      }
	    }
	
	    var deffer = $q.defer();
	    var promises = [];
	
	    promises.push(upload.happyPromise(validateAsync('maxHeight', function (cons) {
	      return cons.height && cons.height.max;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.height <= val;
	    })));
	    promises.push(upload.happyPromise(validateAsync('minHeight', function (cons) {
	      return cons.height && cons.height.min;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.height >= val;
	    })));
	    promises.push(upload.happyPromise(validateAsync('maxWidth', function (cons) {
	      return cons.width && cons.width.max;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.width <= val;
	    })));
	    promises.push(upload.happyPromise(validateAsync('minWidth', function (cons) {
	      return cons.width && cons.width.min;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return d.width >= val;
	    })));
	    function ratioToFloat(val) {
	      var r = val, xIndex = r.search(/x/i);
	      if (xIndex > -1) {
	        r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
	      } else {
	        r = parseFloat(r);
	      }
	      return r;
	    }
	    promises.push(upload.happyPromise(validateAsync('ratio', function (cons) {
	      return cons.ratio;
	    }, /image/, this.imageDimensions, function (d, val) {
	      var split = val.toString().split(','), valid = false;
	      for (var i = 0; i < split.length; i++) {
	        if (Math.abs((d.width / d.height) - ratioToFloat(split[i])) < 0.0001) {
	          valid = true;
	        }
	      }
	      return valid;
	    })));
	    promises.push(upload.happyPromise(validateAsync('maxRatio', function (cons) {
	      return cons.ratio;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return Math.abs((d.width / d.height) - ratioToFloat(val)) < 0.0001;
	    })));
	    promises.push(upload.happyPromise(validateAsync('minRatio', function (cons) {
	      return cons.ratio;
	    }, /image/, this.imageDimensions, function (d, val) {
	      return Math.abs((d.width / d.height) - ratioToFloat(val)) > -0.0001;
	    })));
	    promises.push(upload.happyPromise(validateAsync('maxDuration', function (cons) {
	      return cons.duration && cons.duration.max;
	    }, /audio|video/, this.mediaDuration, function (d, val) {
	      return d <= upload.translateScalars(val);
	    })));
	    promises.push(upload.happyPromise(validateAsync('minDuration', function (cons) {
	      return cons.duration && cons.duration.min;
	    }, /audio|video/, this.mediaDuration, function (d, val) {
	      return d >= upload.translateScalars(val);
	    })));
	
	    promises.push(upload.happyPromise(validateAsync('validateAsyncFn', function () {
	      return null;
	    }, null, function (file, val) {
	      return val;
	    }, function (r) {
	      return r === true || r === null || r === '';
	    })));
	
	    return $q.all(promises).then(function () {
	      deffer.resolve(ngModel, ngModel.$ngfValidations);
	    });
	  };
	
	  upload.imageDimensions = function (file) {
	    if (file.$ngfWidth && file.$ngfHeight) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve({width: file.$ngfWidth, height: file.$ngfHeight});
	      });
	      return d.promise;
	    }
	    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('image') !== 0) {
	        deferred.reject('not image');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var img = angular.element('<img>').attr('src', dataUrl).css('visibility', 'hidden').css('position', 'fixed');
	
	        function success() {
	          var width = img[0].clientWidth;
	          var height = img[0].clientHeight;
	          img.remove();
	          file.$ngfWidth = width;
	          file.$ngfHeight = height;
	          deferred.resolve({width: width, height: height});
	        }
	
	        function error() {
	          img.remove();
	          deferred.reject('load error');
	        }
	
	        img.on('load', success);
	        img.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (img[0].parentNode) {
	              if (img[0].clientWidth) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.getElementsByTagName('body')[0]).append(img);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDimensionPromise = deferred.promise;
	    file.$ngfDimensionPromise['finally'](function () {
	      delete file.$ngfDimensionPromise;
	    });
	    return file.$ngfDimensionPromise;
	  };
	
	  upload.mediaDuration = function (file) {
	    if (file.$ngfDuration) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve(file.$ngfDuration);
	      });
	      return d.promise;
	    }
	    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
	        deferred.reject('not media');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>')
	          .attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');
	
	        function success() {
	          var duration = el[0].duration;
	          file.$ngfDuration = duration;
	          el.remove();
	          deferred.resolve(duration);
	        }
	
	        function error() {
	          el.remove();
	          deferred.reject('load error');
	        }
	
	        el.on('loadedmetadata', success);
	        el.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (el[0].parentNode) {
	              if (el[0].duration) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.body).append(el);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDurationPromise = deferred.promise;
	    file.$ngfDurationPromise['finally'](function () {
	      delete file.$ngfDurationPromise;
	    });
	    return file.$ngfDurationPromise;
	  };
	  return upload;
	}
	]);
	
	ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
	  var upload = UploadValidate;
	
	  /**
	   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
	   * images to fit into a certain area.
	   * Source:  http://stackoverflow.com/a/14731922
	   *
	   * @param {Number} srcWidth Source area width
	   * @param {Number} srcHeight Source area height
	   * @param {Number} maxWidth Nestable area maximum available width
	   * @param {Number} maxHeight Nestable area maximum available height
	   * @return {Object} { width, height }
	   */
	  var calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight) {
	    var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	    return {width: srcWidth * ratio, height: srcHeight * ratio};
	  };
	
	  // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
	  var resize = function (imagen, width, height, quality, type) {
	    var deferred = $q.defer();
	    var canvasElement = document.createElement('canvas');
	    var imageElement = document.createElement('img');
	
	    imageElement.onload = function () {
	      try {
	        if (!width) {
	          width = imageElement.width;
	        }
	        if (!height) {
	          height = imageElement.height;
	        }
	        var dimensions = calculateAspectRatioFit(imageElement.width, imageElement.height, width, height);
	        canvasElement.width = dimensions.width;
	        canvasElement.height = dimensions.height;
	        var context = canvasElement.getContext('2d');
	        context.drawImage(imageElement, 0, 0, dimensions.width, dimensions.height);
	        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 1.0));
	      } catch (e) {
	        deferred.reject(e);
	      }
	    };
	    imageElement.onerror = function () {
	      deferred.reject();
	    };
	    imageElement.src = imagen;
	    return deferred.promise;
	  };
	
	  upload.dataUrltoBlob = function (dataurl, name) {
	    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
	      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
	    while (n--) {
	      u8arr[n] = bstr.charCodeAt(n);
	    }
	    var blob = new Blob([u8arr], {type: mime});
	    blob.name = name;
	    return blob;
	  };
	
	  upload.isResizeSupported = function () {
	    var elem = document.createElement('canvas');
	    return window.atob && elem.getContext && elem.getContext('2d');
	  };
	
	  if (upload.isResizeSupported()) {
	    // add name getter to the blob constructor prototype
	    Object.defineProperty(Blob.prototype, 'name', {
	      get: function () {
	        return this.$ngfName;
	      },
	      set: function (v) {
	        this.$ngfName = v;
	      },
	      configurable: true
	    });
	  }
	
	  upload.resize = function (file, width, height, quality, type) {
	    if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);
	
	    var deferred = $q.defer();
	    upload.dataUrl(file, true).then(function (url) {
	      resize(url, width, height, quality, type || file.type).then(function (dataUrl) {
	        deferred.resolve(upload.dataUrltoBlob(dataUrl, file.name));
	      }, function () {
	        deferred.reject();
	      });
	    }, function () {
	      deferred.reject();
	    });
	    return deferred.promise;
	  };
	
	  return upload;
	}]);
	
	(function () {
	  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$location', 'Upload', '$http',
	    function ($parse, $timeout, $location, Upload, $http) {
	      return {
	        restrict: 'AEC',
	        require: '?ngModel',
	        link: function (scope, elem, attr, ngModel) {
	          linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $location, Upload, $http);
	        }
	      };
	    }]);
	
	  ngFileUpload.directive('ngfNoFileDrop', function () {
	    return function (scope, elem) {
	      if (dropAvailable()) elem.css('display', 'none');
	    };
	  });
	
	  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
	    return function (scope, elem, attr) {
	      if (dropAvailable()) {
	        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
	        $timeout(function () {
	          model(scope);
	          if (model.assign) {
	            model.assign(scope, true);
	          }
	        });
	      }
	    };
	  }]);
	
	  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $location, upload, $http) {
	    var available = dropAvailable();
	
	    var attrGetter = function (name, scope, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (attrGetter('dropAvailable')) {
	      $timeout(function () {
	        if (scope[attrGetter('dropAvailable')]) {
	          scope[attrGetter('dropAvailable')].value = available;
	        } else {
	          scope[attrGetter('dropAvailable')] = available;
	        }
	      });
	    }
	    if (!available) {
	      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
	        elem.css('display', 'none');
	      }
	      return;
	    }
	
	    function isDisabled() {
	      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
	    }
	
	    if (attrGetter('ngfSelect') == null) {
	      upload.registerModelChangeValidator(ngModel, attr, scope);
	    }
	
	    var leaveTimeout = null;
	    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
	    var dragOverDelay = 1;
	    var actualDragOverClass;
	
	    elem[0].addEventListener('dragover', function (evt) {
	      if (isDisabled()) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      // handling dragover events from the Chrome download bar
	      if (navigator.userAgent.indexOf('Chrome') > -1) {
	        var b = evt.dataTransfer.effectAllowed;
	        evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
	      }
	      $timeout.cancel(leaveTimeout);
	      if (!actualDragOverClass) {
	        actualDragOverClass = 'C';
	        calculateDragOverClass(scope, attr, evt, function (clazz) {
	          actualDragOverClass = clazz;
	          elem.addClass(actualDragOverClass);
	          attrGetter('ngfDrag', scope, {$isDragging: true, $class: actualDragOverClass, $event: evt});
	        });
	      }
	    }, false);
	    elem[0].addEventListener('dragenter', function (evt) {
	      if (isDisabled()) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	    }, false);
	    elem[0].addEventListener('dragleave', function (evt) {
	      if (isDisabled()) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      leaveTimeout = $timeout(function () {
	        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	        actualDragOverClass = null;
	        attrGetter('ngfDrag', scope, {$isDragging: false, $event: evt});
	      }, dragOverDelay || 100);
	    }, false);
	    elem[0].addEventListener('drop', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	      actualDragOverClass = null;
	      var html;
	      try {
	        html = (evt.dataTransfer && evt.dataTransfer.getData && evt.dataTransfer.getData('text/html'));
	      } catch (e) {/* Fix IE11 that throw error calling getData */}
	      if (upload.shouldUpdateOn('dropUrl', attr, scope) && html) {
	        var url;
	        html.replace(/<img .*src *=\"([^\"]*)\"/, function (m, src) {
	          url = src;
	        });
	        if (url) {
	          $http({url: url, method: 'get', responseType: 'arraybuffer'}).then(function (resp) {
	            var arrayBufferView = new Uint8Array(resp.data);
	            var type = resp.headers('content-type') || 'image/WebP';
	            var blob = new Blob([arrayBufferView], {type: type});
	            //var split = type.split('[/;]');
	            //blob.name = url.substring(0, 150).replace(/\W+/g, '') + '.' + (split.length > 1 ? split[1] : 'jpg');
	            upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), [blob], evt);
	          });
	        }
	      } else {
	        extractFiles(evt, function (files) {
	            upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	          }, attrGetter('ngfAllowDir', scope) !== false,
	          attrGetter('multiple') || attrGetter('ngfMultiple', scope));
	      }
	    }, false);
	    elem[0].addEventListener('paste', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
	      var files = [];
	      var clipboard = evt.clipboardData || evt.originalEvent.clipboardData;
	      if (clipboard && clipboard.items) {
	        for (var k = 0; k < clipboard.items.length; k++) {
	          if (clipboard.items[k].type.indexOf('image') !== -1) {
	            files.push(clipboard.items[k].getAsFile());
	          }
	        }
	        upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	      }
	    }, false);
	
	    function calculateDragOverClass(scope, attr, evt, callback) {
	      var obj = attrGetter('ngfDragOverClass', scope, {$event: evt}), dClass = 'dragover';
	      if (angular.isString(obj)) {
	        dClass = obj;
	      } else if (obj) {
	        if (obj.delay) dragOverDelay = obj.delay;
	        if (obj.accept || obj.reject) {
	          var items = evt.dataTransfer.items;
	          if (items == null || !items.length) {
	            dClass = obj.accept;
	          } else {
	            var pattern = obj.pattern || attrGetter('ngfPattern', scope, {$event: evt});
	            var len = items.length;
	            while (len--) {
	              if (!upload.validatePattern(items[len], pattern)) {
	                dClass = obj.reject;
	                break;
	              } else {
	                dClass = obj.accept;
	              }
	            }
	          }
	        }
	      }
	      callback(dClass);
	    }
	
	    function extractFiles(evt, callback, allowDir, multiple) {
	      var files = [], processing = 0;
	
	      function traverseFileTree(files, entry, path) {
	        if (entry != null) {
	          if (entry.isDirectory) {
	            var filePath = (path || '') + entry.name;
	            files.push({name: entry.name, type: 'directory', path: filePath});
	            var dirReader = entry.createReader();
	            var entries = [];
	            processing++;
	            var readEntries = function () {
	              dirReader.readEntries(function (results) {
	                try {
	                  if (!results.length) {
	                    for (var i = 0; i < entries.length; i++) {
	                      traverseFileTree(files, entries[i], (path ? path : '') + entry.name + '/');
	                    }
	                    processing--;
	                  } else {
	                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
	                    readEntries();
	                  }
	                } catch (e) {
	                  processing--;
	                  console.error(e);
	                }
	              }, function () {
	                processing--;
	              });
	            };
	            readEntries();
	          } else {
	            processing++;
	            entry.file(function (file) {
	              try {
	                processing--;
	                file.path = (path ? path : '') + file.name;
	                files.push(file);
	              } catch (e) {
	                processing--;
	                console.error(e);
	              }
	            }, function () {
	              processing--;
	            });
	          }
	        }
	      }
	
	      var items = evt.dataTransfer.items;
	
	      if (items && items.length > 0 && $location.protocol() !== 'file') {
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
	            var entry = items[i].webkitGetAsEntry();
	            if (entry.isDirectory && !allowDir) {
	              continue;
	            }
	            if (entry != null) {
	              traverseFileTree(files, entry);
	            }
	          } else {
	            var f = items[i].getAsFile();
	            if (f != null) files.push(f);
	          }
	          if (!multiple && files.length > 0) break;
	        }
	      } else {
	        var fileList = evt.dataTransfer.files;
	        if (fileList != null) {
	          for (var j = 0; j < fileList.length; j++) {
	            files.push(fileList.item(j));
	            if (!multiple && files.length > 0) {
	              break;
	            }
	          }
	        }
	      }
	      var delays = 0;
	      (function waitForProcess(delay) {
	        $timeout(function () {
	          if (!processing) {
	            if (!multiple && files.length > 1) {
	              i = 0;
	              while (files[i].type === 'directory') i++;
	              files = [files[i]];
	            }
	            callback(files);
	          } else {
	            if (delays++ * 10 < 20 * 1000) {
	              waitForProcess(10);
	            }
	          }
	        }, delay || 0);
	      })();
	    }
	  }
	
	  function dropAvailable() {
	    var div = document.createElement('div');
	    return ('draggable' in div) && ('ondrop' in div) && !/Edge\/12./i.test(navigator.userAgent);
	  }
	
	})();
	
	// customized version of https://github.com/exif-js/exif-js
	ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
	  var upload = UploadResize;
	
	  function findEXIFinJPEG(file) {
	    var dataView = new DataView(file);
	
	    if ((dataView.getUint8(0) !== 0xFF) || (dataView.getUint8(1) !== 0xD8)) {
	      return 'Not a valid JPEG';
	    }
	
	    var offset = 2,
	      length = file.byteLength,
	      marker;
	
	    while (offset < length) {
	      if (dataView.getUint8(offset) !== 0xFF) {
	        return 'Not a valid marker at offset ' + offset + ', found: ' + dataView.getUint8(offset);
	      }
	
	      marker = dataView.getUint8(offset + 1);
	      if (marker === 225) {
	        return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);
	      } else {
	        offset += 2 + dataView.getUint16(offset + 2);
	      }
	    }
	  }
	
	  function readOrientation(file, tiffStart, dirStart, bigEnd) {
	    var entries = file.getUint16(dirStart, !bigEnd),
	      entryOffset, i;
	
	    for (i = 0; i < entries; i++) {
	      entryOffset = dirStart + i * 12 + 2;
	      var val = file.getUint16(entryOffset, !bigEnd);
	      if (0x0112 === val) {
	        return readTagValue(file, entryOffset, tiffStart, bigEnd);
	      }
	    }
	    return null;
	  }
	
	  function readTagValue(file, entryOffset, tiffStart, bigEnd) {
	    var numValues = file.getUint32(entryOffset + 4, !bigEnd),
	      valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart, offset, vals, n;
	
	    if (numValues === 1) {
	      return file.getUint16(entryOffset + 8, !bigEnd);
	    } else {
	      offset = numValues > 2 ? valueOffset : (entryOffset + 8);
	      vals = [];
	      for (n = 0; n < numValues; n++) {
	        vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
	      }
	      return vals;
	    }
	  }
	
	  function getStringFromDB(buffer, start, length) {
	    var outstr = '';
	    for (var n = start; n < start + length; n++) {
	      outstr += String.fromCharCode(buffer.getUint8(n));
	    }
	    return outstr;
	  }
	
	  function readEXIFData(file, start) {
	    if (getStringFromDB(file, start, 4) !== 'Exif') {
	      return 'Not valid EXIF data! ' + getStringFromDB(file, start, 4);
	    }
	
	    var bigEnd,
	      tiffOffset = start + 6;
	
	    // test for TIFF validity and endianness
	    if (file.getUint16(tiffOffset) === 0x4949) {
	      bigEnd = false;
	    } else if (file.getUint16(tiffOffset) === 0x4D4D) {
	      bigEnd = true;
	    } else {
	      return 'Not valid TIFF data! (no 0x4949 or 0x4D4D)';
	    }
	
	    if (file.getUint16(tiffOffset + 2, !bigEnd) !== 0x002A) {
	      return 'Not valid TIFF data! (no 0x002A)';
	    }
	
	    var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);
	
	    if (firstIFDOffset < 0x00000008) {
	      return 'Not valid TIFF data! (First offset less than 8)', file.getUint32(tiffOffset + 4, !bigEnd);
	    }
	
	    return readOrientation(file, tiffOffset, tiffOffset + firstIFDOffset, bigEnd);
	
	  }
	
	  upload.isExifSupported = function() {
	    return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
	  };
	
	  upload.orientation = function (file) {
	    if (file.$ngfOrientation != null) {
	      return upload.emptyPromise(file.$ngfOrientation);
	    }
	    var defer = $q.defer();
	    var fileReader = new FileReader();
	    fileReader.onload = function (e) {
	      var orientation;
	      try {
	        orientation = findEXIFinJPEG(e.target.result);
	      } catch (e) {
	        defer.reject(e);
	        return;
	      }
	      if (angular.isString(orientation)) {
	        defer.resolve(1);
	      } else {
	        file.$ngfOrientation = orientation;
	        defer.resolve(orientation);
	      }
	    };
	    fileReader.onerror = function (e) {
	      defer.reject(e);
	    };
	
	    fileReader.readAsArrayBuffer(file);
	    return defer.promise;
	  };
	
	
	  function applyTransform(ctx, orientation, width, height) {
	    switch (orientation) {
	      case 2:
	        return ctx.transform(-1, 0, 0, 1, width, 0);
	      case 3:
	        return ctx.transform(-1, 0, 0, -1, width, height);
	      case 4:
	        return ctx.transform(1, 0, 0, -1, 0, height);
	      case 5:
	        return ctx.transform(0, 1, 1, 0, 0, 0);
	      case 6:
	        return ctx.transform(0, 1, -1, 0, height, 0);
	      case 7:
	        return ctx.transform(0, -1, -1, 0, height, width);
	      case 8:
	        return ctx.transform(0, -1, 1, 0, 0, width);
	    }
	  }
	
	  upload.applyExifRotation = function (file) {
	    if (file.type.indexOf('image/jpeg') !== 0) {
	      return upload.emptyPromise(file);
	    }
	
	    var deferred = $q.defer();
	    upload.orientation(file).then(function (orientation) {
	      if (!orientation || orientation < 2 || orientation > 8) {
	        deferred.resolve(file);
	      }
	      upload.dataUrl(file, true).then(function (url) {
	        var canvas = document.createElement('canvas');
	        var img = document.createElement('img');
	
	        img.onload = function () {
	          try {
	            canvas.width = orientation > 4 ? img.height : img.width;
	            canvas.height = orientation > 4 ? img.width : img.height;
	            var ctx = canvas.getContext('2d');
	            applyTransform(ctx, orientation, img.width, img.height);
	            ctx.drawImage(img, 0, 0);
	            var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 1.0);
	            var blob = upload.dataUrltoBlob(dataUrl, file.name);
	            deferred.resolve(blob);
	          } catch (e) {
	            deferred.reject(e);
	          }
	        };
	        img.onerror = function () {
	          deferred.reject();
	        };
	        img.src = url;
	      }, function (e) {
	        deferred.reject(e);
	      });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  return upload;
	}]);
	


/***/ },
/* 179 */
/***/ function(module, exports) {

	/*!
	 * ngTagsInput v3.1.1
	 * http://mbenford.github.io/ngTagsInput
	 *
	 * Copyright (c) 2013-2016 Michael Benford
	 * License: MIT
	 *
	 * Generated at 2016-05-27 12:28:31 -0300
	 */
	(function() {
	'use strict';
	
	var KEYS = {
	    backspace: 8,
	    tab: 9,
	    enter: 13,
	    escape: 27,
	    space: 32,
	    up: 38,
	    down: 40,
	    left: 37,
	    right: 39,
	    delete: 46,
	    comma: 188
	};
	
	var MAX_SAFE_INTEGER = 9007199254740991;
	var SUPPORTED_INPUT_TYPES = ['text', 'email', 'url'];
	
	var tagsInput = angular.module('ngTagsInput', []);
	
	/**
	 * @ngdoc directive
	 * @name tagsInput
	 * @module ngTagsInput
	 *
	 * @description
	 * Renders an input box with tag editing support.
	 *
	 * @param {string} ngModel Assignable Angular expression to data-bind to.
	 * @param {string=} [template=NA] URL or id of a custom template for rendering each tag.
	 * @param {string=} [templateScope=NA] Scope to be passed to custom templates - of both tagsInput and
	 *    autoComplete directives - as $scope.
	 * @param {string=} [displayProperty=text] Property to be rendered as the tag label.
	 * @param {string=} [keyProperty=text] Property to be used as a unique identifier for the tag.
	 * @param {string=} [type=text] Type of the input element. Only 'text', 'email' and 'url' are supported values.
	 * @param {string=} [text=NA] Assignable Angular expression for data-binding to the element's text.
	 * @param {number=} tabindex Tab order of the control.
	 * @param {string=} [placeholder=Add a tag] Placeholder text for the control.
	 * @param {number=} [minLength=3] Minimum length for a new tag.
	 * @param {number=} [maxLength=MAX_SAFE_INTEGER] Maximum length allowed for a new tag.
	 * @param {number=} [minTags=0] Sets minTags validation error key if the number of tags added is less than minTags.
	 * @param {number=} [maxTags=MAX_SAFE_INTEGER] Sets maxTags validation error key if the number of tags added is greater
	 *    than maxTags.
	 * @param {boolean=} [allowLeftoverText=false] Sets leftoverText validation error key if there is any leftover text in
	 *    the input element when the directive loses focus.
	 * @param {string=} [removeTagSymbol=×] (Obsolete) Symbol character for the remove tag button.
	 * @param {boolean=} [addOnEnter=true] Flag indicating that a new tag will be added on pressing the ENTER key.
	 * @param {boolean=} [addOnSpace=false] Flag indicating that a new tag will be added on pressing the SPACE key.
	 * @param {boolean=} [addOnComma=true] Flag indicating that a new tag will be added on pressing the COMMA key.
	 * @param {boolean=} [addOnBlur=true] Flag indicating that a new tag will be added when the input field loses focus.
	 * @param {boolean=} [addOnPaste=false] Flag indicating that the text pasted into the input field will be split into tags.
	 * @param {string=} [pasteSplitPattern=,] Regular expression used to split the pasted text into tags.
	 * @param {boolean=} [replaceSpacesWithDashes=true] Flag indicating that spaces will be replaced with dashes.
	 * @param {string=} [allowedTagsPattern=.+] Regular expression that determines whether a new tag is valid.
	 * @param {boolean=} [enableEditingLastTag=false] Flag indicating that the last tag will be moved back into the new tag
	 *    input box instead of being removed when the backspace key is pressed and the input box is empty.
	 * @param {boolean=} [addFromAutocompleteOnly=false] Flag indicating that only tags coming from the autocomplete list
	 *    will be allowed. When this flag is true, addOnEnter, addOnComma, addOnSpace and addOnBlur values are ignored.
	 * @param {boolean=} [spellcheck=true] Flag indicating whether the browser's spellcheck is enabled for the input field or not.
	 * @param {expression=} [tagClass=NA] Expression to evaluate for each existing tag in order to get the CSS classes to be used.
	 *    The expression is provided with the current tag as $tag, its index as $index and its state as $selected. The result
	 *    of the evaluation must be one of the values supported by the ngClass directive (either a string, an array or an object).
	 *    See https://docs.angularjs.org/api/ng/directive/ngClass for more information.
	 * @param {expression=} [onTagAdding=NA] Expression to evaluate that will be invoked before adding a new tag. The new
	 *    tag is available as $tag. This method must return either a boolean value or a promise. If either a false value or a rejected
	 *    promise is returned, the tag will not be added.
	 * @param {expression=} [onTagAdded=NA] Expression to evaluate upon adding a new tag. The new tag is available as $tag.
	 * @param {expression=} [onInvalidTag=NA] Expression to evaluate when a tag is invalid. The invalid tag is available as $tag.
	 * @param {expression=} [onTagRemoving=NA] Expression to evaluate that will be invoked before removing a tag. The tag
	 *    is available as $tag. This method must return either a boolean value or a promise. If either a false value or a rejected
	 *    promise is returned, the tag will not be removed.
	 * @param {expression=} [onTagRemoved=NA] Expression to evaluate upon removing an existing tag. The removed tag is available as $tag.
	 * @param {expression=} [onTagClicked=NA] Expression to evaluate upon clicking an existing tag. The clicked tag is available as $tag.
	 */
	tagsInput.directive('tagsInput', ["$timeout", "$document", "$window", "$q", "tagsInputConfig", "tiUtil", function($timeout, $document, $window, $q, tagsInputConfig, tiUtil) {
	    function TagList(options, events, onTagAdding, onTagRemoving) {
	        var self = {}, getTagText, setTagText, canAddTag, canRemoveTag;
	
	        getTagText = function(tag) {
	            return tiUtil.safeToString(tag[options.displayProperty]);
	        };
	
	        setTagText = function(tag, text) {
	            tag[options.displayProperty] = text;
	        };
	
	        canAddTag = function(tag) {
	            var tagText = getTagText(tag);
	            var valid = tagText &&
	                        tagText.length >= options.minLength &&
	                        tagText.length <= options.maxLength &&
	                        options.allowedTagsPattern.test(tagText) &&
	                        !tiUtil.findInObjectArray(self.items, tag, options.keyProperty || options.displayProperty);
	
	            return $q.when(valid && onTagAdding({ $tag: tag })).then(tiUtil.promisifyValue);
	        };
	
	        canRemoveTag = function(tag) {
	            return $q.when(onTagRemoving({ $tag: tag })).then(tiUtil.promisifyValue);
	        };
	
	        self.items = [];
	
	        self.addText = function(text) {
	            var tag = {};
	            setTagText(tag, text);
	            return self.add(tag);
	        };
	
	        self.add = function(tag) {
	            var tagText = getTagText(tag);
	
	            if (options.replaceSpacesWithDashes) {
	                tagText = tiUtil.replaceSpacesWithDashes(tagText);
	            }
	
	            setTagText(tag, tagText);
	
	            return canAddTag(tag)
	                .then(function() {
	                    self.items.push(tag);
	                    events.trigger('tag-added', { $tag: tag });
	                })
	                .catch(function() {
	                    if (tagText) {
	                      events.trigger('invalid-tag', { $tag: tag });
	                    }
	                });
	        };
	
	        self.remove = function(index) {
	            var tag = self.items[index];
	
	            return canRemoveTag(tag).then(function() {
	                self.items.splice(index, 1);
	                self.clearSelection();
	                events.trigger('tag-removed', { $tag: tag });
	                return tag;
	            });
	        };
	
	        self.select = function(index) {
	            if (index < 0) {
	                index = self.items.length - 1;
	            }
	            else if (index >= self.items.length) {
	                index = 0;
	            }
	
	            self.index = index;
	            self.selected = self.items[index];
	        };
	
	        self.selectPrior = function() {
	            self.select(--self.index);
	        };
	
	        self.selectNext = function() {
	            self.select(++self.index);
	        };
	
	        self.removeSelected = function() {
	            return self.remove(self.index);
	        };
	
	        self.clearSelection = function() {
	            self.selected = null;
	            self.index = -1;
	        };
	
	        self.clearSelection();
	
	        return self;
	    }
	
	    function validateType(type) {
	        return SUPPORTED_INPUT_TYPES.indexOf(type) !== -1;
	    }
	
	    return {
	        restrict: 'E',
	        require: 'ngModel',
	        scope: {
	            tags: '=ngModel',
	            text: '=?',
	            templateScope: '=?',
	            tagClass: '&',
	            onTagAdding: '&',
	            onTagAdded: '&',
	            onInvalidTag: '&',
	            onTagRemoving: '&',
	            onTagRemoved: '&',
	            onTagClicked: '&',
	        },
	        replace: false,
	        transclude: true,
	        templateUrl: 'ngTagsInput/tags-input.html',
	        controller: ["$scope", "$attrs", "$element", function($scope, $attrs, $element) {
	            $scope.events = tiUtil.simplePubSub();
	
	            tagsInputConfig.load('tagsInput', $scope, $attrs, {
	                template: [String, 'ngTagsInput/tag-item.html'],
	                type: [String, 'text', validateType],
	                placeholder: [String, 'Add a tag'],
	                tabindex: [Number, null],
	                removeTagSymbol: [String, String.fromCharCode(215)],
	                replaceSpacesWithDashes: [Boolean, true],
	                minLength: [Number, 3],
	                maxLength: [Number, MAX_SAFE_INTEGER],
	                addOnEnter: [Boolean, true],
	                addOnSpace: [Boolean, false],
	                addOnComma: [Boolean, true],
	                addOnBlur: [Boolean, true],
	                addOnPaste: [Boolean, false],
	                pasteSplitPattern: [RegExp, /,/],
	                allowedTagsPattern: [RegExp, /.+/],
	                enableEditingLastTag: [Boolean, false],
	                minTags: [Number, 0],
	                maxTags: [Number, MAX_SAFE_INTEGER],
	                displayProperty: [String, 'text'],
	                keyProperty: [String, ''],
	                allowLeftoverText: [Boolean, false],
	                addFromAutocompleteOnly: [Boolean, false],
	                spellcheck: [Boolean, true]
	            });
	
	            $scope.tagList = new TagList($scope.options, $scope.events,
	                tiUtil.handleUndefinedResult($scope.onTagAdding, true),
	                tiUtil.handleUndefinedResult($scope.onTagRemoving, true));
	
	            this.registerAutocomplete = function() {
	                var input = $element.find('input');
	
	                return {
	                    addTag: function(tag) {
	                        return $scope.tagList.add(tag);
	                    },
	                    getTags: function() {
	                        return $scope.tagList.items;
	                    },
	                    getCurrentTagText: function() {
	                        return $scope.newTag.text();
	                    },
	                    getOptions: function() {
	                        return $scope.options;
	                    },
	                    getTemplateScope: function() {
	                        return $scope.templateScope;
	                    },
	                    on: function(name, handler) {
	                        $scope.events.on(name, handler, true);
	                        return this;
	                    }
	                };
	            };
	
	            this.registerTagItem = function() {
	                return {
	                    getOptions: function() {
	                        return $scope.options;
	                    },
	                    removeTag: function(index) {
	                        if ($scope.disabled) {
	                            return;
	                        }
	                        $scope.tagList.remove(index);
	                    }
	                };
	            };
	        }],
	        link: function(scope, element, attrs, ngModelCtrl) {
	            var hotkeys = [KEYS.enter, KEYS.comma, KEYS.space, KEYS.backspace, KEYS.delete, KEYS.left, KEYS.right],
	                tagList = scope.tagList,
	                events = scope.events,
	                options = scope.options,
	                input = element.find('input'),
	                validationOptions = ['minTags', 'maxTags', 'allowLeftoverText'],
	                setElementValidity,
	                focusInput;
	
	            setElementValidity = function() {
	                ngModelCtrl.$setValidity('maxTags', tagList.items.length <= options.maxTags);
	                ngModelCtrl.$setValidity('minTags', tagList.items.length >= options.minTags);
	                ngModelCtrl.$setValidity('leftoverText', scope.hasFocus || options.allowLeftoverText ? true : !scope.newTag.text());
	            };
	
	            focusInput = function() {
	                $timeout(function() { input[0].focus(); });
	            };
	
	            ngModelCtrl.$isEmpty = function(value) {
	                return !value || !value.length;
	            };
	
	            scope.newTag = {
	                text: function(value) {
	                    if (angular.isDefined(value)) {
	                        scope.text = value;
	                        events.trigger('input-change', value);
	                    }
	                    else {
	                        return scope.text || '';
	                    }
	                },
	                invalid: null
	            };
	
	            scope.track = function(tag) {
	                return tag[options.keyProperty || options.displayProperty];
	            };
	
	            scope.getTagClass = function(tag, index) {
	                var selected = tag === tagList.selected;
	                return [
	                    scope.tagClass({$tag: tag, $index: index, $selected: selected}),
	                    { selected: selected }
	                ];
	            };
	
	            scope.$watch('tags', function(value) {
	                if (value) {
	                    tagList.items = tiUtil.makeObjectArray(value, options.displayProperty);
	                    scope.tags = tagList.items;
	                }
	                else {
	                    tagList.items = [];
	                }
	            });
	
	            scope.$watch('tags.length', function() {
	                setElementValidity();
	
	                // ngModelController won't trigger validators when the model changes (because it's an array),
	                // so we need to do it ourselves. Unfortunately this won't trigger any registered formatter.
	                ngModelCtrl.$validate();
	            });
	
	            attrs.$observe('disabled', function(value) {
	                scope.disabled = value;
	            });
	
	            scope.eventHandlers = {
	                input: {
	                    keydown: function($event) {
	                        events.trigger('input-keydown', $event);
	                    },
	                    focus: function() {
	                        if (scope.hasFocus) {
	                            return;
	                        }
	
	                        scope.hasFocus = true;
	                        events.trigger('input-focus');
	                    },
	                    blur: function() {
	                        $timeout(function() {
	                            var activeElement = $document.prop('activeElement'),
	                                lostFocusToBrowserWindow = activeElement === input[0],
	                                lostFocusToChildElement = element[0].contains(activeElement);
	
	                            if (lostFocusToBrowserWindow || !lostFocusToChildElement) {
	                                scope.hasFocus = false;
	                                events.trigger('input-blur');
	                            }
	                        });
	                    },
	                    paste: function($event) {
	                        $event.getTextData = function() {
	                            var clipboardData = $event.clipboardData || ($event.originalEvent && $event.originalEvent.clipboardData);
	                            return clipboardData ? clipboardData.getData('text/plain') : $window.clipboardData.getData('Text');
	                        };
	                        events.trigger('input-paste', $event);
	                    }
	                },
	                host: {
	                    click: function() {
	                        if (scope.disabled) {
	                            return;
	                        }
	                        focusInput();
	                    }
	                },
	                tag: {
	                    click: function(tag) {
	                        events.trigger('tag-clicked', { $tag: tag });
	                    }
	                }
	            };
	
	            events
	                .on('tag-added', scope.onTagAdded)
	                .on('invalid-tag', scope.onInvalidTag)
	                .on('tag-removed', scope.onTagRemoved)
	                .on('tag-clicked', scope.onTagClicked)
	                .on('tag-added', function() {
	                    scope.newTag.text('');
	                })
	                .on('tag-added tag-removed', function() {
	                    scope.tags = tagList.items;
	                    // Ideally we should be able call $setViewValue here and let it in turn call $setDirty and $validate
	                    // automatically, but since the model is an array, $setViewValue does nothing and it's up to us to do it.
	                    // Unfortunately this won't trigger any registered $parser and there's no safe way to do it.
	                    ngModelCtrl.$setDirty();
	                    focusInput();
	                })
	                .on('invalid-tag', function() {
	                    scope.newTag.invalid = true;
	                })
	                .on('option-change', function(e) {
	                    if (validationOptions.indexOf(e.name) !== -1) {
	                        setElementValidity();
	                    }
	                })
	                .on('input-change', function() {
	                    tagList.clearSelection();
	                    scope.newTag.invalid = null;
	                })
	                .on('input-focus', function() {
	                    element.triggerHandler('focus');
	                    ngModelCtrl.$setValidity('leftoverText', true);
	                })
	                .on('input-blur', function() {
	                    if (options.addOnBlur && !options.addFromAutocompleteOnly) {
	                        tagList.addText(scope.newTag.text());
	                    }
	                    element.triggerHandler('blur');
	                    setElementValidity();
	                })
	                .on('input-keydown', function(event) {
	                    var key = event.keyCode,
	                        addKeys = {},
	                        shouldAdd, shouldRemove, shouldSelect, shouldEditLastTag;
	
	                    if (tiUtil.isModifierOn(event) || hotkeys.indexOf(key) === -1) {
	                        return;
	                    }
	
	                    addKeys[KEYS.enter] = options.addOnEnter;
	                    addKeys[KEYS.comma] = options.addOnComma;
	                    addKeys[KEYS.space] = options.addOnSpace;
	
	                    shouldAdd = !options.addFromAutocompleteOnly && addKeys[key];
	                    shouldRemove = (key === KEYS.backspace || key === KEYS.delete) && tagList.selected;
	                    shouldEditLastTag = key === KEYS.backspace && scope.newTag.text().length === 0 && options.enableEditingLastTag;
	                    shouldSelect = (key === KEYS.backspace || key === KEYS.left || key === KEYS.right) && scope.newTag.text().length === 0 && !options.enableEditingLastTag;
	
	                    if (shouldAdd) {
	                        tagList.addText(scope.newTag.text());
	                    }
	                    else if (shouldEditLastTag) {
	                        tagList.selectPrior();
	                        tagList.removeSelected().then(function(tag) {
	                            if (tag) {
	                                scope.newTag.text(tag[options.displayProperty]);
	                            }
	                        });
	                    }
	                    else if (shouldRemove) {
	                        tagList.removeSelected();
	                    }
	                    else if (shouldSelect) {
	                        if (key === KEYS.left || key === KEYS.backspace) {
	                            tagList.selectPrior();
	                        }
	                        else if (key === KEYS.right) {
	                            tagList.selectNext();
	                        }
	                    }
	
	                    if (shouldAdd || shouldSelect || shouldRemove || shouldEditLastTag) {
	                        event.preventDefault();
	                    }
	                })
	                .on('input-paste', function(event) {
	                    if (options.addOnPaste) {
	                        var data = event.getTextData();
	                        var tags = data.split(options.pasteSplitPattern);
	
	                        if (tags.length > 1) {
	                            tags.forEach(function(tag) {
	                                tagList.addText(tag);
	                            });
	                            event.preventDefault();
	                        }
	                    }
	                });
	        }
	    };
	}]);
	
	
	/**
	 * @ngdoc directive
	 * @name tiTagItem
	 * @module ngTagsInput
	 *
	 * @description
	 * Represents a tag item. Used internally by the tagsInput directive.
	 */
	tagsInput.directive('tiTagItem', ["tiUtil", function(tiUtil) {
	    return {
	        restrict: 'E',
	        require: '^tagsInput',
	        template: '<ng-include src="$$template"></ng-include>',
	        scope: {
	            $scope: '=scope',
	            data: '='
	        },
	        link: function(scope, element, attrs, tagsInputCtrl) {
	            var tagsInput = tagsInputCtrl.registerTagItem(),
	                options = tagsInput.getOptions();
	
	            scope.$$template = options.template;
	            scope.$$removeTagSymbol = options.removeTagSymbol;
	
	            scope.$getDisplayText = function() {
	                return tiUtil.safeToString(scope.data[options.displayProperty]);
	            };
	            scope.$removeTag = function() {
	                tagsInput.removeTag(scope.$index);
	            };
	
	            scope.$watch('$parent.$index', function(value) {
	                scope.$index = value;
	            });
	        }
	    };
	}]);
	
	
	/**
	 * @ngdoc directive
	 * @name autoComplete
	 * @module ngTagsInput
	 *
	 * @description
	 * Provides autocomplete support for the tagsInput directive.
	 *
	 * @param {expression} source Expression to evaluate upon changing the input content. The input value is available as
	 *    $query. The result of the expression must be a promise that eventually resolves to an array of strings.
	 * @param {string=} [template=NA] URL or id of a custom template for rendering each element of the autocomplete list.
	 * @param {string=} [displayProperty=tagsInput.displayText] Property to be rendered as the autocomplete label.
	 * @param {number=} [debounceDelay=100] Amount of time, in milliseconds, to wait before evaluating the expression in
	 *    the source option after the last keystroke.
	 * @param {number=} [minLength=3] Minimum number of characters that must be entered before evaluating the expression
	 *    in the source option.
	 * @param {boolean=} [highlightMatchedText=true] Flag indicating that the matched text will be highlighted in the
	 *    suggestions list.
	 * @param {number=} [maxResultsToShow=10] Maximum number of results to be displayed at a time.
	 * @param {boolean=} [loadOnDownArrow=false] Flag indicating that the source option will be evaluated when the down arrow
	 *    key is pressed and the suggestion list is closed. The current input value is available as $query.
	 * @param {boolean=} [loadOnEmpty=false] Flag indicating that the source option will be evaluated when the input content
	 *    becomes empty. The $query variable will be passed to the expression as an empty string.
	 * @param {boolean=} [loadOnFocus=false] Flag indicating that the source option will be evaluated when the input element
	 *    gains focus. The current input value is available as $query.
	 * @param {boolean=} [selectFirstMatch=true] Flag indicating that the first match will be automatically selected once
	 *    the suggestion list is shown.
	 * @param {expression=} [matchClass=NA] Expression to evaluate for each match in order to get the CSS classes to be used.
	 *    The expression is provided with the current match as $match, its index as $index and its state as $selected. The result
	 *    of the evaluation must be one of the values supported by the ngClass directive (either a string, an array or an object).
	 *    See https://docs.angularjs.org/api/ng/directive/ngClass for more information.
	 */
	tagsInput.directive('autoComplete', ["$document", "$timeout", "$sce", "$q", "tagsInputConfig", "tiUtil", function($document, $timeout, $sce, $q, tagsInputConfig, tiUtil) {
	    function SuggestionList(loadFn, options, events) {
	        var self = {}, getDifference, lastPromise, getTagId;
	
	        getTagId = function() {
	            return options.tagsInput.keyProperty || options.tagsInput.displayProperty;
	        };
	
	        getDifference = function(array1, array2) {
	            return array1.filter(function(item) {
	                return !tiUtil.findInObjectArray(array2, item, getTagId(), function(a, b) {
	                    if (options.tagsInput.replaceSpacesWithDashes) {
	                        a = tiUtil.replaceSpacesWithDashes(a);
	                        b = tiUtil.replaceSpacesWithDashes(b);
	                    }
	                    return tiUtil.defaultComparer(a, b);
	                });
	            });
	        };
	
	        self.reset = function() {
	            lastPromise = null;
	
	            self.items = [];
	            self.visible = false;
	            self.index = -1;
	            self.selected = null;
	            self.query = null;
	        };
	        self.show = function() {
	            if (options.selectFirstMatch) {
	                self.select(0);
	            }
	            else {
	                self.selected = null;
	            }
	            self.visible = true;
	        };
	        self.load = tiUtil.debounce(function(query, tags) {
	            self.query = query;
	
	            var promise = $q.when(loadFn({ $query: query }));
	            lastPromise = promise;
	
	            promise.then(function(items) {
	                if (promise !== lastPromise) {
	                    return;
	                }
	
	                items = tiUtil.makeObjectArray(items.data || items, getTagId());
	                items = getDifference(items, tags);
	                self.items = items.slice(0, options.maxResultsToShow);
	
	                if (self.items.length > 0) {
	                    self.show();
	                }
	                else {
	                    self.reset();
	                }
	            });
	        }, options.debounceDelay);
	
	        self.selectNext = function() {
	            self.select(++self.index);
	        };
	        self.selectPrior = function() {
	            self.select(--self.index);
	        };
	        self.select = function(index) {
	            if (index < 0) {
	                index = self.items.length - 1;
	            }
	            else if (index >= self.items.length) {
	                index = 0;
	            }
	            self.index = index;
	            self.selected = self.items[index];
	            events.trigger('suggestion-selected', index);
	        };
	
	        self.reset();
	
	        return self;
	    }
	
	    function scrollToElement(root, index) {
	        var element = root.find('li').eq(index),
	            parent = element.parent(),
	            elementTop = element.prop('offsetTop'),
	            elementHeight = element.prop('offsetHeight'),
	            parentHeight = parent.prop('clientHeight'),
	            parentScrollTop = parent.prop('scrollTop');
	
	        if (elementTop < parentScrollTop) {
	            parent.prop('scrollTop', elementTop);
	        }
	        else if (elementTop + elementHeight > parentHeight + parentScrollTop) {
	            parent.prop('scrollTop', elementTop + elementHeight - parentHeight);
	        }
	    }
	
	    return {
	        restrict: 'E',
	        require: '^tagsInput',
	        scope: {
	            source: '&',
	            matchClass: '&'
	        },
	        templateUrl: 'ngTagsInput/auto-complete.html',
	        controller: ["$scope", "$element", "$attrs", function($scope, $element, $attrs) {
	            $scope.events = tiUtil.simplePubSub();
	
	            tagsInputConfig.load('autoComplete', $scope, $attrs, {
	                template: [String, 'ngTagsInput/auto-complete-match.html'],
	                debounceDelay: [Number, 100],
	                minLength: [Number, 3],
	                highlightMatchedText: [Boolean, true],
	                maxResultsToShow: [Number, 10],
	                loadOnDownArrow: [Boolean, false],
	                loadOnEmpty: [Boolean, false],
	                loadOnFocus: [Boolean, false],
	                selectFirstMatch: [Boolean, true],
	                displayProperty: [String, '']
	            });
	
	            $scope.suggestionList = new SuggestionList($scope.source, $scope.options, $scope.events);
	
	            this.registerAutocompleteMatch = function() {
	                return {
	                    getOptions: function() {
	                        return $scope.options;
	                    },
	                    getQuery: function() {
	                        return $scope.suggestionList.query;
	                    }
	                };
	            };
	        }],
	        link: function(scope, element, attrs, tagsInputCtrl) {
	            var hotkeys = [KEYS.enter, KEYS.tab, KEYS.escape, KEYS.up, KEYS.down],
	                suggestionList = scope.suggestionList,
	                tagsInput = tagsInputCtrl.registerAutocomplete(),
	                options = scope.options,
	                events = scope.events,
	                shouldLoadSuggestions;
	
	            options.tagsInput = tagsInput.getOptions();
	
	            shouldLoadSuggestions = function(value) {
	                return value && value.length >= options.minLength || !value && options.loadOnEmpty;
	            };
	
	            scope.templateScope = tagsInput.getTemplateScope();
	
	            scope.addSuggestionByIndex = function(index) {
	                suggestionList.select(index);
	                scope.addSuggestion();
	            };
	
	            scope.addSuggestion = function() {
	                var added = false;
	
	                if (suggestionList.selected) {
	                    tagsInput.addTag(angular.copy(suggestionList.selected));
	                    suggestionList.reset();
	                    added = true;
	                }
	                return added;
	            };
	
	            scope.track = function(item) {
	                return item[options.tagsInput.keyProperty || options.tagsInput.displayProperty];
	            };
	
	            scope.getSuggestionClass = function(item, index) {
	                var selected = item === suggestionList.selected;
	                return [
	                    scope.matchClass({$match: item, $index: index, $selected: selected}),
	                    { selected: selected }
	                ];
	            };
	
	            tagsInput
	                .on('tag-added tag-removed invalid-tag input-blur', function() {
	                    suggestionList.reset();
	                })
	                .on('input-change', function(value) {
	                    if (shouldLoadSuggestions(value)) {
	                        suggestionList.load(value, tagsInput.getTags());
	                    }
	                    else {
	                        suggestionList.reset();
	                    }
	                })
	                .on('input-focus', function() {
	                    var value = tagsInput.getCurrentTagText();
	                    if (options.loadOnFocus && shouldLoadSuggestions(value)) {
	                        suggestionList.load(value, tagsInput.getTags());
	                    }
	                })
	                .on('input-keydown', function(event) {
	                    var key = event.keyCode,
	                        handled = false;
	
	                    if (tiUtil.isModifierOn(event) || hotkeys.indexOf(key) === -1) {
	                        return;
	                    }
	
	                    if (suggestionList.visible) {
	
	                        if (key === KEYS.down) {
	                            suggestionList.selectNext();
	                            handled = true;
	                        }
	                        else if (key === KEYS.up) {
	                            suggestionList.selectPrior();
	                            handled = true;
	                        }
	                        else if (key === KEYS.escape) {
	                            suggestionList.reset();
	                            handled = true;
	                        }
	                        else if (key === KEYS.enter || key === KEYS.tab) {
	                            handled = scope.addSuggestion();
	                        }
	                    }
	                    else {
	                        if (key === KEYS.down && scope.options.loadOnDownArrow) {
	                            suggestionList.load(tagsInput.getCurrentTagText(), tagsInput.getTags());
	                            handled = true;
	                        }
	                    }
	
	                    if (handled) {
	                        event.preventDefault();
	                        event.stopImmediatePropagation();
	                        return false;
	                    }
	                });
	
	            events.on('suggestion-selected', function(index) {
	                scrollToElement(element, index);
	            });
	        }
	    };
	}]);
	
	
	/**
	 * @ngdoc directive
	 * @name tiAutocompleteMatch
	 * @module ngTagsInput
	 *
	 * @description
	 * Represents an autocomplete match. Used internally by the autoComplete directive.
	 */
	tagsInput.directive('tiAutocompleteMatch', ["$sce", "tiUtil", function($sce, tiUtil) {
	    return {
	        restrict: 'E',
	        require: '^autoComplete',
	        template: '<ng-include src="$$template"></ng-include>',
	        scope: {
	            $scope: '=scope',
	            data: '='
	        },
	        link: function(scope, element, attrs, autoCompleteCtrl) {
	            var autoComplete = autoCompleteCtrl.registerAutocompleteMatch(),
	                options = autoComplete.getOptions();
	
	            scope.$$template = options.template;
	            scope.$index = scope.$parent.$index;
	
	            scope.$highlight = function(text) {
	                if (options.highlightMatchedText) {
	                    text = tiUtil.safeHighlight(text, autoComplete.getQuery());
	                }
	                return $sce.trustAsHtml(text);
	            };
	            scope.$getDisplayText =  function() {
	                return tiUtil.safeToString(scope.data[options.displayProperty || options.tagsInput.displayProperty]);
	            };
	        }
	    };
	}]);
	
	
	/**
	 * @ngdoc directive
	 * @name tiTranscludeAppend
	 * @module ngTagsInput
	 *
	 * @description
	 * Re-creates the old behavior of ng-transclude. Used internally by tagsInput directive.
	 */
	tagsInput.directive('tiTranscludeAppend', function() {
	    return function(scope, element, attrs, ctrl, transcludeFn) {
	        transcludeFn(function(clone) {
	            element.append(clone);
	        });
	    };
	});
	
	/**
	 * @ngdoc directive
	 * @name tiAutosize
	 * @module ngTagsInput
	 *
	 * @description
	 * Automatically sets the input's width so its content is always visible. Used internally by tagsInput directive.
	 */
	tagsInput.directive('tiAutosize', ["tagsInputConfig", function(tagsInputConfig) {
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function(scope, element, attrs, ctrl) {
	            var threshold = tagsInputConfig.getTextAutosizeThreshold(),
	                span, resize;
	
	            span = angular.element('<span class="input"></span>');
	            span.css('display', 'none')
	                .css('visibility', 'hidden')
	                .css('width', 'auto')
	                .css('white-space', 'pre');
	
	            element.parent().append(span);
	
	            resize = function(originalValue) {
	                var value = originalValue, width;
	
	                if (angular.isString(value) && value.length === 0) {
	                    value = attrs.placeholder;
	                }
	
	                if (value) {
	                    span.text(value);
	                    span.css('display', '');
	                    width = span.prop('offsetWidth');
	                    span.css('display', 'none');
	                }
	
	                element.css('width', width ? width + threshold + 'px' : '');
	
	                return originalValue;
	            };
	
	            ctrl.$parsers.unshift(resize);
	            ctrl.$formatters.unshift(resize);
	
	            attrs.$observe('placeholder', function(value) {
	                if (!ctrl.$modelValue) {
	                    resize(value);
	                }
	            });
	        }
	    };
	}]);
	
	/**
	 * @ngdoc directive
	 * @name tiBindAttrs
	 * @module ngTagsInput
	 *
	 * @description
	 * Binds attributes to expressions. Used internally by tagsInput directive.
	 */
	tagsInput.directive('tiBindAttrs', function() {
	    return function(scope, element, attrs) {
	        scope.$watch(attrs.tiBindAttrs, function(value) {
	            angular.forEach(value, function(value, key) {
	                attrs.$set(key, value);
	            });
	        }, true);
	    };
	});
	
	/**
	 * @ngdoc service
	 * @name tagsInputConfig
	 * @module ngTagsInput
	 *
	 * @description
	 * Sets global configuration settings for both tagsInput and autoComplete directives. It's also used internally to parse and
	 *  initialize options from HTML attributes.
	 */
	tagsInput.provider('tagsInputConfig', function() {
	    var globalDefaults = {},
	        interpolationStatus = {},
	        autosizeThreshold = 3;
	
	    /**
	     * @ngdoc method
	     * @name tagsInputConfig#setDefaults
	     * @description Sets the default configuration option for a directive.
	     *
	     * @param {string} directive Name of the directive to be configured. Must be either 'tagsInput' or 'autoComplete'.
	     * @param {object} defaults Object containing options and their values.
	     *
	     * @returns {object} The service itself for chaining purposes.
	     */
	    this.setDefaults = function(directive, defaults) {
	        globalDefaults[directive] = defaults;
	        return this;
	    };
	
	    /**
	     * @ngdoc method
	     * @name tagsInputConfig#setActiveInterpolation
	     * @description Sets active interpolation for a set of options.
	     *
	     * @param {string} directive Name of the directive to be configured. Must be either 'tagsInput' or 'autoComplete'.
	     * @param {object} options Object containing which options should have interpolation turned on at all times.
	     *
	     * @returns {object} The service itself for chaining purposes.
	     */
	    this.setActiveInterpolation = function(directive, options) {
	        interpolationStatus[directive] = options;
	        return this;
	    };
	
	    /**
	     * @ngdoc method
	     * @name tagsInputConfig#setTextAutosizeThreshold
	     * @description Sets the threshold used by the tagsInput directive to re-size the inner input field element based on its contents.
	     *
	     * @param {number} threshold Threshold value, in pixels.
	     *
	     * @returns {object} The service itself for chaining purposes.
	     */
	    this.setTextAutosizeThreshold = function(threshold) {
	        autosizeThreshold = threshold;
	        return this;
	    };
	
	    this.$get = ["$interpolate", function($interpolate) {
	        var converters = {};
	        converters[String] = function(value) { return value; };
	        converters[Number] = function(value) { return parseInt(value, 10); };
	        converters[Boolean] = function(value) { return value.toLowerCase() === 'true'; };
	        converters[RegExp] = function(value) { return new RegExp(value); };
	
	        return {
	            load: function(directive, scope, attrs, options) {
	                var defaultValidator = function() { return true; };
	
	                scope.options = {};
	
	                angular.forEach(options, function(value, key) {
	                    var type, localDefault, validator, converter, getDefault, updateValue;
	
	                    type = value[0];
	                    localDefault = value[1];
	                    validator = value[2] || defaultValidator;
	                    converter = converters[type];
	
	                    getDefault = function() {
	                        var globalValue = globalDefaults[directive] && globalDefaults[directive][key];
	                        return angular.isDefined(globalValue) ? globalValue : localDefault;
	                    };
	
	                    updateValue = function(value) {
	                        scope.options[key] = value && validator(value) ? converter(value) : getDefault();
	                    };
	
	                    if (interpolationStatus[directive] && interpolationStatus[directive][key]) {
	                        attrs.$observe(key, function(value) {
	                            updateValue(value);
	                            scope.events.trigger('option-change', { name: key, newValue: value });
	                        });
	                    }
	                    else {
	                        updateValue(attrs[key] && $interpolate(attrs[key])(scope.$parent));
	                    }
	                });
	            },
	            getTextAutosizeThreshold: function() {
	                return autosizeThreshold;
	            }
	        };
	    }];
	});
	
	
	/***
	 * @ngdoc service
	 * @name tiUtil
	 * @module ngTagsInput
	 *
	 * @description
	 * Helper methods used internally by the directive. Should not be called directly from user code.
	 */
	tagsInput.factory('tiUtil', ["$timeout", "$q", function($timeout, $q) {
	    var self = {};
	
	    self.debounce = function(fn, delay) {
	        var timeoutId;
	        return function() {
	            var args = arguments;
	            $timeout.cancel(timeoutId);
	            timeoutId = $timeout(function() { fn.apply(null, args); }, delay);
	        };
	    };
	
	    self.makeObjectArray = function(array, key) {
	        if (!angular.isArray(array) || array.length === 0 || angular.isObject(array[0])) {
	            return array;
	        }
	
	        var newArray = [];
	        array.forEach(function(item) {
	            var obj = {};
	            obj[key] = item;
	            newArray.push(obj);
	        });
	        return newArray;
	    };
	
	    self.findInObjectArray = function(array, obj, key, comparer) {
	        var item = null;
	        comparer = comparer || self.defaultComparer;
	
	        array.some(function(element) {
	            if (comparer(element[key], obj[key])) {
	                item = element;
	                return true;
	            }
	        });
	
	        return item;
	    };
	
	    self.defaultComparer = function(a, b) {
	        // I'm aware of the internationalization issues regarding toLowerCase()
	        // but I couldn't come up with a better solution right now
	        return self.safeToString(a).toLowerCase() === self.safeToString(b).toLowerCase();
	    };
	
	    self.safeHighlight = function(str, value) {
	        if (!value) {
	            return str;
	        }
	
	        function escapeRegexChars(str) {
	            return str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	        }
	
	        str = self.encodeHTML(str);
	        value = self.encodeHTML(value);
	
	        var expression = new RegExp('&[^;]+;|' + escapeRegexChars(value), 'gi');
	        return str.replace(expression, function(match) {
	            return match.toLowerCase() === value.toLowerCase() ? '<em>' + match + '</em>' : match;
	        });
	    };
	
	    self.safeToString = function(value) {
	        return angular.isUndefined(value) || value == null ? '' : value.toString().trim();
	    };
	
	    self.encodeHTML = function(value) {
	        return self.safeToString(value)
	            .replace(/&/g, '&amp;')
	            .replace(/</g, '&lt;')
	            .replace(/>/g, '&gt;');
	    };
	
	    self.handleUndefinedResult = function(fn, valueIfUndefined) {
	        return function() {
	            var result = fn.apply(null, arguments);
	            return angular.isUndefined(result) ? valueIfUndefined : result;
	        };
	    };
	
	    self.replaceSpacesWithDashes = function(str) {
	        return self.safeToString(str).replace(/\s/g, '-');
	    };
	
	    self.isModifierOn = function(event) {
	        return event.shiftKey || event.ctrlKey || event.altKey || event.metaKey;
	    };
	
	    self.promisifyValue = function(value) {
	        value = angular.isUndefined(value) ? true : value;
	        return $q[value ? 'when' : 'reject']();
	    };
	
	    self.simplePubSub = function() {
	        var events = {};
	        return {
	            on: function(names, handler, first) {
	                names.split(' ').forEach(function(name) {
	                    if (!events[name]) {
	                        events[name] = [];
	                    }
	                    var method = first ? [].unshift : [].push;
	                    method.call(events[name], handler);
	                });
	                return this;
	            },
	            trigger: function(name, args) {
	                var handlers = events[name] || [];
	                handlers.every(function(handler) {
	                    return self.handleUndefinedResult(handler, true)(args);
	                });
	                return this;
	            }
	        };
	    };
	
	    return self;
	}]);
	
	/* HTML templates */
	tagsInput.run(["$templateCache", function($templateCache) {
	    $templateCache.put('ngTagsInput/tags-input.html',
	    "<div class=\"host\" tabindex=\"-1\" ng-click=\"eventHandlers.host.click()\" ti-transclude-append><div class=\"tags\" ng-class=\"{focused: hasFocus}\"><ul class=\"tag-list\"><li class=\"tag-item\" ng-repeat=\"tag in tagList.items track by track(tag)\" ng-class=\"getTagClass(tag, $index)\" ng-click=\"eventHandlers.tag.click(tag)\"><ti-tag-item scope=\"templateScope\" data=\"::tag\"></ti-tag-item></li></ul><input class=\"input\" autocomplete=\"off\" ng-model=\"newTag.text\" ng-model-options=\"{getterSetter: true}\" ng-keydown=\"eventHandlers.input.keydown($event)\" ng-focus=\"eventHandlers.input.focus($event)\" ng-blur=\"eventHandlers.input.blur($event)\" ng-paste=\"eventHandlers.input.paste($event)\" ng-trim=\"false\" ng-class=\"{'invalid-tag': newTag.invalid}\" ng-disabled=\"disabled\" ti-bind-attrs=\"{type: options.type, placeholder: options.placeholder, tabindex: options.tabindex, spellcheck: options.spellcheck}\" ti-autosize></div></div>"
	  );
	
	  $templateCache.put('ngTagsInput/tag-item.html',
	    "<span ng-bind=\"$getDisplayText()\"></span> <a class=\"remove-button\" ng-click=\"$removeTag()\" ng-bind=\"::$$removeTagSymbol\"></a>"
	  );
	
	  $templateCache.put('ngTagsInput/auto-complete.html',
	    "<div class=\"autocomplete\" ng-if=\"suggestionList.visible\"><ul class=\"suggestion-list\"><li class=\"suggestion-item\" ng-repeat=\"item in suggestionList.items track by track(item)\" ng-class=\"getSuggestionClass(item, $index)\" ng-click=\"addSuggestionByIndex($index)\" ng-mouseenter=\"suggestionList.select($index)\"><ti-autocomplete-match scope=\"templateScope\" data=\"::item\"></ti-autocomplete-match></li></ul></div>"
	  );
	
	  $templateCache.put('ngTagsInput/auto-complete-match.html',
	    "<span ng-bind-html=\"$highlight($getDisplayText())\"></span>"
	  );
	}]);
	
	}());

/***/ },
/* 180 */
/***/ function(module, exports) {

	angular.module('twitter.functions', [])
	
	.factory('$twitterApi', ['$q', '$twitterHelpers', '$http', function($q, $twitterHelpers, $http) {
	  var token;
	  var clientId = '';
	  var clientSecret = '';
	
	  var HOME_TIMELINE_URL = 'https://api.twitter.com/1.1/statuses/home_timeline.json';
	  var SEARCH_TWEETS_URL = 'https://api.twitter.com/1.1/search/tweets.json';
	  var STATUS_UPDATE_URL = 'https://api.twitter.com/1.1/statuses/update.json';
	  var STATUS_MENTIONS_URL = 'https://api.twitter.com/1.1/statuses/mentions_timeline.json';
	  var USER_TIMELINE_URL = 'https://api.twitter.com/1.1/statuses/user_timeline.json';
	  var USER_DETAILS_URL = 'https://api.twitter.com/1.1/users/show.json';
	
	  function getRequest(url, neededParams, optionalParams) {
	    var deferred = $q.defer();
	    if (typeof(optionalParams)==='undefined') optionalParams = {};
	    if (typeof(neededParams)==='undefined') neededParams = {};
	    var parameters = angular.extend(optionalParams, neededParams);
	    $twitterHelpers.createTwitterSignature('GET', url, parameters, clientId, clientSecret, token);
	
	    $http({
	        method: 'GET',
	        url: url,
	        params: parameters
	      })
	    .success(function(data, status, headers, config) {
	      deferred.resolve(data);
	    })
	    .error(function(data, status, headers, config) {
	        if (status === 401) {
	          token = null;
	        }
	        deferred.reject(status);
	    });
	    return deferred.promise;
	  }
	
	  function postRequest(url, neededParams, optionalParams) {
	    var deferred = $q.defer();
	    if (typeof(optionalParams)==='undefined') optionalParams = {};
	    var parameters = angular.extend(optionalParams, neededParams);
	
	    // // Append the bodyparams to the URL
	    var t = $twitterHelpers.createTwitterSignature('POST', url, parameters, clientId, clientSecret, token);
	    if (parameters !== {}) url = url + '?' + $twitterHelpers.transformRequest(parameters);
	
	    $http.post(url, parameters)
	    .success(function(data, status, headers, config) {
	      deferred.resolve(data);
	    })
	    .error(function(data, status, headers, config) {
	        if (status === 401) {
	          token = null;
	        }
	        deferred.reject(status);
	    });
	    return deferred.promise;
	  }
	
	  return {
	    configure: function(cId, cSecret, authToken) {
	      clientId = cId;
	      clientSecret = cSecret;
	      token = authToken;
	    },
	    getHomeTimeline: function(parameters) {
	      return getRequest(HOME_TIMELINE_URL, parameters);
	    },
	    getMentionsTimeline: function(parameters) {
	      return getRequest(STATUS_MENTIONS_URL, parameters);
	    },
	    getUserTimeline: function(parameters) {
	      return getRequest(USER_TIMELINE_URL, parameters);
	    },
	    searchTweets: function(keyword, parameters) {
	      return getRequest(SEARCH_TWEETS_URL, {q: keyword}, parameters);
	    },
	    postStatusUpdate: function(statusText, parameters) {
	      return postRequest(STATUS_UPDATE_URL, {status: statusText}, parameters);
	    },
	    getUserDetails: function(user_id, parameters) {
	      return getRequest(USER_DETAILS_URL, {user_id: user_id}, parameters);
	    },
	    getRequest: getRequest,
	    postRequest: postRequest
	  };
	}]);
	
	/*
	 * AngularJS Twitter REST Api wrapper
	 *
	 * Created by Simon Reimler
	 * http://www.devdactic.com
	 *
	 *
	 *
	 * DESCRIPTION:
	 *
	 * Configure the library with:
	 *    - Consumer Key (API Key)
	 *    - Consumer Secret (API Secret)
	 *    - Valid OAuth Token
	 *
	 *
	 *
	 * Wrapped Endpoints:
	 *
	 *    statuses/home_timeline
	 *    statuses/update
	 *    search/tweets
	 *
	 */
	
	 angular.module('ngTwitter', [
	  'twitter.functions',
	  'twitter.utils'
	]);
	
	angular.module('twitter.utils', [])
	
	.factory('$twitterHelpers', ['$q', '$http', function($q, $http) {
	
	  /* This snippet is copied from Nic Raboy's ngCordovaOauth
	  * For more information see: https://github.com/nraboy/ng-cordova-oauth
	  * Sign an Oauth 1.0 request
	  *
	  * Addition From Simon Reimler:
	  * Encode Bodyparams with escapeSpecialCharacters(), because Twitter is very strict with OAuth.
	  * See: http://stackoverflow.com/questions/14672502/bug-or-spec-change-of-twitter-api-1-1
	  *
	  * @param    string method
	  * @param    string endPoint
	  * @param    object headerParameters
	  * @param    object bodyParameters
	  * @param    string secretKey
	  * @param    string tokenSecret (optional)
	  * @return   object
	  */
	  function createSignature(method, endPoint, headerParameters, bodyParameters, secretKey, tokenSecret) {
	    if(typeof jsSHA !== "undefined") {
	      var headerAndBodyParameters = angular.copy(headerParameters);
	      var bodyParameterKeys = Object.keys(bodyParameters);
	      for(var i = 0; i < bodyParameterKeys.length; i++) {
	        headerAndBodyParameters[bodyParameterKeys[i]] = escapeSpecialCharacters(bodyParameters[bodyParameterKeys[i]]);
	      }
	      var signatureBaseString = method + "&" + encodeURIComponent(endPoint) + "&";
	      var headerAndBodyParameterKeys = (Object.keys(headerAndBodyParameters)).sort();
	      for(i = 0; i < headerAndBodyParameterKeys.length; i++) {
	        if(i == headerAndBodyParameterKeys.length - 1) {
	          signatureBaseString += encodeURIComponent(headerAndBodyParameterKeys[i] + "=" + headerAndBodyParameters[headerAndBodyParameterKeys[i]]);
	        } else {
	          signatureBaseString += encodeURIComponent(headerAndBodyParameterKeys[i] + "=" + headerAndBodyParameters[headerAndBodyParameterKeys[i]] + "&");
	        }
	      }
	      var oauthSignatureObject = new jsSHA(signatureBaseString, "TEXT");
	
	      var encodedTokenSecret = '';
	      if (tokenSecret) {
	        encodedTokenSecret = encodeURIComponent(tokenSecret);
	      }
	
	      headerParameters.oauth_signature = encodeURIComponent(oauthSignatureObject.getHMAC(encodeURIComponent(secretKey) + "&" + encodedTokenSecret, "TEXT", "SHA-1", "B64"));
	      var headerParameterKeys = Object.keys(headerParameters);
	      var authorizationHeader = 'OAuth ';
	      for(i = 0; i < headerParameterKeys.length; i++) {
	        if(i == headerParameterKeys.length - 1) {
	          authorizationHeader += headerParameterKeys[i] + '="' + headerParameters[headerParameterKeys[i]] + '"';
	        } else {
	          authorizationHeader += headerParameterKeys[i] + '="' + headerParameters[headerParameterKeys[i]] + '",';
	        }
	      }
	      return { signature_base_string: signatureBaseString, authorization_header: authorizationHeader, signature: headerParameters.oauth_signature };
	    } else {
	      return "Missing jsSHA JavaScript library";
	    }
	  }
	
	  /* This snippet is copied from Nic Raboy's ngCordovaOauth
	  * For more information see: https://github.com/nraboy/ng-cordova-oauth
	  *
	  * Create Random String Nonce
	  *
	  * @param    integer length
	  * @return   string
	  */
	  function createNonce(length) {
	    var text = "";
	    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	    for(var i = 0; i < length; i++) {
	      text += possible.charAt(Math.floor(Math.random() * possible.length));
	    }
	    return text;
	  }
	
	  function escapeSpecialCharacters(string) {
	    var tmp = encodeURIComponent(string);
	    tmp = tmp.replace(/\!/g, "%21");
	    tmp = tmp.replace(/\'/g, "%27");
	    tmp = tmp.replace(/\(/g, "%28");
	    tmp = tmp.replace(/\)/g, "%29");
	    tmp = tmp.replace(/\*/g, "%2A");
	    return tmp;
	  }
	
	  function transformRequest(obj) {
	      var str = [];
	      for(var p in obj)
	      str.push(encodeURIComponent(p) + "=" + escapeSpecialCharacters(obj[p]));
	      console.log(str.join('&'));
	      return str.join('&');
	  }
	
	  return {
	    createTwitterSignature: function(method, url, bodyParameters, clientId, clientSecret, token) {
	      var oauthObject = {
	        oauth_consumer_key: clientId,
	        oauth_nonce: createNonce(10),
	        oauth_signature_method: "HMAC-SHA1",
	        oauth_token: token.oauth_token,
	        oauth_timestamp: Math.round((new Date()).getTime() / 1000.0),
	        oauth_version: "1.0"
	      };
	      var signatureObj = createSignature(method, url, oauthObject, bodyParameters, clientSecret, token.oauth_token_secret);
	      $http.defaults.headers.common.Authorization = signatureObj.authorization_header;
	      return signatureObj;
	    },
	    transformRequest: transformRequest
	  };
	}]);


/***/ },
/* 181 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A directive for adding google places autocomplete to a text box
	 * google places autocomplete info: https://developers.google.com/maps/documentation/javascript/places
	 *
	 * Usage:
	 *
	 * <input type="text"  ng-autocomplete ng-model="autocomplete" options="options" details="details/>
	 *
	 * + ng-model - autocomplete textbox value
	 *
	 * + details - more detailed autocomplete result, includes address parts, latlng, etc. (Optional)
	 *
	 * + options - configuration for the autocomplete (Optional)
	 *
	 *       + types: type,        String, values can be 'geocode', 'establishment', '(regions)', or '(cities)'
	 *       + bounds: bounds,     Google maps LatLngBounds Object, biases results to bounds, but may return results outside these bounds
	 *       + country: country    String, ISO 3166-1 Alpha-2 compatible country code. examples; 'ca', 'us', 'gb'
	 *       + watchEnter:         Boolean, true; on Enter select top autocomplete result. false(default); enter ends autocomplete
	 *
	 * example:
	 *
	 *    options = {
	 *        types: '(cities)',
	 *        country: 'ca'
	 *    }
	**/
	
	angular.module( "ngAutocomplete", [])
	  .directive('ngAutocomplete', function() {
	    return {
	      require: 'ngModel',
	      scope: {
	        ngModel: '=',
	        options: '=?',
	        details: '=?'
	      },
	
	      link: function(scope, element, attrs, controller) {
	
	        //options for autocomplete
	        var opts
	        var watchEnter = false
	        //convert options provided to opts
	        var initOpts = function() {
	
	          opts = {}
	          if (scope.options) {
	
	            if (scope.options.watchEnter !== true) {
	              watchEnter = false
	            } else {
	              watchEnter = true
	            }
	
	            if (scope.options.types) {
	              opts.types = []
	              opts.types.push(scope.options.types)
	              scope.gPlace.setTypes(opts.types)
	            } else {
	              scope.gPlace.setTypes([])
	            }
	
	            if (scope.options.bounds) {
	              opts.bounds = scope.options.bounds
	              scope.gPlace.setBounds(opts.bounds)
	            } else {
	              scope.gPlace.setBounds(null)
	            }
	
	            if (scope.options.country) {
	              opts.componentRestrictions = {
	                country: scope.options.country
	              }
	              scope.gPlace.setComponentRestrictions(opts.componentRestrictions)
	            } else {
	              scope.gPlace.setComponentRestrictions(null)
	            }
	          }
	        }
	
	        if (scope.gPlace == undefined) {
	          scope.gPlace = new google.maps.places.Autocomplete(element[0], {});
	        }
	        google.maps.event.addListener(scope.gPlace, 'place_changed', function() {
	          var result = scope.gPlace.getPlace();
	          if (result !== undefined) {
	            if (result.address_components !== undefined) {
	
	              scope.$apply(function() {
	
	                scope.details = result;
	
	                controller.$setViewValue(element.val());
	              });
	            }
	            else {
	              if (watchEnter) {
	                getPlace(result)
	              }
	            }
	          }
	        })
	
	        //function to get retrieve the autocompletes first result using the AutocompleteService 
	        var getPlace = function(result) {
	          var autocompleteService = new google.maps.places.AutocompleteService();
	          if (result.name.length > 0){
	            autocompleteService.getPlacePredictions(
	              {
	                input: result.name,
	                offset: result.name.length
	              },
	              function listentoresult(list, status) {
	                if(list == null || list.length == 0) {
	
	                  scope.$apply(function() {
	                    scope.details = null;
	                  });
	
	                } else {
	                  var placesService = new google.maps.places.PlacesService(element[0]);
	                  placesService.getDetails(
	                    {'reference': list[0].reference},
	                    function detailsresult(detailsResult, placesServiceStatus) {
	
	                      if (placesServiceStatus == google.maps.GeocoderStatus.OK) {
	                        scope.$apply(function() {
	
	                          controller.$setViewValue(detailsResult.formatted_address);
	                          element.val(detailsResult.formatted_address);
	
	                          scope.details = detailsResult;
	
	                          //on focusout the value reverts, need to set it again.
	                          var watchFocusOut = element.on('focusout', function(event) {
	                            element.val(detailsResult.formatted_address);
	                            element.unbind('focusout')
	                          })
	
	                        });
	                      }
	                    }
	                  );
	                }
	              });
	          }
	        }
	
	        controller.$render = function () {
	          var location = controller.$viewValue;
	          element.val(location);
	        };
	
	        //watch options provided to directive
	        scope.watchOptions = function () {
	          return scope.options
	        };
	        scope.$watch(scope.watchOptions, function () {
	          initOpts()
	        }, true);
	
	      }
	    };
	  });

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(4)):"function"==typeof define&&define.amd?define(["angular"],t):t(e.angular)}(this,function(e){"use strict";e.module("ngWYSIWYG",["ngSanitize"]),e.module("ngWYSIWYG").config(["$provide",function(e){e.decorator("$sanitize",["$delegate","$log",function(e,t){return function(t,n){var o=e(t,n);return o}}])}]),e.module("ngWYSIWYG").constant("NGP_EVENTS",{ELEMENT_CLICKED:"ngp-element-clicked",CLICK_AWAY:"ngp-click-away"}),e.module("ngWYSIWYG").directive("ngpColorsGrid",["NGP_EVENTS",function(e){var t=function(t,n){t.$on(e.CLICK_AWAY,function(){t.$apply(function(){t.show=!1})}),n.parent().bind("click",function(e){e.stopPropagation()}),t.colors=["#000000","#993300","#333300","#003300","#003366","#000080","#333399","#333333","#800000","#FF6600","#808000","#008000","#008080","#0000FF","#666699","#808080","#FF0000","#FF9900","#99CC00","#339966","#33CCCC","#3366FF","#800080","#999999","#FF00FF","#FFCC00","#FFFF00","#00FF00","#00FFFF","#00CCFF","#993366","#C0C0C0","#FF99CC","#FFCC99","#FFFF99","#CCFFCC","#CCFFFF","#99CCFF","#CC99FF","#FFFFFF"],t.pick=function(e){t.onPick({color:e})},n.ready(function(){function e(t){1==t.nodeType&&(t.setAttribute("unselectable","on"),t.unselectable="on");for(var n=t.firstChild;n;)e(n),n=n.nextSibling}for(var t=0;t<document.getElementsByClassName("ngp-colors-grid").length;t+=1)e(document.getElementsByClassName("ngp-colors-grid")[t])})};return{link:t,scope:{show:"=",onPick:"&"},restrict:"AE",template:'<ul ng-show="show" class="ngp-colors-grid"><li ng-style="{\'background-color\': color}" title: "{{color}}" ng-repeat="color in colors" unselectable="on" ng-click="pick(color)"></li></ul>'}}]),e.module("ngWYSIWYG").directive("ngpSymbolsGrid",["NGP_EVENTS",function(e){var t=function(t,n){t.$on(e.CLICK_AWAY,function(){t.$apply(function(){t.show=!1})}),n.parent().bind("click",function(e){e.stopPropagation()}),t.symbols=["&iexcl;","&iquest;","&ndash;","&mdash;","&raquo;","&laquo;","&copy;","&divide;","&micro;","&para;","&plusmn;","&cent;","&euro;","&pound;","&reg;","&sect;","&trade;","&yen;","&deg;","&forall;","&part;","&exist;","&empty;","&nabla;","&isin;","&notin;","&ni;","&prod;","&sum;","&uarr;","&rarr;","&darr;","&spades;","&clubs;","&hearts;","&diams;","&aacute;","&agrave;","&acirc;","&aring;","&atilde;","&auml;","&aelig;","&ccedil;","&eacute;","&egrave;","&ecirc;","&euml;","&iacute;","&igrave;","&icirc;","&iuml;","&ntilde;","&oacute;","&ograve;","&ocirc;","&oslash;","&otilde;","&ouml;","&szlig;","&uacute;","&ugrave;","&ucirc;","&uuml;","&yuml;"],t.pick=function(e){t.onPick({symbol:e})},n.ready(function(){function e(t){1==t.nodeType&&(t.setAttribute("unselectable","on"),t.unselectable="on");for(var n=t.firstChild;n;)e(n),n=n.nextSibling}for(var t=0;t<document.getElementsByClassName("ngp-symbols-grid").length;t+=1)e(document.getElementsByClassName("ngp-symbols-grid")[t])})};return{link:t,scope:{show:"=",onPick:"&"},restrict:"AE",template:'<ul ng-show="show" class="ngp-symbols-grid"><li ng-repeat="symbol in symbols" unselectable="on" ng-click="pick(symbol)" ng-bind-html="symbol"></li></ul>'}}]),e.module("ngWYSIWYG").service("ngpImageResizer",["NGP_EVENTS",function(e){function t(e){e.preventDefault()}function n(e){e.preventDefault(),e.stopPropagation(),v.style.height="",v.style.width="",l()}function o(e){e.preventDefault(),e.stopPropagation(),v.style.width="100%",v.style.height="",l()}function i(e){return e.target!=y?(c.removeEventListener("mousemove",r),void(h=!1)):(e.stopPropagation(),e.preventDefault(),c.addEventListener("mousemove",r),void(h=!0))}function r(e){e.stopPropagation(),e.preventDefault();var t=e.pageY,n=t-(v.getBoundingClientRect().top+d.pageYOffset);v.style.height=n+"px",v.style.width="",g&&e.clientY>g&&d.innerHeight-e.clientY<=45&&d.scrollTo(0,d.innerHeight),g=e.clientY,l()}function a(e,t){return t==p||h?void c.removeEventListener("mousemove",r):"IMG"!==t.tagName?s():(p.parentNode||u.appendChild(p),v=t,void l())}function l(){var e=d.getComputedStyle(v);p.style.height=e.getPropertyValue("height"),p.style.width=e.getPropertyValue("width"),p.style.top=v.getBoundingClientRect().top+d.pageYOffset+"px",p.style.left=v.getBoundingClientRect().left+d.pageXOffset+"px",p.style.display="block"}function s(e){p.parentNode&&(e&&"IMG"===e.target.tagName||(p.style.display="none",g=null))}var c,d,u,p,g,m,y,f,h,v,b=this;b.setup=function(r,l){d=l.defaultView,c=l,u=c.querySelector("body"),m=r,p=c.createElement("div"),p.className="ngp-image-resizer",p.style.position="absolute",p.style.border="1px dashed black",p.style.display="none",p.setAttribute("contenteditable",!1),y=c.createElement("div"),y.style.position="absolute",y.style.height="10px",y.style.width="10px",y.style.bottom="-5px",y.style.right="-5px",y.style.border="1px solid black",y.style.backgroundColor="#fff",y.style.cursor="se-resize",y.setAttribute("contenteditable",!1),p.appendChild(y),f=c.createElement("div"),f.style.position="absolute",f.style.height="30px",f.style.width="150px",f.style.bottom="-30px",f.style.left="0",p.appendChild(f);var g=c.createElement("button");g.addEventListener("click",n),g.innerHTML="Auto",f.appendChild(g);var h=c.createElement("button");h.addEventListener("click",o),h.innerHTML="100%",f.appendChild(h),c.addEventListener("mousedown",i),c.addEventListener("mouseup",i),d.parent.document.addEventListener("mouseup",i),u.addEventListener("mscontrolselect",t),m.$on(e.ELEMENT_CLICKED,a),m.$on(e.CLICK_AWAY,s)}}]);var t='<div class="tinyeditor"><div class="tinyeditor-header" ng-hide="editMode">{toolbar}<div style="clear: both;"></div></div><div class="sizer" ngp-resizable><textarea data-placeholder-attr="" style="-webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box; resize: none; width: 100%; height: 100%;" ng-show="editMode" ng-model="content"></textarea><iframe style="-webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box; width: 100%; height: 100%;" ng-hide="editMode" ngp-content-frame="{sanitize: config.sanitize}" content-style="{contentStyle}" ng-model="content"></iframe></div><div class="tinyeditor-footer"><div ng-switch="editMode" ng-click="editMode = !editMode" class="toggle"><span ng-switch-when="true">wysiwyg</span><span ng-switch-default>source</span></div></div></div>';return e.module("ngWYSIWYG").directive("wysiwygEdit",["ngpUtils","NGP_EVENTS","$rootScope","$compile","$timeout","$q",function(n,o,i,r,a,l){var s=function(a,s,c,d){function u(){null==m&&(m=document.querySelector("wysiwyg-edit").querySelector("iframe"),y=m.contentDocument,f=y.defaultView)}function p(e){a.$broadcast("insertElement",e)}function g(e){var t="<"+e.type;if(t+=' class="'+e["class"],h&&(t+=" tinyeditor-control-fa"),t+='" ',"div"==e.type){if(e.title&&(t+='title="'+e.title+'" '),e.backgroundPos&&!h&&(t+='style="background-position: '+e.backgroundPos+'; position: relative;" '),e.pressed&&(t+="ng-class=\"{'pressed': cursorStyle."+e.pressed+'}" '),e.command){var n="'"+e.command+"'";e.commandParameter&&(n+=", '"+e.commandParameter+"'"),t+='ng-click="execCommand('+n+')" '}else e.specialCommand&&(t+='ng-click="'+e.specialCommand+'" ');t+=">",e.faIcon&&h&&"-"!=e.faIcon&&(t+='<i class="fa fa-'+e.faIcon+'"></i>'),e.faIcon&&h&&"-"==e.faIcon&&(t+='<div class="hr"></div>'),e.inner&&(t+=e.inner)}else"select"==e.type&&(t+='ng-model="'+e.model+'" ',t+='ng-options="'+e.options+'" ',t+='ng-change="'+e.change+'" ',t+='<option value="">'+e.title+"</option>");return t+="</"+e.type+">"}a.editMode=!1,a.cursorStyle={},document.addEventListener("click",function(){i.$broadcast(o.CLICK_AWAY)});var m=null,y=null,f=null;a.panelButtons={"-":{type:"div","class":"tinyeditor-divider"},bold:{type:"div",title:"Bold","class":"tinyeditor-control",faIcon:"bold",backgroundPos:"34px -120px",pressed:"bold",command:"bold"},italic:{type:"div",title:"Italic","class":"tinyeditor-control",faIcon:"italic",backgroundPos:"34px -150px",pressed:"italic",command:"italic"},underline:{type:"div",title:"Underline","class":"tinyeditor-control",faIcon:"underline",backgroundPos:"34px -180px",pressed:"underline",command:"underline"},strikethrough:{type:"div",title:"Strikethrough","class":"tinyeditor-control",faIcon:"strikethrough",backgroundPos:"34px -210px",pressed:"strikethrough",command:"strikethrough"},subscript:{type:"div",title:"Subscript","class":"tinyeditor-control",faIcon:"subscript",backgroundPos:"34px -240px",pressed:"sub",command:"subscript"},superscript:{type:"div",title:"Superscript","class":"tinyeditor-control",faIcon:"superscript",backgroundPos:"34px -270px",pressed:"super",command:"superscript"},leftAlign:{type:"div",title:"Left Align","class":"tinyeditor-control",faIcon:"align-left",backgroundPos:"34px -420px",pressed:"alignmet == 'left'",command:"justifyleft"},centerAlign:{type:"div",title:"Center Align","class":"tinyeditor-control",faIcon:"align-center",backgroundPos:"34px -450px",pressed:"alignment == 'center'",command:"justifycenter"},rightAlign:{type:"div",title:"Right Align","class":"tinyeditor-control",faIcon:"align-right",backgroundPos:"34px -480px",pressed:"alignment == 'right'",command:"justifyright"},blockJustify:{type:"div",title:"Block Justify","class":"tinyeditor-control",faIcon:"align-justify",backgroundPos:"34px -510px",pressed:"alignment == 'justify'",command:"justifyfull"},orderedList:{type:"div",title:"Insert Ordered List","class":"tinyeditor-control",faIcon:"list-ol",backgroundPos:"34px -300px",command:"insertorderedlist"},unorderedList:{type:"div",title:"Insert Unordered List","class":"tinyeditor-control",faIcon:"list-ul",backgroundPos:"34px -330px",command:"insertunorderedlist"},outdent:{type:"div",title:"Outdent","class":"tinyeditor-control",faIcon:"outdent",backgroundPos:"34px -360px",command:"outdent"},indent:{type:"div",title:"Indent","class":"tinyeditor-control",faIcon:"indent",backgroundPos:"34px -390px",command:"indent"},removeFormatting:{type:"div",title:"Remove Formatting","class":"tinyeditor-control",faIcon:"eraser",backgroundPos:"34px -720px",command:"removeformat"},undo:{type:"div",title:"Undo","class":"tinyeditor-control",faIcon:"undo",backgroundPos:"34px -540px",command:"undo"},redo:{type:"div",title:"Redo","class":"tinyeditor-control",faIcon:"repeat",backgroundPos:"34px -570px",command:"redo"},fontColor:{type:"div",title:"Font Color","class":"tinyeditor-control",faIcon:"font",backgroundPos:"34px -779px",specialCommand:"showFontColors = !showFontColors",inner:'<ngp-colors-grid show="showFontColors" on-pick="setFontColor(color)"><ngp-colors-grid>'},backgroundColor:{type:"div",title:"Background Color","class":"tinyeditor-control",faIcon:"paint-brush",backgroundPos:"34px -808px",specialCommand:"showBgColors = !showBgColors",inner:'<ngp-colors-grid show="showBgColors" on-pick="setBgColor(color)"><ngp-colors-grid>'},image:{type:"div",title:"Insert Image","class":"tinyeditor-control",faIcon:"picture-o",backgroundPos:"34px -600px",specialCommand:"insertImage()"},hr:{type:"div",title:"Insert Horizontal Rule","class":"tinyeditor-control",faIcon:"-",backgroundPos:"34px -630px",command:"inserthorizontalrule"},symbols:{type:"div",title:"Insert Special Symbol","class":"tinyeditor-control",faIcon:"cny",backgroundPos:"34px -838px",specialCommand:"showSpecChars = !showSpecChars",inner:'<ngp-symbols-grid show="showSpecChars" on-pick="insertSpecChar(symbol)"><ngp-symbols-grid>'},link:{type:"div",title:"Insert Hyperlink","class":"tinyeditor-control",faIcon:"link",backgroundPos:"34px -660px",specialCommand:"insertLink()"},unlink:{type:"div",title:"Remove Hyperlink","class":"tinyeditor-control",faIcon:"chain-broken",backgroundPos:"34px -690px",command:"unlink"},print:{type:"div",title:"Print","class":"tinyeditor-control",faIcon:"print",backgroundPos:"34px -750px",command:"print"},font:{type:"select",title:"Font","class":"tinyeditor-font",model:"font",options:"a as a for a in fonts",change:"fontChange()"},size:{type:"select",title:"Size","class":"tinyeditor-size",model:"fontsize",options:"a.key as a.name for a in fontsizes",change:"sizeChange()"},format:{type:"select",title:"Style","class":"tinyeditor-size",model:"textstyle",options:"s.key as s.name for s in styles",change:"styleChange()"}};var h=a.config&&a.config.fontAwesome;a.toolbar=a.config&&a.config.toolbar?a.config.toolbar:[{name:"basicStyling",items:["bold","italic","underline","strikethrough","subscript","superscript","leftAlign","centerAlign","rightAlign","blockJustify","-"]},{name:"paragraph",items:["orderedList","unorderedList","outdent","indent","-"]},{name:"doers",items:["removeFormatting","undo","redo","-"]},{name:"colors",items:["fontColor","backgroundColor","-"]},{name:"links",items:["image","hr","symbols","link","unlink","-"]},{name:"tools",items:["print","-"]},{name:"styling",items:["font","size","format"]}];var v=[];e.forEach(a.toolbar,function(t,n){var o=[];e.forEach(t.items,function(e,t){var n=a.panelButtons[e];n||(n=a.config.buttons[e]),this.push(g(n))},o),this.push('<div class="tinyeditor-buttons-group">'+o.join("")+"</div>")},v);var b=t.replace("{toolbar}",v.join(""));b=b.replace("{contentStyle}",c.contentStyle||""),s.html(b),r(s.contents())(a),a.execCommand=function(e,t){switch(e){case"bold":a.cursorStyle.bold=!a.cursorStyle.bold;break;case"italic":a.cursorStyle.italic=!a.cursorStyle.italic;break;case"underline":a.cursorStyle.underline=!a.cursorStyle.underline;break;case"strikethrough":a.cursorStyle.strikethrough=!a.cursorStyle.strikethrough;break;case"subscript":a.cursorStyle.sub=!a.cursorStyle.sub;break;case"superscript":a.cursorStyle["super"]=!a.cursorStyle["super"];break;case"justifyleft":a.cursorStyle.alignment="left";break;case"justifycenter":a.cursorStyle.alignment="center";break;case"justifyright":a.cursorStyle.alignment="right";break;case"justifyfull":a.cursorStyle.alignment="justify"}a.$broadcast("execCommand",{command:e,arg:t})},a.fonts=["Verdana","Arial","Arial Black","Arial Narrow","Courier New","Century Gothic","Comic Sans MS","Georgia","Impact","Tahoma","Times","Times New Roman","Webdings","Trebuchet MS"],a.fontChange=function(){a.execCommand("fontname",a.font)},a.fontsizes=[{key:1,name:"x-small"},{key:2,name:"small"},{key:3,name:"normal"},{key:4,name:"large"},{key:5,name:"x-large"},{key:6,name:"xx-large"},{key:7,name:"xxx-large"}],a.mapFontSize={10:1,13:2,16:3,18:4,24:5,32:6,48:7},a.sizeChange=function(){a.execCommand("fontsize",a.fontsize)},a.styles=[{name:"Paragraph",key:"<p>"},{name:"Header 1",key:"<h1>"},{name:"Header 2",key:"<h2>"},{name:"Header 3",key:"<h3>"},{name:"Header 4",key:"<h4>"},{name:"Header 5",key:"<h5>"},{name:"Header 6",key:"<h6>"}],a.styleChange=function(){a.execCommand("formatblock",a.textstyle)},a.showFontColors=!1,a.setFontColor=function(e){a.execCommand("foreColor",e)},a.showBgColors=!1,a.setBgColor=function(e){a.execCommand("hiliteColor",e)},a.showSpecChars=!1,a.insertSpecChar=function(e){p(e)},a.insertLink=function(){if(u(),null!=f.getSelection().focusNode){var t=n.getSelectionBoundaryElement(f,!0),o="http://";if(t&&"A"==t.nodeName){o=t.href;var i=y.createRange();i.setStart(t.firstChild,0),i.setEnd(t.firstChild,t.firstChild.length);var r=f.getSelection();r.removeAllRanges(),r.addRange(i)}var s;s=a.api&&a.api.insertLink&&e.isFunction(a.api.insertLink)?a.api.insertLink.apply(a.api.scope||null,[o]):prompt("Please enter the URL","http://"),l.when(s).then(function(e){a.execCommand("createlink",e)})}},a.insertImage=function(){var t;a.api&&a.api.insertImage&&e.isFunction(a.api.insertImage)?t=a.api.insertImage.apply(a.api.scope||null):(t=prompt("Please enter the picture URL","http://"),t='<img src="'+t+'">'),l.when(t).then(function(e){p(e)})},s.ready(function(){function e(t){1==t.nodeType&&(t.setAttribute("unselectable","on"),t.unselectable="on");for(var n=t.firstChild;n;)e(n),n=n.nextSibling}for(var t=0;t<document.getElementsByClassName("tinyeditor-header").length;t+=1)e(document.getElementsByClassName("tinyeditor-header")[t])}),a.$on("cursor-position",function(e,t){a.cursorStyle=t,a.font=t.font.replace(/(')/g,""),a.fontsize=a.mapFontSize[t.size]?a.mapFontSize[t.size]:0})};return{link:s,scope:{content:"=",api:"=",config:"="},restrict:"AE",replace:!0}}]),e.module("ngWYSIWYG").directive("ngpContentFrame",["ngpImageResizer","ngpUtils","NGP_EVENTS","$compile","$timeout","$sanitize",function(t,n,o,i,r,a){var l=function(i,l,s,c){var d=l[0].contentDocument;d.open(),d.write('<!DOCTYPE html><html><head></head><body contenteditable="true"></body></html>'),d.close(),d.designMode="On",t.setup(i,d);var u=e.element(l[0].contentDocument.body),p=e.element(l[0].contentDocument.head);u.attr("contenteditable","true"),d.addEventListener("click",function(e){"HTML"===e.target.tagName&&e.target.querySelector("body").focus(),i.$emit(o.ELEMENT_CLICKED,e.target)}),s.contentStyle&&p.append('<link rel="stylesheet" type="text/css" href="'+s.contentStyle+'">'),c.$render=function(){u[0].innerHTML=c.$viewValue?i.config&&i.config.sanitize?a(c.$viewValue):c.$viewValue:""},i.sync=function(){i.$evalAsync(function(e){c.$setViewValue(u.html())})};var g=null;u.bind("click keyup change paste",function(){g&&r.cancel(g),g=r(function(){var e=u[0].ownerDocument,t=e.querySelector(".ngp-image-resizer"),o=u[0].innerHTML;t&&(o=o.replace(t.outerHTML,"")),c.$setViewValue(o);var r=n.getSelectionBoundaryElement(l[0].contentWindow,!0);if(r){var a=l[0].contentWindow.getComputedStyle(r),s={bold:"bold"==a.getPropertyValue("font-weight")||parseInt(a.getPropertyValue("font-weight"))>=700,italic:"italic"==a.getPropertyValue("font-style"),underline:"underline"==a.getPropertyValue("text-decoration"),strikethrough:"line-through"==a.getPropertyValue("text-decoration"),font:a.getPropertyValue("font-family"),size:parseInt(a.getPropertyValue("font-size")),color:a.getPropertyValue("color"),sub:"sub"==a.getPropertyValue("vertical-align"),"super":"super"==a.getPropertyValue("vertical-align"),background:a.getPropertyValue("background-color"),alignment:a.getPropertyValue("text-align")};i.$emit("cursor-position",s)}},100,!0)}),i.range=null,i.getSelection=function(){if(d.getSelection){var e=d.getSelection();e.getRangeAt&&e.rangeCount&&(i.range=e.getRangeAt(0))}},i.restoreSelection=function(){if(i.range&&d.getSelection){var e=d.getSelection();e.removeAllRanges(),e.addRange(i.range)}},i.$on("execCommand",function(e,t){console.log("execCommand: "),console.log(t),l[0].contentDocument.body.focus();var n=d.selection;if(n){var o=n.createRange();d.execCommand(t.command,0,t.arg),o.collapse(!1),o.select()}else d.execCommand(t.command,0,t.arg);d.body.focus(),i.sync()}),i.$on("insertElement",function(e,t){var n,o;if(d.defaultView.getSelection){if(n=d.defaultView.getSelection(),n.getRangeAt&&n.rangeCount){o=n.getRangeAt(0),o.deleteContents();var r=d.createElement("div");r.innerHTML=t;for(var a,l,s=d.createDocumentFragment();a=r.firstChild;)l=s.appendChild(a);s.firstChild;o.insertNode(s),l&&(o=o.cloneRange(),o.setStartAfter(l),o.collapse(!0),n.removeAllRanges(),n.addRange(o))}}else d.selection&&"Control"!=d.selection.type&&d.selection.createRange().pasteHTML(t);i.sync()}),i.$on("$destroy",function(){});try{d.execCommand("styleWithCSS",0,0),d.execCommand("enableObjectResizing",!1,"false"),d.execCommand("contentReadOnly",0,"false")}catch(m){try{d.execCommand("useCSS",0,1)}catch(m){}}};return{link:l,require:"ngModel",scope:{config:"=ngpContentFrame"},replace:!0,restrict:"AE"}}]),e.module("ngWYSIWYG").directive("ngpResizable",["$document",function(e){return function(t,n){var o=e[0],i=n[0],r=o.createElement("span");r.className="resizer",i.appendChild(r),r.addEventListener("mousedown",function(){function e(e){e.preventDefault();var t=e.pageY;e.view!=o.defaultView&&(t=e.pageY+e.view.frameElement.getBoundingClientRect().top+o.defaultView.pageYOffset);var n=t-(i.getBoundingClientRect().top+o.defaultView.pageYOffset),r=i.style.height.replace("px","");r&&n>r&&window.innerHeight-e.clientY<=45&&o.defaultView.scrollBy(0,n-r),i.style.height=n+"px"}function t(){o.removeEventListener("mousemove",e),o.removeEventListener("mouseup",t);for(var n=o.querySelectorAll("iframe"),i=0;i<n.length;i++)n[i].contentWindow.document.removeEventListener("mouseup",t),n[i].contentWindow.document.removeEventListener("mousemove",e)}o.addEventListener("mousemove",e),o.addEventListener("mouseup",t);for(var n=o.querySelectorAll("iframe"),r=0;r<n.length;r++)n[r].contentWindow.document.addEventListener("mouseup",t),n[r].contentWindow.document.addEventListener("mousemove",e)})}}]),e.module("ngWYSIWYG").service("ngpUtils",[function(){var e=this;e.getSelectionBoundaryElement=function(e,t){var n,o,i=null,r=e.document;return r.selection?(n=r.selection.createRange(),n.collapse(t),n.parentElement()):(r.getSelection?(o=r.getSelection(),o.rangeCount>0&&(n=o.getRangeAt(0),i=n[t?"startContainer":"endContainer"],3===i.nodeType&&(i=i.parentNode))):e.getSelection&&(o=e.getSelection(),o.rangeCount>0&&(n=o.getRangeAt(0),i=n[t?"startContainer":"endContainer"],3===i.nodeType&&(i=i.parentNode))),i)}}]),"ngWYSIWYG"});

/***/ },
/* 183 */
/***/ function(module, exports) {

	/**
	 * Restful Resources service for AngularJS apps
	 * @version v1.5.2 - 2016-02-08 * @link https://github.com/mgonto/restangular
	 * @author Martin Gontovnikas <martin@gon.to>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */(function() {
	
	var restangular = angular.module('restangular', []);
	
	restangular.provider('Restangular', function() {
	  // Configuration
	  var Configurer = {};
	  Configurer.init = function(object, config) {
	    object.configuration = config;
	
	    /**
	     * Those are HTTP safe methods for which there is no need to pass any data with the request.
	     */
	    var safeMethods= ['get', 'head', 'options', 'trace', 'getlist'];
	    config.isSafe = function(operation) {
	      return _.includes(safeMethods, operation.toLowerCase());
	    };
	
	    var absolutePattern = /^https?:\/\//i;
	    config.isAbsoluteUrl = function(string) {
	      return _.isUndefined(config.absoluteUrl) || _.isNull(config.absoluteUrl) ?
	              string && absolutePattern.test(string) :
	              config.absoluteUrl;
	    };
	
	    config.absoluteUrl = _.isUndefined(config.absoluteUrl) ? true : config.absoluteUrl;
	    object.setSelfLinkAbsoluteUrl = function(value) {
	      config.absoluteUrl = value;
	    };
	    /**
	     * This is the BaseURL to be used with Restangular
	     */
	    config.baseUrl = _.isUndefined(config.baseUrl) ? '' : config.baseUrl;
	    object.setBaseUrl = function(newBaseUrl) {
	      config.baseUrl = /\/$/.test(newBaseUrl) ?
	        newBaseUrl.substring(0, newBaseUrl.length-1) :
	        newBaseUrl;
	      return this;
	    };
	
	    /**
	     * Sets the extra fields to keep from the parents
	     */
	    config.extraFields = config.extraFields || [];
	    object.setExtraFields = function(newExtraFields) {
	      config.extraFields = newExtraFields;
	      return this;
	    };
	
	    /**
	     * Some default $http parameter to be used in EVERY call
	    **/
	    config.defaultHttpFields = config.defaultHttpFields || {};
	    object.setDefaultHttpFields = function(values) {
	      config.defaultHttpFields = values;
	      return this;
	    };
	
	    config.withHttpValues = function(httpLocalConfig, obj) {
	      return _.defaults(obj, httpLocalConfig, config.defaultHttpFields);
	    };
	
	    config.encodeIds = _.isUndefined(config.encodeIds) ? true : config.encodeIds;
	    object.setEncodeIds = function(encode) {
	      config.encodeIds = encode;
	    };
	
	    config.defaultRequestParams = config.defaultRequestParams || {
	      get: {},
	      post: {},
	      put: {},
	      remove: {},
	      common: {}
	    };
	
	    object.setDefaultRequestParams = function(param1, param2) {
	      var methods = [],
	          params = param2 || param1;
	      if (!_.isUndefined(param2)) {
	        if (_.isArray(param1)) {
	          methods = param1;
	        } else {
	          methods.push(param1);
	        }
	      } else {
	        methods.push('common');
	      }
	
	      _.each(methods, function (method) {
	        config.defaultRequestParams[method] = params;
	      });
	      return this;
	    };
	
	    object.requestParams = config.defaultRequestParams;
	
	    config.defaultHeaders = config.defaultHeaders || {};
	    object.setDefaultHeaders = function(headers) {
	      config.defaultHeaders = headers;
	      object.defaultHeaders = config.defaultHeaders;
	      return this;
	    };
	
	    object.defaultHeaders = config.defaultHeaders;
	
	    /**
	     * Method overriders will set which methods are sent via POST with an X-HTTP-Method-Override
	     **/
	    config.methodOverriders = config.methodOverriders || [];
	    object.setMethodOverriders = function(values) {
	      var overriders = _.extend([], values);
	      if (config.isOverridenMethod('delete', overriders)) {
	        overriders.push('remove');
	      }
	      config.methodOverriders = overriders;
	      return this;
	    };
	
	    config.jsonp = _.isUndefined(config.jsonp) ? false : config.jsonp;
	    object.setJsonp = function(active) {
	      config.jsonp = active;
	    };
	
	    config.isOverridenMethod = function(method, values) {
	      var search = values || config.methodOverriders;
	      return !_.isUndefined(_.find(search, function(one) {
	        return one.toLowerCase() === method.toLowerCase();
	      }));
	    };
	
	    /**
	     * Sets the URL creator type. For now, only Path is created. In the future we'll have queryParams
	    **/
	    config.urlCreator = config.urlCreator || 'path';
	    object.setUrlCreator = function(name) {
	      if (!_.has(config.urlCreatorFactory, name)) {
	        throw new Error('URL Path selected isn\'t valid');
	      }
	
	      config.urlCreator = name;
	      return this;
	    };
	
	    /**
	     * You can set the restangular fields here. The 3 required fields for Restangular are:
	     *
	     * id: Id of the element
	     * route: name of the route of this element
	     * parentResource: the reference to the parent resource
	     *
	     *  All of this fields except for id, are handled (and created) by Restangular. By default,
	     *  the field values will be id, route and parentResource respectively
	     */
	    config.restangularFields = config.restangularFields || {
	      id: 'id',
	      route: 'route',
	      parentResource: 'parentResource',
	      restangularCollection: 'restangularCollection',
	      cannonicalId: '__cannonicalId',
	      etag: 'restangularEtag',
	      selfLink: 'href',
	      get: 'get',
	      getList: 'getList',
	      put: 'put',
	      post: 'post',
	      remove: 'remove',
	      head: 'head',
	      trace: 'trace',
	      options: 'options',
	      patch: 'patch',
	      getRestangularUrl: 'getRestangularUrl',
	      getRequestedUrl: 'getRequestedUrl',
	      putElement: 'putElement',
	      addRestangularMethod: 'addRestangularMethod',
	      getParentList: 'getParentList',
	      clone: 'clone',
	      ids: 'ids',
	      httpConfig: '_$httpConfig',
	      reqParams: 'reqParams',
	      one: 'one',
	      all: 'all',
	      several: 'several',
	      oneUrl: 'oneUrl',
	      allUrl: 'allUrl',
	      customPUT: 'customPUT',
	      customPOST: 'customPOST',
	      customDELETE: 'customDELETE',
	      customGET: 'customGET',
	      customGETLIST: 'customGETLIST',
	      customOperation: 'customOperation',
	      doPUT: 'doPUT',
	      doPOST: 'doPOST',
	      doDELETE: 'doDELETE',
	      doGET: 'doGET',
	      doGETLIST: 'doGETLIST',
	      fromServer: 'fromServer',
	      withConfig: 'withConfig',
	      withHttpConfig: 'withHttpConfig',
	      singleOne: 'singleOne',
	      plain: 'plain',
	      save: 'save',
	      restangularized: 'restangularized'
	    };
	    object.setRestangularFields = function(resFields) {
	      config.restangularFields =
	        _.extend(config.restangularFields, resFields);
	      return this;
	    };
	
	    config.isRestangularized = function(obj) {
	      return !!obj[config.restangularFields.restangularized];
	    };
	
	    config.setFieldToElem = function(field, elem, value) {
	      var properties = field.split('.');
	      var idValue = elem;
	      _.each(_.initial(properties), function(prop) {
	        idValue[prop] = {};
	        idValue = idValue[prop];
	      });
	      idValue[_.last(properties)] = value;
	      return this;
	    };
	
	    config.getFieldFromElem = function(field, elem) {
	      var properties = field.split('.');
	      var idValue = elem;
	      _.each(properties, function(prop) {
	        if (idValue) {
	          idValue = idValue[prop];
	        }
	      });
	      return angular.copy(idValue);
	    };
	
	    config.setIdToElem = function(elem, id /*, route */) {
	      config.setFieldToElem(config.restangularFields.id, elem, id);
	      return this;
	    };
	
	    config.getIdFromElem = function(elem) {
	      return config.getFieldFromElem(config.restangularFields.id, elem);
	    };
	
	    config.isValidId = function(elemId) {
	      return '' !== elemId && !_.isUndefined(elemId) && !_.isNull(elemId);
	    };
	
	    config.setUrlToElem = function(elem, url /*, route */) {
	      config.setFieldToElem(config.restangularFields.selfLink, elem, url);
	      return this;
	    };
	
	    config.getUrlFromElem = function(elem) {
	      return config.getFieldFromElem(config.restangularFields.selfLink, elem);
	    };
	
	    config.useCannonicalId = _.isUndefined(config.useCannonicalId) ? false : config.useCannonicalId;
	    object.setUseCannonicalId = function(value) {
	      config.useCannonicalId = value;
	      return this;
	    };
	
	    config.getCannonicalIdFromElem = function(elem) {
	      var cannonicalId = elem[config.restangularFields.cannonicalId];
	      var actualId = config.isValidId(cannonicalId) ? cannonicalId : config.getIdFromElem(elem);
	      return actualId;
	    };
	
	    /**
	     * Sets the Response parser. This is used in case your response isn't directly the data.
	     * For example if you have a response like {meta: {'meta'}, data: {name: 'Gonto'}}
	     * you can extract this data which is the one that needs wrapping
	     *
	     * The ResponseExtractor is a function that receives the response and the method executed.
	     */
	
	    config.responseInterceptors = config.responseInterceptors || [];
	
	    config.defaultResponseInterceptor = function(data /*, operation, what, url, response, deferred */) {
	      return data;
	    };
	
	    config.responseExtractor = function(data, operation, what, url, response, deferred) {
	      var interceptors = angular.copy(config.responseInterceptors);
	      interceptors.push(config.defaultResponseInterceptor);
	      var theData = data;
	      _.each(interceptors, function(interceptor) {
	        theData = interceptor(theData, operation,
	          what, url, response, deferred);
	      });
	      return theData;
	    };
	
	    object.addResponseInterceptor = function(extractor) {
	      config.responseInterceptors.push(extractor);
	      return this;
	    };
	
	    config.errorInterceptors = config.errorInterceptors || [];
	    object.addErrorInterceptor = function(interceptor) {
	      config.errorInterceptors.push(interceptor);
	      return this;
	    };
	
	    object.setResponseInterceptor = object.addResponseInterceptor;
	    object.setResponseExtractor = object.addResponseInterceptor;
	    object.setErrorInterceptor = object.addErrorInterceptor;
	
	    /**
	     * Response interceptor is called just before resolving promises.
	     */
	
	
	    /**
	     * Request interceptor is called before sending an object to the server.
	     */
	    config.requestInterceptors = config.requestInterceptors || [];
	
	    config.defaultInterceptor = function(element, operation, path, url, headers, params, httpConfig) {
	      return {
	        element: element,
	        headers: headers,
	        params: params,
	        httpConfig: httpConfig
	      };
	    };
	
	    config.fullRequestInterceptor = function(element, operation, path, url, headers, params, httpConfig) {
	      var interceptors = angular.copy(config.requestInterceptors);
	      var defaultRequest = config.defaultInterceptor(element, operation, path, url, headers, params, httpConfig);
	      return _.reduce(interceptors, function(request, interceptor) {
	        return _.extend(request, interceptor(request.element, operation,
	          path, url, request.headers, request.params, request.httpConfig));
	      }, defaultRequest);
	    };
	
	    object.addRequestInterceptor = function(interceptor) {
	      config.requestInterceptors.push(function(elem, operation, path, url, headers, params, httpConfig) {
	        return {
	          headers: headers,
	          params: params,
	          element: interceptor(elem, operation, path, url),
	          httpConfig: httpConfig
	        };
	      });
	      return this;
	    };
	
	    object.setRequestInterceptor = object.addRequestInterceptor;
	
	    object.addFullRequestInterceptor = function(interceptor) {
	      config.requestInterceptors.push(interceptor);
	      return this;
	    };
	
	    object.setFullRequestInterceptor = object.addFullRequestInterceptor;
	
	    config.onBeforeElemRestangularized = config.onBeforeElemRestangularized || function(elem) {
	      return elem;
	    };
	    object.setOnBeforeElemRestangularized = function(post) {
	      config.onBeforeElemRestangularized = post;
	      return this;
	    };
	
	    object.setRestangularizePromiseInterceptor = function(interceptor) {
	      config.restangularizePromiseInterceptor = interceptor;
	      return this;
	    };
	
	    /**
	     * This method is called after an element has been "Restangularized".
	     *
	     * It receives the element, a boolean indicating if it's an element or a collection
	     * and the name of the model
	     *
	     */
	    config.onElemRestangularized = config.onElemRestangularized || function(elem) {
	      return elem;
	    };
	    object.setOnElemRestangularized = function(post) {
	      config.onElemRestangularized = post;
	      return this;
	    };
	
	    config.shouldSaveParent = config.shouldSaveParent || function() {
	      return true;
	    };
	    object.setParentless = function(values) {
	      if (_.isArray(values)) {
	        config.shouldSaveParent = function(route) {
	          return !_.includes(values, route);
	        };
	      } else if (_.isBoolean(values)) {
	        config.shouldSaveParent = function() {
	          return !values;
	        };
	      }
	      return this;
	    };
	
	    /**
	     * This lets you set a suffix to every request.
	     *
	     * For example, if your api requires that for JSon requests you do /users/123.json, you can set that
	     * in here.
	     *
	     *
	     * By default, the suffix is null
	     */
	    config.suffix = _.isUndefined(config.suffix) ? null : config.suffix;
	    object.setRequestSuffix = function(newSuffix) {
	      config.suffix = newSuffix;
	      return this;
	    };
	
	    /**
	     * Add element transformers for certain routes.
	     */
	    config.transformers = config.transformers || {};
	    object.addElementTransformer = function(type, secondArg, thirdArg) {
	      var isCollection = null;
	      var transformer = null;
	      if (arguments.length === 2) {
	        transformer = secondArg;
	      } else {
	        transformer = thirdArg;
	        isCollection = secondArg;
	      }
	
	      var typeTransformers = config.transformers[type];
	      if (!typeTransformers) {
	        typeTransformers = config.transformers[type] = [];
	      }
	
	      typeTransformers.push(function(coll, elem) {
	        if (_.isNull(isCollection) || (coll === isCollection)) {
	          return transformer(elem);
	        }
	        return elem;
	      });
	
	      return object;
	    };
	
	    object.extendCollection = function(route, fn) {
	      return object.addElementTransformer(route, true, fn);
	    };
	
	    object.extendModel = function(route, fn) {
	      return object.addElementTransformer(route, false, fn);
	    };
	
	    config.transformElem = function(elem, isCollection, route, Restangular, force) {
	      if (!force && !config.transformLocalElements && !elem[config.restangularFields.fromServer]) {
	        return elem;
	      }
	      var typeTransformers = config.transformers[route];
	      var changedElem = elem;
	      if (typeTransformers) {
	        _.each(typeTransformers, function(transformer) {
	          changedElem = transformer(isCollection, changedElem);
	        });
	      }
	      return config.onElemRestangularized(changedElem, isCollection, route, Restangular);
	    };
	
	    config.transformLocalElements = _.isUndefined(config.transformLocalElements) ?
	      false :
	      config.transformLocalElements;
	
	    object.setTransformOnlyServerElements = function(active) {
	      config.transformLocalElements = !active;
	    };
	
	    config.fullResponse = _.isUndefined(config.fullResponse) ? false : config.fullResponse;
	    object.setFullResponse = function(full) {
	      config.fullResponse = full;
	      return this;
	    };
	
	
	    //Internal values and functions
	    config.urlCreatorFactory = {};
	
	    /**
	     * Base URL Creator. Base prototype for everything related to it
	     **/
	
	     var BaseCreator = function() {
	     };
	
	     BaseCreator.prototype.setConfig = function(config) {
	       this.config = config;
	       return this;
	     };
	
	     BaseCreator.prototype.parentsArray = function(current) {
	      var parents = [];
	      while(current) {
	        parents.push(current);
	        current = current[this.config.restangularFields.parentResource];
	      }
	      return parents.reverse();
	    };
	
	    function RestangularResource(config, $http, url, configurer) {
	      var resource = {};
	      _.each(_.keys(configurer), function(key) {
	        var value = configurer[key];
	
	        // Add default parameters
	        value.params = _.extend({}, value.params, config.defaultRequestParams[value.method.toLowerCase()]);
	        // We don't want the ? if no params are there
	        if (_.isEmpty(value.params)) {
	          delete value.params;
	        }
	
	        if (config.isSafe(value.method)) {
	
	          resource[key] = function() {
	            return $http(_.extend(value, {
	              url: url
	            }));
	          };
	
	        } else {
	
	          resource[key] = function(data) {
	            return $http(_.extend(value, {
	              url: url,
	              data: data
	            }));
	          };
	
	        }
	      });
	
	      return resource;
	    }
	
	    BaseCreator.prototype.resource = function(current, $http, localHttpConfig, callHeaders, callParams, what, etag,operation) {
	
	      var params = _.defaults(callParams || {}, this.config.defaultRequestParams.common);
	      var headers = _.defaults(callHeaders || {}, this.config.defaultHeaders);
	
	      if (etag) {
	        if (!config.isSafe(operation)) {
	          headers['If-Match'] = etag;
	        } else {
	          headers['If-None-Match'] = etag;
	        }
	      }
	
	      var url = this.base(current);
	
	      if (what) {
	        var add = '';
	        if (!/\/$/.test(url)) {
	          add += '/';
	        }
	        add += what;
	        url += add;
	      }
	
	      if (this.config.suffix &&
	        url.indexOf(this.config.suffix, url.length - this.config.suffix.length) === -1 &&
	        !this.config.getUrlFromElem(current)) {
	          url += this.config.suffix;
	      }
	
	      current[this.config.restangularFields.httpConfig] = undefined;
	
	      return RestangularResource(this.config, $http, url, {
	        getList: this.config.withHttpValues(localHttpConfig,
	          {method: 'GET',
	          params: params,
	          headers: headers}),
	
	        get: this.config.withHttpValues(localHttpConfig,
	          {method: 'GET',
	          params: params,
	          headers: headers}),
	
	        jsonp: this.config.withHttpValues(localHttpConfig,
	          {method: 'jsonp',
	          params: params,
	          headers: headers}),
	
	        put: this.config.withHttpValues(localHttpConfig,
	          {method: 'PUT',
	          params: params,
	          headers: headers}),
	
	        post: this.config.withHttpValues(localHttpConfig,
	          {method: 'POST',
	          params: params,
	          headers: headers}),
	
	        remove: this.config.withHttpValues(localHttpConfig,
	          {method: 'DELETE',
	          params: params,
	          headers: headers}),
	
	        head: this.config.withHttpValues(localHttpConfig,
	          {method: 'HEAD',
	          params: params,
	          headers: headers}),
	
	        trace: this.config.withHttpValues(localHttpConfig,
	          {method: 'TRACE',
	          params: params,
	          headers: headers}),
	
	        options: this.config.withHttpValues(localHttpConfig,
	          {method: 'OPTIONS',
	          params: params,
	          headers: headers}),
	
	        patch: this.config.withHttpValues(localHttpConfig,
	          {method: 'PATCH',
	          params: params,
	          headers: headers})
	      });
	    };
	
	    /**
	     * This is the Path URL creator. It uses Path to show Hierarchy in the Rest API.
	     * This means that if you have an Account that then has a set of Buildings, a URL to a building
	     * would be /accounts/123/buildings/456
	    **/
	    var Path = function() {
	    };
	
	    Path.prototype = new BaseCreator();
	
	    Path.prototype.normalizeUrl = function (url){
	      var parts = /(http[s]?:\/\/)?(.*)?/.exec(url);
	      parts[2] = parts[2].replace(/[\\\/]+/g, '/');
	      return (typeof parts[1] !== 'undefined')? parts[1] + parts[2] : parts[2];
	    };
	
	    Path.prototype.base = function(current) {
	      var __this = this;
	      return  _.reduce(this.parentsArray(current), function(acum, elem) {
	        var elemUrl;
	        var elemSelfLink = __this.config.getUrlFromElem(elem);
	        if (elemSelfLink) {
	          if (__this.config.isAbsoluteUrl(elemSelfLink)) {
	            return elemSelfLink;
	          } else {
	            elemUrl = elemSelfLink;
	          }
	        } else {
	          elemUrl = elem[__this.config.restangularFields.route];
	
	          if (elem[__this.config.restangularFields.restangularCollection]) {
	            var ids = elem[__this.config.restangularFields.ids];
	            if (ids) {
	              elemUrl += '/' + ids.join(',');
	            }
	          } else {
	            var elemId;
	            if (__this.config.useCannonicalId) {
	              elemId = __this.config.getCannonicalIdFromElem(elem);
	            } else {
	              elemId = __this.config.getIdFromElem(elem);
	            }
	
	            if (config.isValidId(elemId) && !elem.singleOne) {
	              elemUrl += '/' + (__this.config.encodeIds ? encodeURIComponent(elemId) : elemId);
	            }
	          }
	        }
	        acum = acum.replace(/\/$/, '') + '/' + elemUrl;
	        return __this.normalizeUrl(acum);
	
	      }, this.config.baseUrl);
	    };
	
	
	
	    Path.prototype.fetchUrl = function(current, what) {
	      var baseUrl = this.base(current);
	      if (what) {
	        baseUrl += '/' + what;
	      }
	      return baseUrl;
	    };
	
	    Path.prototype.fetchRequestedUrl = function(current, what) {
	      var url = this.fetchUrl(current, what);
	      var params = current[config.restangularFields.reqParams];
	
	      // From here on and until the end of fetchRequestedUrl,
	      // the code has been kindly borrowed from angular.js
	      // The reason for such code bloating is coherence:
	      //   If the user were to use this for cache management, the
	      //   serialization of parameters would need to be identical
	      //   to the one done by angular for cache keys to match.
	      function sortedKeys(obj) {
	        var keys = [];
	        for (var key in obj) {
	          if (obj.hasOwnProperty(key)) {
	            keys.push(key);
	          }
	        }
	        return keys.sort();
	      }
	
	      function forEachSorted(obj, iterator, context) {
	        var keys = sortedKeys(obj);
	        for ( var i = 0; i < keys.length; i++) {
	          iterator.call(context, obj[keys[i]], keys[i]);
	        }
	        return keys;
	      }
	
	      function encodeUriQuery(val, pctEncodeSpaces) {
	        return encodeURIComponent(val).
	                   replace(/%40/gi, '@').
	                   replace(/%3A/gi, ':').
	                   replace(/%24/g, '$').
	                   replace(/%2C/gi, ',').
	                   replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	      }
	
	      if (!params) { return url + (this.config.suffix || ''); }
	
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || value === undefined) { return; }
	        if (!angular.isArray(value)) { value = [value]; }
	
	        angular.forEach(value, function(v) {
	          if (angular.isObject(v)) {
	            v = angular.toJson(v);
	          }
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(v));
	        });
	      });
	
	      return url + (this.config.suffix || '') + ((url.indexOf('?') === -1) ? '?' : '&') + parts.join('&');
	    };
	
	    config.urlCreatorFactory.path = Path;
	  };
	
	  var globalConfiguration = {};
	
	  Configurer.init(this, globalConfiguration);
	
	
	
	  this.$get = ['$http', '$q', function($http, $q) {
	
	    function createServiceForConfiguration(config) {
	      var service = {};
	
	      var urlHandler = new config.urlCreatorFactory[config.urlCreator]();
	      urlHandler.setConfig(config);
	
	      function restangularizeBase(parent, elem, route, reqParams, fromServer) {
	        elem[config.restangularFields.route] = route;
	        elem[config.restangularFields.getRestangularUrl] = _.bind(urlHandler.fetchUrl, urlHandler, elem);
	        elem[config.restangularFields.getRequestedUrl] = _.bind(urlHandler.fetchRequestedUrl, urlHandler, elem);
	        elem[config.restangularFields.addRestangularMethod] = _.bind(addRestangularMethodFunction, elem);
	        elem[config.restangularFields.clone] = _.bind(copyRestangularizedElement, elem, elem);
	        elem[config.restangularFields.reqParams] = _.isEmpty(reqParams) ? null : reqParams;
	        elem[config.restangularFields.withHttpConfig] = _.bind(withHttpConfig, elem);
	        elem[config.restangularFields.plain] = _.bind(stripRestangular, elem, elem);
	
	        // Tag element as restangularized
	        elem[config.restangularFields.restangularized] = true;
	
	        // RequestLess connection
	        elem[config.restangularFields.one] = _.bind(one, elem, elem);
	        elem[config.restangularFields.all] = _.bind(all, elem, elem);
	        elem[config.restangularFields.several] = _.bind(several, elem, elem);
	        elem[config.restangularFields.oneUrl] = _.bind(oneUrl, elem, elem);
	        elem[config.restangularFields.allUrl] = _.bind(allUrl, elem, elem);
	
	        elem[config.restangularFields.fromServer] = !!fromServer;
	
	        if (parent && config.shouldSaveParent(route)) {
	          var parentId = config.getIdFromElem(parent);
	          var parentUrl = config.getUrlFromElem(parent);
	
	          var restangularFieldsForParent = _.union(
	            _.values( _.pick(config.restangularFields, ['route', 'singleOne', 'parentResource']) ),
	            config.extraFields
	          );
	          var parentResource = _.pick(parent, restangularFieldsForParent);
	
	          if (config.isValidId(parentId)) {
	            config.setIdToElem(parentResource, parentId, route);
	          }
	          if (config.isValidId(parentUrl)) {
	            config.setUrlToElem(parentResource, parentUrl, route);
	          }
	
	          elem[config.restangularFields.parentResource] = parentResource;
	        } else {
	          elem[config.restangularFields.parentResource] = null;
	        }
	        return elem;
	      }
	
	      function one(parent, route, id, singleOne) {
	        var error;
	        if (_.isNumber(route) || _.isNumber(parent)) {
	          error = 'You\'re creating a Restangular entity with the number ';
	          error += 'instead of the route or the parent. For example, you can\'t call .one(12).';
	          throw new Error(error);
	        }
	        if (_.isUndefined(route)) {
	          error = 'You\'re creating a Restangular entity either without the path. ';
	          error += 'For example you can\'t call .one(). Please check if your arguments are valid.';
	          throw new Error(error);
	        }
	        var elem = {};
	        config.setIdToElem(elem, id, route);
	        config.setFieldToElem(config.restangularFields.singleOne, elem, singleOne);
	        return restangularizeElem(parent, elem , route, false);
	      }
	
	
	      function all(parent, route) {
	        return restangularizeCollection(parent, [] , route, false);
	      }
	
	      function several(parent, route /*, ids */) {
	        var collection = [];
	        collection[config.restangularFields.ids] = Array.prototype.splice.call(arguments, 2);
	        return restangularizeCollection(parent, collection , route, false);
	      }
	
	      function oneUrl(parent, route, url) {
	        if (!route) {
	          throw new Error('Route is mandatory when creating new Restangular objects.');
	        }
	        var elem = {};
	        config.setUrlToElem(elem, url, route);
	        return restangularizeElem(parent, elem , route, false);
	      }
	
	
	      function allUrl(parent, route, url) {
	        if (!route) {
	          throw new Error('Route is mandatory when creating new Restangular objects.');
	        }
	        var elem = {};
	        config.setUrlToElem(elem, url, route);
	        return restangularizeCollection(parent, elem , route, false);
	      }
	      // Promises
	      function restangularizePromise(promise, isCollection, valueToFill) {
	        promise.call = _.bind(promiseCall, promise);
	        promise.get = _.bind(promiseGet, promise);
	        promise[config.restangularFields.restangularCollection] = isCollection;
	        if (isCollection) {
	            promise.push = _.bind(promiseCall, promise, 'push');
	        }
	        promise.$object = valueToFill;
	        if (config.restangularizePromiseInterceptor) {
	          config.restangularizePromiseInterceptor(promise);
	        }
	        return promise;
	      }
	
	      function promiseCall(method) {
	        var deferred = $q.defer();
	        var callArgs = arguments;
	        var filledValue = {};
	        this.then(function(val) {
	          var params = Array.prototype.slice.call(callArgs, 1);
	          var func = val[method];
	          func.apply(val, params);
	          filledValue = val;
	          deferred.resolve(val);
	        });
	        return restangularizePromise(deferred.promise, this[config.restangularFields.restangularCollection], filledValue);
	      }
	
	      function promiseGet(what) {
	        var deferred = $q.defer();
	        var filledValue = {};
	        this.then(function(val) {
	          filledValue = val[what];
	          deferred.resolve(filledValue);
	        });
	        return restangularizePromise(deferred.promise, this[config.restangularFields.restangularCollection], filledValue);
	      }
	
	      function resolvePromise(deferred, response, data, filledValue) {
	        _.extend(filledValue, data);
	
	        // Trigger the full response interceptor.
	        if (config.fullResponse) {
	          return deferred.resolve(_.extend(response, {
	            data: data
	          }));
	        } else {
	          deferred.resolve(data);
	        }
	      }
	
	
	      // Elements
	      function stripRestangular(elem) {
	        if (_.isArray(elem)) {
	          var array = [];
	          _.each(elem, function(value) {
	              array.push(config.isRestangularized(value) ?  stripRestangular(value) : value);
	          });
	          return array;
	        } else {
	          return _.omit(elem, _.values(_.omit(config.restangularFields, 'id')));
	        }
	      }
	
	      function addCustomOperation(elem) {
	        elem[config.restangularFields.customOperation] = _.bind(customFunction, elem);
	        _.each(['put', 'post', 'get', 'delete'], function(oper) {
	          _.each(['do', 'custom'], function(alias) {
	            var callOperation = oper === 'delete' ? 'remove' : oper;
	            var name = alias + oper.toUpperCase();
	            var callFunction;
	
	            if (callOperation !== 'put' && callOperation !== 'post') {
	              callFunction = customFunction;
	            } else {
	              callFunction = function(operation, elem, path, params, headers) {
	                return _.bind(customFunction, this)(operation, path, params, headers, elem);
	              };
	            }
	            elem[name] = _.bind(callFunction, elem, callOperation);
	          });
	        });
	        elem[config.restangularFields.customGETLIST] = _.bind(fetchFunction, elem);
	        elem[config.restangularFields.doGETLIST] = elem[config.restangularFields.customGETLIST];
	      }
	
	      function copyRestangularizedElement(fromElement, toElement) {
	        var copiedElement = angular.copy(fromElement, toElement);
	        return restangularizeElem(copiedElement[config.restangularFields.parentResource],
	                copiedElement, copiedElement[config.restangularFields.route], true);
	      }
	
	      function restangularizeElem(parent, element, route, fromServer, collection, reqParams) {
	        var elem = config.onBeforeElemRestangularized(element, false, route);
	
	        var localElem = restangularizeBase(parent, elem, route, reqParams, fromServer);
	
	        if (config.useCannonicalId) {
	          localElem[config.restangularFields.cannonicalId] = config.getIdFromElem(localElem);
	        }
	
	        if (collection) {
	          localElem[config.restangularFields.getParentList] = function() {
	            return collection;
	          };
	        }
	
	        localElem[config.restangularFields.restangularCollection] = false;
	        localElem[config.restangularFields.get] = _.bind(getFunction, localElem);
	        localElem[config.restangularFields.getList] = _.bind(fetchFunction, localElem);
	        localElem[config.restangularFields.put] = _.bind(putFunction, localElem);
	        localElem[config.restangularFields.post] = _.bind(postFunction, localElem);
	        localElem[config.restangularFields.remove] = _.bind(deleteFunction, localElem);
	        localElem[config.restangularFields.head] = _.bind(headFunction, localElem);
	        localElem[config.restangularFields.trace] = _.bind(traceFunction, localElem);
	        localElem[config.restangularFields.options] = _.bind(optionsFunction, localElem);
	        localElem[config.restangularFields.patch] = _.bind(patchFunction, localElem);
	        localElem[config.restangularFields.save] = _.bind(save, localElem);
	
	        addCustomOperation(localElem);
	        return config.transformElem(localElem, false, route, service, true);
	      }
	
	      function restangularizeCollection(parent, element, route, fromServer, reqParams) {
	        var elem = config.onBeforeElemRestangularized(element, true, route);
	
	        var localElem = restangularizeBase(parent, elem, route, reqParams, fromServer);
	        localElem[config.restangularFields.restangularCollection] = true;
	        localElem[config.restangularFields.post] = _.bind(postFunction, localElem, null);
	        localElem[config.restangularFields.remove] = _.bind(deleteFunction, localElem);
	        localElem[config.restangularFields.head] = _.bind(headFunction, localElem);
	        localElem[config.restangularFields.trace] = _.bind(traceFunction, localElem);
	        localElem[config.restangularFields.putElement] = _.bind(putElementFunction, localElem);
	        localElem[config.restangularFields.options] = _.bind(optionsFunction, localElem);
	        localElem[config.restangularFields.patch] = _.bind(patchFunction, localElem);
	        localElem[config.restangularFields.get] = _.bind(getById, localElem);
	        localElem[config.restangularFields.getList] = _.bind(fetchFunction, localElem, null);
	
	        addCustomOperation(localElem);
	        return config.transformElem(localElem, true, route, service, true);
	      }
	
	      function restangularizeCollectionAndElements(parent, element, route) {
	        var collection = restangularizeCollection(parent, element, route, false);
	        _.each(collection, function(elem) {
	          restangularizeElem(parent, elem, route, false);
	        });
	        return collection;
	      }
	
	      function getById(id, reqParams, headers){
	        return this.customGET(id.toString(), reqParams, headers);
	      }
	
	      function putElementFunction(idx, params, headers) {
	        var __this = this;
	        var elemToPut = this[idx];
	        var deferred = $q.defer();
	        var filledArray = [];
	        filledArray = config.transformElem(filledArray, true, elemToPut[config.restangularFields.route], service);
	        elemToPut.put(params, headers).then(function(serverElem) {
	          var newArray = copyRestangularizedElement(__this);
	          newArray[idx] = serverElem;
	          filledArray = newArray;
	          deferred.resolve(newArray);
	        }, function(response) {
	          deferred.reject(response);
	        });
	
	        return restangularizePromise(deferred.promise, true, filledArray);
	      }
	
	      function parseResponse(resData, operation, route, fetchUrl, response, deferred) {
	        var data = config.responseExtractor(resData, operation, route, fetchUrl, response, deferred);
	        var etag = response.headers('ETag');
	        if (data && etag) {
	          data[config.restangularFields.etag] = etag;
	        }
	        return data;
	      }
	
	
	      function fetchFunction(what, reqParams, headers) {
	        var __this = this;
	        var deferred = $q.defer();
	        var operation = 'getList';
	        var url = urlHandler.fetchUrl(this, what);
	        var whatFetched = what || __this[config.restangularFields.route];
	
	        var request = config.fullRequestInterceptor(null, operation,
	            whatFetched, url, headers || {}, reqParams || {}, this[config.restangularFields.httpConfig] || {});
	
	        var filledArray = [];
	        filledArray = config.transformElem(filledArray, true, whatFetched, service);
	
	        var method = 'getList';
	
	        if (config.jsonp) {
	          method = 'jsonp';
	        }
	
	        var okCallback = function(response) {
	          var resData = response.data;
	          var fullParams = response.config.params;
	          var data = parseResponse(resData, operation, whatFetched, url, response, deferred);
	
	          // support empty response for getList() calls (some APIs respond with 204 and empty body)
	          if (_.isUndefined(data) || '' === data) {
	            data = [];
	          }
	          if (!_.isArray(data)) {
	            throw new Error('Response for getList SHOULD be an array and not an object or something else');
	          }
	          var processedData = _.map(data, function(elem) {
	            if (!__this[config.restangularFields.restangularCollection]) {
	              return restangularizeElem(__this, elem, what, true, data);
	            } else {
	              return restangularizeElem(__this[config.restangularFields.parentResource],
	                elem, __this[config.restangularFields.route], true, data);
	            }
	          });
	
	          processedData = _.extend(data, processedData);
	
	          if (!__this[config.restangularFields.restangularCollection]) {
	            resolvePromise(
	              deferred,
	              response,
	              restangularizeCollection(
	                __this,
	                processedData,
	                what,
	                true,
	                fullParams
	              ),
	              filledArray
	            );
	          } else {
	            resolvePromise(
	              deferred,
	              response,
	              restangularizeCollection(
	                __this[config.restangularFields.parentResource],
	                processedData,
	                __this[config.restangularFields.route],
	                true,
	                fullParams
	              ),
	              filledArray
	            );
	          }
	        };
	
	        urlHandler.resource(this, $http, request.httpConfig, request.headers, request.params, what,
	                this[config.restangularFields.etag], operation)[method]().then(okCallback, function error(response) {
	          if (response.status === 304 && __this[config.restangularFields.restangularCollection]) {
	            resolvePromise(deferred, response, __this, filledArray);
	          } else if ( _.every(config.errorInterceptors, function(cb) { return cb(response, deferred, okCallback) !== false; }) ) {
	            // triggered if no callback returns false
	            deferred.reject(response);
	          }
	        });
	
	        return restangularizePromise(deferred.promise, true, filledArray);
	      }
	
	      function withHttpConfig(httpConfig) {
	        this[config.restangularFields.httpConfig] = httpConfig;
	        return this;
	      }
	
	      function save(params, headers) {
	        if (this[config.restangularFields.fromServer]) {
	          return this[config.restangularFields.put](params, headers);
	        } else {
	          return _.bind(elemFunction, this)('post', undefined, params, undefined, headers);
	        }
	      }
	
	      function elemFunction(operation, what, params, obj, headers) {
	        var __this = this;
	        var deferred = $q.defer();
	        var resParams = params || {};
	        var route = what || this[config.restangularFields.route];
	        var fetchUrl = urlHandler.fetchUrl(this, what);
	
	        var callObj = obj || this;
	        // fallback to etag on restangular object (since for custom methods we probably don't explicitly specify the etag field)
	        var etag = callObj[config.restangularFields.etag] || (operation !== 'post' ? this[config.restangularFields.etag] : null);
	
	        if (_.isObject(callObj) && config.isRestangularized(callObj)) {
	          callObj = stripRestangular(callObj);
	        }
	        var request = config.fullRequestInterceptor(callObj, operation, route, fetchUrl,
	          headers || {}, resParams || {}, this[config.restangularFields.httpConfig] || {});
	
	        var filledObject = {};
	        filledObject = config.transformElem(filledObject, false, route, service);
	
	        var okCallback = function(response) {
	          var resData = response.data;
	          var fullParams = response.config.params;
	          var elem = parseResponse(resData, operation, route, fetchUrl, response, deferred);
	          if (elem) {
	            var data;
	            if (operation === 'post' && !__this[config.restangularFields.restangularCollection]) {
	              data = restangularizeElem(
	                __this[config.restangularFields.parentResource],
	                elem,
	                route,
	                true,
	                null,
	                fullParams
	              );
	              resolvePromise(deferred, response, data, filledObject);
	            } else {
	              data = restangularizeElem(
	                __this[config.restangularFields.parentResource],
	                elem,
	                __this[config.restangularFields.route],
	                true,
	                null,
	                fullParams
	              );
	
	              data[config.restangularFields.singleOne] = __this[config.restangularFields.singleOne];
	              resolvePromise(deferred, response, data, filledObject);
	            }
	
	          } else {
	            resolvePromise(deferred, response, undefined, filledObject);
	          }
	        };
	
	        var errorCallback = function(response) {
	          if (response.status === 304 && config.isSafe(operation)) {
	            resolvePromise(deferred, response, __this, filledObject);
	          } else if ( _.every(config.errorInterceptors, function(cb) { return cb(response, deferred, okCallback) !== false; }) ) {
	            // triggered if no callback returns false
	            deferred.reject(response);
	          }
	        };
	        // Overriding HTTP Method
	        var callOperation = operation;
	        var callHeaders = _.extend({}, request.headers);
	        var isOverrideOperation = config.isOverridenMethod(operation);
	        if (isOverrideOperation) {
	          callOperation = 'post';
	          callHeaders = _.extend(callHeaders, {'X-HTTP-Method-Override': operation === 'remove' ? 'DELETE' : operation.toUpperCase()});
	        } else if (config.jsonp && callOperation === 'get') {
	          callOperation = 'jsonp';
	        }
	
	        if (config.isSafe(operation)) {
	          if (isOverrideOperation) {
	            urlHandler.resource(this, $http, request.httpConfig, callHeaders, request.params,
	              what, etag, callOperation)[callOperation]({}).then(okCallback, errorCallback);
	          } else {
	            urlHandler.resource(this, $http, request.httpConfig, callHeaders, request.params,
	              what, etag, callOperation)[callOperation]().then(okCallback, errorCallback);
	          }
	        } else {
	          urlHandler.resource(this, $http, request.httpConfig, callHeaders, request.params,
	            what, etag, callOperation)[callOperation](request.element).then(okCallback, errorCallback);
	        }
	
	        return restangularizePromise(deferred.promise, false, filledObject);
	      }
	
	      function getFunction(params, headers) {
	        return _.bind(elemFunction, this)('get', undefined, params, undefined, headers);
	      }
	
	      function deleteFunction(params, headers) {
	        return _.bind(elemFunction, this)('remove', undefined, params, undefined, headers);
	      }
	
	      function putFunction(params, headers) {
	        return _.bind(elemFunction, this)('put', undefined, params, undefined, headers);
	      }
	
	      function postFunction(what, elem, params, headers) {
	        return _.bind(elemFunction, this)('post', what, params, elem, headers);
	      }
	
	      function headFunction(params, headers) {
	        return _.bind(elemFunction, this)('head', undefined, params, undefined, headers);
	      }
	
	      function traceFunction(params, headers) {
	        return _.bind(elemFunction, this)('trace', undefined, params, undefined, headers);
	      }
	
	      function optionsFunction(params, headers) {
	        return _.bind(elemFunction, this)('options', undefined, params, undefined, headers);
	      }
	
	      function patchFunction(elem, params, headers) {
	        return _.bind(elemFunction, this)('patch', undefined, params, elem, headers);
	      }
	
	      function customFunction(operation, path, params, headers, elem) {
	        return _.bind(elemFunction, this)(operation, path, params, elem, headers);
	      }
	
	      function addRestangularMethodFunction(name, operation, path, defaultParams, defaultHeaders, defaultElem) {
	        var bindedFunction;
	        if (operation === 'getList') {
	          bindedFunction = _.bind(fetchFunction, this, path);
	        } else {
	          bindedFunction = _.bind(customFunction, this, operation, path);
	        }
	
	        var createdFunction = function(params, headers, elem) {
	          var callParams = _.defaults({
	            params: params,
	            headers: headers,
	            elem: elem
	          }, {
	            params: defaultParams,
	            headers: defaultHeaders,
	            elem: defaultElem
	          });
	          return bindedFunction(callParams.params, callParams.headers, callParams.elem);
	        };
	
	        if (config.isSafe(operation)) {
	          this[name] = createdFunction;
	        } else {
	          this[name] = function(elem, params, headers) {
	            return createdFunction(params, headers, elem);
	          };
	        }
	      }
	
	      function withConfigurationFunction(configurer) {
	        var newConfig = angular.copy(_.omit(config, 'configuration'));
	        Configurer.init(newConfig, newConfig);
	        configurer(newConfig);
	        return createServiceForConfiguration(newConfig);
	      }
	
	      function toService(route, parent) {
	        var knownCollectionMethods = _.values(config.restangularFields);
	        var serv = {};
	        var collection = (parent || service).all(route);
	        serv.one = _.bind(one, (parent || service), parent, route);
	        serv.post = _.bind(collection.post, collection);
	        serv.getList = _.bind(collection.getList, collection);
	
	        for (var prop in collection) {
	          if (collection.hasOwnProperty(prop) && _.isFunction(collection[prop]) && !_.includes(knownCollectionMethods, prop)) {
	            serv[prop] = _.bind(collection[prop], collection);
	          }
	        }
	
	        return serv;
	      }
	
	
	      Configurer.init(service, config);
	
	      service.copy = _.bind(copyRestangularizedElement, service);
	
	      service.service = _.bind(toService, service);
	
	      service.withConfig = _.bind(withConfigurationFunction, service);
	
	      service.one = _.bind(one, service, null);
	
	      service.all = _.bind(all, service, null);
	
	      service.several = _.bind(several, service, null);
	
	      service.oneUrl = _.bind(oneUrl, service, null);
	
	      service.allUrl = _.bind(allUrl, service, null);
	
	      service.stripRestangular = _.bind(stripRestangular, service);
	
	      service.restangularizeElement = _.bind(restangularizeElem, service);
	
	      service.restangularizeCollection = _.bind(restangularizeCollectionAndElements, service);
	
	      return service;
	    }
	
	    return createServiceForConfiguration(globalConfiguration);
	  }];
	});
	
	})();


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	(function(window) {
	    var re = {
	        not_string: /[^s]/,
	        number: /[diefg]/,
	        json: /[j]/,
	        not_json: /[^j]/,
	        text: /^[^\x25]+/,
	        modulo: /^\x25{2}/,
	        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijosuxX])/,
	        key: /^([a-z_][a-z_\d]*)/i,
	        key_access: /^\.([a-z_][a-z_\d]*)/i,
	        index_access: /^\[(\d+)\]/,
	        sign: /^[\+\-]/
	    }
	
	    function sprintf() {
	        var key = arguments[0], cache = sprintf.cache
	        if (!(cache[key] && cache.hasOwnProperty(key))) {
	            cache[key] = sprintf.parse(key)
	        }
	        return sprintf.format.call(null, cache[key], arguments)
	    }
	
	    sprintf.format = function(parse_tree, argv) {
	        var cursor = 1, tree_length = parse_tree.length, node_type = "", arg, output = [], i, k, match, pad, pad_character, pad_length, is_positive = true, sign = ""
	        for (i = 0; i < tree_length; i++) {
	            node_type = get_type(parse_tree[i])
	            if (node_type === "string") {
	                output[output.length] = parse_tree[i]
	            }
	            else if (node_type === "array") {
	                match = parse_tree[i] // convenience purposes only
	                if (match[2]) { // keyword argument
	                    arg = argv[cursor]
	                    for (k = 0; k < match[2].length; k++) {
	                        if (!arg.hasOwnProperty(match[2][k])) {
	                            throw new Error(sprintf("[sprintf] property '%s' does not exist", match[2][k]))
	                        }
	                        arg = arg[match[2][k]]
	                    }
	                }
	                else if (match[1]) { // positional argument (explicit)
	                    arg = argv[match[1]]
	                }
	                else { // positional argument (implicit)
	                    arg = argv[cursor++]
	                }
	
	                if (get_type(arg) == "function") {
	                    arg = arg()
	                }
	
	                if (re.not_string.test(match[8]) && re.not_json.test(match[8]) && (get_type(arg) != "number" && isNaN(arg))) {
	                    throw new TypeError(sprintf("[sprintf] expecting number but found %s", get_type(arg)))
	                }
	
	                if (re.number.test(match[8])) {
	                    is_positive = arg >= 0
	                }
	
	                switch (match[8]) {
	                    case "b":
	                        arg = arg.toString(2)
	                    break
	                    case "c":
	                        arg = String.fromCharCode(arg)
	                    break
	                    case "d":
	                    case "i":
	                        arg = parseInt(arg, 10)
	                    break
	                    case "j":
	                        arg = JSON.stringify(arg, null, match[6] ? parseInt(match[6]) : 0)
	                    break
	                    case "e":
	                        arg = match[7] ? arg.toExponential(match[7]) : arg.toExponential()
	                    break
	                    case "f":
	                        arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg)
	                    break
	                    case "g":
	                        arg = match[7] ? parseFloat(arg).toPrecision(match[7]) : parseFloat(arg)
	                    break
	                    case "o":
	                        arg = arg.toString(8)
	                    break
	                    case "s":
	                        arg = ((arg = String(arg)) && match[7] ? arg.substring(0, match[7]) : arg)
	                    break
	                    case "u":
	                        arg = arg >>> 0
	                    break
	                    case "x":
	                        arg = arg.toString(16)
	                    break
	                    case "X":
	                        arg = arg.toString(16).toUpperCase()
	                    break
	                }
	                if (re.json.test(match[8])) {
	                    output[output.length] = arg
	                }
	                else {
	                    if (re.number.test(match[8]) && (!is_positive || match[3])) {
	                        sign = is_positive ? "+" : "-"
	                        arg = arg.toString().replace(re.sign, "")
	                    }
	                    else {
	                        sign = ""
	                    }
	                    pad_character = match[4] ? match[4] === "0" ? "0" : match[4].charAt(1) : " "
	                    pad_length = match[6] - (sign + arg).length
	                    pad = match[6] ? (pad_length > 0 ? str_repeat(pad_character, pad_length) : "") : ""
	                    output[output.length] = match[5] ? sign + arg + pad : (pad_character === "0" ? sign + pad + arg : pad + sign + arg)
	                }
	            }
	        }
	        return output.join("")
	    }
	
	    sprintf.cache = {}
	
	    sprintf.parse = function(fmt) {
	        var _fmt = fmt, match = [], parse_tree = [], arg_names = 0
	        while (_fmt) {
	            if ((match = re.text.exec(_fmt)) !== null) {
	                parse_tree[parse_tree.length] = match[0]
	            }
	            else if ((match = re.modulo.exec(_fmt)) !== null) {
	                parse_tree[parse_tree.length] = "%"
	            }
	            else if ((match = re.placeholder.exec(_fmt)) !== null) {
	                if (match[2]) {
	                    arg_names |= 1
	                    var field_list = [], replacement_field = match[2], field_match = []
	                    if ((field_match = re.key.exec(replacement_field)) !== null) {
	                        field_list[field_list.length] = field_match[1]
	                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== "") {
	                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
	                                field_list[field_list.length] = field_match[1]
	                            }
	                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
	                                field_list[field_list.length] = field_match[1]
	                            }
	                            else {
	                                throw new SyntaxError("[sprintf] failed to parse named argument key")
	                            }
	                        }
	                    }
	                    else {
	                        throw new SyntaxError("[sprintf] failed to parse named argument key")
	                    }
	                    match[2] = field_list
	                }
	                else {
	                    arg_names |= 2
	                }
	                if (arg_names === 3) {
	                    throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported")
	                }
	                parse_tree[parse_tree.length] = match
	            }
	            else {
	                throw new SyntaxError("[sprintf] unexpected placeholder")
	            }
	            _fmt = _fmt.substring(match[0].length)
	        }
	        return parse_tree
	    }
	
	    var vsprintf = function(fmt, argv, _argv) {
	        _argv = (argv || []).slice(0)
	        _argv.splice(0, 0, fmt)
	        return sprintf.apply(null, _argv)
	    }
	
	    /**
	     * helpers
	     */
	    function get_type(variable) {
	        return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase()
	    }
	
	    function str_repeat(input, multiplier) {
	        return Array(multiplier + 1).join(input)
	    }
	
	    /**
	     * export to either browser or node.js
	     */
	    if (true) {
	        exports.sprintf = sprintf
	        exports.vsprintf = vsprintf
	    }
	    else {
	        window.sprintf = sprintf
	        window.vsprintf = vsprintf
	
	        if (typeof define === "function" && define.amd) {
	            define(function() {
	                return {
	                    sprintf: sprintf,
	                    vsprintf: vsprintf
	                }
	            })
	        }
	    }
	})(typeof window === "undefined" ? this : window);


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".facebookShare{border:none;visibility:visible;width:auto;height:22px;background:transparent;overflow:hidden;-webkit-text-size-adjust:none;color:#333;line-height:1.28;margin:0;padding:0;text-align:left;direction:ltr;cursor:pointer;font-family:Helvetica Neue,Helvetica,Arial,lucida grande,tahoma,verdana,arial,sans-serif;display:inline-block}.facebookShare:active .facebookButton .pluginButton,.facebookShare:focus .facebookButton .pluginButton,.facebookShare:hover .facebookButton .pluginButton{background:#5b7bd5;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#5b7bd5),color-stop(100%,#4864b1));background:-webkit-linear-gradient(top,#5b7bd5,#4864b1);background:linear-gradient(180deg,#5b7bd5 0,#4864b1);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#5b7bd5',endColorstr='#4864b1',GradientType=0);border-color:#5874c3 #4961a8 #41599f;box-shadow:inset 0 0 1px #607fd6}.facebookShare .facebookButton{color:#3b5998;text-decoration:none;font-size:11px;text-align:left;display:inline-block;width:55px}.facebookShare .facebookButton .pluginButton{background:#4c69ba;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#4c69ba),color-stop(100%,#3b55a0));background:-webkit-linear-gradient(top,#4c69ba,#3b55a0);background:linear-gradient(180deg,#4c69ba 0,#3b55a0);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#4c69ba',endColorstr='#3b55a0',GradientType=0);border:none;border-radius:3px;color:#fff;cursor:pointer;font-weight:700;height:20px;line-height:20px;padding:0;text-shadow:0 -1px 0 #354c8c;white-space:nowrap}.facebookShare .facebookButton .pluginButton .pluginButtonContainer{-webkit-font-smoothing:antialiased;text-shadow:1px 1px 1px hsla(0,0%,100%,.004)}.facebookShare .facebookButton .pluginButton .pluginButtonContainer .pluginButtonImage{display:inline-block}.facebookShare .facebookButton .pluginButton button{background:transparent;border:0;color:inherit;cursor:pointer;font:inherit;font-weight:700;margin:-1px;outline:none;padding:0;text-shadow:0 -1px 0 #354c8c}.facebookShare .facebookButton .pluginButton button .pluginButtonIcon{height:14px;left:0;margin:0 4px;position:relative;top:3px;vertical-align:top;width:14px}.facebookShare .facebookButton .pluginButton button .sp_plugin-button-2x{background-image:url(https://fbstatic-a.akamaihd.net/rsrc.php/v2/y5/r/KxVPs0eEy36.png);background-size:30px 72px;background-repeat:no-repeat;display:inline-block;height:14px;width:14px}.facebookShare .facebookButton .pluginButton button .sx_plugin-button-2x_favblue{background-position:0 -42px}.facebookShare .facebookButton .pluginButton button i.img{-ms-high-contrast-adjust:none;_overflow:hidden}.facebookShare .facebookButton .pluginButton .pluginButtonLabel{padding:0 5px 0 0;position:relative;vertical-align:top}.facebookShare .facebookCount{display:inline-block;width:auto}.facebookShare .facebookCount .pluginCountButton{background:#fff;border:1px solid #bbb;border-radius:3px;color:#6a7180;display:inline-block;font-size:11px;height:auto;line-height:18px;margin-left:6px;min-width:15px;padding:0 3px;text-align:center;white-space:nowrap}.facebookShare .facebookCount .pluginCountButton span{display:inline-block;min-height:12px;min-width:4px;color:#333}.facebookShare .facebookCount .pluginCountButtonNub{height:0;left:2px;position:relative;top:-15px;width:5px;z-index:2}.facebookShare .facebookCount .pluginCountButtonNub i,.facebookShare .facebookCount .pluginCountButtonNub s{border-color:transparent #bbb;border-style:solid;border-width:4px 5px 4px 0;display:block;position:relative;top:1px}.facebookShare .facebookCount .pluginCountButtonNub i{border-right-color:#fff;left:2px;top:-7px}@-moz-document url-prefix(){.facebookShare .facebookButton .pluginButton button .pluginButtonIcon{margin:0 1px}}.linkedinShare{line-height:1;vertical-align:baseline;display:inline-block;text-align:center;width:auto;padding:0;margin:0;position:relative;border:0;text-decoration:none;height:20px;cursor:pointer}.linkedinShare:active .linkedinButton .pluginButtonLabel,.linkedinShare:focus .linkedinButton .pluginButtonLabel,.linkedinShare:hover .linkedinButton .pluginButtonLabel{border:1px solid #000;border-top-color:#ababab;border-right-color:#9a9a9a;border-bottom-color:#787878;border-left-color:#04568b;border-left:0;background:#ededed;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#ededed),color-stop(100%,#dedede));background:-webkit-linear-gradient(top,#ededed,#dedede);background:linear-gradient(180deg,#ededed 0,#dedede);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ededed',endColorstr='#dedede',GradientType=0)}.linkedinShare .linkedinButton{display:inline-block;width:59px;height:20px;padding:0;margin:0}.linkedinShare .linkedinButton .pluginButtonImage{background-image:url(https://www.linkedin.com/scds/common/u/images/apps/connect/sprites/sprite_connect_v14.png);background-position:0 -276px;background-repeat:no-repeat;cursor:pointer;border:0;text-indent:-9999em;overflow:hidden;padding:0;margin:0;position:absolute;left:0;top:0;display:block;width:20px;height:20px;border-radius:2px;color:#069}.linkedinShare .linkedinButton .pluginButtonLabel{color:#333;cursor:pointer;display:block;white-space:nowrap;float:left;margin-left:1px;overflow:hidden;text-align:center;height:18px;padding:0 4px 0 23px;border:1px solid #000;border-top-color:#e2e2e2;border-right-color:#bfbfbf;border-bottom-color:#b9b9b9;border-left-color:#e2e2e2;border-left:0;text-shadow:#fff -1px 1px 0;line-height:20px;border-radius:2px;background-color:#ececec;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#fefefe),color-stop(100%,#ececec));background:-webkit-linear-gradient(top,#fefefe,#ececec);background:linear-gradient(180deg,#fefefe 0,#ececec);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fefefe',endColorstr='#ececec',GradientType=0)}.linkedinShare .linkedinButton .pluginButtonLabel span{color:#333;font-size:11px;font-family:Arial,sans-serif;font-weight:700;font-style:normal;-webkit-font-smoothing:antialiased;display:inline-block;background:transparent none;vertical-align:top;height:18px;line-height:20px;float:none}.linkedinShare .linkedinCount{padding:0;margin:0;text-indent:0;display:inline-block;vertical-align:baseline}.linkedinShare .linkedinCount .pluginCountButton{display:inline-block;overflow:visible;position:relative;height:18px;padding-left:2px}.linkedinShare .linkedinCount .pluginCountButton .pluginCountButtonRight{height:18px;padding-right:4px;background-position:right -100px}.linkedinShare .linkedinCount .pluginCountButton .pluginCountButtonRight,.linkedinShare .linkedinCount .pluginCountButton .pluginCountButtonRight .pluginCountButtonLeft{display:block;float:left;background-image:url(https://www.linkedin.com/scds/common/u/images/apps/connect/sprites/sprite_connect_v14.png);background-color:transparent;background-repeat:no-repeat}.linkedinShare .linkedinCount .pluginCountButton .pluginCountButtonRight .pluginCountButtonLeft{padding-left:8px;text-align:center;background-position:0 -60px}.linkedinShare .linkedinCount .pluginCountButton .pluginCountButtonRight .pluginCountButtonLeft span{display:inline;font-size:11px;color:#04558b;font-weight:700;font-family:Arial,sans-serif;line-height:18px;padding:0 2px}", ""]);
	
	// exports


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".ui-notification{position:fixed;z-index:9999;width:300px;cursor:pointer;-webkit-transition:all .5s ease;transition:all .5s ease;color:#fff;border-radius:0;background:#337ab7;box-shadow:5px 5px 10px rgba(0,0,0,.3)}.ui-notification.killed{-webkit-transition:opacity 1s ease;transition:opacity 1s ease;opacity:0}.ui-notification>h3{font-size:14px;font-weight:700;display:block;margin:10px 10px 0;padding:0 0 5px;text-align:left;border-bottom:1px solid hsla(0,0%,100%,.3)}.ui-notification a{color:#fff}.ui-notification a:hover{text-decoration:underline}.ui-notification>.message{margin:10px}.ui-notification.warning{color:#fff;background:#f0ad4e}.ui-notification.error{color:#fff;background:#d9534f}.ui-notification.success{color:#fff;background:#5cb85c}.ui-notification.info{color:#fff;background:#5bc0de}.ui-notification:hover{opacity:.7}", ""]);
	
	// exports


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "tags-input{display:block}tags-input *,tags-input :after,tags-input :before{box-sizing:border-box}tags-input .host{position:relative;margin-top:5px;margin-bottom:5px;height:100%}tags-input .host:active{outline:none}tags-input .tags{-moz-appearance:textfield;-webkit-appearance:textfield;padding:1px;overflow:hidden;word-wrap:break-word;cursor:text;background-color:#fff;border:1px solid #a9a9a9;box-shadow:inset 1px 1px 1px 0 #d3d3d3;height:100%}tags-input .tags.focused{outline:none;box-shadow:0 0 3px 1px rgba(5,139,242,.6)}tags-input .tags .tag-list{margin:0;padding:0;list-style-type:none}tags-input .tags .tag-item{margin:2px;padding:0 5px;display:inline-block;float:left;font:14px Helvetica Neue,Helvetica,Arial,sans-serif;height:26px;line-height:25px;border:1px solid #acacac;border-radius:3px;background:-webkit-linear-gradient(top,#f0f9ff,#cbebff 47%,#a1dbff);background:linear-gradient(180deg,#f0f9ff 0,#cbebff 47%,#a1dbff)}tags-input .tags .tag-item.selected{background:-webkit-linear-gradient(top,#febbbb,#fe9090 45%,#ff5c5c);background:linear-gradient(180deg,#febbbb 0,#fe9090 45%,#ff5c5c)}tags-input .tags .tag-item .remove-button{margin:0 0 0 5px;padding:0;border:none;background:none;cursor:pointer;vertical-align:middle;font:700 16px Arial,sans-serif;color:#585858}tags-input .tags .tag-item .remove-button:active{color:red}tags-input .tags .input{border:0;outline:none;margin:2px;padding:0;padding-left:5px;float:left;height:26px;font:14px Helvetica Neue,Helvetica,Arial,sans-serif}tags-input .tags .input.invalid-tag{color:red}tags-input .tags .input::-ms-clear{display:none}tags-input.ng-invalid .tags{box-shadow:0 0 3px 1px rgba(255,0,0,.6)}tags-input[disabled] .host:focus{outline:none}tags-input[disabled] .tags{background-color:#eee;cursor:default}tags-input[disabled] .tags .tag-item{opacity:.65;background:-webkit-linear-gradient(top,#f0f9ff,rgba(203,235,255,.75) 47%,rgba(161,219,255,.62));background:linear-gradient(180deg,#f0f9ff 0,rgba(203,235,255,.75) 47%,rgba(161,219,255,.62))}tags-input[disabled] .tags .tag-item .remove-button{cursor:default}tags-input[disabled] .tags .tag-item .remove-button:active{color:#585858}tags-input[disabled] .tags .input{background-color:#eee;cursor:default}tags-input .autocomplete{margin-top:5px;position:absolute;padding:5px 0;z-index:999;width:100%;background-color:#fff;border:1px solid rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2)}tags-input .autocomplete .suggestion-list{margin:0;padding:0;list-style-type:none;max-height:280px;overflow-y:auto;position:relative}tags-input .autocomplete .suggestion-item{padding:5px 10px;cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font:16px Helvetica Neue,Helvetica,Arial,sans-serif;color:#000;background-color:#fff}tags-input .autocomplete .suggestion-item.selected,tags-input .autocomplete .suggestion-item.selected em{color:#fff;background-color:#0097cf}tags-input .autocomplete .suggestion-item em{font:normal 700 16px Helvetica Neue,Helvetica,Arial,sans-serif;color:#000;background-color:#fff}", ""]);
	
	// exports


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "wysiwyg-edit .tinyeditor{border:1px solid #bbb;padding:0 1px 1px;font:12px Verdana,Arial}wysiwyg-edit .tinyeditor iframe{border:none;background:#fff;overflow-x:hidden}wysiwyg-edit .tinyeditor .sizer{min-height:200px;height:400px;position:relative}wysiwyg-edit .tinyeditor .resizer{background:url(" + __webpack_require__(18) + ") 15px 15px no-repeat;float:right;height:32px;width:32px;cursor:ns-resize}wysiwyg-edit .tinyeditor .tinyeditor-header{height:auto;border-bottom:1px solid #bbb;background:url(" + __webpack_require__(149) + ");padding-top:1px}wysiwyg-edit .tinyeditor .tinyeditor-header select{float:left;width:220px;border:1px solid #ccc;background-color:#fff;height:30px;line-height:30px}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group{float:left;height:31px}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-size{margin:0 3px}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-style{margin-right:12px}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-divider{float:left;width:1px;height:30px;background:#ccc}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-control{float:left;width:34px;height:30px;cursor:pointer;background-image:url(" + __webpack_require__(17) + ");background-position-x:0}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-control:hover{background-color:#fff;background-position-x:34px}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-control.pressed{background-color:#d0cfcf}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-control-fa{background-image:none;position:relative}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-control-fa i{font-size:16px;margin:8px 5px 0 10px;color:#555}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-control-fa div.hr{border:1px solid #555;margin:15px 10px}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group:after{clear:left}wysiwyg-edit .tinyeditor .tinyeditor-footer{height:32px;border-top:1px solid #bbb;background:#f5f5f5;margin-top:10px}wysiwyg-edit .tinyeditor .tinyeditor-footer .toggle{float:left;background:url(" + __webpack_require__(17) + ") -34px 2px no-repeat;padding:9px 13px 0 31px;height:23px;border-right:1px solid #ccc;cursor:pointer;color:#666}wysiwyg-edit .tinyeditor .tinyeditor-footer .toggle:hover{background-color:#fff}wysiwyg-edit .tinyeditor .resize{float:right;height:32px;width:32px;background:url(" + __webpack_require__(18) + ") 15px 15px no-repeat;cursor:s-resize}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-control .ngp-colors-grid{position:absolute;left:0;top:30px;background-color:#fff;width:192px;border:2px solid #000;padding:0;margin:0;z-index:100}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-control .ngp-colors-grid>li{list-style:none;border:2px solid #fff;float:left;width:20px;height:20px}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-control .ngp-colors-grid>li:hover{opacity:.7}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-control .ngp-symbols-grid{position:absolute;left:0;top:30px;background-color:#fff;width:384px;border:2px solid #000;padding:0;margin:0;z-index:100}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-control .ngp-symbols-grid>li{list-style:none;border:1px solid #e7e7e7;float:left;width:30px;height:30px;text-align:center;font-size:1.3em}wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-control .ngp-symbols-grid>li:hover{opacity:.7;font-size:1.7em}@media only screen and (max-width:500px){wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-font,wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-size,wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-style{width:80px}}@media only screen and (max-width:768px){wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-font,wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-size,wysiwyg-edit .tinyeditor .tinyeditor-header .tinyeditor-buttons-group .tinyeditor-style{width:80px}}", ""]);
	
	// exports


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".facebookShare{border:none;visibility:visible;width:auto;height:22px;background:transparent;overflow:hidden;-webkit-text-size-adjust:none;color:#333;line-height:1.28;margin:0;padding:0;text-align:left;direction:ltr;cursor:pointer;font-family:Helvetica Neue,Helvetica,Arial,lucida grande,tahoma,verdana,arial,sans-serif;display:inline-block}.facebookShare:active .facebookButton .pluginButton,.facebookShare:focus .facebookButton .pluginButton,.facebookShare:hover .facebookButton .pluginButton{background:#5b7bd5;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#5b7bd5),color-stop(100%,#4864b1));background:-webkit-linear-gradient(top,#5b7bd5,#4864b1);background:linear-gradient(180deg,#5b7bd5 0,#4864b1);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#5b7bd5',endColorstr='#4864b1',GradientType=0);border-color:#5874c3 #4961a8 #41599f;box-shadow:inset 0 0 1px #607fd6}.facebookShare .facebookButton{color:#3b5998;text-decoration:none;font-size:11px;text-align:left;display:inline-block;width:55px}.facebookShare .facebookButton .pluginButton{background:#4c69ba;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#4c69ba),color-stop(100%,#3b55a0));background:-webkit-linear-gradient(top,#4c69ba,#3b55a0);background:linear-gradient(180deg,#4c69ba 0,#3b55a0);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#4c69ba',endColorstr='#3b55a0',GradientType=0);border:none;border-radius:3px;color:#fff;cursor:pointer;font-weight:700;height:20px;line-height:20px;padding:0;text-shadow:0 -1px 0 #354c8c;white-space:nowrap}.facebookShare .facebookButton .pluginButton .pluginButtonContainer{-webkit-font-smoothing:antialiased;text-shadow:1px 1px 1px hsla(0,0%,100%,.004)}.facebookShare .facebookButton .pluginButton .pluginButtonContainer .pluginButtonImage{display:inline-block}.facebookShare .facebookButton .pluginButton button{background:transparent;border:0;color:inherit;cursor:pointer;font:inherit;font-weight:700;margin:-1px;outline:none;padding:0;text-shadow:0 -1px 0 #354c8c}.facebookShare .facebookButton .pluginButton button .pluginButtonIcon{height:14px;left:0;margin:0 4px;position:relative;top:3px;vertical-align:top;width:14px}.facebookShare .facebookButton .pluginButton button .sp_plugin-button-2x{background-image:url(https://fbstatic-a.akamaihd.net/rsrc.php/v2/y5/r/KxVPs0eEy36.png);background-size:30px 72px;background-repeat:no-repeat;display:inline-block;height:14px;width:14px}.facebookShare .facebookButton .pluginButton button .sx_plugin-button-2x_favblue{background-position:0 -42px}.facebookShare .facebookButton .pluginButton button i.img{-ms-high-contrast-adjust:none;_overflow:hidden}.facebookShare .facebookButton .pluginButton .pluginButtonLabel{padding:0 5px 0 0;position:relative;vertical-align:top}.facebookShare .facebookCount{display:inline-block;width:auto}.facebookShare .facebookCount .pluginCountButton{background:#fff;border:1px solid #bbb;border-radius:3px;color:#6a7180;display:inline-block;font-size:11px;height:auto;line-height:18px;margin-left:6px;min-width:15px;padding:0 3px;text-align:center;white-space:nowrap}.facebookShare .facebookCount .pluginCountButton span{display:inline-block;min-height:12px;min-width:4px;color:#333}.facebookShare .facebookCount .pluginCountButtonNub{height:0;left:2px;position:relative;top:-15px;width:5px;z-index:2}.facebookShare .facebookCount .pluginCountButtonNub i,.facebookShare .facebookCount .pluginCountButtonNub s{border-color:transparent #bbb;border-style:solid;border-width:4px 5px 4px 0;display:block;position:relative;top:1px}.facebookShare .facebookCount .pluginCountButtonNub i{border-right-color:#fff;left:2px;top:-7px}@-moz-document url-prefix(){.facebookShare .facebookButton .pluginButton button .pluginButtonIcon{margin:0 1px}}.linkedinShare{line-height:1;vertical-align:baseline;display:inline-block;text-align:center;width:auto;padding:0;margin:0;position:relative;border:0;text-decoration:none;height:20px;cursor:pointer}.linkedinShare:active .linkedinButton .pluginButtonLabel,.linkedinShare:focus .linkedinButton .pluginButtonLabel,.linkedinShare:hover .linkedinButton .pluginButtonLabel{border:1px solid #000;border-top-color:#ababab;border-right-color:#9a9a9a;border-bottom-color:#787878;border-left-color:#04568b;border-left:0;background:#ededed;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#ededed),color-stop(100%,#dedede));background:-webkit-linear-gradient(top,#ededed,#dedede);background:linear-gradient(180deg,#ededed 0,#dedede);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ededed',endColorstr='#dedede',GradientType=0)}.linkedinShare .linkedinButton{display:inline-block;width:59px;height:20px;padding:0;margin:0}.linkedinShare .linkedinButton .pluginButtonImage{background-image:url(https://www.linkedin.com/scds/common/u/images/apps/connect/sprites/sprite_connect_v14.png);background-position:0 -276px;background-repeat:no-repeat;cursor:pointer;border:0;text-indent:-9999em;overflow:hidden;padding:0;margin:0;position:absolute;left:0;top:0;display:block;width:20px;height:20px;border-radius:2px;color:#069}.linkedinShare .linkedinButton .pluginButtonLabel{color:#333;cursor:pointer;display:block;white-space:nowrap;float:left;margin-left:1px;overflow:hidden;text-align:center;height:18px;padding:0 4px 0 23px;border:1px solid #000;border-top-color:#e2e2e2;border-right-color:#bfbfbf;border-bottom-color:#b9b9b9;border-left-color:#e2e2e2;border-left:0;text-shadow:#fff -1px 1px 0;line-height:20px;border-radius:2px;background-color:#ececec;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#fefefe),color-stop(100%,#ececec));background:-webkit-linear-gradient(top,#fefefe,#ececec);background:linear-gradient(180deg,#fefefe 0,#ececec);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fefefe',endColorstr='#ececec',GradientType=0)}.linkedinShare .linkedinButton .pluginButtonLabel span{color:#333;font-size:11px;font-family:Arial,sans-serif;font-weight:700;font-style:normal;-webkit-font-smoothing:antialiased;display:inline-block;background:transparent none;vertical-align:top;height:18px;line-height:20px;float:none}.linkedinShare .linkedinCount{padding:0;margin:0;text-indent:0;display:inline-block;vertical-align:baseline}.linkedinShare .linkedinCount .pluginCountButton{display:inline-block;overflow:visible;position:relative;height:18px;padding-left:2px}.linkedinShare .linkedinCount .pluginCountButton .pluginCountButtonRight{height:18px;padding-right:4px;background-position:right -100px}.linkedinShare .linkedinCount .pluginCountButton .pluginCountButtonRight,.linkedinShare .linkedinCount .pluginCountButton .pluginCountButtonRight .pluginCountButtonLeft{display:block;float:left;background-image:url(https://www.linkedin.com/scds/common/u/images/apps/connect/sprites/sprite_connect_v14.png);background-color:transparent;background-repeat:no-repeat}.linkedinShare .linkedinCount .pluginCountButton .pluginCountButtonRight .pluginCountButtonLeft{padding-left:8px;text-align:center;background-position:0 -60px}.linkedinShare .linkedinCount .pluginCountButton .pluginCountButtonRight .pluginCountButtonLeft span{display:inline;font-size:11px;color:#04558b;font-weight:700;font-family:Arial,sans-serif;line-height:18px;padding:0 2px}", ""]);
	
	// exports


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(106) + ");src:url(" + __webpack_require__(106) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(200) + ") format(\"woff2\"),url(" + __webpack_require__(199) + ") format(\"woff\"),url(" + __webpack_require__(198) + ") format(\"truetype\"),url(" + __webpack_require__(231) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:transparent}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#323232;text-decoration:none}a:focus,a:hover{color:#0c0c0c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.42857;background-color:#fff;border:1px solid #ddd;border-radius:3px;-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#323232}a.text-primary:focus,a.text-primary:hover{color:#191919}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#323232}a.bg-primary:focus,a.bg-primary:hover{background-color:#191919}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{content:\" \";display:table}.dl-horizontal dd:after{clear:both}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:'\\2014   \\A0'}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:''}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:'\\A0   \\2014'}address{margin-bottom:20px;font-style:normal;line-height:1.42857}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4}code,kbd{padding:2px 4px;font-size:90%;border-radius:3px}kbd{color:#fff;background-color:#333;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857;word-break:break-all;word-wrap:break-word;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:3px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container:after,.container:before{content:\" \";display:table}.container:after{clear:both}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container-fluid:after,.container-fluid:before{content:\" \";display:table}.container-fluid:after{clear:both}.row{margin-left:-15px;margin-right:-15px}.row:after,.row:before{content:\" \";display:table}.row:after{clear:both}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12,.ot-3-sm,.ot-9-sm,.ot-full-container,.ot-half-container,.ot-half-container-payments,.ot-half-right-container,.ot-modal-left-container,.ot-modal-right-container,.ot-quarter-container,.ot-quarter-container-payments,.ot-responsive-full-container-large,.ot-responsive-full-container-medium,.ot-sixth-container,.ot-third-container,.ot-third-right-container,.ot-threequarter-container,.ot-threequarter-container-payments,.ot-twothirds-container{position:relative;min-height:1px;padding-left:15px;padding-right:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12,.ot-3-sm,.ot-9-sm,.ot-full-container,.ot-half-container-payments,.ot-modal-left-container,.ot-modal-right-container,.ot-quarter-container-payments,.ot-threequarter-container-payments{float:left}.col-xs-1{width:8.33333%}.col-xs-2{width:16.66667%}.col-xs-3,.ot-quarter-container-payments{width:25%}.col-xs-4,.ot-modal-left-container,.ot-modal-right-container{width:33.33333%}.col-xs-5{width:41.66667%}.col-xs-6,.ot-half-container-payments{width:50%}.col-xs-7{width:58.33333%}.col-xs-8{width:66.66667%}.col-xs-9,.ot-threequarter-container-payments{width:75%}.col-xs-10{width:83.33333%}.col-xs-11{width:91.66667%}.col-xs-12,.ot-3-sm,.ot-9-sm,.ot-full-container{width:100%}.col-xs-pull-0{right:auto}.col-xs-pull-1{right:8.33333%}.col-xs-pull-2{right:16.66667%}.col-xs-pull-3{right:25%}.col-xs-pull-4,.ot-modal-left-container{right:33.33333%}.col-xs-pull-5{right:41.66667%}.col-xs-pull-6{right:50%}.col-xs-pull-7{right:58.33333%}.col-xs-pull-8{right:66.66667%}.col-xs-pull-9{right:75%}.col-xs-pull-10{right:83.33333%}.col-xs-pull-11{right:91.66667%}.col-xs-pull-12{right:100%}.col-xs-push-0{left:auto}.col-xs-push-1{left:8.33333%}.col-xs-push-2{left:16.66667%}.col-xs-push-3{left:25%}.col-xs-push-4{left:33.33333%}.col-xs-push-5{left:41.66667%}.col-xs-push-6{left:50%}.col-xs-push-7{left:58.33333%}.col-xs-push-8,.ot-modal-right-container{left:66.66667%}.col-xs-push-9{left:75%}.col-xs-push-10{left:83.33333%}.col-xs-push-11{left:91.66667%}.col-xs-push-12{left:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.33333%}.col-xs-offset-2{margin-left:16.66667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.33333%}.col-xs-offset-5{margin-left:41.66667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.33333%}.col-xs-offset-8{margin-left:66.66667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.33333%}.col-xs-offset-11{margin-left:91.66667%}.col-xs-offset-12{margin-left:100%}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.ot-3-sm,.ot-9-sm,.ot-modal-left-container,.ot-modal-right-container{float:left}.col-sm-1{width:8.33333%}.col-sm-2{width:16.66667%}.col-sm-3,.ot-3-sm{width:25%}.col-sm-4,.ot-modal-left-container,.ot-modal-right-container{width:33.33333%}.col-sm-5{width:41.66667%}.col-sm-6{width:50%}.col-sm-7{width:58.33333%}.col-sm-8{width:66.66667%}.col-sm-9,.ot-9-sm{width:75%}.col-sm-10{width:83.33333%}.col-sm-11{width:91.66667%}.col-sm-12{width:100%}.col-sm-pull-0{right:auto}.col-sm-pull-1{right:8.33333%}.col-sm-pull-2{right:16.66667%}.col-sm-pull-3{right:25%}.col-sm-pull-4,.ot-modal-left-container{right:33.33333%}.col-sm-pull-5{right:41.66667%}.col-sm-pull-6{right:50%}.col-sm-pull-7{right:58.33333%}.col-sm-pull-8{right:66.66667%}.col-sm-pull-9{right:75%}.col-sm-pull-10{right:83.33333%}.col-sm-pull-11{right:91.66667%}.col-sm-pull-12{right:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.33333%}.col-sm-push-2{left:16.66667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.33333%}.col-sm-push-5{left:41.66667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.33333%}.col-sm-push-8,.ot-modal-right-container{left:66.66667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.33333%}.col-sm-push-11{left:91.66667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.33333%}.col-sm-offset-2{margin-left:16.66667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.33333%}.col-sm-offset-5{margin-left:41.66667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.33333%}.col-sm-offset-8{margin-left:66.66667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.33333%}.col-sm-offset-11{margin-left:91.66667%}.col-sm-offset-12{margin-left:100%}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.ot-3-sm,.ot-9-sm,.ot-full-container,.ot-half-container,.ot-half-container-payments,.ot-half-right-container,.ot-modal-left-container,.ot-modal-right-container,.ot-quarter-container,.ot-quarter-container-payments,.ot-responsive-full-container-large,.ot-responsive-full-container-medium,.ot-sixth-container,.ot-third-container,.ot-third-right-container,.ot-threequarter-container,.ot-threequarter-container-payments,.ot-twothirds-container{float:left}.col-md-1{width:8.33333%}.col-md-2,.ot-sixth-container{width:16.66667%}.col-md-3,.ot-3-sm,.ot-quarter-container,.ot-quarter-container-payments{width:25%}.col-md-4,.ot-modal-left-container,.ot-modal-right-container,.ot-third-container,.ot-third-right-container{width:33.33333%}.col-md-5{width:41.66667%}.col-md-6,.ot-half-container,.ot-half-container-payments,.ot-half-right-container{width:50%}.col-md-7{width:58.33333%}.col-md-8,.ot-responsive-full-container-medium,.ot-twothirds-container{width:66.66667%}.col-md-9,.ot-9-sm,.ot-threequarter-container,.ot-threequarter-container-payments{width:75%}.col-md-10,.ot-responsive-full-container-large{width:83.33333%}.col-md-11{width:91.66667%}.col-md-12,.ot-full-container{width:100%}.col-md-pull-0{right:auto}.col-md-pull-1{right:8.33333%}.col-md-pull-2{right:16.66667%}.col-md-pull-3{right:25%}.col-md-pull-4,.ot-modal-left-container{right:33.33333%}.col-md-pull-5{right:41.66667%}.col-md-pull-6{right:50%}.col-md-pull-7{right:58.33333%}.col-md-pull-8{right:66.66667%}.col-md-pull-9{right:75%}.col-md-pull-10{right:83.33333%}.col-md-pull-11{right:91.66667%}.col-md-pull-12{right:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.33333%}.col-md-push-2{left:16.66667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.33333%}.col-md-push-5{left:41.66667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.33333%}.col-md-push-8,.ot-modal-right-container{left:66.66667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.33333%}.col-md-push-11{left:91.66667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1,.ot-responsive-full-container-large{margin-left:8.33333%}.col-md-offset-2,.ot-responsive-full-container-medium{margin-left:16.66667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.33333%}.col-md-offset-5{margin-left:41.66667%}.col-md-offset-6,.ot-half-right-container{margin-left:50%}.col-md-offset-7{margin-left:58.33333%}.col-md-offset-8,.ot-third-right-container{margin-left:66.66667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.33333%}.col-md-offset-11{margin-left:91.66667%}.col-md-offset-12{margin-left:100%}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.ot-3-sm,.ot-9-sm,.ot-full-container,.ot-half-container,.ot-half-container-payments,.ot-half-right-container,.ot-modal-left-container,.ot-modal-right-container,.ot-quarter-container,.ot-quarter-container-payments,.ot-responsive-full-container-large,.ot-responsive-full-container-medium,.ot-sixth-container,.ot-third-container,.ot-third-right-container,.ot-threequarter-container,.ot-threequarter-container-payments,.ot-twothirds-container{float:left}.col-lg-1{width:8.33333%}.col-lg-2,.ot-sixth-container{width:16.66667%}.col-lg-3,.ot-3-sm,.ot-quarter-container,.ot-quarter-container-payments{width:25%}.col-lg-4,.ot-modal-left-container,.ot-modal-right-container,.ot-third-container,.ot-third-right-container{width:33.33333%}.col-lg-5{width:41.66667%}.col-lg-6,.ot-half-container,.ot-half-container-payments,.ot-half-right-container,.ot-responsive-full-container-medium{width:50%}.col-lg-7{width:58.33333%}.col-lg-8,.ot-twothirds-container{width:66.66667%}.col-lg-9,.ot-9-sm,.ot-threequarter-container,.ot-threequarter-container-payments{width:75%}.col-lg-10,.ot-responsive-full-container-large{width:83.33333%}.col-lg-11{width:91.66667%}.col-lg-12,.ot-full-container{width:100%}.col-lg-pull-0{right:auto}.col-lg-pull-1{right:8.33333%}.col-lg-pull-2{right:16.66667%}.col-lg-pull-3{right:25%}.col-lg-pull-4,.ot-modal-left-container{right:33.33333%}.col-lg-pull-5{right:41.66667%}.col-lg-pull-6{right:50%}.col-lg-pull-7{right:58.33333%}.col-lg-pull-8{right:66.66667%}.col-lg-pull-9{right:75%}.col-lg-pull-10{right:83.33333%}.col-lg-pull-11{right:91.66667%}.col-lg-pull-12{right:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.33333%}.col-lg-push-2{left:16.66667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.33333%}.col-lg-push-5{left:41.66667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.33333%}.col-lg-push-8,.ot-modal-right-container{left:66.66667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.33333%}.col-lg-push-11{left:91.66667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1,.ot-responsive-full-container-large{margin-left:8.33333%}.col-lg-offset-2{margin-left:16.66667%}.col-lg-offset-3,.ot-responsive-full-container-medium{margin-left:25%}.col-lg-offset-4{margin-left:33.33333%}.col-lg-offset-5{margin-left:41.66667%}.col-lg-offset-6,.ot-half-right-container{margin-left:50%}.col-lg-offset-7{margin-left:58.33333%}.col-lg-offset-8,.ot-third-right-container{margin-left:66.66667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.33333%}.col-lg-offset-11{margin-left:91.66667%}.col-lg-offset-12{margin-left:100%}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857;color:#555}.form-control{width:100%;height:38px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:3px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:38px}.input-group-sm>.input-group-btn>input[type=date].btn,.input-group-sm>.input-group-btn>input[type=datetime-local].btn,.input-group-sm>.input-group-btn>input[type=month].btn,.input-group-sm>.input-group-btn>input[type=time].btn,.input-group-sm>input[type=date].form-control,.input-group-sm>input[type=date].input-group-addon,.input-group-sm>input[type=datetime-local].form-control,.input-group-sm>input[type=datetime-local].input-group-addon,.input-group-sm>input[type=month].form-control,.input-group-sm>input[type=month].input-group-addon,.input-group-sm>input[type=time].form-control,.input-group-sm>input[type=time].input-group-addon,.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg>.input-group-btn>input[type=date].btn,.input-group-lg>.input-group-btn>input[type=datetime-local].btn,.input-group-lg>.input-group-btn>input[type=month].btn,.input-group-lg>.input-group-btn>input[type=time].btn,.input-group-lg>input[type=date].form-control,.input-group-lg>input[type=date].input-group-addon,.input-group-lg>input[type=datetime-local].form-control,.input-group-lg>input[type=datetime-local].input-group-addon,.input-group-lg>input[type=month].form-control,.input-group-lg>input[type=month].input-group-addon,.input-group-lg>input[type=time].form-control,.input-group-lg>input[type=time].input-group-addon,.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:34px}.form-control-static.input-lg,.form-control-static.input-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-left:0;padding-right:0}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.input-group-sm>.input-group-btn>select.btn,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,select.input-sm{height:30px;line-height:30px}.input-group-sm>.input-group-btn>select[multiple].btn,.input-group-sm>.input-group-btn>textarea.btn,.input-group-sm>select[multiple].form-control,.input-group-sm>select[multiple].input-group-addon,.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:6px}.input-group-lg>.input-group-btn>select.btn,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,select.input-lg{height:46px;line-height:46px}.input-group-lg>.input-group-btn>select[multiple].btn,.input-group-lg>.input-group-btn>textarea.btn,.input-group-lg>select[multiple].form-control,.input-group-lg>select[multiple].input-group-addon,.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.33333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:47.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:38px;height:38px;line-height:38px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}.form-horizontal .form-group:after,.form-horizontal .form-group:before{content:\" \";display:table}.form-horizontal .form-group:after{clear:both}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857;border-radius:3px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.btn-default.dropdown-toggle{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.btn-default.dropdown-toggle.focus,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.btn-default.dropdown-toggle{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary,.ot-fake-tabs .ot-active,.ot-hire button:hover{color:#fff;background-color:#323232;border-color:#252525}.btn-primary.focus,.btn-primary:focus,.ot-fake-tabs .focus.ot-active,.ot-fake-tabs .ot-active:focus,.ot-hire button.focus:hover,.ot-hire button:focus:hover{color:#fff;background-color:#191919;border-color:#000}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.btn-primary.dropdown-toggle,.ot-fake-tabs .active.ot-active,.ot-fake-tabs .open>.dropdown-toggle.ot-active,.ot-fake-tabs .ot-active:active,.ot-fake-tabs .ot-active:hover,.ot-hire .open>button.dropdown-toggle:hover,.ot-hire button.active:hover,.ot-hire button:active:hover,.ot-hire button:hover{color:#fff;background-color:#191919;border-color:#070707}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover,.ot-fake-tabs .active.focus.ot-active,.ot-fake-tabs .active.ot-active:focus,.ot-fake-tabs .active.ot-active:hover,.ot-fake-tabs .open>.dropdown-toggle.focus.ot-active,.ot-fake-tabs .open>.dropdown-toggle.ot-active:focus,.ot-fake-tabs .open>.dropdown-toggle.ot-active:hover,.ot-fake-tabs .ot-active:active.focus,.ot-fake-tabs .ot-active:active:focus,.ot-fake-tabs .ot-active:active:hover,.ot-hire .open>button.dropdown-toggle.focus:hover,.ot-hire .open>button.dropdown-toggle:focus:hover,.ot-hire .open>button.dropdown-toggle:hover,.ot-hire button.active.focus:hover,.ot-hire button.active:focus:hover,.ot-hire button.active:hover,.ot-hire button:active.focus:hover,.ot-hire button:active:focus:hover,.ot-hire button:active:hover{color:#fff;background-color:#070707;border-color:#000}.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle,.ot-fake-tabs .active.ot-active,.ot-fake-tabs .open>.dropdown-toggle.ot-active,.ot-fake-tabs .ot-active:active,.ot-hire .open>button.dropdown-toggle:hover,.ot-hire button.active:hover,.ot-hire button:active:hover{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,.ot-fake-tabs .disabled.focus.ot-active,.ot-fake-tabs .disabled.ot-active:focus,.ot-fake-tabs .disabled.ot-active:hover,.ot-fake-tabs [disabled].focus.ot-active,.ot-fake-tabs [disabled].ot-active:focus,.ot-fake-tabs [disabled].ot-active:hover,.ot-fake-tabs fieldset[disabled] .focus.ot-active,.ot-fake-tabs fieldset[disabled] .ot-active:focus,.ot-fake-tabs fieldset[disabled] .ot-active:hover,.ot-hire button.disabled.focus:hover,.ot-hire button.disabled:focus:hover,.ot-hire button.disabled:hover,.ot-hire button[disabled].focus:hover,.ot-hire button[disabled]:focus:hover,.ot-hire button[disabled]:hover,.ot-hire fieldset[disabled] button.focus:hover,.ot-hire fieldset[disabled] button:focus:hover,.ot-hire fieldset[disabled] button:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover,fieldset[disabled] .ot-fake-tabs .focus.ot-active,fieldset[disabled] .ot-fake-tabs .ot-active:focus,fieldset[disabled] .ot-fake-tabs .ot-active:hover,fieldset[disabled] .ot-hire button.focus:hover,fieldset[disabled] .ot-hire button:focus:hover,fieldset[disabled] .ot-hire button:hover{background-color:#323232;border-color:#252525}.btn-primary .badge,.ot-fake-tabs .ot-active .badge,.ot-hire button:hover .badge{color:#323232;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.btn-warning.dropdown-toggle{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.btn-danger.dropdown-toggle{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.btn-danger.dropdown-toggle{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{color:#323232;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#0c0c0c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;-webkit-transition:opacity .15s linear;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;-webkit-transition-property:height,visibility;transition-property:height,visibility;-webkit-transition-duration:.35s;transition-duration:.35s;-webkit-transition-timing-function:ease;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:3px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#323232}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar:after,.btn-toolbar:before{content:\" \";display:table}.btn-toolbar:after{clear:both}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group-lg.btn-group>.btn+.dropdown-toggle,.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after{clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:3px;border-top-left-radius:3px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:3px}.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav:after,.nav:before{content:\" \";display:table}.nav:after{clear:both}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#323232}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857;border:1px solid transparent;border-radius:3px 3px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:3px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#323232}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified,.nav-tabs.nav-justified{width:100%}.nav-justified>li,.nav-tabs.nav-justified>li{float:none}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li,.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified,.nav-tabs.nav-justified{border-bottom:0}.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:3px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:3px 3px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:85px;margin-bottom:20px;border:1px solid transparent}.navbar:after,.navbar:before{content:\" \";display:table}.navbar:after{clear:both}@media (min-width:768px){.navbar{border-radius:3px}}.navbar-header:after,.navbar-header:before{content:\" \";display:table}.navbar-header:after{clear:both}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse:after,.navbar-collapse:before{content:\" \";display:table}.navbar-collapse:after{clear:both}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:32.5px 15px;font-size:18px;line-height:20px;height:85px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:25.5px;margin-bottom:25.5px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:3px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:16.25px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:32.5px;padding-bottom:32.5px}}.navbar-form{margin:23.5px -15px;padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:3px;border-top-left-radius:3px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:23.5px;margin-bottom:23.5px}.btn-group-sm>.navbar-btn.btn,.navbar-btn.btn-sm{margin-top:27.5px;margin-bottom:27.5px}.btn-group-xs>.navbar-btn.btn,.navbar-btn.btn-xs{margin-top:31.5px;margin-bottom:31.5px}.navbar-text{margin-top:32.5px;margin-bottom:32.5px}@media (min-width:768px){.navbar-text{float:left;margin-left:15px;margin-right:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#fff;border-color:#eee}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#eee}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#eee}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#eee;color:#555}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#eee}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#090909}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#090909;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:3px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{content:\"/\\A0\";padding:0 5px;color:#ccc}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:3px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;line-height:1.42857;text-decoration:none;color:#323232;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#0c0c0c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;background-color:#323232;border-color:#323232;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.33333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:20px 0;list-style:none;text-align:center}.pager:after,.pager:before{content:\" \";display:table}.pager:after{clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.label:empty{display:none}.btn .label{position:relative;top:-1px}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#323232}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#191919}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#323232;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{border-radius:6px;padding-left:15px;padding-right:15px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857;background-color:#fff;border:1px solid #ddd;border-radius:3px;-webkit-transition:border .2s ease-in-out;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto;margin-left:auto;margin-right:auto}.thumbnail .caption{padding:9px;color:#333}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#323232}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:3px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:3px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#323232;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#eee;color:#777;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#323232;border-color:#323232}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#989898}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:3px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-body:after,.panel-body:before{content:\" \";display:table}.panel-body:after{clear:both}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:2px;border-top-left-radius:2px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:2px;border-bottom-left-radius:2px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:2px;border-top-left-radius:2px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:2px;border-bottom-left-radius:2px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:2px;border-top-left-radius:2px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:2px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:2px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:2px;border-bottom-left-radius:2px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:2px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:2px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:3px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#323232}.panel-primary>.panel-heading{color:#fff;background-color:#323232;border-color:#323232}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#323232}.panel-primary>.panel-heading .badge{color:#323232;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#323232}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:3px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out}.modal.in .modal-dialog{-webkit-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after,.modal-header:before{content:\" \";display:table}.modal-header:after{clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after,.modal-footer:before{content:\" \";display:table}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.42857;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:12px;opacity:0;filter:alpha(opacity=0)}.tooltip.in{opacity:.9;filter:alpha(opacity=90)}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:3px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.42857;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.carousel,.carousel-inner{position:relative}.carousel-inner{overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;-webkit-transition:left .6s ease-in-out;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{display:block;max-width:100%;height:auto;line-height:1}@media (-webkit-transform-3d),all and (transform-3d){.carousel-inner>.item{-webkit-transition:-webkit-transform .6s ease-in-out;transition:-webkit-transform .6s ease-in-out;transition:transform .6s ease-in-out;transition:transform .6s ease-in-out,-webkit-transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{-webkit-transform:translateZ(0);transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;filter:alpha(opacity=50);font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent}.carousel-control.left{background-image:-webkit-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,.0001));background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000',endColorstr='#00000000',GradientType=1)}.carousel-control.right{left:auto;right:0;background-image:-webkit-linear-gradient(left,rgba(0,0,0,.0001),rgba(0,0,0,.5));background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000',endColorstr='#80000000',GradientType=1)}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9;filter:alpha(opacity=90)}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;margin-top:-10px;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:'\\2039'}.carousel-control .icon-next:before{content:'\\203A'}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:#000\\9;background-color:transparent}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}@font-face{font-family:Avenir-Regular;font-style:normal;font-weight:400;src:local(\"Avenir-Regular\"),local(\"Avenir-Regular\"),url(" + __webpack_require__(195) + ") format(\"woff\")}@font-face{font-family:Avenir-Bold;font-style:normal;font-weight:400;src:local(\"Avenir-Bold\"),local(\"Avenir-Bold\"),url(" + __webpack_require__(197) + ") format(\"woff\")}@font-face{font-family:Avenir-Demi;font-style:normal;font-weight:400;src:local(\"Avenir-Demi\"),local(\"Avenir-Demi\"),url(" + __webpack_require__(194) + ") format(\"woff\")}@font-face{font-family:Avenir-It;font-style:normal;font-weight:400;src:local(\"Avenir-It\"),local(\"Avenir-It\"),url(" + __webpack_require__(196) + ") format(\"woff\")}@font-face{font-family:Avenir-Medium;font-style:normal;font-weight:400;src:local(\"Avenir-It\"),local(\"Avenir-It\"),url(" + __webpack_require__(193) + ") format(\"woff\")}body,html{font-family:Avenir-Regular;font-size:16px}.ot-avatar>div,.ot-event-table table td .ot-banner,.ot-event-table table th .ot-banner,.ot-profile .ot-editable-avatar>div,.ot-rsvp-payment-modal .ot-banner,.ot-z-depth-1{box-shadow:0 2px 5px rgba(0,0,0,.04),0 2px 10px rgba(0,0,0,.03)}.ot-event-list .ot-event,.ot-event-page .ot-sub-header,.ot-event-table table tbody tr,.ot-manage-menu .ot-menu-box,.ot-z-depth-2{box-shadow:0 2px 5px rgba(0,0,0,.08),0 2px 10px rgba(0,0,0,.06)}.modal-content,.ot-event-list .ot-event:hover,.ot-event-page .ot-card,.ot-event-page .ot-card-subheadered,.ot-z-depth-3,.tooltip>.tooltip-inner{box-shadow:0 2px 5px rgba(0,0,0,.16),0 2px 10px rgba(0,0,0,.12)}.modal-backdrop{background-color:#000}.modal-backdrop.in{opacity:.8}.modal-content{border:1px solid #8c8c8c;border-radius:0;background-clip:padding-box;background-color:#fff;border-radius:5px}.modal-md,.modal-sm{max-width:640px}.modal-sm{width:400px;height:330px;text-align:center}@media (max-width:767px){.modal-sm{width:90%;margin-left:5%;margin-right:5%}}@media (max-width:400px){.modal-sm{width:auto}}.translate-cloak{visibility:hidden}.tooltip.top>.tooltip-arrow{border-top-color:#fff}.tooltip>.tooltip-inner{background-color:#fff;color:#424242}.ot-unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ot-input-error{border:1px solid #ed7666}.ot-checkbox-error,.ot-error-message{color:#ed7666!important}.ot-error-message{font-family:Avenir-Demi;font-size:12px;margin-bottom:0}.ot-error-message.ot-radio-error{display:inline-block;margin-left:20px}.ot-hilight{color:#ee8202}.ot-upcase-first{text-transform:capitalize}.ot-upcase-first-letter{display:inline-block}.ot-upcase-first-letter:first-letter{text-transform:uppercase}.ot-close{background:url(" + __webpack_require__(14) + ") 50% #fff;background-repeat:no-repeat;right:3px;top:13px;z-index:1;border-radius:50%;-webkit-border-radius:50%;padding:20px}.ot-close,.ot-close-login{height:13px;width:13px;margin:0 auto;float:right;position:absolute;cursor:pointer}.ot-close-login{background:url(" + __webpack_require__(14) + ") 50%;background-size:contain;background-repeat:no-repeat;right:10px;top:10px}.spinner{width:130px;height:130px;margin:0 44%;top:200px}.please-wait,.spinner{position:fixed;z-index:10001}.please-wait{text-align:center;top:250px;width:120px;margin:0 46%;color:#323232}.double-bounce1,.double-bounce2{width:100%;height:100%;border-radius:50%;background-color:#fff;background-image:url(" + __webpack_require__(112) + ");background-position:50%;background-repeat:no-repeat;opacity:1;box-shadow:0 0 10px #999;-webkit-box-shadow:0 0 10px #999;position:absolute;top:0;left:0;z-index:10001;-webkit-animation:bounce 2s infinite ease-in-out;animation:bounce 2s infinite ease-in-out}.double-bounce2{-webkit-animation-delay:-1s;animation-delay:-1s}@-webkit-keyframes bounce{0%,to{-webkit-transform:scale(0);opacity:0}50%{-webkit-transform:scale(1);opacity:1}}@keyframes bounce{0%,to{transform:scale(0);-webkit-transform:scale(0);opacity:0}50%{transform:scale(1);-webkit-transform:scale(1);opacity:1}}.ot-spinner-overlay{position:fixed;width:100%;height:100%;top:0;left:0;z-index:10000;text-align:center;background:#fff;opacity:.4}.ot-site-content>.ng-enter,.ot-site-content>.ng-leave{-webkit-transition:all .5s cubic-bezier(.25,.46,.45,.94);transition:all .5s cubic-bezier(.25,.46,.45,.94);position:absolute;top:0;left:0;right:0}.ot-site-content>.ng-enter{opacity:0}.ot-site-content>.ng-enter.ng-enter-active{opacity:1}.ot-site-content>.ng-leave,.ot-site-content>.ng-leave.ng-leave-active{opacity:0}@media (max-width:767px){.spinner{margin:0 34%}}.ot-avatar{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ot-avatar .ot-avatar-initials{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;width:100%;color:#fff;border:0;text-align:center;text-transform:uppercase}.ot-avatar.ot-horizontal{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.ot-avatar.ot-vertical{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ot-avatar.ot-dark div:first-child{border:1px solid #8c8c8c}.ot-avatar span{margin:4px}.ot-avatar>div{display:block;border-radius:50%;background-color:#fff;background-image:url(" + __webpack_require__(16) + ");background-repeat:no-repeat;background-size:cover;background-position:50%;border:1px solid #fff;margin:4px}.ot-avatar .ot-xs{width:30px;height:30px;font-size:8px}.ot-avatar .ot-ss{width:32px;height:32px;font-size:10px}.ot-avatar .ot-sm{width:44px;height:44px;font-size:14px;margin-left:5px;margin-right:5px}.ot-avatar .ot-md{width:72px;height:72px;font-size:17px}.ot-avatar .ot-lg{width:80px;height:80px;box-shadow:0 0 15px rgba(2,3,4,.15);font-size:20px}.ot-avatar-host-name{color:#323232}.ot-logo{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ot-logo div{display:inline-block;background-repeat:no-repeat}.ot-logo.ot-active{cursor:pointer}.ot-logo .ot-logo-header{height:35px;width:170px;background-image:url(" + __webpack_require__(15) + ");background-size:contain}.ot-logo .ot-logo-footer{height:35px;width:170px;background-image:url(" + __webpack_require__(141) + ");margin:0 auto;background-size:contain}.ot-logo .ot-logo-emblem{height:25px;width:120px;background-image:url(" + __webpack_require__(15) + ");background-size:contain}.ot-logo .ot-logo-vertical{height:35px;width:152px;background-image:url(" + __webpack_require__(145) + ");margin:0 auto}.ot-logo .ot-logo-onward{height:55px;width:320px;background-image:url(" + __webpack_require__(143) + ")}.ot-logo .ot-logo-onward-vertical{height:128px;width:155px;background-image:url(" + __webpack_require__(144) + ");margin:0 auto}@media (max-width:767px){.footer-left{display:none}}.ot-banner{width:100%;height:390px;background:url(" + __webpack_require__(107) + ");background-repeat:no-repeat;background-position:50%;background-size:cover;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center}.ot-banner .ot-title{width:100%;color:#fff;font-size:70px;font-family:Avenir-Demi;letter-spacing:2px;text-shadow:0 0 30px rgba(66,66,66,.5);text-transform:capitalize}.ot-loader{height:50px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ot-loader .ot-progress{width:44px;height:44px;background:url(" + __webpack_require__(140) + ") no-repeat;background-size:100%;margin:0 auto}@media (min-width:1200px){.ot-loader{height:85px}}.ot-separator.ot-horizontal p,.ot-separator.ot-vertical p,.ot_separator-text{text-transform:uppercase;font-size:.75rem;font-weight:700;color:#8c8c8c;padding:0}.ot-separator.ot-vertical{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%}.ot-separator.ot-vertical p{margin:12.25px 17px}.ot-separator.ot-vertical div{width:1px;background-color:#e5e5e5;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.ot-separator.ot-horizontal{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}.ot-separator.ot-horizontal p{margin:8.5px 24.5px}.ot-separator.ot-horizontal div{height:1px;background-color:#e5e5e5;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.ot-social-share .ot-facebook,.ot-social-share .ot-twitter{height:38px;line-height:38px;width:100%;padding-bottom:0;padding-top:0}.ot-social-share .ot-facebook span,.ot-social-share .ot-twitter span{color:#fff}.ot-social-share .ot-facebook{width:77.5px;height:42.5px;background:url(" + __webpack_require__(147) + ") 50%;background-size:contain;background-repeat:no-repeat;cursor:pointer;border:0}.ot-social-share .ot-twitter{width:77.5px;height:42.5px;background:url(" + __webpack_require__(148) + ") 50%;background-size:contain;background-repeat:no-repeat;cursor:pointer;border:0}.ot-social-share .ot-margin-right-20{margin-right:20px}.ot-image-uploader,.ot-image-uploader .ot-carousel{height:480px}.ot-image-uploader .ot-carousel .ot-cover,.ot-image-uploader .ot-carousel .ot-cover-custom{width:100%;background-size:cover;background-position:50%;height:480px}.ot-image-uploader .ot-carousel .ot-cover{background-repeat:no-repeat}.ot-image-uploader .ot-carousel .ot-cover-0{background-image:url(" + __webpack_require__(108) + ")}.ot-image-uploader .ot-carousel .ot-cover-1{background-image:url(" + __webpack_require__(109) + ")}.ot-image-uploader .ot-carousel .ot-cover-2{background-image:url(" + __webpack_require__(110) + ")}.ot-image-uploader .ot-carousel .ot-cover-3{background-image:url(" + __webpack_require__(111) + ")}.ot-image-uploader .ot-select-or-upload-container{position:absolute;top:0;left:0;right:0}.ot-image-uploader .ot-select-or-upload-container .ot-select-or-upload{padding-top:18px;padding-bottom:18px;background-color:rgba(0,0,0,.7);color:#fff;font-size:14px}.ot-image-uploader .ot-select-or-upload-container .ot-select-or-upload span{font-family:Avenir-Demi;color:#8c8c8c}.ot-image-uploader .ot-select-or-upload-container .ot-select-or-upload a{cursor:pointer;font-family:Avenir-Demi;color:#fff;text-decoration:underline;-webkit-text-decoration-style:dashed;text-decoration-style:dashed}.ot-input-combo button.ot-toggle{height:38px}.ot-input-combo-other .ot-input-combo ul{width:auto;right:0!important;left:auto!important;height:300px;overflow-y:scroll}.ot-info p span{max-width:160px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;display:inline-block;color:#4d4d4d;font-family:Avenir-Regular}.ot-info.ot-horizontal p{display:inline}.ot-event-action-menu .uib-dropdown-toggle{cursor:pointer}.ot-search{background-color:hsla(0,0%,100%,.95);position:absolute;bottom:0;left:0;right:0}.ot-search.ot-active{background-color:#fff}.ot-search .ot-search-container{max-width:892px;margin:25px auto;margin-top:25px}.ot-search .ot-search-container .ot-lens{position:absolute;top:12px;bottom:12px;left:25px;margin:0;padding:0;width:26px;background-image:url(" + __webpack_require__(146) + ");background-repeat:no-repeat}.ot-search .ot-search-container button,.ot-search .ot-search-container input{padding-left:50px;height:50px;font-size:14px}.ot-search .ot-search-container .icon-filter{display:inline-block;margin-right:5px;color:#8c8c8c}.ot-search .ot-search-container .ot-search-form-container .ot-button-input-container{position:relative}.ot-search .ot-search-container .ot-search-form-container .ot-button-input-container input[type=submit]{position:absolute;top:0;right:0;height:100%;font-family:Avenir-Demi;background-color:#323232;color:#fff;border-color:#000;font-size:14px;padding-left:20px;padding-right:20px}.ot-search .ot-search-container .ot-search-form-container .ot-filter-button{font-family:Avenir-Demi;font-size:14px;color:#424242;margin-left:20px;padding-left:20px;padding-right:20px}.ot-search-filter h4{text-align:center;font-family:Avenir-Demi;font-size:19px;color:#000;margin-top:10px;margin-bottom:18px}.ot-search-filter h5{text-align:center;font-size:16px;color:#e5e5e5;margin-top:0;margin-bottom:12px}.ot-search-filter .ot-search-container{max-width:892px;margin:30px auto}.ot-search-filter .ot-search-container .ot-button-input-container{position:relative;padding:20px;margin:23px 0 0}.ot-search-filter .ot-search-container .ot-button-input-container input[type=submit]{position:absolute;top:0;left:40%;height:100%;font-family:Avenir-Demi;background-color:#323232;color:#fff;border-color:#000;font-size:14px}.ot-search-filter .ot-search-container label{font-family:Avenir-Demi;font-size:14px;font-weight:400;color:#000;display:block}.ot-search-filter .ot-search-container button{height:38px}.ot-search-filter .ot-search-container .ot-from-to{display:-webkit-box;display:-ms-flexbox;display:flex}.ot-search-filter .ot-search-container .ot-from-to p.ot-to{display:inline-block;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;height:38px;line-height:38px;text-align:center}.ot-search-filter .ot-search-container .ot-from-to p.ot-date{display:inline-block;width:40%}@media (max-width:767px){.ot-search .ot-search-form-container .ot-button-input-container{padding-right:0}.ot-search .ot-search-form-container .ot-button-input-container .ot-filter-button{font-family:Avenir-Demi;font-size:14px;color:#424242;margin:20px 25% 0!important;width:50%;padding-left:20px;padding-right:20px}.ot-search .ot-search-container input{font-size:10px}.ot-search .ot-button-input-container{padding-left:0}}.ot-search-description{text-align:center;font-size:14px;margin-top:40px;margin-bottom:25px;color:#000;font-family:Avenir-Regular}.ot-search-description .ot-hilight{font-size:15px;text-decoration:underline}.ot-search-description .ot-current-city{color:#323232;text-transform:capitalize;border-bottom:1px dotted #323232;cursor:pointer}.ot-event-action-menu .dropdown-menu{max-height:200px!important;overflow-y:scroll!important}.ot-event-list{list-style-type:none;padding:0;margin:0}.ot-event-list li{margin:15px}.ot-event-list .ot-event{background-color:#fff;text-align:center}.ot-event-list .ot-event a{text-decoration:none}.ot-event-list .ot-event.ot-clickable{cursor:pointer}.ot-event-list .ot-event .ot-separator{margin:auto;width:20%}.ot-event-list .ot-event .ot-info{margin:15px 0}.ot-event-list .ot-event .ot-info .ot-grey-icon{color:#bbb}.ot-event-list .ot-event .ot-attendants,.ot-event-list .ot-event .ot-be-the-first,.ot-event-list .ot-event .ot-event-manual,.ot-event-list .ot-event .ot-event-private{height:38px;margin:10px 0}.ot-event-list .ot-event .ot-attendants{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ot-event-list .ot-event .ot-be-the-first{display:table;width:100%}.ot-event-list .ot-event .ot-be-the-first p{display:table-cell;vertical-align:middle;font-size:12px;color:#8c8c8c;font-family:Avenir-It}.ot-event-list .ot-event .ot-event-private{display:table;width:60%;margin-left:auto;margin-right:auto;background:#f7f7f7;border:1px solid #e5e5e5;border-radius:5px}.ot-event-list .ot-event .ot-event-private p{display:table-cell;vertical-align:middle;font-size:12px;color:#8c8c8c;font-family:Avenir-It}.ot-event-list .ot-event .ot-event-manual{display:table;width:80%;margin-left:auto;margin-right:auto;background:#f7f7f7;border:1px solid #e5e5e5;border-radius:5px}.ot-event-list .ot-event .ot-event-manual p{display:table-cell;vertical-align:middle;font-size:12px;color:#8c8c8c;font-family:Avenir-It}.ot-event-list.ot-event-compact-style{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;max-width:63rem;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:20px auto}.ot-event-list.ot-event-compact-style .ot-event{padding-bottom:15px;width:270px}.ot-event-list.ot-event-compact-style .ot-event>.ot-right{margin-top:-34px}.ot-event-list.ot-event-compact-style .ot-event .ot-banner{height:5.5rem}.ot-event-list.ot-event-compact-style .ot-event .ot-notification{display:none}.ot-event-list.ot-event-landing-style{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;max-width:1215px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:20px auto}.ot-event-list.ot-event-landing-style li{margin:15px}@media (max-width:767px){.ot-event-list.ot-event-landing-style li{width:100%}}@media (max-width:991px) and (min-width:768px){.ot-event-list.ot-event-landing-style li{width:100%}}.ot-event-list.ot-event-landing-style .ot-event>.ot-right{position:relative;margin-top:-70px;z-index:2}.ot-event-list.ot-event-landing-style .ot-event{padding-bottom:15px;width:270px;border-radius:5px;-webkit-border-radius:5px;-moz-border-radius:5px;overflow:hidden}@media (max-width:767px){.ot-event-list.ot-event-landing-style .ot-event{width:100%}}@media (max-width:991px) and (min-width:768px){.ot-event-list.ot-event-landing-style .ot-event{width:100%}}.ot-event-list.ot-event-landing-style .ot-event .ot-right{position:relative;margin-top:-70px;z-index:2}.ot-event-list.ot-event-landing-style .ot-event .ot-avatar .ot-bottom{margin-top:12px;margin-bottom:16px;font-size:12px}.ot-event-list.ot-event-landing-style .ot-event .ot-attendants .ot-right{font-size:12px;color:#8c8c8c;margin-top:0!important}.ot-event-list.ot-event-landing-style .ot-event .ot-event-title{margin:auto;font-family:Avenir-Demi;color:#4d4d4d;max-width:230px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;font-size:16px}.ot-event-list.ot-event-landing-style .ot-event .ot-separator{margin-top:16px;margin-bottom:19px}.ot-event-list.ot-event-landing-style .ot-event .ot-info{font-size:12px}.ot-event-list.ot-event-landing-style .ot-event .ot-info p{margin:8px}.ot-event-list.ot-event-landing-style .ot-event .ot-banner-container{position:relative;height:170px;z-index:1}.ot-event-list.ot-event-landing-style .ot-event .ot-banner-container .ot-notification{padding:14px;padding-bottom:0}.ot-event-list.ot-event-landing-style .ot-event .ot-banner-container .ot-notification p{padding-top:4px;padding-bottom:2px;background:rgba(238,130,2,.9);color:#fff;font-family:Avenir-Demi;text-transform:uppercase;font-size:9px;letter-spacing:2px;margin:0}.ot-event-list.ot-event-landing-style .ot-event .ot-banner-container .ot-notification p.ot-important{background:hsla(7,79%,66%,.7)}.ot-event-list.ot-event-landing-style .ot-event .ot-banner-container .ot-notification p.ot-warning{background:rgba(238,130,2,.9)}.ot-event-list.ot-event-landing-style .ot-event .ot-banner-container .ot-notification p.ot-success{background:rgba(118,210,118,.9)}.ot-event-list.ot-event-landing-style .ot-event .ot-banner-container .ot-notification p.ot-full{background:#ed7666}.ot-event-list.ot-event-landing-style .ot-event .ot-banner-container ot-banner{position:absolute;top:0;left:0;right:0;z-index:-1}.ot-event-list.ot-event-landing-style .ot-event .ot-banner-container ot-banner .ot-banner{height:170px}.ot-event-list.ot-event-manage-style>li{margin:28px 15px}@media (max-width:767px){.ot-event-list.ot-event-manage-style>li{margin:28px 0}}.ot-event-list.ot-event-manage-style>li:first-child{margin-top:0}.ot-event-list.ot-event-manage-style .ot-event{height:165px;border:1px solid #e5e5e5}@media (max-width:767px){.ot-event-list.ot-event-manage-style .ot-event{height:auto}}.ot-event-list.ot-event-manage-style .ot-event .ot-banner-container{float:left;height:100%;width:256px}@media (max-width:767px){.ot-event-list.ot-event-manage-style .ot-event .ot-banner-container{float:none;margin:0;width:100%}}.ot-event-list.ot-event-manage-style .ot-event .ot-banner-container .ot-banner{height:100%;width:256px}@media (max-width:767px){.ot-event-list.ot-event-manage-style .ot-event .ot-banner-container .ot-banner{width:100%}}.ot-event-list.ot-event-manage-style .ot-event .ot-banner-container .ot-notification{display:none}.ot-event-list.ot-event-manage-style .ot-event .ot-event-title{margin-top:26px;color:#000;font-family:Avenir-Demi;font-size:17px;height:25px;overflow:hidden}.ot-event-list.ot-event-manage-style .ot-event .ot-info span:last-child{font-size:12px}.ot-event-list.ot-event-manage-style .ot-event .ot-info p{margin:0}.ot-event-list.ot-event-manage-style .ot-event>a .ot-right{float:right;height:100%;padding:16px 20px 0;text-align:right}@media (max-width:767px){.ot-event-list.ot-event-manage-style .ot-event>a .ot-right{float:none;text-align:center}}.ot-event-list.ot-event-manage-style .ot-event>a .ot-right .ot-avatar .ot-label{font-size:12px}.ot-event-list.ot-event-manage-style .ot-event>a .ot-right .ot-attendants{margin-top:40px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}@media (max-width:767px){.ot-event-list.ot-event-manage-style .ot-event>a .ot-right .ot-attendants{margin-top:15px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}.ot-event-list.ot-event-manage-style .ot-event>a .ot-right .ot-attendants .ot-left{font-family:Avenir-Demi;font-size:12px}.ot-event-list.ot-event-manage-style .ot-event>a .ot-right .ot-attendants .ot-right{font-size:12px;color:#8c8c8c}.ot-event-list.ot-event-manage-style .ot-event>a .ot-right .ot-action-container>*{display:inline-block}.ot-event-list.ot-event-manage-style .ot-event>a .ot-right .ot-action-container .uib-dropdown-toggle span{margin-left:8px;color:#8c8c8c;vertical-align:bottom}.ot-event-list.ot-event-manage-style .ot-event>a .ot-right .ot-action-container .ot-event-action-menu ul{right:0;left:auto;top:-50%}.ot-event-list.ot-event-manage-style .ot-event>a .ot-right .ot-action-container .ot-event-action-menu ul li{margin:0}.ot-event-list.ot-event-manage-style .ot-event>a .ot-left{float:left;height:100%;padding:0 26px;text-align:left;max-width:250px}@media (max-width:767px){.ot-event-list.ot-event-manage-style .ot-event>a .ot-left{float:none}}.ot-event-list.ot-event-manage-style .ot-event>a .ot-left .ot-info{margin-top:13px}.ot-event-list.ot-event-manage-style .ot-event>a .ot-left .ot-info p{height:24px}.ot-event-table table{width:100%}.ot-event-table table tbody tr{background:#fff;margin-top:14px;margin-bottom:28px;padding:30px 0}.ot-event-table table tr{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ot-event-table table td,.ot-event-table table th{display:block;-ms-flex-negative:0;flex-shrink:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;padding-right:16px}.ot-event-table table td p,.ot-event-table table th p{margin:0}.ot-event-table table td .ot-banner,.ot-event-table table th .ot-banner{width:90px;height:82px;border-radius:4px}.ot-event-table table th{font-family:Avenir-Demi;font-size:13px}.ot-event-table table td:last-child,.ot-event-table table th:last-child{text-align:right;padding-right:26px}.ot-event-table table td:first-child,.ot-event-table table th:first-child{padding-left:26px;padding-right:0}.ot-event-table table td.ot-title p{font-family:Avenir-Demi;color:#000;font-size:14px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.ot-event-table table td.ot-title a{color:#8c8c8c;font-size:12px}.ot-event-table table td.ot-attendance,.ot-event-table table td .ot-info span,.ot-event-table table td.ot-status{font-size:13px}.ot-event-table table td.ot-attendance p,.ot-event-table table td.ot-status p{padding-top:2px;padding-bottom:2px}.ot-event-table table .ot-event-action-menu .uib-dropdown-toggle{font-size:13px}.ot-event-table table .ot-event-action-menu ul{right:0;left:auto;top:-50%}.ot-label-event{color:#4d4d4d;font-family:Avenir-Regular}@media (max-width:767px){#no-more-tables table,#no-more-tables tbody,#no-more-tables td,#no-more-tables th,#no-more-tables thead,#no-more-tables tr{display:block}#no-more-tables thead tr{position:absolute;top:-9999px;left:-9999px}#no-more-tables tr{border:1px solid #ccc}#no-more-tables td{border:none;border-bottom:1px solid #eee;position:relative;padding-left:50%;white-space:normal}#no-more-tables td,#no-more-tables td:before{padding-top:5px;padding-bottom:5px;text-align:left}#no-more-tables td:before{position:absolute;top:0;left:6px;width:45%;padding-right:10px;white-space:nowrap;font-weight:700;font-size:14px;content:attr(data-title)}}.ot-type-list>div{display:inline-block;margin-left:10px;margin-right:10px}.ot-type-list div>span{display:block}.ot-type-list div>span:first-child{font-size:30px}.ot-type-list div>span:last-child{margin-top:8px;font-family:Avenir-Demi;font-size:12px}.ot-type-list .ot-icon-alcohol-free{height:40px;width:40px;margin:0 auto;background:url(" + __webpack_require__(116) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-type-list .ot-icon-beer-and-wine{height:40px;width:40px;margin:0 auto;background:url(" + __webpack_require__(117) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-type-list .ot-icon-byob{height:40px;width:40px;margin:0 auto;background:url(" + __webpack_require__(119) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-type-list .ot-icon-gluten-free{height:40px;width:40px;margin:0 auto;background:url(" + __webpack_require__(123) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-type-list .ot-icon-kosher{height:40px;width:40px;margin:0 auto;background:url(" + __webpack_require__(126) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-type-list .ot-icon-pescatarian{height:40px;width:40px;margin:0 auto;background:url(" + __webpack_require__(129) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-type-list .ot-icon-vegan{height:40px;width:40px;margin:0 auto;background:url(" + __webpack_require__(137) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-type-list .ot-icon-vegetarian{height:40px;width:40px;margin:0 auto;background:url(" + __webpack_require__(138) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-manage-header{margin-top:50px;margin-bottom:60px}.ot-manage-header .ot-greeting{color:#000;font-family:Avenir-Demi;font-size:30px}.ot-manage-header>div>p{color:#000;text-align:center}.ot-manage-header>div>p .ot-hilight{color:#000;font-family:Avenir-Demi}.ot-manage-header .ot-small .ot-separator{margin:30px auto 50px;width:40px}.ot-manage-menu ul{list-style-type:none;margin:0;padding:0}.ot-manage-menu .ot-menu-box{background-color:#fff;border:1px solid #e5e5e5}.ot-manage-menu .ot-menu-box .ot-clickable{cursor:pointer}.ot-manage-menu .ot-menu-box .ot-clickable:hover,.ot-manage-menu .ot-menu-box .ot-selected{background-color:#f1f1f1}.ot-manage-menu .ot-menu-box>li{border:1px solid #e5e5e5;margin:-1px;padding:16px;padding-left:20px}.ot-manage-menu .ot-menu-box>li.ot-subbed{padding:0}.ot-manage-menu .ot-menu-box>li.ot-subbed>a{pointer-events:none}.ot-manage-menu .ot-menu-box>li.ot-subbed>a>div{padding:16px;padding-left:20px}.ot-manage-menu .ot-menu-box>li>a{display:block}.ot-manage-menu .ot-menu-box>li>a>div>span{color:#000;font-family:Avenir-Demi;font-size:14px}.ot-manage-menu .ot-menu-box>li>ul>li:first-child{margin-top:-10px}.ot-manage-menu .ot-menu-box>li>ul>li:last-child{margin-bottom:10px}.ot-manage-menu .ot-menu-box>li>ul>li>a{display:block;padding:6px;padding-left:36px}.ot-manage-menu .ot-menu-box>li>ul>li>a>div>span{color:#000;font-size:14px}.ot-manage-menu .ot-menu-box .badge{display:inline-block;margin-left:5px;color:#fff;background-color:#ee8202}.ot-manage-menu .ot-menu-box .badge.ot-red{background-color:#ed7666}.ot-manage-menu>button{width:100%;font-size:14px;height:40px;margin-top:25px;margin-bottom:30px;font-family:Avenir-Demi}.ot-rsvp{text-align:center}.ot-rsvp .ot-rsvp-wrapper{min-width:230px;display:inline-block}.ot-rsvp .ot-rsvp-wrapper button{width:100%;height:38px;color:#fff;font-size:12px;text-transform:uppercase;letter-spacing:1px}.ot-rsvp .ot-rsvp-wrapper button .ot-left{text-align:center;width:100%;float:left}.ot-rsvp .ot-rsvp-wrapper button .ot-right{margin-left:-35px}.ot-rsvp .ot-rsvp-initial button{background-color:#323232}.ot-rsvp .ot-rsvp-initial button:focus,.ot-rsvp .ot-rsvp-initial button:hover{background-color:#323232;color:#fff}.ot-rsvp .ot-rsvp-pending button{background-color:#f5b15f}.ot-rsvp .ot-rsvp-pending button:focus,.ot-rsvp .ot-rsvp-pending button:hover{background-color:#f5b15f;color:#fff}.ot-rsvp .ot-rsvp-done button{background-color:#76d276}.ot-rsvp .ot-rsvp-done button.uib-dropdown-toggle,.ot-rsvp .ot-rsvp-done button.uib-dropdown-toggle:focus,.ot-rsvp .ot-rsvp-done button.uib-dropdown-toggle:hover{background-color:#76d276;color:#fff}.ot-rsvp .ot-rsvp-done .uib-dropdown-menu{text-align:center}.ot-rsvp .ot-rsvp-done .uib-dropdown-menu>li>a{padding-top:8px;padding-bottom:8px;font-size:14px}.ot-invite-guests textarea{resize:none;margin-top:30px;padding:10px 14px;height:114px}.ot-invite-guests .ot-hint{font-size:14px;margin-bottom:2px}.ot-invite-guests .ot-tags-input-wrapper{position:relative}.ot-invite-guests .ot-tags-input-wrapper tags-input .tags{padding-bottom:4px}.ot-invite-guests .ot-tags-input-wrapper.ot-after tags-input .tags{padding:0}.ot-invite-guests .ot-tags-input-wrapper>a{position:absolute;top:4px;right:8px;font-family:Avenir-Demi;font-size:14px}.ot-invite-guests tags-input .tags{border:0;box-shadow:none}.ot-invite-guests tags-input .host{margin-top:0;margin-bottom:0;border:1px solid #ccc;border-radius:3px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.ot-invite-guests tags-input .tags .tag-item{margin:2px;padding:0 5px;display:inline-block;float:left;height:26px;line-height:25px;border:1px solid #c38695;border-radius:3px;background:#f4e8eb}.ot-invite-guests tags-input .tags .tag-item .remove-button{margin:0 0 0 5px;padding:0;border:none;background:0 0;cursor:pointer;vertical-align:middle;font:\"Avenir-Bold\";color:#777072}.ot-invite-guests button{width:100%;font-size:14px;height:40px;margin-top:25px;margin-bottom:30px;font-family:Avenir-Demi}div[ng-view]{padding-top:50px}.ot-header.navbar.navbar-default.navbar-fixed-top{min-height:50px;height:50px}.ot-header{border-bottom:1px solid #e5e5e5}.ot-header .ot-logo{margin-left:35px;margin-right:25px;height:50px}.ot-header .ot-separator{height:50px}.ot-header .ot-separator div{margin:24.5px 17px}.ot-header .ot-separator div:first-child{margin-bottom:0}.ot-header .ot-separator div:last-child{margin-top:0}@media (max-width:767px){.ot-header .navbar-left{float:left!important}.ot-header .navbar-right{float:right!important}.ot-header .ot-logo{margin-left:0;margin-right:0}}@media (min-width:1200px){div[ng-view]{padding-top:85px}.ot-header.navbar.navbar-default.navbar-fixed-top{min-height:85px;height:85px}.ot-header .ot-logo,.ot-header .ot-separator{height:85px}}.ot-footer{min-height:185px;margin-bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff}.ot-footer ot-link-list{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;list-style-type:none}.ot-footer ot-link-list .ot-link-list{padding:0;margin:0;margin-left:45px}.ot-footer ot-link-list .ot-link-list li{display:inline-block;margin-right:5px;cursor:pointer}.ot-footer ot-link-list .ot-link-list li:last-child{margin-right:0}.ot-footer ot-link-list .ot-link-list li a{color:#000;font-size:13px}.ot-footer .ot-footer-contacts{text-align:right;color:#000;font-size:13px}.ot-footer .ot-footer-contacts a,.ot-footer .ot-footer-contacts span{margin:5px;color:#323232;font-size:13px;cursor:pointer;margin-right:45px}.ot-footer .ot-footer-contacts a{display:inline-block}@media (max-width:767px){.ot-footer .ot-footer-contacts a{margin-right:0}}@media (min-width:1200px){.ot-footer .ot-footer-contacts a{margin-right:10px}}.ot-hire{height:50px;margin-right:35px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ot-hire .icon-login{display:inline-block;margin-right:5px;font-size:15px;color:#8c8c8c;vertical-align:middle}.ot-hire a{font-size:12px;color:#000}.ot-hire a:hover{cursor:pointer}.ot-hire button{font-family:Avenir-Bold;text-transform:uppercase;font-size:10px;letter-spacing:2px;color:#323232;padding:11px;margin-left:25px;border:2px solid #323232}@media (min-width:1200px){.ot-hire{height:85px}}.ot-link-list{height:50px;list-style-type:none;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ot-link-list .custom-powered{padding:2px 140px 2px 0;background:url(" + __webpack_require__(142) + ") 100% no-repeat}.ot-link-list li{display:inline-block}.ot-link-list li .ot-indicator,.ot-link-list li .ot-link{height:50px;line-height:50px;color:#000;font-size:14px;cursor:pointer;font-family:Avenir-Medium;padding-left:8px;padding-right:8px}.ot-link-list li .ot-indicator:hover,.ot-link-list li .ot-link:hover{color:#323232}.ot-link-list li .ot-indicator .ot-icon,.ot-link-list li .ot-link .ot-icon{position:relative}.ot-link-list li .ot-indicator .icon-notifications,.ot-link-list li .ot-link .icon-notifications{font-size:18px;color:#8c8c8c}.ot-link-list li .ot-indicator .ot-notification,.ot-link-list li .ot-link .ot-notification{position:absolute;top:25%;left:100%}.ot-link-list li .ot-dropdown-menu li{width:100%}.ot-link-list li .ot-subheader-link{height:85px;line-height:85px;color:#000;font-size:14px;cursor:pointer;font-family:Avenir-Medium;padding-left:12.5px;padding-right:12.5px}.ot-link-list li .ot-subheader-link:hover{color:#323232}.ot-link-list li .ot-subheader-link .ot-icon{position:relative}.ot-link-list li .ot-subheader-link .icon-notifications{font-size:18px;color:#8c8c8c}.ot-link-list li .ot-subheader-link .ot-notification{position:absolute;top:25%;left:100%}@media (min-width:1200px){.ot-link-list{height:85px}.ot-link-list .ot-indicator,.ot-link-list li .ot-link{height:85px;line-height:85px;padding-left:25px;padding-right:25px}}.ot-indicator-list{height:50px;list-style-type:none;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ot-indicator-list li{display:inline-block;height:100%}.ot-indicator-list li .ot-indicator,.ot-indicator-list li .ot-link{height:50px;line-height:50px;color:#000;font-size:14px;cursor:pointer;font-family:Avenir-Medium;padding-left:8px;padding-right:8px}.ot-indicator-list li .ot-indicator:hover,.ot-indicator-list li .ot-link:hover{color:#323232}.ot-indicator-list li .ot-indicator .ot-icon,.ot-indicator-list li .ot-link .ot-icon{position:relative}.ot-indicator-list li .ot-indicator .icon-notifications,.ot-indicator-list li .ot-link .icon-notifications{font-size:18px;color:#8c8c8c}.ot-indicator-list li .ot-indicator .ot-notification,.ot-indicator-list li .ot-link .ot-notification{position:absolute;top:25%;left:100%}@media (min-width:1200px){.ot-indicator-list{height:85px}.ot-indicator-list .ot-indicator,.ot-indicator-list li .ot-link{height:85px;line-height:85px;padding-left:25px;padding-right:25px}}.ot-user-recap{height:50px;margin-right:35px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ot-user-recap .ot-avatar{cursor:pointer}.ot-user-recap .ot-username{color:#424242;font-size:12px;margin-bottom:0;margin-right:11px;font-family:Avenir-Demi}.ot-user-recap .ot-dropdown-menu.uib-dropdown-menu li a{color:#8c8c8c;font-size:12px;font-family:Avenir-Demi}@media (min-width:1200px){.ot-user-recap{height:85px}}.ot-facebook-login{padding-left:20px;padding-right:20px}.ot-facebook-login button{padding-right:18px;text-transform:uppercase;font-family:Avenir-Bold;font-size:10px;letter-spacing:1px;background-color:#485093;border-color:#485093;height:38px}.ot-facebook-login button:hover{background-color:#485093}.ot-facebook-login button .icon-facebook{font-size:18px;vertical-align:middle}.ot-email-login{padding:20px;padding-top:0}.ot-email-login .ot-error-login-failed{padding-bottom:10px;padding-left:7px;padding-right:7px;text-align:center}.ot-email-login .ot-password{position:relative}.ot-email-login .ot-password span{position:absolute;top:0;right:0;height:38px}.ot-email-login .ot-password span button{height:100%;background-color:transparent;border-color:transparent;font-family:Avenir-Demi;font-size:11px;color:#323232}.ot-email-login .ot-password span button:active,.ot-email-login .ot-password span button:focus{border-color:transparent;outline-color:transparent;background:transparent}.ot-email-login input{margin-bottom:10px}.ot-email-login .ot-fake-tabs input.ot-active,.ot-email-login input.btn-primary,.ot-fake-tabs .ot-email-login input.ot-active{margin-top:5px;text-transform:uppercase;font-family:Avenir-Bold;font-size:10px;letter-spacing:1px;height:38px}.ot-email-signup .ot-fix{padding:0 5px}.ot-email-signup .ot-fix:first-child{padding-left:0}.ot-email-signup .ot-fix:last-child{padding-right:0}.ot-email-signup .row-dropdown,.ot-email-signup input{margin-bottom:10px}.ot-email-signup .ot-fake-tabs input.ot-active,.ot-email-signup input.btn-primary,.ot-fake-tabs .ot-email-signup input.ot-active{margin-top:5px;text-transform:uppercase;font-family:Avenir-Bold;font-size:10px;letter-spacing:1px;height:38px}.ot-email-signup .ot-date-container{margin:-30px}.ot-email-signup .dropdown-menu{max-height:150px;overflow-y:scroll}@media (max-width:767px){.ot-email-signup .ot-date-container{margin:0 -15px}.ot-email-signup .ot-date-container .ot-full-container{padding:0!important}.ot-email-signup .ot-fix:first-child,.ot-email-signup .ot-fix:last-child{padding-left:0;padding-right:0}}.ot-burger{height:50px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-left:-5px;margin-right:35px}@media (max-width:767px){.ot-burger{margin-right:0}}.ot-modal{padding:20px 40px;text-align:center}.ot-simple-modal{text-align:center;padding:45px 55px}.ot-simple-modal .ot-logo{display:inline-block}.ot-simple-modal h2{font-family:Avenir-Medium;font-size:18px;color:#000;margin-top:0;margin-bottom:20px}.ot-simple-modal h3{color:#4d4d4d;font-size:14px;margin-bottom:20px;font-family:Avenir-Regular;line-height:1.6em}.ot-simple-modal p{text-align:center;margin:0;color:#424242;font-size:12px}.ot-simple-modal p a{color:#323232;font-family:Avenir-Demi;font-size:12px}.ot-simple-modal button,.ot-simple-modal input{height:38px}.ot-simple-modal button.ot-first,.ot-simple-modal input.ot-first{margin-bottom:15px}.ot-simple-modal button,.ot-simple-modal input[type=submit]{width:100%;margin-top:15px;margin-bottom:30px;font-family:Avenir-Bold;letter-spacing:1px;font-size:10px;text-transform:uppercase}.ot-simple-modal .btn-default{border:2px solid #000}.ot-simple-modal .btn-default:hover{background-color:#000;color:#fff}p.ot-date{position:relative;margin:0}p.ot-date.ot-full-width>ul,p.ot-date.ot-full-width>ul>li,p.ot-date.ot-full-width>ul>li table{width:100%}p.ot-date.ot-align-right .uib-dropdown-menu{width:auto;right:0;left:auto!important}p.ot-date .btn-default{border:0}p.ot-date>span{width:38px;height:38px;position:absolute;right:-1px;top:0}p.ot-date>span button{background-color:transparent;border-color:transparent;width:100%;height:38px}p.ot-date>span button:active,p.ot-date>span button:focus,p.ot-date>span button:hover{border-color:transparent;outline-color:transparent;background:transparent}.has-error p.ot-date>span button{border:1px solid #d9534f}.ot-timepicker{width:100%}.ot-timepicker input[type=text]{padding-left:0;padding-right:0}.ot-timepicker button,.ot-timepicker input,.ot-timepicker table,.ot-timepicker tbody,.ot-timepicker tr{width:100%!important}.ot-timepicker button,.ot-timepicker table,.ot-timepicker tbody,.ot-timepicker tr{height:38px}.ot-timepicker td:nth-child(2){text-align:center;line-height:38px;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:1;flex-shrink:1;width:4%}.ot-timepicker td:nth-child(3){padding-left:3px;padding-right:3px}.ot-timepicker td:first-child{padding-left:0}.ot-timepicker td:last-child{padding-right:0}.ot-timepicker td{width:32%;padding:0 5px}.ot-input-dropdown .ot-left{float:left;max-width:90%;overflow:hidden;text-overflow:ellipsis;opacity:.6}.ot-input-dropdown .ot-required-field{color:#323232}.ot-input-dropdown button{text-align:right;width:100%}.ot-input-dropdown ul{width:100%}.ot-placeholder{opacity:.6;font-weight:bolder}.ot-dropdown-menu.uib-dropdown-menu,.ot-dropdown-menu.uib-dropdown-menu li{padding:0}.ot-dropdown-menu.uib-dropdown-menu li:first-child a{margin-top:12px}.ot-dropdown-menu.uib-dropdown-menu li:last-child a{margin-bottom:12px}.ot-dropdown-menu.uib-dropdown-menu li a{padding:8px 20px;margin:0;font-size:13px}.ot-fake-tabs{padding:20px;padding-bottom:0}.ot-fake-tabs button{text-transform:uppercase;font-family:Avenir-Bold;font-size:10px;letter-spacing:1px;height:38px}.ot-fake-tabs button:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.ot-fake-tabs button:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.ot-landing{background-color:#fbfaf9}.ot-landing .ot-top-wrapper{position:relative}.ot-landing .ot-accordion{border:0}.ot-landing .ot-accordion .panel-heading{display:none}.ot-landing .ot-accordion .panel-body{border:0;border-top:0!important;margin:0;padding:0}.ot-event-page{background-color:#fbfaf9;padding-top:10px;position:relative}.ot-event-page .ot-banner-container{position:relative;padding-left:0;padding-right:0;overflow:hidden}.ot-event-page .ot-small .ot-separator{width:40px}.ot-event-page .ot-event-header{height:130px}.ot-event-page .ot-event-sub-header{height:80px;font-family:Avenir-Medium}.ot-event-page .ot-event-sub-header h3{vertical-align:middle;margin:0;margin-right:15px;font-family:Avenir-Demi;font-size:16px;color:#000;float:left;line-height:80px;max-width:50%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ot-event-page .ot-event-sub-header ot-price-badge{height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;float:right;margin-right:-15px}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge-noborder{border-radius:3px;display:-webkit-box;display:-ms-flexbox;display:flex;width:320px;font-family:Avenir-Regular;color:#000}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge-noborder>p{height:38px;line-height:38px;white-space:nowrap;margin-bottom:0}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge-noborder>p span{white-space:nowrap}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge-noborder>p span:first-child{margin-left:10px;color:#000}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge-noborder>p span:last-child{margin-right:10px;color:#323232}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge-noborder>ot-rsvp{-ms-flex-negative:0;flex-shrink:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;height:38px}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge-noborder>ot-rsvp .ot-rsvp-wrapper{width:100%}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge-noborder>ot-rsvp .ot-rsvp-wrapper .form-group{padding:0}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge-noborder .form-group{margin-bottom:0}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge{border:1px solid #e5e5e5;padding:-1px;border-radius:3px;display:-webkit-box;display:-ms-flexbox;display:flex;width:320px;font-family:Avenir-Regular;color:#000}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge>p{height:38px;line-height:38px;white-space:nowrap;margin-bottom:0}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge>p span{white-space:nowrap}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge>p span:first-child{margin-left:10px;color:#000}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge>p span:last-child{margin-right:10px;color:#323232}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge>ot-rsvp{-ms-flex-negative:0;flex-shrink:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;height:38px}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge>ot-rsvp .ot-rsvp-wrapper{width:100%}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge>ot-rsvp .ot-rsvp-wrapper .form-group{padding:0}.ot-event-page .ot-event-sub-header ot-price-badge .ot-price-badge .form-group{margin-bottom:0}.ot-event-page .ot-sub-header{visibility:hidden;position:absolute;height:80px;background-color:#fff;width:100%;-webkit-transform:translateY(-100%);transform:translateY(-100%)}.ot-event-page .ot-sub-header .ot-it-should-be-perfectly-aligned .ot-left-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ot-event-page .ot-sub-header .ot-it-should-be-perfectly-aligned .ot-left-container>h3{height:auto;line-height:normal;margin-top:0;margin-bottom:-4px}.ot-event-page .ot-sub-header .ot-it-should-be-perfectly-aligned .ot-left-container .ot-link-list{line-height:normal;height:auto}.ot-event-page .ot-sub-header .ot-it-should-be-perfectly-aligned .ot-price-badge-noborder{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ot-event-page .ot-sub-header .ot-it-should-be-perfectly-aligned .ot-price-badge-noborder p{margin-bottom:-4px}.ot-event-page .ot-sub-header>div>div{max-width:1192px;margin:auto}.ot-event-page .ot-sub-header .ot-link-list-container{display:inline-block;margin:0;height:80px;line-height:80px}.ot-event-page .ot-sub-header .ot-link-list-container.ot-hide-dishes-link .ot-dishes-link{display:none}.ot-event-page .ot-sub-header .ot-link-list{height:80px;list-style-type:none;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ot-event-page .ot-sub-header .ot-link-list li{display:inline-block;height:100%}.ot-event-page .ot-sub-header .ot-link-list li .ot-link{height:85px;line-height:85px;padding-left:21.25px;padding-right:21.25px;cursor:pointer}.ot-event-page .ot-sub-header.ot-fixed-sub-header{position:fixed;top:50px;display:block;z-index:1001;visibility:visible;-webkit-transition:all .4s ease;transition:all .4s ease;-webkit-transform:translate(0);transform:translate(0)}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions,.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*{height:80px}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*>.ot-sub-header-content{position:relative;height:80px;font-family:Avenir-Medium}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*>.ot-sub-header-content>div{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*>.ot-sub-header-content>div input{height:48px;margin-left:15px;margin-right:15px;padding-left:16px;padding-right:16px;font-size:14px;font-family:Avenir-Medium}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*>.ot-sub-header-content>div input.btn-default{border:2px solid #000;color:#323232}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*>.ot-sub-header-content>div input.btn-default:hover{background-color:#000;color:#fff}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*>.ot-sub-header-content>div input.btn-noborder-default{border:0;color:#323232;background:transparent}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*>.ot-sub-header-content>div input.btn-noborder-default:hover{color:#000}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*>.ot-sub-header-content>*{position:absolute;top:0;height:80px}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*>.ot-sub-header-content h2{right:0;left:0;font-family:Avenir-Medium;font-size:30px;color:#000;text-align:center;height:80px;line-height:80px;margin:0}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*>.ot-sub-header-content>div.ot-left{left:0}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*>.ot-sub-header-content>div.ot-left input:first-child{margin-left:0}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*>.ot-sub-header-content>div.ot-right{right:0;text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*>.ot-sub-header-content>div.ot-right input:last-child{margin-right:0}@media (min-width:1200px){.ot-event-page .ot-sub-header.ot-fixed-sub-header{top:85px}}@media (max-width:767px){.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions{height:130px}.ot-event-page .ot-sub-header.ot-fixed-sub-header.ot-actions>*>.ot-sub-header-content>div input{margin-top:100px;margin-left:0;margin-right:4px;padding-left:10px;padding-right:10px}}.ot-event-page .ot-anchor{position:relative;top:-180px}.ot-event-page .ot-first-anchor{position:relative;top:-120px}.ot-event-page .ot-attendants,.ot-event-page .ot-host{display:-webkit-box;display:-ms-flexbox;display:flex}.ot-event-page .ot-card,.ot-event-page .ot-card-subheadered{background-color:#fff;margin:20px}.ot-event-page .ot-card-borderless{margin:20px}@media (max-width:767px){.ot-event-page .ot-card-borderless{margin:20px 0}}@media (max-width:991px) and (min-width:768px){.ot-event-page .ot-card-borderless{margin:20px 0}}.ot-event-page .ot-card-subheadered{margin-top:100px}.ot-event-page .ot-viewported{display:block;margin-left:auto;margin-right:auto;max-width:1192px}@media (max-width:767px){.ot-event-page .ot-viewported{height:auto!important}}@media (max-width:991px) and (min-width:768px){.ot-event-page .ot-viewported{height:auto!important}}.ot-event-page .host-card>div>button,.ot-event-page .ot-might-like>div>button{display:block;margin:auto;border:1px solid #323232;color:#323232;font-family:Avenir-Demi;height:38px;padding-left:40px;padding-right:40px}.ot-event-page .ot-might-like>div>button{margin-bottom:90px}.ot-event-page .host-card>div>button{margin-top:30px}.ot-event-page .ot-event-type-picker{text-align:center;max-width:1192px;margin-left:auto;margin-right:auto;padding-top:40px;padding-bottom:40px}.ot-event-page .ot-event-type-picker label{margin:0;padding:0;font-weight:400;font-size:14px;color:#000}@media (max-width:767px){.ot-event-page .ot-event-type-picker label{width:100%}}.ot-event-page .ot-event-type-picker .ot-description{font-family:Avenir-Demi;font-size:18px;color:#323232}.ot-event-page .ot-event-type-picker input[type=radio]{margin-left:22px;margin-right:8px}.ot-event-page .ot-event-type-picker .glyphicon{color:#bbb}.ot-event-page .center-card{padding-left:5%;padding-right:5%;display:block;padding-bottom:10px}.ot-event-page .center-card .ot-dish>span:first-child{font-size:50px}.ot-event-page .center-card .ot-description-label{display:none}.ot-event-page .center-card textarea{resize:none;margin-top:30px;padding:10px 14px;height:114px}.ot-event-page .center-card .ot-type-list{margin-bottom:30px}.ot-event-page .center-card .ot-type-picker{margin-top:20px;text-align:left}.ot-event-page .main-card{height:480px;padding-bottom:28px;display:block}.ot-event-page .main-card .dropdown-menu{max-height:200px!important;overflow-y:scroll!important}.ot-event-page .main-card .ot-price-row button{height:38px}.ot-event-page .main-card .ot-price-row input{width:6em}.ot-event-page .main-card>.ot-half-container:last-child{padding-right:45px}@media (max-width:767px){.ot-event-page .main-card>.ot-half-container:last-child{padding-right:15px}}@media (max-width:991px) and (min-width:768px){.ot-event-page .main-card>.ot-half-container:last-child{padding-right:0}}.ot-event-page .main-card .ot-withheld-fees{font-size:12px;margin-top:13px;text-align:justify}.ot-event-page .main-card label{font-family:Avenir-Demi;font-size:14px;font-weight:400;color:#000;display:block;white-space:nowrap}.ot-event-page .main-card .ot-label-with-suggestion label{float:left}.ot-event-page .main-card .ot-label-with-suggestion .ot-label-suggestion{float:right;font-size:12px;margin-top:3px;font-weight:400;font-family:Avenir-Regular}.ot-event-page .main-card .row.ot-first{margin-top:20px}.ot-event-page .main-card ot-banner{width:50%}.ot-event-page .main-card ot-banner .ot-banner{height:480px}.ot-event-page .main-card .ot-avatar{padding-top:45px;color:#424242;font-family:Avenir-Regular;font-size:12px}.ot-event-page .main-card .ot-avatar .ot-md{height:80px;width:80px}.ot-event-page .main-card h3{font-family:Avenir-Demi;font-size:30px;margin:0 auto;color:#4d4d4d;padding-top:30px;padding-bottom:10px;text-align:center;overflow:hidden;text-overflow:ellipsis}.ot-event-page .main-card .ot-info{text-align:center;padding-top:10px;padding-bottom:18px;font-size:13px;color:#bbb}.ot-event-page .main-card .ot-info p span{max-width:190px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;display:inline-block;color:#bbb;font-family:Avenir-Regular}.ot-event-page .main-card .ot-separator{display:block;margin-left:auto;margin-right:auto;padding-bottom:18px}.ot-event-page .main-card p{text-align:center}.ot-event-page .main-card .ot-price-badge{font-family:Avenir-Regular;color:#000}.ot-event-page .main-card .ot-price-badge p span{display:block}.ot-event-page .main-card .ot-price-badge p span:last-child{color:#323232;font-size:23px}.ot-event-page .ot-ev1{text-align:center;font-family:Avenir-Regular}.ot-event-page .ot-ev1 h3{font-size:21px;color:#323232;padding-top:50px;padding-bottom:30px;margin:0;text-align:center}.ot-event-page .ot-ev1 .ot-separator{display:block;margin-left:auto;margin-right:auto}.ot-event-page .ot-ev1 h4{font-family:Avenir-Demi;font-size:14px;color:#000;padding-bottom:20px;padding-top:20px;margin:0}.ot-event-page .ot-ev1 p{font-size:14px;color:#424242;padding-top:30px;padding-bottom:20px;margin:0;line-height:1.5;color:#3d3d3d}.ot-event-page .ot-ev1 wysiwyg-edit{margin-top:10px}.ot-event-page .ot-ev1 wysiwyg-edit .tinyeditor{margin-top:16px}.ot-event-page .ot-ev1 wysiwyg-edit .tinyeditor .sizer{height:250px!important}.ot-event-page .ot-ev1 wysiwyg-edit .resizer,.ot-event-page .ot-ev1 wysiwyg-edit .tinyeditor-footer{display:none}.ot-event-page .ot-ev1 ot-attendants{display:inline-block}.ot-event-page .ot-ev1 .ot-avatar{margin:auto}.ot-event-page .menu-card h3{font-size:21px;color:#323232;text-align:center;padding-top:50px;padding-bottom:30px;margin:0}.ot-event-page .menu-card .ot-separator{display:block;margin-left:auto;margin-right:auto;margin-bottom:20px}.ot-event-page .menu-card .ot-third-container{text-align:center}.ot-event-page .menu-card .ot-third-container h4{color:#323232;padding-top:20px;padding-bottom:25px;margin:0;text-align:center}.ot-event-page .menu-card .ot-third-container .ot-dish-list{font-size:13px;color:#424242}.ot-event-page .menu-card .ot-third-container .ot-dish-list .ot-remove{margin-left:4px}.ot-event-page .menu-card .ot-third-container .ot-dish-list form{width:60%;margin:auto;position:relative}.ot-event-page .menu-card .ot-third-container .ot-dish-list form input[type=submit]{position:absolute;height:38px;border:0;background-color:transparent;top:0;right:0}.ot-event-page .menu-card .ot-third-container ol,.ot-event-page .menu-card .ot-third-container ul{padding-left:0;list-style-position:inside}.ot-event-page .nourishment-card{text-align:center;color:#4d4d4d;padding-bottom:20px}.ot-event-page .nourishment-card h3{font-size:21px;color:#323232;text-align:center;padding-top:50px;padding-bottom:30px;margin:0}.ot-event-page .nourishment-card h2{font-family:Avenir-Demi}.ot-event-page .nourishment-card .ot-separator{display:block;margin-left:auto;margin-right:auto;margin-bottom:20px}.ot-event-page .nourishment-card .small{width:50%;margin:40px auto;margin-top:40px;margin-bottom:40px}@media (max-width:767px){.ot-event-page .nourishment-card .small{margin:0 auto}}.ot-event-page .nourishment-card .center{border-left:solid #d3d3d3;border-right:solid #d3d3d3;border-left-width:1px;border-right-width:1px}.ot-event-page .nourishment-card .ot-logo-sponsor{height:80px;margin:0 auto;background-size:contain;background-repeat:no-repeat;background-position:50%}.ot-event-page .nourishment-card .ot-logo-instacart{height:80px;margin:0 auto;background:url(" + __webpack_require__(11) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-plated{height:80px;margin:0 auto;background:url(" + __webpack_require__(12) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-freshdirect{height:80px;margin:0 auto;background:url(" + __webpack_require__(10) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-drizzly{height:80px;margin:0 auto;background:url(" + __webpack_require__(121) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-grow-behold{height:80px;margin:0 auto;background:url(" + __webpack_require__(125) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-etsy{height:80px;margin:0 auto;background:url(" + __webpack_require__(122) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-our-harvest{height:80px;margin:0 auto;background:url(" + __webpack_require__(128) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-seamless{height:80px;margin:0 auto;background:url(" + __webpack_require__(131) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-sherry-leheman{height:80px;margin:0 auto;background:url(" + __webpack_require__(132) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-soom-soom{height:80px;margin:0 auto;background:url(" + __webpack_require__(133) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-table-swoon{height:80px;margin:0 auto;background:url(" + __webpack_require__(134) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-doordash{height:80px;margin:0 auto;background:url(" + __webpack_require__(120) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-localmission{height:80px;margin:0 auto;background:url(" + __webpack_require__(127) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-wholefoods{height:80px;margin:0 auto;background:url(" + __webpack_require__(139) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-goodeggs{height:80px;margin:0 auto;background:url(" + __webpack_require__(124) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-rainbow{height:80px;margin:0 auto;background:url(" + __webpack_require__(130) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-themarket{height:80px;margin:0 auto;background:url(" + __webpack_require__(135) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-birite{height:80px;margin:0 auto;background:url(" + __webpack_require__(118) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card .ot-logo-thrivemarket{height:80px;margin:0 auto;background:url(" + __webpack_require__(136) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card input{height:48px;margin-left:15px;margin-right:15px;padding-left:40px;padding-right:40px;font-size:14px;font-family:Avenir-Medium;margin:0 auto}.ot-event-page .nourishment-card input.btn-default{border:2px solid #000;color:#323232}.ot-event-page .nourishment-card input.btn-default:hover{background-color:#000;color:#fff}.ot-event-page .nourishment-card .form-control{width:140px;text-align:center}.ot-event-page .nourishment-card-page{text-align:center;color:#4d4d4d;padding-bottom:20px;margin-top:120px}.ot-event-page .nourishment-card-page h3{font-size:21px;color:#323232;text-align:center;padding-top:50px;padding-bottom:30px;margin:0}.ot-event-page .nourishment-card-page h2{font-family:Avenir-Demi}.ot-event-page .nourishment-card-page .ot-separator{display:block;margin-left:auto;margin-right:auto;margin-bottom:20px}.ot-event-page .nourishment-card-page .small{width:50%;margin:0 auto;margin-top:40px;margin-bottom:40px}.ot-event-page .nourishment-card-page .center{border-left:solid #d3d3d3;border-right:solid #d3d3d3;border-left-width:1px;border-right-width:1px}.ot-event-page .nourishment-card-page .ot-logo-instacart{height:80px;margin:0 auto;background:url(" + __webpack_require__(11) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card-page .ot-logo-plated{height:80px;margin:0 auto;background:url(" + __webpack_require__(12) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card-page .ot-logo-freshdirect{height:80px;margin:0 auto;background:url(" + __webpack_require__(10) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .nourishment-card-page input{height:48px;margin-left:15px;margin-right:15px;padding-left:40px;padding-right:40px;font-size:14px;font-family:Avenir-Medium;margin:0 auto}.ot-event-page .nourishment-card-page input.btn-default{border:2px solid #000;color:#323232}.ot-event-page .nourishment-card-page input.btn-default:hover{background-color:#000;color:#fff}.ot-event-page .nourishment-card-page .form-control{width:140px}.ot-event-page .guests-card{text-align:center;color:#4d4d4d;padding-bottom:50px;padding-top:50px;margin-top:30px;min-height:0}.ot-event-page .guests-card .ot-seat-counter{height:50px;width:30%;border:1px solid #e5e5e5;border-radius:6px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:30px;margin-bottom:30px}@media (max-width:767px){.ot-event-page .guests-card .ot-seat-counter{width:80%}}.ot-event-page .guests-card .ot-seat-counter>a{width:50px;height:50px;margin:-1px;color:#323232;font-size:12px;padding:0}.ot-event-page .guests-card .ot-seat-counter>a span{height:50px;line-height:50px}.ot-event-page .guests-card .ot-seat-counter>button{width:50px;height:50px;margin:-1px;color:#323232;font-size:12px;padding:0}.ot-event-page .guests-card .ot-seat-counter>button span{height:50px;line-height:50px}.ot-event-page .guests-card .ot-seat-counter>span{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;font-size:14px;color:#8c8c8c}.ot-event-page .guests-card h3{font-size:21px;color:#323232;text-align:center;padding-top:50px;padding-bottom:30px;margin:0}.ot-event-page .guests-card h2{font-family:Avenir-Demi}.ot-event-page .guests-card .ot-separator{display:block;margin-left:auto;margin-right:auto;margin-bottom:20px}.ot-event-page .guests-card .small{width:50%;margin:0 auto;margin-top:40px;margin-bottom:40px}.ot-event-page .guests-card .center{border-left:solid #d3d3d3;border-right:solid #d3d3d3;border-left-width:1px;border-right-width:1px}.ot-event-page .guests-card .ot-logo-instacart{height:80px;margin:0 auto;background:url(" + __webpack_require__(11) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .guests-card .ot-logo-plated{height:80px;margin:0 auto;background:url(" + __webpack_require__(12) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .guests-card .ot-logo-freshdirect{height:80px;margin:0 auto;background:url(" + __webpack_require__(10) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-event-page .guests-card input{height:48px;margin-left:15px;margin-right:15px;padding-left:40px;padding-right:40px;font-size:14px;font-family:Avenir-Medium;margin:0 auto}.ot-event-page .guests-card input.btn-default{border:2px solid #000;color:#323232}.ot-event-page .guests-card input.btn-default:hover{background-color:#000;color:#fff}.ot-event-page .guests-card .ot-fake-tabs input.ot-active,.ot-event-page .guests-card input.btn-primary,.ot-fake-tabs .ot-event-page .guests-card input.ot-active{border:2px solid #323232;color:#323232;border-color:#323232;background:#fff}.ot-event-page .guests-card .ot-fake-tabs input.ot-active:hover,.ot-event-page .guests-card input.btn-primary:hover,.ot-fake-tabs .ot-event-page .guests-card input.ot-active:hover{background-color:#323232;color:#fff}.ot-event-page .guests-card input.btn-primary-disabled{border:2px solid #4d4d4d;color:#fff;border-color:#4d4d4d;background-color:#4d4d4d}.ot-event-page .guests-card .form-control{width:140px}.ot-event-page.ot-edit .ot-dish-list input[type=text]{margin-top:24px;margin-bottom:24px;padding-right:45px}.ot-event-page.ot-edit .ot-dish-list{padding-top:24px}.ot-event-page .host-card h3{font-size:21px;color:#323232;text-align:center;padding-top:50px;padding-bottom:30px;margin:0}.ot-event-page .host-card .ot-separator{display:block;margin-left:auto;margin-right:auto}.ot-event-page .host-card .ot-avatar{padding-top:30px;padding-bottom:15px}.ot-event-page .host-card .ot-lg{width:80px;height:80px;box-shadow:0 0 20px #000}.ot-event-page .host-card p{text-align:center;padding-top:15px;font-size:14px;margin-bottom:0;color:#424242;padding-bottom:15px;line-height:1.5}.ot-event-page .host-card .host-message-button{background:#323232;color:#fff;text-transform:uppercase;font-family:Avenir-Regular;margin-bottom:40px}.ot-event-page .ot-title-card{margin-top:120px;text-align:center;min-height:150px;max-width:1192px;margin-left:auto;margin-right:auto;padding-left:5%;padding-right:5%;display:block}.ot-event-page .ot-title-card h3{font-family:Avenir-Demi;font-size:30px;overflow:hidden;margin:0 auto;color:#4d4d4d;padding-top:30px;padding-bottom:10px;text-align:center;white-space:nowrap;text-overflow:ellipsis}.ot-event-page .ot-gray-text{color:#4d4d4d}.ot-event-page .ot-red-shadow{box-shadow:inset 0 0 5px #323232}.ot-event-page .ot-red-shadow h2,.ot-event-page .ot-red-shadow p{color:#323232}.ot-event-page .ot-red-border{border:1px solid #323232}.ot-event-page .ot-red-border h2,.ot-event-page .ot-red-border p{color:#323232}.ot-event-page .ot-event-type-error{font-size:18px;padding-bottom:20px}.ot-event-page .ot-be-the-first,.ot-event-page .ot-event-manual,.ot-event-page .ot-event-private{height:38px}.ot-event-page .ot-be-the-first{display:table;width:100%}.ot-event-page .ot-be-the-first p{padding:5px;display:table-cell;vertical-align:middle;font-size:12px;color:#8c8c8c;font-family:Avenir-It}.ot-event-page .ot-event-private{display:table;margin-left:auto;margin-right:auto;background:#f7f7f7;border:1px solid #e5e5e5;border-radius:5px}.ot-event-page .ot-event-private p{padding:5px;display:table-cell;vertical-align:middle;font-size:12px;color:#8c8c8c;font-family:Avenir-It}.ot-event-page .ot-event-manual{display:table;margin-left:auto;margin-right:auto;background:#f7f7f7;border:1px solid #e5e5e5;border-radius:5px}.ot-event-page .ot-event-manual p{padding:5px;display:table-cell;vertical-align:middle;font-size:12px;color:#8c8c8c;font-family:Avenir-It}.ot-link-active{color:#323232}.ot-icon-appetizers{background:url(" + __webpack_require__(113) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-icon-appetizers,.ot-icon-dessert{height:100px;width:100px;margin:0 auto}.ot-icon-dessert{background:url(" + __webpack_require__(114) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-icon-main{height:100px;width:100px;margin:0 auto;background:url(" + __webpack_require__(115) + ") 50%;background-size:contain;background-repeat:no-repeat}.ot-subheader-margin{margin-top:90px}.ot-attendants-spacing,.ot-nourished-spacing{margin-bottom:20px}.ot-nourished-spacing p{min-height:70px}.ot-currency-sign{left:25px;line-height:38px}.ot-currency-sign,.ot-currency-sign-big{position:absolute;font-size:14px;color:#555}.ot-currency-sign-big{left:32px;line-height:48px}.ot-currency-sign-field{padding-left:20px;float:left}.ot-beta-test{font-size:15px;margin-top:-10px;font-size:12px;color:#4d4d4d;margin-top:10px}.ot-manage{background-color:#fbfaf9}.ot-manage>.container-fluid{max-width:1192px;margin:auto}.ot-api-test{margin:30px}.ot-profile{background-color:#fbfaf9}.ot-profile button,.ot-profile input{height:42px!important}.ot-profile textarea{height:114px;width:100%;resize:none}.ot-profile h2{text-align:center;margin-top:50px;margin-bottom:50px;color:#000;font-family:Avenir-Demi;font-size:30px}.ot-profile .ot-date>span{width:42px;height:42px}.ot-profile .ot-date>span button{height:42px;width:100%}.ot-profile .ot-editable-avatar{cursor:pointer;background:none}.ot-profile .ot-editable-avatar>div{margin:0;border-radius:50%;background-color:#fff;background-image:url(" + __webpack_require__(16) + ");background-repeat:no-repeat;background-size:cover;background-position:50%;border:1px solid #fff}.ot-profile .ot-editable-avatar>div div{color:#fff;text-align:center;line-height:80px}.ot-profile .ot-editable-avatar .ot-edit{display:none}.ot-profile .ot-editable-avatar:hover .ot-edit{display:block}.ot-profile .ot-editable-avatar:hover .ot-view{display:none}.ot-profile .ot-username{margin-top:20px;font-family:Avenir-Demi;color:#000;font-size:18px}.ot-profile .row{margin-bottom:16px}.ot-profile .row.ot-last{margin-bottom:50px}.ot-profile .ot-change-password-link,.ot-profile label{height:42px;line-height:42px;margin:0;padding:0}.ot-profile .ot-change-password-link{font-family:Avenir-Demi;font-size:13px;color:#323232;cursor:pointer}.ot-profile label{font-family:Avenir-Demi;font-size:14px;color:#000}.ot-profile .ot-small .ot-separator{margin:30px auto 50px;width:40px}.ot-profile input[type=submit]{padding:0 30px}.ot-profile .action-card-button,.ot-profile input[type=submit]{font-size:14px;font-family:Avenir-Demi;margin-top:20px;margin-left:10px;display:block;float:right}.ot-profile .action-card-button{padding:10px 30px}.ot-profile .card-number{position:relative}.ot-profile .card-number span{position:absolute;left:65px;top:14px}.ot-profile .ot-credit-card div{position:relative}.ot-profile .ot-credit-card p{margin:30px 0 10px;font-family:Avenir-Demi;color:#443035;font-size:18px;text-align:left}.ot-profile .ot-credit-card div.add_card_button{width:100%;background:transparent;color:#323232;font-size:16px}.ot-profile .ot-credit-card div.add_card_button:hover{color:#fff;background:#000}.ot-profile .ot-credit-card .sub-label{width:100%;font-size:12px;color:#555}.ot-profile .ot-register-credit-card{opacity:0}.ot-profile .ot-register-credit-card p{color:#555;font-size:12px}.ot-profile .ot-register-credit-card input[type=checkbox]{height:auto!important}.ot-profile .ot-register-credit-card .set_default_text{text-align:right;margin-top:10px}.ot-profile .showcard{max-height:300px;opacity:1!important}.ot-profile .hidecard,.ot-profile .showcard{-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.ot-profile .hidecard{max-height:0!important;overflow:hidden;opacity:0!important}.ot-profile .card-calendar-icon{position:absolute;right:28px;top:13px}.ot-profile .cancel-button{background:transparent;opacity:0;color:#323232;margin-top:20px;padding:12px 20px}.ot-profile .ot-list-credit-card{margin-bottom:40px}.ot-profile .ot-list-credit-card label{height:10px;line-height:10px}.ot-profile .ot-list-credit-card .change-card-button{background:transparent;font-family:Avenir-Black;font-size:16px;color:#323232;float:right;border:none;box-shadow:none}.ot-profile .ot-list-credit-card .sub-label{width:100%;font-size:10px;color:#555}.ot-profile .card-menu{opacity:1}.ot-profile .card-menu p{color:#555;font-size:12px}.ot-profile .card-menu .set_default_text{text-align:right;margin-top:10px}.ot-host-promotion{text-align:center}.ot-host-promotion h3{font-family:Avenir-Demi;font-size:30px;margin-top:50px;margin-bottom:20px}.ot-host-promotion h4{font-family:Avenir-Regular;font-size:16px;margin-top:0;margin-bottom:30px}.ot-host-promotion button{margin-top:0;margin-bottom:30px;height:38px;font-family:Avenir-Bold;font-size:10px;letter-spacing:2px;text-transform:uppercase}.ot-error-container h1{text-align:center}.ot-error-container p{font-size:100px;color:#8d1b37;padding:20px 0 0;margin:0 30% 20px;border-bottom:1px solid #ddd;text-align:center}.ot-modal .ot-half-background{position:absolute;top:0;bottom:0;left:0;width:50%;margin:0;padding:0}.ot-modal.ot-login>div{min-height:320px}.ot-modal.ot-login>div>div:not(.ot-close-login){display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ot-modal.ot-login>div>div:not(.ot-close-login):first-child{-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:left;padding-left:35px;padding-right:30px}.ot-modal.ot-login>div>div:not(.ot-close-login):first-child .ot-logo{margin-bottom:20px}.ot-modal.ot-login>div>div:not(.ot-close-login):first-child p{font-size:13px}.ot-modal.ot-login>div>div:not(.ot-close-login):first-child p:nth-child(2){font-family:Avenir-Demi;color:#000}.ot-modal form{text-align:left}@media (min-width:1200px){.ot-modal .ot-logo{height:85px}}.ot-modal .ot-separator{padding:5px}.ot-modal ot-separator.ot-first .ot-separator,.ot-modal ot-separator.ot-second .ot-separator{margin-top:18px;margin-bottom:18px}.ot-modal ot-separator.ot-first .ot-separator p,.ot-modal ot-separator.ot-second .ot-separator p{font-size:10px;font-family:Avenir-Bold;margin-left:12px;margin-right:12px}.ot-modal ot-separator.ot-first.ot-second .ot-separator,.ot-modal ot-separator.ot-second.ot-second .ot-separator{margin-top:8px;margin-bottom:8px}.ot-modal ot-separator.ot-first.ot-second.ot-active,.ot-modal ot-separator.ot-second.ot-second.ot-active{cursor:pointer}.ot-modal ot-separator.ot-first.ot-second.ot-active p,.ot-modal ot-separator.ot-second.ot-second.ot-active p{color:#323232}.ot-modal .ot-stepper .ot-current{font-weight:700}.ot-modal .ot-terms{margin-right:15px;margin-left:15px;text-align:center;font-size:12px;color:#8c8c8c}.ot-modal .ot-terms a{color:#323232;text-decoration:underline;cursor:pointer}@media (max-width:767px){.ot-modal.ot-login>div .ot-logo{margin-bottom:20px}}.ot-confirm button{margin-top:8px;margin-bottom:8px}.ot-confirm.ot-small{text-align:center;padding:45px 65px}.ot-confirm.ot-small .ot-logo{display:inline}.ot-confirm.ot-small h2{font-family:Avenir-Demi;font-size:18px}.ot-welcome p{margin-bottom:20px}.ot-welcome button{margin:10px 0}.ot-rsvp-modal{padding:0}.ot-rsvp-modal>.row>.ot-half-container:last-child{padding:0;margin-top:35px}@media (max-width:767px){.ot-rsvp-modal>.row>.ot-half-container:last-child{padding-right:0}}@media (max-width:991px) and (min-width:768px){.ot-rsvp-modal>.row>.ot-half-container:last-child{padding-right:0}}.ot-rsvp-modal h4{margin-top:30px;margin-bottom:10px;font-size:13px}.ot-rsvp-modal h3{margin-top:0;margin-bottom:10px;color:#000;font-family:Avenir-Demi;font-size:18px}.ot-rsvp-modal .ot-info{font-size:13px}.ot-rsvp-modal .ot-small .ot-separator{margin:14px auto;width:40px}.ot-rsvp-modal .ot-mini-cost span{display:block}.ot-rsvp-modal .ot-mini-cost span:first-child{color:#000;font-size:13px;margin-bottom:6px}.ot-rsvp-modal .ot-mini-cost span:last-child{color:#323232;font-size:24px}.ot-rsvp-modal button{width:50%;display:inline-block;height:38px;color:#fff;font-size:14px;font-family:Avenir-Demi;text-transform:uppercase;letter-spacing:1px}@media (max-width:767px){.ot-rsvp-guests-modal,.ot-rsvp-modal{padding:20px 10px}}.ot-rsvp-guests-modal .ot-seat-counter,.ot-rsvp-modal .ot-seat-counter{height:38px;width:50%;border:1px solid #e5e5e5;border-radius:6px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media (max-width:767px){.ot-rsvp-guests-modal .ot-seat-counter,.ot-rsvp-modal .ot-seat-counter{width:70%}}.ot-rsvp-guests-modal .ot-seat-counter>button,.ot-rsvp-modal .ot-seat-counter>button{width:38px;height:38px;margin:-1px;color:#323232;font-size:12px;padding:0}.ot-rsvp-guests-modal .ot-seat-counter>button span,.ot-rsvp-modal .ot-seat-counter>button span{height:38px;line-height:38px}.ot-rsvp-guests-modal .ot-seat-counter>span,.ot-rsvp-modal .ot-seat-counter>span{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;font-size:14px;color:#8c8c8c}.ot-rsvp-guests-modal h2{font-family:Avenir-Demi;font-size:18px;color:#000;margin-top:20px;margin-bottom:30px}.ot-rsvp-guests-modal h3{color:#424242;font-size:14px;margin-bottom:22px}.ot-rsvp-guests-modal .ot-seat-counter{margin-bottom:18px}.ot-rsvp-guests-modal form .rf-small{margin-left:15px;margin-right:15px}.ot-rsvp-guests-modal .ot-row{margin-top:8px;margin-bottom:8px}.ot-rsvp-guests-modal .ot-row div:first-child input{border-bottom-left-radius:0;border-bottom-right-radius:0}.ot-rsvp-guests-modal .ot-row div:last-child input{border-top-left-radius:0;border-top-right-radius:0}.ot-rsvp-guests-modal .ot-row input.ot-rounded{border-radius:3px}.ot-rsvp-guests-modal .ot-separator{margin-top:22px;margin-bottom:10px}.ot-rsvp-guests-modal .ot-actions{position:relative;width:100%;height:38px}.ot-rsvp-guests-modal .ot-actions input[type=reset],.ot-rsvp-guests-modal .ot-actions input[type=submit]{height:38px;font-family:Avenir-Bold;font-size:10px;letter-spacing:1px;text-transform:uppercase}.ot-rsvp-guests-modal .ot-actions input[type=reset]{position:absolute;left:0;border:2px solid #000}.ot-rsvp-guests-modal .ot-actions input[type=reset]:hover{background-color:#000;color:#fff}.ot-rsvp-guests-modal .ot-actions input[type=submit]{position:absolute;right:0}.ot-rsvp-payment-modal{padding-left:95px;padding-right:95px;padding-bottom:60px}@media (max-width:767px){.ot-rsvp-payment-modal{padding-left:20px;padding-right:20px;padding-bottom:20px}}.ot-rsvp-payment-modal .default-checkbox{font-size:12px}.ot-rsvp-payment-modal .card-list-box{max-height:0}.ot-rsvp-payment-modal .card-list-box,.ot-rsvp-payment-modal .card-list-box-all{overflow:hidden;-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.ot-rsvp-payment-modal .card-list-box-all{max-height:85px!important}.ot-rsvp-payment-modal .card-list-box-height{overflow:hidden;max-height:400px!important;-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.ot-rsvp-payment-modal h2{font-family:Avenir-Demi;font-size:21px;color:#000;margin-top:35px;margin-bottom:30px}.ot-rsvp-payment-modal h3{font-size:14px;margin-top:25px;margin-bottom:50px}.ot-rsvp-payment-modal .ot-card-general-row{margin-top:10px}.ot-rsvp-payment-modal .ot-card-general-row label input{font-family:Avenir-Regular}.ot-rsvp-payment-modal .ot-card-info-group{margin-top:10px}.ot-rsvp-payment-modal .ot-card-info-group label input{font-family:Avenir-Regular;float:left;width:50%;text-align:center}.ot-rsvp-payment-modal .close-button-icon{color:#8c8c8c;font-size:18px}.ot-rsvp-payment-modal .coupon-label{text-align:left;font-size:14px;font-family:Avenir-Demi;color:#323232}.ot-rsvp-payment-modal .use-default{font-family:Avenir-Regular;font-size:12px}@media (max-width:767px){.ot-rsvp-payment-modal .use-default{float:left;margin-top:15px;margin-left:20px}}.ot-rsvp-payment-modal label{font-family:Avenir-Demi;font-size:14px;font-weight:400;color:#000;display:block;margin-top:16px;margin-bottom:10px}.ot-rsvp-payment-modal label span{padding:2px 0 0}.ot-rsvp-payment-modal label.ot-inline{display:inline-block;margin-left:12px;margin-top:10px;margin-bottom:10px;font-size:13px;vertical-align:middle}.ot-rsvp-payment-modal .ot-first label{margin-top:0}.ot-rsvp-payment-modal input[type=checkbox]{margin:0;margin-bottom:2px;vertical-align:middle}.ot-rsvp-payment-modal .ot-banner{display:inline-block;border-radius:3px;height:80px;vertical-align:top;margin:30px 0}.ot-rsvp-payment-modal .ot-right{display:inline-block;vertical-align:top;margin-left:18px}.ot-rsvp-payment-modal .ot-right h3{font-family:Avenir-Demi;font-size:14px;color:#000;margin:0}.ot-rsvp-payment-modal .ot-right .ot-info{margin-top:12px;margin-bottom:10px;font-size:12px}.ot-rsvp-payment-modal .ot-right .ot-info p{margin:0}.ot-rsvp-payment-modal .ot-separator{padding-left:0;padding-right:0}.ot-rsvp-payment-modal .ot-data-row{font-size:13px;display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:10px;margin-bottom:10px}.ot-rsvp-payment-modal .ot-data-row a{font-family:Avenir-Demi;font-size:11px;display:inline-block;margin-left:4px;color:#323232}.ot-rsvp-payment-modal .ot-data-row>span:last-child{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;text-align:right;font-family:Avenir-Demi;color:#000}.ot-rsvp-payment-modal .title-list-card{font-family:Avenir-Demi;font-size:16px;padding:0}.ot-rsvp-payment-modal .expire-list-card{font-family:Avenir-Regular;font-size:12px;padding:0}.ot-rsvp-payment-modal .brand-list-card{padding:0}.ot-rsvp-payment-modal .list-row{border-bottom:1px solid #e5e5e5}.ot-rsvp-payment-modal .radio-card{margin:7px 3px 0 2px;opacity:0}.ot-rsvp-payment-modal .radio-div{position:relative}.ot-rsvp-payment-modal .radio-div span{position:absolute;border:1px solid #323232;left:0;padding:7px;top:6px;color:#323232;font-size:12px;line-height:12px}.ot-rsvp-payment-modal .radio-div .radiocard:after{position:absolute;left:2px;top:2px;content:'\\2714';color:#323232;font-size:12px;line-height:12px}.ot-rsvp-payment-modal .add-card-icon{font-size:20px;color:#8c8c8c;margin-right:5px}.ot-rsvp-payment-modal .data-coupon{color:#323232!important}.ot-rsvp-payment-modal .coupon-button{background:transparent;color:#323232;padding:10px 20px 6px;font-family:Avenir-Demi;float:right;margin:10px 0;width:100%}.ot-rsvp-payment-modal .change-button{background:transparent;color:#323232;padding:10px 0 6px;font-family:Avenir-Demi;float:right;border:none;box-shadow:none}.ot-rsvp-payment-modal .change-button:hover{background:transparent;color:#000}.ot-rsvp-payment-modal .sub-label{font-size:12px;padding-top:3px;color:#323232;font-family:Avenir-Bold}.ot-rsvp-payment-modal .credit-card-icon{width:30px;top:-2px;position:relative;margin:3px 0 0 5%}.ot-rsvp-payment-modal input[type=submit]{width:100%;margin-top:12px;margin-bottom:12px;height:38px;font-family:Avenir-Bold;font-size:10px;letter-spacing:1px;text-transform:uppercase}.ot-rsvp-payment-modal .ot-terms{text-align:center;font-size:12px;color:#e5e5e5}.ot-rsvp-payment-modal .ot-terms a{color:#323232}.ot-manual-approval-warning{font-size:12px;color:#4d4d4d;margin:10px 60px}.ot-higlight-name{color:#323232}.showcard{max-height:300px;opacity:1!important}.hidecard,.showcard{-webkit-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.hidecard{max-height:0!important;overflow:hidden;opacity:0!important}@media (max-width:767px){.ot-forgot{padding:20px 10px}}.ot-change-password p.ot-error-message,.ot-forgot p.ot-error-message{text-align:left}.ot-manage-guests{padding-left:55px;padding-right:55px}@media (max-width:767px){.ot-manage-guests{padding-left:10px;padding-right:10px}}.ot-manage-guests h2{font-family:Avenir-Demi;color:#323232;font-size:21px;margin-top:30px;margin-bottom:30px}.ot-manage-guests h3{font-size:14px;margin-bottom:30px}.ot-manage-guests h3 span.ot-hilight{font-family:Avenir-Bold;color:#424242}.ot-manage-guests .ot-reservation-list{background-color:#fbfaf9;border:1px solid #e5e5e5;max-height:300px;overflow-y:auto;padding-bottom:10px}@media (max-width:767px){.ot-manage-guests .ot-reservation-list{margin:0 5%;width:90%}}.ot-manage-guests .ot-reservation-list .ot-reservation-row.ot-first{margin-top:10px}.ot-manage-guests .ot-reservation-list .ot-reservation-row.ot-last .ot-separator{visibility:hidden}.ot-manage-guests .ot-reservation-list .ot-reservation-row>div:first-child{text-align:left;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ot-manage-guests .ot-reservation-list .ot-reservation-row>div:first-child .ot-avatar{margin:5px 10px 5px 0}.ot-manage-guests .ot-reservation-list .ot-reservation-row>div:first-child .ot-data{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.ot-manage-guests .ot-reservation-list .ot-reservation-row>div:first-child .ot-data h4,.ot-manage-guests .ot-reservation-list .ot-reservation-row>div:first-child .ot-data h5{margin:0}.ot-manage-guests .ot-reservation-list .ot-reservation-row>div:first-child .ot-data h4{font-family:Avenir-Demi;color:#000;font-size:13px}.ot-manage-guests .ot-reservation-list .ot-reservation-row>div:first-child .ot-data h4 .seats-link{cursor:pointer}.ot-manage-guests .ot-reservation-list .ot-reservation-row>div:first-child .ot-data h5{color:#8c8c8c;font-size:12px;margin-top:4px}.ot-manage-guests .ot-reservation-list .ot-reservation-row>div:first-child .ot-data .add_guests{color:#323232;font-size:16px;padding-left:20px}.ot-manage-guests .ot-reservation-list .ot-reservation-row>div:first-child .ot-approved{font-size:12px}.ot-manage-guests .ot-reservation-list .ot-reservation-row>div:first-child .ot-approved span>span:first-child{display:inline-block;margin-right:8px}.ot-manage-guests .ot-reservation-list .ot-seats-raw{width:90%;border-bottom:1px solid #ddd;padding:5px 0;margin:0 5%}.ot-manage-guests .ot-reservation-list .ot-last-seats{border-bottom:none!important}.ot-manage-guests .ot-reservation-list .ot-message-box textarea{width:100%;resize:none}.ot-manage-guests .ot-reservation-list .ot-message-box-addguests{width:100%;background:#fff;box-shadow:0 0 5px #ddd}.ot-manage-guests .ot-reservation-list .ot-message-box-addguests .ot-list-seats-left{text-align:left;padding:5px 0}.ot-manage-guests .ot-reservation-list .ot-message-box-addguests .ot-list-seats-right{text-align:right;padding:5px 0}.ot-manage-guests .ot-reservation-list .ot-action-link-box{margin-top:8px;margin-bottom:6px;text-align:right}.ot-manage-guests .ot-reservation-list .ot-action-link-box span{color:#8c8c8c;display:inline-block;margin-left:6px;margin-right:6px}.ot-manage-guests .ot-reservation-list .ot-action-link-box a{font-family:Avenir-Demi;color:#323232;cursor:pointer;font-size:12px}.ot-modal-success h2{font-size:24px;font-family:Avenir-Medium;color:#000;margin-top:40px;margin-bottom:40px}.ot-modal-success h3{font-size:18px;font-family:Avenir-Demi;color:#514043;margin-top:20px;margin-bottom:20px}.ot-modal-success .ot-separator{display:block;margin-left:auto;margin-right:auto;padding-bottom:18px}.ot-modal-success .ot-small .ot-separator{width:40px}.ot-modal-success p{color:#4d4d4d;line-height:1.6em;margin-top:40px;margin-bottom:40px}.ot-burger-menu .ot-link-list{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:auto}body{background:#fbfaf9}", ""]);
	
	// exports


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:fontello;src:url('data:application/octet-stream;base64,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') format('woff'),url('data:application/octet-stream;base64,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') format('truetype')}[class*=\" icon-\"]:before,[class^=icon-]:before{font-family:fontello;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em}.icon-facebook:before{content:'\\E800'}.icon-login:before{content:'\\E801'}.icon-calendar:before{content:'\\E802'}.icon-notifications:before{content:'\\E803'}.icon-marker:before{content:'\\E804'}.icon-clock:before{content:'\\E805'}.icon-filter:before{content:'\\E806'}", ""]);
	
	// exports


/***/ },
/* 192 */,
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "AvenirNextLTPro-Medium.woff";

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Graphik-Medium.woff";

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Graphik-Regular.woff";

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "Graphik-RegularItalic.woff";

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ProximaNovaCond-Bold.woff";

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "glyphicons-halflings-regular.ttf";

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "glyphicons-halflings-regular.woff";

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "glyphicons-halflings-regular.woff2";

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/Landing_Banner.jpg";

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/arabic.png";

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/bay_area@2x.jpg";

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/chicago@2x.jpg";

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cover_0_old.jpg";

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cover_1_old.jpg";

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cover_2_old.jpg";

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cover_3_old.jpg";

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cover_4_old.jpg";

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cover_5_old.jpg";

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cover_6_old.jpg";

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/credit-card.jpg";

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/emblem_navbar.png";

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/emblem_navbar.svg";

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/emblem_onetable.png";

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/favicon.ico";

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_sherry-lehmann.jpg";

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/img_thrive_market.jpg";

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo.png";

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_footer.svg";

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_footer_old.jpg";

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_footer_old.png";

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_footer_old1.jpg";

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_footer_old1.png";

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_navbar_old.jpg";

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_navbar_old1.jpg";

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_vertical.svg";

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_vertical_old1.png";

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/new_york@2x.jpg";

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/others@2x.jpg";

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bower_components/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg";

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "languages/en_EN.json";

/***/ },
/* 233 */
/***/ function(module, exports) {

	module.exports = {
		"apiEndpoint": "https://bbyo-api-development.herokuapp.com/api/v1",
		"publicEndpoint": "https://bbyo.rawfishindustries.com/",
		"facebookAppId": "920258291402212",
		"stripePublishableKey": "pk_test_umtjH6YlxvIiDv0VKX5JB1vV",
		"amazonUrl": "https://onetable-dev.s3.amazonaws.com/",
		"googleKey": "AIzaSyB0VgLqty-SkmfMeT33HVO_oLK0SNLOt_g",
		"isOnward": false
	};

/***/ },
/* 234 */
/***/ function(module, exports) {

	module.exports = {
		"apiEndpoint": "https://bbyo-api-production.herokuapp.com/api/v1",
		"publicEndpoint": "https://bbyo.onetable.org/",
		"facebookAppId": "920258291402212",
		"stripePublishableKey": "pk_test_umtjH6YlxvIiDv0VKX5JB1vV",
		"amazonUrl": "https://bbyo-tmp-production.s3.amazonaws.com/",
		"googleKey": "AIzaSyB0VgLqty-SkmfMeT33HVO_oLK0SNLOt_g",
		"isOnward": false
	};

/***/ },
/* 235 */
/***/ function(module, exports) {

	module.exports = {
		"apiEndpoint": "https://bbyo-api-staging.herokuapp.com/api/v1",
		"publicEndpoint": "https://bbyo.hexatlanta.com/",
		"facebookAppId": "920258291402212",
		"stripePublishableKey": "pk_test_umtjH6YlxvIiDv0VKX5JB1vV",
		"amazonUrl": "https://bbyo-tmp-staging.s3.amazonaws.com/",
		"googleKey": "AIzaSyB0VgLqty-SkmfMeT33HVO_oLK0SNLOt_g",
		"isOnward": false
	};

/***/ },
/* 236 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"page-container\">\n      <div class=\"ot-error-container\">\n        <p>{{vm.type}}!</p>\n        <h1>{{vm.title | translate}}</h1>\n      </div>\n    </div>\n  </div>\n</div>\n<ot-footer></ot-footer>\n"

/***/ },
/* 237 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-api-test\">\n\n  <div class=\"row\">\n  <div class=\"ot-half-container\">\n    <form ng-submit=\"vm.loadAWSConfig()\">\n      <input type=\"submit\" class=\"btn btn-primary\" value=\"LoadAWSConfig\"></input>\n    </form>\n\n    <br></br>\n\n    <pre>{{vm.aws | json:4}}</pre>\n\n  </div>\n\n<div class=\"ot-half-container\">\n<form ng-submit=\"vm.submit()\">\n  <div class=\"form-group\">\n   <label for=\"name\">Name:</label>\n   <input type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"vm.file.name\"></input>\n </div>\n <div class=\"form-group\">\n   <label for=\"file\">File:</label>\n   <input ngf-select=\"\" ng-model=\"vm.file\" name=\"file\" accept=\"image/*\" required=\"\" type=\"file\">\n </div>\n<div class=\"form-group\">\n  <input type=\"submit\" class=\"btn btn-primary\"></input>\n</div>\n\n<img ngf-src=\"vm.file || '/thumb.jpg'\">\n\n<div class=\"button\" ngf-select=\"upload($file)\">Upload on file select</div>\n\n</form>\n</div>\n</div>\n</div>\n"

/***/ },
/* 238 */
/***/ function(module, exports) {

	module.exports = ""

/***/ },
/* 239 */
/***/ function(module, exports) {

	module.exports = "<div ng-show=\"vm.currentData.event!=null\" class=\"ot-event-page\" ng-class=\"{'ot-view': vm.mode == 'view', 'ot-edit': vm.mode == 'edit' || vm.mode == 'new'}\"><!-- there is already a directive called ot-event -->\n  <div id=\"event-type\"></div>\n  <div> <!-- main container used for scrolling calculations -->\n    <form name=\"createForm\" ng-submit=\"vm.createEvent(createForm)\" novalidate>\n\n\n\n      <!-- EVENT TYPE -->\n\n\n      <!--<div ng-if=\"vm.mode!='view' && !vm.session.isOnward()\" class=\"row ot-card-subheadered ot-event-type-picker\"\n      ng-class=\"{'ot-red-border': createForm.$submitted && !createForm.eventType.$valid}\">\n        <div class=\"ot-full-container ot-error-message ot-event-type-error\"\n          ng-show=\"createForm.$submitted && !createForm.eventType.$valid\">\n            {{\"CREATE.ERROR_EMPTY_TYPE\" | translate}}\n        </div>\n        <div class=\"ot-full-container\">\n          <span class=\"ot-description\">{{'CREATE.EVENT_TYPE' | translate}}</span>\n          <input type=\"hidden\" name=\"eventType\" ng-model=\"vm.currentData.event.eventType\" required></input>\n          <label>\n            <input type=\"radio\" ng-model=\"vm.currentData.event.eventType\" ng-value=\"vm.eventTypeOptions[0]\">\n            <span>{{vm.eventTypeOptions[0] | enumName:'event' | translate}}</span>\n            <span class=\"glyphicon glyphicon-question-sign\" uib-tooltip=\"{{vm.eventTypeOptions[0] | enumName:'eventExplanation' | translate}}\"></span>\n          </label>\n          <label>\n            <input type=\"radio\" ng-model=\"vm.currentData.event.eventType\" ng-value=\"vm.eventTypeOptions[1]\">\n            <span>{{vm.eventTypeOptions[1] | enumName:'event' | translate}}</span>\n            <span class=\"glyphicon glyphicon-question-sign\" uib-tooltip=\"{{vm.eventTypeOptions[1] | enumName:'eventExplanation' | translate}}\"></span>\n          </label>\n          <label>\n            <input type=\"radio\" ng-model=\"vm.currentData.event.eventType\" ng-value=\"vm.eventTypeOptions[2]\">\n            <span>{{vm.eventTypeOptions[2] | enumName:'event' | translate}}</span>\n            <span class=\"glyphicon glyphicon-question-sign\" uib-tooltip=\"{{vm.eventTypeOptions[2] | enumName:'eventExplanation' | translate}}\"></span>\n          </label>\n        </div>\n      </div>-->\n      <div ng-if=\"vm.mode!='view'\" class=\"row ot-card-subheadered ot-event-type-picker\"\n      ng-class=\"{'ot-red-border': createForm.$submitted && !createForm.eventType.$valid}\">\n        <div class=\"ot-full-container\">\n          <span class=\"ot-description\">Once you get 5 prospects (Jewish teens that are not yet members of BBYO) to register to attend your event, you’ll be contacted to select a free gift card to feed your crowd!<br/> Remember, BBYO is covering food for up to 20 guests so think about how many teens you can host in your space!</span>\n          <input type=\"hidden\" name=\"eventType\" ng-model=\"vm.currentData.event.eventType\" ng-value=\"vm.eventTypeOptions[1]\" required></input>\n        </div>\n      </div>\n\n\n\n      <!-- MAIN -->\n\n\n      <div class=\"row ot-card main-card ot-viewported\">\n        <div class=\"ot-half-container ot-banner-container\">\n          <!-- MAIN BANNER IN VIEW MODE -->\n          <ot-banner ng-if=\"vm.mode=='view'\" params=\"{'src': vm.getCurrentData().event.cover.l}\"></ot-banner>\n\n          <!-- MAIN BANNER IN EDIT MODE -->\n          <div ng-if=\"vm.getCurrentData()\">\n            <ot-image-uploader ng-if=\"vm.mode=='edit' || vm.mode == 'new'\" image=\"vm.imagePromise\" current=\"vm.getCurrentData().event.cover.l\"></ot-image-uploader>\n          </div>\n        </div>\n\n        <div class=\"ot-half-container\">\n\n          <!-- MAIN IN VIEW MODE -->\n          <div ng-if=\"vm.mode=='view'\">\n            <ot-avatar class=\"ot-host-avatar\"\n              params=\"{\n                image: {src: vm.getCurrentData().event.created_by_profile.avatar.m, size: 'md'},\n                label: {text: vm.getCurrentData().event.created_by_profile.first_name, prefix: 'Hosted by'},\n                initials: {'first_name': vm.getCurrentData().event.created_by_profile.first_name, 'last_name': vm.getCurrentData().event.created_by_profile.last_name}\n              }\"></ot-avatar>\n            <h3>{{vm.getCurrentData().event.title}}</h3>\n            <ot-info params=\"{event: vm.getCurrentData().event, type:'horizontal'}\"></ot-info>\n            <ot-separator class=\"ot-small\" params=\"{type: 'horizontal'}\"></ot-separator>\n            <ot-price-badge params=\"{event: vm.getCurrentData().event}\"></ot-price-badge>\n          </div>\n\n\n          <!-- MAIN IN EDIT MODE -->\n          <div ng-if=\"vm.mode!='view'\">\n\n            <div class=\"row ot-first\">\n              <div class=\"form-group ot-twothirds-container\">\n                    <label for=\"name-{{$id}}\">{{\"CREATE.NAME\" | translate}}</label>\n                    <input type=\"text\" required class=\"form-control\" id=\"name-{{$id}}\" name=\"name\" maxlength=\"60\"\n                    ng-class=\"{'ot-input-error': (createForm.$submitted || createForm.name.$touched) && !createForm.name.$valid}\"\n                    ng-model=\"vm.currentData.event.name\"\n                    placeholder=\"{{((createForm.$submitted || createForm.name.$touched) && !createForm.name.$valid ? 'CREATE.REQUIRED_FIELD' : 'CREATE.NAME_PLACEHOLDER') | translate}}\">\n              </div>\n              <div class=\"form-group ot-third-container\">\n                  <label for=\"maxseats-{{$id}}\">\n                    {{\"CREATE.MAX_SEATS\" | translate}}\n                    <span style=\"margin: 0px 0px 0px 10px; font-size: 13px;\" class=\"glyphicon glyphicon-info-sign\" tooltip-placement=\"left\" uib-tooltip=\"BBYO can only cover food for up to 20 guests so think about how many teens you can host in your space\"></span>\n                  </label>\n                  <input type=\"number\" min=\"1\" required class=\"form-control\" id=\"maxseats-{{$id}}\" name=\"maxseats\" maxlength=\"2\"\n                  ng-class=\"{'ot-input-error': (createForm.$submitted || createForm.maxseats.$touched) && !createForm.maxseats.$valid}\"\n                  ng-model=\"vm.currentData.event.maxseats\"\n                  placeholder=\"{{((createForm.$submitted || createForm.maxseats.$touched) && !createForm.maxseats.$valid ? 'CREATE.REQUIRED_FIELD' : 'CREATE.SEATS_PLACEHOLDER') | translate}}\">\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"form-group ot-third-container\">\n\n                  <div class=\"ot-input-combo ot-input-dropdown\" uib-dropdown uib-keyboard-nav>\n                    <label>Date Event</label>\n                    <input type=\"hidden\" ng-required=\"required\" ng-model=\"vm.currentData.event.begin\" name=\"date\"></input>\n                    <button\n                      type=\"button\" id=\"{{params.uuid}}-{{$id}}\"\n                      class=\"btn btn-default ot-toggle\" uib-dropdown-toggle\n                      >\n                      <span class=\"ot-left ot-placeholder\">{{vm.getDateLabel() || \"Select a date\"}}</span>\n                      <span class=\"ot-left ot-placeholder\"\n                        ng-show=\"(parentform.$submitted || parentform[params.name].$touched) && !parentform[params.name].$valid\">\n                        &nbsp&nbsp{{\"CREATE.REQUIRED_SELECTION\" | translate}}\n                      </span>\n                      <span class=\"ot-right caret\"></span>\n                    </button>\n\n                    <ul class=\"uib-dropdown-menu\" uib-dropdown-menu role=\"menu\">\n                      <li role=\"menuitem\" ng-repeat=\"item in vm.availableDates\">\n                        <a ng-click=\"vm.currentData.event.begin = item.date\" href=\"\">\n                          {{item.label}}\n                        </a>\n                      </li>\n                    </ul>\n                  </div>\n              </div>\n\n              <div class=\"form-group ot-third-container\"\n                ng-class=\"{'has-error': (createForm.$submitted || createForm.begin.$touched) && !createForm.begin.$valid}\">\n                <label for=\"begin-{{$id}}\">{{\"CREATE.BEGIN\" | translate}}</label>\n                <input type=\"hidden\" required class=\"form-control\" id=\"begin-{{$id}}\" name=\"begin\"\n                ng-model=\"vm.currentData.event.begin\">\n                <uib-timepicker class=\"ot-timepicker\" ng-model=\"vm.currentData.event.begin\" show-spinners=\"false\"\n                hour-step=\"vm.hstep\" minute-step=\"vm.mstep\" show-meridian=\"true\"></uib-timepicker>\n              </div>\n              <div class=\"form-group ot-third-container\"\n                ng-class=\"{'has-error': (createForm.$submitted || createForm.end.$touched) && !createForm.end.$valid}\">\n\n                <label for=\"end-{{$id}}\">{{\"CREATE.END\" | translate}}</label>\n                <input type=\"hidden\" required class=\"form-control\" id=\"end-{{$id}}\" name=\"end\"\n                ng-model=\"vm.currentData.event.end\">\n                <uib-timepicker class=\"ot-timepicker\" ng-model=\"vm.currentData.event.end\" show-spinners=\"false\"\n                hour-step=\"vm.hstep\" minute-step=\"vm.mstep\" show-meridian=\"true\"></uib-timepicker>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"form-group ot-twothirds-container\">\n                <!--\n                <label for=\"city-{{$id}}\">{{\"CREATE.CITY\" | translate}}</label>\n                <input type=\"text\" required class=\"form-control\"\n                 id=\"city-{{$id}}\"\n                 name=\"city\"\n                 ng-class=\"{'ot-input-error': (createForm.$submitted || createForm.city.$touched) && !createForm.city.$valid}\"\n                 ng-model=\"vm.currentData.event.city\">\n                 -->\n                 <div class=\"row\">\n                   <div ng-class=\"{\n                     'ot-full-container': !vm.hasNeighborhood() && !vm.isOther(),\n                     'ot-half-container': vm.hasNeighborhood() || vm.isOther()\n                   }\">\n                     <ot-input-combo params=\"{\n                       id:'city',\n                       name: 'city',\n                       label: 'CREATE.CITY',\n                       required: true,\n                       values: vm.availableCities,\n                       placeholder: 'Select a state'\n                     }\" parentform=\"createForm\" value=\"vm.currentData.event.area.city\"></ot-input-combo>\n                   </div>\n\n                   <div class=\"ot-half-container\" ng-show=\"vm.hasNeighborhood() && !vm.isOther()\">\n                     <ot-input-combo params=\"{\n                       id:'neighborhood',\n                       name: 'neighborhood',\n                       label: 'CREATE.NEIGHBORHOOD',\n                       required: false,\n                       values: vm.currentData.event.area.city.neighborhoods\n                     }\" parentform=\"createForm\" value=\"vm.currentData.event.area.neighborhood\"></ot-input-combo>\n                   </div>\n\n\n                   <div class=\"ot-half-container\" ng-show=\"vm.isOther()\">\n                     <label for=\"other-city-{{$id}}\">{{\"CREATE.OTHER_CITY\" | translate}}</label>\n                     <input type=\"text\" ng-required=\"vm.isOther()\" class=\"form-control ot-required-field\" id=\"other-city-{{$id}}\" name=\"otherCity\"\n                     ng-class=\"{'ot-input-error': (createForm.$submitted || createForm.otherCity.$touched) && !createForm.otherCity.$valid}\"\n                     ng-model=\"vm.currentData.event.area_other\">\n                     </div>\n                 </div>\n\n              </div>\n              <div ng-if=\"vm.isOther()\" class=\"ot-third-container\">\n                <ot-input-combo class=\"ot-input-combo-other\" params=\"{\n                  id:'timezone',\n                  name: 'timezone',\n                  label: 'CREATE.TIMEZONE',\n                  required: true,\n                  values: vm.timeZones,\n                  placeholder: 'State Timezone'\n                }\" parentform=\"createForm\" value=\"vm.currentData.event.timezone\"></ot-input-combo>\n              </div>\n              <div ng-if=\"!vm.isOther()\" class=\"form-group ot-third-container\" id=\"timezone\">\n                <label for=\"timezone\">{{\"CREATE.TIMEZONE\" | translate}}</label>\n                <input readonly type=\"text\" class=\"form-control ot-required-field\" ng-model=\"vm.currentData.event.area.city.timezone\">\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"form-group ot-full-container\">\n                <div class=\"ot-label-with-suggestion\">\n                  <label for=\"location-{{$id}}\">{{\"CREATE.ADDRESS\" | translate}} </label>\n                  <span class=\"ot-label-suggestion\">{{\"CREATE.ONLY_CONFIRMED\" | translate}}</span>\n                </div>\n                <input type=\"text\" class=\"form-control\" ng-autocomplete\n                 id=\"location-{{$id}}\" ng-model=\"vm.currentData.event.full_address\">\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"form-group ot-full-container\">\n                <label for=\"location-{{$id}}\">{{\"CREATE.ADDRESS_SECONDARY\" | translate}}</label>\n                <input type=\"text\" class=\"form-control\" id=\"address-secondary-{{$id}}\" ng-model=\"vm.currentData.event.secondary_address\">\n              </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"form-group ot-full-container\" style=\"margin-bottom: 0px\">\n                  <div class=\"ot-label-with-suggestion\">\n                    <label for=\"location-{{$id}}\">\n                      {{\"CREATE.PARENT_AUTH_TITLE\" | translate}}\n                      <span ng-class=\"{'ot-checkbox-error': (createForm.$submitted || createForm.parentAuth.$touched) && !vm.currentData.event.parentAuth}\"\n                      ng-show=\"(createForm.$submitted || createForm.parentAuth.$touched) && !vm.currentData.event.parentAuth\"\n                      >\n                        Parent authorization is required!!\n                      </span>\n                    </label>\n                  </div>\n               </div>\n             </div>\n             <div class=\"row\">\n                 <div class=\"form-group ot-full-container\">\n                   <input type=\"checkbox\"\n                      ng-model=\"vm.currentData.event.parentAuth\"\n                      name=\"parentAuth\"\n                      ng-true-value=\"true\"\n                      ng-false-value=\"false\">\n                  <span style=\"font-size:small\">{{'CREATE.PARENT_AUTH' | translate}}</span>\n                </div>\n              </div>\n          </div>\n        </div>\n      </div>\n\n\n\n      <!-- SUBHEADER -->\n\n\n      <div ng-if=\"vm.mode=='view'\" class=\"ot-sub-header hidden-xs hidden-sm\" ot-fixer=\"ot-fixed-sub-header\">\n        <div class=\"ot-full-container\">\n          <div class=\"row ot-it-should-be-perfectly-aligned\">\n            <div class=\"ot-event-sub-header ot-twothirds-container ot-left-container\">\n              <h3>{{vm.getCurrentData().event.title}}</h3>\n              <div class=\"ot-link-list-container\"\n              ng-class=\"{'ot-hide-dishes-link': vm.hideMenuCard()}\">\n                <ot-link-list params=\"{type:'eventAnchors'}\"></ot-link-list>\n              </div>\n            </div>\n\n            <div class=\"ot-event-sub-header ot-third-container\">\n              <ot-price-badge params=\"{event: vm.getCurrentData().event}\"></ot-price-badge>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <ot-separator params=\"{type: 'horizontal'}\"></ot-separator>\n          </div>\n        </div>\n      </div>\n\n\n\n      <!-- ABOUT EVENT -->\n\n\n      <div class=\"row ot-card center-card ot-ev1 ot-viewported\">\n        <div class=\"ot-full-container\">\n          <div id=\"details\" class=\"ot-anchor\"></div>\n          <h3>{{'EVENT.ABOUT_TITLE' | translate}}</h3>\n          <ot-separator class=\"ot-small\" params=\"{type: 'horizontal'}\"></ot-separator>\n\n          <!-- ABOUT EVENT IN VIEW MODE -->\n          <div ng-if=\"vm.mode=='view'\">\n            <p class=\"ot-description\" ng-bind-html=\"vm.toHtml(vm.getCurrentData().event.description)\"></p>\n\n            <div ng-show=\"vm.hasTypes()\">\n              <h4>{{'EVENT.TYPE_TITLE' | translate}}</h4>\n              <ot-type-list params=\"{'alcoholPolicy': vm.getCurrentData().event.alcohol_policy, 'dietaryRestrictions': vm.getCurrentData().event.dietary_restrictions}\"></ot-type-list>\n            </div>\n\n            <div>\n              <h4>{{'EVENT.ATTENDANTS_TITLE' | translate}}</h4>\n              <ot-attendants class=\"ot-attendants-spacing\" ng-show=\"vm.getCurrentData().event.reservations.length > 0\" params=\"{items: vm.getCurrentData().event.reservations, size: 'sm'}\"></ot-attendants>\n\n              <div class=\"ot-be-the-first\" ng-show=\"vm.getCurrentData().event.reservations.length <= 0 && vm.getCurrentData().event.event_type == 'public'\">\n                 <p>{{'EVENT.BE_THE_FIRST_TO_RSVP' | translate}}</p>\n              </div>\n\n              <div class=\"ot-event-private\" ng-show=\"vm.getCurrentData().event.reservations.length <= 0 && vm.getCurrentData().event.event_type == 'private'\">\n                 <p>{{'EVENT.PRIVATE_DINNER_NOTICE' | translate}}</p>\n              </div>\n\n              <div class=\"ot-event-manual\" ng-show=\"vm.getCurrentData().event.reservations.length <= 0 && vm.getCurrentData().event.event_type == 'manual_approval'\">\n                 <p>{{'EVENT.MANUAL_APPROVAL_NOTICE' | translate}}</p>\n              </div>\n\n            </div>\n\n            <div style=\"margin-bottom:20px\"></div>\n          </div>\n\n          <!-- ABOUT EVENT IN EDIT MODE -->\n          <div ng-if=\"vm.mode!='view'\">\n\n            <div class=\"row\">\n              <div class=\"form-group ot-full-container\">\n                <label class=\"ot-description-label\" for=\"description-{{$id}}\">{{\"CREATE.DESCRIPTION\" | translate}}</label>\n\n                <textarea placeholder=\"{{'CREATE.DESCRIPTION_PLACEHOLDER' | translate}}\" class=\"form-control\" id=\"description-{{$id}}\" ng-model=\"vm.currentData.event.description\"></textarea>\n\n                <!-- <wysiwyg-edit content=\"vm.currentData.event.description\" config=\"vm.editorConfig\"></wysiwyg-edit> -->\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <ot-type-picker form=\"createForm\"\n                              params=\"{data: vm.currentData}\"\n                              alcohol=\"vm.currentData.event.filter.alcoholTypes\"\n                              meal=\"vm.currentData.event.filter.mealTypes\"\n                              dietary=\"vm.currentData.event.filter.dietTypes\"\n                              class=\"ot-full-container\">\n              </ot-type-picker>\n            </div>\n\n          </div>\n        </div>\n      </div>\n\n\n\n      <!-- SUBHEADER FIXED FOR FORM ACTIONS IN EDIT MODE -->\n\n\n      <div ng-if=\"vm.mode!='view'\" class=\"ot-sub-header ot-fixed-sub-header ot-actions\">\n        <div class=\"ot-full-container\">\n          <div class=\"row ot-sub-header-content\">\n\n            <h2 ng-show=\"vm.mode == 'new'\">{{\"CREATE.TITLE\" | translate}}</h2>\n            <h2 ng-show=\"vm.mode == 'edit'\">{{\"CREATE.EDIT_TITLE\" | translate}}</h2>\n\n            <div class=\"ot-left\">\n              <input class=\"btn btn-default\" type=\"reset\" value=\"{{'CREATE.CANCEL' | translate}}\" ng-click=\"vm.goManageHosted()\"></input>\n            </div>\n\n            <div class=\"ot-right\">\n              <input class=\"btn btn-default\" type=\"submit\" value=\"{{'CREATE.SUBMIT_DRAFT' | translate}}\" ng-show=\"vm.mode == 'new'\"></input>\n              <input class=\"btn btn-primary\" type=\"submit\" ng-click=\"vm.setPublish(createForm)\" value=\"{{'CREATE.SUBMIT' | translate}}\" ng-show=\"vm.mode == 'new'\"></input>\n\n              <input class=\"btn btn-default\" type=\"submit\" value=\"{{'CREATE.UPDATE' | translate}}\" ng-show=\"vm.mode == 'edit'\"></input>\n              <input class=\"btn btn-primary\" type=\"submit\" ng-click=\"vm.setPublish(createForm)\" value=\"{{'CREATE.SUBMIT' | translate}}\" ng-show=\"vm.mode == 'edit' && vm.currentData.event.state == 'draft'\"></input>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- HIDDEN INPUT FOR OPTIONAL DINNER COURSES -->\n      <input type=\"hidden\" ng-model=\"vm.currentData.event.notes\"></input>\n\n    </form>\n\n\n\n    <!-- MENU -->\n\n\n    <div class=\"row ot-card center-card menu-card ot-viewported\" ng-hide=\"vm.hideMenuCard()\">\n      <div class=\"ot-full-container\">\n        <div id=\"menu\" class=\"ot-anchor\"></div>\n        <h3>{{'EVENT.MENU_TITLE' | translate}}</h3>\n        <ot-separator class=\"ot-small\" params=\"{type: 'horizontal'}\"></ot-separator>\n\n        <h5 ng-if=\"vm.mode!='view'\" style=\"text-align:center;margin-bottom:20px\">{{'EVENT.MENU_DESC_1' | translate}} <strong>{{'EVENT.MENU_DESC_2' | translate}}</strong></h5>\n\n        <div class=\"row\">\n          <div class=\"ot-third-container ot-dish\">\n            <div class=\"ot-icon-appetizers\"></div>\n            <h4>{{'EVENT.MENU_FIRST_COURSE' | translate}}</h4>\n            <ot-separator class=\"ot-small\" params=\"{type: 'horizontal'}\"></ot-separator>\n            <ot-dish-list params=\"{editable: vm.mode!='view', items: vm.getCurrentData().event.notes.first, placeholder:'EVENT.MENU_FIRST_COURSE_PLACEHOLDER'}\"></ot-dish-list>\n          </div>\n          <div class=\"ot-third-container ot-dish\">\n            <div class=\"ot-icon-main\"></div>\n            <h4>{{'EVENT.MENU_SECOND_COURSE' | translate}}</h4>\n            <ot-separator class=\"ot-small\" params=\"{type: 'horizontal'}\"></ot-separator>\n            <ot-dish-list params=\"{editable: vm.mode!='view', items: vm.getCurrentData().event.notes.second, placeholder:'EVENT.MENU_SECOND_COURSE_PLACEHOLDER'}\"></ot-dish-list>\n          </div>\n          <div class=\"ot-third-container ot-dish\">\n            <div class=\"ot-icon-dessert\"></div>\n            <h4>{{'EVENT.MENU_DESSERT' | translate}}</h4>\n            <ot-separator class=\"ot-small\" params=\"{type: 'horizontal'}\"></ot-separator>\n            <ot-dish-list params=\"{editable: vm.mode!='view', items: vm.getCurrentData().event.notes.third, placeholder:'EVENT.MENU_DESSERT_PLACEHOLDER'}\"></ot-dish-list>\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <!--div ng-if=\"vm.mode!='view' || vm.getCurrentData().event.hosted_by_me\" class=\"row ot-card center-card nourishment-card\">\n      <div class=\"ot-full-container\">\n        <form name=\"submitAllocationForm\" ng-submit=\"vm.submitAllocation(submitAllocationForm)\" novalidate>\n          <div id=\"nourishment\" class=\"ot-anchor\"></div>\n          <h3>{{'EVENT.NOURISHED_TITLE' | translate}}</h3>\n          <ot-separator class=\"ot-small\" params=\"{type: 'horizontal'}\"></ot-separator>\n          <p>{{'EVENT.NOURISHED_DESCRIPTION_1' | translate}}<br>{{'EVENT.NOURISHED_DESCRIPTION_2' | translate}}</p>\n          <div class=\"row small\">\n            <div class=\"ot-third-container\">\n              <h2 style=\"font-size:28px\">100</h2>\n              <p>guests</p>\n            </div>\n            <div class=\"ot-third-container center\">\n              <h2 style=\"font-size:28px\">$ 100.00</h2>\n              <p>available</p>\n            </div>\n            <div class=\"ot-third-container\">\n              <h2 style=\"font-size:28px\">$ 0.00</h2>\n              <p>allocated</p>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"ot-third-container\">\n              <div class=\"ot-logo-instacart\"></div>\n              <p>{{'EVENT.NOURISHED_INSTACART' | translate}}</p>\n              <a href=\"https://www.instacart.com/\" target=\"_blank\">{{'EVENT.NOURISHED_READ_MORE' | translate}}</a>\n              <br>\n              <br>\n              <input ng-model=\"vm.instacart\" type=\"number\" min=\"0.00\" step=\"0.01\" class=\"form-control\" id=\"instacart-{{$id}}\" name=\"instacart\" placeholder=\"$ 0.00\" />\n            </div>\n            <div class=\"ot-third-container\">\n              <div class=\"ot-logo-plated\"></div>\n              <p>{{'EVENT.NOURISHED_PLATED' | translate}}</p>\n              <a href=\"https://www.plated.com/\" target=\"_blank\">{{'EVENT.NOURISHED_READ_MORE' | translate}}</a>\n              <br>\n              <br>\n              <input ng-model=\"vm.plated\" type=\"number\" min=\"0.00\" step=\"0.01\" class=\"form-control\" id=\"plated-{{$id}}\" name=\"plated\"  placeholder=\"$ 0.00\" />\n            </div>\n            <div class=\"ot-third-container\">\n              <div class=\"ot-logo-freshdirect\"></div>\n              <p>{{'EVENT.NOURISHED_FRESHDIRECT' | translate}}</p>\n              <a href=\"https://www.freshdirect.com/\" target=\"_blank\">{{'EVENT.NOURISHED_READ_MORE' | translate}}</a>\n              <br>\n              <br>\n              <input ng-model=\"vm.freshdirect\" type=\"number\" min=\"0.00\" step=\"0.01\" class=\"form-control\" id=\"freshdirect-{{$id}}\" name=\"freshdirect\" placeholder=\"$ 0.00\" />\n            </div>\n          </div>\n          <br>\n          <br>\n          <input class=\"btn btn-primary\" type=\"submit\" value=\"{{'EVENT.NOURISHED_SUBMIT' | translate}}\" />\n        </form>\n      </div>\n    </div-->\n\n\n\n    <!-- HOST -->\n\n\n    <div ng-if=\"vm.mode=='view'\" class=\"row ot-card center-card host-card ot-viewported\">\n      <div class=\"ot-full-container\">\n        <div id=\"host\" class=\"ot-anchor\"></div>\n        <h3>{{'EVENT.HOST_TITLE' | translate | sprintf:vm.getCurrentData().event.created_by_profile.first_name}}</h3>\n        <ot-separator class=\"ot-small\" params=\"{type: 'horizontal'}\"></ot-separator>\n        <ot-avatar params=\"{image: {src: vm.getCurrentData().event.created_by_profile.avatar.m, size: 'lg'}, initials: {'first_name': vm.getCurrentData().event.created_by_profile.first_name, 'last_name': vm.getCurrentData().event.created_by_profile.last_name}}\"></ot-avatar>\n        <p>{{vm.getCurrentData().event.created_by_profile.bio}}</p>\n        <button class=\"btn btn-default host-message-button\" ng-click=\"vm.messageHost()\">{{'EVENT.MESSAGE_HOST' | translate}}</button>\n      </div>\n    </div>\n\n\n\n    <!-- MIGHT LIKE -->\n\n\n    <div ng-if=\"vm.mode=='view'\" class=\"row ot-card-borderless ot-might-like\">\n      <div class=\"ot-full-container\">\n        <ot-separator class=\"ot-viewported\" params=\"{type: 'horizontal', text: 'EVENT.MIGHT_LIKE'}\"></ot-separator>\n        <ot-event-list params=\"{type: 'landing', items: vm.session.getData().suggestedEventList}\"></ot-event-list>\n        <button class=\"btn btn-default\" ng-click=\"vm.goLanding()\">{{'EVENT.BROWSE' | translate}}</button>\n      </div>\n    </div>\n\n  </div>\n\n  <ot-footer></ot-footer>\n</div>\n"

/***/ },
/* 240 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-event-page ot-guests-page\" ng-class=\"{'ot-view': vm.mode == 'view', 'ot-edit': vm.mode == 'edit'}\"><!-- there is already a directive called ot-event -->\n\n  <div> <!-- main container used for scrolling calculations -->\n      <div class=\"ot-sub-header ot-fixed-sub-header ot-actions\">\n        <div class=\"ot-full-container\">\n          <div class=\"row ot-sub-header-content\">\n\n            <h2>{{\"CREATE.GET_NOURISHED\" | translate}}</h2>\n\n            <div class=\"ot-right\">\n              <input class=\"btn btn-noborder-default\" type=\"submit\" ng-click=\"vm.publishEvent()\" value=\"{{'CREATE.SKIP_NOURISHED' | translate}}\"></input>\n              <input class=\"btn btn-primary-disabled\" disabled=\"disabled\" type=\"submit\" value=\"{{'CREATE.SUBMIT_NOURISHED' | translate}}\"></input>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"center-card ot-title-card\" style=\"\"><!-- Info-->\n        <h3>{{vm.getCurrentData().event.title}}</h3>\n        <ot-info params=\"{event: vm.getCurrentData().event, type:'horizontal'}\"></ot-info>\n      </div>\n\n      <div class=\"row ot-card center-card guests-card\">\n        <div class=\"ot-full-container\">\n          <form name=\"submitAllocationForm\" ng-submit=\"vm.submitGuests(submitAllocationForm)\" novalidate>\n            <p>{{'EVENT.NOURISHED_GUESTS_DESCRIPTION' | translate | sprintf:(vm.getCurrentEventDate())}}</p>\n            <p style=\"font-weight:bold\">{{'EVENT.NOURISHED_GUESTS_DESCRIPTION_2' | translate}}</p>\n\n            <p class=\"ot-seat-counter btn-group\">\n              <a class=\"btn btn-default\" ng-click=\"vm.removeSeat()\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a>\n              <span>{{\"RSVP.X_GUESTS\" | translate | sprintf:(vm.guestsCount)}}</span>\n              <a class=\"btn btn-default\" ng-click=\"vm.addSeat()\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a>\n            </p>\n\n            <br>\n\n            <input class=\"btn btn-primary\" type=\"submit\" value=\"{{'EVENT.NOURISHED_GUESTS_SUBMIT' | translate}}\" />\n          </form>\n        </div>\n      </div>\n  </div>\n\n\n\n\n</div>\n"

/***/ },
/* 241 */
/***/ function(module, exports) {

	module.exports = "<div ng-if=\"!vm.session.isOnward()\" class=\"ot-host-promotion\">\n  <div class=\"container-fluid\">\n    <h3>{{\"HOST_PROMOTION.TITLE\" | translate}}</h3>\n    <h4>{{\"HOST_PROMOTION.SUBTITLE\" | translate}}</h4>\n    <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.promote()\">{{\"HOST_PROMOTION.SUBMIT\" | translate}}</button>\n  </div>\n</div>\n<div ng-if=\"vm.session.isOnward()\" class=\"ot-host-promotion\">\n  <div class=\"container-fluid\">\n    <h3>{{\"HOST_PROMOTION.TITLE\" | translate}}</h3>\n    <h4>{{\"HOST_PROMOTION.SUBTITLE_ONWARD\" | translate}}</h4>\n    <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.promote()\">{{\"HOST_PROMOTION.FINISH\" | translate}}</button>\n  </div>\n</div>\n"

/***/ },
/* 242 */
/***/ function(module, exports) {

	module.exports = "\n<div class=\"ot-landing\">\n  <div class=\"container-fluid\">\n    <div class=\"ot-top-wrapper row\">\n      <ot-banner params=\"{'src': vm.getCurrentCityCover(), 'title': 'GET YOUR GAME ON', 'parallax': true}\"></ot-banner>\n      <p style=\"padding:20px;background-color:#FFFFFF;margin:0;text-align:center;font-family:'Avenir-Medium'\">Host and attend presidential debate watch parties with BBYO. Food, resources, and the chance to get a surprise visit from a celebrity gamechanger is on us!</p>\n      <ot-search params=\"{'filter': vm.filter, 'callback': vm.searchCallback}\"></ot-search>\n    </div>\n    <uib-accordion>\n      <uib-accordion-group class=\"ot-accordion row\" is-open=\"vm.filter.visibility\">\n        <ot-search-filter params=\"{'filter': vm.filter, 'callback': vm.searchCallback, 'clearCallback': vm.clearCallback}\"></ot-search-filter>\n      </uib-accordion-group>\n    </uib-accordion>\n    <div>\n      <ot-search-description\n        ng-class=\"{'invisible': !vm.isCurrentEventListLoaded()}\"\n        params=\"{count: vm.getCurrentEventListLength(), city: vm.getCurrentCityLabel(), cities:vm.filteredCities}\"></ot-search-description>\n      <ot-event-list params=\"{items: vm.getCurrentEventList(), 'type': 'landing'}\"></ot-event-list>\n    </div>\n  </div>\n\n  <ot-footer></ot-footer>\n</div>\n"

/***/ },
/* 243 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-manage\">\n  <div class=\"container-fluid\">\n    <ot-manage-header params=\"{\n      'upcoming': vm.session.getData().upcomingEventListMetadata.total_count,\n      'hosted': vm.session.getData().hostedEventListMetadata.total_count,\n      'saved': vm.session.getData().savedEventListMetadata.total_count,\n      'past': vm.session.getData().pastEventListMetadata.total_count\n    }\"></ot-manage-header>\n  </div>\n  <div class=\"container-fluid\">\n    <ot-manage-menu ng-if=\"vm.session.isHost()\" class=\"ot-quarter-container\"></ot-manage-menu>\n\n    <div ng-switch=\"vm.section\" ng-class=\"{\n      'ot-threequarter-container': vm.session.isHost(),\n      'ot-responsive-full-container-large': !vm.session.isHost()\n    }\">\n\n      <ot-event-list ng-switch-when=\"upcoming\" params=\"{'items': vm.session.getData().upcomingEventList, 'type': 'manage'}\"></ot-event-list>\n      <ot-event-table ng-switch-when=\"hosted\" params=\"{'items': vm.session.getData().hostedEventList, 'type': 'hosted'}\"></ot-event-table>\n      <ot-event-table ng-switch-when=\"saved\" params=\"{'items': vm.session.getData().savedEventList, 'type': 'saved'}\"></ot-event-table>\n      <ot-event-table ng-switch-when=\"past\" params=\"{'items': vm.session.getData().pastEventList, 'type': 'past'}\"></ot-event-table>\n\n    </div>\n  </div>\n\n  <ot-footer></ot-footer>\n</div>\n"

/***/ },
/* 244 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-not-found\">\n<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"page-container\">\n        <h1>{{\"NOT_FOUND.PAGE_TITLE\" | translate}}</h1>\n    </div>\n  </div>\n</div>\n  <ot-footer></ot-footer>\n</div>\n"

/***/ },
/* 245 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-event-page\" ng-class=\"{'ot-view': vm.mode == 'view', 'ot-edit': vm.mode == 'edit'}\"><!-- there is already a directive called ot-event -->\n\n  <form name=\"submitAllocationForm\" ng-submit=\"vm.submitAllocation(submitAllocationForm)\" novalidate>\n  <div> <!-- main container used for scrolling calculations -->\n      <div class=\"ot-sub-header ot-fixed-sub-header ot-actions\">\n        <div class=\"ot-full-container\">\n          <div class=\"row ot-sub-header-content\">\n\n            <h2>{{\"CREATE.GET_NOURISHED\" | translate}}</h2>\n\n            <div class=\"ot-right\">\n              <input class=\"btn btn-noborder-default\" type=\"button\" ng-click=\"vm.publishEvent()\" value=\"{{'CREATE.SKIP_NOURISHED' | translate}}\"></input>\n              <input class=\"btn btn-primary\" type=\"submit\" value=\"{{'CREATE.SUBMIT_NOURISHED' | translate}}\"></input>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"center-card ot-title-card\" style=\"\"><!-- Info-->\n        <h3>{{vm.getCurrentData().event.title}}</h3>\n        <ot-info params=\"{event: vm.getCurrentData().event, type:'horizontal'}\"></ot-info>\n      </div>\n\n      <div class=\"row ot-card center-card nourishment-card\">\n        <div class=\"ot-full-container\">\n            <div id=\"nourishment\" class=\"ot-anchor\"></div>\n            <h3>{{'EVENT.NOURISHED_TITLE' | translate}}</h3>\n            <ot-separator class=\"ot-small\" params=\"{type: 'horizontal'}\"></ot-separator>\n            <p>{{'EVENT.NOURISHED_DESCRIPTION_1' | translate | sprintf: (vm.getMaxNourishmentAllocation() | currency : \"$\" : 2)}}<br>{{'EVENT.NOURISHED_DESCRIPTION_2' | translate}}</p>\n            <div class=\"row small\">\n              <div class=\"ot-third-container\">\n                <h2 style=\"font-size:18px\">{{vm.getCurrentData().event.expected_guests}}</h2>\n                <p>guests</p>\n              </div>\n              <div class=\"ot-third-container center\">\n                <h2 style=\"font-size:18px\">{{ vm.getMaxNourishmentAllocation() | currency : \"$\" : 2}}</h2>\n                <p>available</p>\n              </div>\n              <div class=\"ot-third-container\" ng-class=\"vm.getAllocatedClass()\">\n                <h2 style=\"font-size:18px\">{{ vm.getAllocated() | currency : \"$\" : 2}}</h2>\n                <p>allocated</p>\n              </div>\n            </div>\n            <div class=\"row\">\n                <div ng-repeat=\"sponsor in vm.currentSponsors\" class=\"ot-third-container ot-nourished-spacing\"\n                ng-class=\"{'has-error': !submitAllocationForm['sponsor-'+sponsor.id].$valid}\">\n                  <div class=\"ot-logo-sponsor\" style=\"background-image:url('{{sponsor.photo.m}}');\"></div>\n                  <p>{{sponsor.description}}</p>\n                  <a ng-href=\"{{sponsor.url}}\" target=\"_blank\">{{'EVENT.NOURISHED_READ_MORE' | translate}}</a>\n                  <br>\n                  <br>\n                  <input ng-model=\"sponsor.currentValue\"\n                       type=\"text\"\n                       ng-pattern=\"/^\\d{0,9}(\\.\\d{1,9})?$/\"\n                       ng-trim=\"true\"\n                       class=\"form-control\" id=\"sponsor-{{sponsor.id}}\" name=\"sponsor-{{sponsor.id}}\" placeholder=\"0.00\" />\n                </div>\n            </div>\n            <br>\n            <br>\n            <input class=\"btn btn-primary\" type=\"submit\" value=\"{{'EVENT.NOURISHED_SUBMIT' | translate}}\" />\n\n\n        </div>\n      </div>\n  </div>\n</form>\n</div>\n"

/***/ },
/* 246 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-profile\">\n  <div class=\"container-fluid\">\n\n  <div class=\"row\">\n    <div class=\"ot-responsive-full-container-medium\">\n\n      <div class=\"row\">\n        <div class=\"rf-full-container\">\n            <h2>{{\"PROFILE.TITLE\" | translate}}</h2>\n\n            <div class=\"ot-avatar ot-vertical\">\n\n              <div class=\"ot-lg ot-editable-avatar\">\n                <div class=\"ot-lg ot-view\"\n                  ng-style=\"vm.getAvatarStyle()\">\n\n                  <div class=\"ot-avatar-initials\" style=\"\">{{vm.getCurrentInitials()}}</div>\n\n                </div>\n\n                <div class=\"ot-lg ot-edit\" ngf-select=\"vm.uploadNewAvatar(newAvatar)\"\n                  ng-model=\"newAvatar\" name=\"file\" accept=\"image/*\" required=\"\" type=\"file\"\n                  ng-style=\"vm.getAvatarStyle('withShadow')\">\n                  <div>\n                    <span class=\"glyphicon glyphicon-pencil\"></span>\n                  </div>\n                </div>\n              </div>\n\n              <span class=\"ot-bottom ot-username\">\n                {{vm.getCurrentFullName()}}\n              </span>\n            </div>\n\n            <ot-separator class=\"ot-small\" params=\"{'type': 'horizontal'}\"></ot-separator>\n        </div>\n      </div>\n\n      <form name=\"profileForm\" ng-submit=\"vm.submit(profileForm)\" novalidate>\n\n\n        <!-- NAME -->\n\n        <div class=\"row\">\n          <div class=\"ot-third-container\">\n            <label for=\"first-name-{{$id}}\">{{'PROFILE.NAME_LABEL' | translate}}</label>\n          </div>\n          <div class=\"ot-third-container\">\n            <input type=\"text\" required class=\"form-control\" id=\"first-name-{{$id}}\" name=\"firstName\"\n              placeholder=\"{{'PROFILE.FIRST_NAME_PLACEHOLDER' | translate}}\"\n              ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.firstName.$touched) && !profileForm.firstName.$valid}\"\n              ng-model=\"vm.profile.firstName\">\n          </div>\n          <div class=\"ot-third-container\">\n            <input type=\"text\" required class=\"form-control\" id=\"last-name-{{$id}}\" name=\"lastName\"\n              placeholder=\"{{'PROFILE.LAST_NAME_PLACEHOLDER' | translate}}\"\n              ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.lastName.$touched) && !profileForm.lastName.$valid}\"\n              ng-model=\"vm.profile.lastName\">\n          </div>\n        </div>\n\n\n\n        <!-- EMAIL -->\n\n        <div class=\"row\">\n          <div class=\"ot-third-container\">\n            <label for=\"email-{{$id}}\">{{'PROFILE.EMAIL_LABEL' | translate}}</label>\n          </div>\n          <div class=\"ot-twothirds-container\">\n            <input type=\"text\" required class=\"form-control\" id=\"email-{{$id}}\" name=\"email\"\n              placeholder=\"{{'PROFILE.EMAIL_PLACEHOLDER' | translate}}\"\n              ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.email.$touched) && !profileForm.email.$valid}\"\n              ng-model=\"vm.profile.email\">\n          </div>\n        </div>\n\n\n\n        <!-- PASSWORD -->\n\n        <div class=\"row\">\n          <div class=\"ot-third-container\">\n            <label>{{'PROFILE.PASSWORD_LABEL' | translate}}</label>\n          </div>\n          <div class=\"ot-twothirds-container\">\n            <a class=\"ot-change-password-link\" ng-click=\"vm.openChangePasswordModal()\">{{'PROFILE.PASSWORD_CHANGE_LABEL' | translate}}</a>\n          </div>\n        </div>\n\n\n\n        <!-- DATE OF BIRTH -->\n\n        <div class=\"row\">\n          <div class=\"ot-third-container\">\n            <label for=\"birth-date-{{$id}}\">{{'PROFILE.BIRTH_DATE_LABEL' | translate}}</label>\n          </div>\n          <div class=\"ot-twothirds-container\">\n            <p class=\"ot-date ot-full-width\">\n              <input type=\"text\" class=\"form-control\"\n                ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.birthDate.$touched) && !profileForm.birthDate.$valid}\"\n                id=\"birth-date-{{$id}}\" name=\"birthDate\"\n                uib-datepicker-popup=\"MM/dd/yyyy\" show-button-bar=\"false\" ng-model=\"vm.profile.birthDate\"\n                is-open=\"_popupStatus\" year-range=\"200\" min-date=\"vm.minBirthDate\" max-date=\"vm.maxBirthDate\"\n                uib-datepicker-options=\"dateOptions\" date-disabled=\"disabled(date, mode)\" close-text=\"Close\" required\n                placeholder=\"{{'PROFILE.BIRTH_DATE_PLACEHOLDER' | translate}}\" />\n              <span class=\"input-group-btn\">\n                <button type=\"button\" class=\"btn btn-default btn-birth\" ng-click=\"_popupStatus = !_popupStatus\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n              </span>\n            </p>\n          </div>\n        </div>\n\n\n        <!-- ADDRESS -->\n\n        <div class=\"row\">\n          <div class=\"ot-third-container\">\n            <label for=\"address-{{$id}}\">{{'PROFILE.ADDRESS_LABEL' | translate}}</label>\n          </div>\n          <div class=\"ot-twothirds-container\">\n            <input type=\"text\" class=\"form-control\" id=\"address-{{$id}}\" name=\"address\"\n              placeholder=\"{{'PROFILE.ADDRESS_PLACEHOLDER' | translate}}\"\n              ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.address.$touched) && !profileForm.address.$valid}\"\n              ng-model=\"vm.profile.address\">\n          </div>\n        </div>\n\n        <!-- ADDRESS SECONDARY -->\n\n        <div class=\"row\">\n          <div class=\"ot-third-container\">\n            <label for=\"address-secondary-{{$id}}\">{{'PROFILE.ADDRESS_SECONDARY_LABEL' | translate}}</label>\n          </div>\n          <div class=\"ot-twothirds-container\">\n            <input type=\"text\" class=\"form-control\" id=\"address-{{$id}}\" name=\"addressSecondary\"\n              placeholder=\"{{'PROFILE.ADDRESS_SECONDARY_PLACEHOLDER' | translate}}\"\n              ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.addressSecondary.$touched) && !profileForm.addressSecondary.$valid}\"\n              ng-model=\"vm.profile.addressSecondary\">\n          </div>\n        </div>\n\n        <!-- CITY -->\n\n        <div class=\"row\">\n          <div class=\"ot-third-container\">\n            <label for=\"city-{{$id}}\">{{'PROFILE.CITY_LABEL' | translate}}</label>\n          </div>\n          <div class=\"ot-twothirds-container\">\n            <input type=\"text\" class=\"form-control ot-upcase-first\" id=\"city-{{$id}}\" name=\"city\"\n              placeholder=\"{{'PROFILE.CITY_PLACEHOLDER' | translate}}\"\n              ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.city.$touched) && !profileForm.city.$valid}\"\n              ng-model=\"vm.profile.city\">\n          </div>\n        </div>\n\n        <!-- STATE -->\n\n        <div class=\"row\">\n          <div class=\"ot-third-container\">\n            <label for=\"state-{{$id}}\">{{'PROFILE.STATE_LABEL' | translate}}</label>\n          </div>\n          <div class=\"ot-twothirds-container\">\n            <input type=\"text\" class=\"form-control ot-upcase-first\" id=\"state-{{$id}}\" name=\"state\"\n              placeholder=\"{{'PROFILE.STATE_PLACEHOLDER' | translate}}\"\n              ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.state.$touched) && !profileForm.state.$valid}\"\n              ng-model=\"vm.profile.city_state\">\n          </div>\n        </div>\n\n        <!-- PHONE -->\n\n        <div class=\"row\">\n          <div class=\"ot-third-container\">\n            <label for=\"address-{{$id}}\">{{'PROFILE.PHONE_LABEL' | translate}}</label>\n          </div>\n          <div class=\"ot-quarter-container\">\n            <input type=\"text\" class=\"form-control\" id=\"phone-{{$id}}\" name=\"phone\"\n              placeholder=\"{{'PROFILE.PHONE_PLACEHOLDER' | translate}}\"\n              ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.phone.$touched) && !profileForm.phone.$valid}\"\n              ng-model=\"vm.profile.phone\">\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"ot-third-container\">\n            <label for=\"bio-{{$id}}\">{{'PROFILE.BIO_LABEL' | translate}}</label>\n          </div>\n          <div class=\"ot-twothirds-container\">\n            <textarea class=\"form-control\" id=\"bio-{{$id}}\" name=\"bio\"\n              placeholder=\"{{'PROFILE.BIO_PLACEHOLDER' | translate}}\"\n              ng-model=\"vm.profile.bio\"></textarea>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"ot-full-container\">\n            <input type=\"submit\" class=\"btn btn-primary\" value=\"{{'PROFILE.SUBMIT' | translate}}\">\n          </div>\n        </div>\n      </form>\n      <!--<form name=\"creditCardForm\" novalidate>\n        <!-- CREDIT CARD -->\n        <!--<div class=\"row\">\n          <div class=\"ot-full-container ot-credit-card\">\n            <ot-separator params=\"{'type': 'horizontal'}\"></ot-separator>\n            <p>{{'PROFILE.CARD_PAY_TITLE' | translate}}</p>\n          </div>\n        </div>\n\n        <div ng-class=\"{'showcard': !vm.showRegisterCard , 'hidecard': vm.showRegisterCard}\" class=\"card-menu\">\n          <div ng-repeat=\"card in vm.cardList\" ng-show=\"vm.cardList.length > 0\" class=\"ot-list-credit-card\">\n            <div class=\"row\">\n              <div class=\"ot-quarter-container\">\n                <label>{{card.brand}}</label>\n                <label class=\"sub-label\" ng-show=\"card.favourite\">{{'PROFILE.CARD_DEFAULT' | translate}}</label>\n              </div>\n              <div class=\"ot-half-container\">\n                <input type=\"text\" readonly class=\"form-control\" id=\"card-number-{{$id}}\" name=\"cardNumber\"\n                  pattern=\"[0-9]{13,16}\"\n                  placeholder=\"{{'PROFILE.CARDLIST_NUMBER_PLACEHOLDER' | translate}}\"\n                  ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.cardNumber.$touched) && !profileForm.cardNumber.$valid}\"\n                  ng-value=\"'**** **** **** ' + card.number\">\n              </div>\n              <div class=\"ot-quarter-container\">\n                <div ng-click=\"vm.openRegisterCard(vm.showParam,card.id)\" class=\"btn btn-primary change-card-button\">{{'PROFILE.CARD_CHANGE_BUTTON' | translate}}</div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"ot-full-container ot-credit-card\">\n              <div ng-click=\"vm.openRegisterCard(vm.showParam)\" class=\"btn btn-primary add_card_button\" ng-model=\"vm.showParam\">\n                {{'PROFILE.ADD_CARD_BUTTON' | translate}}\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div ng-class=\"{'showcard': vm.showRegisterCard , 'hidecard': !vm.showRegisterCard}\" class=\"ot-register-credit-card\">\n          <div class=\"row\">\n            <div class=\"ot-third-container\">\n              <label for=\"card-full-name-{{$id}}\">{{'PROFILE.CARD_NAME_LABEL' | translate}}</label>\n            </div>\n            <div class=\"ot-twothirds-container\">\n              <input type=\"text\" required class=\"form-control\" id=\"card-full-name-{{$id}}\" name=\"cardFullName\"\n                placeholder=\"{{'PROFILE.FULL_NAME_PLACEHOLDER' | translate}}\"\n                ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.cardFullName.$touched) && !profileForm.cardFullName.$valid}\"\n                ng-model=\"vm.cardSelected.owner\">\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"ot-third-container\">\n              <label for=\"card-number-{{$id}}\">{{'PROFILE.CARD_NUMBER_LABEL' | translate}}</label>\n            </div>\n            <div class=\"ot-twothirds-container\">\n              <input type=\"text\" required class=\"form-control\" id=\"card-number-{{$id}}\" name=\"cardNumber\"\n                pattern=\"[0-9]{13,16}\"\n                placeholder=\"{{'PROFILE.CARD_NUMBER_PLACEHOLDER' | translate}}\"\n                ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.number.$touched) && !profileForm.number.$valid}\"\n                ng-model=\"vm.cardSelected.number\">\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"ot-third-container\">\n              <label for=\"card-month-{{$id}}\">{{'PROFILE.CARD_EXPIRATION' | translate}}</label>\n            </div>\n            <div class=\"ot-third-container\">\n              <input type=\"text\" required class=\"form-control\" id=\"card-month-{{$id}}\" name=\"cardMonth\"\n                placeholder=\"{{'PROFILE.CARD_MONTH_PLACEHOLDER' | translate}}\"\n                ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.cardMonth.$touched) && !profileForm.cardMonth.$valid}\"\n                ng-model=\"vm.cardSelected.expiration_month\">\n            </div>\n            <div class=\"ot-third-container\">\n              <input type=\"text\" required class=\"form-control\" id=\"card-year-{{$id}}\" name=\"cardYear\"\n                placeholder=\"{{'PROFILE.CARD_YEAR_PLACEHOLDER' | translate}}\"\n                ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.cardYear.$touched) && !profileForm.cardYear.$valid}\"\n                ng-model=\"vm.cardSelected.expiration_year\">\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"ot-third-container\">\n              <label for=\"card-email-{{$id}}\">{{'PROFILE.CARD_CVV' | translate}}</label>\n            </div>\n            <div class=\"ot-third-container\">\n              <input type=\"text\" required class=\"form-control\" id=\"card-cvv-{{$id}}\" name=\"cardCvv\"\n                placeholder=\"{{'PROFILE.CARD_CVV_PLACEHOLDER' | translate}}\"\n                ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.email.$touched) && !profileForm.email.$valid}\"\n                ng-model=\"vm.cardSelected.cvv\">\n            </div>\n            <div class=\"ot-third-container\">\n              <p>{{'PROFILE.CARD_CVV_TEXT' | translate}}</p>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"ot-third-container\">\n            </div>\n            <div class=\"ot-third-container\">\n\n            </div>\n            <div class=\"ot-third-container\">\n              <p class=\"set_default_text\">\n                <input type=\"checkbox\"\n                   ng-model=\"vm.cardSelected.favourite\"\n                   name=\"defaultCard\"\n                   ng-true-value=\"true\"\n                   ng-false-value=\"false\"\n                   ng-change=\"test\">\n               {{'PROFILE.CARD_DEFAULT_TEXT' | translate}}\n             </p>\n             </div>\n          </div>\n          <div class=\"row\">\n            <ot-separator class=\"ot-full-container\" params=\"{'type': 'horizontal'}\"></ot-separator>\n            <div class=\"ot-third-container\">\n              <div class=\"cancel-button btn btn-primary\" ng-class=\"{'showcard': vm.showRegisterCard, 'hidecard': !vm.showRegisterCard}\" ng-click=\"vm.openRegisterCard(vm.showParam)\" class=\"cancel-button btn btn-primary\" ng-model=\"vm.showParam\">\n                {{'PROFILE.CARD_CANCEL_BUTTON' | translate}}\n              </div>\n            </div>\n            <div class=\"ot-twothirds-container\">\n              <div ng-if=\"!vm.newCard\" ng-click=\"vm.registerCard(creditCardForm,'update')\" class=\"btn btn-primary action-card-button\">{{'PROFILE.SUBMIT_CARD' | translate}}</div>\n              <div ng-if=\"vm.newCard\" ng-click=\"vm.registerCard(creditCardForm,'newcard')\" class=\"btn btn-primary action-card-button\">{{'PROFILE.SUBMIT_CARD' | translate}}</div>\n              <div ng-if=\"!vm.newCard\" ng-click=\"vm.registerCard(creditCardForm,'delete')\" class=\"btn btn-primary action-card-button\">{{'PROFILE.DELETE_CARD' | translate}}</div>\n            </div>\n          </div>\n\n        </div>\n\n\n      </form>-->\n    </div>\n  </div>\n\n  </div>\n\n  <ot-footer></ot-footer>\n</div>\n"

/***/ },
/* 247 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-avatar\"\n  ng-class=\"vm.getAvatarAdditionalClass()\"\n  >\n\n  <span\n    ng-if=\"vm.hasLabelBefore()\"\n    ng-class=\"vm.getLabelClass() + ' ' + vm.getLabelAdditionalClass()\"\n    >\n    {{vm.getLabelText()}}\n  </span>\n\n  <div\n    ng-class=\"vm.getImageClass() + ' ' + vm.getImageAdditionalClass()\"\n    ng-style=\"vm.getImageStyle()\"\n    >\n\n    <span class=\"ot-avatar-initials\" style=\"\">{{vm.getUserInitials()}}</span>\n\n  </div>\n\n  <span\n    ng-if=\"vm.hasLabelAfter()\"\n    ng-class=\"vm.getLabelClass() + ' ' + vm.getLabelAdditionalClass()\"\n    >\n    {{vm.getLabelPrefix()}}<span class=\"ot-avatar-host-name\">{{vm.getLabelText()}}</span>{{vm.getLabelSuffix()}}\n  </span>\n\n</div>\n"

/***/ },
/* 248 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-banner\" ng-class=\"{'ot-parallaxed': !!params.parallax}\" ng-style=\"vm.getSrc()\">\n  <h3 class=\"ot-title\">{{params.title}}</h3>\n</div>\n"

/***/ },
/* 249 */
/***/ function(module, exports) {

	module.exports = "\n<div class=\"datafield\">\n  <div>\n    <p>{{name}}</p>\n  </div>\n  <div>\n    <p>{{value}}</p>\n  </div>\n</div>\n"

/***/ },
/* 250 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-image-uploader\">\n\n  <uib-carousel class=\"ot-carousel\" active=\"vm.active\">\n    <uib-slide class=\"ot-slide\" ng-repeat=\"cover in vm.covers\" index=\"$index\">\n      <div class=\"ot-cover\" ng-class=\"cover.imgClass\"></div>\n    </uib-slide>\n\n    <uib-slide class=\"ot-slide\" index=\"vm.covers.length\" ng-if=\"vm.lastValidUploadedImage || current\">\n      <div ng-show=\"!!vm.lastValidUploadedImage\" class=\"ot-cover-custom\" ngf-background=\"vm.lastValidUploadedImage\"></div>\n      <ot-banner ng-show=\"!vm.lastValidUploadedImage\" params=\"{'src': current}\"></ot-banner>\n    </uib-slide>\n  </uib-carousel>\n\n\n\n\n  <div class=\"ot-select-or-upload-container\">\n\n    <p class=\"ot-select-or-upload\">\n      <span>{{\"CREATE.SELECT_IMAGE\" | translate}}</span>\n      <a ngf-select=\"\" ngf-change=\"vm.onFileChange($invalidFiles, $event)\"\n        ngf-max-size=\"2.5MB\" ng-model=\"vm.lastUploadedImage\"\n        name=\"file\" accept=\"image/*\" type=\"file\">\n        {{\"CREATE.UPLOAD_IMAGE\" | translate}}\n      </a>\n      <span>{{\"CREATE.SMALLER_THAN\" | translate}}</span>\n    </p>\n\n    <uib-progressbar ng-show=\"vm.isUploading\" style=\"margin:10px;\" max=\"max\" value=\"vm.uploadCurrentPercentual\">\n      <span style=\"color:white; white-space:nowrap;\">{{vm.uploadCurrentPercentual | number: 2}} / {{max}}</span>\n    </uib-progressbar>\n\n  </div>\n</div>\n"

/***/ },
/* 251 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-input-combo ot-input-dropdown\" uib-dropdown uib-keyboard-nav>\n  <label>{{params.label | translate}}</label>\n  <input type=\"hidden\" ng-required=\"params.required\" ng-model=\"value\" name=\"{{params.name}}\"></input>\n  <button\n    type=\"button\" id=\"{{params.uuid}}-{{$id}}\"\n    class=\"btn btn-default ot-toggle\" uib-dropdown-toggle\n    ng-class=\"{'ot-input-error': (parentform.$submitted || parentform[params.name].$touched) && !parentform[params.name].$valid}\"\n    >\n    <span class=\"ot-left ot-placeholder\">{{value.label || params.placeholder}}</span>\n    <span class=\"ot-left ot-placeholder\"\n      ng-show=\"(parentform.$submitted || parentform[params.name].$touched) && !parentform[params.name].$valid\">\n      &nbsp&nbsp{{\"CREATE.REQUIRED_SELECTION\" | translate}}\n    </span>\n    <span class=\"ot-right caret\"></span>\n  </button>\n\n  <ul class=\"uib-dropdown-menu\" uib-dropdown-menu role=\"menu\">\n    <li role=\"menuitem\" ng-repeat=\"item in params.values\">\n      <a ng-click=\"$parent.value = item\" href=\"\">\n        {{item.label}}\n      </a>\n    </li>\n    <li role=\"menuitem\" ng-if=\"!params.required\">\n      <a ng-click=\"$parent.value = undefined\" href=\"\">\n        {{\"CREATE.UNSPECIFIED_OPTION\" | translate}}\n      </a>\n    </li>\n  </ul>\n</div>\n"

/***/ },
/* 252 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-input-select ot-input-dropdown\" uib-dropdown auto-close=\"outsideClick\" uib-keyboard-nav>\n  <label for=\"{{params.name}}-{{$id}}\">{{params.label | translate}}</label>\n  <input type=\"hidden\" required ng-model=\"params.model\" name=\"{{params.name}}\"></input>\n  <button type=\"button\" id=\"{{params.name}}-{{$id}}\" class=\"btn btn-default\" uib-dropdown-toggle\n  ng-class=\"{'ot-input-error': (form.$submitted || form.alcohol.$touched) && !form.alcohol.$valid}\"\n  ng-disabled=\"params.disabled\"\n  >\n    <span class=\"ot-left\">\n      <span ng-show=\"params.model.length < params.dataSet.length\" ng-repeat=\"type in params.model\">\n        {{type| enumName:params.enumName | translate}}\n        <span ng-show=\"!$last\">, </span>\n      </span>\n      <span ng-show=\"params.model.length == 0\">\n        {{params.labelWhenEmpty | translate}}\n      </span>\n      <span ng-show=\"params.model.length == params.dataSet.length\">\n        {{params.labelWhenFull | translate}}\n      </span>\n    </span>\n    <span class=\"ot-right caret\"></span>\n  </button>\n\n  <ul class=\"uib-dropdown-menu\" uib-dropdown-menu role=\"menu\">\n    <li role=\"menuitem\" ng-repeat=\"item in params.dataSet\">\n      <a ng-click=\"$parent.vm.toggle(params.model, item, params.multiple)\" href=\"\">\n\n        <span class=\"glyphicon glyphicon-check\" ng-show=\"$parent.vm.contains($parent.params.model, item)\"></span>\n        <!--\n        <span class=\"glyphicon glyphicon-unchecked\" ng-show=\"!$parent.vm.contains(params.model, item)\"></span>\n        -->\n        {{item | enumName:params.enumName | translate}}\n      </a>\n    </li>\n\n  </ul>\n</div>\n"

/***/ },
/* 253 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-loader\">\n  <div class=\"ot-progress\"></div>\n</div>\n"

/***/ },
/* 254 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-logo\" ng-class=\"{'ot-active':vm.isClickable()}\" ng-click=\"vm.click()\">\n  <div ng-class=\"vm.getImageClass()\"></div>\n</div>\n"

/***/ },
/* 255 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-separator\"\n  ng-class=\"{'ot-vertical': params.type != 'horizontal', 'ot-horizontal': params.type == 'horizontal'}\">\n  <div></div>\n    <p ng-show=\"params.text.length && params.text.length > 0\">{{params.text | translate}}</p>\n  <div></div>\n</div>\n"

/***/ },
/* 256 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-social-share container-fluid\">\n  <div class=\"row\">\n    <h3>{{\"MANAGE.SOCIAL_SHARE\" | translate}}</h3>\n  </div>\n\n  <form class=\"row\">\n    <div class=\"ot-full-container\" ng-if=\"vm.getEventType() != 'private'\">\n      <div style=\"float:left\">\n        <a ng-click=\"vm.shareOnTwitter()\" class=\"btn btn-default ot-twitter\"></a>\n      </div>\n\n      <div style=\"text-align: right;\">\n        <a href=\"{{vm.getUrlShortener(params.item.uuid)}}\" target=\"_blank\" style=\"line-height:38px\">\n          {{vm.getUrlShortener(params.item.uuid)}}\n        </a>\n      </div>\n\n    </div>\n    <div ng-if=\"vm.getEventType() == 'private'\">\n      <div class=\"ot-full-container\">\n        <input type=\"text\" class=\"form-control\" id=\"url-{{$id}}\" name=\"url\" value=\"{{vm.getUrlShortener(params.item.uuid)}}\">\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ },
/* 257 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-stepper\">\n  <span ng-repeat-start=\"item in params.items\" ng-class=\"{'ot-current': params.current == $index}\">\n      {{item | translate}}\n  </span>\n\n  <span ng-show=\"!$last\" ng-repeat-end>&nbsp;&#062;&nbsp;</span>\n</div>\n"

/***/ },
/* 258 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-attendants\">\n  <ot-avatar ng-repeat=\"item in vm.getAvatars()\" params=\"item\"></ot-avatar>\n</div>\n"

/***/ },
/* 259 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-dish-list\">\n  <ul>\n    <li ng-repeat=\"dish in params.items track by $index\">\n      <span>{{dish}}</span><span ng-if=\"params.editable==true\" class=\"glyphicon glyphicon-remove ot-remove\" ng-click=\"$parent.vm.removeItemAt($index)\"></span>\n    </li>\n  </ul>\n  <form ng-if=\"params.editable==true\"\n  name=\"addDish\" ng-submit=\"vm.submit(addDish)\" novalidate>\n    <input class=\"form-control\" type=\"text\" ng-model=\"vm.dish\" placeholder=\"{{params.placeholder | translate}}\" required></input>\n    <input class=\"btn btn-default\" type=\"submit\" value=\"{{'CREATE.ADD' | translate}}\"></input>\n  </form>\n</div>\n"

/***/ },
/* 260 */
/***/ function(module, exports) {

	module.exports = "\n<div class=\"ot-event\" ng-class=\"{'ot-clickable': params.type=='landing'}\" ng-click=\"params.type=='landing' && vm.showEvent()\">\n  <a ng-href=\"{{vm.linkPublicEvent()}}\">\n    <div class=\"ot-banner-container\">\n\n      <ot-notification ng-show=\"params.item.hosted_by_me\" params=\"{text: 'EVENT.HOST_DINNER', type: 'success'}\"></ot-notification>\n      <ot-notification ng-show=\"params.item.my_reservation != null && params.item.my_reservation.state == 'accepted'\" params=\"{text: 'EVENT.YOURE_GOING', type:'success'}\"></ot-notification>\n      <ot-notification ng-show=\"params.item.my_reservation != null && params.item.my_reservation.state == 'pending'\" params=\"{text: 'EVENT.PENDING_HOST_APPROVAL', type:'warning'}\"></ot-notification>\n      <ot-notification ng-show=\"params.item.reservations_stats.guests_accepted == (params.item.number_of_guests_max - 1)\" params=\"{text: 'EVENT.LAST_SEAT', type: 'important'}\"></ot-notification>\n      <ot-notification ng-show=\"params.item.reservations_stats.guests_accepted >= (params.item.number_of_guests_max)\" params=\"{text: 'EVENT.FULL_DINNER', type: 'fulldinner'}\"></ot-notification>\n      <ot-notification ng-show=\"params.item.my_reservation != null && params.item.my_reservation.state == 'rejected'\" params=\"{text: 'EVENT.REJECTED', type: 'rejecteddinner'}\"></ot-notification>\n\n      <ot-banner params=\"{'src': params.item.cover.m}\"></ot-banner>\n\n    </div>\n\n    <div class=\"ot-right\">\n      <div class=\"ot-action-container\">\n        <ot-avatar class=\"ot-host-avatar\"\n          params=\"{\n            image: {src: params.item.created_by_profile.avatar.m, size: vm.getAvatarSize()},\n            label: {text: vm.getAvatarLabel(), position: vm.getAvatarPosition(), class: 'ot-label-event', suffix:'is hosting'},\n            initials: {'first_name': params.item.created_by_profile.first_name, 'last_name': params.item.created_by_profile.last_name}\n          }\"></ot-avatar>\n\n        <ot-event-action-menu ng-if=\"params.type == 'manage'\" params=\"{item: params.item, type: 'attending'}\"></ot-event-action-menu>\n      </div>\n\n      <ot-attendants ng-if=\"params.type == 'manage'\" ng-show=\"params.item.reservations.length > 0\"\n        params=\"{size: 'ss', items: params.item.reservations, title: params.type == 'manage' && 'EVENT.ATTENDANTS'}\"></ot-attendants>\n    </div>\n\n\n    <div class=\"ot-left\">\n      <!--<a ng-if=\"params.type == 'manage'\" ng-click=\"vm.showEvent()\">\n        <h3 class=\"ot-event-title\">{{params.item.title}}</h3>\n      </a>-->\n      <h3 class=\"ot-event-title\">{{params.item.title}}</h3>\n\n      <ot-separator ng-if=\"params.type != 'manage' && params.type != 'compact'\" params=\"{'type': 'horizontal'}\"></ot-separator>\n\n      <ot-info params=\"{event: params.item, showFullAddress: params.type == 'manage', showSecondaryAddress: params.type == 'manage'}\"></ot-info>\n\n      <ot-attendants ng-if=\"params.type != 'manage' && params.type != 'compact'\" ng-show=\"vm.getReservationsList().length > 0 && params.item.event_type != 'private'\" params=\"{'items': vm.getReservationsList()}\"></ot-attendants>\n\n      <div class=\"ot-be-the-first\" ng-if=\"params.type != 'manage' && params.type != 'compact'\"\n         ng-show=\"params.item.reservations.length <= 0 && params.item.event_type == 'public'\">\n         <p>{{'EVENT.BE_THE_FIRST_TO_RSVP' | translate}}</p>\n      </div>\n\n      <div class=\"ot-event-private\" ng-if=\"params.type != 'manage' && params.type != 'compact'\"\n         ng-show=\"params.item.event_type == 'private'\">\n         <p>{{'EVENT.PRIVATE_DINNER_NOTICE' | translate}}</p>\n      </div>\n\n      <div class=\"ot-event-manual\" ng-if=\"params.type != 'manage' && params.type != 'compact'\"\n         ng-show=\"params.item.reservations.length <= 0 && params.item.event_type == 'manual_approval'\">\n         <p>{{'EVENT.MANUAL_APPROVAL_NOTICE' | translate}}</p>\n      </div>\n    </div>\n  </a>\n</div>\n"

/***/ },
/* 261 */
/***/ function(module, exports) {

	module.exports = "<span uib-dropdown class=\"ot-event-action-menu\">\n  <span ng-if=\"params.type!='attending'\" uib-dropdown-toggle class=\"uib-dropdown-toggle\">{{'MANAGE.ACTION_MENU' | translate}}<span class=\"caret\"></span></span>\n  <span ng-if=\"params.type=='attending'\" uib-dropdown-toggle class=\"uib-dropdown-toggle\"><span class=\"glyphicon glyphicon-option-horizontal\"></span></span>\n  <ul class=\"uib-dropdown-menu ot-dropdown-menu\" uib-dropdown-menu aria-labelledby=\"simple-dropdown\">\n    <li ng-repeat=\"actionItem in vm.actionList\">\n      <a href ng-click=\"actionItem.callback()\">{{actionItem.label | translate}}</a>\n    </li>\n  </ul>\n</span>\n"

/***/ },
/* 262 */
/***/ function(module, exports) {

	module.exports = "<ot-loader ng-show=\"vm.session.getData().isLoadingPrivateEvents()\"></ot-loader>\n<ul infinite-scroll='vm.loadMore(params.type)' class=\"ot-event-list\" ng-class=\"{\n  'ot-event-landing-style': params.type == 'landing',\n  'ot-event-manage-style': params.type == 'manage',\n  'ot-event-compact-style': params.type == 'compact'\n}\">\n  <li ng-repeat=\"event in params.items track by $index\">\n    <ot-event params=\"{'item': event, 'type': $parent.params.type}\"></ot-event>\n  </li>\n</ul>\n"

/***/ },
/* 263 */
/***/ function(module, exports) {

	module.exports = "<!-- This is a little different to the other directives as\n  it needs to be correctly nested to be displayed as the table content -->\n<td data-title=\"{{'MANAGE.COVER_TABLE_HEADER' | translate}}\">\n  <ot-banner params=\"{'src': params.item.cover.m}\"></ot-banner>\n</td>\n\n<td class=\"ot-title\" data-title=\"{{'MANAGE.EVENT_TABLE_HEADER' | translate}}\">\n  <a href ng-click=\"vm.showEvent()\">\n    <p>{{params.item.title}}</p>\n  </a>\n</td>\n\n<td data-title=\"{{'MANAGE.DETAILS_TABLE_HEADER' | translate}}\">\n  <ot-info params=\"{event: params.item, onlyText: true, limit: 20}\"></ot-info>\n</td>\n\n<td class=\"ot-status ot-upcase-first\" data-title=\"{{'MANAGE.STATUS_TABLE_HEADER' | translate}}\">\n  <p>{{params.item.state}}</p>\n</td>\n\n<td ng-if=\"params.type == 'hosted'\" class=\"ot-attendance\" data-title=\"{{'MANAGE.ATTENDANCE_TABLE_HEADER' | translate}}\">\n  <p>{{'EVENT.X_ATTENDING' | translate | sprintf:vm.getAcceptedList()}}</p>\n  <p ng-if=\"params.item.event_type == 'manual_approval' || params.item.event_type == 'private'\">{{'EVENT.X_PENDING' | translate | sprintf:vm.getPendingList()}}</p>\n</td>\n\n<td data-title=\"{{'MANAGE.MANAGE_TABLE_HEADER' | translate}}\">\n  <ot-event-action-menu params=\"{item: params.item, type: params.type}\"></ot-event-action-menu>\n</td>\n"

/***/ },
/* 264 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-event-table\" id=\"no-more-tables\">\n  <table>\n    <thead>\n      <th>Cover</th>\n      <th>{{'MANAGE.EVENT_TABLE_HEADER' | translate}}</th>\n      <th>{{'MANAGE.DETAILS_TABLE_HEADER' | translate}}</th>\n      <th>{{'MANAGE.STATUS_TABLE_HEADER' | translate}}</th>\n      <th ng-if=\"params.type == 'hosted'\">{{'MANAGE.ATTENDANCE_TABLE_HEADER' | translate}}</th>\n      <th>{{'MANAGE.MANAGE_TABLE_HEADER' | translate}}</th>\n    </thead>\n    <tbody infinite-scroll='vm.loadMore(params.type)'>\n      <tr class=\"ot-event-row\" ng-repeat=\"event in params.items\" ot-event-row params=\"{item: event, type: params.type, reservations: event.reservations}\"></tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ },
/* 265 */
/***/ function(module, exports) {

	module.exports = "<div class =\"ot-host\">\n  <ot-avatar params=\"{\n                      image: {src: params.host.avatar, size: 'lg'},\n                      initials: {'first_name': params.host.first_name, 'last_name': params.host.last_name}\n                    }\"></ot-avatar>\n  <div>\n    <p>{{params.host.bio}}</p>\n    <button class=\"btn btn-default\">{{'EVENT.SEND_MESSAGE' | translate}}</button>\n  </div>\n\n</div>\n"

/***/ },
/* 266 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-info\"\n  ng-class=\"{'ot-horizontal': params.type == 'horizontal', 'ot-vertical': params.type == 'vertical'}\">\n  <p ng-repeat=\"item in vm.getData().items\" ng-class=\"item.class\" ng-if=\"item.visible\">\n    <span ng-if=\"!$parent.params.onlyText\" ng-class=\"item.icon\"></span>\n    <span>{{item.text}}</span>\n  </p>\n</div>\n"

/***/ },
/* 267 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-invite-guests container-fluid\">\n  <div class=\"row\">\n    <h3 ng-if=\"vm.session.getData().event.hosted_by_me\">{{\"MANAGE.INVITE_GUESTS\" | translate}}</h3>\n    <h3 ng-if=\"!vm.session.getData().event.hosted_by_me\">{{\"MANAGE.INVITE_FRIENDS_EMAIL\" | translate}}</h3>\n  </div>\n\n  <form class=\"row\" name=\"inviteFriendsForm\" ng-submit=\"vm.inviteGuests(inviteFriendsForm)\">\n    <div class=\"ot-full-container\">\n      <p class=\"ot-hint\">{{\"MANAGE.ADD_EMAIL_HINT\" | translate}}</p>\n      <div class=\"ot-tags-input-wrapper\" ng-class=\"{'ot-after': showSend}\">\n        <tags-input add-on-space=\"true\" ng-model=\"tags\" class=\"ot-tags-input\"></tags-input>\n      </div>\n\n      <div>\n        <textarea placeholder=\"{{'GUEST.DESCRIPTION_PLACEHOLDER' | translate}}\" class=\"form-control\" ng-model=\"emailText\"></textarea>\n        <button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"!vm.canSend()\">SEND INVITE</button>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ },
/* 268 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-manage-header\">\n  <ot-avatar params=\"{\n    image: {src:vm.session.getAvatar(), size: 'lg'},\n    label: {text: 'Hello, ' + vm.session.getFirstName() + '.', position: 'right', class: 'ot-greeting'},\n    initials: {'first_name': vm.session.getFirstName(), 'last_name': vm.session.getLastName()}\n  }\"></ot-avatar>\n  <ot-separator class=\"ot-small\" params=\"{type: 'horizontal'}\"></ot-separator>\n\n  <div ng-switch=\"vm.section\">\n\n    <p ng-switch-when=\"upcoming\">\n      <span>{{\"MANAGE.YOU_HAVE\" | translate}}</span>\n      <span ng-if=\"vm.getUpcomingCount() > 1 || vm.getUpcomingCount() == 0\" class=\"ot-hilight\">{{\"MANAGE.X_UPCOMING_DINNERS\" | translate | sprintf: vm.getUpcomingCount() }}</span>\n      <span ng-if=\"vm.getUpcomingCount() == 1\" class=\"ot-hilight\">{{\"MANAGE.X_UPCOMING_DINNER\" | translate | sprintf: vm.getUpcomingCount() }}</span>\n      <span>{{\"MANAGE.DOT\" | translate}}</span>\n\n      <!--span>{{\"MANAGE.AND\" | translate}}</span>\n      <span class=\"ot-hilight\">{{\"MANAGE.X_PENDING_APPROVALS\" | translate | sprintf:'TODO'}}</span>\n      <span>{{\"MANAGE.DOT\" | translate}}</span-->\n    </p>\n\n    <p ng-switch-when=\"hosted\">\n      <span>{{\"MANAGE.YOU_HAVE\" | translate}}</span>\n      <span ng-if=\"vm.getHostedCount() > 1 || vm.getHostedCount() == 0\" class=\"ot-hilight\">{{\"MANAGE.X_HOSTED_DINNERS\" | translate | sprintf: vm.getHostedCount() }}</span>\n      <span ng-if=\"vm.getHostedCount() == 1\" class=\"ot-hilight\">{{\"MANAGE.X_HOSTED_DINNER\" | translate | sprintf: vm.getHostedCount() }}</span>\n      <span>{{\"MANAGE.DOT\" | translate}}</span>\n      <br>\n      <!--span>{{\"MANAGE.AND\" | translate}}</span>\n      <span class=\"ot-hilight\">{{\"MANAGE.X_PENDING_ATTENDEES\" | translate | sprintf:'TODO'}}</span>\n      <span>{{\"MANAGE.DOT\" | translate}}</span-->\n    </p>\n\n    <p ng-switch-when=\"saved\">\n      <span>{{\"MANAGE.YOU_HAVE\" | translate}}</span>\n      <span ng-if=\"vm.getSavedCount() > 1 || vm.getSavedCount() == 0\" class=\"ot-hilight\">{{\"MANAGE.X_DRAFT_DINNERS\" | translate | sprintf: vm.getSavedCount()}}</span>\n      <span ng-if=\"vm.getSavedCount() == 1\" class=\"ot-hilight\">{{\"MANAGE.X_DRAFT_DINNER\" | translate | sprintf: vm.getSavedCount()}}</span>\n      <span>{{\"MANAGE.DOT\" | translate}}</span>\n    </p>\n\n    <p ng-switch-when=\"past\">\n      <span>{{\"MANAGE.YOU_HAVE\" | translate}}</span>\n      <span ng-if=\"vm.getPastCount() > 1 || vm.getPastCount() == 0\" class=\"ot-hilight\">{{\"MANAGE.X_PAST_DINNERS\" | translate | sprintf: vm.getPastCount()}}</span>\n      <span ng-if=\"vm.getPastCount() == 1\" class=\"ot-hilight\">{{\"MANAGE.X_PAST_DINNER\" | translate | sprintf: vm.getPastCount()}}</span>\n      <span>{{\"MANAGE.DOT\" | translate}}</span>\n    </p>\n\n  </div>\n</div>\n"

/***/ },
/* 269 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-manage-menu\">\n\n  <ul class=\"ot-menu-box\">\n    <li ng-repeat=\"menuItem in vm.menuItemList\"\n      ng-class=\"{'ot-selected': menuItem.key == $parent.vm.current, 'ot-clickable': !!menuItem.callback, 'ot-subbed': !!menuItem.subMenu}\">\n      <a ng-href=\"{{menuItem.linkUrl}}\" ng-click=\"menuItem.callback()\">\n        <div>\n          <span>{{menuItem.label | translate}}</span>\n\n          <span class=\"badge\" ng-show=\"menuItem.orange() > 0\">{{menuItem.orange()}}</span>\n          <span class=\"badge ot-red\" ng-show=\"menuItem.red() > 0\">{{menuItem.red()}}</span>\n        </div>\n      </a>\n\n      <ul>\n        <li ng-repeat=\"subItem in menuItem.subMenu\"\n          ng-class=\"{'ot-selected': subItem.key == $parent.$parent.vm.current, 'ot-clickable': !!subItem.callback}\">\n          <a ng-href=\"{{subItem.linkUrl}}\" ng-click=\"subItem.callback()\">\n            <div>\n              <span>{{subItem.label | translate}}</span>\n\n              <span class=\"badge\" ng-show=\"subItem.orange() > 0\">{{subItem.orange()}}</span>\n              <span class=\"badge ot-red\" ng-show=\"subItem.red() > 0\">{{subItem.red()}}</span>\n            </div>\n          </a>\n        </li>\n      </ul>\n    </li>\n  </ul>\n\n  <button class=\"btn btn-primary\" ng-click=\"vm.openCreatePage()\">{{'MANAGE.CREATE' | translate}}</button>\n\n</div>\n"

/***/ },
/* 270 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-modal-action-bar\">\n  <ot-separator params=\"{'type': 'horizontal'}\"></ot-separator>\n\n  <div class=\"ot-full-container\">\n    <div class=\"row\">\n      <!-- the order matters: the first has to be the one with the submit action as angular will call it when enter is pressed -->\n      <button class=\"btn btn-default ot-modal-right-container\" ng-click=\"params.right.callback()\">{{params.right.label | translate}}</button>\n      <button class=\"btn btn-default ot-modal-left-container\" ng-click=\"params.left.callback()\">{{params.left.label | translate}}</button>\n\n    </div>\n  </div>\n</div>\n"

/***/ },
/* 271 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-notification\">\n  <p ng-class=\"{'ot-important': params.type=='important', 'ot-warning': params.type=='warning', 'ot-success': params.type=='success','ot-full': params.type=='fulldinner','ot-full': params.type=='rejecteddinner'}\">{{params.text | translate}}</p>\n</div>\n"

/***/ },
/* 272 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-price-badge-noborder\">\n  <p>\n    <!-- <span>{{'EVENT.COST' | translate}}</span> -->\n    <span ng-if=\"params.event.price_per_person<=0\">{{'EVENT.COST_FREE' | translate}}</span>\n    <span ng-if=\"params.event.price_per_person>0\">{{(params.event.price_per_person / 100) | currency:\"$\":0}}</span>\n  </p>\n  <ot-rsvp class=\"row\"></ot-rsvp>\n</div>\n"

/***/ },
/* 273 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-rsvp container-fluid\">\n\n  <div ng-switch=\"vm.getReservationStatus()\">\n\n\n\n    <div class=\"ot-rsvp-wrapper\">\n\n\n      <div ng-switch-when=\"0\"\n        class=\"form-group ot-rsvp-initial\">\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openRsvpModal()\">\n          <span ng-if=\"vm.isRsvp()\">{{'EVENT.RSVP' | translate}}</span>\n          <span ng-if=\"vm.isManualApproval()\">{{'EVENT.REQUEST_A_SEAT' | translate}}</span>\n        </button>\n      </div>\n\n      <div ng-switch-when=\"1\"\n        class=\"form-group ot-rsvp-pending\">\n        <button type=\"button\" class=\"btn btn-default\">{{'EVENT.PENDING_HOST_APPROVAL' | translate}}</button>\n      </div>\n\n      <div ng-switch-when=\"2\"\n      class=\"form-group ot-input-dropdown ot-rsvp-done\" uib-dropdown uib-keyboard-nav>\n        <button type=\"button\" id=\"meal-type-{{$id}}\" class=\"btn btn-default\" uib-dropdown-toggle>\n          <span class=\"ot-left\">{{params.data.event.mealType | enumName:'meal':'EVENT.YOURE_GOING' | translate}}</span>\n          <span class=\"ot-right caret\"></span>\n        </button>\n\n        <ul class=\"uib-dropdown-menu\" uib-dropdown-menu role=\"menu\">\n          <li role=\"menuitem\">\n            <a ng-click=\"vm.openCancelReservationConfirm()\" href=\"\">\n              {{'EVENT.CANCEL_RESERVATION' | translate}}\n            </a>\n          </li>\n          <li role=\"menuitem\">\n            <a ng-click=\"vm.openInviteGuests()\" href=\"\">\n              {{'EVENT.INVITE_FRIENDS' | translate}}\n            </a>\n          </li>\n        </ul>\n\n      </div>\n\n      <div ng-switch-when=\"3\"\n      class=\"form-group ot-input-dropdown ot-rsvp-done\" uib-dropdown uib-keyboard-nav>\n        <button type=\"button\" id=\"meal-type-{{$id}}\" class=\"btn btn-default\" uib-dropdown-toggle>\n          <span class=\"ot-left\">{{params.data.event.mealType | enumName:'meal':'EVENT.YOURE_GOING' | translate}}</span>\n          <span class=\"ot-right caret\"></span>\n        </button>\n\n        <ul class=\"uib-dropdown-menu\" uib-dropdown-menu role=\"menu\">\n          <li role=\"menuitem\">\n            <a ng-click=\"vm.openInviteGuests()\" href=\"\">\n              {{'EVENT.INVITE_FRIENDS' | translate}}\n            </a>\n          </li>\n        </ul>\n      </div>\n\n      <div ng-switch-when=\"4\" class=\"form-group ot-rsvp-initial\">\n        <button type=\"button\" class=\"btn btn-default\" disabled=\"true\">\n          <span>{{'EVENT.FULL_DINNER' | translate}}</span>\n        </button>\n      </div>\n\n      <div ng-switch-when=\"5\"\n      class=\"form-group ot-input-dropdown ot-rsvp-done\" uib-dropdown uib-keyboard-nav>\n        <button type=\"button\" id=\"meal-type-{{$id}}\" class=\"btn btn-default\" uib-dropdown-toggle>\n          <span class=\"ot-left\">{{params.data.event.mealType | enumName:'meal':'EVENT.HOST_DINNER' | translate}}</span>\n          <span class=\"ot-right caret\"></span>\n        </button>\n\n        <ul class=\"uib-dropdown-menu\" uib-dropdown-menu role=\"menu\">\n          <li role=\"menuitem\">\n            <a ng-click=\"vm.openInviteGuests()\" href=\"\">\n              {{'EVENT.INVITE_FRIENDS' | translate}}\n            </a>\n          </li>\n        </ul>\n      </div>\n\n      <div ng-switch-when=\"6\" class=\"form-group ot-rsvp-initial\">\n        <button type=\"button\" class=\"btn btn-default\" disabled=\"true\">\n          <span>{{'EVENT.REJECTED' | translate}}</span>\n        </button>\n      </div>\n\n    </div>\n\n  </div>\n\n\n</div>\n"

/***/ },
/* 274 */
/***/ function(module, exports) {

	module.exports = "<form class=\"ot-search\" name=\"searchForm\" ng-submit=\"params.callback()\" novalidate ng-class=\"{'ot-active': params.filter.visibility}\">\n  <!--<div class=\"ot-search-container container-fluid\">\n    <div class=\"row\">\n\n      <div class=\"ot-full-container ot-search-form-container\">\n        <div class=\"ot-threequarter-container ot-button-input-container\">\n          <input type=\"text\" name=\"queryString\" class=\"form-control\" placeholder=\"{{'SEARCH.PLACEHOLDER' | translate}}\" ng-model=\"params.filter.queryString\" autocomplete=\"off\"></input>\n          <p class=\"ot-lens\"></p>\n          <input type=\"submit\" class=\"btn btn-default\" value=\"{{'LANDING.SEARCH' | translate}}\"></input>\n        </div>\n        <div class=\"ot-quarter-container ot-button-input-container\">\n          <button type=\"button\" class=\"btn btn-default ot-filter-button\" ng-click=\"params.filter.visibility = !params.filter.visibility\">\n            <span class=\"icon-filter\"></span>\n            <span ng-if=\"!params.filter.visibility\">{{\"LANDING.FILTER_SHOW\" | translate}}</span>\n            <span ng-if=\"params.filter.visibility\">{{\"LANDING.FILTER_HIDE\" | translate}}</span>\n          </button>\n        </div>\n      </div>\n\n    </div>\n  </div>-->\n <ot-separator ng-hide=\"params.filter.visibility\" params=\"{type: 'horizontal'}\"></ot-separator>\n</form>\n"

/***/ },
/* 275 */
/***/ function(module, exports) {

	module.exports = "<div style=\"text-align: center;\" class=\"ot-search-description\">\n  {{\"LANDING.SUMMARY\" | translate | sprintf:params.count}}\n  <span uib-dropdown class=\"ot-event-action-menu\">\n    <span class=\"ot-current-city\" uib-dropdown-toggle>{{params.city}}</span>\n    <ul class=\"uib-dropdown-menu ot-dropdown-menu\" uib-dropdown-menu aria-labelledby=\"simple-dropdown\">\n      <li ng-repeat=\"city in params.cities\">\n        <a ng-href=\"{{vm.getUrl(city)}}\" ng-click=\"goTo(city)\">{{city.label | translate}}</a>\n      </li>\n    </ul>\n  </span>\n</div>\n"

/***/ },
/* 276 */
/***/ function(module, exports) {

	module.exports = "<form class=\"ot-search-filter\" name=\"searchFilterForm\" ng-submit=\"params.callback()\" novalidate>\n  <div ng-if=\"!vm.session.isOnward()\" class=\"ot-search-container container-fluid\">\n\n    <div class=\"row\">\n      <h4>{{\"FILTER.TITLE\" | translate}}</h4>\n      <h5>{{\"FILTER.SUBTITLE\" | translate}}</h5>\n    </div>\n\n    <div style=\"float:right;margin-top:-48px\" ng-show=\"params.filter.eventType != 3\n                              || params.filter.costType != 2\n                              || params.filter.mealTypes.length != 0\n                              || params.filter.alcoholTypes.length != 0\n                              || params.filter.dietTypes.length != 0\">\n      <h5 ng-click=\"params.clearCallback()\" style=\"cursor:pointer;margin-top:20px\">{{\"FILTER.CLEAR\" | translate}}</h5>\n    </div>\n\n    <!-- FIRST ROW, NEIGHBORHOOD, DATE AND TYPE -->\n\n    <div class=\"row\">\n\n      <!--div class=\"ot-quarter-container ot-input-dropdown\">\n        <label>{{\"FILTER.NEIGHBORHOOD\" | translate}}</label>\n        <button type=\"button\" class=\"btn btn-default\" ng-disabled=\"true\" style=\"width:100%\">\n          <span class=\"ot-left\">{{\"FILTER.NEIGHBORHOOD\" | translate}}</span><span class=\"caret ot-right\"></span>\n        </button>\n      </div-->\n\n      <!--<div class=\"ot-half-container\">\n        <label for=\"min-date-{{$id}}\">{{\"FILTER.DATE_RANGE\" | translate}}</label>\n\n        <div class=\"ot-from-to\">\n\n          <p class=\"ot-date ot-align-right\">\n            <input type=\"text\" class=\"form-control\"\n              ng-class=\"{'ot-input-error': (createForm.$submitted || createForm.date.$touched) && !createForm.date.$valid}\"\n              name=\"date\" uib-datepicker-popup=\"MM/dd/yyyy\" show-button-bar=\"false\"\n              ng-model=\"params.filter.minDate\" id=\"min-date-{{$id}}\"\n              is-open=\"_popupMinStatus\" year-range=\"200\" min-date=\"vm.minEventDate\"\n              max-date=\"vm.maxEventDate\" close-text=\"Close\" required\n              />\n\n            <span class=\"input-group-btn\">\n              <button type=\"button\" class=\"btn btn-default btn-birth\" ng-click=\"_popupMinStatus = !_popupMinStatus\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n            </span>\n          </p>\n\n          <p class=\"ot-to\">{{\"FILTER.TO\" | translate}}</p>\n\n          <p class=\"ot-date ot-align-right\">\n            <input type=\"text\" class=\"form-control\"\n              ng-class=\"{'ot-input-error': (searchFilterForm.$submitted || searchFilterForm.minDate.$touched) && !searchFilterForm.minDate.$valid}\"\n              name=\"minDate\" uib-datepicker-popup=\"MM/dd/yyyy\" show-button-bar=\"false\"\n              ng-model=\"params.filter.maxDate\" id=\"date-{{$id}}\"\n              is-open=\"_popupMaxStatus\" year-range=\"200\" min-date=\"vm.minEventDate\"\n              max-date=\"vm.maxEventDate\" close-text=\"Close\" required\n              />\n\n            <span class=\"input-group-btn\">\n              <button type=\"button\" class=\"btn btn-default btn-birth\" ng-click=\"_popupMaxStatus = !_popupMaxStatus\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n            </span>\n          </p>\n        </div>\n      </div>-->\n\n\n\n\n\n\n      <div class=\"ot-half-container\">\n          <div class=\"ot-input-combo ot-input-dropdown\" uib-dropdown uib-keyboard-nav>\n            <label>Date Event</label>\n            <button\n              type=\"button\"\n              class=\"btn btn-default ot-toggle\" uib-dropdown-toggle\n              >\n              <span class=\"ot-left ot-placeholder\">{{vm.getDateLabel() || \"Select a date\"}}</span>\n              <span class=\"ot-right caret\"></span>\n            </button>\n\n            <ul class=\"uib-dropdown-menu\" uib-dropdown-menu role=\"menu\">\n              <li role=\"menuitem\" ng-repeat=\"item in vm.availableDates\">\n                <a ng-click=\"params.filter.minDate = item.date; params.filter.maxDate = item.date\" href=\"\">\n                  {{item.label}}\n                </a>\n              </li>\n            </ul>\n          </div>\n      </div>\n      <div class=\"ot-half-container ot-button-input-container\">\n        <input type=\"submit\" class=\"btn btn-default\" value=\"{{'LANDING.SEARCH' | translate}}\"></input>\n      </div>\n\n\n\n\n\n\n      <!--<div class=\"form-group ot-half-container\">\n        <div class=\"ot-input-dropdown\"  uib-dropdown uib-keyboard-nav>\n          <label for=\"event-type-{{$id}}\">{{\"FILTER.EVENT_TYPE\" | translate}}</label>\n          <input type=\"hidden\" ng-model=\"params.filter.eventType\" name=\"eventType\"></input>\n          <button type=\"button\" id=\"event-type-{{$id}}\" class=\"btn btn-default\" uib-dropdown-toggle>\n            <span class=\"ot-left\">{{params.filter.eventType| enumName:'event':'CREATE.SELECT' | translate}}</span>\n            <span class=\"ot-right caret\"></span>\n          </button>\n\n          <ul class=\"uib-dropdown-menu\" uib-dropdown-menu role=\"menu\">\n            <li role=\"menuitem\" ng-repeat=\"item in vm.eventTypeOptions\">\n              <a ng-click=\"$parent.params.filter.eventType = item\" href=\"\">\n                {{item | enumName:'event' | translate}}\n              </a>\n            </li>\n          </ul>\n        </div>\n\n      </div>-->\n\n    </div>\n\n\n\n\n    <!-- SECOND ROW, RESTRICTION TYPES -->\n\n    <!--<div class=\"row\">\n      <div class=\"ot-threequarter-container\">\n        <ot-type-picker params=\"{filter: params}\"\n                        alcohol=\"params.filter.alcoholTypes\"\n                        meal=\"params.filter.mealTypes\"\n                        dietary=\"params.filter.dietTypes\">\n        </ot-type-picker>\n      </div>\n\n\n\n\n      <div class=\"form-group ot-quarter-container\">\n        <div class=\"ot-input-dropdown\"  uib-dropdown uib-keyboard-nav>\n          <label for=\"event-type-{{$id}}\">{{\"FILTER.COST_TYPE\" | translate}}</label>\n          <input type=\"hidden\" ng-model=\"params.filter.costType\" name=\"costType\"></input>\n          <button type=\"button\" id=\"cost-type-{{$id}}\" class=\"btn btn-default\" uib-dropdown-toggle>\n            <span class=\"ot-left\">{{params.filter.costType| enumName:'cost':'CREATE.SELECT' | translate}}</span>\n            <span class=\"ot-right caret\"></span>\n          </button>\n\n          <ul class=\"uib-dropdown-menu\" uib-dropdown-menu role=\"menu\">\n            <li role=\"menuitem\" ng-repeat=\"item in vm.costTypeOptions\">\n              <a ng-click=\"$parent.params.filter.costType = item\" href=\"\">\n                {{item | enumName:'cost' | translate}}\n              </a>\n            </li>\n          </ul>\n        </div>\n\n      </div>\n\n    </div>-->\n  </div>\n\n\n  <ot-separator params=\"{type: 'horizontal'}\"></ot-separator>\n</form>\n"

/***/ },
/* 277 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-type-list\">\n  <div ng-repeat=\"type in vm.typeList | type:params.alcoholPolicy:params.dietaryRestrictions\">\n    <div ng-class=\"type.iconClass\"></div>\n    <span>{{type.label | translate}}</span>\n  </div>\n</div>\n"

/***/ },
/* 278 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-type-picker\">\n\n  <div class=\"row\">\n\n    <!--div class=\"form-group ot-third-container\">\n\n      <ot-input-select params=\"{\n        name: 'meal-type',\n        label:'CREATE.MEAL_TYPE',\n        labelWhenEmpty: 'CREATE.MEAL_TYPE_ALL',\n        labelWhenFull: 'CREATE.MEAL_TYPE_ALL',\n        model: meal,\n        dataSet: vm.mealTypeOptions,\n        enumName: 'meal',\n        multiple: false,\n        disabled: false\n      }\"></ot-input-select>\n\n    </div-->\n\n    <!--<div ng-if=\"!vm.session.isOnward()\" class=\"form-group ot-half-container\">\n      <ot-input-select params=\"{\n        name: 'alcohol-type',\n        label:'CREATE.ALCOHOL_TYPE',\n        labelWhenEmpty: 'CREATE.ALCOHOL_TYPE_ALL',\n        labelWhenFull: 'CREATE.ALCOHOL_TYPE_ALL',\n        model: alcohol,\n        dataSet: vm.alcoholTypeOptions,\n        enumName: 'alcohol',\n        multiple: false\n      }\"></ot-input-select>\n    </div>-->\n\n    <div class=\"form-group ot-half-container\">\n\n      <ot-input-select params=\"{\n        name: 'diet-type',\n        label:'CREATE.DIET_TYPE',\n        labelWhenEmpty: 'CREATE.DIET_TYPE_ALL',\n        labelWhenFull: 'CREATE.DIET_TYPE_ALL',\n        model: dietary,\n        dataSet: vm.dietTypeOptions,\n        enumName: 'diet',\n        multiple: true\n      }\"></ot-input-select>\n\n    </div>\n\n  </div>\n</div>\n"

/***/ },
/* 279 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-burger\">\n  <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openMenuModal()\">\n    <span class=\"glyphicon glyphicon-align-justify\"></span>\n  </button>\n</div>\n"

/***/ },
/* 280 */
/***/ function(module, exports) {

	module.exports = "<form class=\"ot-email-login container-fluid\" name=\"loginForm\" ng-submit=\"vm.submit(loginForm)\" novalidate>\n\n  <div class=\"row\">\n    <p class=\"ot-error-message ot-error-login-failed ng-hide\" ng-show=\"vm.hasFailedLogin\">{{'LOGIN.LOGIN_FAILED' | translate}}</p>\n  </div>\n\n  <div class=\"row\">\n    <p class=\"ot-error-message\" ng-show=\"loginForm.email.$touched && !loginForm.email.$valid\">{{'LOGIN.WRONG_EMAIL' | translate}}</p>\n  </div>\n  <div class=\"row\">\n    <input type=\"text\" name=\"email\" required ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\"\n      placeholder=\"{{'LOGIN.EMAIL_PLACEHOLDER' | translate}}\"\n      ng-change=\"vm.hasFailedLogin = false\"\n      class=\"form-control ot-full-container\" ng-class=\"{'ot-input-error': loginForm.email.$touched && !loginForm.email.$valid}\" ng-model=\"vm.email\"></input>\n  </div>\n  <div class=\"row\">\n    <div class=\"ot-password\">\n    <input type=\"password\" name=\"password\"\n      placeholder=\"{{'LOGIN.PASSWORD_PLACEHOLDER' | translate}}\"\n      ng-change=\"vm.hasFailedLogin = false\"\n      class=\"form-control ot-full-container\" ng-model=\"vm.password\"></input>\n      <span>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.openForgotModal()\">{{'LOGIN.FORGOT' | translate}}</button>\n      </span>\n    </div>\n  </div>\n  <div class=\"row\">\n    <input type=\"submit\" class=\"btn btn-primary ot-full-container\" value=\"{{'LOGIN.EMAIL' | translate}}\"></input>\n  </div>\n<form>\n"

/***/ },
/* 281 */
/***/ function(module, exports) {

	module.exports = "<form class=\"ot-email-signup container-fluid\" name=\"signupForm\" ng-submit=\"vm.submit(signupForm)\" novalidate autocomplete=\"off\">\n\n  <div class=\"row\">\n    <div class=\"ot-half-container ot-fix\">\n      <input type=\"text\" name=\"firstName\" required\n        placeholder=\"{{'LOGIN.SIGN_UP_FIRST_NAME_PLACEHOLDER' | translate}}\"\n        class=\"form-control ot-upcase-first\" ng-class=\"{'ot-input-error': (signupForm.$submitted || signupForm.firstName.$touched) && !signupForm.firstName.$valid}\" ng-model=\"vm.signupData.firstName\"></input>\n    </div>\n    <div class=\"ot-half-container ot-fix\">\n      <input type=\"text\" name=\"lastName\" required\n        placeholder=\"{{'LOGIN.SIGN_UP_LAST_NAME_PLACEHOLDER' | translate}}\"\n        class=\"form-control ot-upcase-first\" ng-class=\"{'ot-input-error': (signupForm.$submitted || signupForm.lastName.$touched) && !signupForm.lastName.$valid}\" ng-model=\"vm.signupData.lastName\"></input>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"ot-half-container ot-fix\">\n      <input type=\"text\" name=\"cellPhone\" required\n        placeholder=\"{{'LOGIN.SIGN_UP_CELL_PHONE_PLACEHOLDER' | translate}}\"\n        class=\"form-control ot-upcase-first\" ng-class=\"{'ot-input-error': (signupForm.$submitted || signupForm.cellPhone.$touched) && !signupForm.cellPhone.$valid}\" ng-model=\"vm.signupData.cellPhone\"></input>\n    </div>\n    <div class=\"ot-half-container ot-fix\">\n      <input type=\"text\" name=\"zipCode\" required\n        placeholder=\"{{'LOGIN.SIGN_UP_PARENT_ZIPCODE_PLACEHOLDER' | translate}}\"\n        class=\"form-control ot-upcase-first\" ng-class=\"{'ot-input-error': (signupForm.$submitted || signupForm.zipCode.$touched) && !signupForm.zipCode.$valid}\" ng-model=\"vm.signupData.zipCode\"></input>\n    </div>\n  </div>\n\n  <div class=\"row row-dropdown\">\n    <div class=\"ot-half-container ot-fix\">\n      <div class=\"ot-input-dropdown\"  uib-dropdown uib-keyboard-nav>\n        <input required type=\"hidden\" ng-model=\"vm.signupData.highSchoolSelected\" name=\"highSchool\"></input>\n        <button ng-class=\"{'ot-input-error': (signupForm.$submitted || signupForm.highSchool.$touched) && !signupForm.highSchool.$valid}\"\n         type=\"button\" id=\"highSchool\" class=\"btn btn-default form-control\" uib-dropdown-toggle>\n          <span ng-show=\"vm.signupData.highSchoolSelected == ''\" class=\"ot-left\">{{\"LOGIN.SIGN_UP_HIGH_SCHOOL_PLACEHOLDER\" | translate}}</span>\n          <span ng-show=\"vm.signupData.highSchoolSelected !== ''\" class=\"ot-left\">{{vm.signupData.highSchoolSelected}}</span>\n          <span class=\"ot-right caret\"></span>\n        </button>\n        <ul class=\"uib-dropdown-menu\" uib-dropdown-menu role=\"menu\">\n          <li role=\"menuitem\" ng-repeat=\"item in vm.highSchoolOptions\">\n            <a ng-click=\"vm.signupData.highSchoolSelected = item\" href=\"\">\n              {{item}}\n            </a>\n          </li>\n        </ul>\n      </div>\n    </div>\n    <div class=\"ot-half-container ot-fix\">\n      <div class=\"ot-input-dropdown\"  uib-dropdown uib-keyboard-nav>\n        <input required type=\"hidden\" ng-model=\"vm.signupData.genderSelected\" name=\"gender\"></input>\n        <button ng-class=\"{'ot-input-error': (signupForm.$submitted || signupForm.gender.$touched) && !signupForm.gender.$valid}\"\n        type=\"button\" id=\"gender\" class=\"btn btn-default form-control\" uib-dropdown-toggle>\n          <span ng-show=\"vm.signupData.genderSelected == ''\" class=\"ot-left\">{{\"LOGIN.SIGN_UP_GENDER_PLACEHOLDER\" | translate}}</span>\n          <span ng-show=\"vm.signupData.genderSelected !== ''\" class=\"ot-left\">{{vm.signupData.genderSelected}}</span>\n          <span class=\"ot-right caret\"></span>\n        </button>\n        <ul class=\"uib-dropdown-menu\" uib-dropdown-menu role=\"menu\">\n          <li role=\"menuitem\" ng-repeat=\"item in vm.genderOptions\">\n            <a ng-click=\"vm.signupData.genderSelected = item\" href=\"\">\n              {{item}}\n            </a>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"ot-half-container ot-fix\">\n      <p class=\"ot-error-message\" ng-show=\"(signupForm.$submitted || signupForm.newEmail.$touched) && !signupForm.newEmail.$valid\">{{'LOGIN.WRONG_EMAIL' | translate}}</p>\n      <p class=\"ot-error-message\" ng-show=\"vm.errorEmailAlreadyUsed\">{{'LOGIN.WRONG_EMAIL_ALREADY_TAKEN' | translate}}</p>\n      <p class=\"ot-error-message\" ng-show=\"vm.errorEmailNotValid\">{{'LOGIN.WRONG_EMAIL_NOT_VALID' | translate}}</p>\n      <input type=\"text\" name=\"newEmail\" required ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\"\n        placeholder=\"{{'LOGIN.SIGN_UP_EMAIL_PLACEHOLDER' | translate}}\"\n        ng-change=\"vm.errorEmailAlreadyUsed = false;vm.errorEmailNotValid = false\"\n        ng-class=\"{'ot-input-error': vm.errorEmailAlreadyUsed || vm.errorEmailNotValid || ((signupForm.$submitted || signupForm.newEmail.$touched) && !signupForm.newEmail.$valid)}\"\n        class=\"form-control ot-full-container\" ng-model=\"vm.signupData.newEmail\" autocomplete=\"off\"></input>\n    </div>\n    <div class=\"ot-half-container ot-fix\">\n      <div class=\"ot-input-dropdown\"  uib-dropdown uib-keyboard-nav>\n        <input required type=\"hidden\" ng-model=\"vm.signupData.bbyoMemberSelected\" name=\"bbyomember\"></input>\n        <button ng-class=\"{'ot-input-error': (signupForm.$submitted || signupForm.bbyomember.$touched) && !signupForm.bbyomember.$valid}\"\n        type=\"button\" id=\"memberbbyo\" class=\"btn btn-default form-control\" uib-dropdown-toggle>\n          <span ng-show=\"vm.signupData.bbyoMemberSelected == ''\" class=\"ot-left\">{{\"LOGIN.SIGN_UP_BBYO_MEMBER_PLACEHOLDER\" | translate}}</span>\n          <span ng-show=\"vm.signupData.bbyoMemberSelected !== ''\" class=\"ot-left\">{{vm.signupData.bbyoMemberSelected}}</span>\n          <span class=\"ot-right caret\"></span>\n        </button>\n        <ul class=\"uib-dropdown-menu\" uib-dropdown-menu role=\"menu\">\n          <li role=\"menuitem\" ng-repeat=\"item in vm.bbyoMemberOptions\">\n            <a ng-click=\"vm.signupData.bbyoMemberSelected = item\" href=\"\">\n              {{item}}\n            </a>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <p class=\"ot-error-message\" ng-show=\"vm.errorPasswordTooShort\">{{'LOGIN.WRONG_PASSWORD_TOO_SHORT' | translate}}</p>\n  </div>\n  <div class=\"row\">\n    <input type=\"password\" name=\"newPassword\"\n      placeholder=\"{{'LOGIN.SIGN_UP_PASSWORD_PLACEHOLDER' | translate}}\"\n      ng-change=\"vm.errorPasswordTooShort = false\"\n      ng-class=\"{'ot-input-error': vm.errorPasswordTooShort || ((signupForm.$submitted || signupForm.newPassword.$touched) && !signupForm.newPassword.$valid)}\"\n      ng-required=\"true\"\n      class=\"form-control ot-full-container\" ng-model=\"vm.signupData.newPassword\" autocomplete=\"off\"></input>\n  </div>\n  <div class=\"row\">\n    <ot-separator class=\"ot-second ot-active\" params=\"{type: 'horizontal', text: 'LOGIN.SIGN_UP_PARENT_DATA'}\"></ot-separator>\n  </div>\n  <div class=\"row\">\n    <div class=\"ot-half-container ot-fix\">\n      <input type=\"text\" name=\"parentFirstName\" required\n        placeholder=\"{{'LOGIN.SIGN_UP_PARENT_FIRSTNAME_PLACEHOLDER' | translate}}\"\n        class=\"form-control ot-upcase-first\" ng-class=\"{'ot-input-error': (signupForm.$submitted || signupForm.parentFirstName.$touched) && !signupForm.parentFirstName.$valid}\" ng-model=\"vm.signupData.parentFirstName\"></input>\n    </div>\n    <div class=\"ot-half-container ot-fix\">\n      <input type=\"text\" name=\"parentLastName\" required\n        placeholder=\"{{'LOGIN.SIGN_UP_PARENT_LASTNAME_PLACEHOLDER' | translate}}\"\n        class=\"form-control ot-upcase-first\" ng-class=\"{'ot-input-error': (signupForm.$submitted || signupForm.parentLastName.$touched) && !signupForm.parentLastName.$valid}\" ng-model=\"vm.signupData.parentLastName\"></input>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"ot-half-container ot-fix\">\n      <input type=\"text\" name=\"parentCellPhone\" required\n        placeholder=\"{{'LOGIN.SIGN_UP_PARENT_PHONE_PLACEHOLDER' | translate}}\"\n        class=\"form-control ot-upcase-first\" ng-class=\"{'ot-input-error': (signupForm.$submitted || signupForm.parentCellPhone.$touched) && !signupForm.parentCellPhone.$valid}\" ng-model=\"vm.signupData.parentCellPhone\"></input>\n    </div>\n    <div class=\"ot-half-container ot-fix\">\n      <p class=\"ot-error-message\" ng-show=\"(signupForm.$submitted || signupForm.parentNewEmail.$touched) && !signupForm.parentNewEmail.$valid\">{{'LOGIN.WRONG_EMAIL' | translate}}</p>\n      <p class=\"ot-error-message\" ng-show=\"vm.errorEmailAlreadyUsed\">{{'LOGIN.WRONG_EMAIL_ALREADY_TAKEN' | translate}}</p>\n      <p class=\"ot-error-message\" ng-show=\"vm.errorEmailNotValid\">{{'LOGIN.WRONG_EMAIL_NOT_VALID' | translate}}</p>\n      <input type=\"text\" name=\"parentNewEmail\" required ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\"\n        placeholder=\"{{'LOGIN.SIGN_UP_PARENT_EMAIL_PLACEHOLDER' | translate}}\"\n        ng-change=\"vm.errorEmailAlreadyUsed = false;vm.errorEmailNotValid = false\"\n        ng-class=\"{'ot-input-error': vm.errorEmailAlreadyUsed || vm.errorEmailNotValid || ((signupForm.$submitted || signupForm.newEmail.$touched) && !signupForm.newEmail.$valid)}\"\n        class=\"form-control ot-full-container\" ng-model=\"vm.signupData.parentNewEmail\" autocomplete=\"off\"></input>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <input type=\"submit\" class=\"btn btn-primary ot-full-container\" value=\"{{'LOGIN.EMAIL' | translate}}\"></input>\n  </div>\n<form>\n"

/***/ },
/* 282 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-facebook-login container-fluid\">\n  <div class=\"row\">\n    <button class=\"btn btn-primary ot-full-container\" ng-click=\"vm.loginWithFacebook()\"><span class=\"icon-facebook\"></span>{{\"LOGIN.FACEBOOK\" | translate}}</button>\n  </div>\n</div>\n"

/***/ },
/* 283 */
/***/ function(module, exports) {

	module.exports = "\n  <nav class=\"ot-footer navbar navbar-default\">\n        <ot-link-list class=\"navbar-bar navbar-left footer-left col-xs-12 ot-third-container\"></ot-link-list>\n        <ot-logo params=\"{type: 'footer'}\" class=\"navbar-bar navbar-left col-xs-6 ot-third-container\"></ot-logo>\n        <p ng-if=\"!vm.session.isOnward()\" class=\"ot-footer-contacts col-xs-6 ot-third-container\">{{\"FOOTER.QUESTIONS\" | translate}}<a href=\"mailto:debatenights2016@bbyo.org\">{{\"FOOTER.CONTACT_US\" | translate}}</a></p>\n\n  </nav>\n"

/***/ },
/* 284 */
/***/ function(module, exports) {

	module.exports = "<nav class=\"ot-header navbar navbar-default navbar-fixed-top\">\n  <div class=\"container-fluid\">\n    <!--\n    <ot-logo class=\"navbar-bar navbar-left\" params=\"{type: vm.getLogoType(), linkHome: true}\"></ot-logo>\n    -->\n    <ot-logo class=\"navbar-bar navbar-left hidden-md hidden-lg\" params=\"{type: 'emblem', linkHome: true}\"></ot-logo>\n    <ot-logo class=\"navbar-bar navbar-left hidden-xs hidden-sm\" params=\"{type: 'navbar', linkHome: true}\"></ot-logo>\n\n    <ot-link-list params=\"{type: 'header'}\" class=\"navbar-bar navbar-left hidden-xs\"></ot-link-list>\n\n\n    <ot-burger class=\"navbar-bar navbar-right hidden-sm hidden-md hidden-lg\"></ot-burger>\n\n    <ot-user-recap class=\"navbar-bar navbar-right\" ng-show=\"vm.session.isLogged()\"></ot-user-recap>\n    <!--ot-separator class=\"navbar-bar navbar-right\" ng-show=\"vm.session.isLogged()\"></ot-separator-->\n    <ot-indicator-list class=\"navbar-bar navbar-right\" ng-show=\"vm.session.isLogged()\"></ot-indicator-list>\n\n    <ot-loader class=\"navbar-bar navbar-right\" ng-show=\"vm.session.isLogging()\"></ot-loader>\n\n    <ot-hire class=\"navbar-bar navbar-right\" ng-show=\"vm.session.isNotLogging()\"></ot-hire>\n  </div>\n</nav>\n"

/***/ },
/* 285 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-hire\">\n<a ng-click=\"vm.openLoginModal('login')\"><span class=\"icon-login\"></span>\n  <span class=\"hidden-xs hidden-sm\">{{\"HEADER.LOGIN\" | translate}}</span>\n  <span class=\"hidden-md hidden-lg hidden-xl\">{{\"HEADER.SIGN_UP\" | translate}}</span>\n</a>\n<button class=\"btn btn-default hidden-xs hidden-sm\" ng-click=\"vm.openLoginModal('signup')\">\n  {{\"HEADER.SIGN_UP\" | translate}}\n</button>\n</div>\n"

/***/ },
/* 286 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-indicator\">\n  <div class=\"ot-icon\">\n    <span class=\"icon-notifications\"></span>\n    <span class=\"ot-notification badge\">{{item.notificationCount}}</span>\n  <div>\n</div>\n"

/***/ },
/* 287 */
/***/ function(module, exports) {

	module.exports = "<ul class=\"ot-indicator-list\">\n  <li ng-repeat=\"indicator in vm.indicatorList\">\n    <ot-indicator item=\"indicator\"></ot-indicator>\n  </li>\n</ul>\n"

/***/ },
/* 288 */
/***/ function(module, exports) {

	module.exports = "<a ng-href=\"{{item.linkUrl}}\" ng-if=\"!item.subLinkList\" ng-click=\"item.callback()\" ng-class=\"computeLinkCss()\" target=\"{{item.target}}\">{{item.label | translate}}</a>\n<span uib-dropdown>\n<a uib-dropdown-toggle ng-if=\"item.subLinkList\" ng-class=\"computeLinkCss()\">{{item.label | translate}}</a>\n  <ul class=\"uib-dropdown-menu ot-dropdown-menu\" uib-dropdown-menu aria-labelledby=\"simple-dropdown\">\n    <li ng-repeat=\"subItem in item.subLinkList\">\n      <a ng-href=\"#/landing/{{subItem.linkSection}}\" ng-click=\"$parent.item.callback(subItem.linkSection)\">{{subItem.label | translate}}</a>\n    </li>\n  </ul>\n</span>\n"

/***/ },
/* 289 */
/***/ function(module, exports) {

	module.exports = "<ul class=\"ot-link-list\">\n  <li ng-repeat=\"link in vm.linkList | link:vm.session\">\n    <a ng-show=\"link.label == 'LANDING.POWERED'\" ng-href=\"http://onetable.org\" ng-class=\"computeLinkCss()\" class=\"custom-powered\" target=\"_blank\">Powered by</a>\n    <ot-link ng-show=\"link.label != 'LANDING.POWERED'\" item=\"link\"></ot-link>\n  </li>\n</ul>\n"

/***/ },
/* 290 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-user-recap\">\n  <span uib-dropdown>\n    <ot-avatar params=\"{'dark': true, image: {'src': vm.session.getAvatar(), size: 'sm'},\n                        label: {'text': vm.session.getFirstName(), 'position': 'left', 'class': 'ot-username'},\n                        initials: {'first_name': vm.session.getFirstName(), 'last_name': vm.session.getLastName()}}\" uib-dropdown-toggle></ot-avatar>\n\n    <ul class=\"uib-dropdown-menu ot-dropdown-menu\" uib-dropdown-menu aria-labelledby=\"simple-dropdown\">\n      <li ng-repeat=\"menuItem in vm.menuItemList | menuItem:vm.session\">\n        <a ng-href=\"{{menuItem.linkUrl}}\" ng-click=\"menuItem.callback()\">{{menuItem.label | translate}}</a>\n      </li>\n    </ul>\n\n  </span>\n</div>\n"

/***/ },
/* 291 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-modal ot-burger-menu\">\n  <div>\n    <ot-link-list params=\"{type: 'header'}\"></ot-link-list>\n  </div>\n</div>\n"

/***/ },
/* 292 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-modal ot-change-password ot-simple-modal container-fluid\">\n  <div class=\"row\">\n    <div class=\"ot-close-login\" ng-click=\"$dismiss()\"></div>\n    <div class=\"ot-full-container\">\n      <ot-logo params=\"{type: 'vertical'}\"></ot-logo>\n      <h2>{{'CHANGE_PASSWORD.TITLE' | translate}}</h2>\n      <h3>\n        {{'CHANGE_PASSWORD.DESCRIPTION' | translate}}\n      </h3>\n    </div>\n    <form class=\"container-fluid\" name=\"changePasswordForm\" ng-submit=\"vm.submit(changePasswordForm)\" novalidate>\n      <div class=\"row\">\n        <div class=\"ot-full-container\">\n          <input type=\"password\" name=\"password\" required\n            placeholder=\"{{'CHANGE_PASSWORD.PASSWORD_PLACEHOLDER' | translate}}\"\n            class=\"form-control ot-first\"\n            ng-class=\"{'ot-input-error': changePasswordForm.password.$touched && !changePasswordForm.password.$valid}\"\n            ng-change=\"vm.resetError()\";\n            ng-model=\"vm.password\"></input>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"ot-full-container\">\n          <p class=\"ot-error-message\"\n            ng-if=\"vm.errorchangepwd\">\n              {{vm.errorchangepwd | translate}}\n          </p>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"ot-full-container\">\n          <p class=\"ot-error-message\"\n            ng-show=\"changePasswordForm.passwordConfirm.$touched && !changePasswordForm.passwordConfirm.$valid\">\n            {{'CHANGE_PASSWORD.WRONG_PASSWORD' | translate}}\n          </p>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"ot-full-container\">\n          <input type=\"password\" name=\"passwordConfirm\" ot-compare-to=\"vm.password\"  required\n            placeholder=\"{{'CHANGE_PASSWORD.PASSWORD_CONFIRM_PLACEHOLDER' | translate}}\"\n            class=\"form-control ot-full-container\"\n            ng-class=\"{'ot-input-error': changePasswordForm.passwordConfirm.$touched && !changePasswordForm.passwordConfirm.$valid}\"\n            ng-change=\"vm.resetError()\";\n            ng-model=\"vm.passwordConfirm\"></input>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"ot-full-container\">\n          <input type=\"submit\" class=\"btn btn-primary\" value=\"{{'CHANGE_PASSWORD.SUBMIT' | translate}}\"></input>\n        </div>\n      </div>\n\n    <form>\n  </div>\n</div>\n"

/***/ },
/* 293 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-modal ot-confirm ot-simple-modal container-fluid\" ng-class=\"vm.config.class\">\n  <div class=\"ot-close\" ng-click=\"$dismiss()\"></div>\n  <div class=\"row\">\n    <div class=\"ot-full-container\">\n      <ot-logo ng-if=\"vm.config.logo\" params=\"{type: 'vertical'}\"></ot-logo>\n      <h2>{{vm.config.title | translate}}</h2>\n      <h3>{{vm.config.title2 | translate}}</h3>\n      <h4>{{vm.config.title3 | translate}}</h4>\n    </div>\n    <div clas=\"row\" ng-repeat=\"action in vm.config.actions\" >\n      <div class=\"ot-full-container\">\n        <button class=\"btn\"\n          ng-class=\"{'btn-default': !action.primary, 'btn-primary': action.primary}\"\n          ng-click=\"action.callback()\">{{action.label | translate}}</button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ },
/* 294 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-modal ot-forgot ot-simple-modal container-fluid\">\n  <div class=\"ot-close\" ng-click=\"$dismiss()\"></div>\n  <div class=\"row\">\n    <div class=\"ot-full-container\">\n      <ot-logo params=\"{type: 'vertical'}\"></ot-logo>\n      <h2>{{'FORGOT.TITLE' | translate}}</h2>\n      <h3>\n        {{'FORGOT.DESCRIPTION' | translate}}\n      </h3>\n    </div>\n    <form class=\"container-fluid\" name=\"forgotForm\" ng-submit=\"vm.submit(forgotForm)\" novalidate>\n      <div class=\"row\">\n        <div class=\"ot-full-container\">\n          <p class=\"ot-error-message\"\n            ng-if=\"vm.erroremail\">\n              {{vm.erroremail | translate}}\n          </p>\n        </div>\n      </div>\n      <div class=\"row\">\n        <p class=\"ot-error-message ot-full-container\" ng-show=\"forgotForm.forgotEmail.$touched && !forgotForm.forgotEmail.$valid\">{{'FORGOT.WRONG_EMAIL' | translate}}</p>\n      </div>\n      <div class=\"row\">\n        <div class=\"ot-full-container\">\n          <input type=\"text\" name=\"forgotEmail\" required ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\"\n            placeholder=\"{{'FORGOT.EMAIL_PLACEHOLDER' | translate}}\"\n            class=\"form-control ot-full-container\" ng-class=\"{'ot-input-error': forgotForm.forgotEmail.$touched && !forgotForm.forgotEmail.$valid}\"\n            ng-change=\"vm.resetError()\"\n            ng-model=\"vm.email\"></input>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"ot-full-container\">\n          <input type=\"submit\" class=\"btn btn-primary\" value=\"{{'FORGOT.SUBMIT' | translate}}\"></input>\n        </div>\n      </div>\n\n\n      <div class=\"row\">\n        <p class=\"ot-full-container\">\n          <span>{{\"FORGOT.GO_BACK_TO\" | translate}}</span>\n          <a ng-click=\"vm.openLoginDialog('login')\">{{\"FORGOT.LOGIN\" | translate}}</a>\n          <span>{{\"FORGOT.OR\" | translate}}</span>\n          <a ng-click=\"vm.openLoginDialog('signup')\">{{\"FORGOT.SIGNUP\" | translate}}</a>\n        </p>\n      </div>\n    <form>\n  </div>\n</div>\n"

/***/ },
/* 295 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-modal ot-host-message container-fluid\">\n  <div class=\"ot-close\" ng-click=\"$dismiss()\"></div>\n  <div class=\"row\">\n    <div class=\"ot-full-container\">\n      <div class=\"row\">\n        <div class=\"ot-full-container\">\n          <ot-avatar params=\"{image: {'src': vm.hostData.avatar.m, size: 'md'}, initials: {'first_name': vm.hostData.first_name, 'last_name': vm.hostData.last_name}}\"></ot-avatar>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"ot-full-container\">\n          <h2>{{\"MANAGE.HOST_CONTACT\" | translate}} {{vm.hostData.first_name + \" \"+ vm.hostData.last_name}}</h2>\n        </div>\n    </div>\n    <div class=\"ot-third-container\"></div>\n    <div class=\"ot-third-container\">\n      <ot-separator class=\"ot-small\" params=\"{type: 'horizontal'}\"></ot-separator>\n    </div>\n    <div class=\"ot-third-container\"></div>\n    <!-- HOST MESSAGING -->\n\n    <div class=\"ot-invite-guests container-fluid\">\n\n      <form class=\"row\" name=\"hostMessageForm\" ng-submit=\"vm.sendMessage(hostMessageForm)\">\n        <div class=\"ot-full-container\">\n          <div>\n            <textarea placeholder=\"{{'MANAGE.DESCRIPTION_HOST_PLACEHOLDER' | translate}}\" class=\"form-control\" ng-model=\"vm.emailText\"></textarea>\n            <button class=\"btn btn-primary\" type=\"submit\">{{'MANAGE.HOST_MESSAGE_BUTTON' | translate}}</button>\n          </div>\n        </div>\n      </form>\n    </div>\n\n\n    </div>\n  </div>\n</div>\n"

/***/ },
/* 296 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-modal ot-login container-fluid\">\n  <p class=\"ot-half-background hidden-sm hidden-xs\"></p>\n  <div class=\"row\">\n    <div class=\"ot-close-login\" ng-click=\"$dismiss()\"></div>\n\n    <ot-logo params=\"{type: 'vertical'}\"></ot-logo>\n    <p ng-if=\"!vm.isOnward()\">\n      {{'LOGIN.DESCRIPTION' | translate}}\n    </p>\n    <p ng-if=\"!vm.isOnward()\">\n      {{'LOGIN.DESCRIPTION2' | translate}}\n    </p>\n    <p ng-if=\"!vm.isOnward()\">\n      {{'LOGIN.DESCRIPTION3' | translate}}\n    </p>\n    <div class=\"ot-full-container\">\n      <div class=\"ot-fake-tabs row\">\n        <button ng-click=\"vm.logIn = false; vm.signUp = true\"\n          ng-class=\"{'ot-active': !vm.logIn}\"\n          class=\"ot-half-container btn btn-default\">{{'LOGIN.SIGN_UP' | translate}}</button>\n        <button ng-click=\"vm.logIn = true\"\n          ng-class=\"{'ot-active': vm.logIn}\"\n          class=\"ot-half-container btn btn-default\">{{'LOGIN.LOG_IN' | translate}}</button>\n      </div>\n    </div>\n\n\n    <div class=\"ot-full-container\">\n      <ot-separator class=\"ot-first\" params=\"{type: 'horizontal'}\"></ot-separator>\n      <!--<ot-separator class=\"ot-first\" params=\"{type: 'horizontal'}\"></ot-separator>\n      <ot-facebook-login></ot-facebook-login>-->\n\n      <ot-email-login params=\"{modal: vm.currentModal}\" class=\"ng-hide\" ng-show=\"vm.logIn\"></ot-email-login>\n\n      <!--<ot-separator class=\"ot-second ot-active ng-hide\"\n        ng-show=\"!vm.logIn\" params=\"{type: 'horizontal', text: 'LOGIN.OR_SIGN_UP'}\"\n        ng-click=\"vm.signUp = !vm.signUp\"></ot-separator>-->\n    </div>\n    <div class=\"ot-full-container\">\n      <ot-email-signup class=\"ng-hide\" ng-show=\"!vm.logIn && vm.signUp\"></ot-email-signup>\n\n      <div class=\"ng-hide\" ng-show=\"!vm.logIn\">\n        <p class=\"ot-terms\">\n          <span>{{\"LOGIN.YOU_AGREE_TO\" | translate}}</span>\n          <a ng-href=\"{{vm.getTermsLink()}}\" target=\"_blank\">{{\"LOGIN.TERMS\" | translate}}</a>\n        </p>\n        <p class=\"ot-terms\">\n          <span>{{\"LOGIN.MESSAGE_LOCATION_1\" | translate}}</span>\n          <a ng-href=\"{{vm.getLocationLink()}}\" target=\"_blank\">{{\"LOGIN.MESSAGE_LOCATION_2\" | translate}}</a>\n          <span>{{\"LOGIN.MESSAGE_LOCATION_3\" | translate}}</span>\n        </p>\n      </div>\n    </div>\n    <div class=\"ot-half-container\">\n    </div>\n  </div>\n</div>\n"

/***/ },
/* 297 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-modal ot-manage-guests container-fluid\">\n  <div class=\"ot-close\" ng-click=\"$dismiss()\"></div>\n  <div class=\"row\">\n    <div class=\"ot-full-container\">\n\n      <div class=\"row\">\n        <div class=\"ot-full-container\">\n          <h2 ng-if=\"vm.isEventHosted()\">{{\"MANAGE.GUESTS_TITLE\" | translate}}</h2>\n          <h2 ng-if=\"!vm.isEventHosted()\">{{\"MANAGE.INVITE_FRIENDS\" | translate}}</h2>\n\n          <h3 ng-show=\"vm.isEventHosted()\">\n            <span>{{\"MANAGE.YOU_HAVE\" | translate}}</span>\n            <span class=\"ot-hilight\">{{\"MANAGE.X_PENDING\" | translate | sprintf:vm.getGuestsPending()}}</span>\n            <span>{{\"MANAGE.AND\" | translate}}</span>\n            <span class=\"ot-hilight\">{{\"MANAGE.X_ATTENDING\" | translate | sprintf:vm.getGuestsAccepted()}}</span>\n            <span>{{\"MANAGE.GUESTS\" | translate}}</span>\n          </h3>\n      </div>\n    </div>\n\n\n      <!-- RESERVATION LIST -->\n      <div class=\"row\" ng-show=\"vm.isEventHosted() && vm.getReservationList().length > 0\">\n        <div class=\"ot-full-container ot-reservation-list\">\n\n          <div class=\"row\" ng-repeat=\"reservation in vm.getReservationList()\">\n            <div class=\"ot-full-container ot-reservation-row\" ng-class=\"{'ot-first': $index == 0, 'ot-last': $index == vm.getReservationList().length -1}\">\n\n              <div>\n                <ot-avatar params=\"{image: {'src': reservation.profile.avatar.m, size: 'sm'}, initials: {'first_name': reservation.profile.first_name, 'last_name': reservation.profile.last_name}}\"></ot-avatar>\n\n                <div class=\"ot-data\">\n                  <h4>{{reservation.profile.first_name + ' ' + reservation.profile.last_name}}\n                    <a ng-if=\"!reservation.toggleSeats\" class=\"seats-link\" ng-click=\"reservation.toggleSeats=true; reservation.toggle=false\" ng-show=\"{{reservation.additional_guests.length!=0}}\" class=\"add_guests\">\n                       + {{reservation.additional_guests.length}} seats\n                    </a>\n                    <a ng-if=\"reservation.toggleSeats==true\" class=\"seats-link\" ng-click=\"reservation.toggleSeats=false; reservation.toggle=false\" ng-show=\"{{reservation.additional_guests.length!=0}}\" class=\"add_guests\">\n                       + {{reservation.additional_guests.length}} seats\n                    </a>\n                  </h4>\n                  <!--h5>{{reservation.profile.email || 'mia@mail.com'}}</h5-->\n                </div>\n\n                <div class=\"ot-approved\" ng-show=\"!reservation.toggle && reservation.confirmed_at > 0\">\n                  <span uib-dropdown-toggle><span>{{'MANAGE.APPROVED' | translate}}</span><span class=\"caret\"></span></span>\n                  <ul class=\"uib-dropdown-menu\" uib-dropdown-menu aria-labelledby=\"simple-dropdown\">\n                    <!-- TODO -->\n                    <li ng-repeat=\"actionItem in vm.actionList\">\n                      <a href ng-click=\"actionItem.callback()\">{{actionItem.label | translate}}</a>\n                    </li>\n                  </ul>\n                </div>\n\n                <div class=\"ot-action-link-box\" ng-show=\"reservation.state != 'accepted' && reservation.state != 'rejected'\">\n                  <a ng-click=\"reservation.toggle=true; reservation.toggleSeats=false\">{{\"MANAGE.ACTION_APPROVE\" | translate}}</a>\n                  <span>|</span>\n                  <a ng-click=\"$parent.vm.denyReservation(reservation.id)\">{{\"MANAGE.ACTION_DENY\" | translate}}</a>\n                </div>\n              </div>\n\n              <div class=\"ot-message-box\" ng-show=\"reservation.toggle\">\n                <p class=\"ot-error-message\" ng-show=\"$parent.vm.maxguestsError==2\">{{\"MANAGE.ERROR_MAX_GUESTS_NUM\" | translate}} {{$parent.vm.numberGuestsMax}}.</p>\n                <p class=\"ot-error-message\" ng-show=\"$parent.vm.maxguestsError==2\">{{\"MANAGE.ERROR_MAX_GUESTS\" | translate}}</p>\n\n                <textarea class=\"form-control\"  ng-class=\"{'ot-input-error': $parent.vm.maxguestsError==2}\"></textarea>\n                <div class=\"ot-action-link-box\" ng-model=\"$parent.vm.reservationMessage\">\n                  <a ng-click=\"reservation.toggle=false\">{{\"MANAGE.ACTION_CANCEL\" | translate}}</a>\n                  <span>|</span>\n                  <a  ng-click=\"$parent.vm.approveReservation(reservation.id)\">{{\"MANAGE.ACTION_APPROVE2\" | translate}}</a>\n                </div>\n              </div>\n              <!-- seats list -->\n              <div class=\"ot-full-container ot-reservation-list ot-message-box-addguests\" ng-show=\"reservation.toggleSeats\">\n                <div class=\"row\" ng-repeat=\"addedGuests in reservation.additional_guests\">\n                  <div class=\"ot-full-container ot-reservation-row ot-seats-raw\" ng-class=\"{'ot-first-seats': $index == 0, 'ot-last-seats': $index == reservation.additional_guests.length - 1}\">\n\n                    <div>\n                      <!--<ot-avatar params=\"{image: {'src': reservation.profile.avatar.m, size: 'sm'}, initials: {'first_name': 'Guest', 'last_name': 'Seats'}}\"></ot-avatar>-->\n                      <div class=\"ot-data\">\n                        <h4>{{addedGuests.name}}  </h4>\n                        <h5><a href=\"mailto:{{addedGuests.email}}\">{{addedGuests.email}}</a></h5>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <!---->\n            </div>\n          </div>\n\n        </div>\n      </div>\n\n      <!-- INVITE GUESTS -->\n\n      <div class=\"row\">\n        <ot-invite-guests class=\"ot-full-container\" params=\"{onSuccessCallback: $dismiss}\"></ot-invite-guests>\n      </div>\n\n\n\n      <!-- SOCIAL SHARE -->\n\n      <div class=\"row\">\n        <ot-social-share class=\"ot-full-container\" params=\"{item: vm.session.getData().event}\"></ot-social-share>\n      </div>\n\n    </div>\n  </div>\n</div>\n"

/***/ },
/* 298 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-modal ot-confirm ot-rsvp-modal container-fluid\"> <!-- there is already a directive called ot-rsvp -->\n  <div class=\"ot-close\" ng-click=\"$dismiss()\"></div>\n  <div class=\"row\">\n    <div class=\"ot-half-container\">\n      <ot-banner params=\"{'src': vm.session.getData().event.cover.l}\"></ot-banner>\n    </div>\n    <div class=\"ot-half-container\">\n      <h4>\n        <span class=\"ot-higlight-name\">{{vm.session.getData().event.created_by_profile.first_name}}</span>\n        <span>{{\"RSVP.IS_HOSTING\" | translate}}</span>\n      </h4>\n      <h3>{{vm.session.getData().event.title}}</h3>\n      <ot-info params=\"{event: vm.session.getData().event, type:'horizontal'}\"></ot-info>\n      <ot-separator class=\"ot-small\" params=\"{type: 'horizontal'}\"></ot-separator>\n      <p class=\"ot-mini-cost\">\n        <span class=\"ot-price\" ng-if=\"vm.session.getData().event.price_per_person<=0\">{{'EVENT.COST_FREE' | translate}}</span>\n        <span class=\"ot-price\" ng-if=\"vm.session.getData().event.price_per_person>0\">{{(vm.session.getData().event.price_per_person / 100) | currency:\"$\"}}</span>\n      </p>\n\n      <!--<p class=\"ot-error-message\" ng-if=\"vm.seatsAvailable\">{{vm.seatsAvailable}}{{'EVENT.MAX_SEATS' | translate}}</p>\n\n      <p class=\"ot-seat-counter btn-group\">\n        <button class=\"btn btn-default\" ng-click=\"vm.removeSeat()\"><span class=\"glyphicon glyphicon-chevron-down\"></span></button>\n        <span>{{\"RSVP.X_SEATS\" | translate | sprintf:vm.reservationData.seats}}</span>\n        <button ng-disabled=\"vm.seatsAvailable\" class=\"btn btn-default\" ng-click=\"vm.addSeat(vm.maxSeats-vm.acceptedSeats)\"><span class=\"glyphicon glyphicon-chevron-up\"></span></button>\n      </p>-->\n\n      <button class=\"btn btn-primary\" ng-click=\"vm.openRsvpGuestsModal()\">{{\"RSVP.SUBMIT\" | translate}}</button>\n\n      <p class=\"ot-manual-approval-warning\" ng-show=\"vm.session.getData().event.event_type == 'manual_approval'\">{{\"RSVP.MANUAL_APPROVAL_WARNING\" | translate}}</p>\n    </div>\n  </div>\n</div>\n"

/***/ },
/* 299 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-modal ot-rsvp-guests-modal container-fluid\"> <!-- there is already a directive called ot-rsvp -->\n  <div class=\"ot-close\" ng-click=\"$dismiss()\"></div>\n  <div class=\"row\">\n    <div class=\"ot-full-container\">\n      <h2>{{\"RSVP.REGISTER_GUESTS_TITLE\" | translate}}</h2>\n      <h3>{{\"RSVP.REGISTER_GUESTS_DESCRIPTION\" | translate}}</h3>\n\n      <p class=\"ot-error-message\" ng-if=\"vm.seatsAvailable\">{{'EVENT.MAX_SEATS' | translate}}{{vm.seatsAvailable}}</p>\n\n      <p class=\"ot-seat-counter btn-group\">\n        <button class=\"btn btn-default\" ng-click=\"vm.removeSeat()\"><span class=\"glyphicon glyphicon-chevron-down\"></span></button>\n        <span>{{\"RSVP.X_GUESTS\" | translate | sprintf:(vm.reservationData.seats)}}</span>\n        <button class=\"btn btn-default\" ng-disabled=\"vm.seatsAvailable\" ng-click=\"vm.addSeat(vm.maxSeats-vm.acceptedSeats)\"><span class=\"glyphicon glyphicon-chevron-up\"></span></button>\n      </p>\n\n      <form class=\"container-fluid\" name=\"guestsForm\" ng-submit=\"vm.openRsvpPaymentModal(guestsForm)\" novalidate>\n\n        <div class=\"container-fluid rf-small\">\n          <div class=\"row\">\n            <div class=\"ot-full-container ot-row\">\n              <input type=\"text\" ng-disabled=\"true\" class=\"form-control ot-rounded\" value=\"{{'RSVP.YOU' | translate}}\"></input>\n            </div>\n          </div>\n\n\n          <div class=\"row\" ng-repeat=\"credential in vm.reservationData.credentials\">\n            <div class=\"ot-full-container ot-row\">\n              <div ng-class=\"{'has-error': (guestsForm.$submitted || guestsForm['name' + $index].$touched) && !guestsForm['name' + $index].$valid}\">\n                <input\n                  ng-required=\"true\"\n                  name=\"{{'name' + $index}}\"\n                  ng-model=\"credential.name\"\n                  type=\"text\"\n                  class=\"form-control\"\n                  placeholder=\"{{'RSVP.FULL_NAME_OF_GUEST_X' | translate | sprintf:($index + 1)}}\"></input>\n              </div>\n            <div ng-class=\"{'has-error': (guestsForm.$submitted || guestsForm['email' + $index].$touched) && !guestsForm['email' + $index].$valid}\">\n              <input\n                ng-required=\"true\"\n                name=\"{{'email' + $index}}\"\n                ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\"\n                ng-model=\"credential.email\"\n                type=\"text\"\n                class=\"form-control\"\n                placeholder=\"{{'RSVP.EMAIL' | translate}}\"></input>\n              </div>\n            </div>\n          </div>\n        </div>\n\n\n        <div class=\"container-fluid\">\n          <div class=\"row\">\n            <ot-separator params=\"{type: 'horizontal'}\"></ot-separator>\n            <div class=\"ot-actions\">\n              <input type=\"reset\" class=\"btn btn-default\" value=\"{{'RSVP.BACK' | translate}}\" ng-click=\"vm.openRsvpModal()\"></input>\n              <input type=\"submit\" class=\"btn btn-primary\" value=\"{{'RSVP.NEXT' | translate}}\"></input>\n            </div>\n          </div>\n        </div>\n\n      </form>\n\n    </div>\n  </div>\n</div>\n"

/***/ },
/* 300 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-modal ot-rsvp-payment-modal container-fluid\"> <!-- there is already a directive called ot-rsvp -->\n\n  <h2>{{\"RSVP.PAYMENT_TITLE\" | translate}}</h2>\n  <h3 ng-show=\"vm.isManualApproval()\">{{\"RSVP.PAYMENT_SUBTITLE\" | translate}}</h3>\n\n  <form name=\"paymentForm\" ng-submit=\"vm.submitPayment(paymentForm)\" novalidate>\n\n    <div class=\"row\">\n      <div class=\"ot-half-container\">\n\n        <div class=\"row ot-first\">\n          <div class=\"ot-twothirds-container\">\n            <label class=\"coupon-label\">{{'RSVP.CARD_PAY_TITLE' | translate}}</label>\n          </div>\n          <div class=\"ot-third-container\">\n              <div ng-show=\"vm.showParam === 'showList' || vm.showParam === 'hide'\" style=\"padding: 0px;\" ng-click=\"vm.openListCard(vm.showParam)\" class=\"btn btn-primary change-button\">\n                {{'PROFILE.CARD_CLOSE_BUTTON' | translate}} <span class=\"close-button-icon\">x</span>\n              </div>\n          </div>\n        </div>\n\n        <!--CARD DATA-->\n        <!--<div ng-class=\"{'showcard': !vm.checkCard , 'hidecard': vm.checkCard}\">-->\n        <div ng-class=\"{'card-list-box': vm.showParam === 'showList' || vm.showParam === 'showSingle','card-list-box-height': vm.showParam === 'hide' || !vm.checkCard}\">\n          <div class=\"row ot-first\">\n            <div class=\"ot-full-container\">\n              <label for=\"card-name-{{$id}}\">{{'RSVP.CARD_NAME_LABEL' | translate}}</label>\n              <input type=\"text\" required class=\"form-control\" id=\"card-name-{{$id}}\" name=\"cardName\"\n                placeholder=\"{{'RSVP.CARD_NAME_PLACEHOLDER' | translate}}\"\n                ng-class=\"{'ot-input-error': (paymentForm.$submitted || paymentForm.cardName.$touched) && !paymentForm.cardName.$valid}\"\n                ng-model=\"vm.cardData.cardName\">\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"ot-full-container\">\n              <div class=\"row ot-card-general-row\">\n                <div class=\"ot-quarter-container\">\n                  <label for=\"card-number-{{$id}}\">{{'RSVP.CARD_DETAILS_LABEL' | translate}}</label>\n                </div>\n                <div class=\"ot-threequarter-container\">\n                  <label>\n                    <input type=\"text\" required class=\"form-control\" id=\"card-number-{{$id}}\" name=\"cardNumber\"\n                      placeholder=\"{{'RSVP.CARD_NUMBER_PLACEHOLDER' | translate}}\"\n                      ng-class=\"{'ot-input-error': (paymentForm.$submitted || paymentForm.cardNumber.$touched) && !paymentForm.cardNumber.$valid}\"\n                      ng-model=\"vm.cardData.cardNumber\">\n                  </label>\n                </div>\n              </div>\n            </div>\n            <div class=\"ot-full-container\">\n              <div class=\"row ot-card-info-group\">\n                <div class=\"ot-quarter-container\">\n                  <label for=\"card-number-{{$id}}\">Expiration</label>\n                </div>\n                <div class=\"ot-threequarter-container\">\n                  <label>\n                    <input type=\"text\" required class=\"form-control\" id=\"card-month-{{$id}}\" name=\"cardMonth\"\n                      placeholder=\"{{'RSVP.CARD_MONTH_PLACEHOLDER' | translate}}\"\n                      ng-class=\"{'ot-input-error': (paymentForm.$submitted || paymentForm.cardMonth.$touched) && !paymentForm.cardMonth.$valid}\"\n                      ng-model=\"vm.cardData.cardMonth\">\n                    <input style=\"position: relative;left: -3px;\" type=\"text\" required class=\"form-control\" id=\"card-year-{{$id}}\" name=\"cardYear\"\n                      placeholder=\"{{'RSVP.CARD_YEAR_PLACEHOLDER' | translate}}\"\n                      ng-class=\"{'ot-input-error': (paymentForm.$submitted || paymentForm.cardYear.$touched) && !paymentForm.cardYear.$valid}\"\n                      ng-model=\"vm.cardData.cardYear\">\n                  </label>\n                </div>\n              </div>\n              <div class=\"row ot-card-info-group\">\n                <div class=\"ot-quarter-container\">\n                    <label for=\"card-number-{{$id}}\">{{'PROFILE.CARD_CVV' | translate}}</label>\n                </div>\n                <div class=\"ot-quarter-container\">\n                  <label>\n                    <input style=\"width:100%\" type=\"text\" required class=\"form-control\" id=\"card-cvc-{{$id}}\" name=\"cardCvc\"\n                      placeholder=\"{{'RSVP.CARD_CVC_PLACEHOLDER' | translate}}\"\n                      ng-class=\"{'ot-input-error': (paymentForm.$submitted || paymentForm.cardCvc.$touched) && !paymentForm.cardCvc.$valid}\"\n                      ng-model=\"vm.cardData.cardCvc\">\n                  </label>\n                </div>\n                <!--<div class=\"ot-full-container ot-card-info-group\">\n                  <input type=\"text\" required class=\"form-control\" id=\"card-month-{{$id}}\" name=\"cardMonth\"\n                    placeholder=\"{{'RSVP.CARD_MONTH_PLACEHOLDER' | translate}}\"\n                    ng-class=\"{'ot-input-error': (paymentForm.$submitted || paymentForm.cardMonth.$touched) && !paymentForm.cardMonth.$valid}\"\n                    ng-model=\"vm.cardData.cardMonth\">\n                  <input type=\"text\" required class=\"form-control\" id=\"card-year-{{$id}}\" name=\"cardYear\"\n                    placeholder=\"{{'RSVP.CARD_YEAR_PLACEHOLDER' | translate}}\"\n                    ng-class=\"{'ot-input-error': (paymentForm.$submitted || paymentForm.cardYear.$touched) && !paymentForm.cardYear.$valid}\"\n                    ng-model=\"vm.cardData.cardYear\">\n                  <input type=\"text\" required class=\"form-control\" id=\"card-cvc-{{$id}}\" name=\"cardCvc\"\n                    placeholder=\"{{'RSVP.CARD_CVC_PLACEHOLDER' | translate}}\"\n                    ng-class=\"{'ot-input-error': (paymentForm.$submitted || paymentForm.cardCvc.$touched) && !paymentForm.cardCvc.$valid}\"\n                    ng-model=\"vm.cardData.cardCvc\">\n                </div>-->\n                <div class=\"ot-half-container\" style=\"text-align:left\">\n                  <label>\n                    <div class=\"ot-quarter-container\" style=\"width:10% !important\">\n                      <input style=\"width:1.5em;margin-top: 15px;\" type=\"checkbox\" ng-model=\"vm.cardData.cardFavourite\"></input>\n                    </div>\n                    <div class=\"ot-threequarter-container\" style=\"width:90% !important;padding:0px;\">\n                      <div class=\"use-default\">{{'PROFILE.CARD_USE_DEFAULT' | translate}}</div>\n                    </div>\n                  </label>\n                </div>\n                <!--<div class=\"ot-full-container\">\n                  <div ng-click=\"vm.changeCard('hide')\" class=\"btn btn-primary change-button\">{{'PROFILE.CARD_VIEW_LIST_BUTTON' | translate}}</div>\n                </div>-->\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <!--SINGLE CARD-->\n\n        <div ng-class=\"{'card-list-box-height': vm.showParam === 'showSingle','card-list-box': vm.showParam === 'showList' || vm.showParam === 'hide'}\">\n          <input type=\"hidden\" name=\"cardId\" ng-model=\"vm.cardId\"></input>\n          <div ng-repeat=\"card in vm.cardList\" ng-show=\"vm.cardList.length > 0 && card.favourite\" class=\"ot-list-credit-card\">\n            <div class=\"row mobile-row\">\n              <div class=\"ot-quarter-container-payments\" style=\"width:auto\">\n                <label>\n                  <!--<img class=\"credit-card-icon\" src=\"/assets/credit-card.jpg\"/>-->\n                  <img class=\"credit-card-icon\" ng-src=\"{{card.image}}\"/>\n                </label>\n              </div>\n              <div class=\"ot-half-container-payments\" style=\"padding:0px\">\n                <label>\n                  <span>{{card.brand}}</span><br/>\n                  **** **** **** {{card.number}}<br/>\n                  <span class=\"sub-label\" ng-show=\"card.favourite\">{{'PROFILE.CARD_DEFAULT' | translate}}</span>\n                </label>\n              </div>\n              <div class=\"ot-quarter-container-payments\" style=\"padding: 0px;\">\n                  <div ng-show=\"vm.showParam === 'showSingle'\" style=\"margin-top: 5px;\" ng-click=\"vm.openListCard(vm.showParam)\" class=\"btn btn-primary change-button\">{{'PROFILE.CARD_CHANGE_BUTTON' | translate}}</div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <!--CARD LIST-->\n\n        <div ng-class=\"{'card-list-box-height': vm.showParam === 'showList','card-list-box': vm.showParam === 'showSingle' || vm.showParam === 'hide'}\">\n          <div class=\"row\">\n            <div class=\"ot-twothirds-container\">\n              <label><span class=\"title-list-card\">{{'PROFILE.CARD_YOUR' | translate}}</span></label>\n            </div>\n            <div class=\"ot-third-container\" style=\"text-align: right\">\n              <label><span class=\"expire-list-card\">{{'PROFILE.CARD_EXPIRE' | translate}}</span></label>\n            </div>\n          </div>\n\n          <input type=\"hidden\" name=\"cardId\" ng-model=\"vm.cardId\"></input>\n          <div ng-repeat=\"card in vm.cardList\" ng-show=\"vm.cardList.length > 0\" class=\"ot-list-credit-card\">\n            <div class=\"row list-row\" ng-class=\"{'selected-card': card.favourite}\">\n              <div class=\"ot-quarter-container-payments\">\n                <label>\n                  <div style=\"padding: 0px\" class=\"radio-div\">\n                     <input id=\"card-{{card.id}}\" class=\"radio-card\" type=\"radio\" ng-model=\"vm.cardSelected.id\" value=\"{{card.id}}\">\n                     <img class=\"credit-card-icon\" ng-src=\"{{card.image}}\"/>\n                     <span ng-class=\"{'radiocard': vm.cardSelected.id == card.id}\"></span>\n                  </div>\n                </label>\n              </div>\n              <div class=\"ot-half-container-payments brand-list-card\">\n                <label>\n                  <span>{{card.brand}}</span><br/>\n                  **** **** **** {{card.number}}<br/>\n                  <span class=\"sub-label\" ng-show=\"card.favourite\">{{'PROFILE.CARD_DEFAULT' | translate}}</span>\n                </label>\n              </div>\n              <div class=\"ot-quarter-container-payments\" style=\"text-align: center\">\n                <label>{{card.expiration}}</label>\n              </div>\n              <!--<div class=\"ot-full-container\">\n                <input type=\"text\" readonly class=\"form-control\" id=\"card-number-{{$id}}\" name=\"cardNumber\"\n                  placeholder=\"{{'PROFILE.CARDLIST_NUMBER_PLACEHOLDER' | translate}}\"\n                  ng-class=\"{'ot-input-error': (profileForm.$submitted || profileForm.cardNumber.$touched) && !profileForm.cardNumber.$valid}\"\n                  ng-value=\"'**** **** **** ' + card.number\">\n              </div>-->\n            </div>\n          </div>\n          <input type=\"hidden\" name=\"selectedCard\" ng-model=\"vm.cardSelected.id\" ng-value=\"vm.cardSelected.id\">\n          <div class=\"row list-row\">\n            <div class=\"ot-quarter-container-payments\">\n              <label>\n                <div style=\"padding: 0px\">\n                  <span class=\"add-card-icon\">+</span>\n                  <img class=\"credit-card-icon\" src=\"/assets/credit-card.jpg\"/>\n                </div>\n              </label>\n            </div>\n            <div class=\"ot-twothirds-container\" style=\"float: right\">\n              <label ng-click=\"vm.changeCard('show')\" class=\"btn btn-primary change-button\" style=\"padding: 5px 0px 6px\">\n                {{'PROFILE.CARD_NEW_BUTTON' | translate}}\n              </label>\n            </div>\n          </div>\n        </div>\n\n        <!--<div class=\"ot-half-container\">\n          <div ng-click=\"vm.changeCard('show')\" class=\"btn btn-primary change-button\">{{'PROFILE.CARD_NEW_BUTTON' | translate}}</div>\n        </div>-->\n\n\n        <!--COUPON-->\n\n        <div class=\"row ot-card-general-row\">\n          <div class=\"ot-full-container\">\n            <ot-separator params=\"{'type': 'horizontal'}\"></ot-separator>\n            <label class=\"coupon-label\">{{'RSVP.CARD_COUPON_TITLE' | translate}}</label>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"ot-full-container\">\n            <label>{{'RSVP.CARD_COUPON_LABEL' | translate}}</label>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"ot-twothirds-container\">\n            <input type=\"text\" class=\"form-control\" id=\"coupon-number\" name=\"couponNumber\"\n              placeholder=\"{{'RSVP.CARD_COUPON_LABEL' | translate}}\"\n              ng-model=\"vm.couponNumber\"\n              ng-change=\"vm.changeCouponCheck()\">\n          </div>\n          <div class=\"ot-third-container\">\n            <div ng-click=\"vm.verifyCoupon()\" class=\"btn btn-primary coupon-button\">{{'RSVP.CARD_COUPON_APPLY' | translate}}</div>\n          </div>\n        </div>\n\n      </div>\n\n\n      <div class=\"ot-half-container\">\n\n        <div class=\"row\">\n          <div class=\"ot-full-container\">\n\n            <ot-banner params=\"{'src': vm.session.getData().event.cover.m}\"></ot-banner>\n            <div class=\"ot-right\">\n              <h3>{{vm.session.getData().event.title}}</h3>\n              <ot-info params=\"{event: vm.session.getData().event}\"></ot-info>\n            </div>\n\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"ot-full-container\">\n\n            <ot-separator params=\"{'type': 'horizontal'}\"></ot-separator>\n\n            <!-- total cost -->\n            <p class=\"ot-data-row\">\n              <span>\n                <span>{{\"RSVP.X_SEATS_AT_Y\" | translate | sprintf:vm.reservationData.seats:(\"$\" + vm.session.getData().event.price_per_person/100)}}</span>\n                <a>{{\"RSVP.CHANGE\" | translate}}</a>\n              </span>\n              <span>{{\"$\" + (vm.reservationData.seats * vm.session.getData().event.price_per_person/100)}}</span>\n            </p>\n\n            <!-- fees -->\n            <p class=\"ot-data-row\">\n              <span>{{\"RSVP.FEES\" | translate}}</span>\n              <span>{{\"$\" + vm.reservationData.fees}}</span>\n            </p>\n\n            <!-- coupon -->\n            <p ng-show=\"vm.couponCheck\" class=\"ot-data-row\">\n              <span>{{\"RSVP.COUPON\" | translate}}</span>\n              <span class=\"data-coupon\">- {{vm.couponType + \" \" + vm.couponAmount}}</span>\n            </p>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"ot-full-container\">\n\n            <ot-separator params=\"{'type': 'horizontal'}\"></ot-separator>\n\n            <p class=\"ot-data-row\"> <!-- total -->\n              <span>{{\"RSVP.TOTAL\" | translate}}</span>\n              <span>{{\"$\" + vm.totalAmount}}</span>\n            </p>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"ot-full-container\">\n\n            <input type=\"submit\" class=\"btn btn-primary\" value=\"{{'RSVP.PAYMENT_SUBMIT' | translate}}\" ng-disabled=\"vm.isPaying\"></input>\n          </div>\n        </div>\n\n\n        <div class=\"row\">\n          <div class=\"ot-full-container\">\n            <p class=\"ot-terms\">\n              <span>{{\"RSVP.YOU_AGREE_TO\" | translate}}</span>\n              <a ng-href=\"{{vm.getTermsLink()}}\" target=\"_blank\">{{\"RSVP.TERMS\" | translate}}</a>\n              <span>{{\"RSVP.AND\" | translate}}</span>\n              <a>{{\"RSVP.CANCELLATION_POLICY\" | translate}}</a>\n            </p>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ },
/* 301 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-modal ot-forgot container-fluid\">\n  <div class=\"ot-close\" ng-click=\"$dismiss()\"></div>\n  <div class=\"row\">\n    <div class=\"ot-full-container ot-modal-success\">\n      <h2>{{\"SUCCESS.TITLE\" | translate}}</h2>\n\n      <!--<p ng-if=\"vm.session.getData().event.event_type == 'public'\">{{\"SUCCESS.SUBTITLE_PUBLIC\" | translate}}</p>\n      <p ng-if=\"vm.session.getData().event.event_type == 'manual_approval'\">{{\"SUCCESS.SUBTITLE_MANUAL\" | translate}}</p>\n      <p ng-if=\"vm.session.getData().event.event_type == 'private'\">{{\"SUCCESS.SUBTITLE_PRIVATE\" | translate}}</p>\n\n      <ot-separator class=\"ot-small\" params=\"{type: 'horizontal'}\"></ot-separator>\n      <ot-invite-guests params=\"{onSuccessCallback: $dismiss}\"></ot-invite-guests>\n      <ot-social-share params=\"{item: 'vm.session.getData().event'}\"></ot-social-share>-->\n    </div>\n  </div>\n</div>\n"

/***/ },
/* 302 */
/***/ function(module, exports) {

	module.exports = "<div class=\"ot-modal ot-welcome ot-simple-modal container-fluid\">\n  <div class=\"ot-close\" ng-click=\"$dismiss()\"></div>\n  <div class=\"row\">\n    <div class=\"ot-full-container\">\n      <ot-logo params=\"{type: 'vertical'}\"></ot-logo>\n      <h2>{{'WELCOME.TITLE' | translate}}</h2>\n      <p>\n        {{'WELCOME.DESCRIPTION' | translate}}\n      </p>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"ot-full-container\">\n      <button class=\"btn btn-primary\" ng-click=\"$dismiss()\">{{'WELCOME.BROWSE' | translate}}</button>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"ot-full-container\">\n      <button class=\"btn btn-default\" ng-click=\"vm.becomeHost($dismiss)\">{{'WELCOME.BECOME_HOST' | translate}}</button>\n    </div>\n  </div>\n</div>\n"

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(185);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/postcss-loader/index.js!./angular-socialshare.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/postcss-loader/index.js!./angular-socialshare.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(186);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./angular-ui-notification.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./angular-ui-notification.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(187);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/postcss-loader/index.js!./ng-tags-input.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/postcss-loader/index.js!./ng-tags-input.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(188);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./editor.min.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./editor.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(189);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/postcss-loader/index.js!./../../node_modules/less-loader/index.js!./angular-socialshare.less", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/postcss-loader/index.js!./../../node_modules/less-loader/index.js!./angular-socialshare.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(190);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/postcss-loader/index.js!./../../node_modules/sass-loader/index.js!./main.scss", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/postcss-loader/index.js!./../../node_modules/sass-loader/index.js!./main.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(191);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/postcss-loader/index.js!./static.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/postcss-loader/index.js!./static.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    var AccessRouteController = (function () {
	        function AccessRouteController($routeParams) {
	            switch ($routeParams.which) {
	                case "401":
	                    this.type = "401";
	                    this.title = "ACCESS_ROUTE.ERROR_401";
	                    break;
	                case "403":
	                    this.type = "403";
	                    this.title = "ACCESS_ROUTE.ERROR_403";
	                    break;
	                case "404":
	                    this.type = "404";
	                    this.title = "ACCESS_ROUTE.ERROR_404";
	                    break;
	                default:
	                    this.type = "400";
	                    this.title = "ACCESS_ROUTE.ERROR_400";
	            }
	        }
	        AccessRouteController.$inject = ["$routeParams"];
	        return AccessRouteController;
	    })();
	    exports.AccessRouteController = AccessRouteController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, config_1) {
	    var ControlPanelController = (function () {
	        function ControlPanelController($routeParams, session, $location, $modal, $rootScope, $document) {
	            this.location = $location;
	            window.location.href = config_1.Config.controlPanelEndpoint;
	        }
	        ControlPanelController.$inject = ["$routeParams", "session", "$location", "$uibModal", "$rootScope", "$document"];
	        return ControlPanelController;
	    })();
	    exports.ControlPanelController = ControlPanelController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(13), __webpack_require__(19), __webpack_require__(3), __webpack_require__(20), __webpack_require__(8), __webpack_require__(365), __webpack_require__(9), __webpack_require__(363), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, angular, $, _, config_1, session_1, data_1, success_1, login_1, hostMessage_1, TPL) {
	    var EventController = (function () {
	        function EventController($routeParams, session, $location, $modal, $rootScope, $document, filter, notification, $scope, $timeout, $sce, $log) {
	            var _this = this;
	            this.hstep = 1;
	            this.mstep = 15;
	            this.minEventDate = new Date();
	            this.maxEventDate = null;
	            this.eventTypeOptions = [
	                data_1.EventType.PUBLIC,
	                data_1.EventType.MANUAL,
	                data_1.EventType.PRIVATE
	            ];
	            this.editorConfig = {
	                sanitize: true,
	                toolbar: [
	                    { name: 'doers', items: ['undo', 'redo', '-'] },
	                ]
	            };
	            window["EVENTCONTROLLER"] = this;
	            this.eventId = $routeParams.id;
	            this.session = session;
	            this.rootScope = $rootScope;
	            this.location = $location;
	            this.modal = $modal;
	            this.filter = filter;
	            this.notification = notification;
	            this.sce = $sce;
	            this.log = $log;
	            var cities = this.session.getAvailableCities();
	            cities.splice(0, 1);
	            this.availableCities = cities;
	            this.availableDates = [
	                { id: "3", date: new Date(2016, 9, 19, 19, 0, 0, 0), label: "10/19/2016" }
	            ];
	            this.dateLabel;
	            this.myReservations = this.session.loadMyReservations();
	            this.guestsCount = 1;
	            this.rootScope.$on("share_done", function () {
	                if (_this.currentSuccessModal != null) {
	                    _this.currentSuccessModal.dismiss();
	                }
	            });
	            this.imagePromise = $timeout(false);
	            if (this.session.isLogged()) {
	                this.session.loadTimezones().then(function (response) {
	                    _this.timeZones = _this.parseTimezones(response);
	                });
	            }
	            if (this.eventId) {
	                var currentPath = $location.path();
	                if (this.endsWith(currentPath, "edit")) {
	                    this.mode = "edit";
	                }
	                else if (this.endsWith(currentPath, "nourished")) {
	                    this.mode = "nourished";
	                }
	                else if (this.endsWith(currentPath, "guests")) {
	                    this.mode = "guests";
	                }
	                else {
	                    this.mode = "view";
	                }
	                this.session.loadEvent(this.eventId).then(function (eventResponse) {
	                    _this.session.loadSuggestedEvents();
	                    _this.currentData = {
	                        event: eventResponse
	                    };
	                    if (_this.mode == "edit" || _this.mode == "guests") {
	                        if (eventResponse.created_by_profile.id != _this.session.getUserId()) {
	                            _this.goLanding();
	                        }
	                    }
	                    try {
	                        _this.currentData.event.area = {};
	                        _this.currentData.event.area.city = _.find(_this.availableCities, { code: eventResponse.area_code });
	                        _this.currentData.event.area.neighborhood = _.find(_this.currentData.event.area.city.neighborhoods, { code: eventResponse.neighborhood_code });
	                        var shortime = eventResponse.timezone.split(" - ");
	                        _this.currentData.event.timezone = {
	                            id: eventResponse.timezone,
	                            label: shortime[0]
	                        };
	                    }
	                    catch (e) {
	                        _this.log.debug(e);
	                    }
	                    _this.currentData.event.name = eventResponse.title;
	                    _this.currentData.event.maxseats = eventResponse.number_of_guests_max;
	                    var dateBegin = session_1.SessionService.toDate(eventResponse.event_date, true);
	                    var hrsMins = eventResponse.event_time.split(":");
	                    dateBegin.setHours(parseInt(hrsMins[0]));
	                    dateBegin.setMinutes(parseInt(hrsMins[1]));
	                    _this.currentData.event.begin = dateBegin;
	                    var dateEnd = new Date(dateBegin.getTime());
	                    dateEnd.setSeconds(dateEnd.getSeconds() + _this.currentData.event.duration);
	                    _this.currentData.event.end = dateEnd;
	                    _this.dateLabel = _this.getDateLabel();
	                    _this.currentData.event.price = eventResponse.price_per_person / 100;
	                    if (eventResponse.price_per_person > 0) {
	                        _this.currentData.event.paid = true;
	                    }
	                    else {
	                        _this.currentData.event.paid = false;
	                    }
	                    if (eventResponse.event_type != null && eventResponse.event_type == "public") {
	                        _this.currentData.event.eventType = data_1.EventType.PUBLIC;
	                    }
	                    else if (eventResponse.event_type != null && eventResponse.event_type == "private") {
	                        _this.currentData.event.eventType = data_1.EventType.PRIVATE;
	                    }
	                    else if (eventResponse.event_type != null && eventResponse.event_type == "manual_approval") {
	                        _this.currentData.event.eventType = data_1.EventType.MANUAL;
	                    }
	                    var alcoholPolicies = [];
	                    var alcoholPolicy = eventResponse.alcohol_policy;
	                    if (eventResponse.alcohol_policy != null && eventResponse.alcohol_policy == "host_provides") {
	                        alcoholPolicies.push(0);
	                    }
	                    else if (eventResponse.alcohol_policy != null && eventResponse.alcohol_policy == "byob") {
	                        alcoholPolicies.push(1);
	                    }
	                    else if (eventResponse.alcohol_policy != null && eventResponse.alcohol_policy == "alcohol_free") {
	                        alcoholPolicies.push(2);
	                    }
	                    var dietaryRestrictions = [];
	                    angular.forEach(eventResponse.dietary_restrictions, function (dietary_restriction) {
	                        if (dietary_restriction == "vegetarian") {
	                            dietaryRestrictions.push(0);
	                        }
	                        else if (dietary_restriction == "vegan") {
	                            dietaryRestrictions.push(1);
	                        }
	                        else if (dietary_restriction == "gluten_free") {
	                            dietaryRestrictions.push(2);
	                        }
	                        else if (dietary_restriction == "kosher") {
	                            dietaryRestrictions.push(3);
	                        }
	                    });
	                    _this.currentData.event.filter = {
	                        dietTypes: dietaryRestrictions,
	                        alcoholTypes: alcoholPolicies,
	                        mealTypes: [],
	                    };
	                    if (_this.mode == "guests") {
	                        if (eventResponse.city && _this.hasToSkipNourisment()) {
	                            _this.publishEvent();
	                        }
	                    }
	                    if (_this.session.isLogged()) {
	                        _this.session.loadSponsors(eventResponse.area_code).then(function () {
	                            _this.currentSponsors = JSON.parse(JSON.stringify(session.getData().sponsorList));
	                        });
	                    }
	                }).catch(function (eventResponse) {
	                    if (eventResponse.status == 404) {
	                        _this.location.url(config_1.Config.error + eventResponse.status);
	                    }
	                });
	                if (this.mode == "view") {
	                    $document.bind("scroll", function () {
	                        if ($("#details") != null && $('#details').offset() != null) {
	                            var window_top = $(window).scrollTop();
	                            var div_details_top = $('#details').offset().top - 20;
	                            var div_details_bottom = div_details_top + $('#details').parent().height();
	                            var div_menu_top = $('#menu').offset().top - 20;
	                            var div_menu_bottom = div_menu_top + $('#menu').parent().parent().height();
	                            var div_host_top = $('#host').offset().top - 20;
	                            var div_host_bottom = div_host_top + $('#host').parent().height();
	                            var menu_list = $('.ot-link-list-container').first().find("ot-link");
	                            var menu_item_details = menu_list.first().find('a');
	                            var menu_item_menu = $(menu_list.get(1)).find('a');
	                            var menu_item_host = $(menu_list.get(2)).find('a');
	                            if (window_top > div_details_top && window_top < div_details_bottom) {
	                                menu_item_details.addClass('ot-link-active');
	                            }
	                            else {
	                                menu_item_details.removeClass('ot-link-active');
	                            }
	                            if (window_top > div_menu_top && window_top < div_menu_bottom) {
	                                menu_item_menu.addClass('ot-link-active');
	                            }
	                            else {
	                                menu_item_menu.removeClass('ot-link-active');
	                            }
	                            if (window_top > div_host_top && window_top < div_host_bottom) {
	                                menu_item_host.addClass('ot-link-active');
	                            }
	                            else {
	                                menu_item_host.removeClass('ot-link-active');
	                            }
	                        }
	                    });
	                }
	            }
	            else {
	                $document.unbind('scroll');
	                var dateBegin = new Date(2016, 9, 19, 19, 0, 0, 0);
	                var beginDate = dateBegin;
	                beginDate.setHours(19);
	                beginDate.setMinutes(0);
	                var endDate = new Date();
	                endDate.setHours(21);
	                endDate.setMinutes(0);
	                this.mode = "new";
	                this.currentData = {
	                    event: {
	                        eventType: data_1.EventType.PUBLIC,
	                        area: {},
	                        begin: beginDate,
	                        end: endDate,
	                        parentAuth: false,
	                        notes: {
	                            version: "1",
	                            first: [],
	                            second: [],
	                            third: []
	                        },
	                        filter: {
	                            mealTypes: [],
	                            alcoholTypes: [],
	                            dietTypes: []
	                        },
	                        alcoholType: "",
	                        dietTypes: [],
	                        mealType: ""
	                    }
	                };
	                this.dateLabel = this.getDateLabel();
	            }
	        }
	        EventController.prototype.getDateLabel = function () {
	            var dateLabel = (this.currentData.event.begin.getMonth() + 1) + "/" + this.currentData.event.begin.getDate() + "/" + this.currentData.event.begin.getFullYear();
	            return dateLabel;
	        };
	        EventController.prototype.toHtml = function (str) {
	            if (!str) {
	                return "";
	            }
	            return str.split('\n').join("<br>");
	        };
	        EventController.prototype.hasNeighborhood = function () {
	            if (this.mode == "new" || (this.session.getData().event && typeof this.session.getData().event !== "undefined")) {
	                if (this.currentData && typeof this.currentData != "undefined") {
	                    return this.currentData.event.area && this.currentData.event.area.city &&
	                        this.currentData.event.area.city.neighborhoods && this.currentData.event.area.city.neighborhoods.length > 0;
	                }
	            }
	        };
	        EventController.prototype.isOther = function () {
	            if (this.mode == "new" || (this.session.getData().event && typeof this.session.getData().event !== "undefined")) {
	                if (this.currentData && typeof this.currentData != "undefined") {
	                    return this.currentData.event.area && this.currentData.event.area.city && this.currentData.event.area.city.code == "OTHER";
	                }
	            }
	        };
	        EventController.prototype.getCurrentData = function () {
	            if (this.mode == "view") {
	                return this.session.getData();
	            }
	            else {
	                return this.currentData;
	            }
	        };
	        EventController.prototype.trust = function (html) {
	            return this.sce.trustAsHtml(html);
	        };
	        EventController.prototype.parseTimezones = function (res) {
	            var result = [];
	            var id = "";
	            var label = "";
	            angular.forEach(res, function (value) {
	                result.push({
	                    id: value[0],
	                    label: value[1]
	                });
	            });
	            return result;
	        };
	        EventController.prototype.goLanding = function () {
	            if (this.getCurrentData().event) {
	                var areaCode = this.getCurrentData().event.area_code;
	                var area = _.find(this.availableCities, { code: areaCode });
	                if (area) {
	                    this.location.url(config_1.Config.home + "/" + area.url);
	                }
	            }
	            else {
	                this.location.url(config_1.Config.home);
	            }
	        };
	        EventController.prototype.messageHost = function () {
	            if (this.session.isNotLogging()) {
	                this.currentModal = login_1.LoginController.openSignupModal(this.modal, this, this.rootScope);
	            }
	            else {
	                hostMessage_1.HostMessageController.open(this.modal, this.eventId);
	            }
	        };
	        EventController.prototype.hideMenuCard = function () {
	            return true;
	        };
	        EventController.prototype.goManageUpcoming = function () {
	            this.location.url(config_1.Config.manage + "/" + config_1.Config.upcoming);
	        };
	        EventController.prototype.goManageHosted = function () {
	            this.location.url(config_1.Config.manage + "/" + config_1.Config.hosted);
	        };
	        EventController.prototype.createEvent = function (form) {
	            var _this = this;
	            this.log.debug(form);
	            if (form.$valid && this.currentData.event.parentAuth) {
	                if (!this.currentData.event.paid) {
	                    this.currentData.event.price = 0;
	                }
	                var mealType = "";
	                var mealTypes = this.currentData.event.filter.mealTypes;
	                if (mealTypes.length > 0) {
	                    var selectedType = mealTypes[0];
	                    if (selectedType == 0) {
	                        mealType = "ordered_in";
	                    }
	                    else if (selectedType == 1) {
	                        mealType = "cooked";
	                    }
	                    else if (selectedType == 2) {
	                        mealType = "buffet";
	                    }
	                }
	                this.currentData.event.mealType = mealType;
	                var alcoholType = "";
	                var alcoholTypes = this.currentData.event.filter.alcoholTypes;
	                if (alcoholTypes.length > 0) {
	                    var selectedAlcoholType = alcoholTypes[0];
	                    if (selectedAlcoholType == 0) {
	                        alcoholType = "host_provides";
	                    }
	                    else if (selectedAlcoholType == 1) {
	                        alcoholType = "byob";
	                    }
	                    else if (selectedAlcoholType == 2) {
	                        alcoholType = "alcohol_free";
	                    }
	                }
	                this.currentData.event.alcoholType = alcoholType;
	                var dietTypes = [];
	                var dietTypesForm = this.currentData.event.filter.dietTypes;
	                if (dietTypesForm.length > 0) {
	                    dietTypesForm.forEach(function (entry) {
	                        var dietType = "";
	                        if (entry == 0) {
	                            dietType = "vegetarian";
	                        }
	                        else if (entry == 1) {
	                            dietType = "vegan";
	                        }
	                        else if (entry == 2) {
	                            dietType = "gluten_free";
	                        }
	                        else if (entry == 3) {
	                            dietType = "kosher";
	                        }
	                        if (dietType.length > 0) {
	                            dietTypes.push(dietType);
	                        }
	                    });
	                }
	                this.currentData.event.dietTypes = dietTypes;
	                this.imagePromise().then(function (result) {
	                    _this.log.debug(result);
	                    if (result) {
	                        _this.currentData.event.coverUpdate = result;
	                    }
	                    return _this.createEventInternal(_this.currentData);
	                });
	            }
	            else {
	                this.shouldPublish = false;
	                if (this.currentData.event.paid && this.currentData.event.price == null) {
	                    this.notification.error("Insert a valid price");
	                }
	            }
	        };
	        EventController.prototype.publishEvent = function () {
	            var _this = this;
	            this.log.debug("publishEvent");
	            this.session.publishEvent(this.eventId).then(function (result) {
	                _this.session.spinnerService.hide("mainSpinner");
	                _this.showConfirmModal(_this.eventId);
	                _this.shouldPublish = false;
	            });
	        };
	        EventController.prototype.getMaxNourishmentAllocation = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                var maxAmount = this.getCurrentData().event.expected_guests * 15;
	                maxAmount = Math.min(maxAmount, 150);
	                return maxAmount;
	            }
	            else {
	                return 0;
	            }
	        };
	        EventController.prototype.submitAllocation = function (form) {
	            var _this = this;
	            this.log.debug("submitAllocation");
	            this.log.debug(form);
	            if (form.$valid) {
	                var amount = this.getAllocated();
	                var maxAmount = this.getMaxNourishmentAllocation();
	                if (amount > maxAmount) {
	                    this.notification.error("You can assign at most $" + maxAmount + ".00");
	                }
	                else {
	                    this.session.saveNourishment(this.eventId, this.guestsCount, this.currentSponsors).then(function (response) {
	                        if (_this.getCurrentData().event.state != "published") {
	                            _this.session.publishEvent(_this.eventId).then(function (result) {
	                                _this.showConfirmModal(_this.eventId);
	                                _this.shouldPublish = false;
	                            });
	                        }
	                        else {
	                            _this.notification.success("Nourished updated");
	                        }
	                    });
	                }
	            }
	            else {
	                this.notification.error("You have to type a number on input!");
	            }
	        };
	        EventController.prototype.submitGuests = function (form) {
	            var _this = this;
	            this.log.debug("submitGuests");
	            this.log.debug(form);
	            this.session.saveExpectedGuest(this.eventId, this.guestsCount + 1)
	                .then(function (response) {
	                _this.location.url(config_1.Config.events + "/" + _this.eventId + "/nourished");
	            });
	        };
	        EventController.prototype.setPublish = function (form) {
	            if (form.$valid) {
	                this.log.debug("setPublish");
	                this.shouldPublish = true;
	            }
	            else {
	                $('html, body').animate({ scrollTop: 0 }, 300);
	            }
	        };
	        EventController.prototype.getCurrentEventDate = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null && this.getCurrentData().event.event_date != null) {
	                var date = session_1.SessionService.toDate(this.getCurrentData().event.event_date, true);
	                date.setDate(date.getDate() - 5);
	                var now = new Date();
	                if (now > date) {
	                    return this.filter('date')(now, 'longDate');
	                }
	                else {
	                    return this.filter('date')(date, 'longDate');
	                }
	            }
	            else {
	                return "";
	            }
	        };
	        EventController.prototype.createEventInternal = function (currentData) {
	            var _this = this;
	            if (this.eventId != null) {
	                this.session.spinnerService.show("mainSpinner");
	                return this.session.updateEvent(this.currentData.event, this.eventId).then(function (result) {
	                    if (_this.shouldPublish) {
	                        if (_this.hasToSkipNourisment()) {
	                            _this.publishEvent();
	                        }
	                        else {
	                            _this.session.spinnerService.hide("mainSpinner");
	                            _this.location.url(config_1.Config.events + "/" + _this.eventId + "/guests");
	                        }
	                    }
	                    else {
	                        _this.session.spinnerService.hide("mainSpinner");
	                        _this.notification.success("Event updated!");
	                    }
	                })
	                    .catch(function (error) {
	                    _this.notification.error("Cannot update event");
	                    _this.session.spinnerService.hide("mainSpinner");
	                });
	            }
	            else {
	                this.session.spinnerService.show("mainSpinner");
	                return this.session.createEvent(this.currentData.event).then(function (result) {
	                    var eventId = result.data.data.uuid;
	                    _this.eventId = eventId;
	                    if (_this.shouldPublish) {
	                        if (_this.hasToSkipNourisment()) {
	                            _this.publishEvent();
	                        }
	                        else {
	                            _this.session.spinnerService.hide("mainSpinner");
	                            _this.location.url(config_1.Config.events + "/" + eventId + "/guests");
	                        }
	                    }
	                    else {
	                        _this.session.spinnerService.hide("mainSpinner");
	                        _this.notification.success("Draft saved!");
	                        _this.location.url(config_1.Config.events + "/" + eventId + "/edit");
	                    }
	                }).catch(function (error) {
	                    if (error.status === 422) {
	                        _this.notification.error("Oops! You cannot create a dinner in the past");
	                        _this.session.spinnerService.hide("mainSpinner");
	                    }
	                });
	            }
	        };
	        EventController.prototype.hasToSkipNourisment = function () {
	            if (!this.currentData.event.area || this.session.isOnward()) {
	                return true;
	            }
	            var unnourishables = _.filter(this.availableCities, { nourishment: false });
	            var found = !!_.find(unnourishables, { code: this.currentData.event.area.city.code });
	            return found;
	        };
	        EventController.prototype.showConfirmModal = function (eventId) {
	            var _this = this;
	            this.location.url(config_1.Config.events + "/" + eventId);
	            this.currentSuccessModal = this.modal.open({
	                controller: function () { return new success_1.SuccessController(_this.session); },
	                controllerAs: "vm",
	                replace: true,
	                size: "md",
	                template: TPL.modals.success
	            });
	        };
	        EventController.prototype.addSeat = function () {
	            this.guestsCount++;
	        };
	        EventController.prototype.removeSeat = function () {
	            if (this.guestsCount > 1) {
	                this.guestsCount--;
	            }
	        };
	        EventController.prototype.getAllocated = function () {
	            var total = _.reduce(this.currentSponsors, function (sum, n) {
	                var value = parseFloat(n['currentValue']);
	                return isNaN(value) ? sum : sum + value;
	            }, 0);
	            return total;
	        };
	        EventController.prototype.getAllocatedClass = function () {
	            if (this.getAllocated() == 0) {
	                return "ot-gray-text";
	            }
	            else if (this.getAllocated() > this.getMaxNourishmentAllocation()) {
	                return "ot-red-border";
	            }
	            else {
	                return "";
	            }
	        };
	        EventController.prototype.isDateDisabled = function (info) {
	            if (info.mode == "day") {
	                if (info.date.getDay() != 5) {
	                    return true;
	                }
	            }
	            return false;
	        };
	        EventController.prototype.hasTypes = function () {
	            if (this.getCurrentData().event != null) {
	                return (this.getCurrentData().event.alcohol_policy.length > 0 || this.getCurrentData().event.dietary_restrictions.length > 0);
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.canAllocateInstacart = function () {
	            return true;
	        };
	        EventController.prototype.canAllocateSeamless = function () {
	            return true;
	        };
	        EventController.prototype.canAllocateEtsy = function () {
	            return true;
	        };
	        EventController.prototype.canAllocateTableSwoon = function () {
	            return true;
	        };
	        EventController.prototype.canAllocateGrowBehold = function () {
	            return true;
	        };
	        EventController.prototype.canAllocateDoorDash = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                if (this.currentData.event.area.city.nourishment == true && this.currentData.event.area.city.code == "SF") {
	                    return true;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.canAllocateLocalMission = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                if (this.currentData.event.area.city.nourishment == true && this.currentData.event.area.city.code == "SF") {
	                    return true;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.canAllocateWholeFoods = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                if (this.currentData.event.area.city.nourishment == true && this.currentData.event.area.city.code == "SF") {
	                    return true;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.canAllocateGoodEggs = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                if (this.currentData.event.area.city.nourishment == true && this.currentData.event.area.city.code == "SF") {
	                    return true;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.canAllocateRainbow = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                if (this.currentData.event.area.city.nourishment == true && this.currentData.event.area.city.code == "SF") {
	                    return true;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.canAllocateTheMarket = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                if (this.currentData.event.area.city.nourishment == true && this.currentData.event.area.city.code == "SF") {
	                    return true;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.canAllocateBiRite = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                if (this.currentData.event.area.city.nourishment == true && this.currentData.event.area.city.code == "SF") {
	                    return true;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.canAllocateThriveMarket = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                if (this.currentData.event.area.city.nourishment == true && this.currentData.event.area.city.code == "SF") {
	                    return true;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.canAllocatePlated = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                if (this.currentData.event.area.city.nourishment == true && (this.currentData.event.area.city.code == "NY" || this.currentData.event.area.city.code == "CHICAGO")) {
	                    return true;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.canAllocateFreshDirect = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                if (this.currentData.event.area.city.nourishment == true && this.currentData.event.area.city.code == "NY") {
	                    return true;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.canAllocateOurHarvest = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                if (this.currentData.event.area.city.nourishment == true && this.currentData.event.area.city.code == "NY") {
	                    return true;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.canAllocateSoomSoom = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                if (this.currentData.event.area.city.nourishment == true && this.currentData.event.area.city.code == "NY") {
	                    return true;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.canAllocateSherryLehmann = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                if (this.currentData.event.area.city.nourishment == true && this.currentData.event.area.city.code == "NY") {
	                    return true;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.canAllocateDrizly = function () {
	            if (this.getCurrentData() != null && this.getCurrentData().event != null) {
	                if (this.currentData.event.area.city.nourishment == true && (this.currentData.event.area.city.code == "NY" || this.currentData.event.area.city.code == "CHICAGO")) {
	                    return true;
	                }
	            }
	            else {
	                return false;
	            }
	        };
	        EventController.prototype.endsWith = function (str, suffix) {
	            return str.indexOf(suffix, str.length - suffix.length) !== -1;
	        };
	        EventController.$inject = [
	            "$routeParams",
	            "session",
	            "$location",
	            "$uibModal",
	            "$rootScope",
	            "$document",
	            "$filter",
	            "Notification",
	            "$scope",
	            "$timeout",
	            "$sce",
	            "$log"
	        ];
	        return EventController;
	    })();
	    exports.EventController = EventController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, config_1) {
	    var HostPromotionController = (function () {
	        function HostPromotionController(session, location) {
	            this.session = session;
	            this.location = location;
	            if (this.session.isHost()) {
	                this.location.url(this.session.getLandingPage());
	            }
	        }
	        HostPromotionController.prototype.promote = function () {
	            var _this = this;
	            if (this.session.isOnward()) {
	                this.session.requestHost().then(function () {
	                    _this.location.url(_this.session.getLandingPage());
	                });
	            }
	            else {
	                this.session.requestHost().then(function () {
	                    return _this.session.autoPromoteToHost()
	                        .then(function (response) {
	                        _this.location.url(config_1.Config.manage + "/" + config_1.Config.hosted);
	                        _this.location.replace();
	                    });
	                });
	            }
	        };
	        HostPromotionController.$inject = ["session", "$location"];
	        return HostPromotionController;
	    })();
	    exports.HostPromotionController = HostPromotionController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(151), __webpack_require__(8), __webpack_require__(9), __webpack_require__(150), __webpack_require__(19)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, changePassword_1, data_1, login_1, link_1, _) {
	    var LandingController = (function () {
	        function LandingController($rootScope, session, $routeParams, $modal, $location, $log) {
	            var _this = this;
	            this.filter = {
	                queryString: undefined,
	                city: null,
	                visibility: true,
	                minDate: new Date(),
	                eventType: data_1.EventType.ALL,
	                costType: data_1.CostType.ALL,
	                mealTypes: [],
	                alcoholTypes: [],
	                dietTypes: []
	            };
	            this.eventsList = [];
	            this.session = session;
	            this.modal = $modal;
	            this.location = $location;
	            this.log = $log;
	            this.availableCities = session.getAvailableCities();
	            if ($routeParams.city) {
	                this.currentCity = _.find(this.availableCities, { url: $routeParams.city });
	                this.filterCities();
	                this.filter.city = this.currentCity.code;
	            }
	            if (!this.currentCity) {
	                this.currentCity = "";
	                this.filter.city = "";
	                this.filterCities();
	            }
	            if ($routeParams.q) {
	                this.filter.queryString = $routeParams.q;
	            }
	            if ($routeParams.changePassword) {
	                this.currentModal = changePassword_1.ChangePasswordController.openUndismissableChangePasswordModal(this.modal, this, this.session, this.location);
	                this.resetPasswordToken = $routeParams.changePassword;
	            }
	            else {
	                if ($routeParams.signup) {
	                    if (!this.session.isLogged()) {
	                        this.currentModal = login_1.LoginController.openSignupModal(this.modal, this, $rootScope);
	                    }
	                    this.location.url('/landing');
	                }
	                else if ($routeParams.login) {
	                    if (!this.session.isLogged()) {
	                        this.currentModal = login_1.LoginController.openLoginModal(this.modal, this, $rootScope);
	                    }
	                    this.location.url('/landing');
	                }
	                else if ($routeParams.apply) {
	                    link_1.LinkList.becomeHostProcedure(session, this.modal, $rootScope);
	                }
	                if (this.session.isNotLogging()) {
	                    this.session.loadPublicEvents(this.filter);
	                }
	                if (this.session.isLogged()) {
	                    this.session.loadPrivateEvents(null, this.filter);
	                }
	                this.session.loadMyReservations();
	                this.searchCallback = function () { _this.search(); };
	                this.clearCallback = function () {
	                    _this.log.debug("Clear callback");
	                    _this.filter = {
	                        queryString: undefined,
	                        city: _this.currentCity.code,
	                        visibility: true,
	                        minDate: new Date(),
	                        eventType: data_1.EventType.ALL,
	                        costType: data_1.CostType.ALL,
	                        mealTypes: [],
	                        alcoholTypes: [],
	                        dietTypes: []
	                    };
	                };
	            }
	        }
	        LandingController.prototype.getCurrentEventList = function () {
	            if (this.session.isLogged()) {
	                return this.session.getData().privateEventList;
	            }
	            return this.session.getData().publicEventList;
	        };
	        LandingController.prototype.getCurrentEventListLength = function () {
	            if (this.session.isLogged()) {
	                return this.session.getData().privateEventListMetadata && this.session.getData().privateEventListMetadata.total_count;
	            }
	            return this.session.getData().publicEventListMetadata && this.session.getData().publicEventListMetadata.total_count;
	        };
	        LandingController.prototype.isCurrentEventListLoaded = function () {
	            if (this.session.isLogged()) {
	                return this.session.getData().hasLoadedPrivateEvents();
	            }
	            return this.session.getData().hasLoadedPublicEvents();
	        };
	        LandingController.prototype.search = function () {
	            this.log.debug(this.filter);
	            if (this.session.isLogged()) {
	                this.session.loadPrivateEvents(null, this.filter);
	            }
	            else {
	                this.session.loadPublicEvents(this.filter);
	            }
	        };
	        LandingController.prototype.getCurrentCityCover = function () {
	            return "/assets/Landing_Banner.jpg";
	        };
	        LandingController.prototype.filterCities = function () {
	            var _this = this;
	            this.filteredCities = _.filter(this.availableCities, function (city) {
	                return _this.currentCity.code != city.code;
	            });
	        };
	        LandingController.prototype.getCurrentCityLabel = function () {
	            if (this.currentCity) {
	                return this.currentCity.label;
	            }
	            else {
	                return "All States";
	            }
	        };
	        LandingController.$inject = ["$rootScope", "session", "$routeParams", "$uibModal", "$location", "$log"];
	        return LandingController;
	    })();
	    exports.LandingController = LandingController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    var ManageController = (function () {
	        function ManageController($routeParams, session, $rootScope) {
	            this.section = $routeParams.what;
	            this.session = session;
	            this.rootScope = $rootScope;
	            switch (this.section) {
	                case "upcoming":
	                    this.session.loadUpcomingEvents();
	                    break;
	                case "hosted":
	                    this.session.loadHostedEvents();
	                    break;
	                case "saved":
	                    this.session.loadSavedEvents();
	                    break;
	                case "past":
	                    this.session.loadPastEvents();
	                    break;
	            }
	        }
	        ManageController.$inject = ["$routeParams", "session", "$rootScope"];
	        return ManageController;
	    })();
	    exports.ManageController = ManageController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    var NotFoundController = (function () {
	        function NotFoundController() {
	        }
	        return NotFoundController;
	    })();
	    exports.NotFoundController = NotFoundController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(3), __webpack_require__(5), __webpack_require__(151), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, config_1, confirm_1, changePassword_1, TPL) {
	    var ProfileController = (function () {
	        function ProfileController($routeParams, session, $location, $modal, $timeout, $log, stripe, notification) {
	            this.eventId = $routeParams.id;
	            this.session = session;
	            this.stripe = stripe;
	            this.location = $location;
	            this.modal = $modal;
	            this.timeout = $timeout;
	            this.notification = notification;
	            this.log = $log;
	            this.showParam = "show";
	            this.showRegisterCard = false;
	            this.cardList = [];
	            this.clearProfile();
	            this.getCardsList();
	            this.cardSelected = "";
	            this.newCard = true;
	            this.randomColor = this.getRandomColor();
	            this.log.debug(this.profile.birthDate);
	        }
	        ProfileController.prototype.clearProfile = function () {
	            this.profile = {
	                firstName: this.session.getFirstName(),
	                lastName: this.session.getLastName(),
	                email: this.session.getEmail(),
	                birthDate: this.session.getBirthDate(),
	                city: this.session.getCity(),
	                city_state: this.session.getCityState(),
	                address: this.session.getAddress(),
	                address_secondary: this.session.getAddressSecondary(),
	                phone: this.session.getPhone(),
	                bio: this.session.getBio()
	            };
	        };
	        ProfileController.prototype.uploadNewAvatar = function (file) {
	            var _this = this;
	            this.session.uploadFile(file).then(function (url) {
	                return _this.session.updateProfile({
	                    avatar: url
	                }).then(function () {
	                    //This is a trick to make the avatar update itself.
	                    //TODO remove as it is shameful polling!!
	                    //TODO 2 what happens if avatar upload fails??
	                    var recursiveRefresh = function () {
	                        _this.session.refreshProfile().then(function () {
	                            if (!_this.session.getAvatar()) {
	                                _this.timeout(recursiveRefresh, 2000);
	                            }
	                        });
	                    };
	                    _this.timeout(recursiveRefresh, 2000);
	                });
	            });
	        };
	        ProfileController.prototype.getAvatarStyle = function (shadow) {
	            if (!this.session.getAvatar()) {
	                return { 'background': this.randomColor };
	            }
	            if (shadow) {
	                return { 'background-image': 'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(' + this.session.getAvatar() + ')' };
	            }
	            else {
	                return { 'background-image': 'url(' + this.session.getAvatar() + ')' };
	            }
	        };
	        ProfileController.prototype.getCurrentFullName = function () {
	            return (this.profile.firstName || "") + " " + (this.profile.lastName || "");
	        };
	        ProfileController.prototype.getCurrentInitials = function () {
	            if (!this.session.getAvatar()) {
	                if (this.profile.firstName != null && this.profile.lastName != null) {
	                    return (this.profile.firstName.charAt(0) || "") + " " + (this.profile.lastName.charAt(0) || "");
	                }
	                else {
	                    return "";
	                }
	            }
	            else {
	                return "";
	            }
	        };
	        ProfileController.prototype.goLanding = function () {
	            this.location.url(config_1.Config.home);
	        };
	        ProfileController.prototype.openChangePasswordModal = function () {
	            this.currentModal = changePassword_1.ChangePasswordController.openChangePasswordModal(this.modal, this, this.session, this.location);
	        };
	        ProfileController.prototype.submit = function (form) {
	            var _this = this;
	            if (form.$valid) {
	                var modal = this.modal.open({
	                    controller: function () { return new confirm_1.ConfirmController(_this, {
	                        title: "PROFILE.CONFIRM_TITLE",
	                        title2: "PROFILE.CONFIRM_SUBTITLE",
	                        logo: false,
	                        actions: [
	                            {
	                                label: "PROFILE.CONFIRM_SUBMIT",
	                                primary: true,
	                                callback: function () {
	                                    _this.session.updateProfile(_this.profile).then(function (response) {
	                                        _this.clearProfile();
	                                        modal.dismiss();
	                                    });
	                                }
	                            },
	                            {
	                                label: "PROFILE.CONFIRM_CANCEL",
	                                primary: false,
	                                callback: function () {
	                                    _this.clearProfile();
	                                    modal.dismiss();
	                                }
	                            },
	                        ]
	                    }); },
	                    controllerAs: "vm",
	                    replace: true,
	                    size: "sm",
	                    template: TPL.modals.confirm
	                });
	            }
	        };
	        ProfileController.prototype.registerCard = function (form, param) {
	            var _this = this;
	            var cardData = {
	                number: this.cardSelected.number,
	                name: this.cardSelected.owner,
	                cvc: this.cardSelected.cvv,
	                exp_month: this.cardSelected.expiration_month,
	                exp_year: this.cardSelected.expiration_year
	            };
	            var data;
	            if (!this.newCard) {
	                data = {
	                    id: this.cardSelected.id,
	                    favourite: this.cardSelected.favourite
	                };
	                return this.session.changeCard(data, param).then(function (response) {
	                    _this.getCardsList();
	                    _this.cardSelected = "";
	                    _this.newCard = true;
	                    _this.openRegisterCard('hide');
	                });
	            }
	            else {
	                this.stripe.card.createToken(cardData)
	                    .then(function (response) {
	                    data = {
	                        stripe_token: response.id,
	                        favourite: _this.cardSelected.favourite
	                    };
	                    return _this.session.registerNewCard(data).then(function (response) {
	                        _this.getCardsList();
	                        _this.openRegisterCard('hide');
	                        _this.notification.success("Registration of card has been completed!");
	                    });
	                })
	                    .catch(function (err) {
	                    _this.notification.error("Register card error!");
	                    if (err.type && /^Stripe/.test(err.type)) {
	                        _this.log.debug('Stripe error: ', err.message);
	                    }
	                    else {
	                        _this.log.debug('Other error occurred, possibly with your API', err.message);
	                    }
	                    throw err;
	                });
	            }
	        };
	        ProfileController.prototype.getRandomColor = function () {
	            var colors = ["#8D1B3D", "#443135", "#857363", "#50C9B5", "#FCD450"];
	            var randomIndex = Math.floor(Math.random() * colors.length);
	            this.log.debug(randomIndex);
	            return colors[randomIndex];
	        };
	        ProfileController.prototype.openRegisterCard = function (param, cardId) {
	            if (param === "show") {
	                this.showRegisterCard = true;
	                this.showParam = "hide";
	            }
	            else {
	                this.showRegisterCard = false;
	                this.showParam = "show";
	            }
	            if (cardId) {
	                this.getCard(cardId);
	            }
	            else {
	                this.cardSelected = null;
	            }
	        };
	        ProfileController.prototype.getCardsList = function () {
	            var _this = this;
	            this.session.getCardList().then(function (response) {
	                _this.cardList = response;
	            });
	            this.log.debug("cards-list");
	            this.log.debug(this.cardList);
	        };
	        ProfileController.prototype.getCard = function (cardId) {
	            var _this = this;
	            this.session.getCardSelected(cardId).then(function (response) {
	                var expiration = response.expiration.split("/");
	                _this.cardSelected = {
	                    id: response.id,
	                    number: "**** **** **** " + response.number,
	                    expiration_month: expiration[0],
	                    expiration_year: expiration[1],
	                    brand: response.brand,
	                    favourite: response.favourite,
	                    owner: response.owner,
	                    cvv: "***"
	                };
	                _this.newCard = false;
	            });
	        };
	        ProfileController.$inject = ["$routeParams", "session", "$location", "$uibModal", "$timeout", "$log", "stripe", "Notification"];
	        return ProfileController;
	    })();
	    exports.ProfileController = ProfileController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var AvatarDirective = (function () {
	        function AvatarDirective() {
	            var _this = this;
	            this.template = TPL.commonDirectives.avatar;
	            this.scope = {
	                params: "=params"
	            };
	            this.link = function (scope, el, attrs) {
	                var randomColor = _this.getRandomColor();
	                scope.vm = {
	                    getUserInitials: function () {
	                        if ((!scope.vm.hasImage() || !scope.params.image.src) && scope.params.initials != null) {
	                            if (scope.params.initials.first_name != null && scope.params.initials.last_name != null) {
	                                return scope.params.initials.first_name.charAt(0) + scope.params.initials.last_name.charAt(0);
	                            }
	                            else {
	                                return "";
	                            }
	                        }
	                        else {
	                            return "";
	                        }
	                    },
	                    getAvatarAdditionalClass: function () {
	                        var result = "";
	                        if (!scope.params) {
	                            return result;
	                        }
	                        if (!!scope.params.dark) {
	                            result += "ot-dark ";
	                        }
	                        if (scope.vm.isHorizontal()) {
	                            result += "ot-horizontal ";
	                        }
	                        if (scope.vm.isVertical()) {
	                            result += "ot-vertical ";
	                        }
	                        return result;
	                    },
	                    hasImage: function () {
	                        return scope.params &&
	                            scope.params.image;
	                    },
	                    getImageSize: function () {
	                        if (!scope.vm.hasImage()) {
	                            return "md";
	                        }
	                        switch (scope.params.image.size) {
	                            case "xs":
	                                return "xs";
	                            case "ss":
	                                return "ss";
	                            case "sm":
	                                return "sm";
	                            case "lg":
	                                return "lg";
	                            case "md":
	                            default:
	                                return "md";
	                        }
	                    },
	                    getRandomIndex: function (length) {
	                        return Math.floor(Math.random() * length);
	                    },
	                    getImageStyle: function () {
	                        if (!scope.vm.hasImage() || !scope.params.image.src) {
	                            return { 'background': randomColor, 'align-content': 'center', 'display': 'flex' };
	                        }
	                        else {
	                            return { 'background-image': 'url(' + scope.params.image.src + ')' };
	                        }
	                    },
	                    getImageClass: function () {
	                        if (!scope.vm.hasImage()) {
	                            return "";
	                        }
	                        return "ot-" + scope.vm.getImageSize();
	                    },
	                    getImageAdditionalClass: function () {
	                        if (!scope.vm.hasImage()) {
	                            return "";
	                        }
	                        return scope.params.image.class;
	                    },
	                    hasLabel: function () {
	                        return scope.params &&
	                            scope.params.label &&
	                            scope.params.label.text &&
	                            scope.params.label.text.length > 0;
	                    },
	                    hasLabelPrefix: function () {
	                        return scope.params &&
	                            scope.params.label &&
	                            scope.params.label.prefix &&
	                            scope.params.label.prefix.length > 0;
	                    },
	                    hasLabelSuffix: function () {
	                        return scope.params &&
	                            scope.params.label &&
	                            scope.params.label.suffix &&
	                            scope.params.label.suffix.length > 0;
	                    },
	                    isHorizontal: function () {
	                        var pos = scope.vm.getLabelPosition();
	                        return scope.vm.hasLabel() && (pos == "left" || pos == "right");
	                    },
	                    isVertical: function () {
	                        var pos = scope.vm.getLabelPosition();
	                        return scope.vm.hasLabel() && (pos == "top" || pos == "bottom");
	                    },
	                    hasLabelBefore: function () {
	                        var pos = scope.vm.getLabelPosition();
	                        return scope.vm.hasLabel() && (pos == "top" || pos == "left");
	                    },
	                    hasLabelAfter: function () {
	                        var pos = scope.vm.getLabelPosition();
	                        return scope.vm.hasLabel() && (pos == "right" || pos == "bottom");
	                    },
	                    getLabelText: function () {
	                        if (!scope.vm.hasLabel()) {
	                            return "";
	                        }
	                        return scope.params.label.text;
	                    },
	                    getLabelPrefix: function () {
	                        if (!scope.vm.hasLabelPrefix()) {
	                            return "";
	                        }
	                        return scope.params.label.prefix;
	                    },
	                    getLabelSuffix: function () {
	                        if (!scope.vm.hasLabelSuffix()) {
	                            return "";
	                        }
	                        return scope.params.label.suffix;
	                    },
	                    getLabelPosition: function () {
	                        if (!scope.vm.hasLabel()) {
	                            return "bottom";
	                        }
	                        switch (scope.params.label.position) {
	                            case "left":
	                                return "left";
	                            case "right":
	                                return "right";
	                            case "top":
	                                return "top";
	                            case "bottom":
	                            default:
	                                return "bottom";
	                        }
	                    },
	                    getLabelClass: function () {
	                        if (!scope.vm.hasLabel()) {
	                            return "";
	                        }
	                        return "ot-" + scope.vm.getLabelPosition();
	                    },
	                    getLabelAdditionalClass: function () {
	                        if (!scope.vm.hasLabel()) {
	                            return "";
	                        }
	                        return scope.params.label.class;
	                    }
	                };
	            };
	        }
	        AvatarDirective.factory = function () {
	            return function () { return new AvatarDirective(); };
	        };
	        AvatarDirective.prototype.getRandomColor = function () {
	            var colors = ["#8D1B3D", "#443135", "#857363", "#50C9B5", "#FCD450"];
	            var randomIndex = Math.floor(Math.random() * colors.length);
	            return colors[randomIndex];
	        };
	        return AvatarDirective;
	    })();
	    exports.AvatarDirective = AvatarDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var BannerDirective = (function () {
	        function BannerDirective() {
	            this.template = TPL.commonDirectives.banner;
	            this.scope = {
	                params: "=params"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    getSrc: function () {
	                        if (!scope.params.src) {
	                            return null;
	                        }
	                        return { 'background-image': 'url(' + scope.params.src + ')' };
	                    }
	                };
	            };
	        }
	        BannerDirective.factory = function () {
	            return function () { return new BannerDirective(); };
	        };
	        return BannerDirective;
	    })();
	    exports.BannerDirective = BannerDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var FieldDirective = (function () {
	        function FieldDirective() {
	            this.template = TPL.commonDirectives.field;
	            this.scope = {
	                name: "=name",
	                value: "=value"
	            };
	        }
	        FieldDirective.factory = function () {
	            var tmp = function () { return new FieldDirective(); };
	            return tmp;
	        };
	        return FieldDirective;
	    })();
	    exports.FieldDirective = FieldDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, $) {
	    var FixerDirective = (function () {
	        function FixerDirective($window, $log) {
	            this.restrict = "A";
	            var $el;
	            var $viewport;
	            var fixerClass;
	            var offsetTop;
	            this.link = function (scope, el, attrs) {
	                $el = $(el);
	                $viewport = $($window);
	                fixerClass = attrs.otFixer;
	                offsetTop = $el.position().top - $el.height();
	                $viewport.on("scroll", function (e) {
	                    if ($viewport.scrollTop() >= offsetTop) {
	                        $el.addClass(fixerClass);
	                    }
	                    else {
	                        $el.removeClass(fixerClass);
	                    }
	                });
	            };
	        }
	        FixerDirective.factory = function () {
	            var tmp = function (a, b) { return new FixerDirective(a, b); };
	            tmp.$inject = ["$window", "$log"];
	            return tmp;
	        };
	        return FixerDirective;
	    })();
	    exports.FixerDirective = FixerDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(5), __webpack_require__(8), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, confirm_1, data_1, config_1) {
	    var ImageUploaderDirective = (function () {
	        function ImageUploaderDirective(session, $modal, $timeout, $log) {
	            this.template = TPL.commonDirectives.imageUploader;
	            this.scope = {
	                params: "=params",
	                current: "=current",
	                image: "=image"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    active: 0,
	                    lastValidUploadedImage: undefined,
	                    lastUploadedImage: undefined,
	                    isUploading: false,
	                    uploadCurrentPercentual: 0,
	                    covers: data_1.Covers.getCoversInstance(config_1.Config.publicEndpoint),
	                    onFileChange: function (invalidFilesArray, event) {
	                        $log.debug("onFileChange");
	                        $log.debug(invalidFilesArray);
	                        if (scope.vm.lastUploadedImage) {
	                            scope.vm.lastValidUploadedImage = scope.vm.lastUploadedImage;
	                            scope.vm.active = scope.vm.covers.length;
	                        }
	                        if (invalidFilesArray && invalidFilesArray.length && event && event.type == "change") {
	                            confirm_1.ConfirmController.openImageTooLargeModal($modal);
	                        }
	                    }
	                };
	                var getRandomInt = function (min, max) {
	                    return Math.floor(Math.random() * (max - min)) + min;
	                };
	                scope.vm.active = scope.current ? scope.vm.covers.length : getRandomInt(0, scope.vm.covers.length - 1);
	                scope.image = function () {
	                    for (var i = 0; i < scope.vm.covers.length; i++) {
	                        if (scope.vm.active >= 0 && scope.vm.active < scope.vm.covers.length) {
	                            return $timeout(function () { return scope.vm.covers[scope.vm.active].url; });
	                        }
	                    }
	                    if (!scope.vm.lastValidUploadedImage) {
	                        return $timeout(false);
	                    }
	                    scope.vm.isUploading = true;
	                    return session.uploadFile(scope.vm.lastValidUploadedImage, function (progress) {
	                        scope.vm.uploadCurrentPercentual = (progress.loaded / progress.total) * 100;
	                    }).then(function (result) {
	                        scope.vm.isUploading = false;
	                        return result;
	                    });
	                };
	            };
	        }
	        ImageUploaderDirective.factory = function () {
	            var tmp = function (a, b, c, d) { return new ImageUploaderDirective(a, b, c, d); };
	            tmp.$inject = ["session", "$uibModal", "$timeout", "$log"];
	            return tmp;
	        };
	        return ImageUploaderDirective;
	    })();
	    exports.ImageUploaderDirective = ImageUploaderDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var InputComboDirective = (function () {
	        function InputComboDirective() {
	            this.template = TPL.commonDirectives.inputCombo;
	            this.scope = {
	                params: "=params",
	                parentform: "=parentform",
	                value: "=value"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {};
	            };
	        }
	        InputComboDirective.factory = function () {
	            var tmp = function () { return new InputComboDirective(); };
	            return tmp;
	        };
	        return InputComboDirective;
	    })();
	    exports.InputComboDirective = InputComboDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var InputSelectDirective = (function () {
	        function InputSelectDirective() {
	            this.template = TPL.commonDirectives.inputSelect;
	            this.scope = {
	                params: "=params"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    toggle: function (array, type, multiple) {
	                        if (multiple === true) {
	                            var index = array.indexOf(type);
	                            if (index >= 0) {
	                                array.splice(index, 1);
	                            }
	                            else {
	                                array.push(type);
	                            }
	                        }
	                        else {
	                            var index = array.indexOf(type);
	                            if (index >= 0) {
	                                array.splice(index, 1);
	                            }
	                            else {
	                                array.splice(0, 1);
	                                array.push(type);
	                            }
	                        }
	                    },
	                    contains: function (array, type) {
	                        if (array != null) {
	                            return array.indexOf(type) >= 0;
	                        }
	                        else {
	                            return false;
	                        }
	                    }
	                };
	            };
	        }
	        InputSelectDirective.factory = function () {
	            var tmp = function () { return new InputSelectDirective(); };
	            return tmp;
	        };
	        return InputSelectDirective;
	    })();
	    exports.InputSelectDirective = InputSelectDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var LoaderDirective = (function () {
	        function LoaderDirective() {
	            this.template = TPL.commonDirectives.loader;
	            this.scope = {
	                name: "=name"
	            };
	        }
	        LoaderDirective.factory = function () {
	            var tmp = function () { return new LoaderDirective(); };
	            return tmp;
	        };
	        return LoaderDirective;
	    })();
	    exports.LoaderDirective = LoaderDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, config_1) {
	    var LogoDirective = (function () {
	        function LogoDirective($location) {
	            this.scope = {
	                params: "=params"
	            };
	            this.template = TPL.commonDirectives.logo;
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    goHome: function () {
	                        window.location.href = config_1.Config.wp_home;
	                    },
	                    isClickable: function () {
	                        return scope.params && scope.params.linkHome;
	                    },
	                    click: function () {
	                        if (scope.vm.isClickable()) {
	                            scope.vm.goHome();
	                        }
	                    },
	                    getImageClass: function () {
	                        var logoClass;
	                        if (!config_1.Config.isOnward) {
	                            switch (scope.params.type) {
	                                case "footer":
	                                    logoClass = "ot-logo-footer";
	                                    break;
	                                case "emblem":
	                                    logoClass = "ot-logo-emblem";
	                                    break;
	                                case "vertical":
	                                    logoClass = "ot-logo-vertical";
	                                    break;
	                                case "header":
	                                default:
	                                    logoClass = "ot-logo-header";
	                            }
	                        }
	                        else {
	                            switch (scope.params.type) {
	                                case "footer":
	                                    logoClass = "ot-logo-onward";
	                                    break;
	                                case "emblem":
	                                    logoClass = "ot-logo-emblem";
	                                    break;
	                                case "vertical":
	                                    logoClass = "ot-logo-onward-vertical";
	                                    break;
	                                case "header":
	                                default:
	                                    logoClass = "ot-logo-onward";
	                            }
	                        }
	                        return logoClass;
	                    }
	                };
	            };
	        }
	        LogoDirective.factory = function () {
	            var tmp = function (a) { return new LogoDirective(a); };
	            tmp.$inject = ["$location"];
	            return tmp;
	        };
	        return LogoDirective;
	    })();
	    exports.LogoDirective = LogoDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var SeparatorDirective = (function () {
	        function SeparatorDirective() {
	            this.template = TPL.commonDirectives.separator;
	            this.scope = {
	                params: "=params"
	            };
	        }
	        SeparatorDirective.factory = function () {
	            return function () { return new SeparatorDirective(); };
	        };
	        return SeparatorDirective;
	    })();
	    exports.SeparatorDirective = SeparatorDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, config_1) {
	    var SocialShareDirective = (function () {
	        function SocialShareDirective(session, rootScope, window, $log) {
	            var _this = this;
	            this.template = TPL.commonDirectives.socialShare;
	            this.scope = {
	                params: "=params"
	            };
	            this.isloading = false;
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    getEventType: function () {
	                        var currentEvent = session.data.event;
	                        if (currentEvent != null) {
	                            return currentEvent.event_type;
	                        }
	                        else {
	                            return null;
	                        }
	                    },
	                    getUrlShortener: function (eventId) {
	                        var searchEventId;
	                        if (eventId) {
	                            searchEventId = eventId;
	                        }
	                        else {
	                            var currentEvent = session.data.event;
	                            if (currentEvent != null) {
	                                searchEventId = currentEvent.uuid;
	                            }
	                        }
	                        if (searchEventId != null && searchEventId != _this.shortUrlEventId && !_this.isloading) {
	                            var eventUrl = config_1.Config.publicEndpoint + '#' + config_1.Config.events + '/' + searchEventId;
	                            _this.isloading = true;
	                            session.shortenUrl(eventUrl).then(function (response) {
	                                _this.shortUrl = response.data.id;
	                                _this.isloading = false;
	                                _this.shortUrlEventId = searchEventId;
	                            });
	                        }
	                        return _this.shortUrl;
	                    },
	                    shareOnTwitter: function () {
	                        var url = scope.vm.getUrlShortener();
	                        var encodedUrl = window.encodeURI(url);
	                        var twitterBaseUrl = "https://twitter.com/intent/tweet?text=" + encodedUrl;
	                        var newwindow = window.open(twitterBaseUrl, 'name', 'height=397,width=550');
	                        if (window.focus) {
	                            newwindow.focus();
	                        }
	                    },
	                    shareOnFacebook: function () {
	                        $log.debug("share on facebook");
	                        $log.debug(FB);
	                        var currentEvent = session.data.event;
	                        var eventURL = config_1.Config.publicEndpoint + '#' + config_1.Config.events + '/' + currentEvent.uuid;
	                        $log.debug("eventURL: " + eventURL);
	                        var currentEventPhoto = config_1.Config.publicEndpoint + 'assets/bannerless.jpg';
	                        if (currentEvent.cover) {
	                            currentEventPhoto = currentEvent.cover.m;
	                        }
	                        try {
	                            FB.ui({
	                                display: 'popup',
	                                method: 'feed',
	                                link: eventURL,
	                                title: currentEvent.title,
	                                picture: currentEventPhoto,
	                                description: currentEvent.description,
	                                caption: 'Powered by BBYO'
	                            }, function (response) {
	                                $log.debug("response: " + response);
	                                rootScope.$broadcast("share_done");
	                            });
	                        }
	                        catch (err) {
	                            $log.debug("err: " + err);
	                        }
	                    },
	                };
	            };
	        }
	        SocialShareDirective.factory = function () {
	            var tmp = function (a, b, c, d) { return new SocialShareDirective(a, b, c, d); };
	            tmp.$inject = ["session", "$rootScope", "$window", "$log"];
	            return tmp;
	        };
	        return SocialShareDirective;
	    })();
	    exports.SocialShareDirective = SocialShareDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var StepperDirective = (function () {
	        function StepperDirective() {
	            this.template = TPL.commonDirectives.stepper;
	            this.scope = {
	                params: "=params"
	            };
	        }
	        StepperDirective.factory = function () {
	            return function () { return new StepperDirective(); };
	        };
	        return StepperDirective;
	    })();
	    exports.StepperDirective = StepperDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var AttendantsDirective = (function () {
	        function AttendantsDirective($filter) {
	            this.template = TPL.contentDirectives.attendants;
	            this.scope = {
	                params: "=params"
	            };
	            var translate = $filter('translate');
	            this.link = function (scope, el, attrs) {
	                var size = scope.params.size || "xs";
	                scope.vm = {
	                    avatar0: { dark: true, image: { size: size }, label: { position: "left" } },
	                    avatar1: { dark: true, image: { size: size } },
	                    avatar2: { dark: true, image: { size: size } },
	                    avatar3: { dark: true, image: { size: size }, label: { position: "right" } },
	                    avatarList: [],
	                    getAvatars: function () {
	                        while (scope.vm.avatarList.length > 0) {
	                            scope.vm.avatarList.pop();
	                        }
	                        if (scope.params.items) {
	                            var attendants = scope.params.items;
	                            var maxAvatarCount = Math.min(attendants.length, 4);
	                            for (var i = 0; i < maxAvatarCount; i++) {
	                                scope.vm.avatarList.push(scope.vm["avatar" + i]);
	                                if (attendants[(attendants.length - i) - 1].profile.avatar) {
	                                    scope.vm.avatarList[i].image.src = attendants[(attendants.length - i) - 1].profile.avatar.m;
	                                }
	                                if (attendants[(attendants.length - i) - 1].profile.first_name) {
	                                    scope.vm.avatarList[i].initials = {
	                                        first_name: attendants[(attendants.length - i) - 1].profile.first_name,
	                                        last_name: attendants[(attendants.length - i) - 1].profile.last_name,
	                                    };
	                                }
	                            }
	                            if (scope.params.title) {
	                                scope.vm.avatar0.label.text = translate(scope.params.title);
	                            }
	                            else {
	                                scope.vm.avatar0.label.text = undefined;
	                            }
	                            if (attendants.length > maxAvatarCount) {
	                                var diff = attendants.length - maxAvatarCount;
	                                scope.vm.avatar3.label.text = "+" + diff + " more";
	                            }
	                            else {
	                                scope.vm.avatar3.label.text = undefined;
	                            }
	                        }
	                        return scope.vm.avatarList;
	                    }
	                };
	            };
	        }
	        AttendantsDirective.factory = function () {
	            var tmp = function (a) { return new AttendantsDirective(a); };
	            tmp.$inject = ["$filter"];
	            return tmp;
	        };
	        return AttendantsDirective;
	    })();
	    exports.AttendantsDirective = AttendantsDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var DishListDirective = (function () {
	        function DishListDirective() {
	            this.template = TPL.contentDirectives.dishList;
	            this.scope = {
	                params: "=params"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    submit: function (form) {
	                        if (form.$valid) {
	                            scope.params.items.push(scope.vm.dish);
	                            scope.vm.dish = "";
	                        }
	                    },
	                    removeItemAt: function (i) {
	                        scope.params.items.splice(i, 1);
	                    }
	                };
	            };
	        }
	        DishListDirective.factory = function () {
	            var tmp = function () { return new DishListDirective(); };
	            return tmp;
	        };
	        return DishListDirective;
	    })();
	    exports.DishListDirective = DishListDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(2), __webpack_require__(3), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, angular, TPL, config_1, confirm_1) {
	    var EventTableDirective = (function () {
	        function EventTableDirective(session, $log) {
	            this.template = TPL.contentDirectives.eventTable;
	            this.scope = {
	                params: "=params",
	                events: "="
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    session: session,
	                    loadMore: function (type) {
	                        if (type == "hosted") {
	                            session.loadMoreHostedEvents();
	                        }
	                        else if (type == "saved") {
	                            session.loadMoreSavedEvents();
	                        }
	                        else if (type == "past") {
	                            session.loadMorePastEvents();
	                        }
	                    }
	                };
	            };
	        }
	        EventTableDirective.factory = function () {
	            var tmp = function (a, b) { return new EventTableDirective(a, b); };
	            tmp.$inject = ["session", "$log"];
	            return tmp;
	        };
	        return EventTableDirective;
	    })();
	    exports.EventTableDirective = EventTableDirective;
	    var EventListDirective = (function () {
	        function EventListDirective(session, $log) {
	            this.template = TPL.contentDirectives.eventList;
	            this.scope = {
	                params: "=params"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    session: session,
	                    loadMore: function (type) {
	                        if (type == "manage") {
	                            session.loadMoreUpcomingEvents();
	                        }
	                        else {
	                            if (session.isLogged()) {
	                                session.loadMorePrivateEvents();
	                            }
	                            else {
	                                session.loadMorePublicEvents();
	                            }
	                        }
	                    }
	                };
	            };
	        }
	        EventListDirective.factory = function () {
	            var tmp = function (a, b) { return new EventListDirective(a, b); };
	            tmp.$inject = ["session", "$log"];
	            return tmp;
	        };
	        return EventListDirective;
	    })();
	    exports.EventListDirective = EventListDirective;
	    var EventRowDirective = (function () {
	        function EventRowDirective($location, $modal, session) {
	            this.template = TPL.contentDirectives.eventRow;
	            this.scope = {
	                params: "=params"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    showEvent: function () {
	                        $location.url(config_1.Config.events + "/" + scope.params.item.uuid);
	                    },
	                    getReservationsList: function () {
	                        var reservationStats = scope.params.item.reservations_stats;
	                        return reservationStats.reservations_total;
	                    },
	                    getAcceptedList: function () {
	                        var reservationStats = scope.params.item.reservations_stats;
	                        return reservationStats.guests_accepted;
	                    },
	                    getPendingList: function () {
	                        var reservationStats = scope.params.item.reservations_stats;
	                        return reservationStats.guests_pending;
	                    },
	                    getGuestsCount: function () {
	                        var reservationStats = scope.params.item.reservations_stats;
	                        return reservationStats.guests_total;
	                    },
	                    getAcceptedCount: function () {
	                        var reservationStats = scope.params.item.reservations_stats;
	                        return reservationStats.guests_accepted;
	                    },
	                    getPendingCount: function () {
	                        var reservationStats = scope.params.item.reservations_stats;
	                        return reservationStats.reservations_pending;
	                    },
	                    getGuestsList: function () {
	                        var guestsList = scope.params.item.reservations;
	                        var guestEmails;
	                        angular.forEach(guestsList, function (guestsListItem) {
	                            guestEmails.push(guestsListItem.profile.first_name);
	                        });
	                        return guestsList;
	                    },
	                };
	            };
	        }
	        EventRowDirective.factory = function () {
	            var tmp = function (a, b, c) { return new EventRowDirective(a, b, c); };
	            tmp.$inject = ["$location", "$uibModal", "session"];
	            return tmp;
	        };
	        return EventRowDirective;
	    })();
	    exports.EventRowDirective = EventRowDirective;
	    var EventDirective = (function () {
	        function EventDirective($location, $modal) {
	            this.template = TPL.contentDirectives.event;
	            this.scope = {
	                params: "=params"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    getReservationsList: function () {
	                        var reservationList = scope.params.item.reservations;
	                        var reservationListFiltered = [];
	                        angular.forEach(reservationList, function (reservationListItem) {
	                            if (reservationListItem.state != "rejected") {
	                                reservationListFiltered.push(reservationListItem);
	                            }
	                        });
	                        return reservationListFiltered;
	                    },
	                    getPendingList: function () {
	                        var reservationList = scope.params.item.reservations;
	                        var reservationListFiltered = [];
	                        angular.forEach(reservationList, function (reservationListItem) {
	                            if (reservationListItem.state == "pending") {
	                                reservationListFiltered.push(reservationListItem);
	                            }
	                        });
	                        return reservationListFiltered;
	                    },
	                    showEvent: function () {
	                        if (scope.params.item.event_type == "private" && !scope.params.item.hosted_by_me && (scope.params.item.my_reservation == undefined || scope.params.item.my_reservation.state !== "accepted")) {
	                            var modalPrivate = confirm_1.ConfirmController.openPrivateDinnerModal($modal, function () {
	                                modalPrivate.dismiss();
	                            });
	                        }
	                        else {
	                            $location.path(config_1.Config.events + "/" + scope.params.item.uuid);
	                        }
	                    },
	                    getAvatarSize: function () {
	                        switch (scope.params.type) {
	                            case "manage":
	                                return "sm";
	                            case "compact":
	                                return "sm";
	                            case "landing":
	                            default:
	                                return "lg";
	                        }
	                    },
	                    getAvatarPosition: function () {
	                        return scope.params.type == "manage" ? "left" : "";
	                    },
	                    getAvatarLabel: function () {
	                        if (scope.params.type != "compact" && scope.params.item.created_by_profile) {
	                            return scope.params.item.created_by_profile.first_name;
	                        }
	                        return " ";
	                    },
	                    linkPublicEvent: function () {
	                        var eventLink;
	                        if (scope.params.item.event_type == "private") {
	                            if (scope.params.type === "manage") {
	                                eventLink = "#/events/" + scope.params.item.uuid;
	                            }
	                            else if (scope.params.item.my_reservation != undefined && scope.params.item.my_reservation.state === "accepted") {
	                                eventLink = "#/events/" + scope.params.item.uuid;
	                            }
	                            else {
	                                eventLink = "";
	                            }
	                        }
	                        else {
	                            eventLink = "#/events/" + scope.params.item.uuid;
	                        }
	                        return eventLink;
	                    },
	                };
	            };
	        }
	        EventDirective.factory = function () {
	            var tmp = function (a, b) { return new EventDirective(a, b); };
	            tmp.$inject = ["$location", "$uibModal"];
	            return tmp;
	        };
	        return EventDirective;
	    })();
	    exports.EventDirective = EventDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(2), __webpack_require__(3), __webpack_require__(152), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, angular, TPL, config_1, manageGuests_1, confirm_1) {
	    var ActionItem = (function () {
	        function ActionItem() {
	        }
	        ActionItem.buildActionItem = function (label, key, callback) {
	            var result = new ActionItem();
	            result.label = label;
	            result.callback = callback;
	            return result;
	        };
	        return ActionItem;
	    })();
	    exports.ActionItem = ActionItem;
	    var ActionList = (function (_super) {
	        __extends(ActionList, _super);
	        function ActionList() {
	            _super.call(this);
	            this.returnList;
	        }
	        ActionList.buildHostedActionList = function ($location, $modal, session, eventId, notification, rootScope) {
	            var result = new ActionList();
	            result.push(ActionItem.buildActionItem("MANAGE.ACTION_EDIT_EVENT", config_1.Config.upcoming, function () {
	                $location.url(config_1.Config.events + "/" + eventId + '/edit');
	            }));
	            result.push(ActionItem.buildActionItem("MANAGE.ACTION_MANAGE_GUESTS", config_1.Config.upcoming, function () {
	                manageGuests_1.ManageGuestsController.open($modal, eventId);
	            }));
	            result.push(ActionItem.buildActionItem("MANAGE.ACTION_CANCEL_EVENT", config_1.Config.upcoming, function () {
	                var modalView = confirm_1.ConfirmController.openConfirmDeleteEventModal($modal, function () {
	                    session.spinnerService.show("mainSpinner");
	                    session.deleteEvent(eventId).then(function () {
	                        modalView.dismiss();
	                        notification.success("Dinner deleted");
	                        session.loadHostedEvents();
	                        session.loadPastEvents();
	                        session.spinnerService.hide("mainSpinner");
	                        $location.url(config_1.Config.manage + "/" + config_1.Config.hosted);
	                    });
	                }, function () {
	                    modalView.dismiss();
	                    $location.url(config_1.Config.manage + "/" + config_1.Config.hosted);
	                });
	            }));
	            result.push(ActionItem.buildActionItem("MANAGE.SEND_EMAIL_TO", config_1.Config.upcoming, function () {
	                session.loadReservations(eventId).then(function (response) {
	                    var list = response;
	                    if (list != null) {
	                        var returnList = "";
	                        angular.forEach(list, function (reservation) {
	                            if (reservation.state != 'rejected') {
	                                if (returnList !== "") {
	                                    returnList = returnList + ";" + reservation.profile.email;
	                                }
	                                else {
	                                    returnList = reservation.profile.email;
	                                }
	                            }
	                        });
	                        return returnList;
	                    }
	                }).then(function (returnList) {
	                    if (returnList === undefined) {
	                        notification.error("There aren't emails adresses!");
	                    }
	                    else {
	                        var link = "mailto:" + returnList;
	                        window.location.href = link;
	                    }
	                });
	            }));
	            return result;
	        };
	        ActionList.buildAttendingActionList = function ($location, $modal, session, eventId, notification, rootScope) {
	            var result = new ActionList();
	            result.push(ActionItem.buildActionItem("MANAGE.ACTION_CANCEL_RESERVATION", config_1.Config.upcoming, function () {
	                var modalView = confirm_1.ConfirmController.openConfirmDeleteReservationModal($modal, function () {
	                    session.deleteReservation(eventId).then(function () {
	                        modalView.dismiss();
	                        notification.success("Reservation deleted");
	                        session.loadUpcomingEvents();
	                    });
	                }, function () {
	                    modalView.dismiss();
	                });
	            }));
	            if ($location.$$path !== "/manage/past") {
	                result.push(ActionItem.buildActionItem("MANAGE.ACTION_INVITE_FRIENDS", config_1.Config.upcoming, function () {
	                    manageGuests_1.ManageGuestsController.open($modal, eventId);
	                }));
	            }
	            return result;
	        };
	        ActionList.buildSavedActionList = function ($location, $modal, session, eventId, notification, rootScope) {
	            var result = new ActionList();
	            result.push(ActionItem.buildActionItem("MANAGE.ACTION_EDIT_DRAFT", config_1.Config.upcoming, function () {
	                $location.url(config_1.Config.events + "/" + eventId + '/edit');
	            }));
	            result.push(ActionItem.buildActionItem("MANAGE.ACTION_PUBLISH_DRAFT", config_1.Config.upcoming, function () {
	                $location.url(config_1.Config.events + "/" + eventId + "/guests");
	            }));
	            result.push(ActionItem.buildActionItem("MANAGE.ACTION_DELETE_DRAFT", config_1.Config.upcoming, function () {
	                var modalView = confirm_1.ConfirmController.openConfirmDeleteEventModal($modal, function () {
	                    session.deleteEvent(eventId).then(function () {
	                        modalView.dismiss();
	                        notification.success("Draft deleted");
	                        session.loadHostedEvents();
	                        session.loadPastEvents();
	                        $location.url(config_1.Config.manage + "/" + config_1.Config.hosted);
	                    });
	                }, function () {
	                    modalView.dismiss();
	                    $location.url(config_1.Config.manage + "/" + config_1.Config.hosted);
	                });
	            }));
	            return result;
	        };
	        return ActionList;
	    })(Array);
	    exports.ActionList = ActionList;
	    var EventActionMenuDirective = (function () {
	        function EventActionMenuDirective($location, $modal, session, notification, $rootScope) {
	            this.template = TPL.contentDirectives.eventActionMenu;
	            this.scope = {
	                params: "=params"
	            };
	            this.link = function (scope, el, attrs) {
	                var actionList;
	                switch (scope.params.type) {
	                    case "saved":
	                        actionList = ActionList.buildSavedActionList($location, $modal, session, scope.params.item.uuid, notification, $rootScope);
	                        break;
	                    case "hosted":
	                        actionList = ActionList.buildHostedActionList($location, $modal, session, scope.params.item.uuid, notification, $rootScope);
	                        break;
	                    case "attending":
	                    default:
	                        actionList = ActionList.buildAttendingActionList($location, $modal, session, scope.params.item.uuid, notification, $rootScope);
	                }
	                scope.vm = {
	                    session: session,
	                    actionList: actionList,
	                };
	            };
	        }
	        EventActionMenuDirective.factory = function () {
	            var tmp = function (a, b, c, d, e) { return new EventActionMenuDirective(a, b, c, d, e); };
	            tmp.$inject = ["$location", "$uibModal", "session", "Notification", "$rootScope"];
	            return tmp;
	        };
	        return EventActionMenuDirective;
	    })();
	    exports.EventActionMenuDirective = EventActionMenuDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var HostDirective = (function () {
	        function HostDirective() {
	            this.template = TPL.contentDirectives.host;
	            this.scope = {
	                params: "=params"
	            };
	        }
	        HostDirective.factory = function () {
	            return function () { return new HostDirective(); };
	        };
	        return HostDirective;
	    })();
	    exports.HostDirective = HostDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(20), __webpack_require__(19)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, session_1, _) {
	    var InfoDirective = (function () {
	        function InfoDirective($filter, session) {
	            this.template = TPL.contentDirectives.info;
	            this.scope = {
	                params: "=params"
	            };
	            var availableCities = session.getAvailableCities();
	            this.link = function (scope, el, attrs) {
	                var dateFilter = $filter("date");
	                var translateFilter = $filter("translate");
	                scope.vm = {
	                    infoParams: {
	                        items: [{ visible: true }, { visible: true }, { visible: true }, { visible: true }]
	                    },
	                    getData: function () {
	                        if (scope.params.items) {
	                            return scope.params.items;
	                        }
	                        return scope.vm.getInfoParams(scope.params.event);
	                    },
	                    getInfoParams: function (event) {
	                        if (event) {
	                            scope.vm.infoParams.items[0].icon = "icon-calendar ot-grey-icon";
	                            scope.vm.infoParams.items[0].text = scope.vm.buildPrettyDate(event.event_date);
	                            if (scope.vm.isNear(event.event_date)) {
	                                scope.vm.infoParams.items[0].class = "ot-hilight";
	                            }
	                            scope.vm.infoParams.items[1].icon = "icon-clock ot-grey-icon";
	                            scope.vm.infoParams.items[1].text = scope.vm.buildPrettyHours(event.event_date, event.event_time, event.duration);
	                            scope.vm.infoParams.items[2].icon = "icon-marker ot-grey-icon";
	                            var locationLabel = "";
	                            if (event.area_code) {
	                                var area = _.find(availableCities, { code: event.area_code });
	                                if (area) {
	                                    locationLabel = area.code == "OTHER" ? event.area_other : area.label;
	                                }
	                            }
	                            if (event.neighborhood_code) {
	                                var neighborhood = _.find(area.neighborhoods, { code: event.neighborhood_code });
	                                if (neighborhood) {
	                                    locationLabel += ", " + neighborhood.label;
	                                }
	                            }
	                            if (scope.params.showFullAddress && event.full_address) {
	                                locationLabel = event.full_address;
	                            }
	                            locationLabel = locationLabel || "";
	                            if (scope.params.limit != null && locationLabel.length > scope.params.limit) {
	                                scope.vm.infoParams.items[2].text = locationLabel.substr(0, scope.params.limit) + "...";
	                            }
	                            else {
	                                scope.vm.infoParams.items[2].text = locationLabel;
	                            }
	                            if (!event.secondary_address) {
	                                scope.vm.infoParams.items[3].visible = false;
	                            }
	                            else {
	                                scope.vm.infoParams.items[3].visible = true;
	                            }
	                            if (!scope.params.showSecondaryAddress) {
	                                scope.vm.infoParams.items[3].visible = false;
	                            }
	                            scope.vm.infoParams.items[3].icon = "icon-marker ot-grey-icon";
	                            var location2Label = event.secondary_address || "";
	                            if (scope.params.limit != null && location2Label.length > scope.params.limit) {
	                                scope.vm.infoParams.items[3].text = location2Label.substr(0, scope.params.limit) + "...";
	                            }
	                            else {
	                                scope.vm.infoParams.items[3].text = location2Label;
	                            }
	                        }
	                        return scope.vm.infoParams;
	                    },
	                    isNear: function (rawData) {
	                        var d = session_1.SessionService.toDate(rawData, true);
	                        return session_1.SessionService.isToday(d) || session_1.SessionService.isTomorrow(d);
	                    },
	                    buildPrettyDate: function (rawData) {
	                        var d = session_1.SessionService.toDate(rawData, true);
	                        if (session_1.SessionService.isToday(d)) {
	                            return translateFilter("LANDING.TODAY");
	                        }
	                        else if (session_1.SessionService.isTomorrow(d)) {
	                            return translateFilter("LANDING.TOMORROW");
	                        }
	                        else {
	                            return dateFilter(d, "EEEE, MMMM d");
	                        }
	                    },
	                    buildPrettyHours: function (rawDate, rawTime, duration) {
	                        var dStart = session_1.SessionService.toDate(rawDate, true);
	                        var hrsMins = rawTime.split(":");
	                        dStart.setHours(parseInt(hrsMins[0]));
	                        dStart.setMinutes(parseInt(hrsMins[1]));
	                        var dEnd = new Date(dStart.getTime() + duration * 1000);
	                        if (isNaN(dStart.getTime()) || isNaN(dEnd.getTime())) {
	                            return "";
	                        }
	                        var startMinutes = dStart.getMinutes();
	                        var endMinutes = dEnd.getMinutes();
	                        var dateStartString = dateFilter(dStart, "h:mma").toLowerCase();
	                        var dateEndString = dateFilter(dEnd, "h:mma").toLowerCase();
	                        return dateStartString + " - " + dateEndString;
	                    }
	                };
	            };
	        }
	        InfoDirective.factory = function () {
	            var tmp = function (a, b) { return new InfoDirective(a, b); };
	            tmp.$inject = ["$filter", "session"];
	            return tmp;
	        };
	        return InfoDirective;
	    })();
	    exports.InfoDirective = InfoDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, angular, TPL) {
	    var InviteGuestsDirective = (function () {
	        function InviteGuestsDirective(session, $log) {
	            var _this = this;
	            this.template = TPL.contentDirectives.inviteGuests;
	            this.scope = {
	                params: "=params",
	            };
	            this.session = session;
	            this.link = function (scope, el, attrs) {
	                scope.tags = [];
	                scope.emailText = "";
	                scope.placeholder = "Insert your friends emails";
	                scope.vm = {
	                    getTags: function () {
	                        return scope.tags;
	                    },
	                    canSend: function () {
	                        return scope.tags.length != 0;
	                    },
	                    isValidEmail: function (value) {
	                        if (!value) {
	                            return false;
	                        }
	                        var regex = /^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/i;
	                        return regex.exec(value) != null;
	                    },
	                    inviteGuests: function (form) {
	                        $log.debug("inviteGuests");
	                        angular.forEach(scope.tags, function (tag) {
	                            var email = tag.text;
	                            var emails = [];
	                            if (scope.vm.isValidEmail(email)) {
	                                $log.debug("Valid email:" + email);
	                                emails.push(email);
	                            }
	                            else {
	                                $log.debug("Invalid email:" + email);
	                            }
	                            if (emails.length > 0) {
	                                _this.session.sendInvitations("guest-invitation", emails, scope.emailText).then(function () {
	                                    scope.params.onSuccessCallback();
	                                });
	                            }
	                            else {
	                            }
	                        });
	                        return true;
	                    }
	                };
	            };
	        }
	        InviteGuestsDirective.factory = function () {
	            var tmp = function (a, b) { return new InviteGuestsDirective(a, b); };
	            tmp.$inject = ["session", "$log"];
	            return tmp;
	        };
	        return InviteGuestsDirective;
	    })();
	    exports.InviteGuestsDirective = InviteGuestsDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, config_1) {
	    var ManageHeaderDirective = (function () {
	        function ManageHeaderDirective(session, $routeParams) {
	            this.template = TPL.contentDirectives.manageHeader;
	            this.scope = {
	                params: "=params"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    session: session,
	                    section: $routeParams.what,
	                    getUpcomingCount: function () {
	                        return scope.params.upcoming;
	                    },
	                    getHostedCount: function () {
	                        return scope.params.hosted;
	                    },
	                    getSavedCount: function () {
	                        return scope.params.saved;
	                    },
	                    getPastCount: function () {
	                        return scope.params.past;
	                    },
	                    isOnward: function () {
	                        return config_1.Config.isOnward;
	                    }
	                };
	            };
	        }
	        ManageHeaderDirective.factory = function () {
	            var tmp = function (a, b) { return new ManageHeaderDirective(a, b); };
	            tmp.$inject = ["session", "$routeParams"];
	            return tmp;
	        };
	        return ManageHeaderDirective;
	    })();
	    exports.ManageHeaderDirective = ManageHeaderDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, config_1) {
	    var ManageMenuItem = (function () {
	        function ManageMenuItem() {
	        }
	        ManageMenuItem.buildManageMenuItem = function (label, key, linkUrl, callback, subMenu, orange, red) {
	            var result = new ManageMenuItem();
	            result.label = label;
	            result.key = key;
	            result.linkUrl = linkUrl;
	            result.callback = callback;
	            result.subMenu = subMenu;
	            result.orange = orange ? orange : function () { return 0; };
	            result.red = red ? red : function () { return 0; };
	            return result;
	        };
	        return ManageMenuItem;
	    })();
	    exports.ManageMenuItem = ManageMenuItem;
	    var ManageMenuItemList = (function (_super) {
	        __extends(ManageMenuItemList, _super);
	        function ManageMenuItemList() {
	            _super.call(this);
	        }
	        ManageMenuItemList.buildManageMenuItemList = function ($location) {
	            var result = new ManageMenuItemList();
	            var innerHosting = new ManageMenuItemList();
	            innerHosting.push(ManageMenuItem.buildManageMenuItem("MANAGE.HOSTED", config_1.Config.hosted, config_1.Config.linkHash + config_1.Config.manage + "/" + config_1.Config.hosted, function () {
	            }, null, function () { return 0; }));
	            innerHosting.push(ManageMenuItem.buildManageMenuItem("MANAGE.SAVED", config_1.Config.saved, config_1.Config.linkHash + config_1.Config.manage + "/" + config_1.Config.saved, function () {
	            }, null, function () { return 0; }, function () { return 0; }));
	            innerHosting.push(ManageMenuItem.buildManageMenuItem("MANAGE.PAST", config_1.Config.past, config_1.Config.linkHash + config_1.Config.manage + "/" + config_1.Config.past, function () {
	            }, null, function () { return 0; }, function () { return 0; }));
	            result.push(ManageMenuItem.buildManageMenuItem("MANAGE.HOSTING", null, null, null, innerHosting));
	            result.push(ManageMenuItem.buildManageMenuItem("MANAGE.UPCOMING", config_1.Config.upcoming, config_1.Config.linkHash + config_1.Config.manage + "/" + config_1.Config.upcoming, function () {
	            }, null, function () { return 0; }, function () { return 0; }));
	            return result;
	        };
	        return ManageMenuItemList;
	    })(Array);
	    exports.ManageMenuItemList = ManageMenuItemList;
	    var ManageMenuDirective = (function () {
	        function ManageMenuDirective($location, $routeParams, $modal, session) {
	            this.template = TPL.contentDirectives.manageMenu;
	            this.scope = {
	                params: "=params"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    menuItemList: ManageMenuItemList.buildManageMenuItemList($location),
	                    current: $routeParams.what,
	                    openCreatePage: function () {
	                        $location.path(config_1.Config.events);
	                        $location.replace();
	                    }
	                };
	            };
	        }
	        ManageMenuDirective.factory = function () {
	            var tmp = function (a, b, c, d) { return new ManageMenuDirective(a, b, c, d); };
	            tmp.$inject = ["$location", "$routeParams", "$uibModal", "session"];
	            return tmp;
	        };
	        return ManageMenuDirective;
	    })();
	    exports.ManageMenuDirective = ManageMenuDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var ModalActionBarDirective = (function () {
	        function ModalActionBarDirective() {
	            this.template = TPL.contentDirectives.modalActionBar;
	            this.scope = {
	                params: "=params"
	            };
	        }
	        ModalActionBarDirective.factory = function () {
	            return function () { return new ModalActionBarDirective(); };
	        };
	        return ModalActionBarDirective;
	    })();
	    exports.ModalActionBarDirective = ModalActionBarDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var NotificationDirective = (function () {
	        function NotificationDirective() {
	            this.template = TPL.contentDirectives.notification;
	            this.scope = {
	                params: "=params"
	            };
	        }
	        NotificationDirective.factory = function () {
	            var tmp = function () { return new NotificationDirective(); };
	            return tmp;
	        };
	        return NotificationDirective;
	    })();
	    exports.NotificationDirective = NotificationDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var PriceBadgeDirective = (function () {
	        function PriceBadgeDirective() {
	            this.template = TPL.contentDirectives.priceBadge;
	            this.scope = {
	                params: "=params"
	            };
	        }
	        PriceBadgeDirective.factory = function () {
	            return function () { return new PriceBadgeDirective(); };
	        };
	        return PriceBadgeDirective;
	    })();
	    exports.PriceBadgeDirective = PriceBadgeDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(2), __webpack_require__(364), __webpack_require__(9), __webpack_require__(5), __webpack_require__(152)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, angular, TPL, rsvp_1, login_1, confirm_1, manageGuests_1) {
	    var RsvpDirective = (function () {
	        function RsvpDirective($modal, session, $location, $rootScope, stripe, notification, $log) {
	            this.template = TPL.contentDirectives.rsvp;
	            this.scope = {
	                params: "=params"
	            };
	            var event = session.getData().event;
	            $log.debug("Event: " + event);
	            $log.debug(event);
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    openCancelReservationConfirm: function () {
	                        var modalView = confirm_1.ConfirmController.openConfirmDeleteReservationModal($modal, function () {
	                            var event = session.getData().event;
	                            session.deleteReservation(event.uuid).then(function () {
	                                modalView.dismiss();
	                                notification.success("Reservation deleted");
	                            }).then(function () {
	                                session.loadEvent(event.uuid).then(function () {
	                                    session.loadMyReservations();
	                                });
	                            });
	                        }, function () {
	                            modalView.dismiss();
	                        });
	                    },
	                    openInviteGuests: function () {
	                        var event = session.getData().event;
	                        manageGuests_1.ManageGuestsController.open($modal, event.uuid);
	                    },
	                    getReservationStatus: function () {
	                        var event = session.getData().event;
	                        var myreservations = session.getData().myReservations;
	                        var myReservState;
	                        angular.forEach(myreservations, function (value) {
	                            if (event && value.event_id == event.id) {
	                                myReservState = value.state;
	                            }
	                        });
	                        if (!event) {
	                            return 0;
	                        }
	                        if (session.user.user_id == event.created_by_profile.id) {
	                            return 5;
	                        }
	                        if (myReservState) {
	                            if (myReservState == "pending") {
	                                return 1;
	                            }
	                            else if (myReservState == "accepted") {
	                                return 2;
	                            }
	                            else if (myReservState == "rejected") {
	                                return 6;
	                            }
	                            else if (myReservState != "rejected") {
	                                return 3;
	                            }
	                        }
	                        if (event.reservations_stats && event.reservations_stats.guests_accepted >= event.number_of_guests_max) {
	                            return 4;
	                        }
	                        return 0;
	                    },
	                    isRsvp: function () {
	                        var event = session.getData().event;
	                        if (event != null) {
	                            return event.event_type != "manual_approval";
	                        }
	                        else {
	                            return false;
	                        }
	                    },
	                    isManualApproval: function () {
	                        var event = session.getData().event;
	                        if (event != null) {
	                            return event.event_type == "manual_approval";
	                        }
	                        else {
	                            return false;
	                        }
	                    },
	                    openRsvpModal: function () {
	                        if (session.isNotLogging()) {
	                            scope.vm.currentModal = login_1.LoginController.openLoginModal($modal, scope.vm, $rootScope, function () {
	                                scope.vm.currentModal = rsvp_1.RsvpController.openRsvpModal($modal, scope.vm, session, $location, stripe, notification, $log);
	                            });
	                        }
	                        else {
	                            scope.vm.currentModal = rsvp_1.RsvpController.openRsvpModal($modal, scope.vm, session, $location, stripe, notification, $log);
	                        }
	                    }
	                };
	            };
	        }
	        RsvpDirective.factory = function () {
	            var tmp = function (a, b, c, d, e, f, g) { return new RsvpDirective(a, b, c, d, e, f, g); };
	            tmp.$inject = ["$uibModal", "session", "$location", "$rootScope", "stripe", "Notification", "$log"];
	            return tmp;
	        };
	        return RsvpDirective;
	    })();
	    exports.RsvpDirective = RsvpDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, data_1) {
	    var SearchDirective = (function () {
	        function SearchDirective() {
	            this.template = TPL.contentDirectives.search;
	            this.scope = {
	                params: "=params"
	            };
	        }
	        SearchDirective.factory = function () {
	            var tmp = function () { return new SearchDirective(); };
	            return tmp;
	        };
	        return SearchDirective;
	    })();
	    exports.SearchDirective = SearchDirective;
	    var SearchFilterDirective = (function () {
	        function SearchFilterDirective(session) {
	            this.template = TPL.contentDirectives.searchFilter;
	            this.scope = {
	                params: "=params"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    session: session,
	                    eventTypeOptions: [
	                        data_1.EventType.ALL,
	                        data_1.EventType.PUBLIC,
	                        data_1.EventType.MANUAL,
	                        data_1.EventType.PRIVATE
	                    ],
	                    costTypeOptions: [
	                        data_1.CostType.ALL,
	                        data_1.CostType.FREE,
	                        data_1.CostType.PAID
	                    ],
	                    availableDates: [
	                        { id: "1", date: new Date(1970, 1, 1, 0, 0, 0, 0), label: "All" },
	                        { id: "4", date: new Date(2016, 9, 19, 19, 0, 0, 0), label: "10/19/2016" }
	                    ],
	                    minEventDate: new Date(2016, 9, 24, 19, 0, 0, 0),
	                    getDateLabel: function () {
	                        if (scope.params.filter.minDate) {
	                            var dateLabel;
	                            if (scope.params.filter.minDate.getFullYear() == 1970) {
	                                dateLabel = "All";
	                                scope.params.filter.minDate = new Date();
	                                scope.params.filter.maxDate = undefined;
	                            }
	                            else {
	                                dateLabel = (scope.params.filter.minDate.getMonth() + 1) + "/" + scope.params.filter.minDate.getDate() + "/" + scope.params.filter.minDate.getFullYear();
	                            }
	                        }
	                        return dateLabel;
	                    }
	                };
	            };
	        }
	        SearchFilterDirective.factory = function () {
	            var tmp = function (a) { return new SearchFilterDirective(a); };
	            tmp.$inject = ["session"];
	            return tmp;
	        };
	        return SearchFilterDirective;
	    })();
	    exports.SearchFilterDirective = SearchFilterDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, config_1) {
	    var SearchDescriptionDirective = (function () {
	        function SearchDescriptionDirective(location, $log) {
	            this.template = TPL.contentDirectives.searchDescription;
	            this.scope = {
	                params: "=params"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    goTo: function (city) {
	                        $log.debug("goTo");
	                        $log.debug(city);
	                        location.url(config_1.Config.home + "/" + city.url);
	                    },
	                    getUrl: function (city) {
	                        return "#" + config_1.Config.home + "/" + city.url;
	                    }
	                };
	            };
	        }
	        SearchDescriptionDirective.factory = function () {
	            var tmp = function (a, b) { return new SearchDescriptionDirective(a, b); };
	            tmp.$inject = ["$location", "$log"];
	            return tmp;
	        };
	        return SearchDescriptionDirective;
	    })();
	    exports.SearchDescriptionDirective = SearchDescriptionDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var Type = (function () {
	        function Type() {
	        }
	        Type.buildType = function (key, label, iconClass) {
	            var result = new Type();
	            result.key = key;
	            result.label = label;
	            result.iconClass = iconClass;
	            return result;
	        };
	        Type.createDummyType = function () {
	            var result = new Type();
	            result.label = "Label " + Type.idGen++;
	            result.iconClass = "glyphicon glyphicon-asterisk";
	            return result;
	        };
	        Type.idGen = 0;
	        return Type;
	    })();
	    exports.Type = Type;
	    var TypeList = (function (_super) {
	        __extends(TypeList, _super);
	        function TypeList() {
	            _super.call(this);
	        }
	        TypeList.buildCompleteTypeList = function () {
	            var result = new TypeList();
	            result.push(Type.buildType("alcohol_free", "CREATE.ALCOHOL_TYPE_FREE", "ot-icon-alcohol-free"));
	            result.push(Type.buildType("byob", "CREATE.ALCOHOL_TYPE_BYOB", "ot-icon-byob"));
	            result.push(Type.buildType("host_provides", "CREATE.ALCOHOL_TYPE_HOST_PROVIDES", "ot-icon-beer-and-wine"));
	            result.push(Type.buildType("vegetarian", "CREATE.DIET_TYPE_VEGETARIAN", "ot-icon-vegetarian"));
	            result.push(Type.buildType("vegan", "CREATE.DIET_TYPE_VEGAN", "ot-icon-vegan"));
	            result.push(Type.buildType("gluten_free", "CREATE.DIET_TYPE_GLUTEN_FREE", "ot-icon-gluten-free"));
	            result.push(Type.buildType("kosher", "CREATE.DIET_TYPE_KOSHER", "ot-icon-kosher"));
	            return result;
	        };
	        return TypeList;
	    })(Array);
	    exports.TypeList = TypeList;
	    var TypeListDirective = (function () {
	        function TypeListDirective() {
	            this.template = TPL.contentDirectives.typeList;
	            this.scope = {
	                params: "=params"
	            };
	            this.link = function (scope, el, attrs) {
	                var typeList = TypeList.buildCompleteTypeList();
	                scope.vm = {
	                    typeList: typeList
	                };
	            };
	        }
	        TypeListDirective.factory = function () {
	            return function () { return new TypeListDirective(); };
	        };
	        return TypeListDirective;
	    })();
	    exports.TypeListDirective = TypeListDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, data_1) {
	    var TypePickerDirective = (function () {
	        function TypePickerDirective(session) {
	            this.template = TPL.contentDirectives.typePicker;
	            this.scope = {
	                params: "=params",
	                form: "=form",
	                alcohol: "=alcohol",
	                meal: "=meal",
	                dietary: "=dietary",
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    session: session,
	                    mealTypeOptions: [
	                        data_1.MealType.HOME_COOKED,
	                        data_1.MealType.ORDERED_IN,
	                        data_1.MealType.BUFFET
	                    ],
	                    alcoholTypeOptions: [
	                        data_1.AlcoholType.HOST_PROVIDES,
	                        data_1.AlcoholType.BYOB,
	                        data_1.AlcoholType.ALCOHOL_FREE
	                    ],
	                    dietTypeOptions: [
	                        data_1.DietType.VEGETARIAN,
	                        data_1.DietType.VEGAN,
	                        data_1.DietType.GLUTEN_FREE,
	                        data_1.DietType.KOSHER
	                    ]
	                };
	            };
	        }
	        TypePickerDirective.factory = function () {
	            var tmp = function (a) { return new TypePickerDirective(a); };
	            tmp.$inject = ["session"];
	            return tmp;
	        };
	        return TypePickerDirective;
	    })();
	    exports.TypePickerDirective = TypePickerDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var BurgerDirective = (function () {
	        function BurgerDirective(session, $modal) {
	            this.scope = {
	                params: "=params"
	            };
	            this.template = TPL.navigationDirectives.burger;
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    session: session,
	                    openMenuModal: function () {
	                        BurgerDirective.currentModal = $modal.open({
	                            controller: function () { return scope.vm; },
	                            controllerAs: "vm",
	                            replace: true,
	                            size: "fs",
	                            backdropClass: "of-burger-backdrop",
	                            windowClass: "of-burger-window",
	                            template: TPL.modals.burger
	                        });
	                    },
	                };
	            };
	        }
	        BurgerDirective.factory = function () {
	            var tmp = function (a, b) { return new BurgerDirective(a, b); };
	            tmp.$inject = ["session", "$uibModal"];
	            return tmp;
	        };
	        return BurgerDirective;
	    })();
	    exports.BurgerDirective = BurgerDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(362)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, forgot_1) {
	    var EmailLoginDirective = (function () {
	        function EmailLoginDirective(session, $modal, $rootScope) {
	            this.scope = {
	                params: "=params"
	            };
	            this.template = TPL.navigationDirectives.emailLogin;
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    session: session,
	                    currentModal: scope.params.modal,
	                    hasFailedLogin: false,
	                    submit: function (form) {
	                        if (form.$valid) {
	                            session.loginWithPassword(scope.vm.email, scope.vm.password)
	                                .catch(function (error) {
	                                scope.vm.hasFailedLogin = true;
	                            });
	                        }
	                    },
	                    openForgotModal: function () {
	                        scope.vm.hasFailedLogin = false;
	                        if (scope.vm.currentModal) {
	                            scope.vm.currentModal.dismiss();
	                        }
	                        scope.vm.currentModal = forgot_1.ForgotController.openForgotModal($modal, scope.vm, $rootScope, session);
	                    }
	                };
	            };
	        }
	        EmailLoginDirective.factory = function () {
	            var tmp = function (a, b, c) { return new EmailLoginDirective(a, b, c); };
	            tmp.$inject = ["session", "$uibModal", "$rootScope"];
	            return tmp;
	        };
	        return EmailLoginDirective;
	    })();
	    exports.EmailLoginDirective = EmailLoginDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, angular, TPL) {
	    var EmailSignupDirective = (function () {
	        function EmailSignupDirective(session, $rootScope, $modal, $filter, $log) {
	            this.scope = {};
	            var translate = $filter('translate');
	            this.template = TPL.navigationDirectives.emailSignup;
	            this.link = function (scope, el, attrs) {
	                scope.$watch('date', function (newvalue, oldvalue) {
	                    $log.debug("watch: " + newvalue);
	                });
	                scope.vm = {
	                    birthdayFocused: false,
	                    session: session,
	                    signupData: {
	                        highSchoolSelected: "",
	                        genderSelected: "",
	                        bbyoMemberSelected: "",
	                    },
	                    highSchoolOptions: [
	                        "2017",
	                        "2018",
	                        "2019",
	                        "2020",
	                        "2021"
	                    ],
	                    genderOptions: [
	                        "M",
	                        "F",
	                        "I do not identity with either"
	                    ],
	                    bbyoMemberOptions: [
	                        "I'm not a member",
	                        "Big Apple",
	                        "Central Region West",
	                        "CSR",
	                        "Connecticut Valley",
	                        "Eastern",
	                        "Evergreen",
	                        "Gold Coast",
	                        "GJHRR",
	                        "Great Midwest",
	                        "Kentucky Indiana Ohio",
	                        "Keystone Mountain",
	                        "Liberty",
	                        "Lonestar",
	                        "Manhattan",
	                        "Mid America",
	                        "Michigan",
	                        "Miami",
	                        "Mountain",
	                        "New England",
	                        "North Florida",
	                        "NRE: DC Council",
	                        "NRE: Baltimore",
	                        "NRE: Nova",
	                        "Nassau Suffolk",
	                        "North Texas Oklahoma",
	                        "Ohio Northern",
	                        "Pacific Western",
	                        "Rocky Mountain",
	                        "South Jersey",
	                        "Southern: Atlanta",
	                        "Southern: Dixie",
	                        "Westchester",
	                        "Wisconsin"
	                    ],
	                    errorPasswordTooShort: false,
	                    errorEmailAlreadyUsed: false,
	                    errorEmailNotValid: false,
	                    setBirthdayFocus: function (focused) {
	                        scope.vm.birthdayFocused = focused;
	                    },
	                    getBirthdayPlaceholder: function () {
	                        if (scope.vm.birthdayFocused) {
	                            return translate('LOGIN.SIGN_UP_DATE_PLACEHOLDER_EXAMPLE');
	                        }
	                        else {
	                            return translate('LOGIN.SIGN_UP_DATE_PLACEHOLDER');
	                        }
	                    },
	                    birthdateKeyUp: function () {
	                        var currentDate = scope.signupForm.date.$viewValue;
	                        if (currentDate != null) {
	                            if (currentDate.length == 2) {
	                                $log.debug("birthdateKeyUp " + scope.signupForm.date.$viewValue + "<2>");
	                            }
	                            else if (currentDate.length == 5) {
	                                $log.debug("birthdateKeyUp " + scope.signupForm.date.$viewValue + "<5>");
	                            }
	                            $log.debug("birthdateKeyUp " + scope.signupForm.date.$viewValue);
	                        }
	                    },
	                    submit: function (form) {
	                        if (form.$valid) {
	                            session.signup(scope.vm.signupData).then(function () {
	                                session.loginWithPassword(scope.vm.signupData.newEmail, scope.vm.signupData.newPassword);
	                            }).catch(function (error) {
	                                $log.debug(error);
	                                if (error.status == 422) {
	                                    if (angular.isDefined(error.data.errors.email)) {
	                                        angular.forEach(error.data.errors.email, function (value) {
	                                            if (value.indexOf("is invalid") >= 0) {
	                                                scope.vm.errorEmailNotValid = true;
	                                            }
	                                            if (value.indexOf("has already been taken") >= 0) {
	                                                scope.vm.errorEmailAlreadyUsed = true;
	                                            }
	                                        });
	                                    }
	                                    else if (angular.isDefined(error.data.errors.password)) {
	                                        scope.vm.errorPasswordTooShort = true;
	                                    }
	                                }
	                            });
	                        }
	                    }
	                };
	            };
	        }
	        EmailSignupDirective.factory = function () {
	            var tmp = function (a, b, c, d, e) { return new EmailSignupDirective(a, b, c, d, e); };
	            tmp.$inject = ["session", "$rootScope", "$uibModal", "$filter", "$log"];
	            return tmp;
	        };
	        return EmailSignupDirective;
	    })();
	    exports.EmailSignupDirective = EmailSignupDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var FacebookLoginDirective = (function () {
	        function FacebookLoginDirective(session, $modal, $rootScope, $log) {
	            this.template = TPL.navigationDirectives.facebookLogin;
	            this.scope = {
	                name: "=name",
	                value: "=value"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    session: session,
	                    facebook: FB,
	                    loginWithFacebook: function () {
	                        FB.login(function (responseLogin) {
	                            $log.debug(responseLogin);
	                            session.loginWithFb(responseLogin.authResponse.userID, responseLogin.authResponse.accessToken)
	                                .then(function () {
	                            });
	                        }, { scope: 'public_profile, email' });
	                    },
	                };
	            };
	        }
	        FacebookLoginDirective.factory = function () {
	            var tmp = function (a, b, c, d) { return new FacebookLoginDirective(a, b, c, d); };
	            tmp.$inject = ["session", "$uibModal", "$rootScope", "$log"];
	            return tmp;
	        };
	        FacebookLoginDirective.prototype.makeFbLogin = function () {
	            FB.login(function (response) {
	                this.session.loginWithFb(response.userID, response.accessToken);
	            });
	        };
	        return FacebookLoginDirective;
	    })();
	    exports.FacebookLoginDirective = FacebookLoginDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var FooterDirective = (function () {
	        function FooterDirective(session) {
	            this.template = TPL.navigationDirectives.footer;
	            this.scope = function (scope) {
	                scope.vm = {
	                    session: session
	                };
	            };
	        }
	        FooterDirective.factory = function () {
	            var tmp = function (a) { return new FooterDirective(a); };
	            tmp.$inject = ["session"];
	            return tmp;
	        };
	        return FooterDirective;
	    })();
	    exports.FooterDirective = FooterDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var HeaderDirective = (function () {
	        function HeaderDirective(session) {
	            this.scope = {};
	            this.template = TPL.navigationDirectives.header;
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    session: session,
	                    getLogoType: function () {
	                        return "navbar";
	                    }
	                };
	            };
	        }
	        HeaderDirective.factory = function () {
	            var tmp = function (a) { return new HeaderDirective(a); };
	            tmp.$inject = ["session"];
	            return tmp;
	        };
	        return HeaderDirective;
	    })();
	    exports.HeaderDirective = HeaderDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, login_1) {
	    var HireDirective = (function () {
	        function HireDirective($modal, $rootScope) {
	            this.template = TPL.navigationDirectives.hire;
	            this.scope = {
	                params: "=params"
	            };
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    openLoginModal: function (which) {
	                        if (which == "login") {
	                            scope.vm.currentModal = login_1.LoginController.openLoginModal($modal, scope.vm, $rootScope);
	                        }
	                        else {
	                            scope.vm.currentModal = login_1.LoginController.openSignupModal($modal, scope.vm, $rootScope);
	                        }
	                    }
	                };
	            };
	        }
	        HireDirective.factory = function () {
	            var tmp = function (a, b) { return new HireDirective(a, b); };
	            tmp.$inject = ["$uibModal", "$rootScope"];
	            return tmp;
	        };
	        return HireDirective;
	    })();
	    exports.HireDirective = HireDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var Indicator = (function () {
	        function Indicator() {
	        }
	        Indicator.createDummyIndicator = function () {
	            var result = new Indicator();
	            result.id = Indicator.idGen++;
	            result.name = "name" + result.id.toString();
	            result.notificationCount = 4;
	            return result;
	        };
	        Indicator.idGen = 0;
	        return Indicator;
	    })();
	    exports.Indicator = Indicator;
	    var IndicatorList = (function (_super) {
	        __extends(IndicatorList, _super);
	        function IndicatorList() {
	            _super.call(this);
	        }
	        IndicatorList.buildIndicatorList = function () {
	            var result = new IndicatorList();
	            return result;
	        };
	        return IndicatorList;
	    })(Array);
	    exports.IndicatorList = IndicatorList;
	    var IndicatorListDirective = (function () {
	        function IndicatorListDirective() {
	            this.scope = {};
	            this.template = TPL.navigationDirectives.indicatorList;
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    indicatorList: IndicatorList.buildIndicatorList()
	                };
	            };
	        }
	        IndicatorListDirective.factory = function () {
	            var tmp = function () { return new IndicatorListDirective(); };
	            return tmp;
	        };
	        return IndicatorListDirective;
	    })();
	    exports.IndicatorListDirective = IndicatorListDirective;
	    var IndicatorDirective = (function () {
	        function IndicatorDirective() {
	            this.scope = {
	                item: "=item"
	            };
	            this.template = TPL.navigationDirectives.indicator;
	        }
	        IndicatorDirective.factory = function () {
	            var tmp = function () { return new IndicatorDirective(); };
	            return tmp;
	        };
	        return IndicatorDirective;
	    })();
	    exports.IndicatorDirective = IndicatorDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, config_1) {
	    var MenuItem = (function () {
	        function MenuItem() {
	        }
	        MenuItem.createMenuItem = function (label, linkUrl, callback) {
	            var result = new MenuItem();
	            result.label = label;
	            result.callback = callback;
	            result.linkUrl = linkUrl;
	            return result;
	        };
	        return MenuItem;
	    })();
	    exports.MenuItem = MenuItem;
	    var MenuItemList = (function (_super) {
	        __extends(MenuItemList, _super);
	        function MenuItemList() {
	            _super.call(this);
	        }
	        MenuItemList.buildMenu = function (session, location, modal, rootScope) {
	            var result = new MenuItemList();
	            var hosted;
	            if (session.isHost()) {
	                hosted = "#" + config_1.Config.manage + "/" + config_1.Config.hosted;
	            }
	            else {
	                hosted = "#" + config_1.Config.manage + "/" + config_1.Config.upcoming;
	            }
	            result.push(MenuItem.createMenuItem("MENU.MANAGE_EVENTS", hosted, function () {
	            }));
	            result.push(MenuItem.createMenuItem("MENU.CREATE_DINNER", config_1.Config.linkHash + config_1.Config.events, function () { }));
	            result.push(MenuItem.createMenuItem("MENU.SETTINGS", config_1.Config.linkHash + config_1.Config.profile, function () { }));
	            result.push(MenuItem.createMenuItem("MENU.LOGOUT", config_1.Config.linkHash + config_1.Config.home, function () {
	                session.logout();
	            }));
	            return result;
	        };
	        return MenuItemList;
	    })(Array);
	    exports.MenuItemList = MenuItemList;
	    var UserRecapDirective = (function () {
	        function UserRecapDirective(session, $location, $modal, $rootScope, $log) {
	            this.scope = {
	                params: "=params"
	            };
	            this.template = TPL.navigationDirectives.userRecap;
	            this.link = function (scope, el, attrs) {
	                scope.vm = {
	                    session: session,
	                    menuItemList: MenuItemList.buildMenu(session, $location, $modal, $rootScope)
	                };
	                scope.$watch(function () { return session.isHost(); }, function () {
	                    scope.vm.menuItemList = MenuItemList.buildMenu(session, $location, $modal, $rootScope);
	                });
	            };
	        }
	        UserRecapDirective.factory = function () {
	            var tmp = function (a, b, c, d, e) { return new UserRecapDirective(a, b, c, d, e); };
	            tmp.$inject = ["session", "$location", "$uibModal", "$rootScope", "$log"];
	            return tmp;
	        };
	        return UserRecapDirective;
	    })();
	    exports.UserRecapDirective = UserRecapDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    function ageFilter() {
	        var calculateAge = function (birthday) {
	            var ageDifMs = Date.now() - birthday.getTime();
	            var ageDate = new Date(ageDifMs);
	            return Math.abs(ageDate.getUTCFullYear() - 1970);
	        };
	        return function (birthDate) {
	            if (!birthDate) {
	                return -1;
	            }
	            return calculateAge(birthDate);
	        };
	    }
	    exports.ageFilter = ageFilter;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, data_1) {
	    function enumNameFilter() {
	        var events = [
	            {
	                value: data_1.EventType.PUBLIC,
	                label: "CREATE.EVENT_TYPE_PUBLIC"
	            },
	            {
	                value: data_1.EventType.PRIVATE,
	                label: "CREATE.EVENT_TYPE_PRIVATE"
	            },
	            {
	                value: data_1.EventType.MANUAL,
	                label: "CREATE.EVENT_TYPE_MANUAL"
	            },
	            {
	                value: data_1.EventType.ALL,
	                label: "CREATE.EVENT_TYPE_ALL"
	            }
	        ];
	        var eventExplainations = [
	            {
	                value: data_1.EventType.PUBLIC,
	                label: "CREATE.EVENT_TYPE_PUBLIC_HELP"
	            },
	            {
	                value: data_1.EventType.PRIVATE,
	                label: "CREATE.EVENT_TYPE_PRIVATE_HELP"
	            },
	            {
	                value: data_1.EventType.MANUAL,
	                label: "CREATE.EVENT_TYPE_MANUAL_HELP"
	            },
	            {
	                value: data_1.EventType.ALL,
	                label: "CREATE.EVENT_TYPE_ALL_HELP"
	            }
	        ];
	        var meals = [
	            {
	                value: data_1.MealType.HOME_COOKED,
	                label: "CREATE.MEAL_TYPE_HOME_COOKED"
	            },
	            {
	                value: data_1.MealType.ORDERED_IN,
	                label: "CREATE.MEAL_TYPE_ORDERED_IN"
	            },
	            {
	                value: data_1.MealType.BUFFET,
	                label: "CREATE.MEAL_TYPE_BUFFET"
	            }
	        ];
	        var alcohols = [
	            {
	                value: data_1.AlcoholType.HOST_PROVIDES,
	                label: "CREATE.ALCOHOL_TYPE_HOST_PROVIDES"
	            },
	            {
	                value: data_1.AlcoholType.BYOB,
	                label: "CREATE.ALCOHOL_TYPE_BYOB"
	            },
	            {
	                value: data_1.AlcoholType.ALCOHOL_FREE,
	                label: "CREATE.ALCOHOL_TYPE_FREE"
	            },
	            {
	                value: data_1.AlcoholType.ALL,
	                label: "CREATE.ALCOHOL_TYPE_ALL"
	            }
	        ];
	        var diets = [
	            {
	                value: data_1.DietType.VEGETARIAN,
	                label: "CREATE.DIET_TYPE_VEGETARIAN"
	            },
	            {
	                value: data_1.DietType.VEGAN,
	                label: "CREATE.DIET_TYPE_VEGAN"
	            },
	            {
	                value: data_1.DietType.GLUTEN_FREE,
	                label: "CREATE.DIET_TYPE_GLUTEN_FREE"
	            },
	            {
	                value: data_1.DietType.KOSHER,
	                label: "CREATE.DIET_TYPE_KOSHER"
	            },
	            {
	                value: data_1.DietType.ALL,
	                label: "CREATE.DIET_TYPE_ALL"
	            }
	        ];
	        var costs = [
	            {
	                value: data_1.CostType.FREE,
	                label: "CREATE.COST_TYPE_FREE"
	            },
	            {
	                value: data_1.CostType.PAID,
	                label: "CREATE.COST_TYPE_PAID"
	            },
	            {
	                value: data_1.CostType.ALL,
	                label: "CREATE.COST_TYPE_ALL"
	            }
	        ];
	        var label = function (value, events, defaultOnError) {
	            for (var i = 0; i < events.length; i++) {
	                if (events[i].value == value) {
	                    return events[i].label;
	                }
	            }
	            return defaultOnError ? defaultOnError : "Error";
	        };
	        return function (value, enumName, defaultOnError) {
	            switch (enumName) {
	                case "event":
	                    return label(value, events, defaultOnError);
	                case "eventExplanation":
	                    return label(value, eventExplainations, defaultOnError);
	                case "meal":
	                    return label(value, meals, defaultOnError);
	                case "alcohol":
	                    return label(value, alcohols, defaultOnError);
	                case "diet":
	                    return label(value, diets, defaultOnError);
	                case "cost":
	                    return label(value, costs, defaultOnError);
	                default:
	                    return defaultOnError ? defaultOnError : "Error";
	            }
	        };
	    }
	    exports.enumNameFilter = enumNameFilter;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    function linkFilter() {
	        return function (items, session) {
	            return items.filter(function (item) {
	                if (item.label == "LANDING.BECOME_HOST") {
	                    return !session.isLogged() || (session.isGuest() && !session.isHostRequested());
	                }
	                if (item.label == "LANDING.CREATE_DINNER") {
	                    return session.isHost();
	                }
	                return true;
	            });
	        };
	    }
	    exports.linkFilter = linkFilter;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    function menuItemFilter() {
	        return function (items, session) {
	            return items.filter(function (item) {
	                if ((session.isHost() || session.isHostRequested()) && item.label == "MENU.BECOME_HOST") {
	                    return false;
	                }
	                if (session.isGuest() && item.label == "MENU.CREATE_DINNER") {
	                    return false;
	                }
	                return true;
	            });
	        };
	    }
	    exports.menuItemFilter = menuItemFilter;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, angular) {
	    function typeFilter() {
	        return function (typeList, alcoholPolicy, dietaryRestrictions) {
	            return typeList.filter(function (item) {
	                if (item.key == alcoholPolicy) {
	                    return true;
	                }
	                var found = false;
	                angular.forEach(dietaryRestrictions, function (value) {
	                    if (item.key == value) {
	                        found = true;
	                    }
	                });
	                return found;
	            });
	        };
	    }
	    exports.typeFilter = typeFilter;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(4), __webpack_require__(2), __webpack_require__(3), __webpack_require__(20), __webpack_require__(316), __webpack_require__(310), __webpack_require__(312), __webpack_require__(315), __webpack_require__(314), __webpack_require__(317), __webpack_require__(311), __webpack_require__(313), __webpack_require__(320), __webpack_require__(322), __webpack_require__(321), __webpack_require__(325), __webpack_require__(327), __webpack_require__(318), __webpack_require__(319), __webpack_require__(326), __webpack_require__(329), __webpack_require__(328), __webpack_require__(324), __webpack_require__(323), __webpack_require__(352), __webpack_require__(351), __webpack_require__(354), __webpack_require__(150), __webpack_require__(355), __webpack_require__(353), __webpack_require__(350), __webpack_require__(348), __webpack_require__(349), __webpack_require__(347), __webpack_require__(332), __webpack_require__(343), __webpack_require__(344), __webpack_require__(330), __webpack_require__(340), __webpack_require__(342), __webpack_require__(334), __webpack_require__(331), __webpack_require__(341), __webpack_require__(335), __webpack_require__(337), __webpack_require__(338), __webpack_require__(339), __webpack_require__(346), __webpack_require__(336), __webpack_require__(333), __webpack_require__(345), __webpack_require__(366), __webpack_require__(356), __webpack_require__(357), __webpack_require__(359), __webpack_require__(358), __webpack_require__(360)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, angular, TPL, config_1, session_1, notFound_1, accessRouteErr_1, event_1, manage_1, landing_1, profile_1, controlPanel_1, hostPromotion_1, field_1, imageUploader_1, fixer_1, loader_1, separator_1, avatar_1, banner_1, logo_1, stepper_1, socialShare_1, inputSelect_1, inputCombo_1, header_1, footer_1, indicator_1, link_1, userRecap_1, hire_1, facebookLogin_1, emailLogin_1, emailSignup_1, burger_1, event_2, search_1, searchDescription_1, attendants_1, notification_1, rsvp_1, host_1, dishList_1, priceBadge_1, info_1, manageHeader_1, manageMenu_1, modalActionBar_1, typePicker_1, inviteGuests_1, eventActionMenu_1, type_1, compareTo_1, age_1, enumName_1, menuItem_1, link_2, type_2) {
	    var Main = (function () {
	        function Main() {
	        }
	        Main.prototype.init = function (deferredBootstrapper) {
	            angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 990);
	            angular.module("sessionModule", ["pascalprecht.translate", "ngCookies", "ngFileUpload", "sprintf", "angularMoment", "ngRoute", "angularSpinners"])
	                .factory("tokenRefreshInterceptor", ["$q", "$log", "$injector", function ($q, $log, $injector) {
	                    /**
	                      Interceptor that logins with refresh token if necessary
	                    */
	                    var tri = {
	                        responseError: function (rejection) {
	                            $log.debug(rejection);
	                            var session = $injector.get("session");
	                            var $http = $injector.get("$http");
	                            if (rejection.status == 401) {
	                                if (rejection.config.url == config_1.Config.tokenEndpoint && rejection.config.data && rejection.config.data.grant_type == "refresh_token") {
	                                    return $q.reject(rejection);
	                                }
	                                var localStorageRefreshToken = localStorage.getItem(config_1.Config.localStorageRefreshToken);
	                                if (!localStorageRefreshToken) {
	                                    return $q.reject(rejection);
	                                }
	                                return session.loginWithRefreshToken(localStorageRefreshToken).then(function () {
	                                    var newConfig = rejection.config;
	                                    newConfig.headers.Authorization = session.user.token;
	                                    return $http(newConfig);
	                                })
	                                    .catch(function (error) {
	                                    return $q.reject(rejection);
	                                });
	                            }
	                            return $q.reject(rejection);
	                        }
	                    };
	                    return tri;
	                }])
	                .service("session", session_1.SessionService)
	                .constant("prelogin", false)
	                .constant("preconfig", false)
	                .config(["$httpProvider", function ($httpProvider) {
	                    $httpProvider.defaults.headers.post["Content-Type"] = "application/json";
	                    $httpProvider.defaults.headers.common["Accept"] = "application/json";
	                    $httpProvider.interceptors.push("tokenRefreshInterceptor");
	                }])
	                .config(['$compileProvider', function ($compileProvider) {
	                    $compileProvider.debugInfoEnabled(!config_1.Config.productionMode);
	                }])
	                .config(['$logProvider', function ($logProvider) {
	                    $logProvider.debugEnabled(!config_1.Config.productionMode);
	                }]);
	            angular.module("main", ["sessionModule", "ngAnimate", "ui.bootstrap", "angular-table", "ngAutocomplete", "ngSanitize", "angular-stripe", "ui-notification", "ngTwitter", "ngTagsInput", "djds4rce.angular-socialshare", "ngWYSIWYG", "infinite-scroll"])
	                .controller("NotFound", notFound_1.NotFoundController)
	                .controller("AccessRouteErr", accessRouteErr_1.AccessRouteController)
	                .controller("Event", event_1.EventController)
	                .controller("Manage", manage_1.ManageController)
	                .controller("Landing", landing_1.LandingController)
	                .controller("Profile", profile_1.ProfileController)
	                .controller("ControlPanel", controlPanel_1.ControlPanelController)
	                .controller("HostPromotion", hostPromotion_1.HostPromotionController)
	                .directive("otField", field_1.FieldDirective.factory())
	                .directive("otImageUploader", imageUploader_1.ImageUploaderDirective.factory())
	                .directive("otFixer", fixer_1.FixerDirective.factory())
	                .directive("otHeader", header_1.HeaderDirective.factory())
	                .directive("otFooter", footer_1.FooterDirective.factory())
	                .directive("otIndicatorList", indicator_1.IndicatorListDirective.factory())
	                .directive("otIndicator", indicator_1.IndicatorDirective.factory())
	                .directive("otLinkList", link_1.LinkListDirective.factory())
	                .directive("otLink", link_1.LinkDirective.factory())
	                .directive("otLogo", logo_1.LogoDirective.factory())
	                .directive("otUserRecap", userRecap_1.UserRecapDirective.factory())
	                .directive("otSeparator", separator_1.SeparatorDirective.factory())
	                .directive("otAvatar", avatar_1.AvatarDirective.factory())
	                .directive("otHire", hire_1.HireDirective.factory())
	                .directive("otBurger", burger_1.BurgerDirective.factory())
	                .directive("otSocialShare", socialShare_1.SocialShareDirective.factory())
	                .directive("otInviteGuests", inviteGuests_1.InviteGuestsDirective.factory())
	                .directive("otFacebookLogin", facebookLogin_1.FacebookLoginDirective.factory())
	                .directive("otEmailLogin", emailLogin_1.EmailLoginDirective.factory())
	                .directive("otEmailSignup", emailSignup_1.EmailSignupDirective.factory())
	                .directive("otBanner", banner_1.BannerDirective.factory())
	                .directive("otSearch", search_1.SearchDirective.factory())
	                .directive("otSearchFilter", search_1.SearchFilterDirective.factory())
	                .directive("otSearchDescription", searchDescription_1.SearchDescriptionDirective.factory())
	                .directive("otEventTable", event_2.EventTableDirective.factory())
	                .directive("otEventList", event_2.EventListDirective.factory())
	                .directive("otEventRow", event_2.EventRowDirective.factory())
	                .directive("otEvent", event_2.EventDirective.factory())
	                .directive("otLoader", loader_1.LoaderDirective.factory())
	                .directive("otAttendants", attendants_1.AttendantsDirective.factory())
	                .directive("otHost", host_1.HostDirective.factory())
	                .directive("otDishList", dishList_1.DishListDirective.factory())
	                .directive("otPriceBadge", priceBadge_1.PriceBadgeDirective.factory())
	                .directive("otInfo", info_1.InfoDirective.factory())
	                .directive("otNotification", notification_1.NotificationDirective.factory())
	                .directive("otRsvp", rsvp_1.RsvpDirective.factory())
	                .directive("otManageHeader", manageHeader_1.ManageHeaderDirective.factory())
	                .directive("otManageMenu", manageMenu_1.ManageMenuDirective.factory())
	                .directive("otStepper", stepper_1.StepperDirective.factory())
	                .directive("otModalActionBar", modalActionBar_1.ModalActionBarDirective.factory())
	                .directive("otTypeList", type_1.TypeListDirective.factory())
	                .directive("otTypePicker", typePicker_1.TypePickerDirective.factory())
	                .directive("otEventActionMenu", eventActionMenu_1.EventActionMenuDirective.factory())
	                .directive("otInputSelect", inputSelect_1.InputSelectDirective.factory())
	                .directive("otInputCombo", inputCombo_1.InputComboDirective.factory())
	                .directive("otCompareTo", compareTo_1.CompareToDirective.factory())
	                .filter("age", age_1.ageFilter)
	                .filter("enumName", enumName_1.enumNameFilter)
	                .filter("menuItem", menuItem_1.menuItemFilter)
	                .filter("link", link_2.linkFilter)
	                .filter("type", type_2.typeFilter)
	                .config(['$compileProvider', function ($compileProvider) {
	                    $compileProvider.debugInfoEnabled(!config_1.Config.productionMode);
	                }])
	                .config(['$logProvider', function ($logProvider) {
	                    $logProvider.debugEnabled(!config_1.Config.productionMode);
	                }])
	                .config(["$translateProvider", function ($translateProvider) {
	                    $translateProvider.useStaticFilesLoader({
	                        prefix: "languages/",
	                        suffix: ".json"
	                    });
	                    $translateProvider.preferredLanguage("en_EN");
	                    $translateProvider.useSanitizeValueStrategy("escape");
	                }])
	                .config(["stripeProvider", function (stripeProvider) {
	                    stripeProvider.setPublishableKey(config_1.Config.stripePublishableKey);
	                }])
	                .config(["tagsInputConfigProvider", function (tagsInputConfigProvider) {
	                    tagsInputConfigProvider.setDefaults('tagsInput', { placeholder: 'Add tag' });
	                    tagsInputConfigProvider.setActiveInterpolation('tagsInput', { placeholder: true });
	                }])
	                .config(["$routeProvider", "$locationProvider", function ($routeProvider, $locationProvider) {
	                    // $locationProvider.html5Mode(true).hashPrefix('!');
	                    $routeProvider
	                        .when("/", {
	                        redirectTo: config_1.Config.home,
	                    })
	                        .when("/notfound", {
	                        template: TPL.components.notFound,
	                        controller: "NotFound",
	                        controllerAs: "vm"
	                    })
	                        .when(config_1.Config.home + "/:city?", {
	                        template: TPL.components.landing,
	                        controller: "Landing",
	                        controllerAs: "vm"
	                    })
	                        .when("/manage/:what", {
	                        template: TPL.components.manage,
	                        controller: "Manage",
	                        controllerAs: "vm"
	                    })
	                        .when("/events", {
	                        template: TPL.components.event,
	                        controller: "Event",
	                        controllerAs: "vm"
	                    })
	                        .when("/events/:id", {
	                        template: TPL.components.event,
	                        controller: "Event",
	                        controllerAs: "vm"
	                    })
	                        .when("/events/:id/guests", {
	                        template: TPL.components.guests,
	                        controller: "Event",
	                        controllerAs: "vm"
	                    })
	                        .when("/events/:id/edit", {
	                        template: TPL.components.event,
	                        controller: "Event",
	                        controllerAs: "vm"
	                    })
	                        .when("/events/:id/nourished", {
	                        template: TPL.components.nourished,
	                        controller: "Event",
	                        controllerAs: "vm"
	                    })
	                        .when("/profile", {
	                        template: TPL.components.profile,
	                        controller: "Profile",
	                        controllerAs: "vm"
	                    })
	                        .when(config_1.Config.hostPromotion, {
	                        template: TPL.components.hostPromotion,
	                        controller: "HostPromotion",
	                        controllerAs: "vm"
	                    })
	                        .when("/apitest", {
	                        template: TPL.components.apiTest,
	                        controller: "ApiTest",
	                        controllerAs: "vm"
	                    })
	                        .when("/controlpanel", {
	                        template: TPL.components.controlPanel,
	                        controller: "ControlPanel",
	                        controllerAs: "vm"
	                    })
	                        .when("/error/:which", {
	                        template: TPL.components.accessRouteErr,
	                        controller: "AccessRouteErr",
	                        controllerAs: "vm"
	                    })
	                        .otherwise({
	                        redirectTo: "/notfound"
	                    });
	                }])
	                .run(["$rootScope", "$location", "$anchorScroll", "$routeParams", "session", "$route", function ($rootScope, $location, $anchorScroll, $routeParams, session, $route) {
	                    $rootScope.$on("session.login", function () {
	                        $route.reload();
	                    });
	                    $rootScope.$on("session.logout", function () {
	                        $location.path(session.getLandingPage());
	                        $location.replace();
	                        $route.reload();
	                    });
	                    $rootScope.$on("$routeChangeSuccess", function (event, currentRoute, previousRoute) {
	                        window.scrollTo(0, 0);
	                        if (burger_1.BurgerDirective.currentModal) {
	                            burger_1.BurgerDirective.currentModal.dismiss();
	                        }
	                        var ga = window["ga"];
	                        if (ga) {
	                            ga('send', 'pageview', { page: $location.url() });
	                        }
	                    });
	                }]);
	            deferredBootstrapper.bootstrap({
	                element: document,
	                module: 'main',
	                bootstrapConfig: {
	                    strictDi: true
	                },
	                injectorModules: 'sessionModule',
	                resolve: {
	                    "prelogin": ["session", function (session) {
	                            /**
	                              This will try to do a login using the information stored in the user cookie.
	                              It allow to inject everywhere a logged session before anything else.
	                              Remember that this piece of code will be called before everything so all the config
	                              is not done yet!
	                            */
	                            return session.prelogin();
	                        }],
	                    "preconfig": ["session", function (session) {
	                            /**
	                              Get list of available cities
	                            */
	                            return session.preconfig();
	                        }]
	                }
	            });
	        };
	        return Main;
	    })();
	    exports.Main = Main;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(9), __webpack_require__(5), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, login_1, confirm_1, TPL) {
	    var ForgotController = (function () {
	        function ForgotController(parent, $rootScope, modal, session) {
	            this.parent = parent;
	            this.currentModal = this.parent.currentModal;
	            this.rootScope = $rootScope;
	            this.session = session;
	            this.modal = modal;
	            this.erroremail = "";
	        }
	        ForgotController.prototype.submit = function (form) {
	            var _this = this;
	            if (form.$valid) {
	                this.session.resetPassword(this.email).then(function () {
	                    if (_this.currentModal) {
	                        _this.currentModal.dismiss();
	                    }
	                    confirm_1.ConfirmController.openForgotPasswordDoneModal(_this.modal);
	                }).catch(function (data) {
	                    if (data.data.errors.email) {
	                        _this.erroremail = "FORGOT.EMAIL_ERROR_MESSAGE";
	                    }
	                });
	            }
	        };
	        ForgotController.prototype.resetError = function () {
	            this.erroremail = false;
	        };
	        ForgotController.prototype.openLoginDialog = function (which) {
	            if (this.currentModal) {
	                this.currentModal.dismiss();
	            }
	            if (which == "login") {
	                this.currentModal = login_1.LoginController.openLoginModal(this.modal, this, this.rootScope);
	            }
	            else {
	                this.currentModal = login_1.LoginController.openSignupModal(this.modal, this, this.rootScope);
	            }
	        };
	        ForgotController.openForgotModal = function (modal, parent, rootScope, session) {
	            return modal.open({
	                controller: function () { return new ForgotController(parent, rootScope, modal, session); },
	                controllerAs: "vm",
	                replace: true,
	                size: "sm",
	                template: TPL.modals.forgot
	            });
	        };
	        return ForgotController;
	    })();
	    exports.ForgotController = ForgotController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL) {
	    var HostMessageController = (function () {
	        function HostMessageController(session, modalInstance, log, route, notification) {
	            this.session = session;
	            this.modalInstance = modalInstance;
	            this.log = log;
	            this.route = route;
	            this.notification = notification;
	            this.scope = {
	                params: "=params"
	            };
	            this.eventId = this.session.getData().event.uuid;
	            this.hostData = {
	                avatar: this.session.getData().event.created_by_profile.avatar,
	                first_name: this.session.getData().event.created_by_profile.first_name,
	                last_name: this.session.getData().event.created_by_profile.last_name,
	                email: [this.session.getData().event.created_by_profile.email]
	            };
	            this.session.loadEvent(this.eventId);
	            this.session.loadReservations(this.eventId);
	        }
	        HostMessageController.prototype.sendMessage = function (form) {
	            var _this = this;
	            if (form.$valid) {
	                this.hostData.email;
	                this.emailText;
	                if (this.hostData.email) {
	                    this.session.sendInvitations("guest-message", this.hostData.email, this.emailText).then(function () {
	                        _this.notification.success("The message has been sent!");
	                        _this.modalInstance.dismiss();
	                    });
	                }
	            }
	        };
	        HostMessageController.prototype.isValidEmail = function (value) {
	            if (!value) {
	                return false;
	            }
	            var regex = /^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/i;
	            return regex.exec(value) != null;
	        };
	        HostMessageController.open = function (modal, eventId) {
	            HostMessageController.eventId = eventId;
	            return modal.open({
	                controller: HostMessageController,
	                controllerAs: "vm",
	                replace: true,
	                size: "md",
	                template: TPL.modals.hostMessage
	            });
	        };
	        HostMessageController.$inject = ["session", "$uibModalInstance", "$log", "$route", "Notification"];
	        return HostMessageController;
	    })();
	    exports.HostMessageController = HostMessageController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(5), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, TPL, confirm_1, config_1) {
	    var RsvpController = (function () {
	        function RsvpController(parent, session, modal, location, stripe, notification, log) {
	            this.parent = parent;
	            this.session = session;
	            this.modal = modal;
	            this.location = location;
	            this.stripe = stripe;
	            this.notification = notification;
	            this.log = log;
	            this.maxSeats = this.session.getData().event.number_of_guests_max;
	            this.acceptedSeats = this.session.getData().event.reservations_stats.guests_accepted;
	            this.currentModal = this.parent.currentModal;
	            this.cardList = this.getCardList();
	            this.clearReservationData();
	            this.clearCardData();
	            this.showListCard = false;
	            this.showParam = "showSingle";
	            this.cardSelected = {
	                id: ''
	            };
	            this.couponNumber = "";
	            this.couponAmount;
	            this.couponType;
	            this.couponId = "";
	            this.couponCheck = false;
	            this.calculateAmount();
	            this.reservationData.seats = 1;
	        }
	        RsvpController.prototype.clearCardData = function () {
	            this.cardData = {
	                rememberCard: true
	            };
	        };
	        RsvpController.prototype.clearReservationData = function () {
	            this.reservationData = {
	                seats: 1,
	                credentials: [],
	                fees: 0
	            };
	        };
	        RsvpController.prototype.getCardList = function () {
	            var _this = this;
	            this.session.getCardList().then(function (response) {
	                _this.cardList = response;
	                if (response.length > 0) {
	                    angular.forEach(response, function (value) {
	                        if (value.favourite) {
	                            _this.cardSelected.id = value.id;
	                        }
	                    });
	                    _this.checkCard = true;
	                }
	            });
	        };
	        RsvpController.prototype.changeCard = function (param) {
	            if (param == "show") {
	                this.checkCard = false;
	                this.showListCard = false;
	                this.showParam = "hide";
	            }
	            else {
	                this.checkCard = true;
	                this.showListCard = true;
	            }
	        };
	        RsvpController.prototype.openListCard = function (param) {
	            if (param === "showList") {
	                this.showParam = "showSingle";
	            }
	            else {
	                this.showParam = "showList";
	                this.checkCard = true;
	            }
	        };
	        RsvpController.prototype.verifyCoupon = function () {
	            var _this = this;
	            this.session.couponValidation(this.couponNumber).then(function (response) {
	                _this.couponAmount = response.amount;
	                _this.couponType = response.discount_type;
	                _this.couponId = response.id;
	                _this.couponCheck = true;
	            }).then(function () {
	                _this.calculateAmount();
	            }).catch(function (err) {
	                _this.couponCheck = false;
	                _this.notification.error("Your coupon isn't valid!");
	                _this.log.debug('Coupon error', err.message);
	                throw err;
	            });
	        };
	        RsvpController.prototype.calculateAmount = function () {
	            this.couponAmount = parseFloat(this.couponAmount);
	            if (!this.couponType || typeof this.couponType === 'undefined' || this.couponNumber == '') {
	                this.totalAmount = (this.reservationData.seats * this.session.getData().event.price_per_person / 100) + this.reservationData.fees;
	            }
	            else if (this.couponType == "%") {
	                this.totalAmount = ((this.reservationData.seats * this.session.getData().event.price_per_person / 100) + this.reservationData.fees) * (1 - (this.couponAmount / 100));
	            }
	            else {
	                this.totalAmount = ((this.reservationData.seats * this.session.getData().event.price_per_person / 100) + this.reservationData.fees) - (this.couponAmount);
	            }
	            this.totalAmount = Number(this.totalAmount).toFixed(2);
	            return this.totalAmount;
	        };
	        RsvpController.prototype.changeCouponCheck = function () {
	            if (this.couponNumber === "") {
	                this.calculateAmount();
	                this.couponCheck = false;
	                this.couponId = "";
	            }
	        };
	        RsvpController.prototype.logConsole = function (cardId) {
	            this.cardSelected.id = cardId;
	            this.log.debug("Value is : " + this.cardSelected.id);
	        };
	        ;
	        RsvpController.prototype.addSeat = function (seatsavailable) {
	            if (this.reservationData.seats < seatsavailable) {
	                this.reservationData.seats++;
	                this.reservationData.credentials.push({});
	            }
	            else {
	                this.seatsAvailable = seatsavailable;
	            }
	        };
	        RsvpController.prototype.removeSeat = function () {
	            this.reservationData.seats--;
	            this.seatsAvailable = "";
	            if (this.reservationData.seats < 1) {
	                this.reservationData.seats = 1;
	            }
	            else {
	                this.reservationData.credentials.pop();
	            }
	        };
	        RsvpController.prototype.openRsvpModal = function () {
	            if (this.currentModal) {
	                this.currentModal.dismiss();
	            }
	            this.currentModal = RsvpController.openRsvpModal(this.modal, this, this.session, this.location, this.stripe, this.notification, this.log);
	        };
	        RsvpController.prototype.openRsvpGuestsModal = function () {
	            if (this.currentModal) {
	                this.currentModal.dismiss();
	            }
	            if (this.reservationData.seats > 1) {
	                this.currentModal = RsvpController.openRsvpGuestsModal(this.modal, this);
	            }
	            else {
	                this.openRsvpPaymentModal();
	            }
	        };
	        RsvpController.prototype.openRsvpPaymentModal = function (guestsForm) {
	            var _this = this;
	            if (this.reservationData.seats > 1 && (!guestsForm || !guestsForm.$valid)) {
	                this.notification.error("Check your guests data");
	                return;
	            }
	            if (this.currentModal) {
	                this.currentModal.dismiss();
	            }
	            if (this.session.getData().event.price_per_person > 0) {
	                this.currentModal = RsvpController.openRsvpPaymentModal(this.modal, this);
	            }
	            else {
	                this.session.spinnerService.show("mainSpinner");
	                this.session.reserve(this.reservationData.credentials).then(function () {
	                    _this.onReservationSuccess();
	                    _this.session.spinnerService.hide("mainSpinner");
	                }).catch(function (eventResponse) {
	                    if (eventResponse.status === 422) {
	                        _this.session.spinnerService.hide("mainSpinner");
	                        if (eventResponse.data.errors.event_date) {
	                            _this.notification.error("Reservation deadline already reached");
	                        }
	                    }
	                });
	            }
	        };
	        RsvpController.prototype.isManualApproval = function () {
	            var event = this.session.getData().event;
	            if (event != null) {
	                return event.event_type == "manual_approval";
	            }
	            else {
	                return false;
	            }
	        };
	        RsvpController.prototype.submitPayment = function (form) {
	            var _this = this;
	            if (form.$valid) {
	                this.isPaying = true;
	                var cardName = this.cardData.cardName;
	                var cardNumber = this.cardData.cardNumber;
	                var cardCvc = this.cardData.cardCvc;
	                var cardMonth = this.cardData.cardMonth;
	                var cardYear = this.cardData.cardYear;
	                var favourite = this.cardData.cardFavourite;
	                var payToken;
	                var cardData = {
	                    number: cardNumber,
	                    name: cardName,
	                    cvc: cardCvc,
	                    exp_month: cardMonth,
	                    exp_year: cardYear
	                };
	                this.stripe.card.createToken(cardData)
	                    .then(function (response) {
	                    _this.isPaying = true;
	                    _this.log.debug(response);
	                    _this.log.debug('token created for card ending in ', response.card.last4);
	                    var payment = angular.copy(response);
	                    payment.card = void 0;
	                    payment.token = response.id;
	                    _this.log.debug('shoud send the payment to the server');
	                    _this.log.debug(payment);
	                    payToken = response.id;
	                    _this.log.debug(payment);
	                    _this.log.debug(payToken);
	                    var data = {
	                        stripe_token: payToken,
	                        favourite: favourite
	                    };
	                    return _this.session.pay(payment, _this.reservationData.seats, _this.reservationData.credentials, _this.couponId);
	                })
	                    .then(function (payment) {
	                    _this.stripe.card.createToken(cardData)
	                        .then(function (response) {
	                        var payment = angular.copy(response);
	                        payment.card = void 0;
	                        payment.token = response.id;
	                        payToken = response.id;
	                        _this.log.debug(payment);
	                        _this.log.debug(payToken);
	                        var data = {
	                            stripe_token: payToken,
	                            favourite: favourite
	                        };
	                        _this.session.registerNewCard(data);
	                    });
	                    _this.log.debug('successfully submitted preauthorized payment for $', payment.amount);
	                    _this.isPaying = false;
	                    if (_this.session.getData().event.event_type == "manual_approval") {
	                        _this.notification.success("Payment Completed");
	                    }
	                    _this.session.loadMyReservations();
	                    _this.onReservationSuccess();
	                })
	                    .catch(function (err) {
	                    _this.isPaying = false;
	                    if (err.status === 422 && err.data.errors.event_date) {
	                        _this.session.spinnerService.hide("mainSpinner");
	                        _this.notification.error("Reservation deadline already reached");
	                    }
	                    else {
	                        _this.notification.error("Payment Error");
	                        if (err.type && /^Stripe/.test(err.type)) {
	                            _this.log.debug('Stripe error: ', err.message);
	                        }
	                        else {
	                            _this.log.debug('Other error occurred, possibly with your API', err.message);
	                        }
	                        throw err;
	                    }
	                });
	            }
	            else if (form.selectedCard) {
	                this.isPaying = true;
	                var payment = {
	                    card_id: this.cardSelected.id
	                };
	                return this.session.pay(payment, this.reservationData.seats, this.reservationData.credentials, this.couponId)
	                    .then(function (payment) {
	                    _this.isPaying = false;
	                    if (_this.session.getData().event.event_type == "manual_approval") {
	                        _this.notification.success("Payment Completed");
	                    }
	                    _this.session.loadMyReservations();
	                    _this.onReservationSuccess();
	                })
	                    .catch(function (err) {
	                    _this.isPaying = false;
	                    if (err.status === 422 && err.data.errors.event_date) {
	                        _this.session.spinnerService.hide("mainSpinner");
	                        _this.notification.error("Reservation deadline already reached");
	                    }
	                    else {
	                        _this.notification.error("Payment Error");
	                        if (err.type && /^Stripe/.test(err.type)) {
	                            _this.log.debug('Stripe error: ', err.message);
	                        }
	                        else {
	                            _this.log.debug('Other error occurred, possibly with your API', err.message);
	                        }
	                        throw err;
	                    }
	                });
	            }
	        };
	        RsvpController.prototype.getTermsLink = function () {
	            return config_1.Config.wp_termsandconditions;
	        };
	        RsvpController.prototype.onReservationSuccess = function () {
	            var _this = this;
	            if (this.currentModal) {
	                this.currentModal.dismiss();
	            }
	            var shareCallback = function () {
	                _this.log.debug("share on facebook");
	                var currentEvent = _this.session.data.event;
	                var eventURL = config_1.Config.publicEndpoint + '#' + config_1.Config.events + '/' + currentEvent.uuid;
	                var currentEventPhoto = config_1.Config.publicEndpoint + 'assets/bannerless.jpg';
	                if (currentEvent.cover) {
	                    currentEventPhoto = currentEvent.cover.m;
	                }
	                try {
	                    FB.ui({
	                        display: 'popup',
	                        method: 'feed',
	                        link: eventURL,
	                        title: currentEvent.title,
	                        picture: currentEventPhoto,
	                        description: currentEvent.description,
	                        caption: 'Powered by BBYO'
	                    }, function (response) {
	                        _this.log.debug("response: " + response);
	                    });
	                }
	                catch (err) {
	                    _this.log.debug("err: " + err);
	                }
	            };
	            var browseCallback = function () {
	                _this.location.url(config_1.Config.home);
	                if (_this.currentModal) {
	                    _this.currentModal.dismiss();
	                }
	            };
	            var dismissCallback = function () {
	                if (_this.currentModal) {
	                    _this.currentModal.dismiss();
	                }
	            };
	            var currentEvent = this.session.data.event;
	            if (currentEvent.event_type != "manual_approval") {
	                this.currentModal = confirm_1.ConfirmController.openReservationDonePublicModal(this.modal, shareCallback, browseCallback, dismissCallback);
	            }
	            else {
	                this.currentModal = confirm_1.ConfirmController.openReservationDoneManualModal(this.modal, shareCallback, browseCallback, dismissCallback);
	            }
	            this.session.loadEvent();
	        };
	        RsvpController.openRsvpModal = function (modal, parent, session, location, stripe, Notification, log) {
	            return modal.open({
	                controller: function () { return new RsvpController(parent, session, modal, location, stripe, Notification, log); },
	                controllerAs: "vm",
	                replace: true,
	                size: "lg",
	                template: TPL.modals.rsvp
	            });
	        };
	        RsvpController.openRsvpGuestsModal = function (modal, controller) {
	            return modal.open({
	                controller: function () { return controller; },
	                controllerAs: "vm",
	                replace: true,
	                size: "sm",
	                template: TPL.modals.rsvpGuests
	            });
	        };
	        RsvpController.openRsvpPaymentModal = function (modal, controller) {
	            return modal.open({
	                controller: function () { return controller; },
	                controllerAs: "vm",
	                replace: true,
	                size: "lg",
	                template: TPL.modals.rsvpPayment
	            });
	        };
	        return RsvpController;
	    })();
	    exports.RsvpController = RsvpController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    var SuccessController = (function () {
	        function SuccessController(parent) {
	            this.session = parent;
	        }
	        return SuccessController;
	    })();
	    exports.SuccessController = SuccessController;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    var CompareToDirective = (function () {
	        function CompareToDirective() {
	            this.restrict = "A";
	            this.scope = {
	                otCompareTo: "=otCompareTo"
	            };
	            this.require = "ngModel";
	            this.link = function (scope, el, attrs, ctrl) {
	                var validatorFn = function (modelValue, viewValue) {
	                    var value = modelValue || viewValue;
	                    var valid = true;
	                    if (value) {
	                        valid = scope.otCompareTo == value;
	                    }
	                    return valid;
	                };
	                ctrl.$validators["compareTo"] = validatorFn;
	                scope.$watch("otCompareTo", function (newValue) {
	                    ctrl.$validate();
	                });
	            };
	        }
	        CompareToDirective.factory = function () {
	            var tmp = function () { return new CompareToDirective(); };
	            return tmp;
	        };
	        return CompareToDirective;
	    })();
	    exports.CompareToDirective = CompareToDirective;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	var sf = __webpack_require__(384);
	
	angular.
	    module("sprintf", []).
	    filter("sprintf", function() {
	        return function() {
	            return sf.sprintf.apply(null, arguments)
	        }
	    }).
	    filter("fmt", ["$filter", function($filter) {
	        return $filter("sprintf")
	    }]).
	    filter("vsprintf", function() {
	        return function(format, argv) {
	            return sf.vsprintf(format, argv)
	        }
	    }).
	    filter("vfmt", ["$filter", function($filter) {
	        return $filter("vsprintf")
	    }])


/***/ },
/* 368 */
/***/ function(module, exports) {

	/* ng-infinite-scroll - v1.3.0 - 2016-06-30 */
	angular.module('infinite-scroll', []).value('THROTTLE_MILLISECONDS', null).directive('infiniteScroll', [
	  '$rootScope', '$window', '$interval', 'THROTTLE_MILLISECONDS', function($rootScope, $window, $interval, THROTTLE_MILLISECONDS) {
	    return {
	      scope: {
	        infiniteScroll: '&',
	        infiniteScrollContainer: '=',
	        infiniteScrollDistance: '=',
	        infiniteScrollDisabled: '=',
	        infiniteScrollUseDocumentBottom: '=',
	        infiniteScrollListenForEvent: '@'
	      },
	      link: function(scope, elem, attrs) {
	        var changeContainer, checkInterval, checkWhenEnabled, container, handleInfiniteScrollContainer, handleInfiniteScrollDisabled, handleInfiniteScrollDistance, handleInfiniteScrollUseDocumentBottom, handler, height, immediateCheck, offsetTop, pageYOffset, scrollDistance, scrollEnabled, throttle, unregisterEventListener, useDocumentBottom, windowElement;
	        windowElement = angular.element($window);
	        scrollDistance = null;
	        scrollEnabled = null;
	        checkWhenEnabled = null;
	        container = null;
	        immediateCheck = true;
	        useDocumentBottom = false;
	        unregisterEventListener = null;
	        checkInterval = false;
	        height = function(elem) {
	          elem = elem[0] || elem;
	          if (isNaN(elem.offsetHeight)) {
	            return elem.document.documentElement.clientHeight;
	          } else {
	            return elem.offsetHeight;
	          }
	        };
	        offsetTop = function(elem) {
	          if (!elem[0].getBoundingClientRect || elem.css('none')) {
	            return;
	          }
	          return elem[0].getBoundingClientRect().top + pageYOffset(elem);
	        };
	        pageYOffset = function(elem) {
	          elem = elem[0] || elem;
	          if (isNaN(window.pageYOffset)) {
	            return elem.document.documentElement.scrollTop;
	          } else {
	            return elem.ownerDocument.defaultView.pageYOffset;
	          }
	        };
	        handler = function() {
	          var containerBottom, containerTopOffset, elementBottom, remaining, shouldScroll;
	          if (container === windowElement) {
	            containerBottom = height(container) + pageYOffset(container[0].document.documentElement);
	            elementBottom = offsetTop(elem) + height(elem);
	          } else {
	            containerBottom = height(container);
	            containerTopOffset = 0;
	            if (offsetTop(container) !== void 0) {
	              containerTopOffset = offsetTop(container);
	            }
	            elementBottom = offsetTop(elem) - containerTopOffset + height(elem);
	          }
	          if (useDocumentBottom) {
	            elementBottom = height((elem[0].ownerDocument || elem[0].document).documentElement);
	          }
	          remaining = elementBottom - containerBottom;
	          shouldScroll = remaining <= height(container) * scrollDistance + 1;
	          if (shouldScroll) {
	            checkWhenEnabled = true;
	            if (scrollEnabled) {
	              if (scope.$$phase || $rootScope.$$phase) {
	                return scope.infiniteScroll();
	              } else {
	                return scope.$apply(scope.infiniteScroll);
	              }
	            }
	          } else {
	            if (checkInterval) {
	              $interval.cancel(checkInterval);
	            }
	            return checkWhenEnabled = false;
	          }
	        };
	        throttle = function(func, wait) {
	          var later, previous, timeout;
	          timeout = null;
	          previous = 0;
	          later = function() {
	            previous = new Date().getTime();
	            $interval.cancel(timeout);
	            timeout = null;
	            return func.call();
	          };
	          return function() {
	            var now, remaining;
	            now = new Date().getTime();
	            remaining = wait - (now - previous);
	            if (remaining <= 0) {
	              $interval.cancel(timeout);
	              timeout = null;
	              previous = now;
	              return func.call();
	            } else {
	              if (!timeout) {
	                return timeout = $interval(later, remaining, 1);
	              }
	            }
	          };
	        };
	        if (THROTTLE_MILLISECONDS != null) {
	          handler = throttle(handler, THROTTLE_MILLISECONDS);
	        }
	        scope.$on('$destroy', function() {
	          container.unbind('scroll', handler);
	          if (unregisterEventListener != null) {
	            unregisterEventListener();
	            unregisterEventListener = null;
	          }
	          if (checkInterval) {
	            return $interval.cancel(checkInterval);
	          }
	        });
	        handleInfiniteScrollDistance = function(v) {
	          return scrollDistance = parseFloat(v) || 0;
	        };
	        scope.$watch('infiniteScrollDistance', handleInfiniteScrollDistance);
	        handleInfiniteScrollDistance(scope.infiniteScrollDistance);
	        handleInfiniteScrollDisabled = function(v) {
	          scrollEnabled = !v;
	          if (scrollEnabled && checkWhenEnabled) {
	            checkWhenEnabled = false;
	            return handler();
	          }
	        };
	        scope.$watch('infiniteScrollDisabled', handleInfiniteScrollDisabled);
	        handleInfiniteScrollDisabled(scope.infiniteScrollDisabled);
	        handleInfiniteScrollUseDocumentBottom = function(v) {
	          return useDocumentBottom = v;
	        };
	        scope.$watch('infiniteScrollUseDocumentBottom', handleInfiniteScrollUseDocumentBottom);
	        handleInfiniteScrollUseDocumentBottom(scope.infiniteScrollUseDocumentBottom);
	        changeContainer = function(newContainer) {
	          if (container != null) {
	            container.unbind('scroll', handler);
	          }
	          container = newContainer;
	          if (newContainer != null) {
	            return container.bind('scroll', handler);
	          }
	        };
	        changeContainer(windowElement);
	        if (scope.infiniteScrollListenForEvent) {
	          unregisterEventListener = $rootScope.$on(scope.infiniteScrollListenForEvent, handler);
	        }
	        handleInfiniteScrollContainer = function(newContainer) {
	          if ((newContainer == null) || newContainer.length === 0) {
	            return;
	          }
	          if (newContainer.nodeType && newContainer.nodeType === 1) {
	            newContainer = angular.element(newContainer);
	          } else if (typeof newContainer.append === 'function') {
	            newContainer = angular.element(newContainer[newContainer.length - 1]);
	          } else if (typeof newContainer === 'string') {
	            newContainer = angular.element(document.querySelector(newContainer));
	          }
	          if (newContainer != null) {
	            return changeContainer(newContainer);
	          } else {
	            throw new Error("invalid infinite-scroll-container attribute.");
	          }
	        };
	        scope.$watch('infiniteScrollContainer', handleInfiniteScrollContainer);
	        handleInfiniteScrollContainer(scope.infiniteScrollContainer || []);
	        if (attrs.infiniteScrollParent != null) {
	          changeContainer(angular.element(elem.parent()));
	        }
	        if (attrs.infiniteScrollImmediateCheck != null) {
	          immediateCheck = scope.$eval(attrs.infiniteScrollImmediateCheck);
	        }
	        return checkInterval = $interval((function() {
	          if (immediateCheck) {
	            handler();
	          }
	          return $interval.cancel(checkInterval);
	        }));
	      }
	    };
	  }
	]);
	
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	  module.exports = 'infinite-scroll';
	}


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(165);

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(166);

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(168);

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(169);
	__webpack_require__(303);
	__webpack_require__(307);

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(170);

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(171);

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(304);
	module.exports = __webpack_require__(174);

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(175);

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(178);

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(179);
	__webpack_require__(305);

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(180);

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(368);

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(306);
	module.exports = __webpack_require__(182);
	__webpack_require__(149);
	__webpack_require__(17);
	__webpack_require__(18);

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(183);

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(184);

/***/ }
]);


/** WEBPACK FOOTER **
 ** app.js
 **/